import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
	[_ in K]?: never;
};
export type Incremental<T> =
	| T
	| { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	DateTime: { input: string; output: string };
	JSON: { input: any; output: any };
	LowercaseString: { input: string; output: string };
	Password: { input: string; output: string };
	PhoneNumber: { input: string; output: string };
};

export type AcceptOffersPreview = {
	__typename?: 'AcceptOffersPreview';
	currency: CurrencyEnum;
	/** Products + delivery + fees − discounts — paid later (production invoice). */
	payLater: AcceptOffersPreviewSection;
	/** Samples — paid now (separate invoice). */
	payNow: AcceptOffersPreviewSection;
	/** payNow + payLater combined. */
	total: AcceptOffersPreviewSection;
};

export type AcceptOffersPreviewSection = {
	__typename?: 'AcceptOffersPreviewSection';
	/** netAmount + vatAmount (incl. VAT). */
	grossAmount: Scalars['Float']['output'];
	/** Net total (ex-VAT) for this payment. */
	netAmount: Scalars['Float']['output'];
	/** VAT on netAmount. */
	vatAmount: Scalars['Float']['output'];
	/** Applied VAT (moms) rate as a percentage. */
	vatRate: Scalars['Float']['output'];
};

export type AcceptOrderQuoteOfferSelectionInput = {
	deliveryId?: InputMaybe<Scalars['ID']['input']>;
	offerId: Scalars['ID']['input'];
	pricingId: Scalars['ID']['input'];
	quantity: Scalars['Int']['input'];
	sampleChoice?: InputMaybe<OrderSampleChoice>;
};

export type AcceptOrderQuoteOffersInput = {
	/** Invoice recipients — internal users and/or external emails. All receive the invoice. */
	invoiceRecipients?: InputMaybe<Array<OrderInvoiceRecipientInput>>;
	orderQuoteId: Scalars['ID']['input'];
	/** Optional PO number — stored on the order and defaulted onto both the sample and production invoices. */
	poNumber?: InputMaybe<Scalars['String']['input']>;
	selections: Array<AcceptOrderQuoteOfferSelectionInput>;
};

export type AcceptOrderQuoteOffersResponse = {
	__typename?: 'AcceptOrderQuoteOffersResponse';
	message: Scalars['String']['output'];
	orderId?: Maybe<Scalars['ID']['output']>;
	/** True when the accept deadline had passed, so the acceptance was captured and routed to an admin for re-confirmation instead of creating an order. */
	pendingReview?: Maybe<Scalars['Boolean']['output']>;
	success: Scalars['Boolean']['output'];
};

export type AcquireStudioLockResponse = {
	__typename?: 'AcquireStudioLockResponse';
	lock?: Maybe<StudioLock>;
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
};

export enum ActionDisplayType {
	Button = 'BUTTON',
	InlineWidget = 'INLINE_WIDGET',
}

/**
 * Whether an action is somebody's TURN.
 *
 * Three types carried three different ways of saying "this one is not the pending move" — a
 * CANCELLED status here, a null status there, a sentence in a doc-comment somewhere else — and
 * null status meant opposite things on two of them. This says it once, the same way everywhere.
 */
export enum ActionKind {
	/** Calls the thing off: cancel. Always available, never what anyone is waiting for. */
	Escape = 'ESCAPE',
	/** Advances the thing it belongs to. This is the turn: whoever owns it is who everyone is waiting for. */
	Move = 'MOVE',
	/** Changes a property without moving anything — correcting tracking details, changing how a sample is paid for. Available at many points, and never the pending move. */
	Property = 'PROPERTY',
}

export type AddOrderQuoteItemInput = {
	deadline?: InputMaybe<Scalars['DateTime']['input']>;
	productId: Scalars['ID']['input'];
	quantities?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AddOrderQuoteItemsInput = {
	items: Array<AddOrderQuoteItemInput>;
	orderQuoteId: Scalars['ID']['input'];
};

export type AddOrderQuoteOfferAdjustmentInput = {
	calculationType: OrderAdjustmentCalculationType;
	currency?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	orderQuoteOfferId: Scalars['ID']['input'];
	type: OrderAdjustmentType;
	value: Scalars['Float']['input'];
};

export type AddOrderQuoteOfferDeliveryInput = {
	currency: Scalars['String']['input'];
	deliveryDaysMax?: InputMaybe<Scalars['Int']['input']>;
	/** Optional — omit both to save a priced method whose lead time isn't settled yet, then patch them in with updateOrderQuoteOfferDelivery. Such an option can't be sent to a client until they're set. */
	deliveryDaysMin?: InputMaybe<Scalars['Int']['input']>;
	orderQuoteOfferPricingId: Scalars['ID']['input'];
	/** What the client pays for this option, in the currency named below. Replaces basePrice + adminFee. */
	price: Scalars['Float']['input'];
	quantity: Scalars['Int']['input'];
	shippingMethod: OrderShippingMethod;
};

export type AddOrderQuoteOfferDeliverySplitInput = {
	orderQuoteOfferPricingId: Scalars['ID']['input'];
	/** At least two. Quantities must add up to exactly the tier's quantity. */
	parts: Array<OrderQuoteOfferDeliveryPartInput>;
};

export type AddOrderQuoteOfferInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	orderQuoteItemId: Scalars['ID']['input'];
	orderQuoteOfferBatchId: Scalars['ID']['input'];
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
	vetterId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddOrderQuoteOfferSampleInput = {
	/** Required unless paymentTreatment is WAIVED — a free sample has no price to state. */
	baseSamplePrice?: InputMaybe<Scalars['Float']['input']>;
	baseShippingPrice?: InputMaybe<Scalars['Float']['input']>;
	currency: Scalars['String']['input'];
	deliveryDaysMax?: InputMaybe<Scalars['Int']['input']>;
	deliveryDaysMin?: InputMaybe<Scalars['Int']['input']>;
	maxProductionDays?: InputMaybe<Scalars['Int']['input']>;
	minProductionDays?: InputMaybe<Scalars['Int']['input']>;
	notes?: InputMaybe<Scalars['String']['input']>;
	orderQuoteOfferId: Scalars['ID']['input'];
	/** How the client pays for this sample. Defaults to PREPAID when omitted. */
	paymentTreatment?: InputMaybe<SamplePaymentTreatment>;
};

export type AddOrderQuoteRequestItemInput = {
	deadline?: InputMaybe<Scalars['DateTime']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type AddOrderQuoteRequestItemsInput = {
	items: Array<AddOrderQuoteRequestItemInput>;
	orderQuoteId: Scalars['ID']['input'];
};

export type AddQuoteProductCommentInput = {
	attachments?: InputMaybe<Array<QuoteProductCommentAttachmentInput>>;
	body?: InputMaybe<Scalars['String']['input']>;
	orderQuoteItemId: Scalars['ID']['input'];
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddQuoteProductCommentResponse = {
	__typename?: 'AddQuoteProductCommentResponse';
	/** The new message. Null on failure. */
	comment?: Maybe<QuoteProductComment>;
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
};

export type AddStudioFileVersionMetadataInput = {
	canvasHeight: Scalars['Float']['input'];
	canvasWidth: Scalars['Float']['input'];
	comment?: InputMaybe<Scalars['String']['input']>;
	height?: InputMaybe<Scalars['Float']['input']>;
	points?: InputMaybe<Array<PolygonPointInput>>;
	type: MetadataType;
	width?: InputMaybe<Scalars['Float']['input']>;
	x?: InputMaybe<Scalars['Float']['input']>;
	y?: InputMaybe<Scalars['Float']['input']>;
};

export enum AddressType {
	Billing = 'BILLING',
	Branch = 'BRANCH',
	Headquarters = 'HEADQUARTERS',
	Other = 'OTHER',
	Shipping = 'SHIPPING',
}

export type AddressValidationResult = {
	__typename?: 'AddressValidationResult';
	errors: Array<Scalars['String']['output']>;
	valid: Scalars['Boolean']['output'];
	warnings: Array<Scalars['String']['output']>;
};

export type AdminActiveActivities = {
	__typename?: 'AdminActiveActivities';
	activities: Array<AdminActivity>;
};

export type AdminActivity =
	| AdminOrderActivity
	| AdminOrderQuoteOfferBatchActivity
	| AdminQuoteActivity;

export enum AdminActivityType {
	DraftQuote = 'DRAFT_QUOTE',
	OfferBatchPendingSend = 'OFFER_BATCH_PENDING_SEND',
	OrderConfirmationPending = 'ORDER_CONFIRMATION_PENDING',
	OrderNewSampleRequestPending = 'ORDER_NEW_SAMPLE_REQUEST_PENDING',
	OrderProductProductionInProgress = 'ORDER_PRODUCT_PRODUCTION_IN_PROGRESS',
	OrderProductProductionPending = 'ORDER_PRODUCT_PRODUCTION_PENDING',
	OrderProductShipmentPending = 'ORDER_PRODUCT_SHIPMENT_PENDING',
	OrderSampleProductionInProgress = 'ORDER_SAMPLE_PRODUCTION_IN_PROGRESS',
	OrderSampleProductionPending = 'ORDER_SAMPLE_PRODUCTION_PENDING',
	OrderSampleSubmissionPending = 'ORDER_SAMPLE_SUBMISSION_PENDING',
	PendingQuote = 'PENDING_QUOTE',
}

/**
 * Admin-built invoice draft lifecycle.
 *   - draft: items selected, e-conomic draft minted, not yet sent.
 *   - booked: admin booked + sent — read-only thereafter.
 *   - cancelled: admin cancelled before booking; e-conomic draft deleted,
 *     items become invoiceable again automatically.
 */
export enum AdminInvoiceDraftStatus {
	Booked = 'booked',
	Cancelled = 'cancelled',
	Draft = 'draft',
}

/** Admin action required on an order — state transition blocked until admin acts. */
export type AdminOrderActivity = {
	__typename?: 'AdminOrderActivity';
	id: Scalars['ID']['output'];
	orderId: Scalars['ID']['output'];
	title?: Maybe<Scalars['String']['output']>;
	type: AdminActivityType;
};

/** A draft offer batch the admin has built but not yet sent to the client. */
export type AdminOrderQuoteOfferBatchActivity = {
	__typename?: 'AdminOrderQuoteOfferBatchActivity';
	batch?: Maybe<OrderQuoteOfferBatch>;
	batchId: Scalars['ID']['output'];
	id: Scalars['ID']['output'];
	title?: Maybe<Scalars['String']['output']>;
	type: AdminActivityType;
};

export type AdminQuoteActivity = {
	__typename?: 'AdminQuoteActivity';
	id: Scalars['ID']['output'];
	quoteId: Scalars['ID']['output'];
	/** Ready-to-display label for the activity. */
	title?: Maybe<Scalars['String']['output']>;
	type: AdminActivityType;
};

export type AdminSystemSetting = {
	__typename?: 'AdminSystemSetting';
	createdAt: Scalars['String']['output'];
	defaultApproval: Scalars['Boolean']['output'];
	defaultInvoiceMinimumThreshold: Scalars['Float']['output'];
	defaultMargin: Scalars['Float']['output'];
	defaultProductPaymentMode: PaymentModeEnum;
	defaultSamplePaymentMode: PaymentModeEnum;
	defaultStripeCheckoutLimit: Scalars['Float']['output'];
	id: Scalars['ID']['output'];
	updatedAt: Scalars['String']['output'];
};

export type AdminUser = Base & {
	__typename?: 'AdminUser';
	authenticationUser?: Maybe<AuthenticationUser>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	lastName: Scalars['String']['output'];
	status: StatusEnum;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId: Scalars['ID']['output'];
};

export type AdminUserPage = {
	__typename?: 'AdminUserPage';
	data: Array<AdminUser>;
	pageInfo: PageInfo;
};

/** Aggregate admin user counts, broken down by lifecycle status. */
export type AdminUserStats = {
	__typename?: 'AdminUserStats';
	/** Users who have completed onboarding (status COMPLETED). */
	active: Scalars['Int']['output'];
	/** Users who have been invited but not yet activated (status PENDING). */
	pending: Scalars['Int']['output'];
	/** All admin users. */
	total: Scalars['Int']['output'];
};

export type AdminUserStub = {
	__typename?: 'AdminUserStub';
	firstName: Scalars['String']['output'];
	lastName: Scalars['String']['output'];
};

export type ApplyCatalogPriceToOfferSampleInput = {
	orderQuoteOfferSampleId: Scalars['ID']['input'];
};

export type ApplyCatalogPriceToOfferTierInput = {
	mode: CatalogPriceDriftActionMode;
	orderQuoteOfferPricingId: Scalars['ID']['input'];
};

export type ApplyVetterPricesInput = {
	orderQuoteOfferBatchId: Scalars['ID']['input'];
	/** Any subset of the batch's products; each with the supplier whose answer to use. */
	products: Array<ApplyVetterPricesProductInput>;
};

export type ApplyVetterPricesPreview = {
	__typename?: 'ApplyVetterPricesPreview';
	/** Why not, ready to show. The same message apply would return. */
	blockedReason?: Maybe<Scalars['String']['output']>;
	/** Whether applyVetterPrices would go through with this input. */
	canApply: Scalars['Boolean']['output'];
	products: Array<ApplyVetterPricesProductPreview>;
};

export type ApplyVetterPricesProductInput = {
	orderQuoteItemId: Scalars['ID']['input'];
	/** Only these quantities of the product. Leave out for every quantity the supplier priced. */
	orderQuoteItemQuantityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	/**
	 * The quantities to apply, each optionally with the client price set at the same time. Use this
	 * OR orderQuoteItemQuantityIds, not both. A quantity with no pricing given keeps its margin rule.
	 */
	quantities?: InputMaybe<Array<ApplyVetterPricesQuantityInput>>;
	/** The supplier's price request (VetterJob / OrderQuoteVetterJob id). Must cover this product. */
	vetterJobId: Scalars['ID']['input'];
};

export type ApplyVetterPricesProductPreview = {
	__typename?: 'ApplyVetterPricesProductPreview';
	orderQuoteItemId: Scalars['ID']['output'];
	productName: Scalars['String']['output'];
	quantities: Array<ApplyVetterPricesQuantityPreview>;
	supplierChanges: Scalars['Boolean']['output'];
	/** The product's supplier now. Null when none is chosen. */
	supplierFrom?: Maybe<VetterEntity>;
	supplierTo: VetterEntity;
};

/**
 * One quantity to apply, with at most ONE way of setting the client price — the same three the offer
 * page has. All left out: the tier's margin rule is kept (and a quantity with no price yet stays
 * without a client price).
 */
export type ApplyVetterPricesQuantityInput = {
	/** Margin per unit on top of the cost. */
	marginAmount?: InputMaybe<Scalars['Float']['input']>;
	marginAmountCurrency?: InputMaybe<Scalars['String']['input']>;
	/** Markup on the supplier's cost: price = cost x (1 + markup/100). */
	markupPercentage?: InputMaybe<Scalars['Float']['input']>;
	orderQuoteItemQuantityId: Scalars['ID']['input'];
	/**
	 * Delivery prices typed for this quantity, in the same step. Each wins over the supplier's price
	 * for its line; lines not listed keep the supplier's price (or stay as they are).
	 */
	shipping?: InputMaybe<Array<ApplyVetterPricesShippingInput>>;
	/** What the client pays per unit. The markup is derived. Refused below the supplier's cost. */
	unitSalePrice?: InputMaybe<Scalars['Float']['input']>;
	/** Currency of unitSalePrice; converted to the supplier's currency like everywhere on the offer. */
	unitSalePriceCurrency?: InputMaybe<Scalars['String']['input']>;
};

export type ApplyVetterPricesQuantityPreview = {
	__typename?: 'ApplyVetterPricesQuantityPreview';
	after: ApplyVetterPricesTierState;
	/** Null when the offer hasn't priced this quantity yet (createsPrice). */
	before?: Maybe<ApplyVetterPricesTierState>;
	/** False when applying would leave this quantity exactly as it is — its price and its shipping. */
	changed: Scalars['Boolean']['output'];
	/** True when the offer hasn't priced this quantity yet: apply creates its price, with no margin. */
	createsPrice: Scalars['Boolean']['output'];
	/** The margin rule carried over, ready to show, e.g. 20% markup kept. */
	marginRule: Scalars['String']['output'];
	orderQuoteItemQuantityId: Scalars['ID']['output'];
	quantity: Scalars['Int']['output'];
	/**
	 * Every shipping line of the quantity — each plain option, each split part, and a Standard /
	 * Express slot where it has no plain option of that method — unchanged ones included.
	 */
	shipping: Array<ApplyVetterPricesShippingPreview>;
	/** True when the tier has no margin, so it will have a cost but no client price. */
	unpricedForClient: Scalars['Boolean']['output'];
};

/**
 * One typed delivery price. Targets exactly ONE of: an existing plain option, a split's part, or a
 * new plain option by method (only where the quantity has no plain option of that method). Use the
 * line ids from the preview's shipping list.
 */
export type ApplyVetterPricesShippingInput = {
	deliveryDaysMax?: InputMaybe<Scalars['Int']['input']>;
	/** Both or neither. */
	deliveryDaysMin?: InputMaybe<Scalars['Int']['input']>;
	orderQuoteOfferDeliveryId?: InputMaybe<Scalars['ID']['input']>;
	orderQuoteOfferDeliveryPartId?: InputMaybe<Scalars['ID']['input']>;
	/** What the client pays for this option or part. */
	price: Scalars['Float']['input'];
	/** Defaults to the supplier's quoted currency. */
	priceCurrency?: InputMaybe<Scalars['String']['input']>;
	shippingMethod?: InputMaybe<OrderShippingMethod>;
};

export type ApplyVetterPricesShippingPreview = {
	__typename?: 'ApplyVetterPricesShippingPreview';
	after: ApplyVetterPricesShippingState;
	/** Null when createsOption. */
	before?: Maybe<ApplyVetterPricesShippingState>;
	changed: Scalars['Boolean']['output'];
	/** True for a slot: the quantity has no plain option of this method yet; it is created only when priced. */
	createsOption: Scalars['Boolean']['output'];
	/**
	 * The line's id, to send back in ApplyVetterPricesShippingInput: an option's id
	 * (orderQuoteOfferDeliveryId), a split part's id (orderQuoteOfferDeliveryPartId), or
	 * new:STANDARD / new:EXPRESS for a slot — send shippingMethod for those.
	 */
	id: Scalars['ID']['output'];
	/** Ready to show, e.g. Standard, or 10 Express + 490 Standard — 10 Express for a split's part. */
	label: Scalars['String']['output'];
	quantity: Scalars['Int']['output'];
	shippingMethod: OrderShippingMethod;
	/** Where after comes from. */
	source: ApplyVetterPricesShippingSource;
};

export enum ApplyVetterPricesShippingSource {
	/** The supplier's quoted price. */
	Supplier = 'SUPPLIER',
	/** Typed by the studio in the apply dialog. */
	Typed = 'TYPED',
	/** Left as it is — nothing to take from the supplier, nothing typed. */
	Unchanged = 'UNCHANGED',
}

export type ApplyVetterPricesShippingState = {
	__typename?: 'ApplyVetterPricesShippingState';
	deliveryDaysMax?: Maybe<Scalars['Int']['output']>;
	deliveryDaysMin?: Maybe<Scalars['Int']['output']>;
	/** What the client pays for this option or part. Null on a slot with nothing to fill it from. */
	price?: Maybe<Scalars['Float']['output']>;
};

export type ApplyVetterPricesShippingStatePriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ApplyVetterPricesTierState = {
	__typename?: 'ApplyVetterPricesTierState';
	/** Cost per unit. */
	cost?: Maybe<Scalars['Float']['output']>;
	/** Profit as a share of revenue, as OrderQuoteOfferPricing.marginPercentage. */
	marginPercentage?: Maybe<Scalars['Float']['output']>;
	/** Margin per unit. */
	marginUnit?: Maybe<Scalars['Float']['output']>;
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	/** What the client pays for the whole quantity. */
	totalPrice?: Maybe<Scalars['Float']['output']>;
	/** What the client pays per unit. Null when the tier has no client price. */
	unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type ApplyVetterPricesTierStateCostArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ApplyVetterPricesTierStateMarginUnitArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ApplyVetterPricesTierStateTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ApplyVetterPricesTierStateUnitPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ApproveEarlyAccessRequestInput = {
	/** Display label to cache alongside the number. Optional. */
	economicPaymentTermsName?: InputMaybe<Scalars['String']['input']>;
	/** e-conomic payment-terms number the client will sit under (from economicPaymentTerms). */
	economicPaymentTermsNumber: Scalars['Int']['input'];
	requestId: Scalars['ID']['input'];
};

export type ApproveEarlyAccessResponse = {
	__typename?: 'ApproveEarlyAccessResponse';
	inviteToken: Scalars['String']['output'];
	message: Scalars['String']['output'];
};

export type ApproveNewSampleRoundInput = {
	notes?: InputMaybe<Scalars['String']['input']>;
	/**
	 * How this round is paid for. Defaults to CHARGED and is deliberately NOT inherited from the round
	 * it replaces: the first sample is the client's prepayment, and a re-run exists because they
	 * rejected it, so it is rework.
	 *
	 * Inheriting PREPAID made every rejection mint another credit against the same production invoice,
	 * wiping out that revenue and making rework free to whoever caused it.
	 */
	paymentTreatment?: InputMaybe<SamplePaymentTreatment>;
};

export type AssignPermissionsToRoleInput = {
	permissionIds: Array<Scalars['ID']['input']>;
	roleId: Scalars['ID']['input'];
};

export type AssignStudioFileToClientInput = {
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	studioFileId: Scalars['ID']['input'];
};

export enum AuthRoleEnum {
	Admin = 'ADMIN',
	Manufacturer = 'MANUFACTURER',
	Organization = 'ORGANIZATION',
	Vetter = 'VETTER',
}

export type AuthenticationToken = Base & {
	__typename?: 'AuthenticationToken';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	secret?: Maybe<Scalars['String']['output']>;
	token: Scalars['String']['output'];
	type: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	user?: Maybe<AuthenticationUser>;
	userId: Scalars['ID']['output'];
};

export enum AuthenticationTokenTypeEnum {
	Login = 'LOGIN',
	Refresh = 'REFRESH',
	Register = 'REGISTER',
	ResetPassword = 'RESET_PASSWORD',
	Validation = 'VALIDATION',
}

export type AuthenticationUser = Base & {
	__typename?: 'AuthenticationUser';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	email?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	language: Scalars['String']['output'];
	lastActive?: Maybe<Scalars['DateTime']['output']>;
	lockReason?: Maybe<Scalars['String']['output']>;
	lockedAt?: Maybe<Scalars['DateTime']['output']>;
	mfaEnabled: Scalars['Boolean']['output'];
	mfaMethod?: Maybe<MfaMethodEnum>;
	/** The membership in the organization this session works in (for the signed-in user), else the oldest one. */
	organizationUser?: Maybe<OrganizationUser>;
	role: AuthRoleEnum;
	/** Set only on the user returned with a freshly issued session (loginValidate, refreshToken, switchOrganization): the organization that session works in. Null everywhere else. */
	sessionOrganizationId?: Maybe<Scalars['ID']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	vetterUser?: Maybe<VetterUser>;
};

export type AuthenticationUserInput = {
	email: Scalars['String']['input'];
};

export type AuthenticationUserMetadata = {
	__typename?: 'AuthenticationUserMetadata';
	organizationId?: Maybe<Scalars['ID']['output']>;
};

export type AuthenticationUserPage = {
	__typename?: 'AuthenticationUserPage';
	data: Array<AuthenticationUser>;
	pageInfo: PageInfo;
};

export type AuthenticationUserUpdateInput = {
	email?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	language?: InputMaybe<Scalars['String']['input']>;
	role?: InputMaybe<AuthRoleEnum>;
};

export type AuthorizationPermission = Base & {
	__typename?: 'AuthorizationPermission';
	action?: Maybe<AuthorizationPermissionAction>;
	authorizationRolePermissions?: Maybe<Array<AuthorizationRolePermission>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	resource?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum AuthorizationPermissionAction {
	Create = 'CREATE',
	Delete = 'DELETE',
	Read = 'READ',
	Update = 'UPDATE',
}

export type AuthorizationRole = Base & {
	__typename?: 'AuthorizationRole';
	authorizationRolePermissions?: Maybe<Array<AuthorizationRolePermission>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	scope: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AuthorizationRoleCreateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	permissionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AuthorizationRolePage = {
	__typename?: 'AuthorizationRolePage';
	data?: Maybe<Array<AuthorizationRole>>;
	pageInfo: PageInfo;
};

export type AuthorizationRolePermission = Base & {
	__typename?: 'AuthorizationRolePermission';
	authorizationPermission?: Maybe<AuthorizationPermission>;
	authorizationPermissionId: Scalars['ID']['output'];
	authorizationRoleId: Scalars['ID']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AuthorizationRoleUpdateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorizationUserRole = Base & {
	__typename?: 'AuthorizationUserRole';
	authorizationRole?: Maybe<AuthorizationRole>;
	authorizationRoleId: Scalars['ID']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	resourceId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId: Scalars['ID']['output'];
};

export type AuthorizationUserRolePage = {
	__typename?: 'AuthorizationUserRolePage';
	data?: Maybe<Array<AuthorizationUserRole>>;
	pageInfo: PageInfo;
};

export type BackupCodesResponse = {
	__typename?: 'BackupCodesResponse';
	backupCodes: Array<Scalars['String']['output']>;
	message: Scalars['String']['output'];
};

/** What a manually recorded bank transfer paid for — the same three routes a client can pay by. */
export enum BankTransferScope {
	FullOrder = 'FULL_ORDER',
	Products = 'PRODUCTS',
	Samples = 'SAMPLES',
}

export type Base = {
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Brand = Base & {
	__typename?: 'Brand';
	address?: Maybe<BrandAddress>;
	brandFiles?: Maybe<Array<BrandFile>>;
	brandPersonality?: Maybe<BrandPersonality>;
	brandguide?: Maybe<Scalars['String']['output']>;
	colorPalette?: Maybe<BrandColorPalette>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	fontFiles?: Maybe<Array<FontFile>>;
	id: Scalars['ID']['output'];
	logo?: Maybe<BrandLogo>;
	name: Scalars['String']['output'];
	organizationId: Scalars['ID']['output'];
	typography?: Maybe<BrandTypography>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	usageGuidelines?: Maybe<BrandUsageGuidelines>;
	website?: Maybe<Scalars['String']['output']>;
};

export type BrandAiContext = {
	__typename?: 'BrandAIContext';
	assetSummary?: Maybe<BrandAssetSummary>;
	brand: Brand;
	designGuidelines?: Maybe<Scalars['String']['output']>;
	recommendations?: Maybe<Array<Scalars['String']['output']>>;
};

export type BrandAddress = {
	__typename?: 'BrandAddress';
	city?: Maybe<Scalars['String']['output']>;
	country?: Maybe<Scalars['String']['output']>;
	formatted?: Maybe<Scalars['String']['output']>;
	postalCode?: Maybe<Scalars['String']['output']>;
	state?: Maybe<Scalars['String']['output']>;
	street?: Maybe<Scalars['String']['output']>;
};

export type BrandAddressInput = {
	city?: InputMaybe<Scalars['String']['input']>;
	country?: InputMaybe<Scalars['String']['input']>;
	formatted?: InputMaybe<Scalars['String']['input']>;
	postalCode?: InputMaybe<Scalars['String']['input']>;
	state?: InputMaybe<Scalars['String']['input']>;
	street?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAsset = BrandFile | FontFile;

export type BrandAssetSummary = {
	__typename?: 'BrandAssetSummary';
	availableFormats: Array<Scalars['String']['output']>;
	brandMood?: Maybe<Scalars['String']['output']>;
	colorCount: Scalars['Int']['output'];
	dominantColors: Array<Scalars['String']['output']>;
	fontCount: Scalars['Int']['output'];
	logoVariants: Scalars['Int']['output'];
	totalAssets: Scalars['Int']['output'];
};

export type BrandColor = {
	__typename?: 'BrandColor';
	aiDescription?: Maybe<Scalars['String']['output']>;
	hex: Scalars['String']['output'];
	mood?: Maybe<Scalars['String']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	pantone?: Maybe<BrandPantoneRef>;
	usage?: Maybe<Scalars['String']['output']>;
};

export type BrandColorInput = {
	aiDescription?: InputMaybe<Scalars['String']['input']>;
	hex: Scalars['String']['input'];
	mood?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	pantone?: InputMaybe<BrandPantoneRefInput>;
	usage?: InputMaybe<Scalars['String']['input']>;
};

export type BrandColorPalette = {
	__typename?: 'BrandColorPalette';
	accent?: Maybe<Array<BrandColor>>;
	neutral?: Maybe<Array<BrandColor>>;
	primary?: Maybe<Array<BrandColor>>;
	secondary?: Maybe<Array<BrandColor>>;
};

export type BrandColorPaletteInput = {
	accent?: InputMaybe<Array<BrandColorInput>>;
	neutral?: InputMaybe<Array<BrandColorInput>>;
	primary?: InputMaybe<Array<BrandColorInput>>;
	secondary?: InputMaybe<Array<BrandColorInput>>;
};

export type BrandCreateInput = {
	address?: InputMaybe<BrandAddressInput>;
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	website?: InputMaybe<Scalars['String']['input']>;
};

export type BrandFile = {
	__typename?: 'BrandFile';
	aiDescription?: Maybe<Scalars['String']['output']>;
	backgroundType?: Maybe<Array<Scalars['String']['output']>>;
	designVariant?: Maybe<Scalars['String']['output']>;
	dimensions?: Maybe<FileDimensions>;
	id: Scalars['ID']['output'];
	mimeType: Scalars['String']['output'];
	name: Scalars['String']['output'];
	resolution?: Maybe<Scalars['String']['output']>;
	size: Scalars['Int']['output'];
	tags?: Maybe<Array<Scalars['String']['output']>>;
	thumbnailUrl?: Maybe<Scalars['String']['output']>;
	type: BrandFileType;
	uploadedAt: Scalars['DateTime']['output'];
	url?: Maybe<Scalars['String']['output']>;
	usageContext?: Maybe<Array<Scalars['String']['output']>>;
};

export enum BrandFileType {
	Document = 'document',
	Font = 'font',
	Icon = 'icon',
	Image = 'image',
	Logo = 'logo',
}

export type BrandFileUploadInput = {
	brandFileType: BrandFileType;
	brandId: Scalars['ID']['input'];
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
};

export type BrandLogo = {
	__typename?: 'BrandLogo';
	aiDescription?: Maybe<Scalars['String']['output']>;
	dimensions?: Maybe<FileDimensions>;
	id: Scalars['ID']['output'];
	mimeType: Scalars['String']['output'];
	name: Scalars['String']['output'];
	size: Scalars['Int']['output'];
	thumbnailUrl?: Maybe<Scalars['String']['output']>;
	uploadedAt: Scalars['DateTime']['output'];
	url?: Maybe<Scalars['String']['output']>;
};

export type BrandLogoInput = {
	aiDescription?: InputMaybe<Scalars['String']['input']>;
	dimensions?: InputMaybe<FileDimensionsInput>;
	id: Scalars['ID']['input'];
	mimeType: Scalars['String']['input'];
	name: Scalars['String']['input'];
	size: Scalars['Int']['input'];
	uploadedAt: Scalars['DateTime']['input'];
	url: Scalars['String']['input'];
};

export type BrandPage = {
	__typename?: 'BrandPage';
	data: Array<Brand>;
	pageInfo: PageInfo;
};

export type BrandPantoneRef = {
	__typename?: 'BrandPantoneRef';
	book: PantoneBook;
	code: Scalars['String']['output'];
	color?: Maybe<PantoneColor>;
	hex?: Maybe<Scalars['String']['output']>;
};

export type BrandPantoneRefInput = {
	book: PantoneBook;
	code: Scalars['String']['input'];
	hex?: InputMaybe<Scalars['String']['input']>;
};

export type BrandPersonality = {
	__typename?: 'BrandPersonality';
	aiGuidance?: Maybe<Scalars['String']['output']>;
	tone?: Maybe<Scalars['String']['output']>;
	traits?: Maybe<Array<Scalars['String']['output']>>;
	values?: Maybe<Array<Scalars['String']['output']>>;
};

export type BrandPersonalityInput = {
	aiGuidance?: InputMaybe<Scalars['String']['input']>;
	tone?: InputMaybe<Scalars['String']['input']>;
	traits?: InputMaybe<Array<Scalars['String']['input']>>;
	values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BrandTypography = {
	__typename?: 'BrandTypography';
	guidelines?: Maybe<Scalars['String']['output']>;
	hierarchy?: Maybe<TypographyHierarchy>;
	primaryFont?: Maybe<Scalars['String']['output']>;
	secondaryFont?: Maybe<Scalars['String']['output']>;
};

export type BrandTypographyInput = {
	guidelines?: InputMaybe<Scalars['String']['input']>;
	hierarchy?: InputMaybe<TypographyHierarchyInput>;
	primaryFont?: InputMaybe<Scalars['String']['input']>;
	secondaryFont?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUpdateInput = {
	address?: InputMaybe<BrandAddressInput>;
	brandPersonality?: InputMaybe<BrandPersonalityInput>;
	brandguide?: InputMaybe<Scalars['String']['input']>;
	colorPalette?: InputMaybe<BrandColorPaletteInput>;
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	logo?: InputMaybe<BrandLogoInput>;
	name?: InputMaybe<Scalars['String']['input']>;
	typography?: InputMaybe<BrandTypographyInput>;
	usageGuidelines?: InputMaybe<BrandUsageGuidelinesInput>;
	website?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUsageGuidelines = {
	__typename?: 'BrandUsageGuidelines';
	aiInstructions?: Maybe<Scalars['String']['output']>;
	colorUsage?: Maybe<Scalars['String']['output']>;
	logoPlacement?: Maybe<Scalars['String']['output']>;
	spacing?: Maybe<Scalars['String']['output']>;
	typographyRules?: Maybe<Scalars['String']['output']>;
};

export type BrandUsageGuidelinesInput = {
	aiInstructions?: InputMaybe<Scalars['String']['input']>;
	colorUsage?: InputMaybe<Scalars['String']['input']>;
	logoPlacement?: InputMaybe<Scalars['String']['input']>;
	spacing?: InputMaybe<Scalars['String']['input']>;
	typographyRules?: InputMaybe<Scalars['String']['input']>;
};

export type BulkImageFileInput = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: FileTypeEnum;
};

export type BulkImageUploadUrl = {
	__typename?: 'BulkImageUploadUrl';
	blobUrl: Scalars['String']['output'];
	expiresAt: Scalars['DateTime']['output'];
	fileName: Scalars['String']['output'];
	imageId: Scalars['ID']['output'];
	uploadUrl: Scalars['String']['output'];
};

export type BulkProductInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	imageUrls: Array<Scalars['String']['input']>;
	metadata?: InputMaybe<ProductMetadataInput>;
	name: Scalars['String']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	specifications?: InputMaybe<ProductSpecificationsInput>;
	tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BusinessRegistration = {
	__typename?: 'BusinessRegistration';
	number: Scalars['String']['output'];
	type: Scalars['String']['output'];
	verified?: Maybe<Scalars['Boolean']['output']>;
	verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BusinessRegistrationInput = {
	number: Scalars['String']['input'];
	type: Scalars['String']['input'];
};

export type CvrAddress = {
	__typename?: 'CVRAddress';
	city: Scalars['String']['output'];
	country: Scalars['String']['output'];
	street: Scalars['String']['output'];
	zipcode: Scalars['String']['output'];
};

export type CvrCompanyInfo = {
	__typename?: 'CVRCompanyInfo';
	active: Scalars['Boolean']['output'];
	address: CvrAddress;
	email?: Maybe<Scalars['String']['output']>;
	employees?: Maybe<Scalars['String']['output']>;
	industryCode?: Maybe<Scalars['Int']['output']>;
	industryDescription?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
	phone?: Maybe<Scalars['String']['output']>;
	startDate?: Maybe<Scalars['String']['output']>;
	vat: Scalars['String']['output'];
};

export type CvrValidationResult = {
	__typename?: 'CVRValidationResult';
	companyInfo?: Maybe<CvrCompanyInfo>;
	error?: Maybe<Scalars['String']['output']>;
	valid: Scalars['Boolean']['output'];
};

export type CatalogPriceBreak = {
	__typename?: 'CatalogPriceBreak';
	baseUnitPrice: Scalars['Float']['output'];
	/** This rung in the currency passed as inCurrency. Null when none was passed or no rate is available. */
	converted?: Maybe<CatalogPriceConversion>;
	currency: Scalars['String']['output'];
	markupPercentage?: Maybe<Scalars['Float']['output']>;
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	quantity: Scalars['Int']['output'];
};

/**
 * A suggested cost restated in the currency the pricing form saves in, at today's rate.
 *
 * The catalogue and a supplier's answer each keep the one currency they were given in. Prefill the
 * form from this block when the suggestion's own currency differs from the form's, and show the
 * original amount beside it so the admin can see what was actually quoted.
 */
export type CatalogPriceConversion = {
	__typename?: 'CatalogPriceConversion';
	baseUnitPrice: Scalars['Float']['output'];
	currency: Scalars['String']['output'];
	/** One unit of the suggestion's own currency in this one. 1 when they are the same. */
	exchangeRate: Scalars['Float']['output'];
	/** The supplier's shipping at the same rate. VETTER suggestions only, empty otherwise. */
	shippingPrices: Array<VetterShippingPrice>;
};

export type CatalogPriceDrift = {
	__typename?: 'CatalogPriceDrift';
	/** The buttons. Always both modes, in this order: USE_NEW_COST, then KEEP_CLIENT_PRICE. */
	actions: Array<CatalogPriceDriftAction>;
	catalogCurrency: Scalars['String']['output'];
	/** The catalogue's current cost for this product, supplier and tier, in catalogCurrency. */
	catalogUnitPrice: Scalars['Float']['output'];
	/** A note when the catalogue had no price for this exact volume. Null on an exact match. */
	caveat?: Maybe<Scalars['String']['output']>;
	/** When the catalogue price changed, or was added. Null when not recorded. */
	changedAt?: Maybe<Scalars['DateTime']['output']>;
	/** Who changed it, on CATALOGUE_EDITED. Null when not known. */
	changedByName?: Maybe<Scalars['String']['output']>;
	/** The quote an inferred catalogue price followed, on FOLLOWED_NEWER_QUOTE. */
	changedByQuote?: Maybe<CatalogPriceDriftQuote>;
	/**
	 * The three amounts above in the currency passed as inCurrency, for display. The comparison
	 * itself is still made in catalogCurrency; differencePercentage is the same in any currency.
	 * Null when no inCurrency was passed or no rate is available.
	 */
	converted?: Maybe<CatalogPriceDriftFigures>;
	/** catalogUnitPrice minus offerUnitPrice. Positive means the catalogue is now dearer than this offer. */
	differenceAmount: Scalars['Float']['output'];
	/** The same difference as a share of the offer's cost. Null when the offer's cost is zero. */
	differencePercentage?: Maybe<Scalars['Float']['output']>;
	direction: CatalogPriceDriftDirection;
	/** The currency the strings use: inCurrency when a rate allows it, otherwise catalogCurrency. */
	displayCurrency: Scalars['String']['output'];
	/** What happened and what it means for this tier's margin, in displayCurrency. */
	explanation: Scalars['String']['output'];
	/** The badge, ready to show, e.g. Cost up 8%. */
	label: Scalars['String']['output'];
	/** How this tier's margin changes if the catalogue cost applies at today's price, in displayCurrency. Negative is a drop. */
	marginImpact?: Maybe<Scalars['Float']['output']>;
	match: CatalogPriceMatch;
	/**
	 * The catalogue break the comparison used, which is NOT always this tier's own quantity — the
	 * catalogue answers by break, so a 550 tier is compared against the 500 row.
	 *
	 * Say which volume the comparison came from whenever match is not EXACT, and treat
	 * BELOW_MINIMUM with suspicion: there the catalogue price is a floor on a volume smaller than
	 * any it holds, so the difference is not a like-for-like drift at all.
	 */
	matchedQuantity: Scalars['Int']['output'];
	/** This tier's stored cost, converted to catalogCurrency so the two are comparable. */
	offerUnitPrice: Scalars['Float']['output'];
	reason: CatalogPriceDriftReason;
	source: CatalogPriceSource;
};

export type CatalogPriceDriftAction = {
	__typename?: 'CatalogPriceDriftAction';
	available: Scalars['Boolean']['output'];
	/** Ready to show, with the result in it, e.g. Use new cost · price becomes USD 1.13. */
	label: Scalars['String']['output'];
	mode: CatalogPriceDriftActionMode;
	/** Why the action is unavailable. Null when available. */
	unavailableReason?: Maybe<Scalars['String']['output']>;
	/** Ask the admin to confirm this before applying, e.g. when the client has already seen the offer. */
	warning?: Maybe<Scalars['String']['output']>;
};

export enum CatalogPriceDriftActionMode {
	/** Take the catalogue cost and keep the client price exactly: the margin absorbs the difference. */
	KeepClientPrice = 'KEEP_CLIENT_PRICE',
	/** Take the catalogue cost and keep the markup: the client price follows the cost. */
	UseNewCost = 'USE_NEW_COST',
}

export enum CatalogPriceDriftDirection {
	/** The catalogue cost is now lower. */
	Down = 'DOWN',
	/** The catalogue cost is now higher than this offer's cost. */
	Up = 'UP',
}

/** A catalogue drift's amounts restated in one currency. Unit figures, so up to 6 decimals. */
export type CatalogPriceDriftFigures = {
	__typename?: 'CatalogPriceDriftFigures';
	catalogUnitPrice: Scalars['Float']['output'];
	currency: Scalars['String']['output'];
	differenceAmount: Scalars['Float']['output'];
	offerUnitPrice: Scalars['Float']['output'];
};

export type CatalogPriceDriftQuote = {
	__typename?: 'CatalogPriceDriftQuote';
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
};

export enum CatalogPriceDriftReason {
	/** The catalogue had no price for this when the tier was priced; one was added later. */
	AddedAfter = 'ADDED_AFTER',
	/** A person changed the catalogue cost after this tier was priced. */
	CatalogueEdited = 'CATALOGUE_EDITED',
	/** The catalogue has not changed since; this tier was priced differently from the start. */
	DifferentFromStart = 'DIFFERENT_FROM_START',
	/** An inferred catalogue price followed a newer quote after this tier was priced. */
	FollowedNewerQuote = 'FOLLOWED_NEWER_QUOTE',
	/** The catalogue's history from before change tracking began (21 Oct 2026) is not recorded. */
	HistoryUnknown = 'HISTORY_UNKNOWN',
}

/**
 * How far the catalogue had to reach to price this tier.
 *
 * EXACT is a row for this very quantity. BRACKET reached DOWN to a lower break and errs safe — the
 * true cost at 550 is at most the 500 cost. BELOW_MINIMUM reached UP to the ladder's first rung
 * because the whole ladder starts above this quantity, and errs the other way: a shorter run costs
 * more per unit, so that price is a FLOOR on the real cost, not the cost.
 */
export enum CatalogPriceMatch {
	BelowMinimum = 'BELOW_MINIMUM',
	Bracket = 'BRACKET',
	Exact = 'EXACT',
}

/**
 * Which row answered: the supplier's own catalogue row, the house fallback, or — VETTER — the
 * prices the supplier submitted through a vetter link for this very quote line.
 */
export enum CatalogPriceSource {
	House = 'HOUSE',
	Supplier = 'SUPPLIER',
	Vetter = 'VETTER',
}

export type CatalogPriceSuggestion = {
	__typename?: 'CatalogPriceSuggestion';
	/**
	 * The rest of the ladder this price came from, lowest first, with the applied rung left out.
	 *
	 * Context, not values to fill in: what the OTHER volumes would cost, so an admin pricing 550
	 * can see that 1000 is cheaper per unit and decide whether to push the client there. Render it
	 * distinctly from the prefilled fields — the moment it looks like a suggested value, someone
	 * will save it against the wrong tier.
	 *
	 * Same supplier as the applied break, or the house rows if the house answered. Never mixed.
	 */
	alternatives: Array<CatalogPriceBreak>;
	baseUnitPrice: Scalars['Float']['output'];
	/**
	 * This suggestion in the currency passed as inCurrency, at today's rate. Null when none was
	 * passed or no rate is available, in which case only the original amount can be used.
	 */
	converted?: Maybe<CatalogPriceConversion>;
	currency: Scalars['String']['output'];
	markupPercentage?: Maybe<Scalars['Float']['output']>;
	match: CatalogPriceMatch;
	/**
	 * The catalogue break this price came from. Equal to quantity on an exact hit, lower when a
	 * break was applied — a ladder with rows at 500 and 1000 prices a 550 tier off the 500 row.
	 *
	 * Show it when it differs. Carrying a 500 price up to a 550 tier is a reasonable default and a
	 * bad thing to apply without saying so.
	 */
	matchedQuantity: Scalars['Int']['output'];
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	/** The supplier's note on the submission this came from. VETTER suggestions only. */
	note?: Maybe<Scalars['String']['output']>;
	orderQuoteItemQuantityId: Scalars['ID']['output'];
	/** The tier being priced. */
	quantity: Scalars['Int']['output'];
	/**
	 * Shipping the supplier quoted for this tier, per method — VETTER suggestions only, empty on
	 * catalogue ones. The supplier's figure: prefill the delivery option with it and let the
	 * admin set what the client pays before sending.
	 */
	shippingPrices: Array<VetterShippingPrice>;
	source: CatalogPriceSource;
	/**
	 * The supplier whose row answered, or null on a house price.
	 *
	 * Read the supplier's name from this rather than inferring it from the source field plus the id
	 * you passed in: assign a supplier with no catalogue prices of its own and the lookup correctly
	 * falls back to the house ladder, where naming that supplier would credit them with a price
	 * they never gave.
	 */
	vetterEntity?: Maybe<VetterEntity>;
};

export type CatalogSampleConversion = {
	__typename?: 'CatalogSampleConversion';
	currency: Scalars['String']['output'];
	/** One unit of the suggestion's own currency in this one. */
	exchangeRate: Scalars['Float']['output'];
	samplePrice: Scalars['Float']['output'];
	shippingPrice?: Maybe<Scalars['Float']['output']>;
};

/**
 * How a sample's price compares with the catalogue today, why, and the button that applies it.
 * Freight is compared only when both the sample and the catalogue state one.
 */
export type CatalogSamplePriceDrift = {
	__typename?: 'CatalogSamplePriceDrift';
	/** The one button: take the catalogue price. Render as it comes; confirm the warning first. */
	action: CatalogSamplePriceDriftAction;
	catalogCurrency: Scalars['String']['output'];
	catalogSamplePrice: Scalars['Float']['output'];
	/** Null when the catalogue knows no freight; applying then keeps the sample's own freight. */
	catalogShippingPrice?: Maybe<Scalars['Float']['output']>;
	changedAt?: Maybe<Scalars['DateTime']['output']>;
	changedByName?: Maybe<Scalars['String']['output']>;
	changedByQuote?: Maybe<CatalogPriceDriftQuote>;
	/** The amounts in inCurrency, for display. Null when none was passed or no rate exists. */
	converted?: Maybe<CatalogSamplePriceDriftFigures>;
	/** Catalogue total minus this sample's total. Positive means the catalogue is now dearer. */
	differenceAmount: Scalars['Float']['output'];
	differencePercentage?: Maybe<Scalars['Float']['output']>;
	direction: CatalogPriceDriftDirection;
	/** The currency the strings use. */
	displayCurrency: Scalars['String']['output'];
	explanation: Scalars['String']['output'];
	/** The badge, e.g. Sample price up 8%. */
	label: Scalars['String']['output'];
	/** This sample's stored amounts, read in catalogCurrency. */
	offerSamplePrice: Scalars['Float']['output'];
	offerShippingPrice?: Maybe<Scalars['Float']['output']>;
	reason: CatalogPriceDriftReason;
	source: CatalogPriceSource;
};

export type CatalogSamplePriceDriftAction = {
	__typename?: 'CatalogSamplePriceDriftAction';
	available: Scalars['Boolean']['output'];
	/** Ready to show, with exactly what it writes, e.g. Use catalogue price · USD 100.00 + USD 20.00 freight. */
	label: Scalars['String']['output'];
	unavailableReason?: Maybe<Scalars['String']['output']>;
	/** Ask the admin to confirm this first, e.g. when the client has already seen the offer. */
	warning?: Maybe<Scalars['String']['output']>;
};

export type CatalogSamplePriceDriftFigures = {
	__typename?: 'CatalogSamplePriceDriftFigures';
	catalogSamplePrice: Scalars['Float']['output'];
	catalogShippingPrice?: Maybe<Scalars['Float']['output']>;
	currency: Scalars['String']['output'];
	differenceAmount: Scalars['Float']['output'];
	offerSamplePrice: Scalars['Float']['output'];
	offerShippingPrice?: Maybe<Scalars['Float']['output']>;
};

/** A catalogue sample price, to prefill a sample with. Both amounts are what the client pays. */
export type CatalogSampleSuggestion = {
	__typename?: 'CatalogSampleSuggestion';
	/** Inferred from quote history and not yet confirmed by anyone. Say so beside the prefilled figure. */
	backfilled: Scalars['Boolean']['output'];
	/** Both amounts in inCurrency at today's rate. Prefill from this. Null when none was passed or no rate exists. */
	converted?: Maybe<CatalogSampleConversion>;
	currency: Scalars['String']['output'];
	deliveryDaysMax?: Maybe<Scalars['Int']['output']>;
	deliveryDaysMin?: Maybe<Scalars['Int']['output']>;
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	samplePrice: Scalars['Float']['output'];
	/** Null when the catalogue knows no freight. Leave the field empty then, not zero. */
	shippingPrice?: Maybe<Scalars['Float']['output']>;
	source: CatalogPriceSource;
	/** The supplier whose row answered; null on a house price. Read the name from here, not from the id you passed. */
	vetterEntity?: Maybe<VetterEntity>;
};

export type CategorizeBulkProductImagesInput = {
	imageUrls: Array<Scalars['String']['input']>;
};

export type CategorizeBulkProductImagesResponse = {
	__typename?: 'CategorizeBulkProductImagesResponse';
	categorizedImages: Scalars['Int']['output'];
	message: Scalars['String']['output'];
	products: Array<CategorizedProduct>;
	success: Scalars['Boolean']['output'];
	totalImages: Scalars['Int']['output'];
	unmappedImages: Array<UnmappedProjectProductImage>;
};

export type CategorizedProduct = {
	__typename?: 'CategorizedProduct';
	imageUrls: Array<Scalars['String']['output']>;
	productName: Scalars['String']['output'];
};

export enum ChatAttachmentType {
	Mask = 'mask',
	MaskPreview = 'maskPreview',
	Reference = 'reference',
}

export type ChatAttachmentUploadInput = {
	attachmentType: ChatAttachmentType;
	contentType: Scalars['String']['input'];
	fileName: Scalars['String']['input'];
	studioFileId: Scalars['ID']['input'];
};

export type ChatAttachmentUploadResponse = {
	__typename?: 'ChatAttachmentUploadResponse';
	blobUrl: Scalars['String']['output'];
	expiresAt: Scalars['DateTime']['output'];
	uploadUrl: Scalars['String']['output'];
};

export enum ChatRole {
	Assistant = 'assistant',
	System = 'system',
	User = 'user',
}

export enum CheckoutSessionStatus {
	Cancelled = 'cancelled',
	Completed = 'completed',
	Expired = 'expired',
	Pending = 'pending',
}

export type ClientGetAllOrderQuoteInput = {
	createdAt?: InputMaybe<DateRangeInput>;
	deadline?: InputMaybe<DateRangeInput>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	statuses?: InputMaybe<Array<OrderQuoteStatus>>;
};

export type ClientOrder = {
	__typename?: 'ClientOrder';
	/** What you can do with this order now. Pass inCurrency to have the payment routes quote their amounts in it, as the money fields on this type do; it defaults to DKK. */
	availableActions?: Maybe<Array<OrderNextAction>>;
	availablePaymentMethods?: Maybe<Array<OrderPaymentMethodOption>>;
	availableSamplePaymentMethods?: Maybe<Array<OrderPaymentMethodOption>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	/**
	 * Everything coming to you on this order — each sample and each shipment, with where it is and
	 * when it is expected. Present from the moment the order is placed, so a delivery that has not
	 * started yet still shows with its projected arrival.
	 */
	deliveries?: Maybe<Array<OrderDelivery>>;
	/** Where this order ships, as accepted. Changing the quote's address afterwards does not move a placed order. */
	deliveryAddress?: Maybe<OrderQuoteAddress>;
	id: Scalars['ID']['output'];
	items: Array<ClientOrderItem>;
	name: Scalars['String']['output'];
	orderNumber: Scalars['String']['output'];
	orderQuoteId: Scalars['ID']['output'];
	/** Everything you can pay for right now, priced and worded. One list — see OrderPaymentOption. */
	paymentOptions?: Maybe<Array<OrderPaymentOption>>;
	/** What has been paid on this order and what is still owed, split by products and samples. Same figures the admin sees — it is the client's own money. */
	paymentSummary?: Maybe<OrderPaymentSummary>;
	/** PO number captured at acceptance. Pre-fill the checkout PO field with this (still overridable per invoice). */
	poNumber?: Maybe<Scalars['String']['output']>;
	/**
	 * Whether the studio is still setting this order up. The same stage the studio sees, so the two
	 * pages cannot disagree about where an order is — without the internal detail of how many
	 * products are still being confirmed, which is the studio's own work.
	 */
	setupStage?: Maybe<OrderSetupStage>;
	/**
	 * Physical shipments, in sequence — one per product, or one per part where a split was picked.
	 * Where the goods are is what this answers; the item-level tracking fields answer for the first
	 * box only.
	 */
	shipments: Array<OrderShipment>;
	status: OrderStatus;
	summary?: Maybe<OrderSummary>;
	/** @deprecated Line revenue snapshotted at acceptance — ex-VAT, no fees, no delivery. For the headline order total use summary { grossAmount }. */
	totalAmount?: Maybe<Scalars['Float']['output']>;
	/** Units ordered across every non-cancelled item. */
	totalQuantity?: Maybe<Scalars['Int']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ClientOrderAvailableActionsArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderPaymentOptionsArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderPaymentSummaryArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderSummaryArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderTotalAmountArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderItem = {
	__typename?: 'ClientOrderItem';
	actualDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	adjustedTotalPrice?: Maybe<Scalars['Float']['output']>;
	attachments?: Maybe<Array<OrderItemAttachment>>;
	/**
	 * What you can do with this product now. Carries PAY_PRODUCT once the order is on the
	 * pay-per-product route: unblocked when this product's sample is settled, blocked with a reason
	 * while it is not. Render this list and nothing else — the rule for when a product can be paid
	 * for lives here, not in the page.
	 */
	availableActions?: Maybe<Array<OrderItemNextAction>>;
	carrier?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	/** How much of this item has arrived. Compare with quantity for the 100/500 reading. */
	deliveredQuantity?: Maybe<Scalars['Int']['output']>;
	delivery?: Maybe<ClientOrderItemDelivery>;
	estimatedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	lifecycle?: Maybe<Array<OrderItemLifecycleStep>>;
	/** What this line contributes to the order total: adjustedTotalPrice where the item carries adjustments, otherwise totalPrice. */
	lineTotal?: Maybe<Scalars['Float']['output']>;
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	orderId: Scalars['ID']['output'];
	paidAt?: Maybe<Scalars['DateTime']['output']>;
	productDescription?: Maybe<Scalars['String']['output']>;
	/** Unit dimensions as they stood on the quote line you accepted. */
	productDimensions?: Maybe<OrderProductDimensions>;
	productId?: Maybe<Scalars['ID']['output']>;
	productImages?: Maybe<Array<OrderItemProductImage>>;
	productName?: Maybe<Scalars['String']['output']>;
	/** The product's SKU as it stood on the quote line you accepted. Null on custom lines. */
	productSku?: Maybe<Scalars['String']['output']>;
	/** Specifications as they stood on the quote line that was accepted. Frozen at accept: later edits to the catalogue product do not reach it. */
	productSpecifications?: Maybe<OrderProductSpecifications>;
	/** When the specifications above were frozen. */
	productSpecificationsAt?: Maybe<Scalars['DateTime']['output']>;
	/** Unit weight as it stood on the quote line you accepted. */
	productWeight?: Maybe<Scalars['Float']['output']>;
	productionCompletedAt?: Maybe<Scalars['DateTime']['output']>;
	productionStartedAt?: Maybe<Scalars['DateTime']['output']>;
	quantity: Scalars['Int']['output'];
	sampleChoice?: Maybe<OrderSampleChoice>;
	samples?: Maybe<Array<ClientOrderItemSample>>;
	/**
	 * The boxes carrying this product, in order, each with how much of it they hold.
	 *
	 * The same list the studio sees — where your goods are is not internal. A product that was split
	 * travels in several boxes, and the flat carrier and trackingNumber fields above answer for the
	 * first one only.
	 */
	shipments?: Maybe<Array<OrderItemShipment>>;
	shippedAt?: Maybe<Scalars['DateTime']['output']>;
	/** How much of this item has left, counted from its shipments. */
	shippedQuantity?: Maybe<Scalars['Int']['output']>;
	sortOrder: Scalars['Int']['output'];
	status: OrderItemStatus;
	totalPrice?: Maybe<Scalars['Float']['output']>;
	trackingNumber?: Maybe<Scalars['String']['output']>;
	unitPrice?: Maybe<Scalars['Float']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	/** Who this product is waiting for right now — the actor of its current lifecycle step. Null when nothing is pending. */
	waitingOn?: Maybe<SampleActionActor>;
};

export type ClientOrderItemAdjustedTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderItemLineTotalArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderItemTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderItemUnitPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderItemDelivery = {
	__typename?: 'ClientOrderItemDelivery';
	deliveryDaysMax: Scalars['Int']['output'];
	deliveryDaysMin: Scalars['Int']['output'];
	id: Scalars['ID']['output'];
	quantity: Scalars['Int']['output'];
	shippingMethod: OrderShippingMethod;
	/** The method worded for display. Backend-owned, like every other label here. */
	shippingMethodLabel?: Maybe<Scalars['String']['output']>;
	totalPrice?: Maybe<Scalars['Float']['output']>;
};

export type ClientOrderItemDeliveryTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderItemSample = {
	__typename?: 'ClientOrderItemSample';
	actualDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	approvalNotes?: Maybe<Scalars['String']['output']>;
	/** Approval */
	approvedAt?: Maybe<Scalars['DateTime']['output']>;
	availableActions?: Maybe<Array<SampleNextAction>>;
	carrier?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deliveryDaysMax?: Maybe<Scalars['Int']['output']>;
	deliveryDaysMin?: Maybe<Scalars['Int']['output']>;
	estimatedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	/** This round's own progress. Six steps; the DELIVERY step is worded for the sample you have (shipped vs virtual delivery). */
	lifecycle?: Maybe<Array<OrderSampleLifecycleStep>>;
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	notes?: Maybe<Scalars['String']['output']>;
	paidAt?: Maybe<Scalars['DateTime']['output']>;
	/** How this sample is paid for. PREPAID means what you pay is credited against your production invoice. */
	paymentTreatment: SamplePaymentTreatment;
	previousSampleId?: Maybe<Scalars['ID']['output']>;
	productionCompletedAt?: Maybe<Scalars['DateTime']['output']>;
	productionStartedAt?: Maybe<Scalars['DateTime']['output']>;
	/** Rejection */
	rejectedAt?: Maybe<Scalars['DateTime']['output']>;
	rejectionAttachments?: Maybe<Array<ClientOrderItemSampleAttachment>>;
	rejectionReason?: Maybe<Scalars['String']['output']>;
	requestNewSample?: Maybe<Scalars['Boolean']['output']>;
	sampleChoice: OrderSampleChoice;
	sampleRound: Scalars['Int']['output'];
	shippedAt?: Maybe<Scalars['DateTime']['output']>;
	status: OrderSampleStatus;
	totalPrice?: Maybe<Scalars['Float']['output']>;
	/** Physical delivery */
	trackingNumber?: Maybe<Scalars['String']['output']>;
	/** A link to the carrier's tracking page, when the carrier is one we know. */
	trackingUrl?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	virtualDeliveryAttachments?: Maybe<Array<ClientOrderItemSampleAttachment>>;
	virtualDeliveryNotes?: Maybe<Scalars['String']['output']>;
	/** Virtual delivery */
	virtualDeliverySubmittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ClientOrderItemSampleTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderItemSampleAttachment = {
	__typename?: 'ClientOrderItemSampleAttachment';
	id: Scalars['ID']['output'];
	mimeType: Scalars['String']['output'];
	name: Scalars['String']['output'];
	size: Scalars['Int']['output'];
	type: OrderSampleAttachmentType;
	url: Scalars['String']['output'];
};

export type ClientOrderPage = {
	__typename?: 'ClientOrderPage';
	data: Array<ClientOrder>;
	pageInfo: PageInfo;
};

export type ClientOrderQuote = {
	__typename?: 'ClientOrderQuote';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deadline?: Maybe<Scalars['DateTime']['output']>;
	deliveryAddress?: Maybe<OrderQuoteAddress>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	items: Array<OrderQuoteItem>;
	lifecycle?: Maybe<Array<OrderQuoteLifecycleStep>>;
	name: Scalars['String']['output'];
	/**
	 * How many offer batches the client can see. Pass the same previewBatchIds as
	 * getClientOrderQuoteOfferBatches so the count and the list can't disagree in an admin preview.
	 */
	offerBatchCount: Scalars['Int']['output'];
	offerRequestedAt?: Maybe<Scalars['DateTime']['output']>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	purpose?: Maybe<OrderQuotePurpose>;
	purposeOther?: Maybe<Scalars['String']['output']>;
	requestItems: Array<OrderQuoteRequestItem>;
	status: OrderQuoteStatus;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ClientOrderQuoteOfferBatchCountArgs = {
	previewBatchIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ClientOrderQuoteOffer = {
	__typename?: 'ClientOrderQuoteOffer';
	acceptedDeliveryId?: Maybe<Scalars['ID']['output']>;
	acceptedPricingId?: Maybe<Scalars['ID']['output']>;
	acceptedQuantity?: Maybe<Scalars['Int']['output']>;
	adjustments: Array<ClientOrderQuoteOfferAdjustment>;
	attachments: Array<OrderQuoteItemAttachment>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	orderQuoteItemId: Scalars['ID']['output'];
	pricing: Array<ClientOrderQuoteOfferPricing>;
	rejectionReason?: Maybe<Scalars['String']['output']>;
	respondedAt?: Maybe<Scalars['DateTime']['output']>;
	sample?: Maybe<ClientOrderQuoteOfferSample>;
	sortOrder?: Maybe<Scalars['Int']['output']>;
	status: OrderQuoteOfferStatus;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ClientOrderQuoteOfferAdjustment = {
	__typename?: 'ClientOrderQuoteOfferAdjustment';
	calculationType: OrderAdjustmentCalculationType;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	type: OrderAdjustmentType;
	value: Scalars['Float']['output'];
};

export type ClientOrderQuoteOfferAdjustmentValueArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderQuoteOfferBatch = {
	__typename?: 'ClientOrderQuoteOfferBatch';
	acceptDeadline?: Maybe<Scalars['DateTime']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	offers: Array<ClientOrderQuoteOffer>;
	orderQuoteId: Scalars['ID']['output'];
	rejectionReason?: Maybe<Scalars['String']['output']>;
	respondedAt?: Maybe<Scalars['DateTime']['output']>;
	/** The current user's last-picked combination for this batch (null if none saved yet). Use it to preload the selection. */
	savedSelection?: Maybe<OfferBatchSavedSelection>;
	sentToClientAt?: Maybe<Scalars['DateTime']['output']>;
	status: OrderQuoteOfferStatus;
	summary?: Maybe<OrderQuoteOfferBatchSummary>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ClientOrderQuoteOfferBatchSummaryArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
	includedOfferIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	selectedDeliveryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	selectedPricingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	selectedSampleChoices?: InputMaybe<Array<OfferSampleChoiceInput>>;
};

/**
 * One way this product can be delivered at this quantity: a straight method, or a SPLIT — part of
 * the quantity by one method and the rest by another.
 *
 * A split is one option, picked by its id exactly like Standard or Express. Its price is what the
 * whole split costs and its day range spans the first part landing to the last; the per-part detail
 * is in parts. Options come back straight methods first, splits after them.
 */
export type ClientOrderQuoteOfferDelivery = {
	__typename?: 'ClientOrderQuoteOfferDelivery';
	deliveryDaysMax: Scalars['Int']['output'];
	/** On a split, the span: earliest any part lands, latest the last one does. */
	deliveryDaysMin: Scalars['Int']['output'];
	id: Scalars['ID']['output'];
	/** True when this option splits the quantity across methods. */
	isSplit: Scalars['Boolean']['output'];
	/** The parts of a split, in order. Empty on a straight method. */
	parts: Array<ClientOrderQuoteOfferDeliveryPart>;
	/** Projected arrival window (production + delivery in business days). Null when production time isn't set. */
	projectedDelivery?: Maybe<ProjectedDeliveryWindow>;
	quantity: Scalars['Int']['output'];
	/** On a split, the first part's method. Render the parts rather than this. */
	shippingMethod: OrderShippingMethod;
	/** What this option costs in total — on a split, all its parts together. */
	totalPrice?: Maybe<Scalars['Float']['output']>;
};

/**
 * One way this product can be delivered at this quantity: a straight method, or a SPLIT — part of
 * the quantity by one method and the rest by another.
 *
 * A split is one option, picked by its id exactly like Standard or Express. Its price is what the
 * whole split costs and its day range spans the first part landing to the last; the per-part detail
 * is in parts. Options come back straight methods first, splits after them.
 */
export type ClientOrderQuoteOfferDeliveryTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

/**
 * Part of a split: this much of the quantity, by this method, arriving on its own schedule.
 *
 * Never selectable on its own — the client picks the option, and the parts are what they get. The
 * parts of an option always add up to the full quantity.
 */
export type ClientOrderQuoteOfferDeliveryPart = {
	__typename?: 'ClientOrderQuoteOfferDeliveryPart';
	deliveryDaysMax: Scalars['Int']['output'];
	deliveryDaysMin: Scalars['Int']['output'];
	id: Scalars['ID']['output'];
	/** When THIS part arrives. Production time, then this part's own transit. */
	projectedDelivery?: Maybe<ProjectedDeliveryWindow>;
	quantity: Scalars['Int']['output'];
	sequence: Scalars['Int']['output'];
	shippingMethod: OrderShippingMethod;
	totalPrice?: Maybe<Scalars['Float']['output']>;
};

/**
 * Part of a split: this much of the quantity, by this method, arriving on its own schedule.
 *
 * Never selectable on its own — the client picks the option, and the parts are what they get. The
 * parts of an option always add up to the full quantity.
 */
export type ClientOrderQuoteOfferDeliveryPartTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderQuoteOfferPricing = {
	__typename?: 'ClientOrderQuoteOfferPricing';
	adjustedTotalPrice?: Maybe<Scalars['Float']['output']>;
	deliveries: Array<ClientOrderQuoteOfferDelivery>;
	id: Scalars['ID']['output'];
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	orderQuoteItemQuantityId: Scalars['ID']['output'];
	totalPrice?: Maybe<Scalars['Float']['output']>;
	unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type ClientOrderQuoteOfferPricingAdjustedTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderQuoteOfferPricingTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderQuoteOfferPricingUnitPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderQuoteOfferSample = {
	__typename?: 'ClientOrderQuoteOfferSample';
	deliveryDaysMax?: Maybe<Scalars['Int']['output']>;
	deliveryDaysMin?: Maybe<Scalars['Int']['output']>;
	id: Scalars['ID']['output'];
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	notes?: Maybe<Scalars['String']['output']>;
	/** How this sample is paid for. PREPAID means what you pay is credited against your production invoice. */
	paymentTreatment: SamplePaymentTreatment;
	/**
	 * One entry per sample choice, so each option can be priced without arithmetic on money in the
	 * client. Same totals the summary and the accept preview use for the corresponding choice.
	 *
	 * Exists because totalPrice alone is the WITH_SHIPPING figure: showing it as "the" price and then
	 * charging less for video/images reads as the price changing under the client.
	 */
	pricesByChoice: Array<ClientOrderQuoteOfferSamplePrice>;
	status: OrderSampleStatus;
	/** What the sample costs the client: sample + shipping + fee. The fee is internal and is never broken out here. */
	totalPrice?: Maybe<Scalars['Float']['output']>;
};

export type ClientOrderQuoteOfferSamplePricesByChoiceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type ClientOrderQuoteOfferSampleTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

/** What one sample option costs. Prices the tile; never breaks out the internal fee. */
export type ClientOrderQuoteOfferSamplePrice = {
	__typename?: 'ClientOrderQuoteOfferSamplePrice';
	sampleChoice: OrderSampleChoice;
	/** Total for this choice. NO_SAMPLE is 0; SAMPLE_NO_SHIPPING drops the freight, since nothing is shipped. */
	totalPrice: Scalars['Float']['output'];
};

export type ClientOrderQuotePage = {
	__typename?: 'ClientOrderQuotePage';
	data: Array<ClientOrderQuote>;
	pageInfo: PageInfo;
};

export type CommunityPublishability = {
	__typename?: 'CommunityPublishability';
	canPublish: Scalars['Boolean']['output'];
	/** Why the product cannot be published, e.g. Assigned to an organization, Not active. */
	reason?: Maybe<Scalars['String']['output']>;
};

/** PUBLISHED = on the community page. UNPUBLISHED = house products not on it. */
export enum CommunityStatus {
	Published = 'PUBLISHED',
	Unpublished = 'UNPUBLISHED',
}

export type CompleteRecommendationInput = {
	dimensions?: InputMaybe<ProductDimensionsInput>;
	recommendationId: Scalars['ID']['input'];
	weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CompleteRecommendationResponse = {
	__typename?: 'CompleteRecommendationResponse';
	message?: Maybe<Scalars['String']['output']>;
	productId?: Maybe<Scalars['ID']['output']>;
	studioFileId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
};

export type ConfirmBrandFileUploadInput = {
	aiDescription?: InputMaybe<Scalars['String']['input']>;
	backgroundType?: InputMaybe<Array<Scalars['String']['input']>>;
	blobUrl: Scalars['String']['input'];
	brandFileType: BrandFileType;
	brandId: Scalars['ID']['input'];
	designVariant?: InputMaybe<Scalars['String']['input']>;
	dimensions?: InputMaybe<FileDimensionsInput>;
	fileId: Scalars['ID']['input'];
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	resolution?: InputMaybe<Scalars['String']['input']>;
	tags?: InputMaybe<Array<Scalars['String']['input']>>;
	usageContext?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ConfirmBrandFontUploadInput = {
	aiDescription?: InputMaybe<Scalars['String']['input']>;
	blobUrl: Scalars['String']['input'];
	brandId: Scalars['ID']['input'];
	fileName: Scalars['String']['input'];
	fontFamily: Scalars['String']['input'];
	fontId: Scalars['ID']['input'];
	fontStyle?: InputMaybe<Scalars['String']['input']>;
	fontWeight?: InputMaybe<Scalars['String']['input']>;
	language?: InputMaybe<Array<Scalars['String']['input']>>;
	mood?: InputMaybe<Array<Scalars['String']['input']>>;
	readability?: InputMaybe<Scalars['String']['input']>;
	usage?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ConfirmOrderInput = {
	items: Array<ConfirmOrderItemInput>;
};

export type ConfirmOrderItemInput = {
	baseUnitPrice: Scalars['Float']['input'];
	currency: Scalars['String']['input'];
	orderItemId: Scalars['ID']['input'];
	vetterEntityId: Scalars['ID']['input'];
};

export type ConfirmOrderQuoteItemAttachmentUploadItem = {
	blobUrl: Scalars['String']['input'];
	/** Optional at upload — a file can be explained later with updateOrderQuoteItemAttachment. */
	description?: InputMaybe<Scalars['String']['input']>;
	fileId: Scalars['ID']['input'];
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
};

export type ConfirmOrderQuoteItemAttachmentUploadsInput = {
	files: Array<ConfirmOrderQuoteItemAttachmentUploadItem>;
	orderQuoteItemId: Scalars['ID']['input'];
};

export type ConfirmProductImageUploadInput = {
	altText?: InputMaybe<Scalars['String']['input']>;
	blobUrl: Scalars['String']['input'];
	caption?: InputMaybe<Scalars['String']['input']>;
	crop?: InputMaybe<ProductImageCropInput>;
	dimensions?: InputMaybe<ImageDimensionsInput>;
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	imageId: Scalars['ID']['input'];
	isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
	metadata?: InputMaybe<Array<ImageMetadataInput>>;
	productId: Scalars['ID']['input'];
	sortOrder?: InputMaybe<Scalars['Int']['input']>;
	studioFileVersionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ConfirmSampleAttachmentFileInput = {
	mimeType: Scalars['String']['input'];
	name: Scalars['String']['input'];
	size: Scalars['Int']['input'];
	url: Scalars['String']['input'];
};

export type ConfirmSampleAttachmentUploadsInput = {
	files: Array<ConfirmSampleAttachmentFileInput>;
	orderItemSampleId: Scalars['ID']['input'];
	type: OrderSampleAttachmentType;
};

export type ConfirmStudioReferenceImageUploadInput = {
	altText?: InputMaybe<Scalars['String']['input']>;
	blobUrl: Scalars['String']['input'];
	caption?: InputMaybe<Scalars['String']['input']>;
	dimensions?: InputMaybe<ImageDimensionsInput>;
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: FileTypeEnum;
	imageId: Scalars['ID']['input'];
};

export type CreateAdminUserInput = {
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
};

export type CreateBulkProductsInput = {
	products: Array<BulkProductInput>;
};

export type CreateBulkProjectProductsInput = {
	products: Array<ProjectProductInput>;
	sessionId: Scalars['ID']['input'];
};

export type CreateDesignSpecInput = {
	appliesTo?: InputMaybe<Scalars['String']['input']>;
	assetPurpose?: InputMaybe<Scalars['String']['input']>;
	assetType?: InputMaybe<Scalars['String']['input']>;
	assetUrl?: InputMaybe<Scalars['String']['input']>;
	colorHex?: InputMaybe<Scalars['String']['input']>;
	colorName?: InputMaybe<Scalars['String']['input']>;
	confidence?: InputMaybe<Scalars['Float']['input']>;
	derivationMethod?: InputMaybe<Scalars['String']['input']>;
	derivedFromSpecId?: InputMaybe<Scalars['ID']['input']>;
	fontFamily?: InputMaybe<Scalars['String']['input']>;
	fontSize?: InputMaybe<Scalars['Float']['input']>;
	metadata?: InputMaybe<Scalars['JSON']['input']>;
	placement?: InputMaybe<DesignSpecPlacementInput>;
	promptSnippet?: InputMaybe<Scalars['String']['input']>;
	specType: DesignSpecType;
	studioChatId?: InputMaybe<Scalars['ID']['input']>;
	studioFileVersionId: Scalars['ID']['input'];
	textContent?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFullOrderPaymentInput = {
	orderId: Scalars['ID']['input'];
	paymentMethod: OrderPaymentMethod;
	poNumber?: InputMaybe<Scalars['String']['input']>;
	returnUrl: Scalars['String']['input'];
};

export type CreateManyAuthorizationUserRoleInput = {
	authorizationRoleIds: Array<Scalars['ID']['input']>;
	userId: Scalars['ID']['input'];
};

export type CreateOrderPaymentInput = {
	orderId: Scalars['ID']['input'];
	orderItemIds: Array<Scalars['ID']['input']>;
	paymentMethod: OrderPaymentMethod;
	poNumber?: InputMaybe<Scalars['String']['input']>;
	returnUrl: Scalars['String']['input'];
};

export type CreateOrderPaymentResponse = {
	__typename?: 'CreateOrderPaymentResponse';
	clientSecret?: Maybe<Scalars['String']['output']>;
	economicBookedInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	grossAmount?: Maybe<Scalars['Float']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	netAmount?: Maybe<Scalars['Float']['output']>;
	paymentMethod?: Maybe<OrderPaymentMethod>;
	paymentTransactionId?: Maybe<Scalars['ID']['output']>;
	sessionId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
	vatAmount?: Maybe<Scalars['Float']['output']>;
	vatRate?: Maybe<Scalars['Float']['output']>;
};

export type CreateOrderQuoteGuestAcceptanceLinkInput = {
	/** Address that will receive the link and that the guest must type to authenticate. */
	email: Scalars['String']['input'];
	orderQuoteId: Scalars['ID']['input'];
};

export type CreateOrderQuoteInput = {
	adminUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	deadline?: InputMaybe<Scalars['DateTime']['input']>;
	deliveryAddress?: InputMaybe<OrderQuoteAddressInput>;
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	purpose?: InputMaybe<OrderQuotePurpose>;
	purposeOther?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<OrderQuoteStatus>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateOrderQuoteOfferBatchAdjustmentInput = {
	calculationType: OrderAdjustmentCalculationType;
	currency?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	type: OrderAdjustmentType;
	value: Scalars['Float']['input'];
};

/**
 * One delivery option on a tier: a plain method, or a split.
 *
 * Send parts to make it a split — the tier's quantity travelling by more than one method. On a
 * split the option's own shippingMethod, price and day counts are IGNORED and derived from the
 * parts instead; send them as anything valid, or send a split through
 * addOrderQuoteOfferDeliverySplit and leave it out of this input entirely.
 */
export type CreateOrderQuoteOfferBatchDeliveryInput = {
	currency: Scalars['String']['input'];
	deliveryDaysMax?: InputMaybe<Scalars['Int']['input']>;
	/** Optional — omit both to save a priced method whose lead time isn't settled yet. Such an option can't be sent to a client until they're set. */
	deliveryDaysMin?: InputMaybe<Scalars['Int']['input']>;
	/** Two or more legs make this option a split. Their quantities must add up to exactly the tier quantity. */
	parts?: InputMaybe<Array<OrderQuoteOfferDeliveryPartInput>>;
	/** What the client pays for this option, in the currency named below. Replaces basePrice + adminFee. */
	price: Scalars['Float']['input'];
	quantity: Scalars['Int']['input'];
	shippingMethod: OrderShippingMethod;
};

export type CreateOrderQuoteOfferBatchInput = {
	acceptDeadline?: InputMaybe<Scalars['DateTime']['input']>;
	offers: Array<CreateOrderQuoteOfferBatchOfferInput>;
	orderQuoteId: Scalars['ID']['input'];
};

export type CreateOrderQuoteOfferBatchOfferInput = {
	adjustments?: InputMaybe<Array<CreateOrderQuoteOfferBatchAdjustmentInput>>;
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	orderQuoteItemId: Scalars['ID']['input'];
	pricing?: InputMaybe<Array<CreateOrderQuoteOfferBatchPricingInput>>;
	sample?: InputMaybe<CreateOrderQuoteOfferBatchSampleInput>;
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
	vetterId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOrderQuoteOfferBatchPricingInput = {
	baseUnitPrice: Scalars['Float']['input'];
	currency: Scalars['String']['input'];
	deliveries?: InputMaybe<Array<CreateOrderQuoteOfferBatchDeliveryInput>>;
	marginAmount?: InputMaybe<Scalars['Float']['input']>;
	marginAmountCurrency?: InputMaybe<Scalars['String']['input']>;
	/** Markup on cost: price = cost x (1 + markup/100). Mutually exclusive with marginAmount and unitSalePrice. */
	markupPercentage?: InputMaybe<Scalars['Float']['input']>;
	maxProductionDays?: InputMaybe<Scalars['Int']['input']>;
	minProductionDays?: InputMaybe<Scalars['Int']['input']>;
	orderQuoteItemQuantityId: Scalars['ID']['input'];
	/** State what the client pays and let the markup fall out, the way e-conomic prices a line. Given in the same currency as baseUnitPrice. Mutually exclusive with markupPercentage and marginAmount. */
	unitSalePrice?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOrderQuoteOfferBatchSampleInput = {
	baseSamplePrice: Scalars['Float']['input'];
	baseShippingPrice?: InputMaybe<Scalars['Float']['input']>;
	currency: Scalars['String']['input'];
	deliveryDaysMax?: InputMaybe<Scalars['Int']['input']>;
	deliveryDaysMin?: InputMaybe<Scalars['Int']['input']>;
	maxProductionDays?: InputMaybe<Scalars['Int']['input']>;
	minProductionDays?: InputMaybe<Scalars['Int']['input']>;
	notes?: InputMaybe<Scalars['String']['input']>;
	/** How the client pays for this sample. Defaults to PREPAID when omitted. */
	paymentTreatment?: InputMaybe<SamplePaymentTreatment>;
};

export type CreateOrderQuoteVetterLinkInput = {
	/** The address that receives the link, and that the supplier must type to open it. */
	email: Scalars['String']['input'];
	orderQuoteId: Scalars['ID']['input'];
	/** The quote lines this supplier is asked to price. At least one, all on this quote. */
	orderQuoteItemIds: Array<Scalars['ID']['input']>;
	vetterEntityId: Scalars['ID']['input'];
};

export type CreateOrderShipmentInput = {
	carrier?: InputMaybe<Scalars['String']['input']>;
	estimatedDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
	/** What is in the box. At least one line, and no more of an item than is still unshipped. */
	lines: Array<CreateOrderShipmentLineInput>;
	orderId: Scalars['ID']['input'];
	shippedAt?: InputMaybe<Scalars['DateTime']['input']>;
	/** Omit when no method was quoted — the goods still move and still need tracking. */
	shippingMethod?: InputMaybe<OrderShippingMethod>;
	trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderShipmentLineInput = {
	orderItemId: Scalars['ID']['input'];
	quantity: Scalars['Int']['input'];
};

export type CreateOrganizationIndustryInput = {
	name: Scalars['String']['input'];
};

export type CreateProductFromStudioInput = {
	brandId?: InputMaybe<Scalars['ID']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	dimensions?: InputMaybe<ProductDimensionsInput>;
	name?: InputMaybe<Scalars['String']['input']>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	sku?: InputMaybe<Scalars['String']['input']>;
	studioFileId: Scalars['ID']['input'];
	versionIds: Array<Scalars['ID']['input']>;
	weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateProductFromStudioResponse = {
	__typename?: 'CreateProductFromStudioResponse';
	message?: Maybe<Scalars['String']['output']>;
	productId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
};

export type CreateProductVariantFromStudioInput = {
	brandId?: InputMaybe<Scalars['ID']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	sku?: InputMaybe<Scalars['String']['input']>;
	studioFileVersionId: Scalars['ID']['input'];
};

export type CreateProductVariantFromStudioResponse = {
	__typename?: 'CreateProductVariantFromStudioResponse';
	message?: Maybe<Scalars['String']['output']>;
	productId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
};

export type CreateProjectInput = {
	brandId?: InputMaybe<Scalars['ID']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	endDate?: InputMaybe<Scalars['DateTime']['input']>;
	name: Scalars['String']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	sessionId: Scalars['ID']['input'];
	startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateProjectProductInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	finalize?: InputMaybe<Scalars['Boolean']['input']>;
	imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	inspirationImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	name?: InputMaybe<Scalars['String']['input']>;
	productId?: InputMaybe<Scalars['ID']['input']>;
	projectId?: InputMaybe<Scalars['ID']['input']>;
	remixPrompt?: InputMaybe<Scalars['String']['input']>;
	sessionId?: InputMaybe<Scalars['ID']['input']>;
	type: ProjectProductType;
};

export type CreateProjectResponse = {
	__typename?: 'CreateProjectResponse';
	message: Scalars['String']['output'];
	project?: Maybe<Project>;
	success: Scalars['Boolean']['output'];
};

export type CreateSamplePaymentCheckoutInput = {
	currency: CurrencyEnum;
	orderId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
	returnUrl: Scalars['String']['input'];
	samples: Array<SamplePaymentItemInput>;
};

export type CreateSamplePaymentCheckoutResponse = {
	__typename?: 'CreateSamplePaymentCheckoutResponse';
	clientSecret?: Maybe<Scalars['String']['output']>;
	expiresAt?: Maybe<Scalars['DateTime']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	sessionId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
};

export type CreateSamplePaymentInput = {
	orderId: Scalars['ID']['input'];
	paymentMethod: OrderPaymentMethod;
	poNumber?: InputMaybe<Scalars['String']['input']>;
	returnUrl: Scalars['String']['input'];
	/**
	 * The samples to pay for. Omit to pay for every one that is currently payable — the original
	 * behaviour, and still the right call from the order-level PAY_SAMPLES button.
	 *
	 * A sample that is not payable (already paid, waived, on a cancelled round, or already on an
	 * invoice awaiting payment) is refused rather than dropped: a client who picked three samples
	 * and was charged for two has been told nothing about the third.
	 */
	sampleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateSamplePaymentResponse = {
	__typename?: 'CreateSamplePaymentResponse';
	clientSecret?: Maybe<Scalars['String']['output']>;
	economicBookedInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	expiresAt?: Maybe<Scalars['DateTime']['output']>;
	grossAmount?: Maybe<Scalars['Float']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	netAmount?: Maybe<Scalars['Float']['output']>;
	sessionId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
	vatAmount?: Maybe<Scalars['Float']['output']>;
	vatRate?: Maybe<Scalars['Float']['output']>;
};

export type CreateStudioFileVersionInput = {
	changeNotes?: InputMaybe<Scalars['String']['input']>;
	createdBy: Scalars['ID']['input'];
	imageUrls: Array<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	slug: Scalars['String']['input'];
	specs?: InputMaybe<StudioFileSpecsInput>;
	studioFileId: Scalars['ID']['input'];
	versionNumber: Scalars['Int']['input'];
};

export type CreateStudioFileVersionSpecificationInput = {
	capacity?: InputMaybe<SpecificationCapacityInput>;
	colors?: InputMaybe<Array<Scalars['String']['input']>>;
	dimensions?: InputMaybe<SpecificationDimensionsInput>;
	elementName: Scalars['String']['input'];
	elementType?: InputMaybe<Scalars['String']['input']>;
	features?: InputMaybe<Array<Scalars['String']['input']>>;
	finish?: InputMaybe<Scalars['String']['input']>;
	material?: InputMaybe<Scalars['String']['input']>;
	secondaryMaterials?: InputMaybe<Array<Scalars['String']['input']>>;
	studioFileVersionId: Scalars['ID']['input'];
	textureDescription?: InputMaybe<Scalars['String']['input']>;
	weight?: InputMaybe<SpecificationWeightInput>;
};

export type CreateStudioFileVersionTechPackInput = {
	additionalNotes?: InputMaybe<Scalars['String']['input']>;
	colorways?: InputMaybe<Array<TechPackColorwayInput>>;
	construction?: InputMaybe<TechPackConstructionInput>;
	dimensions?: InputMaybe<TechPackDimensionsInput>;
	labeling?: InputMaybe<TechPackLabelingInput>;
	materials?: InputMaybe<TechPackMaterialsInput>;
	packaging?: InputMaybe<TechPackPackagingInput>;
	qualityControl?: InputMaybe<TechPackQualityControlInput>;
	studioFileVersionId: Scalars['ID']['input'];
};

/**
 * Embedded Stripe checkout session for creating a new subscription.
 * The frontend mounts `clientSecret` via @stripe/react-stripe-js.
 */
export type CreateSubscriptionCheckoutResponse = {
	__typename?: 'CreateSubscriptionCheckoutResponse';
	clientSecret?: Maybe<Scalars['String']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	sessionId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
};

export type CreateVetterEntityInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	name: Scalars['String']['input'];
	notes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVetterUserInput = {
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	notes?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
	/**
	 * Set to false to record the vetter without emailing them an invitation. The
	 * account is created but cannot be used until inviteVetterUser is called.
	 * Defaults to true, which is the historical behaviour.
	 */
	sendInvitation?: InputMaybe<Scalars['Boolean']['input']>;
	vetterEntityId: Scalars['ID']['input'];
};

export enum CurrencyEnum {
	Dkk = 'DKK',
	Eur = 'EUR',
	Gbp = 'GBP',
	Nok = 'NOK',
	Sek = 'SEK',
	Usd = 'USD',
}

export type DateRange = {
	__typename?: 'DateRange';
	endDate: Scalars['DateTime']['output'];
	startDate: Scalars['DateTime']['output'];
};

export type DateRangeInput = {
	endDate?: InputMaybe<Scalars['String']['input']>;
	startDate: Scalars['String']['input'];
};

export type DeleteInput = {
	id: Scalars['ID']['input'];
};

export type DeleteManyAuthorizationUserRoleInput = {
	authorizationRoleIds: Array<Scalars['ID']['input']>;
	userId: Scalars['ID']['input'];
};

export type DeleteManyInput = {
	ids: Array<Scalars['ID']['input']>;
};

export type DeleteOrganizationIndustryInput = {
	/** Industry ID to assign to all orgs currently using the deleted industry. Null clears the FK on those orgs. */
	defaultReassignTo?: InputMaybe<Scalars['ID']['input']>;
	id: Scalars['ID']['input'];
	/** Per-org overrides. Each listed org gets the specific industryId (null to clear). Orgs not listed fall back to defaultReassignTo. */
	perOrganizationReassignments?: InputMaybe<Array<OrganizationIndustryReassignment>>;
};

export type DesignSpecPlacement = {
	__typename?: 'DesignSpecPlacement';
	height?: Maybe<Scalars['Float']['output']>;
	position?: Maybe<Scalars['String']['output']>;
	rotation?: Maybe<Scalars['Float']['output']>;
	scale?: Maybe<Scalars['Float']['output']>;
	width?: Maybe<Scalars['Float']['output']>;
	x?: Maybe<Scalars['Float']['output']>;
	y?: Maybe<Scalars['Float']['output']>;
};

export type DesignSpecPlacementInput = {
	height?: InputMaybe<Scalars['Float']['input']>;
	position?: InputMaybe<Scalars['String']['input']>;
	rotation?: InputMaybe<Scalars['Float']['input']>;
	scale?: InputMaybe<Scalars['Float']['input']>;
	width?: InputMaybe<Scalars['Float']['input']>;
	x?: InputMaybe<Scalars['Float']['input']>;
	y?: InputMaybe<Scalars['Float']['input']>;
};

export enum DesignSpecType {
	Asset = 'asset',
	Color = 'color',
	Placement = 'placement',
	Text = 'text',
}

export type DownloadUrlResponse = {
	__typename?: 'DownloadUrlResponse';
	downloadUrl: Scalars['String']['output'];
	errors?: Maybe<Array<ResponseError>>;
	expiresAt: Scalars['DateTime']['output'];
	message?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export type DuplicateOrderQuoteInput = {
	/**
	 * Copy the offer batches too. Default true. Copies always land in DRAFT with no acceptance or
	 * send history, so re-pricing and re-sending is an explicit act.
	 */
	includeOffers?: InputMaybe<Scalars['Boolean']['input']>;
	/** Name for the copy. Defaults to the original's name with (copy) appended. */
	name?: InputMaybe<Scalars['String']['input']>;
	/**
	 * Point the copy at a different client. The contact list, delivery address and payment settings
	 * belong to the client, so they are dropped and re-taken from the new organization rather than
	 * carried across. Omit to keep the original's client.
	 */
	organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type DuplicateProductInput = {
	/** Admin-only. Brand for the duplicate, belonging to its target organization; null for none. When omitted, the source's brand is kept for a copy within the same organization and dropped otherwise. */
	brandId?: InputMaybe<Scalars['ID']['input']>;
	/** Optional name for the duplicate. Defaults to the source name suffixed with (Copy). */
	name?: InputMaybe<Scalars['String']['input']>;
	/** Admin-only. Target organization for the duplicate. Defaults to the source product's organization. */
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	/** Id of the product to duplicate. */
	productId: Scalars['ID']['input'];
	/** Optional SKU for the duplicate. A unique SKU is auto-generated when omitted. */
	sku?: InputMaybe<Scalars['String']['input']>;
};

export type EarlyAccessInvite = {
	__typename?: 'EarlyAccessInvite';
	companyName?: Maybe<Scalars['String']['output']>;
	email: Scalars['String']['output'];
	firstName: Scalars['String']['output'];
	lastName: Scalars['String']['output'];
};

export enum EarlyAccessMakeEnum {
	Merchandise = 'MERCHANDISE',
	/** Something else */
	Other = 'OTHER',
	Packaging = 'PACKAGING',
	Textiles = 'TEXTILES',
}

export type EarlyAccessRequest = {
	__typename?: 'EarlyAccessRequest';
	approvedAt?: Maybe<Scalars['String']['output']>;
	companyName?: Maybe<Scalars['String']['output']>;
	country?: Maybe<Scalars['String']['output']>;
	createdAt: Scalars['String']['output'];
	email: Scalars['String']['output'];
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	lastName: Scalars['String']['output'];
	makes: Array<EarlyAccessMakeEnum>;
	note?: Maybe<Scalars['String']['output']>;
	status: EarlyAccessStatusEnum;
	teamSize?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['String']['output'];
	usedAt?: Maybe<Scalars['String']['output']>;
};

export enum EarlyAccessStatusEnum {
	Approved = 'Approved',
	Pending = 'Pending',
	Rejected = 'Rejected',
	Used = 'Used',
}

/** An e-conomic payment-terms master record (Settings → Your terms of payment). */
export type EconomicPaymentTerm = {
	__typename?: 'EconomicPaymentTerm';
	/** Net credit days, when the terms type carries one. */
	daysOfCredit?: Maybe<Scalars['Int']['output']>;
	/** True for the suggested default the selector should pre-select for a new org. */
	isDefault: Scalars['Boolean']['output'];
	name: Scalars['String']['output'];
	paymentTermsNumber: Scalars['Int']['output'];
	/** e-conomic terms type (e.g. 'net', 'invoiceMonth', 'paidInCash'). */
	paymentTermsType?: Maybe<Scalars['String']['output']>;
};

export type EmailExistsResponse = {
	__typename?: 'EmailExistsResponse';
	exists: Scalars['Boolean']['output'];
};

export type EmailTemplatePreview = {
	__typename?: 'EmailTemplatePreview';
	description: Scalars['String']['output'];
	/** Sender address, e.g. no-reply@05creation.com. */
	fromEmail: Scalars['String']['output'];
	/** Sender display name, e.g. 05 Creation. */
	fromName: Scalars['String']['output'];
	/**
	 * The full HTML email, rendered with representative sample data — the same
	 * data the backend preview tooling uses, so what you see here is what a
	 * recipient gets.
	 *
	 * Render it in a sandboxed iframe. It is a complete document with its own
	 * styles, not a fragment, and it must not be injected into the page.
	 */
	html: Scalars['String']['output'];
	key: Scalars['String']['output'];
	/**
	 * Inbox preview line, shown after the subject in most mail clients.
	 * Extracted from the rendered email.
	 */
	preheader?: Maybe<Scalars['String']['output']>;
	/** The subject line, exactly as it appears in the recipient's inbox. */
	subject: Scalars['String']['output'];
	/** The plain-text alternative sent alongside the HTML. */
	text: Scalars['String']['output'];
};

export type EmailTemplateSummary = {
	__typename?: 'EmailTemplateSummary';
	/** One line describing what this email is and who receives it. */
	description: Scalars['String']['output'];
	/** Stable identifier such as offer-sent. Pass this to getEmailTemplatePreview. */
	key: Scalars['String']['output'];
	/** The subject line, rendered with sample data. */
	subject: Scalars['String']['output'];
};

export type FileDimensions = {
	__typename?: 'FileDimensions';
	aspectRatio?: Maybe<Scalars['String']['output']>;
	height?: Maybe<Scalars['Int']['output']>;
	width?: Maybe<Scalars['Int']['output']>;
};

export type FileDimensionsInput = {
	aspectRatio?: InputMaybe<Scalars['String']['input']>;
	height?: InputMaybe<Scalars['Int']['input']>;
	width?: InputMaybe<Scalars['Int']['input']>;
};

export type FileInput = {
	fileType?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	url: Scalars['String']['input'];
};

export enum FileTypeEnum {
	Csv = 'CSV',
	Excel = 'EXCEL',
	Font = 'FONT',
	Image = 'IMAGE',
	Pdf = 'PDF',
	Video = 'VIDEO',
}

/** Generic response for generating pre-signed upload/download URLs (Azure Blob, S3, etc.) across the app. */
export type FileUploadResponse = {
	__typename?: 'FileUploadResponse';
	blobUrl?: Maybe<Scalars['String']['output']>;
	errors: Array<ResponseError>;
	expiresAt: Scalars['DateTime']['output'];
	fileId?: Maybe<Scalars['String']['output']>;
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
	uploadUrl: Scalars['String']['output'];
};

export type FinishMetadataAttachmentUploadInput = {
	attachment: MetadataAttachmentInput;
	metadataId: Scalars['ID']['input'];
};

export type FontFile = {
	__typename?: 'FontFile';
	aiDescription?: Maybe<Scalars['String']['output']>;
	family: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	language?: Maybe<Array<Scalars['String']['output']>>;
	mood?: Maybe<Array<Scalars['String']['output']>>;
	name: Scalars['String']['output'];
	readability?: Maybe<Scalars['String']['output']>;
	style?: Maybe<Scalars['String']['output']>;
	url?: Maybe<Scalars['String']['output']>;
	usage?: Maybe<Array<Scalars['String']['output']>>;
	weight?: Maybe<Scalars['String']['output']>;
};

export type FontFileUploadInput = {
	brandId: Scalars['ID']['input'];
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	fontFamily: Scalars['String']['input'];
	fontStyle?: InputMaybe<Scalars['String']['input']>;
	fontWeight?: InputMaybe<Scalars['String']['input']>;
};

export type FullOrderPaymentPreview = {
	__typename?: 'FullOrderPaymentPreview';
	currency: Scalars['String']['output'];
	/** Credit belonging to products not on this invoice. Always zero here — this route carries every unpaid product — but reported so both previews answer the same questions. */
	deductionsDeferred: Scalars['Float']['output'];
	/**
	 * Paid sample credit this invoice cannot absorb — the client is owed more than is being charged.
	 * Real money with nowhere to put it: recovering it needs a credit note, which does not exist
	 * yet. Surface it rather than rounding it away.
	 */
	deductionsUncredited: Scalars['Float']['output'];
	/** Order-level shipping: a shipment per line, billed here because this invoice carries every product. */
	deliveries: Array<ProductPaymentPreviewDelivery>;
	/** Net total (ex-VAT) of everything above. */
	grandTotal: Scalars['Float']['output'];
	/** grandTotal + vatAmount. Equals the order summary's grossAmount — this route charges the whole order. */
	grossAmount: Scalars['Float']['output'];
	/** Product lines, exactly as the production preview reports them — credits included. */
	items: Array<ProductPaymentPreviewLine>;
	/** The samples on this invoice. A prepaid one also appears as a credit against its product. */
	samples: Array<FullOrderPaymentPreviewSampleLine>;
	vatAmount: Scalars['Float']['output'];
	vatRate: Scalars['Float']['output'];
};

export type FullOrderPaymentPreviewSampleLine = {
	__typename?: 'FullOrderPaymentPreviewSampleLine';
	description: Scalars['String']['output'];
	orderItemId: Scalars['ID']['output'];
	/** The sample itself, excluding freight. */
	sampleAmount: Scalars['Float']['output'];
	sampleId: Scalars['ID']['output'];
	/** Freight on the sample. Charged and never credited, even on a prepaid sample. */
	shippingAmount: Scalars['Float']['output'];
};

export type GenerateBulkProductImageUploadUrlsInput = {
	files: Array<BulkImageFileInput>;
};

export type GenerateBulkProductImageUploadUrlsResponse = {
	__typename?: 'GenerateBulkProductImageUploadUrlsResponse';
	urls: Array<BulkImageUploadUrl>;
};

export type GenerateOfferEconomicQuotePdfInput = {
	batchId: Scalars['ID']['input'];
	orderQuoteId: Scalars['ID']['input'];
	/** The client's chosen combination across the batch — one selection per offer (same shape as accept). The e-conomic quote is always issued in DKK regardless of the client's display currency. */
	selections: Array<AcceptOrderQuoteOfferSelectionInput>;
};

export type GenerateOfferEconomicQuotePdfResponse = {
	__typename?: 'GenerateOfferEconomicQuotePdfResponse';
	/** The e-conomic draft quote number, for reference/support. */
	economicQuoteNumber?: Maybe<Scalars['Int']['output']>;
	message: Scalars['String']['output'];
	/** Short-lived (~10 min) SAS URL to the e-conomic quote PDF. Null on failure. */
	pdfUrl?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export type GenerateOrderQuoteItemAttachmentUploadUrlInput = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	orderQuoteItemId: Scalars['ID']['input'];
};

export type GenerateOrganizationLogoUploadUrlInput = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	organizationId: Scalars['ID']['input'];
};

export type GenerateProjectProductImageUploadUrlsInput = {
	files: Array<ImageFileInput>;
	imageType: ProjectProductImageType;
};

export type GenerateProjectProductImageUploadUrlsResponse = {
	__typename?: 'GenerateProjectProductImageUploadUrlsResponse';
	urls: Array<ImageUploadUrl>;
};

export type GenerateQuoteProductCommentUploadUrlInput = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	orderQuoteItemId: Scalars['ID']['input'];
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateSampleAttachmentUploadUrlInput = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	orderItemSampleId: Scalars['ID']['input'];
	type: OrderSampleAttachmentType;
};

export type GenerateStudioReferenceImageUploadUrlInput = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: FileTypeEnum;
};

export type GenerateStudioReferenceImageUploadUrlResponse = {
	__typename?: 'GenerateStudioReferenceImageUploadUrlResponse';
	blobUrl: Scalars['String']['output'];
	expiresAt: Scalars['DateTime']['output'];
	imageId: Scalars['ID']['output'];
	uploadUrl: Scalars['String']['output'];
};

export type GenerateUploadUrlInput = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	organizationUserId: Scalars['ID']['input'];
};

export type GetAllAdminAuthenticationUserInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllAdminUserInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	/** Optionally filter by lifecycle status (e.g. COMPLETED for active, PENDING for invited). */
	status?: InputMaybe<StatusEnum>;
};

export type GetAllAuthorizationRoleInput = {
	excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	scope?: InputMaybe<Scalars['String']['input']>;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllAuthorizationUserRoleInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	userId: Scalars['ID']['input'];
};

export type GetAllBrandInput = {
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllClientContactInput = {
	/** Filter guest-acceptance-link members in (true) or out (false). Omit for both. */
	isGuest?: InputMaybe<Scalars['Boolean']['input']>;
	order?: InputMaybe<OrderInput>;
	/** Optionally narrow the list to a single client organization. */
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	/** Free-text search across name, job position, the contact's email and the client's name. */
	search?: InputMaybe<Scalars['String']['input']>;
	/** Optionally filter by lifecycle status (COMPLETED for active, PENDING for invited). */
	status?: InputMaybe<StatusEnum>;
};

export type GetAllClientOrdersInput = {
	createdAt?: InputMaybe<DateRangeInput>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	statuses?: InputMaybe<Array<OrderStatus>>;
};

export type GetAllLoggingAuditLogInput = {
	dateRange?: InputMaybe<DateRangeInput>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	referenceId?: InputMaybe<Scalars['ID']['input']>;
	search?: InputMaybe<Scalars['String']['input']>;
	userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetAllLoggingLoginLogInput = {
	dateRange?: InputMaybe<DateRangeInput>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	referenceId?: InputMaybe<Scalars['ID']['input']>;
	search?: InputMaybe<Scalars['String']['input']>;
	userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetAllManufacturerInput = {
	filter?: InputMaybe<ManufacturerFilterInput>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllOrderQuoteInput = {
	adminUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	createdAt?: InputMaybe<DateRangeInput>;
	deadline?: InputMaybe<DateRangeInput>;
	order?: InputMaybe<OrderInput>;
	organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	statuses?: InputMaybe<Array<OrderQuoteStatus>>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetAllOrdersInput = {
	createdAt?: InputMaybe<DateRangeInput>;
	/** True: only orders with a shipment on the road past its estimated delivery date. */
	hasOverdueShipment?: InputMaybe<Scalars['Boolean']['input']>;
	order?: InputMaybe<OrderInput>;
	organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	/** Orders in any of these shipping states. Combines with statuses (both must match). */
	shippingStates?: InputMaybe<Array<OrderShippingState>>;
	statuses?: InputMaybe<Array<OrderStatus>>;
};

export type GetAllOrganizationInput = {
	countryCode?: InputMaybe<Scalars['String']['input']>;
	order?: InputMaybe<OrderInput>;
	/** Filter by an organizationIndustry row id. The legacy enum-based filter is gone. */
	organizationIndustryId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllOrganizationUserInput = {
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	/** Optionally filter by lifecycle status (e.g. COMPLETED for active, PENDING for invited). */
	status?: InputMaybe<StatusEnum>;
};

export type GetAllPantoneColorInput = {
	books?: InputMaybe<Array<PantoneBook>>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllProductInput = {
	/** Admin-only. When true, returns only admin products (not assigned to any organization). Ignored when organizationId is provided. */
	adminOnly?: InputMaybe<Scalars['Boolean']['input']>;
	/** Products assigned to this brand. Narrows within the caller's scope, never widens it. */
	brandId?: InputMaybe<Scalars['ID']['input']>;
	/** Admin-only. When true, returns only client products (assigned to any organization). Ignored when organizationId is provided. */
	clientsOnly?: InputMaybe<Scalars['Boolean']['input']>;
	/** Admin-only. PUBLISHED = house products on the community page, UNPUBLISHED = house products not on it. Combines with the other filters. */
	communityStatus?: InputMaybe<CommunityStatus>;
	/** Admin-only. When set together with organizationId, returns that organization's products AND the shared admin/house products (organizationId IS NULL). No effect without organizationId. */
	includeAdminProducts?: InputMaybe<Scalars['Boolean']['input']>;
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	/** Non-admins only (admins use communityStatus). OWN (default) = your organization's products. COMMUNITY = the community page, newest first unless order is given. */
	scope?: InputMaybe<ProductScope>;
	search?: InputMaybe<Scalars['String']['input']>;
	/** Products carrying any of these tags. */
	tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetAllProductTagInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	/** Only tags carried by at least one product on the community page. Always applied for non-admins. */
	usedInCommunity?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetAllProjectInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllStudioFileInput = {
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	showArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetAllVetterEntityInput = {
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllVetterUserInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetDownloadUrlInput = {
	organizationUserId: Scalars['ID']['input'];
};

export type GetMyAuthorizationUserRoleInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetMyVetterJobsInput = {
	pagination: PaginationInput;
	/** Matches the quote name or a product name. */
	search?: InputMaybe<Scalars['String']['input']>;
	/** Only jobs in these stages. */
	stages?: InputMaybe<Array<VetterJobStage>>;
};

export type GetOrganizationUserStatsInput = {
	/** Admins may target a specific organization; other users are scoped to their own. */
	organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetProductPricesInput = {
	/** Include rows flagged inactive or outside their validity window. Defaults to false. */
	includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
	productId: Scalars['ID']['input'];
	/** Narrow to one supplier. Omit to get every row for the product, house prices included. */
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetProductSamplePricesInput = {
	/** Include rows flagged inactive or outside their validity window. Defaults to false. */
	includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
	productId: Scalars['ID']['input'];
	/** Narrow to one supplier: its row and the house row. Pass null for the house row alone. Omit for every row. */
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
};

export type GraphQlContext = {
	__typename?: 'GraphQLContext';
	exp?: Maybe<Scalars['String']['output']>;
	iat?: Maybe<Scalars['String']['output']>;
	sub?: Maybe<Scalars['String']['output']>;
};

export type GuestQuoteLoginInput = {
	/** The one-time code emailed by requestGuestQuoteAccessCode. */
	code: Scalars['String']['input'];
	/** The email the guest typed — must match the address the admin nominated. */
	email: Scalars['String']['input'];
	/** The opaque token from the acceptance link (the ?token= query param). */
	token: Scalars['String']['input'];
};

export type GuestQuoteLoginResponse = {
	__typename?: 'GuestQuoteLoginResponse';
	message: Scalars['String']['output'];
	/** The quote this session should route to. Null on failure. */
	orderQuoteId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
	/** Access token to send as 'Authorization: Bearer'. Null on failure. A refresh cookie is also set, so the session refreshes like a normal login. */
	token?: Maybe<Scalars['String']['output']>;
};

export type GuestQuotePreviewLoginInput = {
	/** The opaque token from the preview link (the ?token= query param). */
	token: Scalars['String']['input'];
};

export type ImageDimensions = {
	__typename?: 'ImageDimensions';
	aspectRatio?: Maybe<Scalars['String']['output']>;
	height?: Maybe<Scalars['Int']['output']>;
	width?: Maybe<Scalars['Int']['output']>;
};

export type ImageDimensionsInput = {
	height: Scalars['Int']['input'];
	width: Scalars['Int']['input'];
};

export type ImageFileInput = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: FileTypeEnum;
};

export type ImageMetadata = {
	__typename?: 'ImageMetadata';
	attachments?: Maybe<Array<MetadataAttachment>>;
	canvasHeight: Scalars['Float']['output'];
	canvasWidth: Scalars['Float']['output'];
	comment?: Maybe<Scalars['String']['output']>;
	height?: Maybe<Scalars['Float']['output']>;
	points?: Maybe<Array<PolygonPoint>>;
	type: Scalars['String']['output'];
	width?: Maybe<Scalars['Float']['output']>;
	x?: Maybe<Scalars['Float']['output']>;
	y?: Maybe<Scalars['Float']['output']>;
};

export type ImageMetadataInput = {
	attachments?: InputMaybe<Array<MetadataAttachmentInput>>;
	canvasHeight: Scalars['Float']['input'];
	canvasWidth: Scalars['Float']['input'];
	comment?: InputMaybe<Scalars['String']['input']>;
	height?: InputMaybe<Scalars['Float']['input']>;
	points?: InputMaybe<Array<PolygonPointInput>>;
	type: Scalars['String']['input'];
	width?: InputMaybe<Scalars['Float']['input']>;
	x?: InputMaybe<Scalars['Float']['input']>;
	y?: InputMaybe<Scalars['Float']['input']>;
};

export type ImageUploadResponse = {
	__typename?: 'ImageUploadResponse';
	blobUrl?: Maybe<Scalars['String']['output']>;
	errors: Array<ResponseError>;
	expiresAt: Scalars['DateTime']['output'];
	imageId?: Maybe<Scalars['String']['output']>;
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
	uploadUrl: Scalars['String']['output'];
};

export type ImageUploadUrl = {
	__typename?: 'ImageUploadUrl';
	blobUrl: Scalars['String']['output'];
	expiresAt: Scalars['DateTime']['output'];
	fileName: Scalars['String']['output'];
	imageId: Scalars['ID']['output'];
	uploadUrl: Scalars['String']['output'];
};

export type InviteOrganizationUserInput = {
	/** The organizationUser row id — not the underlying authentication user id. */
	id: Scalars['ID']['input'];
};

/** Discriminates an invoice recipient between an internal system user and an external email address. */
export enum InvoiceRecipientType {
	Email = 'EMAIL',
	User = 'USER',
}

/**
 * Single entry in the organization's kickback ledger. The sum of all entries
 * for an org equals their current balance.
 */
export type KickbackTransaction = {
	__typename?: 'KickbackTransaction';
	amount: Scalars['Float']['output'];
	createdAt: Scalars['DateTime']['output'];
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	orderId?: Maybe<Scalars['ID']['output']>;
	organizationId: Scalars['ID']['output'];
	type: KickbackTransactionType;
};

export enum KickbackTransactionType {
	Accrual = 'accrual',
	Adjustment = 'adjustment',
	Redemption = 'redemption',
}

export type LocalizationAddressFormat = {
	__typename?: 'LocalizationAddressFormat';
	postalCodeLabel: Scalars['String']['output'];
	stateLabel?: Maybe<Scalars['String']['output']>;
	stateRequired: Scalars['Boolean']['output'];
};

export type LocalizationBusinessRegistrationType = {
	__typename?: 'LocalizationBusinessRegistrationType';
	code: Scalars['String']['output'];
	helpText?: Maybe<Scalars['String']['output']>;
	isRequired: Scalars['Boolean']['output'];
	label: Scalars['String']['output'];
	placeholder?: Maybe<Scalars['String']['output']>;
	vatDerivationPattern?: Maybe<Scalars['String']['output']>;
};

export type LocalizationCountry = {
	__typename?: 'LocalizationCountry';
	addressFormat: LocalizationAddressFormat;
	code: Scalars['String']['output'];
	currency?: Maybe<Scalars['String']['output']>;
	defaultMeasurementSystem?: Maybe<MeasurementSystemEnum>;
	defaultTimezone?: Maybe<Scalars['String']['output']>;
	hasStates: Scalars['Boolean']['output'];
	isEU: Scalars['Boolean']['output'];
	name: Scalars['String']['output'];
	nativeName?: Maybe<Scalars['String']['output']>;
	phonePrefix?: Maybe<Scalars['String']['output']>;
	registrations: Array<LocalizationBusinessRegistrationType>;
	states: Array<LocalizationState>;
};

export type LocalizationDefaults = {
	__typename?: 'LocalizationDefaults';
	countryCode: Scalars['String']['output'];
	currency: CurrencyEnum;
	measurementSystem: MeasurementSystemEnum;
	timezone: Scalars['String']['output'];
};

export type LocalizationOrganizationSetting = Base & {
	__typename?: 'LocalizationOrganizationSetting';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	offset: Scalars['String']['output'];
	organizationId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LocalizationState = {
	__typename?: 'LocalizationState';
	code: Scalars['String']['output'];
	name: Scalars['String']['output'];
};

export type LocalizationTimezone = {
	__typename?: 'LocalizationTimezone';
	name: Scalars['String']['output'];
	offset: Scalars['String']['output'];
};

export type LoggingAuditLog = Base & {
	__typename?: 'LoggingAuditLog';
	action?: Maybe<Scalars['String']['output']>;
	changes?: Maybe<Scalars['JSON']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	metadata?: Maybe<Scalars['JSON']['output']>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	resource?: Maybe<Scalars['String']['output']>;
	resourceId?: Maybe<Scalars['ID']['output']>;
	serviceName?: Maybe<Scalars['String']['output']>;
	status?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId?: Maybe<Scalars['ID']['output']>;
};

export type LoggingAuditLogPage = {
	__typename?: 'LoggingAuditLogPage';
	data: Array<LoggingAuditLog>;
	pageInfo: PageInfo;
};

export type LoggingLoginLog = Base & {
	__typename?: 'LoggingLoginLog';
	browser: Scalars['String']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	failureReason?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	ipAddress: Scalars['String']['output'];
	method: Scalars['String']['output'];
	os: Scalars['String']['output'];
	referenceId: Scalars['ID']['output'];
	serviceId: Scalars['String']['output'];
	status: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	user?: Maybe<AuthenticationUser>;
	userAgent: Scalars['String']['output'];
	userId: Scalars['ID']['output'];
};

export type LoggingLoginLogPage = {
	__typename?: 'LoggingLoginLogPage';
	data: Array<LoggingLoginLog>;
	pageInfo: PageInfo;
};

export type LoginInput = {
	authKey: Scalars['String']['input'];
	authSecret: Scalars['String']['input'];
};

export enum LoginLockReason {
	AccountPermanentlyLocked = 'AccountPermanentlyLocked',
	AccountTemporarilyLocked = 'AccountTemporarilyLocked',
	TooManyAttemptsFromThisIp = 'TooManyAttemptsFromThisIP',
}

export type LoginResponse = {
	__typename?: 'LoginResponse';
	backupCodes?: Maybe<Array<Scalars['String']['output']>>;
	mfaMethod?: Maybe<MfaMethodEnum>;
	mfaRequired: Scalars['Boolean']['output'];
	role: AuthRoleEnum;
	supportsBackupCodes: Scalars['Boolean']['output'];
	token: Scalars['String']['output'];
	userId: Scalars['ID']['output'];
};

export type LoginValidateInput = {
	role?: InputMaybe<Array<AuthRoleEnum>>;
	token: Scalars['String']['input'];
};

export type LoginValidateResponse = {
	__typename?: 'LoginValidateResponse';
	token: Scalars['String']['output'];
	user: AuthenticationUser;
};

export type LoginWithBackupCodeInput = {
	backupCode: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type LogoutInput = {
	token: Scalars['String']['input'];
};

export type Manufacturer = Base & {
	__typename?: 'Manufacturer';
	country?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	isActive: Scalars['Boolean']['output'];
	logoUrl?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	vetterEntity?: Maybe<VetterEntity>;
	vetterEntityId?: Maybe<Scalars['ID']['output']>;
	website?: Maybe<Scalars['String']['output']>;
};

export type ManufacturerCreateInput = {
	country?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	logoUrl?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
	website?: InputMaybe<Scalars['String']['input']>;
};

export type ManufacturerFilterInput = {
	country?: InputMaybe<Scalars['String']['input']>;
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	unassignedToVetterEntity?: InputMaybe<Scalars['Boolean']['input']>;
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
};

export type ManufacturerPage = {
	__typename?: 'ManufacturerPage';
	data: Array<Manufacturer>;
	pageInfo: PageInfo;
};

/** Aggregate statistics across all manufacturers, for the admin overview. */
export type ManufacturerStats = {
	__typename?: 'ManufacturerStats';
	/** Manufacturers that are active (isActive = true). */
	active: Scalars['Int']['output'];
	/** Manufacturers that are inactive (isActive = false). */
	inactive: Scalars['Int']['output'];
	/** All manufacturers. */
	total: Scalars['Int']['output'];
	/** Manufacturers that have a vetter assigned (vetterEntityId set). */
	withVetter: Scalars['Int']['output'];
};

export type ManufacturerUpdateInput = {
	country?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	logoUrl?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
	website?: InputMaybe<Scalars['String']['input']>;
};

export type MatchPantoneColorInput = {
	books?: InputMaybe<Array<PantoneBook>>;
	hex: Scalars['String']['input'];
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum MeasurementSystemEnum {
	Imperial = 'IMPERIAL',
	Metric = 'METRIC',
}

export type MessageResponse = {
	__typename?: 'MessageResponse';
	errors?: Maybe<Array<ResponseError>>;
	message: Scalars['String']['output'];
	messageKey?: Maybe<Scalars['String']['output']>;
	referenceKey?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export enum MessageType {
	File = 'file',
	System = 'system',
	Text = 'text',
}

export type MetadataAttachment = {
	__typename?: 'MetadataAttachment';
	contentType: Scalars['String']['output'];
	fileName: Scalars['String']['output'];
	size: Scalars['Int']['output'];
	url: Scalars['String']['output'];
};

export type MetadataAttachmentInput = {
	contentType: Scalars['String']['input'];
	fileName: Scalars['String']['input'];
	size: Scalars['Int']['input'];
	url: Scalars['String']['input'];
};

export type MetadataAttachmentUploadInput = {
	contentType: Scalars['String']['input'];
	fileName: Scalars['String']['input'];
	studioFileVersionMetadataId: Scalars['ID']['input'];
};

export type MetadataAttachmentUploadResponse = {
	__typename?: 'MetadataAttachmentUploadResponse';
	blobUrl: Scalars['String']['output'];
	expiresAt: Scalars['DateTime']['output'];
	uploadUrl: Scalars['String']['output'];
};

export enum MetadataType {
	Polygon = 'polygon',
	Square = 'square',
}

export enum MfaMethodEnum {
	Authenticator = 'Authenticator',
	Email = 'Email',
}

export type MultipleDeleteResponse = {
	__typename?: 'MultipleDeleteResponse';
	deleted?: Maybe<Scalars['Int']['output']>;
	failed?: Maybe<Scalars['Int']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	success?: Maybe<Scalars['Boolean']['output']>;
};

export type Mutation = {
	__typename?: 'Mutation';
	acceptOrderQuoteOffers: AcceptOrderQuoteOffersResponse;
	acquireStudioLock: AcquireStudioLockResponse;
	addOffersToOrderQuoteOfferBatch: MessageResponse;
	addOrderQuoteItems: MessageResponse;
	addOrderQuoteOffer: MessageResponse;
	addOrderQuoteOfferAdjustment: MessageResponse;
	addOrderQuoteOfferDelivery: MessageResponse;
	/**
	 * Create a SPLIT delivery option on one product's quantity tier — part of the tier's quantity by
	 * one method, the rest by another. Its own mutation rather than a flag on
	 * addOrderQuoteOfferDelivery because a split enters no price, method or lead time of its own:
	 * every one of those lives on a part, and the option derives its totals from them.
	 *
	 * referenceKey on the response is the new option's id — the same id the client selects it by.
	 */
	addOrderQuoteOfferDeliverySplit: MessageResponse;
	addOrderQuoteOfferSample: MessageResponse;
	/** Client describes non-catalog needs on a quote so it can be requested. Admins turn these into real offer line items. */
	addOrderQuoteRequestItems: MessageResponse;
	/** Post a message. Tags are read from the body; a message needs a body or at least one attachment. */
	addQuoteProductComment: AddQuoteProductCommentResponse;
	addStudioFileVersionMetadata: MessageResponse;
	/** Put the catalogue's current sample price on this sample. The sample drift badge's button. Admin only. */
	applyCatalogPriceToOfferSample: MessageResponse;
	/** Put the catalogue's current cost on one tier. The catalogue-drift badge's buttons. Admin only. */
	applyCatalogPriceToOfferTier: MessageResponse;
	/**
	 * Admin: take suppliers' quoted prices into an offer the studio already made — per product, from
	 * whichever supplier the studio picks. For each product it sets the offer's supplier to that
	 * supplier, and for each chosen quantity sets the cost and production days from their answer,
	 * keeping the tier's margin rule (markup % or fixed amount), so the client price follows the new
	 * cost. A quote quantity the offer hasn't priced yet gets a new price, with no margin. Delivery
	 * prices go on as the supplier quoted them, for the studio to edit; a quantity with no delivery
	 * options gets the supplier's Standard/Express. It never removes quantities. All products in one
	 * go, or none. Only on a batch that has not been sent to the client.
	 */
	applyVetterPrices: MessageResponse;
	/**
	 * Approve an early-access request. The admin selects the e-conomic payment
	 * terms the new client will sit under (from the economicPaymentTerms query);
	 * the choice is stored on the request and applied when the invitee signs up.
	 */
	approveEarlyAccessRequest: ApproveEarlyAccessResponse;
	approveNewSampleRound: MessageResponse;
	approveProduct: MessageResponse;
	assignPermissionsToRole: MessageResponse;
	assignProductToOrganization: MessageResponse;
	/** Moves products to a client (or back to admin). brandId sets their brand and must belong to that client; without it, products that change client lose their old client's brand. */
	assignProductsToOrganization: MessageResponse;
	assignStudioFileToClient: MessageResponse;
	cancelOrder: MessageResponse;
	/** Undo a scheduled downgrade before it takes effect. */
	cancelScheduledPlanChange: SubscriptionMutationResponse;
	/** Cancel at the end of the current billing period. */
	cancelSubscription: SubscriptionMutationResponse;
	categorizeBulkProductImages: CategorizeBulkProductImagesResponse;
	/**
	 * Upgrade or downgrade the current subscription.
	 * - Upgrades take effect immediately and invoice the prorated diff now.
	 *   If SCA/3DS is required, response.requiresAction is true with a
	 *   clientSecret the frontend confirms with Stripe.js.
	 * - Downgrades are scheduled for the end of the current billing period
	 *   via a Stripe subscription schedule; pendingTier and
	 *   pendingTierEffectiveAt on the subscription reflect the scheduled change.
	 */
	changeSubscriptionPlan: SubscriptionMutationResponse;
	closeOrderQuote: MessageResponse;
	completeRecommendation: CompleteRecommendationResponse;
	/** Link session or supplier account: mark one of the supplier's order items as finished in production. Read the item's availableActions for when it is offered. */
	completeVetterJobProduction: MessageResponse;
	confirmBrandFileUpload: MessageResponse;
	confirmBrandFontUpload: MessageResponse;
	confirmOrder: MessageResponse;
	confirmOrderQuoteItemAttachmentUploads: MessageResponse;
	/** Admin: confirm a client's post-deadline acceptance, materializing the order from the captured selections at current offer terms. */
	confirmPendingOfferAcceptance: AcceptOrderQuoteOffersResponse;
	confirmProductImageUpload: MessageResponse;
	/**
	 * Confirm a backfilled price as right, promoting it to AUTHORED.
	 *
	 * For the case the backfill creates by design: a price inferred from what was once quoted,
	 * which nobody has looked at. Confirming changes no number — it records that someone did.
	 */
	confirmProductPrice: MessageResponse;
	/** Confirm a backfilled sample price as right, promoting it to AUTHORED. Changes no number. */
	confirmProductSamplePrice: MessageResponse;
	confirmSampleAttachmentUploads: MessageResponse;
	confirmStudioReferenceImageUpload: MessageResponse;
	/** Create a new admin user (Admin only) */
	createAdminUser: MessageResponse;
	createAuthorizationRole: MessageResponse;
	createBrand: MessageResponse;
	createBulkProducts: MessageResponse;
	createBulkProjectProducts: MessageResponse;
	createDesignSpec: MessageResponse;
	/**
	 * Pay the whole order in one payment — samples and production together, instead of samples now
	 * and each product as its sample is approved.
	 *
	 * Everything unpaid goes on one invoice, whatever its sample is doing: the point of this route
	 * is to pay before approval. A prepaid sample is charged and credited on the same document, so
	 * the total is summary { grossAmount } and paying here never forfeits a credit.
	 */
	createFullOrderPayment: CreateOrderPaymentResponse;
	createManufacturer: MessageResponse;
	createManyAuthorizationUserRole: MessageResponse;
	createOrderPayment: CreateOrderPaymentResponse;
	createOrderQuote: MessageResponse;
	/** Admin: mint a guest acceptance link for a quote and email it to the nominated address. Can be issued at any point in the quote's life — the guest sees offer batches only once they are sent, so a link created early simply shows nothing until then. */
	createOrderQuoteGuestAcceptanceLink: OrderQuoteGuestAcceptanceLinkResponse;
	/** Admin: mint a single-use, short-lived link that opens this quote in the real guest view, as the admin themselves. No email and no verification code — the admin is already authenticated, and the preview identity is derived from their own staff address. The resulting session is read-only: it can look at everything a guest sees but cannot accept, pay, or generate documents. Requires a staff-domain admin account. */
	createOrderQuoteGuestPreviewLink: OrderQuoteGuestPreviewLinkResponse;
	createOrderQuoteOfferBatch: MessageResponse;
	/**
	 * Admin: send a price request by link to one address.
	 * @deprecated Use sendVetterPriceRequest, which also reaches suppliers with an account without a link.
	 */
	createOrderQuoteVetterLink: OrderQuoteVetterLinkResponse;
	/**
	 * Record a shipment that is going out: what is in the box, how it travels, and its tracking.
	 * Admin or vetter.
	 *
	 * Every product already has a shipment from acceptance — one each, or one per part where the
	 * client picked a split — so this is for goods that need ANOTHER box: a product travelling in
	 * more than one delivery, or a replacement for something that never arrived.
	 *
	 * It refuses to assign more of a product than is left unassigned, so it cannot quietly
	 * double-ship. A product whose whole quantity is already on a shipment has nothing to add here.
	 */
	createOrderShipment: MessageResponse;
	createOrganization: MessageResponse;
	createOrganizationAddress: OrganizationAddress;
	createOrganizationCompliance: OrganizationCompliance;
	createOrganizationComplianceConnection: OrganizationComplianceConnection;
	/**
	 * Create a new industry. Admins create published rows; org users
	 * create pending rows (visible only to their org until an admin
	 * publishes them).
	 */
	createOrganizationIndustry: OrganizationIndustry;
	createOrganizationOnboarding: OrganizationOnboardingResponse;
	createOrganizationProductInterest: OrganizationProductInterest;
	createOrganizationSignup: RegisterResponse;
	createOrganizationSourcingPreference: OrganizationSourcingPreference;
	createOrganizationSourcingPreferenceConnection: OrganizationSourcingPreferenceConnection;
	createOrganizationUser: MessageResponse;
	createProduct: MessageResponse;
	createProductFromStudioFile: CreateProductFromStudioResponse;
	createProductTag: MessageResponse;
	createProductVariantFromStudioFile: CreateProductVariantFromStudioResponse;
	createProject: CreateProjectResponse;
	createProjectProduct: MessageResponse;
	createSamplePayment: CreateSamplePaymentResponse;
	createSamplePaymentCheckout: CreateSamplePaymentCheckoutResponse;
	createStudioFile: MessageResponse;
	createStudioFileVersion: MessageResponse;
	createStudioFileVersionSpecification: MessageResponse;
	createStudioFileVersionTechPack: MessageResponse;
	/**
	 * Starts a Stripe embedded-checkout session for the chosen tier. If the org
	 * already has a subscription, use changeSubscriptionPlan instead.
	 */
	createSubscriptionCheckoutSession: CreateSubscriptionCheckoutResponse;
	createVetterEntity: MessageResponse;
	createVetterUser: MessageResponse;
	declineProduct: MessageResponse;
	/** Delete an admin user (Admin only) */
	deleteAdminUser: MessageResponse;
	deleteAuthorizationRole: MessageResponse;
	deleteBrand: MessageResponse;
	deleteBrandFile: MessageResponse;
	deleteBrandFont: MessageResponse;
	deleteDesignSpec: MessageResponse;
	deleteManufacturer: MessageResponse;
	/** Delete multiple admin users (Admin only) */
	deleteManyAdminUser: MessageResponse;
	deleteManyAuthorizationRole: MessageResponse;
	deleteManyAuthorizationUserRole: MessageResponse;
	deleteManyBrand: MessageResponse;
	deleteManyManufacturer: MessageResponse;
	deleteManyOrderQuote: MessageResponse;
	deleteManyOrganization?: Maybe<MessageResponse>;
	deleteManyOrganizationUser: MessageResponse;
	deleteManyProduct: MessageResponse;
	deleteManyProject: MessageResponse;
	deleteManyProjectProduct: MessageResponse;
	deleteManyVetterEntity: MessageResponse;
	deleteManyVetterUser: MessageResponse;
	deleteMyOrganization: MessageResponse;
	deleteOrderQuote: MessageResponse;
	deleteOrderQuoteItemAttachment: MessageResponse;
	deleteOrderQuoteOfferBatch: MessageResponse;
	deleteOrganization?: Maybe<MessageResponse>;
	deleteOrganizationAddress: MessageResponse;
	deleteOrganizationCompliance: MessageResponse;
	deleteOrganizationComplianceConnection: MessageResponse;
	deleteOrganizationComplianceConnections: MessageResponse;
	deleteOrganizationCompliances: MessageResponse;
	/**
	 * Admin: delete an industry. Any orgs still pointing at this row
	 * will be re-pointed first: per-org overrides take precedence,
	 * then defaultReassignTo applies to the rest (null clears the FK).
	 */
	deleteOrganizationIndustry: MessageResponse;
	deleteOrganizationProductInterest: MessageResponse;
	deleteOrganizationProductInterests: MessageResponse;
	deleteOrganizationSourcingPreference: MessageResponse;
	deleteOrganizationSourcingPreferenceConnection: MessageResponse;
	deleteOrganizationSourcingPreferenceConnections: MessageResponse;
	deleteOrganizationSourcingPreferences: MessageResponse;
	deleteOrganizationUser: MessageResponse;
	deleteProduct: MessageResponse;
	deleteProductImage: MessageResponse;
	deleteProductPrice: MessageResponse;
	deleteProductSamplePrice: MessageResponse;
	deleteProductTag: MessageResponse;
	deleteProductTags: MessageResponse;
	deleteProject: MessageResponse;
	deleteProjectProduct: MessageResponse;
	/** Delete your own message; the studio can delete any. It stays in the thread as deleted. */
	deleteQuoteProductComment: MessageResponse;
	deleteSampleAttachment: MessageResponse;
	deleteStudioFile: MessageResponse;
	deleteStudioFileVersion: MessageResponse;
	deleteStudioFileVersionMetadata: MessageResponse;
	deleteStudioFileVersionSpecification: MessageResponse;
	deleteStudioFileVersionTechPack: MessageResponse;
	deleteVetterEntity: MessageResponse;
	deleteVetterUser: MessageResponse;
	dismissProductRecommendation: MessageResponse;
	/**
	 * Copy a quote as a fresh DRAFT — its products with their quantity tiers, files and
	 * specification snapshot, its request lines, and (unless turned off) every offer batch.
	 * Nothing about the original's history comes along: no activity feed, no guest links, no view
	 * counts, no acceptance. Admin only. referenceKey on the response is the new quote's id.
	 */
	duplicateOrderQuote: MessageResponse;
	duplicateOrderQuoteOfferBatch: MessageResponse;
	/** Duplicate an existing product, copying its details, images (as fresh blob copies) and tag associations into a new product. */
	duplicateProduct: MessageResponse;
	/** Change the text of your own message. Attachments stay. Newly tagged people are notified. */
	editQuoteProductComment: MessageResponse;
	finishMetadataAttachmentUpload: MessageResponse;
	generateBrandFileUploadUrl: FileUploadResponse;
	generateBrandFontUploadUrl: FileUploadResponse;
	generateBulkProductImageUploadUrls: GenerateBulkProductImageUploadUrlsResponse;
	generateChatAttachmentUploadUrl: ChatAttachmentUploadResponse;
	generateMetadataAttachmentUploadUrl: MetadataAttachmentUploadResponse;
	/** Generate a downloadable e-conomic quote PDF for the exact combination the client selected in an offer batch. Creates a draft quote in e-conomic (never emailed) and returns a short-lived PDF URL. Re-requesting the same combination re-serves the cached draft. */
	generateOfferEconomicQuotePdf: GenerateOfferEconomicQuotePdfResponse;
	/** Get an upload URL for a file on a quote PRODUCT. The file is shown on every offer made for that product, in every batch — there is no per-offer upload. */
	generateOrderQuoteItemAttachmentUploadUrl: OrderQuoteItemAttachmentUploadResponse;
	/** Generate a pre-signed upload URL for an organization logo image. Call once for the original, once for the cropped version. */
	generateOrganizationLogoUploadUrl: UploadUrlResponse;
	generateOrganizationUserAvatarUploadUrl: UploadUrlResponse;
	generateProductImageUploadUrl: ImageUploadResponse;
	generateProjectProductImageUploadUrls: GenerateProjectProductImageUploadUrlsResponse;
	/** Step 1 of attaching a file: a short-lived upload URL. PUT the file there, then pass blobUrl to addQuoteProductComment. */
	generateQuoteProductCommentUploadUrl: QuoteProductCommentUploadUrlResponse;
	generateSampleAttachmentUploadUrl: FileUploadResponse;
	generateStudioReferenceImageUploadUrl: GenerateStudioReferenceImageUploadUrlResponse;
	/** Public (no login): step 2 of the guest acceptance flow — verify the one-time code emailed by requestGuestQuoteAccessCode and start a session. On success sets the organization refresh cookie (like a normal login) and returns an access token. The guest becomes a real password-less org client, convertible to a full account later. */
	guestQuoteLogin: GuestQuoteLoginResponse;
	/** Redeem an admin guest-PREVIEW token (from createOrderQuoteGuestPreviewLink) and start a read-only guest session on the quote it was minted for. No email and no code: the token was minted for an authenticated admin, is single-use, expires in minutes, and only ever resolves to a staff-domain identity. The session it returns can read everything a guest sees but every mutation is refused. */
	guestQuotePreviewLogin: GuestQuoteLoginResponse;
	/**
	 * Send (or re-send) the invitation email to a contact person, e.g. one created with
	 * sendInvitation: false. Only valid while the contact is still PENDING — an active
	 * account has nothing left to accept.
	 */
	inviteOrganizationUser: MessageResponse;
	/**
	 * Send (or re-send) the invitation email to a vetter, e.g. one created with
	 * sendInvitation: false. Rejected once the vetter has activated their account —
	 * there is nothing left for them to accept.
	 */
	inviteVetterUser: MessageResponse;
	login: LoginResponse;
	loginValidate: LoginValidateResponse;
	loginWithBackupCode: MessageResponse;
	logout: MessageResponse;
	/** Mark every unread notification read. */
	markAllNotificationsRead: MessageResponse;
	/** Mark one notification read. No-op if it is already read or not yours. */
	markNotificationRead: MessageResponse;
	/** Admin records that a booked production invoice was settled out-of-band (e.g. bank transfer). Flips the payment + items to paid. */
	markOrderProductInvoicePaid: MessageResponse;
	/**
	 * Admin records that a booked SAMPLE invoice was settled out-of-band. Flips the invoice and every
	 * sample on it to paid.
	 *
	 * Takes the transaction, not a sample: one sample invoice is a batch — a single e-conomic
	 * invoice and a single transaction covering several samples — so settling by sample would leave
	 * the rest of the same invoice booked. Every sample on the transaction settles together.
	 *
	 * The hourly poller normally does this by reconciling against e-conomic. This is the override
	 * for when it cannot: e-conomic unreachable, or money that landed somewhere it never sees.
	 */
	markOrderSampleInvoicePaid: MessageResponse;
	/** Mark a thread read for the caller, for unread counts. */
	markQuoteProductThreadRead: MessageResponse;
	passwordReset: MessageResponse;
	passwordResetRequest: Scalars['String']['output'];
	passwordResetValidate: MessageResponse;
	passwordUpdate: MessageResponse;
	/** Admin: flip a pending industry to published. */
	publishOrganizationIndustry: OrganizationIndustry;
	/** Admin-only. Put house products on the community page. All-or-nothing: if any id cannot be published, nothing is, and errors say which and why. Already-published products keep their original publish time. */
	publishProductsToCommunity: MessageResponse;
	recallOrderQuoteOfferBatch: MessageResponse;
	/**
	 * Admin records a bank transfer the client made without going through the platform.
	 *
	 * Books the invoice the client would have received for the chosen scope — same lines and credits as
	 * the client's own invoice route — and immediately marks it paid with the reference and date, so the
	 * books and the order both reflect the money. The invoice is not emailed unless sendInvoice is set.
	 */
	recordOrderBankTransfer: RecordOrderBankTransferResponse;
	/**
	 * Record that the caller opened a quote. Call it once when the quote page mounts —
	 * it is the only thing that produces a view, since read queries also fire on list
	 * prefetch and polling. Repeat calls inside a 30-minute window refresh the timestamp
	 * without inflating the count, so it is safe to call on every mount.
	 */
	recordOrderQuoteView: MessageResponse;
	/** Re-copy the product's name and specifications onto this quote line. The line holds a frozen copy taken when the product was added, so this is how an admin pulls in catalogue changes made since — nothing else refreshes it. */
	refreshOrderQuoteItemProductSnapshot: MessageResponse;
	refreshToken: LoginValidateResponse;
	regenerateBackupCodes: BackupCodesResponse;
	register: RegisterResponse;
	rejectEarlyAccessRequest: MessageResponse;
	rejectOrderQuoteOffer: MessageResponse;
	rejectOrderQuoteOfferBatch: MessageResponse;
	/** Admin: reject a client's post-deadline acceptance; the quote is marked EXPIRED and the captured selections are cleared. */
	rejectPendingOfferAcceptance: AcceptOrderQuoteOffersResponse;
	releaseStudioLock: MessageResponse;
	remixProductToStudio: RemixProductToStudioResponse;
	removeMetadataAttachment: MessageResponse;
	removeOrderQuoteItem: MessageResponse;
	removeOrderQuoteOffer: MessageResponse;
	removeOrderQuoteOfferAdjustment: MessageResponse;
	removeOrderQuoteOfferDelivery: MessageResponse;
	removeOrderQuoteOfferSample: MessageResponse;
	removeOrderQuoteRequestItem: MessageResponse;
	removePermissionsFromRole: MessageResponse;
	requestEarlyAccess: MessageResponse;
	/** Public (no login): step 1 — email a one-time verification code to the nominated address for a guest link. Neutral response regardless of validity (no probing). Rate-limited by a short resend cooldown. Step 2 (verify the code + start the session) is the guestQuoteLogin mutation in the authentication service. */
	requestGuestQuoteAccessCode: MessageResponse;
	/** Client requests an offer on their own DRAFT quote, moving it to REQUESTED so admins can pick it up. */
	requestOrderQuoteOffer: MessageResponse;
	/**
	 * Vetter-link session: email this person the usual vetter invitation, with a set-password link,
	 * so they can have an account and see all their supplier's jobs. Offered when
	 * VetterJob.canClaimAccount is true.
	 */
	requestVetterAccountInvite: MessageResponse;
	/**
	 * Public (no login): step 1 of opening a vetter link — email a one-time code to the address
	 * the link was issued to. Neutral response whatever the outcome, so it cannot be used to probe
	 * which links or emails are valid. Step 2 is vetterJobLogin in the authentication service.
	 */
	requestVetterJobAccessCode: MessageResponse;
	resendEmailMfaCode: MessageResponse;
	resendPasswordResetRequest: Scalars['String']['output'];
	/** Undo a scheduled cancellation before the period ends. */
	resumeSubscription: SubscriptionMutationResponse;
	revertToStudioFileVersion: MessageResponse;
	/** Admin: revise a client's post-deadline acceptance. Archives what the client accepted into supersededAcceptances, reopens the offer for editing (batches -> DRAFT), and returns the quote to PENDING. Edit the offer, then re-send it; the client re-accepts the revised terms. */
	reviseLateOfferAcceptance: AcceptOrderQuoteOffersResponse;
	/** Admin: revoke a previously issued guest acceptance link so it can no longer be used. */
	revokeOrderQuoteGuestAcceptanceLink: MessageResponse;
	/**
	 * Admin: revoke one link. Takes effect at once — any session open through it ends. The job
	 * itself stays, for the supplier's accounts and any other link; withdrawOrderQuoteVetterJob
	 * ends the whole request.
	 */
	revokeOrderQuoteVetterLink: MessageResponse;
	root?: Maybe<Scalars['String']['output']>;
	/** Persist the current user's picked combination for an offer batch so the UI can restore it on the next visit. Also saved automatically when a quote PDF is generated. */
	saveOfferBatchSelection: MessageResponse;
	/** Persist both logo blob URLs on the organization. Call after both uploads are complete. */
	saveOrganizationLogo: MessageResponse;
	sendChatMessage: SendChatMessageResponse;
	sendOrderQuoteOfferBatchToClient: MessageResponse;
	/**
	 * Public (no login): send the studio a message from the contact form. It is
	 * emailed to the studio with Reply-To set to the sender, and kept so admins
	 * can read it. Rate-limited; on failure success is false and message is
	 * readable as is.
	 */
	sendStudioMessage: MessageResponse;
	/**
	 * Raise a real notification addressed to yourself. Administrators only.
	 *
	 * Exists to make the bell testable without staging the flow behind a
	 * notification: there is no way to make an offer expire on demand. The row
	 * is written and published exactly like any other, so a subscriber that
	 * receives this would have received the real thing.
	 *
	 * Defaults to a type that cannot be switched off, so the test cannot fail
	 * for a reason unrelated to what is being tested. Passing a disabled type
	 * sends nothing and says so rather than appearing to succeed.
	 *
	 * Bell only unless an email address is given. Any email is rendered from
	 * the template's own sample data and carries no real order or invoice.
	 */
	sendTestNotification: MessageResponse;
	/**
	 * Admin: ask a supplier to price lines on a quote. Creates the supplier's job on the quote, or
	 * updates its lines when one exists — submitted prices are never touched.
	 *
	 * The recipient decides only who is told and how: a person with an activated account gets an
	 * email pointing at their portal; anyone else gets a secure link (email + code). Every account
	 * at the supplier also gets a bell notification and sees the job in their list regardless.
	 * The recipient may be left out when the supplier has at least one account; every account
	 * holder is then emailed as well as notified.
	 */
	sendVetterPriceRequest: SendVetterPriceRequestResponse;
	/**
	 * Turn a notification type on or off platform-wide. Administrators only.
	 *
	 * Omitted fields are left unchanged. Always-on types are rejected rather
	 * than silently ignored, so an admin is told why nothing happened.
	 */
	setNotificationSetting: MessageResponse;
	setOrderQuoteOfferPricing: MessageResponse;
	/** Admin: change which quote lines a job asks the supplier to price. Prices for a removed line are kept, and reappear if it is given back. */
	setOrderQuoteVetterJobItems: MessageResponse;
	/**
	 * Admin: change the lines of the job a link belongs to.
	 * @deprecated Use setOrderQuoteVetterJobItems.
	 */
	setOrderQuoteVetterLinkItems: MessageResponse;
	/** Replace the org's invoice recipient list (internal users + external emails) wholesale. */
	setOrganizationInvoiceRecipients: MessageResponse;
	/** Replace the price ladder for one product and one supplier. Tiers not in the input are removed; pass vetterEntityId null to edit the house prices. */
	setProductPrices: MessageResponse;
	/**
	 * Set the sample price for one product and one supplier, creating it or replacing it. Pass
	 * vetterEntityId null to set the house sample price.
	 */
	setProductSamplePrice: MessageResponse;
	/**
	 * Admin-only: choose who at the client hears about this quote (offers, orders, samples,
	 * payments and invoice reminders). Replaces the whole list; an empty list goes back to
	 * everyone at the organisation. The quote's guest-link holders are emailed either way.
	 */
	setQuoteClientContacts: MessageResponse;
	/** Admin-only: override the quote's payment settings during the quote flow. The order copies these at acceptance. Partial — omit a field to leave it, pass null on a limit to clear it. */
	setQuotePaymentSettings: MessageResponse;
	/**
	 * Admin: change how a sample is paid for — charged, prepaid (credited against production), or waived.
	 *
	 * Normally decided on the offer and snapshotted at acceptance; this is the override for a decision
	 * made afterwards. Rejected once production has been paid for the sample's item: the credit is
	 * already booked into that invoice, so changing it would leave the record describing something
	 * that never happened.
	 */
	setSamplePaymentTreatment: MessageResponse;
	/**
	 * Move part of a shipment's contents into a shipment of its own. Admin or vetter.
	 *
	 * For when half of a product is ready and the rest is not: the finished half leaves now instead
	 * of waiting. The new shipment carries no price — the freight was agreed once and stays on the
	 * shipment it was split out of, which is still billed once for the whole group.
	 *
	 * Only a PENDING shipment can be split, and something must be left on it: what a shipment that
	 * has already gone carried is a fact, and a split that empties its source is a deletion.
	 */
	splitOrderShipment: MessageResponse;
	/**
	 * Link session or supplier account: submit prices for a job. Each line prices one quantity tier. A
	 * submission replaces the previous one: a tier left out is no longer priced. Can be
	 * resubmitted while the job is active — the studio sees the latest figures.
	 */
	submitVetterJobPrices: MessageResponse;
	/** Move this session to another organization the signed-in user is a member of. Re-issues the session (new access token and rotated refresh cookie) working in that organization; it also becomes the default for the next sign-in. */
	switchOrganization: LoginValidateResponse;
	/**
	 * Re-copy the catalogue onto several quote lines at once — the bulk form of
	 * refreshOrderQuoteItemProductSnapshot, and the thing to call after previewing.
	 *
	 * Unlike the single-line mutation it does not fail when one product is unreachable: that line
	 * is skipped and the rest are synced, because refusing the whole batch would leave an admin
	 * unable to sync a quote that contains one deleted product.
	 */
	syncOrderQuoteProducts: MessageResponse;
	unlockAuthenticationUser: MessageResponse;
	/** Admin-only. Take products off the community page. Copies clients already took are unaffected. */
	unpublishProductsFromCommunity: MessageResponse;
	/** Update an admin user (Admin only) */
	updateAdminUser: MessageResponse;
	updateAuthorizationRole: MessageResponse;
	updateBrand: MessageResponse;
	updateBrandColorPalette: MessageResponse;
	updateBrandPersonality: MessageResponse;
	updateBrandTypography: MessageResponse;
	updateBrandUsageGuidelines: MessageResponse;
	updateManufacturer: MessageResponse;
	updateOrder: MessageResponse;
	/**
	 * Admin: correct where an order ships. Writes the order's own snapshot only — the quote keeps the
	 * address the client accepted under. Must be complete, like at acceptance, and is refused once
	 * anything has shipped or the order is cancelled; see Order.deliveryAddressLockedReason.
	 */
	updateOrderDeliveryAddress: MessageResponse;
	updateOrderItemStatus: MessageResponse;
	updateOrderQuote: MessageResponse;
	updateOrderQuoteItem: MessageResponse;
	/** Edit what an already-uploaded file says about itself. The file is untouched; only its description changes. */
	updateOrderQuoteItemAttachment: MessageResponse;
	updateOrderQuoteOffer: MessageResponse;
	updateOrderQuoteOfferAdjustment: MessageResponse;
	updateOrderQuoteOfferBatch: MessageResponse;
	updateOrderQuoteOfferDelivery: MessageResponse;
	/** Replace a split's legs wholesale. Parts given REPLACE the existing ones; the option keeps its id, so a client who already selected it keeps their selection. */
	updateOrderQuoteOfferDeliverySplit: MessageResponse;
	updateOrderQuoteOfferSample: MessageResponse;
	updateOrderQuoteRequestItem: MessageResponse;
	/**
	 * Set carrier, tracking and dates on one shipment. Admin or vetter.
	 *
	 * Tracking belongs to the shipment, not the product: one shipment can carry several products, so
	 * recording it per product would mean typing the same number repeatedly and leaving the box
	 * half-marked if one was missed.
	 */
	updateOrderShipmentTracking: MessageResponse;
	updateOrganization: MessageResponse;
	updateOrganizationAddress: OrganizationAddress;
	updateOrganizationApprovalAndMargin: MessageResponse;
	updateOrganizationCompliance: OrganizationCompliance;
	updateOrganizationComplianceConnection: OrganizationComplianceConnection;
	/** Admin: rename or republish an industry. */
	updateOrganizationIndustry: OrganizationIndustry;
	/** Set/clear per-org invoice minimum (DKK). null = default (25,000 DKK). */
	updateOrganizationInvoiceMinimum: MessageResponse;
	/** Set per-org default payment modes for products and samples (independent). */
	updateOrganizationPaymentMode: MessageResponse;
	/** Set the e-conomic payment terms the org sits under. Re-syncs the e-conomic customer record. */
	updateOrganizationPaymentTerms: MessageResponse;
	updateOrganizationProductInterest: OrganizationProductInterest;
	updateOrganizationSetting: MessageResponse;
	updateOrganizationSourcingPreference: OrganizationSourcingPreference;
	updateOrganizationSourcingPreferenceConnection: OrganizationSourcingPreferenceConnection;
	/** Set/clear per-org Stripe checkout limit (EUR). null = default (€3,000). */
	updateOrganizationStripeCheckoutLimit: MessageResponse;
	updateOrganizationUser: MessageResponse;
	updateProduct: MessageResponse;
	/** Set or clear the crop applied to a product image for display. Pass crop: null to reset to the full original image. */
	updateProductImageCrop: MessageResponse;
	updateProductImagePrimary: MessageResponse;
	updateProductTag: MessageResponse;
	updateSampleStatus: MessageResponse;
	updateStudioFile: MessageResponse;
	updateStudioFileVersionMetadata: MessageResponse;
	updateStudioFileVersionSpecification: MessageResponse;
	updateStudioFileVersionTechPack: MessageResponse;
	updateStudioPromptTemplate: StudioPromptTemplate;
	/**
	 * Admin-only: update non-Stripe-sourced fields on a tier
	 * (kickback rate, AI token rate, isActive flag, stripePriceId pointer).
	 * Price + currency are read-only via this mutation — they come from
	 * Stripe via the price.created / price.updated webhook. To change a
	 * tier's price, edit it in the Stripe dashboard or create a new
	 * Stripe Price and point stripePriceId at it.
	 */
	updateSubscriptionTierConfig: SubscriptionTierConfig;
	updateSystemSettings: MessageResponse;
	updateVetterEntity: MessageResponse;
	/**
	 * Link session or supplier account: enter carrier and tracking for one of the supplier's shipments. On a
	 * shipment that has not gone yet this marks it shipped; on one already shipped it corrects
	 * the tracking. Read the shipment's availableActions for which one applies and the fields.
	 */
	updateVetterJobShipmentTracking: MessageResponse;
	updateVetterUser: MessageResponse;
	validateAuthenticationToken: AuthenticationToken;
	verifyAuthenticatorMfa: LoginResponse;
	verifyAuthenticatorSetup: LoginResponse;
	verifyEmailMfa: LoginResponse;
	/**
	 * Public (no login): step 2 of opening a vetter link — verify the one-time code emailed by
	 * requestVetterJobAccessCode and start a session. On success sets the vetter refresh cookie,
	 * like a normal login, and returns an access token. The session is bound to that one link and
	 * reaches only getVetterJob and the VetterJob mutations. The supplier becomes a real,
	 * password-less vetter user under the link's vetter entity, convertible to a portal account.
	 */
	vetterJobLogin: VetterJobLoginResponse;
	/** Admin: withdraw a job. It leaves the supplier's list, every link into it stops working at once, and it can no longer be priced. */
	withdrawOrderQuoteVetterJob: MessageResponse;
};

export type MutationAcceptOrderQuoteOffersArgs = {
	input: AcceptOrderQuoteOffersInput;
};

export type MutationAcquireStudioLockArgs = {
	studioFileId: Scalars['ID']['input'];
};

export type MutationAddOffersToOrderQuoteOfferBatchArgs = {
	id: Scalars['ID']['input'];
	offers: Array<CreateOrderQuoteOfferBatchOfferInput>;
};

export type MutationAddOrderQuoteItemsArgs = {
	input: AddOrderQuoteItemsInput;
};

export type MutationAddOrderQuoteOfferArgs = {
	input: AddOrderQuoteOfferInput;
};

export type MutationAddOrderQuoteOfferAdjustmentArgs = {
	input: AddOrderQuoteOfferAdjustmentInput;
};

export type MutationAddOrderQuoteOfferDeliveryArgs = {
	input: AddOrderQuoteOfferDeliveryInput;
};

export type MutationAddOrderQuoteOfferDeliverySplitArgs = {
	input: AddOrderQuoteOfferDeliverySplitInput;
};

export type MutationAddOrderQuoteOfferSampleArgs = {
	input: AddOrderQuoteOfferSampleInput;
};

export type MutationAddOrderQuoteRequestItemsArgs = {
	input: AddOrderQuoteRequestItemsInput;
};

export type MutationAddQuoteProductCommentArgs = {
	input: AddQuoteProductCommentInput;
};

export type MutationAddStudioFileVersionMetadataArgs = {
	input: AddStudioFileVersionMetadataInput;
	studioFileVersionId: Scalars['ID']['input'];
};

export type MutationApplyCatalogPriceToOfferSampleArgs = {
	input: ApplyCatalogPriceToOfferSampleInput;
};

export type MutationApplyCatalogPriceToOfferTierArgs = {
	input: ApplyCatalogPriceToOfferTierInput;
};

export type MutationApplyVetterPricesArgs = {
	input: ApplyVetterPricesInput;
};

export type MutationApproveEarlyAccessRequestArgs = {
	input: ApproveEarlyAccessRequestInput;
};

export type MutationApproveNewSampleRoundArgs = {
	id: Scalars['ID']['input'];
	input?: InputMaybe<ApproveNewSampleRoundInput>;
};

export type MutationApproveProductArgs = {
	productId: Scalars['ID']['input'];
};

export type MutationAssignPermissionsToRoleArgs = {
	input: AssignPermissionsToRoleInput;
};

export type MutationAssignProductToOrganizationArgs = {
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	productId: Scalars['ID']['input'];
};

export type MutationAssignProductsToOrganizationArgs = {
	brandId?: InputMaybe<Scalars['ID']['input']>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	productIds: Array<Scalars['ID']['input']>;
};

export type MutationAssignStudioFileToClientArgs = {
	input: AssignStudioFileToClientInput;
};

export type MutationCancelOrderArgs = {
	id: Scalars['ID']['input'];
};

export type MutationCategorizeBulkProductImagesArgs = {
	input: CategorizeBulkProductImagesInput;
};

export type MutationChangeSubscriptionPlanArgs = {
	tier: SubscriptionTier;
};

export type MutationCloseOrderQuoteArgs = {
	id: Scalars['ID']['input'];
};

export type MutationCompleteRecommendationArgs = {
	input: CompleteRecommendationInput;
};

export type MutationCompleteVetterJobProductionArgs = {
	orderItemId: Scalars['ID']['input'];
};

export type MutationConfirmBrandFileUploadArgs = {
	input: ConfirmBrandFileUploadInput;
};

export type MutationConfirmBrandFontUploadArgs = {
	input: ConfirmBrandFontUploadInput;
};

export type MutationConfirmOrderArgs = {
	id: Scalars['ID']['input'];
	input: ConfirmOrderInput;
};

export type MutationConfirmOrderQuoteItemAttachmentUploadsArgs = {
	input: ConfirmOrderQuoteItemAttachmentUploadsInput;
};

export type MutationConfirmPendingOfferAcceptanceArgs = {
	orderQuoteId: Scalars['ID']['input'];
};

export type MutationConfirmProductImageUploadArgs = {
	input: ConfirmProductImageUploadInput;
};

export type MutationConfirmProductPriceArgs = {
	input: DeleteInput;
};

export type MutationConfirmProductSamplePriceArgs = {
	input: DeleteInput;
};

export type MutationConfirmSampleAttachmentUploadsArgs = {
	input: ConfirmSampleAttachmentUploadsInput;
};

export type MutationConfirmStudioReferenceImageUploadArgs = {
	input: ConfirmStudioReferenceImageUploadInput;
};

export type MutationCreateAdminUserArgs = {
	input: CreateAdminUserInput;
};

export type MutationCreateAuthorizationRoleArgs = {
	input: AuthorizationRoleCreateInput;
};

export type MutationCreateBrandArgs = {
	input: BrandCreateInput;
};

export type MutationCreateBulkProductsArgs = {
	input: CreateBulkProductsInput;
};

export type MutationCreateBulkProjectProductsArgs = {
	input: CreateBulkProjectProductsInput;
};

export type MutationCreateDesignSpecArgs = {
	input: CreateDesignSpecInput;
};

export type MutationCreateFullOrderPaymentArgs = {
	input: CreateFullOrderPaymentInput;
};

export type MutationCreateManufacturerArgs = {
	input: ManufacturerCreateInput;
};

export type MutationCreateManyAuthorizationUserRoleArgs = {
	input: CreateManyAuthorizationUserRoleInput;
};

export type MutationCreateOrderPaymentArgs = {
	input: CreateOrderPaymentInput;
};

export type MutationCreateOrderQuoteArgs = {
	input: CreateOrderQuoteInput;
};

export type MutationCreateOrderQuoteGuestAcceptanceLinkArgs = {
	input: CreateOrderQuoteGuestAcceptanceLinkInput;
};

export type MutationCreateOrderQuoteGuestPreviewLinkArgs = {
	orderQuoteId: Scalars['ID']['input'];
};

export type MutationCreateOrderQuoteOfferBatchArgs = {
	input: CreateOrderQuoteOfferBatchInput;
};

export type MutationCreateOrderQuoteVetterLinkArgs = {
	input: CreateOrderQuoteVetterLinkInput;
};

export type MutationCreateOrderShipmentArgs = {
	input: CreateOrderShipmentInput;
};

export type MutationCreateOrganizationArgs = {
	input: OrganizationCreateInput;
};

export type MutationCreateOrganizationAddressArgs = {
	input: OrganizationAddressInput;
	organizationId: Scalars['ID']['input'];
};

export type MutationCreateOrganizationComplianceArgs = {
	input: OrganizationComplianceCreateInput;
};

export type MutationCreateOrganizationComplianceConnectionArgs = {
	input: OrganizationComplianceConnectionCreateInput;
};

export type MutationCreateOrganizationIndustryArgs = {
	input: CreateOrganizationIndustryInput;
};

export type MutationCreateOrganizationOnboardingArgs = {
	input: OrganizationOnboardingInput;
};

export type MutationCreateOrganizationProductInterestArgs = {
	input: OrganizationProductInterestCreateInput;
};

export type MutationCreateOrganizationSignupArgs = {
	input: OrganizationSignupInput;
};

export type MutationCreateOrganizationSourcingPreferenceArgs = {
	input: OrganizationSourcingPreferenceCreateInput;
};

export type MutationCreateOrganizationSourcingPreferenceConnectionArgs = {
	input: OrganizationSourcingPreferenceConnectionCreateInput;
};

export type MutationCreateOrganizationUserArgs = {
	input: OrganizationUserCreateInput;
};

export type MutationCreateProductArgs = {
	input: ProductCreateInput;
};

export type MutationCreateProductFromStudioFileArgs = {
	input: CreateProductFromStudioInput;
};

export type MutationCreateProductTagArgs = {
	input: ProductTagCreateInput;
};

export type MutationCreateProductVariantFromStudioFileArgs = {
	input: CreateProductVariantFromStudioInput;
};

export type MutationCreateProjectArgs = {
	input: CreateProjectInput;
};

export type MutationCreateProjectProductArgs = {
	input: CreateProjectProductInput;
};

export type MutationCreateSamplePaymentArgs = {
	input: CreateSamplePaymentInput;
};

export type MutationCreateSamplePaymentCheckoutArgs = {
	input: CreateSamplePaymentCheckoutInput;
};

export type MutationCreateStudioFileArgs = {
	input: StudioFileCreateInput;
};

export type MutationCreateStudioFileVersionArgs = {
	input: CreateStudioFileVersionInput;
};

export type MutationCreateStudioFileVersionSpecificationArgs = {
	input: CreateStudioFileVersionSpecificationInput;
};

export type MutationCreateStudioFileVersionTechPackArgs = {
	input: CreateStudioFileVersionTechPackInput;
};

export type MutationCreateSubscriptionCheckoutSessionArgs = {
	tier: SubscriptionTier;
};

export type MutationCreateVetterEntityArgs = {
	input: CreateVetterEntityInput;
};

export type MutationCreateVetterUserArgs = {
	input: CreateVetterUserInput;
};

export type MutationDeclineProductArgs = {
	productId: Scalars['ID']['input'];
};

export type MutationDeleteAdminUserArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteAuthorizationRoleArgs = {
	input: DeleteInput;
};

export type MutationDeleteBrandArgs = {
	input: DeleteInput;
};

export type MutationDeleteBrandFileArgs = {
	brandId: Scalars['ID']['input'];
	fileId: Scalars['ID']['input'];
};

export type MutationDeleteBrandFontArgs = {
	brandId: Scalars['ID']['input'];
	fontId: Scalars['ID']['input'];
};

export type MutationDeleteDesignSpecArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteManufacturerArgs = {
	input: DeleteInput;
};

export type MutationDeleteManyAdminUserArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyAuthorizationRoleArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyAuthorizationUserRoleArgs = {
	input: DeleteManyAuthorizationUserRoleInput;
};

export type MutationDeleteManyBrandArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyManufacturerArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyOrderQuoteArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyOrganizationArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyOrganizationUserArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyProductArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyProjectArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyProjectProductArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyVetterEntityArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyVetterUserArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteOrderQuoteArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrderQuoteItemAttachmentArgs = {
	attachmentId: Scalars['ID']['input'];
	orderQuoteItemId: Scalars['ID']['input'];
};

export type MutationDeleteOrderQuoteOfferBatchArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationArgs = {
	input: DeleteInput;
};

export type MutationDeleteOrganizationAddressArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationComplianceArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationComplianceConnectionArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationComplianceConnectionsArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteOrganizationCompliancesArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteOrganizationIndustryArgs = {
	input: DeleteOrganizationIndustryInput;
};

export type MutationDeleteOrganizationProductInterestArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationProductInterestsArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteOrganizationSourcingPreferenceArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationSourcingPreferenceConnectionArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationSourcingPreferenceConnectionsArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteOrganizationSourcingPreferencesArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteOrganizationUserArgs = {
	input: DeleteInput;
};

export type MutationDeleteProductArgs = {
	input: DeleteInput;
};

export type MutationDeleteProductImageArgs = {
	imageId: Scalars['ID']['input'];
	productId: Scalars['ID']['input'];
};

export type MutationDeleteProductPriceArgs = {
	input: DeleteInput;
};

export type MutationDeleteProductSamplePriceArgs = {
	input: DeleteInput;
};

export type MutationDeleteProductTagArgs = {
	input: DeleteInput;
};

export type MutationDeleteProductTagsArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteProjectArgs = {
	input: DeleteInput;
};

export type MutationDeleteProjectProductArgs = {
	input: DeleteInput;
};

export type MutationDeleteQuoteProductCommentArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteSampleAttachmentArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteStudioFileArgs = {
	input: DeleteInput;
};

export type MutationDeleteStudioFileVersionArgs = {
	versionId: Scalars['ID']['input'];
};

export type MutationDeleteStudioFileVersionMetadataArgs = {
	metadataId: Scalars['ID']['input'];
};

export type MutationDeleteStudioFileVersionSpecificationArgs = {
	specificationId: Scalars['ID']['input'];
};

export type MutationDeleteStudioFileVersionTechPackArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteVetterEntityArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteVetterUserArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDismissProductRecommendationArgs = {
	recommendationId: Scalars['ID']['input'];
};

export type MutationDuplicateOrderQuoteArgs = {
	id: Scalars['ID']['input'];
	input?: InputMaybe<DuplicateOrderQuoteInput>;
};

export type MutationDuplicateOrderQuoteOfferBatchArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDuplicateProductArgs = {
	input: DuplicateProductInput;
};

export type MutationEditQuoteProductCommentArgs = {
	body: Scalars['String']['input'];
	id: Scalars['ID']['input'];
};

export type MutationFinishMetadataAttachmentUploadArgs = {
	input: FinishMetadataAttachmentUploadInput;
};

export type MutationGenerateBrandFileUploadUrlArgs = {
	input: BrandFileUploadInput;
};

export type MutationGenerateBrandFontUploadUrlArgs = {
	input: FontFileUploadInput;
};

export type MutationGenerateBulkProductImageUploadUrlsArgs = {
	input: GenerateBulkProductImageUploadUrlsInput;
};

export type MutationGenerateChatAttachmentUploadUrlArgs = {
	input: ChatAttachmentUploadInput;
};

export type MutationGenerateMetadataAttachmentUploadUrlArgs = {
	input: MetadataAttachmentUploadInput;
};

export type MutationGenerateOfferEconomicQuotePdfArgs = {
	input: GenerateOfferEconomicQuotePdfInput;
};

export type MutationGenerateOrderQuoteItemAttachmentUploadUrlArgs = {
	input: GenerateOrderQuoteItemAttachmentUploadUrlInput;
};

export type MutationGenerateOrganizationLogoUploadUrlArgs = {
	input: GenerateOrganizationLogoUploadUrlInput;
};

export type MutationGenerateOrganizationUserAvatarUploadUrlArgs = {
	input: GenerateUploadUrlInput;
};

export type MutationGenerateProductImageUploadUrlArgs = {
	input: ProductImageUploadInput;
};

export type MutationGenerateProjectProductImageUploadUrlsArgs = {
	input: GenerateProjectProductImageUploadUrlsInput;
};

export type MutationGenerateQuoteProductCommentUploadUrlArgs = {
	input: GenerateQuoteProductCommentUploadUrlInput;
};

export type MutationGenerateSampleAttachmentUploadUrlArgs = {
	input: GenerateSampleAttachmentUploadUrlInput;
};

export type MutationGenerateStudioReferenceImageUploadUrlArgs = {
	input: GenerateStudioReferenceImageUploadUrlInput;
};

export type MutationGuestQuoteLoginArgs = {
	input: GuestQuoteLoginInput;
};

export type MutationGuestQuotePreviewLoginArgs = {
	input: GuestQuotePreviewLoginInput;
};

export type MutationInviteOrganizationUserArgs = {
	input: InviteOrganizationUserInput;
};

export type MutationInviteVetterUserArgs = {
	id: Scalars['ID']['input'];
};

export type MutationLoginArgs = {
	input: LoginInput;
};

export type MutationLoginValidateArgs = {
	input: LoginValidateInput;
};

export type MutationLoginWithBackupCodeArgs = {
	input: LoginWithBackupCodeInput;
};

export type MutationLogoutArgs = {
	input: LogoutInput;
};

export type MutationMarkNotificationReadArgs = {
	id: Scalars['ID']['input'];
};

export type MutationMarkOrderProductInvoicePaidArgs = {
	note?: InputMaybe<Scalars['String']['input']>;
	paymentTransactionId: Scalars['ID']['input'];
};

export type MutationMarkOrderSampleInvoicePaidArgs = {
	note?: InputMaybe<Scalars['String']['input']>;
	paymentTransactionId: Scalars['ID']['input'];
};

export type MutationMarkQuoteProductThreadReadArgs = {
	input: QuoteProductThreadInput;
};

export type MutationPasswordResetArgs = {
	input: PasswordResetInput;
};

export type MutationPasswordResetRequestArgs = {
	input: PasswordResetRequestInput;
};

export type MutationPasswordResetValidateArgs = {
	input: PasswordResetValidateInput;
};

export type MutationPasswordUpdateArgs = {
	input: PasswordUpdateInput;
};

export type MutationPublishOrganizationIndustryArgs = {
	id: Scalars['ID']['input'];
};

export type MutationPublishProductsToCommunityArgs = {
	productIds: Array<Scalars['ID']['input']>;
};

export type MutationRecallOrderQuoteOfferBatchArgs = {
	id: Scalars['ID']['input'];
};

export type MutationRecordOrderBankTransferArgs = {
	input: RecordOrderBankTransferInput;
};

export type MutationRecordOrderQuoteViewArgs = {
	orderQuoteId: Scalars['ID']['input'];
};

export type MutationRefreshOrderQuoteItemProductSnapshotArgs = {
	id: Scalars['ID']['input'];
};

export type MutationRegenerateBackupCodesArgs = {
	input: RegenerateBackupCodesInput;
};

export type MutationRegisterArgs = {
	input: RegisterInput;
};

export type MutationRejectEarlyAccessRequestArgs = {
	requestId: Scalars['ID']['input'];
};

export type MutationRejectOrderQuoteOfferArgs = {
	input: RejectOrderQuoteOfferInput;
};

export type MutationRejectOrderQuoteOfferBatchArgs = {
	input: RejectOrderQuoteOfferBatchInput;
};

export type MutationRejectPendingOfferAcceptanceArgs = {
	orderQuoteId: Scalars['ID']['input'];
	reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationReleaseStudioLockArgs = {
	studioFileId: Scalars['ID']['input'];
};

export type MutationRemixProductToStudioArgs = {
	input: RemixProductToStudioInput;
};

export type MutationRemoveMetadataAttachmentArgs = {
	input: RemoveMetadataAttachmentInput;
};

export type MutationRemoveOrderQuoteItemArgs = {
	id: Scalars['ID']['input'];
};

export type MutationRemoveOrderQuoteOfferArgs = {
	id: Scalars['ID']['input'];
};

export type MutationRemoveOrderQuoteOfferAdjustmentArgs = {
	id: Scalars['ID']['input'];
};

export type MutationRemoveOrderQuoteOfferDeliveryArgs = {
	id: Scalars['ID']['input'];
};

export type MutationRemoveOrderQuoteOfferSampleArgs = {
	id: Scalars['ID']['input'];
};

export type MutationRemoveOrderQuoteRequestItemArgs = {
	id: Scalars['ID']['input'];
};

export type MutationRemovePermissionsFromRoleArgs = {
	input: RemovePermissionsFromRoleInput;
};

export type MutationRequestEarlyAccessArgs = {
	input: RequestEarlyAccessInput;
};

export type MutationRequestGuestQuoteAccessCodeArgs = {
	input: RequestGuestQuoteAccessCodeInput;
};

export type MutationRequestOrderQuoteOfferArgs = {
	orderQuoteId: Scalars['ID']['input'];
};

export type MutationRequestVetterJobAccessCodeArgs = {
	input: RequestVetterJobAccessCodeInput;
};

export type MutationResendEmailMfaCodeArgs = {
	userId: Scalars['ID']['input'];
};

export type MutationResendPasswordResetRequestArgs = {
	input: PasswordResetRequestInput;
};

export type MutationRevertToStudioFileVersionArgs = {
	versionId: Scalars['ID']['input'];
};

export type MutationReviseLateOfferAcceptanceArgs = {
	orderQuoteId: Scalars['ID']['input'];
};

export type MutationRevokeOrderQuoteGuestAcceptanceLinkArgs = {
	id: Scalars['ID']['input'];
};

export type MutationRevokeOrderQuoteVetterLinkArgs = {
	id: Scalars['ID']['input'];
};

export type MutationSaveOfferBatchSelectionArgs = {
	input: SaveOfferBatchSelectionInput;
};

export type MutationSaveOrganizationLogoArgs = {
	input: SaveOrganizationLogoInput;
};

export type MutationSendChatMessageArgs = {
	input: SendChatMessageInput;
};

export type MutationSendOrderQuoteOfferBatchToClientArgs = {
	id: Scalars['ID']['input'];
};

export type MutationSendStudioMessageArgs = {
	input: SendStudioMessageInput;
};

export type MutationSendTestNotificationArgs = {
	email?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<NotificationType>;
};

export type MutationSendVetterPriceRequestArgs = {
	input: SendVetterPriceRequestInput;
};

export type MutationSetNotificationSettingArgs = {
	input: SetNotificationSettingInput;
};

export type MutationSetOrderQuoteOfferPricingArgs = {
	input: SetOrderQuoteOfferPricingInput;
};

export type MutationSetOrderQuoteVetterJobItemsArgs = {
	id: Scalars['ID']['input'];
	orderQuoteItemIds: Array<Scalars['ID']['input']>;
};

export type MutationSetOrderQuoteVetterLinkItemsArgs = {
	id: Scalars['ID']['input'];
	orderQuoteItemIds: Array<Scalars['ID']['input']>;
};

export type MutationSetOrganizationInvoiceRecipientsArgs = {
	input: SetOrganizationInvoiceRecipientsInput;
};

export type MutationSetProductPricesArgs = {
	input: SetProductPricesInput;
};

export type MutationSetProductSamplePriceArgs = {
	input: SetProductSamplePriceInput;
};

export type MutationSetQuoteClientContactsArgs = {
	input: SetQuoteClientContactsInput;
};

export type MutationSetQuotePaymentSettingsArgs = {
	input: SetQuotePaymentSettingsInput;
};

export type MutationSetSamplePaymentTreatmentArgs = {
	sampleId: Scalars['ID']['input'];
	treatment: SamplePaymentTreatment;
};

export type MutationSplitOrderShipmentArgs = {
	id: Scalars['ID']['input'];
	input: SplitOrderShipmentInput;
};

export type MutationSubmitVetterJobPricesArgs = {
	input: SubmitVetterJobPricesInput;
};

export type MutationSwitchOrganizationArgs = {
	organizationId: Scalars['ID']['input'];
};

export type MutationSyncOrderQuoteProductsArgs = {
	input: SyncOrderQuoteProductsInput;
};

export type MutationUnlockAuthenticationUserArgs = {
	userId: Scalars['ID']['input'];
};

export type MutationUnpublishProductsFromCommunityArgs = {
	productIds: Array<Scalars['ID']['input']>;
};

export type MutationUpdateAdminUserArgs = {
	id: Scalars['ID']['input'];
	input: UpdateAdminUserInput;
};

export type MutationUpdateAuthorizationRoleArgs = {
	input: AuthorizationRoleUpdateInput;
};

export type MutationUpdateBrandArgs = {
	input: BrandUpdateInput;
};

export type MutationUpdateBrandColorPaletteArgs = {
	brandId: Scalars['ID']['input'];
	colorPalette: BrandColorPaletteInput;
};

export type MutationUpdateBrandPersonalityArgs = {
	brandId: Scalars['ID']['input'];
	personality: BrandPersonalityInput;
};

export type MutationUpdateBrandTypographyArgs = {
	brandId: Scalars['ID']['input'];
	typography: BrandTypographyInput;
};

export type MutationUpdateBrandUsageGuidelinesArgs = {
	brandId: Scalars['ID']['input'];
	guidelines: BrandUsageGuidelinesInput;
};

export type MutationUpdateManufacturerArgs = {
	input: ManufacturerUpdateInput;
};

export type MutationUpdateOrderArgs = {
	id: Scalars['ID']['input'];
	input: UpdateOrderInput;
};

export type MutationUpdateOrderDeliveryAddressArgs = {
	address: OrderQuoteAddressInput;
	orderId: Scalars['ID']['input'];
};

export type MutationUpdateOrderItemStatusArgs = {
	id: Scalars['ID']['input'];
	input: UpdateOrderItemStatusInput;
};

export type MutationUpdateOrderQuoteArgs = {
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteInput;
};

export type MutationUpdateOrderQuoteItemArgs = {
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteItemInput;
};

export type MutationUpdateOrderQuoteItemAttachmentArgs = {
	attachmentId: Scalars['ID']['input'];
	input: UpdateOrderQuoteItemAttachmentInput;
	orderQuoteItemId: Scalars['ID']['input'];
};

export type MutationUpdateOrderQuoteOfferArgs = {
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteOfferInput;
};

export type MutationUpdateOrderQuoteOfferAdjustmentArgs = {
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteOfferAdjustmentInput;
};

export type MutationUpdateOrderQuoteOfferBatchArgs = {
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteOfferBatchInput;
};

export type MutationUpdateOrderQuoteOfferDeliveryArgs = {
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteOfferDeliveryInput;
};

export type MutationUpdateOrderQuoteOfferDeliverySplitArgs = {
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteOfferDeliverySplitInput;
};

export type MutationUpdateOrderQuoteOfferSampleArgs = {
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteOfferSampleInput;
};

export type MutationUpdateOrderQuoteRequestItemArgs = {
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteRequestItemInput;
};

export type MutationUpdateOrderShipmentTrackingArgs = {
	id: Scalars['ID']['input'];
	input: UpdateOrderShipmentTrackingInput;
};

export type MutationUpdateOrganizationArgs = {
	input: OrganizationUpdateInput;
};

export type MutationUpdateOrganizationAddressArgs = {
	id: Scalars['ID']['input'];
	input: OrganizationAddressInput;
};

export type MutationUpdateOrganizationApprovalAndMarginArgs = {
	input: UpdateOrganizationApprovalAndMarginInput;
};

export type MutationUpdateOrganizationComplianceArgs = {
	input: OrganizationComplianceUpdateInput;
};

export type MutationUpdateOrganizationComplianceConnectionArgs = {
	input: OrganizationComplianceConnectionUpdateInput;
};

export type MutationUpdateOrganizationIndustryArgs = {
	input: UpdateOrganizationIndustryInput;
};

export type MutationUpdateOrganizationInvoiceMinimumArgs = {
	input: UpdateOrganizationInvoiceMinimumInput;
};

export type MutationUpdateOrganizationPaymentModeArgs = {
	input: UpdateOrganizationPaymentModeInput;
};

export type MutationUpdateOrganizationPaymentTermsArgs = {
	input: UpdateOrganizationPaymentTermsInput;
};

export type MutationUpdateOrganizationProductInterestArgs = {
	input: OrganizationProductInterestUpdateInput;
};

export type MutationUpdateOrganizationSettingArgs = {
	input: OrganizationSettingUpdateInput;
};

export type MutationUpdateOrganizationSourcingPreferenceArgs = {
	input: OrganizationSourcingPreferenceUpdateInput;
};

export type MutationUpdateOrganizationSourcingPreferenceConnectionArgs = {
	input: OrganizationSourcingPreferenceConnectionUpdateInput;
};

export type MutationUpdateOrganizationStripeCheckoutLimitArgs = {
	input: UpdateOrganizationStripeCheckoutLimitInput;
};

export type MutationUpdateOrganizationUserArgs = {
	input: OrganizationUserUpdateInput;
};

export type MutationUpdateProductArgs = {
	input: ProductUpdateInput;
};

export type MutationUpdateProductImageCropArgs = {
	crop?: InputMaybe<ProductImageCropInput>;
	imageId: Scalars['ID']['input'];
	productId: Scalars['ID']['input'];
};

export type MutationUpdateProductImagePrimaryArgs = {
	imageId: Scalars['ID']['input'];
	productId: Scalars['ID']['input'];
};

export type MutationUpdateProductTagArgs = {
	input: ProductTagUpdateInput;
};

export type MutationUpdateSampleStatusArgs = {
	id: Scalars['ID']['input'];
	input: UpdateSampleStatusInput;
};

export type MutationUpdateStudioFileArgs = {
	input: StudioFileUpdateInput;
};

export type MutationUpdateStudioFileVersionMetadataArgs = {
	input: UpdateStudioFileVersionMetadataInput;
	metadataId: Scalars['ID']['input'];
};

export type MutationUpdateStudioFileVersionSpecificationArgs = {
	input: UpdateStudioFileVersionSpecificationInput;
	specificationId: Scalars['ID']['input'];
};

export type MutationUpdateStudioFileVersionTechPackArgs = {
	id: Scalars['ID']['input'];
	input: UpdateStudioFileVersionTechPackInput;
};

export type MutationUpdateStudioPromptTemplateArgs = {
	input: UpdateStudioPromptTemplateInput;
};

export type MutationUpdateSubscriptionTierConfigArgs = {
	aiTokenRatePerMillion?: InputMaybe<Scalars['Float']['input']>;
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	kickbackRate?: InputMaybe<Scalars['Float']['input']>;
	stripePriceId?: InputMaybe<Scalars['String']['input']>;
	tier: SubscriptionTier;
};

export type MutationUpdateSystemSettingsArgs = {
	input: UpdateSystemSettingInput;
};

export type MutationUpdateVetterEntityArgs = {
	id: Scalars['ID']['input'];
	input: UpdateVetterEntityInput;
};

export type MutationUpdateVetterJobShipmentTrackingArgs = {
	id: Scalars['ID']['input'];
	input: UpdateVetterJobShipmentTrackingInput;
};

export type MutationUpdateVetterUserArgs = {
	id: Scalars['ID']['input'];
	input: UpdateVetterUserInput;
};

export type MutationValidateAuthenticationTokenArgs = {
	token: Scalars['String']['input'];
};

export type MutationVerifyAuthenticatorMfaArgs = {
	input: VerifyAuthenticatorMfaInput;
};

export type MutationVerifyAuthenticatorSetupArgs = {
	input: VerifyAuthenticatorSetupInput;
};

export type MutationVerifyEmailMfaArgs = {
	input: VerifyEmailMfaInput;
};

export type MutationVetterJobLoginArgs = {
	input: VetterJobLoginInput;
};

export type MutationWithdrawOrderQuoteVetterJobArgs = {
	id: Scalars['ID']['input'];
};

export type Notification = {
	__typename?: 'Notification';
	body?: Maybe<Scalars['String']['output']>;
	createdAt: Scalars['DateTime']['output'];
	/** True when an email was sent for this notification as well. */
	emailSent: Scalars['Boolean']['output'];
	entityId?: Maybe<Scalars['ID']['output']>;
	/**
	 * What this is about, as the (type, id) pair the client's /n/:type/:id
	 * resolver understands — the same contract the email links use.
	 */
	entityType?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	/** The client organization this is about, when it was sent to a client organization's people. Null for account notices. */
	organizationId?: Maybe<Scalars['ID']['output']>;
	readAt?: Maybe<Scalars['DateTime']['output']>;
	title: Scalars['String']['output'];
	type: NotificationType;
};

/**
 * Who a notification is written for. Distinct from the actor, which elsewhere in
 * the platform means whoever performed an action — this is the recipient.
 */
export enum NotificationAudience {
	/** 05 Creation staff. */
	Admin = 'ADMIN',
	/** Users at a client organisation. */
	Client = 'CLIENT',
	/** Someone with no account — an invitee, an applicant, or a guest on an offer link. */
	Guest = 'GUEST',
	/** The account holder, whoever they are. Security and account notices. */
	User = 'USER',
}

/** How notification types group on the settings screen. Mirrors the sections of docs/notifications.md. */
export enum NotificationCategory {
	Account = 'ACCOUNT',
	Joining = 'JOINING',
	Offers = 'OFFERS',
	Orders = 'ORDERS',
	Other = 'OTHER',
	Payments = 'PAYMENTS',
	Samples = 'SAMPLES',
}

export type NotificationList = {
	__typename?: 'NotificationList';
	items: Array<Notification>;
	/** Total matching the query, for paging. */
	total: Scalars['Int']['output'];
	/** Unread count across all of the user's notifications, not just this page. */
	unreadCount: Scalars['Int']['output'];
};

export type NotificationSetting = {
	__typename?: 'NotificationSetting';
	/**
	 * True for security and account notifications, which cannot be switched
	 * off — telling someone their password changed is an obligation, not a
	 * preference. The switches are always reported as on for these.
	 */
	alwaysOn: Scalars['Boolean']['output'];
	/** Who receives this notification. Render it — do not infer it from the description. */
	audience: NotificationAudience;
	bellEnabled: Scalars['Boolean']['output'];
	/** Group to render this under. */
	category: NotificationCategory;
	/** One line explaining what this notification does and who receives it. */
	description: Scalars['String']['output'];
	emailEnabled: Scalars['Boolean']['output'];
	/**
	 * Ready-to-display name, e.g. "Password changed". Render this — never the
	 * raw enum value, and never wording derived on the frontend.
	 */
	label: Scalars['String']['output'];
	/**
	 * The email template this notification sends. Pass it to
	 * getEmailTemplatePreview to show an admin the actual email a switch
	 * controls. Empty only for a type with no metadata entry yet.
	 */
	templateKey: Scalars['String']['output'];
	type: NotificationType;
};

/**
 * Every notification the platform can raise.
 *
 * Auth-flow emails (login codes, verification codes, password-reset codes) are
 * deliberately absent: they are part of a sign-in flow rather than something a
 * user is notified about, they need no bell entry, and they must never be
 * switchable.
 */
export enum NotificationType {
	/** Security: two-factor backup codes were replaced. */
	AccountBackupCodesRegenerated = 'ACCOUNT_BACKUP_CODES_REGENERATED',
	/** Security: account locked after failed sign-in attempts. */
	AccountLocked = 'ACCOUNT_LOCKED',
	/** Security: sign-in from an unrecognised device. */
	AccountNewDeviceSignIn = 'ACCOUNT_NEW_DEVICE_SIGN_IN',
	/** Security: the account password was changed. */
	AccountPasswordChanged = 'ACCOUNT_PASSWORD_CHANGED',
	/** Security: the account was removed by an administrator. */
	AccountRemoved = 'ACCOUNT_REMOVED',
	/** Security: an administrator unlocked the account. */
	AccountUnlocked = 'ACCOUNT_UNLOCKED',
	/** An early access request was approved, with the link to create an account. */
	EarlyAccessApproved = 'EARLY_ACCESS_APPROVED',
	/** An early access request was not approved. */
	EarlyAccessDeclined = 'EARLY_ACCESS_DECLINED',
	/** Internal: someone requested early access and it needs reviewing. */
	EarlyAccessRequested = 'EARLY_ACCESS_REQUESTED',
	/** A guest was sent the secure link to review and accept an offer. */
	GuestOfferLink = 'GUEST_OFFER_LINK',
	/** A booked invoice falls due shortly. */
	InvoiceDueSoon = 'INVOICE_DUE_SOON',
	/** A booked invoice has passed its due date unpaid. */
	InvoiceOverdue = 'INVOICE_OVERDUE',
	/** A post-deadline acceptance was confirmed and an order created. */
	LateAcceptanceConfirmed = 'LATE_ACCEPTANCE_CONFIRMED',
	/** A post-deadline acceptance was not honoured. */
	LateAcceptanceDeclined = 'LATE_ACCEPTANCE_DECLINED',
	/** A post-deadline acceptance is being revised into a new offer. */
	LateAcceptanceRevising = 'LATE_ACCEPTANCE_REVISING',
	/** Internal: a client accepted an offer and an order was created. */
	OfferAccepted = 'OFFER_ACCEPTED',
	/** Internal: a client declined an offer, with their reason. */
	OfferDeclined = 'OFFER_DECLINED',
	/** An offer's answer deadline passed without a response. */
	OfferExpired = 'OFFER_EXPIRED',
	/** An offer's answer deadline is approaching. */
	OfferExpiringSoon = 'OFFER_EXPIRING_SOON',
	/** Internal, urgent: a client accepted after the deadline and it needs an admin decision. */
	OfferLateAcceptance = 'OFFER_LATE_ACCEPTANCE',
	/** An existing offer was revised and resent. */
	OfferRevised = 'OFFER_REVISED',
	/** A new offer is ready for the client to review. */
	OfferSent = 'OFFER_SENT',
	/** An entire order has been cancelled. */
	OrderCancelled = 'ORDER_CANCELLED',
	/** Every item on an order has been confirmed. */
	OrderConfirmed = 'ORDER_CONFIRMED',
	/** One item was cancelled while the rest of the order continues. */
	OrderItemCancelled = 'ORDER_ITEM_CANCELLED',
	/** An item on a live order has been delivered. */
	OrderItemDelivered = 'ORDER_ITEM_DELIVERED',
	/** An item on a live order has shipped, with carrier and tracking. */
	OrderItemShipped = 'ORDER_ITEM_SHIPPED',
	/** Someone who already has an account was added to another organization. */
	OrganizationAccessGranted = 'ORGANIZATION_ACCESS_GRANTED',
	/** A sample or production payment has settled. */
	PaymentReceived = 'PAYMENT_RECEIVED',
	/** A new comment on a quote product thread the recipient takes part in. */
	QuoteProductComment = 'QUOTE_PRODUCT_COMMENT',
	/** Someone was tagged in a comment on a quote product. */
	QuoteProductCommentMention = 'QUOTE_PRODUCT_COMMENT_MENTION',
	/** Internal: a client approved a sample. */
	SampleApproved = 'SAMPLE_APPROVED',
	/** Another sample round has been approved and started. */
	SampleNewRoundApproved = 'SAMPLE_NEW_ROUND_APPROVED',
	/** Internal: a client rejected a sample and asked for another round. */
	SampleNewRoundRequested = 'SAMPLE_NEW_ROUND_REQUESTED',
	/** A sample is waiting for the client to approve or reject it. */
	SampleReadyToReview = 'SAMPLE_READY_TO_REVIEW',
	/** Internal: a client rejected a sample. */
	SampleRejected = 'SAMPLE_REJECTED',
	/** A sample has sat unreviewed and the client is being nudged. */
	SampleReviewReminder = 'SAMPLE_REVIEW_REMINDER',
	/** A physical sample has been shipped to the client. */
	SampleShipped = 'SAMPLE_SHIPPED',
	/** Internal: someone sent the studio a message through the public contact form. */
	StudioMessageReceived = 'STUDIO_MESSAGE_RECEIVED',
	/** Someone was invited to join, with the link to set up their account. */
	UserInvitation = 'USER_INVITATION',
	/** A supplier was sent the secure link to price a quote and report production and tracking. */
	VetterJobLink = 'VETTER_JOB_LINK',
	/** A supplier with an account has a new price request waiting in their portal. */
	VetterJobRequested = 'VETTER_JOB_REQUESTED',
	/** Internal: a supplier submitted or updated prices on a price request. */
	VetterPricesSubmitted = 'VETTER_PRICES_SUBMITTED',
}

/** Tracks the kind of transition an offer is going through — used by notifications, history entries, and audit logs across the quote flow. */
export enum OfferAction {
	AddMargin = 'ADD_MARGIN',
	AdminAcceptClient = 'ADMIN_ACCEPT_CLIENT',
	AdminAcceptVetter = 'ADMIN_ACCEPT_VETTER',
	AdminRejectClient = 'ADMIN_REJECT_CLIENT',
	AdminRejectVetter = 'ADMIN_REJECT_VETTER',
	ApproveForClient = 'APPROVE_FOR_CLIENT',
	AutoReject = 'AUTO_REJECT',
	Cancel = 'CANCEL',
	ClientAcceptAdmin = 'CLIENT_ACCEPT_ADMIN',
	ClientRejectAdmin = 'CLIENT_REJECT_ADMIN',
	CounterOffer = 'COUNTER_OFFER',
	CounterOfferBasePrice = 'COUNTER_OFFER_BASE_PRICE',
	Create = 'CREATE',
	Expire = 'EXPIRE',
	Submit = 'SUBMIT',
	VetterAcceptAdmin = 'VETTER_ACCEPT_ADMIN',
	VetterRejectAdmin = 'VETTER_REJECT_ADMIN',
}

/** The quote an offer batch belongs to, for resolving /n/offer-batch/:id. */
export type OfferBatchLocation = {
	__typename?: 'OfferBatchLocation';
	offerBatchId: Scalars['ID']['output'];
	orderQuoteId: Scalars['ID']['output'];
};

export type OfferBatchSavedSelection = {
	__typename?: 'OfferBatchSavedSelection';
	/** True when this is the 'master' selection — the combination a quote PDF was generated for. It takes precedence over later working (debounced) changes. */
	fromDownloadedQuote: Scalars['Boolean']['output'];
	selections: Array<OfferBatchSelectionItem>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OfferBatchSelectionItem = {
	__typename?: 'OfferBatchSelectionItem';
	deliveryId?: Maybe<Scalars['ID']['output']>;
	offerId: Scalars['ID']['output'];
	pricingId: Scalars['ID']['output'];
	quantity: Scalars['Int']['output'];
	sampleChoice?: Maybe<OrderSampleChoice>;
};

/** The factors behind a feasibility verdict — the raw ingredients only, no prescribed fixes. Null when there's no deadline or production time to judge. */
export type OfferFeasibilityBreakdown = {
	__typename?: 'OfferFeasibilityBreakdown';
	/** What arrival was measured from — the accept-by date (worst case), or now when unset. */
	anchorDate?: Maybe<Scalars['DateTime']['output']>;
	/** The target deadline the arrival was judged against. */
	deadline?: Maybe<Scalars['DateTime']['output']>;
	/** Business days of lead time that fit between the anchor and the deadline. Guaranteed when leadTimeDaysMax ≤ this; possible when leadTimeDaysMin ≤ this. Negative means the anchor is already past the deadline. */
	deadlineCapacityBusinessDays?: Maybe<Scalars['Int']['output']>;
	deliveryDaysMax?: Maybe<Scalars['Int']['output']>;
	deliveryDaysMin?: Maybe<Scalars['Int']['output']>;
	leadTimeDaysMax?: Maybe<Scalars['Int']['output']>;
	/** production + delivery, summed (they run sequentially). */
	leadTimeDaysMin?: Maybe<Scalars['Int']['output']>;
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	/** Business days the best-case arrival misses the deadline by (0 when it fits). */
	overshootBestCaseBusinessDays?: Maybe<Scalars['Int']['output']>;
	/** Business days the worst-case arrival misses the deadline by (0 when it fits). */
	overshootBusinessDays?: Maybe<Scalars['Int']['output']>;
	/** Arrival measured from the anchor — the dates the verdict is based on. */
	projectedArrivalEarliest?: Maybe<Scalars['DateTime']['output']>;
	projectedArrivalLatest?: Maybe<Scalars['DateTime']['output']>;
};

/** Feasibility of production time alone (shipping excluded) — the floor. INFEASIBLE here means no delivery option can meet the deadline, so it's answerable before any delivery is added. */
export type OfferFeasibilityProduction = {
	__typename?: 'OfferFeasibilityProduction';
	/** The factors behind the verdict. Null when there's no deadline or production time. */
	breakdown?: Maybe<OfferFeasibilityBreakdown>;
	/** When production would finish (shipping not included) — earliest to worst case. */
	projectedCompletion?: Maybe<ProjectedDeliveryWindow>;
	/** Unified deadline+feasibility status — color the badge on this. */
	timelineStatus: TimelineStatus;
	verdict: OfferFeasibilityVerdict;
};

/** Per-delivery feasibility verdict for the offer-creation preview. */
export enum OfferFeasibilityVerdict {
	/** Even the best case misses the deadline. */
	Infeasible = 'INFEASIBLE',
	/** Best case makes it, worst case misses. */
	MaySlip = 'MAY_SLIP',
	/** No deadline was supplied, so there's nothing to judge against (dates still returned). */
	NoDeadline = 'NO_DEADLINE',
	/** Even the worst case lands on/before the deadline. */
	Ok = 'OK',
	/** Production time wasn't supplied, so no timeline could be projected. */
	ProductionUnknown = 'PRODUCTION_UNKNOWN',
}

/** Where an offer price's cost came from, when it was taken from a supplier. */
export type OfferPricingAppliedFrom = {
	__typename?: 'OfferPricingAppliedFrom';
	appliedAt: Scalars['DateTime']['output'];
	/** Ready to show, e.g. From Patrick Vetter's price · Sep 30. */
	label: Scalars['String']['output'];
	/** False once the cost on the offer has been changed since. */
	stillMatches: Scalars['Boolean']['output'];
	vetterEntity?: Maybe<VetterEntity>;
};

/**
 * One product's sample decision, as a pair rather than a positional list — offers drop out of
 * selectedPricingIds whenever a client deselects a product, so anything aligned by index breaks on
 * the first exclusion.
 */
export type OfferSampleChoiceInput = {
	offerId: Scalars['ID']['input'];
	sampleChoice: OrderSampleChoice;
};

export type OnboardingComplianceInput = {
	certificationNumber?: InputMaybe<Scalars['String']['input']>;
	certifyingBody?: InputMaybe<Scalars['String']['input']>;
	expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
	issueDate?: InputMaybe<Scalars['DateTime']['input']>;
	organizationComplianceId: Scalars['ID']['input'];
};

export type OnboardingProductInterestInput = {
	customTagName?: InputMaybe<Scalars['String']['input']>;
	productTagId?: InputMaybe<Scalars['ID']['input']>;
};

export type OnboardingSourcingPreferenceInput = {
	notes?: InputMaybe<Scalars['String']['input']>;
	organizationSourcingPreferenceId: Scalars['ID']['input'];
	priority?: InputMaybe<Scalars['Int']['input']>;
};

export type Order = Base & {
	__typename?: 'Order';
	/**
	 * What can be done with this order now. Pass inCurrency to have the payment routes quote their
	 * amounts in it, exactly as the money fields on this type do; it defaults to DKK.
	 */
	availableActions?: Maybe<Array<OrderNextAction>>;
	availablePaymentMethods?: Maybe<Array<OrderPaymentMethodOption>>;
	availableSamplePaymentMethods?: Maybe<Array<OrderPaymentMethodOption>>;
	baseTotalAmount?: Maybe<Scalars['Float']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	/**
	 * Everything this order is waiting to receive — sample rounds and shipments in one list, each
	 * with its state and when it is expected. Complete from acceptance: a delivery that has not
	 * started yet is still here.
	 */
	deliveries?: Maybe<Array<OrderDelivery>>;
	/**
	 * Where this order ships, snapshotted from the quote at acceptance. Editing the quote's address
	 * afterwards does not change it. Null only on orders placed before it was snapshotted.
	 */
	deliveryAddress?: Maybe<OrderQuoteAddress>;
	/** When an admin last corrected the delivery address after acceptance. Invoices booked before this were issued with the previous address and are not re-issued. Null while the address is as accepted. */
	deliveryAddressChangedAt?: Maybe<Scalars['DateTime']['output']>;
	/** Why the delivery address can no longer be changed — something has shipped, or the order is cancelled. Null while updateOrderDeliveryAddress would accept a change. */
	deliveryAddressLockedReason?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	invoiceMinimum?: Maybe<Scalars['Float']['output']>;
	/** Invoice recipients (internal users + external emails). All receive the invoice. */
	invoiceRecipients?: Maybe<Array<OrderInvoiceRecipient>>;
	items: Array<OrderItem>;
	/**
	 * Non-cancelled items with no confirmedAt — the ones still needing an admin to record the real
	 * supplier and cost. Drives the CONFIRM_ORDER action.
	 *
	 * Deliberately NOT a lifecycle position: confirmation gates starting production and nothing
	 * else, so an item can be sampling, or awaiting sample payment, while still counted here. A
	 * non-zero count does not mean the order has not moved.
	 */
	itemsAwaitingConfirmation?: Maybe<Scalars['Int']['output']>;
	marginTotal?: Maybe<Scalars['Float']['output']>;
	name: Scalars['String']['output'];
	orderNumber: Scalars['String']['output'];
	/** The quote this order was accepted from, for the 'from quote X' link. Quotes have a name, not a number. */
	orderQuote?: Maybe<OrderQuote>;
	orderQuoteId: Scalars['ID']['output'];
	organization?: Maybe<Organization>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	/** Every payment the client can make right now, priced. See OrderPaymentOption — this is the payments panel's whole input. */
	paymentOptions?: Maybe<Array<OrderPaymentOption>>;
	paymentSummary?: Maybe<OrderPaymentSummary>;
	/** PO number captured at acceptance. Payment steps default to this (still overridable per invoice). */
	poNumber?: Maybe<Scalars['String']['output']>;
	productPaymentMode: PaymentModeEnum;
	samplePaymentMode: PaymentModeEnum;
	/** Where the ORDER is in its own setup. Orthogonal to the item lifecycle — see OrderSetupStage. Always resolved; nullable only because every computed field on this type is. */
	setupStage?: Maybe<OrderSetupStage>;
	/**
	 * Physical shipments, in sequence — one per product, or one per part where the client picked a
	 * split delivery option. Each carries its own agreed price.
	 */
	shipments: Array<OrderShipment>;
	/** Where the order stands on shipping — the orders list's delivery column. Batched, so safe to ask for on every row. */
	shipping?: Maybe<OrderShipping>;
	status: OrderStatus;
	stripeCheckoutLimit?: Maybe<Scalars['Float']['output']>;
	summary?: Maybe<OrderSummary>;
	/** @deprecated Line revenue snapshotted at acceptance — ex-VAT, no fees, no delivery. For the headline order total use summary { grossAmount }. */
	totalAmount?: Maybe<Scalars['Float']['output']>;
	/** Units ordered across every non-cancelled item. */
	totalQuantity?: Maybe<Scalars['Int']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderAvailableActionsArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderBaseTotalAmountArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderMarginTotalArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderPaymentOptionsArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderPaymentSummaryArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderSummaryArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderTotalAmountArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export enum OrderAction {
	CancelOrder = 'CANCEL_ORDER',
	ConfirmOrder = 'CONFIRM_ORDER',
	/** Admin-only: mark a booked-but-unpaid production invoice as settled. */
	MarkInvoicePaid = 'MARK_INVOICE_PAID',
	/**
	 * Admin-only: mark a booked-but-unpaid SAMPLE invoice as settled.
	 *
	 * Its own key rather than a second MARK_INVOICE_PAID, because the two are different mutations
	 * against different invoices — a caller matching on paymentTransactionId alone would otherwise
	 * have no way to tell which one it holds. Both can be offered at once on an order whose
	 * products and samples were invoiced separately.
	 */
	MarkSampleInvoicePaid = 'MARK_SAMPLE_INVOICE_PAID',
	/** Samples and production in one payment, offered alongside PAY_SAMPLES as an alternative route rather than a later step. Calls createFullOrderPayment. */
	PayFullOrder = 'PAY_FULL_ORDER',
	PayProducts = 'PAY_PRODUCTS',
	PaySamples = 'PAY_SAMPLES',
	/** Admin-only: put produced goods on a shipment. Blocked, with a reason, while nothing has finished production or everything is already on one. */
	RecordShipment = 'RECORD_SHIPMENT',
}

export type OrderActivity = Base & {
	__typename?: 'OrderActivity';
	/** The raw stored value. Style timeline nodes off actionType instead — this stays String so an entry written by a newer service never fails to serialize here. */
	action: Scalars['String']['output'];
	/** action as a known kind, or null when this entry predates the list (or was written by a newer service). Falling back to a neutral node on null is the whole contract. */
	actionType?: Maybe<OrderActivityAction>;
	actorId?: Maybe<Scalars['ID']['output']>;
	actorRole?: Maybe<Scalars['String']['output']>;
	adminUser?: Maybe<AdminUserStub>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	message?: Maybe<Scalars['String']['output']>;
	metadata?: Maybe<Scalars['JSON']['output']>;
	orderId: Scalars['ID']['output'];
	organizationUser?: Maybe<OrganizationUserStub>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Every kind of entry an order timeline can carry. ITEM_* and SAMPLE_* name the status the thing
 * moved to, so they track OrderItemStatus and OrderSampleStatus.
 *
 * Payments are absent on purpose: settling an invoice writes no timeline entry today.
 */
export enum OrderActivityAction {
	ItemCancelled = 'ITEM_CANCELLED',
	ItemDelivered = 'ITEM_DELIVERED',
	ItemInProduction = 'ITEM_IN_PRODUCTION',
	ItemProductionCompleted = 'ITEM_PRODUCTION_COMPLETED',
	ItemShipped = 'ITEM_SHIPPED',
	OrderCancelled = 'ORDER_CANCELLED',
	OrderConfirmed = 'ORDER_CONFIRMED',
	OrderCreated = 'ORDER_CREATED',
	/** An admin corrected where the order ships. Metadata carries the address before and after. */
	OrderDeliveryAddressChanged = 'ORDER_DELIVERY_ADDRESS_CHANGED',
	SampleApproved = 'SAMPLE_APPROVED',
	SampleAwaitingApproval = 'SAMPLE_AWAITING_APPROVAL',
	SampleCancelled = 'SAMPLE_CANCELLED',
	SampleInProduction = 'SAMPLE_IN_PRODUCTION',
	SampleNewRoundApproved = 'SAMPLE_NEW_ROUND_APPROVED',
	SamplePaymentTreatmentChanged = 'SAMPLE_PAYMENT_TREATMENT_CHANGED',
	SampleProductionCompleted = 'SAMPLE_PRODUCTION_COMPLETED',
	SampleRejected = 'SAMPLE_REJECTED',
	SampleShipped = 'SAMPLE_SHIPPED',
	ShipmentCreated = 'SHIPMENT_CREATED',
	ShipmentUpdated = 'SHIPMENT_UPDATED',
}

export enum OrderAdjustmentCalculationType {
	Fixed = 'FIXED',
	Percentage = 'PERCENTAGE',
}

export enum OrderAdjustmentType {
	Discount = 'DISCOUNT',
	Fee = 'FEE',
}

/**
 * One thing this order is waiting to receive — a sample round, or a box of goods.
 *
 * The list is complete from the moment the order exists: every product is assigned to a shipment at
 * acceptance and every sample round is created there, so a delivery that has not started yet still
 * appears, with a state and a projected arrival, rather than being absent until it moves.
 *
 * One row per movement, never per product: a box carrying four things arrives once.
 */
export type OrderDelivery = {
	__typename?: 'OrderDelivery';
	/** When it actually arrived. Null until it has. */
	actualDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	carrier?: Maybe<Scalars['String']['output']>;
	/**
	 * Earliest and latest it can arrive. While projected is true these are a forecast — production
	 * plus transit in business days, anchored on the best fact available — and they move as the
	 * order does. Once something real exists (a carrier's date, an arrival) they state that instead.
	 * Null when the lead time was never agreed, which is the same no-window answer the quote gives.
	 */
	expectedEarliest?: Maybe<Scalars['DateTime']['output']>;
	expectedLatest?: Maybe<Scalars['DateTime']['output']>;
	/** The sample round's or shipment's own id. */
	id: Scalars['ID']['output'];
	/**
	 * Whether anything physically travels. False only for a virtual sample, which arrives as files:
	 * no carrier, no tracking, no dispatch, and nothing to follow. Render those differently —
	 * a row with a date and a state reads as a parcel unless it says otherwise.
	 */
	isPhysical: Scalars['Boolean']['output'];
	kind: OrderDeliveryKind;
	/** What is travelling. */
	lines: Array<OrderDeliveryLine>;
	/** True while the dates above are a forecast. Say so in the UI — a projection shown as a promise is one a client plans around. */
	projected: Scalars['Boolean']['output'];
	/**
	 * Server-worded name for the row, from what is in it: 'Keychain', 'Keychain and 2 more',
	 * 'Canvas Tote sample, round 2'. A product travelling in more than one box adds 'part 2 of 3',
	 * because which part it is says something the contents cannot.
	 *
	 * Falls back to 'Shipment 4' only for a box with nothing assigned to it yet.
	 */
	reference: Scalars['String']['output'];
	/** When it left. Always null on a virtual sample: submitting files is not a dispatch — see actualDeliveryDate for when it landed. */
	shippedAt?: Maybe<Scalars['DateTime']['output']>;
	shippingMethod?: Maybe<OrderShippingMethod>;
	shippingMethodLabel?: Maybe<Scalars['String']['output']>;
	state: OrderDeliveryState;
	/** The state worded for display. A virtual sample reads 'Submitted for review' where a box reads 'Delivered'. */
	stateLabel: Scalars['String']['output'];
	trackingNumber?: Maybe<Scalars['String']['output']>;
	/** A link to the carrier's tracking page, from the same carrier list shipments and samples use. Null when the carrier is unrecognised, has no tracking page, or nothing travels — never guessed, so show the number alone when this is null. */
	trackingUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * What KIND of thing is arriving. Wording differs: a virtual sample is submitted, not shipped, and
 * carries no carrier or tracking.
 */
export enum OrderDeliveryKind {
	/** A sample round travelling to the client. */
	Sample = 'SAMPLE',
	/** Goods, in one box. Carries however many products travel together. */
	Shipment = 'SHIPMENT',
	/** A sample round delivered as files rather than a box. */
	VirtualSample = 'VIRTUAL_SAMPLE',
}

/** One product travelling in a delivery. */
export type OrderDeliveryLine = {
	__typename?: 'OrderDeliveryLine';
	orderItemId: Scalars['ID']['output'];
	productName?: Maybe<Scalars['String']['output']>;
	/** Units of this product in this delivery. Always 1 for a sample. */
	quantity: Scalars['Int']['output'];
};

/**
 * Where one delivery stands, in the same words whether it is a sample or a box of goods.
 *
 * A shipment reports the state of what is INSIDE it until it moves: a pending box whose products
 * are being made reads IN_PRODUCTION, not "not started", and it is READY only when every product in
 * it is. A box is never further along than its slowest item.
 */
export enum OrderDeliveryState {
	/** Nothing has been made yet. */
	Awaiting = 'AWAITING',
	Cancelled = 'CANCELLED',
	/** With the client. For a virtual sample, submitted for review. */
	Delivered = 'DELIVERED',
	/** Being made. */
	InProduction = 'IN_PRODUCTION',
	/** On its way. */
	InTransit = 'IN_TRANSIT',
	/** Made, not yet sent. */
	Ready = 'READY',
}

export type OrderInput = {
	direction: OrderTypes;
	field: Scalars['String']['input'];
};

/** A single invoice recipient — an internal user (userId set) or an external email (email set). All recipients receive the invoice. */
export type OrderInvoiceRecipient = {
	__typename?: 'OrderInvoiceRecipient';
	/** External email address. Set when type = EMAIL. */
	email?: Maybe<Scalars['String']['output']>;
	/** Optional display name. */
	name?: Maybe<Scalars['String']['output']>;
	type: InvoiceRecipientType;
	/** Org-user id. Set when type = USER; resolved to the user's current email at payment time. */
	userId?: Maybe<Scalars['ID']['output']>;
};

export type OrderInvoiceRecipientInput = {
	/** External email address. Required when type = EMAIL. */
	email?: InputMaybe<Scalars['String']['input']>;
	/** Optional display name. */
	name?: InputMaybe<Scalars['String']['input']>;
	type: InvoiceRecipientType;
	/** Org-user id. Required when type = USER. */
	userId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderItem = Base & {
	__typename?: 'OrderItem';
	actualDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	adjustedTotalPrice?: Maybe<Scalars['Float']['output']>;
	adjustments?: Maybe<Array<OrderQuoteOfferAdjustment>>;
	attachments?: Maybe<Array<OrderItemAttachment>>;
	availableActions?: Maybe<Array<OrderItemNextAction>>;
	baseTotalPrice?: Maybe<Scalars['Float']['output']>;
	baseUnitPrice?: Maybe<Scalars['Float']['output']>;
	carrier?: Maybe<Scalars['String']['output']>;
	confirmedAt?: Maybe<Scalars['DateTime']['output']>;
	/** The supplier recorded AT confirmation. Null before it, and the value an audit should read — vetterEntityId above answers what it is now, this answers what was agreed. */
	confirmedVetterEntityId?: Maybe<Scalars['ID']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	/** How much of this item has arrived. Compare with quantity for the 100/500 reading. */
	deliveredQuantity?: Maybe<Scalars['Int']['output']>;
	delivery?: Maybe<OrderItemDelivery>;
	estimatedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	lifecycle?: Maybe<Array<OrderItemLifecycleStep>>;
	/**
	 * What this line contributes to the order: adjustedTotalPrice where the item carries
	 * adjustments, otherwise totalPrice. The figure the summary rail is built from, so a line total
	 * and the order total cannot disagree about whether adjustments count.
	 */
	lineTotal?: Maybe<Scalars['Float']['output']>;
	marginAmount?: Maybe<Scalars['Float']['output']>;
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	orderId: Scalars['ID']['output'];
	orderQuoteOfferId: Scalars['ID']['output'];
	orderQuoteOfferPricingId: Scalars['ID']['output'];
	paidAt?: Maybe<Scalars['DateTime']['output']>;
	productDescription?: Maybe<Scalars['String']['output']>;
	/** Unit dimensions as they stood on the accepted quote line. */
	productDimensions?: Maybe<OrderProductDimensions>;
	productId?: Maybe<Scalars['ID']['output']>;
	productImages?: Maybe<Array<OrderItemProductImage>>;
	productName?: Maybe<Scalars['String']['output']>;
	/** The product's SKU as it stood on the accepted quote line. Null on custom lines that never had a catalogue product. */
	productSku?: Maybe<Scalars['String']['output']>;
	/** Specifications as they stood on the quote line that was accepted. The line is locked once it has been ordered from, so nothing the catalogue does afterwards reaches this. */
	productSpecifications?: Maybe<OrderProductSpecifications>;
	/** When the quote line's product copy was taken. */
	productSpecificationsAt?: Maybe<Scalars['DateTime']['output']>;
	/** Unit weight as it stood on the accepted quote line. */
	productWeight?: Maybe<Scalars['Float']['output']>;
	productionCompletedAt?: Maybe<Scalars['DateTime']['output']>;
	productionStartedAt?: Maybe<Scalars['DateTime']['output']>;
	quantity: Scalars['Int']['output'];
	sampleChoice?: Maybe<OrderSampleChoice>;
	samples?: Maybe<Array<OrderItemSample>>;
	/**
	 * The boxes carrying this product, in order, each with how much of it they hold.
	 *
	 * This is what a product's delivery step should be built from. The flat carrier, trackingNumber
	 * and shippedAt fields above answer for the FIRST box only. A product the client split travels in
	 * several boxes; one shipped whole has exactly one.
	 *
	 * Each entry carries the shipment itself, so its own status, tracking and availableActions come
	 * with it — the action to ship part of a product belongs on the box, not on the product.
	 */
	shipments?: Maybe<Array<OrderItemShipment>>;
	shippedAt?: Maybe<Scalars['DateTime']['output']>;
	/** How much of this item has left, counted from its shipments. A status is one word for a quantity that can be in two places at once. */
	shippedQuantity?: Maybe<Scalars['Int']['output']>;
	sortOrder: Scalars['Int']['output'];
	status: OrderItemStatus;
	totalPrice?: Maybe<Scalars['Float']['output']>;
	trackingNumber?: Maybe<Scalars['String']['output']>;
	unitPrice?: Maybe<Scalars['Float']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	/**
	 * The supplier for this product: the one confirmed for it, falling back to the one chosen when
	 * its offer was priced. Read this when pre-selecting a supplier — confirmedVetterEntityId is
	 * null until confirmation, which is the step it would have helped with, so an admin was being
	 * asked to re-pick something the offer already recorded.
	 */
	vetterEntityId?: Maybe<Scalars['ID']['output']>;
	/** Who this product is waiting for right now — the actor of its current lifecycle step, said once so a card chip needs nothing else. Null when nothing is pending. */
	waitingOn?: Maybe<SampleActionActor>;
};

export type OrderItemAdjustedTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderItemBaseTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderItemBaseUnitPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderItemLineTotalArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderItemMarginAmountArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderItemTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderItemUnitPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export enum OrderItemActionType {
	ConfirmItem = 'CONFIRM_ITEM',
	/** Client: pay for this product on its own. Appears once its sample is settled — approved or cancelled — and blocked, with a reason, until then. Send its id to createOrderPayment. */
	PayProduct = 'PAY_PRODUCT',
	UpdateStatus = 'UPDATE_STATUS',
}

/** A file attached to an order item — snapshotted from the accepted offer's attachments. */
export type OrderItemAttachment = Base & {
	__typename?: 'OrderItemAttachment';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	/** What the file is, copied from the quote line's attachment at acceptance. */
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	mimeType: Scalars['String']['output'];
	name: Scalars['String']['output'];
	orderItemId: Scalars['ID']['output'];
	size: Scalars['Int']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	url: Scalars['String']['output'];
};

export type OrderItemDelivery = Base & {
	__typename?: 'OrderItemDelivery';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deliveryDaysMax: Scalars['Int']['output'];
	deliveryDaysMin: Scalars['Int']['output'];
	id: Scalars['ID']['output'];
	orderItemId: Scalars['ID']['output'];
	quantity: Scalars['Int']['output'];
	shippingMethod: OrderShippingMethod;
	/** The method worded for display. Backend-owned, like every other label here — branch on shippingMethod, render this. */
	shippingMethodLabel?: Maybe<Scalars['String']['output']>;
	totalPrice?: Maybe<Scalars['Float']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderItemDeliveryTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

/**
 * One step of a product's progress. The current step is the first one that is not finished — what
 * the item is WAITING ON, not the last thing that happened.
 */
export type OrderItemLifecycleStep = {
	__typename?: 'OrderItemLifecycleStep';
	/**
	 * Who the step is waiting for. Set on the CURRENT step only — a finished step is waiting for
	 * nobody and a future one has not been reached. This is the answer to "whose turn is it": no
	 * precedence rules, no reading actions to infer it.
	 */
	actor?: Maybe<SampleActionActor>;
	/** Actually DONE — never merely passed. Since production stopped waiting for payment, the marker can sit ahead of a step that is still open; that step reports outstanding, not completed. */
	completed: Scalars['Boolean']['output'];
	current: Scalars['Boolean']['output'];
	label: Scalars['String']['output'];
	/**
	 * Not done, and the item has moved past it anyway.
	 *
	 * A product made before its invoice is settled leaves PRODUCT_PAYMENT behind the marker and
	 * still owed: completed false, current false, outstanding true. Render it as an open step the
	 * item has overtaken — not a tick, not the step in progress — and the stepper agrees with the
	 * payment panel beside it instead of contradicting it.
	 *
	 * Mutually exclusive with completed and with current. Always false where a step has not been
	 * reached yet.
	 */
	outstanding: Scalars['Boolean']['output'];
	/** What is still owed or undone, worded for display. Null unless outstanding. */
	outstandingReason?: Maybe<Scalars['String']['output']>;
	/** The step does not apply to this item — no sample, or a sample that was never chargeable. Render it greyed out rather than ticked: nothing happened here and nothing will. */
	skipped: Scalars['Boolean']['output'];
	/** Why it was skipped, worded for display: no sample on this product, or a sample that costs nothing. Null when the step applies. A waived sample skips SAMPLE PAYMENT while SAMPLING still runs, which is what this exists to explain. */
	skippedReason?: Maybe<Scalars['String']['output']>;
	/** Branch on this, never on label — labels are copy and get reworded. */
	step: OrderItemLifecycleStepEnum;
};

/**
 * The stages a product passes through from acceptance to arrival, in order. Always all eight —
 * steps that do not apply to an item (no sample, a waived sample payment) come back marked
 * skipped rather than being left out, so every item in a list lines up column for column.
 */
export enum OrderItemLifecycleStepEnum {
	Accepted = 'ACCEPTED',
	Approval = 'APPROVAL',
	Delivered = 'DELIVERED',
	Delivery = 'DELIVERY',
	Production = 'PRODUCTION',
	ProductPayment = 'PRODUCT_PAYMENT',
	SamplePayment = 'SAMPLE_PAYMENT',
	Sampling = 'SAMPLING',
}

export type OrderItemNextAction = {
	__typename?: 'OrderItemNextAction';
	action: OrderItemActionType;
	actor: SampleActionActor;
	blocked?: Maybe<Scalars['Boolean']['output']>;
	blockedReason?: Maybe<Scalars['String']['output']>;
	displayType: ActionDisplayType;
	/** Whether this is the pending move, a property change, or an escape. Read this rather than inferring it from status. */
	kind: ActionKind;
	label: Scalars['String']['output'];
	optionalFields: Array<Scalars['String']['output']>;
	requiredFields: Array<Scalars['String']['output']>;
	status?: Maybe<OrderItemStatus>;
	/**
	 * A reason to hesitate, not a reason to refuse: the action WILL go through.
	 *
	 * Starting production before the money is in is a commercial risk the studio is allowed to
	 * take — sometimes the client is good for it and the factory slot is today. Blocking that put
	 * the software in charge of a judgement call it cannot make, so these say what is at stake and
	 * let a human decide. Show it on the confirm step; do not disable the button.
	 *
	 * Null when there is nothing to warn about. Distinct from blockedReason, which means the action
	 * cannot happen at all.
	 */
	warningReason?: Maybe<Scalars['String']['output']>;
};

export type OrderItemProductImage = {
	__typename?: 'OrderItemProductImage';
	altText?: Maybe<Scalars['String']['output']>;
	caption?: Maybe<Scalars['String']['output']>;
	/** Crop as it stood on the accepted quote line, so the order renders the image the way the client saw it. */
	crop?: Maybe<OrderProductImageCrop>;
	dimensions?: Maybe<OrderProductImageDimensions>;
	isPrimary?: Maybe<Scalars['Boolean']['output']>;
	sortOrder?: Maybe<Scalars['Int']['output']>;
	/** Signed, short-lived url for the order-owned copy. Do not store it. */
	url: Scalars['String']['output'];
};

export type OrderItemSample = Base & {
	__typename?: 'OrderItemSample';
	actualDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	approvalNotes?: Maybe<Scalars['String']['output']>;
	/** Approval */
	approvedAt?: Maybe<Scalars['DateTime']['output']>;
	approvedBy?: Maybe<Scalars['ID']['output']>;
	attachments?: Maybe<Array<OrderItemSampleAttachment>>;
	availableActions?: Maybe<Array<SampleNextAction>>;
	/** Snapshotted pricing */
	baseSamplePrice?: Maybe<Scalars['Float']['output']>;
	baseShippingPrice?: Maybe<Scalars['Float']['output']>;
	/** Free text, but write a ShippingCarrier code when the carrier is in the list — same vocabulary shipments use, and what makes trackingUrl resolve. getShippingCarriers is the picker. */
	carrier?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deliveryDaysMax?: Maybe<Scalars['Int']['output']>;
	deliveryDaysMin?: Maybe<Scalars['Int']['output']>;
	estimatedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	/**
	 * This round's own progress, in the same shape as an item's lifecycle. Six steps, always all
	 * six — what differs between a physical and a virtual sample is the DELIVERY step's label
	 * (shipped vs virtual delivery), not which steps exist.
	 *
	 * Scoped to this round: a rejected round stops at REVIEW and the next round starts again at
	 * PAYMENT. The item-level SAMPLING step is where 'are we still sampling at all' is answered.
	 */
	lifecycle?: Maybe<Array<OrderSampleLifecycleStep>>;
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	/** Production timeline */
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	notes?: Maybe<Scalars['String']['output']>;
	orderItemId: Scalars['ID']['output'];
	paidAt?: Maybe<Scalars['DateTime']['output']>;
	/** How this sample is paid for. Snapshotted from the offer at acceptance; an admin can change it until production is paid. */
	paymentTreatment: SamplePaymentTreatment;
	previousSampleId?: Maybe<Scalars['ID']['output']>;
	productionCompletedAt?: Maybe<Scalars['DateTime']['output']>;
	productionStartedAt?: Maybe<Scalars['DateTime']['output']>;
	/** Rejection */
	rejectedAt?: Maybe<Scalars['DateTime']['output']>;
	rejectedBy?: Maybe<Scalars['ID']['output']>;
	rejectionReason?: Maybe<Scalars['String']['output']>;
	requestNewSample?: Maybe<Scalars['Boolean']['output']>;
	sampleChoice: OrderSampleChoice;
	sampleRound: Scalars['Int']['output'];
	shippedAt?: Maybe<Scalars['DateTime']['output']>;
	status: OrderSampleStatus;
	totalPrice?: Maybe<Scalars['Float']['output']>;
	/** Physical delivery */
	trackingNumber?: Maybe<Scalars['String']['output']>;
	/** A link to the carrier's tracking page. Null when the carrier is unrecognised or has no tracking page — never guessed. */
	trackingUrl?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	virtualDeliveryNotes?: Maybe<Scalars['String']['output']>;
	/** Virtual delivery */
	virtualDeliverySubmittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderItemSampleBaseSamplePriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderItemSampleBaseShippingPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderItemSampleTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderItemSampleAttachment = Base & {
	__typename?: 'OrderItemSampleAttachment';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	mimeType: Scalars['String']['output'];
	name: Scalars['String']['output'];
	orderItemSampleId: Scalars['ID']['output'];
	size: Scalars['Int']['output'];
	type: OrderSampleAttachmentType;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	url: Scalars['String']['output'];
};

/**
 * One box carrying part of a product, from that product's point of view.
 *
 * The order flow shows a product's own story — made, then sent — and where the client picked a split
 * that story has more than one ending: 50 units leave in one box and 50 in another, days apart.
 * Without this the product row has nowhere to say so; its own carrier and tracking columns answer for
 * the first box only.
 *
 * So render one of these per row under the product's delivery step. A product that ships whole has
 * exactly one, which reads as the single delivery it has always been.
 */
export type OrderItemShipment = {
	__typename?: 'OrderItemShipment';
	/**
	 * How much of THIS product travels in this shipment.
	 *
	 * Usually the shipment's whole contents, since acceptance writes one shipment per product — but
	 * not always: an order accepted under a combination plan, or a shipment an admin created by
	 * hand, can carry several products at once.
	 */
	quantity: Scalars['Int']['output'];
	/**
	 * The shipment itself, with its own status, tracking, lifecycle and actions.
	 *
	 * Do not read a price off it here. Only one shipment per leg bears the agreed freight; the
	 * rest carry an empty price map and point at the bearer, so summing across a product's
	 * shipments says nothing about what shipping cost.
	 */
	shipment: OrderShipment;
};

export enum OrderItemStatus {
	Cancelled = 'CANCELLED',
	Delivered = 'DELIVERED',
	InProduction = 'IN_PRODUCTION',
	/** Some of this product has shipped but not all of it — it is split across shipments and only some have left. Without this, a client holding part of their order would read as not shipped. */
	PartiallyShipped = 'PARTIALLY_SHIPPED',
	Pending = 'PENDING',
	ProductionCompleted = 'PRODUCTION_COMPLETED',
	Shipped = 'SHIPPED',
}

export type OrderNextAction = {
	__typename?: 'OrderNextAction';
	action: OrderAction;
	actor: SampleActionActor;
	/**
	 * What this action would charge, VAT included, in the currency below. Set on the payment routes
	 * so two alternatives can be labelled with their price without running a preview for each; null
	 * on actions that charge nothing.
	 */
	amount?: Maybe<Scalars['Float']['output']>;
	blocked?: Maybe<Scalars['Boolean']['output']>;
	blockedReason?: Maybe<Scalars['String']['output']>;
	currency?: Maybe<CurrencyEnum>;
	displayType: ActionDisplayType;
	itemCount?: Maybe<Scalars['Int']['output']>;
	/** Whether this is the pending move, a property change, or an escape. Read this rather than inferring it from status. */
	kind: ActionKind;
	label: Scalars['String']['output'];
	/** Target of the action when it operates on a specific payment (e.g. MARK_INVOICE_PAID). */
	paymentTransactionId?: Maybe<Scalars['ID']['output']>;
	/**
	 * A reason to hesitate, not a reason to refuse: the action WILL go through.
	 *
	 * Starting production before the money is in is a commercial risk the studio is allowed to
	 * take — sometimes the client is good for it and the factory slot is today. Blocking that put
	 * the software in charge of a judgement call it cannot make, so these say what is at stake and
	 * let a human decide. Show it on the confirm step; do not disable the button.
	 *
	 * Null when there is nothing to warn about. Distinct from blockedReason, which means the action
	 * cannot happen at all.
	 */
	warningReason?: Maybe<Scalars['String']['output']>;
};

/** The stat cards on the orders overview page. */
export type OrderOverviewStats = {
	__typename?: 'OrderOverviewStats';
	/** Orders finished and delivered. */
	completed: Scalars['Int']['output'];
	/** Orders currently being produced. */
	inProduction: Scalars['Int']['output'];
	/** Orders whose shipping state is IN_TRANSIT. */
	inTransit: Scalars['Int']['output'];
	/** Orders with a shipment on the road past its estimated delivery date. */
	overdue: Scalars['Int']['output'];
	/** Orders not yet in production (awaiting confirmation/payment). */
	pending: Scalars['Int']['output'];
	/** Orders whose shipping state is READY_TO_SHIP — a box is made and waiting to be sent. */
	readyToShip: Scalars['Int']['output'];
	/** All orders in scope. */
	total: Scalars['Int']['output'];
};

export type OrderPage = {
	__typename?: 'OrderPage';
	data: Array<Order>;
	pageInfo: PageInfo;
};

export enum OrderPaymentMethod {
	Invoice = 'INVOICE',
	Stripe = 'STRIPE',
}

export type OrderPaymentMethodOption = {
	__typename?: 'OrderPaymentMethodOption';
	available: Scalars['Boolean']['output'];
	method: OrderPaymentMethod;
	reason?: Maybe<Scalars['String']['output']>;
};

/**
 * One payment a client can make on this order right now, priced and ready to render.
 *
 * The same facts live on the order's, the item's and the sample's actions — an action belongs on
 * the thing it acts on. This is the same state said once, flat, so a payments panel does not have to
 * walk three levels and price each row with its own preview.
 *
 * Three rules the rows themselves cannot show:
 *
 *   - Rows are ALTERNATIVES, not a checklist. Paying all samples and paying one sample overlap. The
 *     list is recomputed on every read, so after a payment the rest come back with new amounts —
 *     never adjust them yourself.
 *   - ONE INVOICE AT A TIME. The moment any payment is raised, every row disappears until it
 *     settles. That is why a panel goes empty, and it is not an error.
 *   - Amounts are gross, in the currency asked for. The real charge is settled at checkout with the
 *     method the client picks.
 *
 * They reconcile with paymentSummary: FULL_ORDER equals totalOutstandingAmount. The itemised rows
 * sum to it too, EXCEPT where one box carries several products — that shared freight rides with
 * whichever product is paid first, so those rows each include it.
 */
export type OrderPaymentOption = {
	__typename?: 'OrderPaymentOption';
	/** What this payment would charge if taken now, VAT included. */
	amount: Scalars['Float']['output'];
	/** A row that cannot be used yet stays in the list and says why, rather than disappearing. */
	blocked?: Maybe<Scalars['Boolean']['output']>;
	blockedReason?: Maybe<Scalars['String']['output']>;
	currency: CurrencyEnum;
	/** Stable key for rendering. Not an id of anything — use targetIds for that. */
	key: Scalars['ID']['output'];
	/** Server-worded label for the row. */
	label: Scalars['String']['output'];
	scope: OrderPaymentOptionScope;
	/** What to send to the mutation: sample ids, or order item ids. Empty on the order-wide rows. */
	targetIds: Array<Scalars['ID']['output']>;
};

/**
 * What a payment row pays for. The only thing to branch on, and it maps one-to-one to a mutation:
 *
 *   FULL_ORDER   → createFullOrderPayment
 *   ALL_SAMPLES  → createSamplePayment, no ids
 *   SAMPLE       → createSamplePayment with targetIds as sampleIds
 *   PRODUCT      → createOrderPayment with targetIds as orderItemIds
 */
export enum OrderPaymentOptionScope {
	AllSamples = 'ALL_SAMPLES',
	FullOrder = 'FULL_ORDER',
	Product = 'PRODUCT',
	Sample = 'SAMPLE',
}

export enum OrderPaymentStatus {
	Awaiting = 'AWAITING',
	/** There is nothing to pay. No samples were ordered, or every round was cancelled. Only ever returned for sampleStatus; an order always has products. */
	NotApplicable = 'NOT_APPLICABLE',
	Partial = 'PARTIAL',
	Settled = 'SETTLED',
	/** Someone declined to charge for it. A real decision — there was something to pay and it was written off. */
	Waived = 'WAIVED',
}

/**
 * What this order will be invoiced, what has been paid, and what is still owed.
 *
 * EVERY figure is GROSS — VAT included — and on the same basis as the invoices themselves: goods,
 * fees, discounts, freight and sample credits. totalAmount therefore equals summary { grossAmount },
 * so "outstanding" and "order total" answer the same question and a page can put them side by side.
 *
 * Freight has no bucket of its own. It is billed once, with the first invoice carrying the goods a
 * shipment moves, so it sits inside the two buckets that exist — order-level shipping in the product
 * bucket, sample freight in the sample bucket. A third bucket would describe an invoice nobody
 * raises.
 */
export type OrderPaymentSummary = {
	__typename?: 'OrderPaymentSummary';
	productOutstandingAmount: Scalars['Float']['output'];
	/** Paid products, with a shipment's freight counted once every product it carries is paid. */
	productPaidAmount: Scalars['Float']['output'];
	productStatus: OrderPaymentStatus;
	/** Products, fees, discounts, order-level freight and sample credits. Gross. */
	productTotalAmount: Scalars['Float']['output'];
	sampleOutstandingAmount: Scalars['Float']['output'];
	samplePaidAmount: Scalars['Float']['output'];
	sampleStatus: OrderPaymentStatus;
	/** The sample invoice in full: goods and their freight. A prepaid sample is billed here and credited back inside the product bucket. Gross. */
	sampleTotalAmount: Scalars['Float']['output'];
	/**
	 * Products and samples together — every invoice this order raises, and nothing else. Add nothing
	 * to these three yourself: if a third kind of payment ever appears it lands here, and a client
	 * adding the two buckets by hand would silently stop reporting the total.
	 */
	totalAmount: Scalars['Float']['output'];
	totalOutstandingAmount: Scalars['Float']['output'];
	totalPaidAmount: Scalars['Float']['output'];
	/** The VAT rate applied to every figure here, for a page that wants to say 'incl. VAT'. */
	vatRate: Scalars['Float']['output'];
};

export type OrderProductColorSpec = {
	__typename?: 'OrderProductColorSpec';
	appliesTo?: Maybe<Scalars['String']['output']>;
	code?: Maybe<Scalars['String']['output']>;
	finish?: Maybe<Scalars['String']['output']>;
	isPrimary?: Maybe<Scalars['Boolean']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	pantone?: Maybe<Scalars['String']['output']>;
};

export type OrderProductCustomSpec = {
	__typename?: 'OrderProductCustomSpec';
	group?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	label: Scalars['String']['output'];
	sortOrder?: Maybe<Scalars['Int']['output']>;
	unit?: Maybe<Scalars['String']['output']>;
	value: Scalars['String']['output'];
};

export type OrderProductDecoration = {
	__typename?: 'OrderProductDecoration';
	area?: Maybe<OrderProductPrintArea>;
	/** Artwork reference. On an order this points at an order-owned copy, so it survives the product being deleted. On a quote line it still points at the product's file. */
	artworkUrl?: Maybe<Scalars['String']['output']>;
	colorCount?: Maybe<Scalars['Int']['output']>;
	colors?: Maybe<Array<OrderProductColorSpec>>;
	id: Scalars['ID']['output'];
	method: OrderProductDecorationMethod;
	methodNote?: Maybe<Scalars['String']['output']>;
	notes?: Maybe<Scalars['String']['output']>;
	placement?: Maybe<Scalars['String']['output']>;
	sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** Mirrors ProductDecorationMethod. Kept separate so retiring a method on the product cannot rewrite history on a quote. */
export enum OrderProductDecorationMethod {
	Debossing = 'DEBOSSING',
	DigitalPrint = 'DIGITAL_PRINT',
	Doming = 'DOMING',
	Dtg = 'DTG',
	Embossing = 'EMBOSSING',
	Embroidery = 'EMBROIDERY',
	Engraving = 'ENGRAVING',
	HeatTransfer = 'HEAT_TRANSFER',
	HotFoil = 'HOT_FOIL',
	LaserEngraving = 'LASER_ENGRAVING',
	Other = 'OTHER',
	PadPrint = 'PAD_PRINT',
	ScreenPrint = 'SCREEN_PRINT',
	Sticker = 'STICKER',
	Sublimation = 'SUBLIMATION',
	UvPrint = 'UV_PRINT',
	WovenLabel = 'WOVEN_LABEL',
}

export type OrderProductDimensions = {
	__typename?: 'OrderProductDimensions';
	height?: Maybe<Scalars['Float']['output']>;
	length?: Maybe<Scalars['Float']['output']>;
	unit: Scalars['String']['output'];
	width?: Maybe<Scalars['Float']['output']>;
};

/** Non-destructive crop applied at display time, copied from the catalogue so the quote renders the image the way the product page does. Null means show the full image. */
export type OrderProductImageCrop = {
	__typename?: 'OrderProductImageCrop';
	/** Target aspect ratio, expressed as width:height (for example 1:1). */
	aspectRatio?: Maybe<Scalars['String']['output']>;
	height: Scalars['Float']['output'];
	rotation?: Maybe<Scalars['Float']['output']>;
	/** Unit of x/y/width/height, PX or PERCENT. Defaults to PERCENT. */
	unit?: Maybe<Scalars['String']['output']>;
	width: Scalars['Float']['output'];
	x: Scalars['Float']['output'];
	y: Scalars['Float']['output'];
	zoom?: Maybe<Scalars['Float']['output']>;
};

export type OrderProductImageDimensions = {
	__typename?: 'OrderProductImageDimensions';
	aspectRatio?: Maybe<Scalars['String']['output']>;
	height?: Maybe<Scalars['Int']['output']>;
	width?: Maybe<Scalars['Int']['output']>;
};

export type OrderProductMeasure = {
	__typename?: 'OrderProductMeasure';
	unit: Scalars['String']['output'];
	value: Scalars['Float']['output'];
};

export type OrderProductPackaging = {
	__typename?: 'OrderProductPackaging';
	dimensions?: Maybe<OrderProductDimensions>;
	notes?: Maybe<Scalars['String']['output']>;
	type?: Maybe<Scalars['String']['output']>;
	weight?: Maybe<Scalars['Float']['output']>;
	weightUnit?: Maybe<Scalars['String']['output']>;
};

export type OrderProductPrintArea = {
	__typename?: 'OrderProductPrintArea';
	height?: Maybe<Scalars['Float']['output']>;
	unit: Scalars['String']['output'];
	width?: Maybe<Scalars['Float']['output']>;
};

/**
 * A frozen copy of a product's specifications, held by the order service.
 *
 * Deliberately a separate type from the product service's ProductSpecifications:
 * this one records what was quoted and never moves, while the product's own keeps
 * changing. Same shape today, free to diverge later.
 */
export type OrderProductSpecifications = {
	__typename?: 'OrderProductSpecifications';
	capacity?: Maybe<OrderProductMeasure>;
	colors?: Maybe<Array<OrderProductColorSpec>>;
	custom?: Maybe<Array<OrderProductCustomSpec>>;
	decorations?: Maybe<Array<OrderProductDecoration>>;
	features?: Maybe<Array<Scalars['String']['output']>>;
	finish?: Maybe<Scalars['String']['output']>;
	material?: Maybe<Scalars['String']['output']>;
	packaging?: Maybe<OrderProductPackaging>;
	secondaryMaterials?: Maybe<Array<Scalars['String']['output']>>;
	textureDescription?: Maybe<Scalars['String']['output']>;
};

export type OrderQuote = Base & {
	__typename?: 'OrderQuote';
	adminUserIds?: Maybe<Array<Scalars['ID']['output']>>;
	adminUsers?: Maybe<Array<AdminUser>>;
	/**
	 * organizationUser ids nominated to hear about this quote. Empty means everyone at the client
	 * organisation. Guest-link holders are emailed either way. Admin-only: empty for anyone else.
	 */
	clientContactUserIds: Array<Scalars['ID']['output']>;
	/** Client-side viewing sessions. Repeat views inside a short window count once. For every viewer including admins, use getOrderQuoteViewSummary. */
	clientViewCount: Scalars['Int']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deadline?: Maybe<Scalars['DateTime']['output']>;
	deliveryAddress?: Maybe<OrderQuoteAddress>;
	description?: Maybe<Scalars['String']['output']>;
	/** First time the client side opened this quote — a logged-in client user or a guest-link viewer. Admin views never count here. Null if they have never opened it. */
	firstClientViewedAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	invoiceMinimum?: Maybe<Scalars['Float']['output']>;
	items: Array<OrderQuoteItem>;
	/** Most recent client-side view. Use this for a ‘not yet opened’ badge; it is never stamped by an admin looking at the quote. */
	lastClientViewedAt?: Maybe<Scalars['DateTime']['output']>;
	lifecycle?: Maybe<Array<OrderQuoteLifecycleStep>>;
	name: Scalars['String']['output'];
	offerBatchCount: Scalars['Int']['output'];
	offerRequestedAt?: Maybe<Scalars['DateTime']['output']>;
	organization?: Maybe<Organization>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	/** When the payment settings were last snapshotted/overridden. Null on legacy quotes (order then falls back to the org). */
	paymentSettingsSnapshotAt?: Maybe<Scalars['DateTime']['output']>;
	/** Set while status is PENDING_REVIEW: the selections a client accepted after the deadline, awaiting admin re-confirmation. Null otherwise. */
	pendingAcceptance?: Maybe<Scalars['JSON']['output']>;
	productPaymentMode?: Maybe<PaymentModeEnum>;
	purpose?: Maybe<OrderQuotePurpose>;
	purposeOther?: Maybe<Scalars['String']['output']>;
	requestItems: Array<OrderQuoteRequestItem>;
	samplePaymentMode?: Maybe<PaymentModeEnum>;
	status: OrderQuoteStatus;
	/** Payment settings snapshotted from the org at quote creation, admin-overridable via setQuotePaymentSettings. The order copies these at acceptance. */
	stripeCheckoutLimit?: Maybe<Scalars['Float']['output']>;
	/** Audit history of post-deadline acceptances superseded by an admin revision (what was accepted, when, missed deadline, who revised). Appended each revise round. */
	supersededAcceptances?: Maybe<Scalars['JSON']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	vetterEntities?: Maybe<Array<VetterEntity>>;
	vetterEntityIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type OrderQuoteActivity = Base & {
	__typename?: 'OrderQuoteActivity';
	action: Scalars['String']['output'];
	actorId?: Maybe<Scalars['ID']['output']>;
	actorRole?: Maybe<Scalars['String']['output']>;
	adminUser?: Maybe<AdminUserStub>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	entityId?: Maybe<Scalars['ID']['output']>;
	entityType?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	message?: Maybe<Scalars['String']['output']>;
	metadata?: Maybe<Scalars['JSON']['output']>;
	orderQuoteId: Scalars['ID']['output'];
	organizationUser?: Maybe<OrganizationUserStub>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderQuoteAddress = {
	__typename?: 'OrderQuoteAddress';
	addressLine1?: Maybe<Scalars['String']['output']>;
	addressLine2?: Maybe<Scalars['String']['output']>;
	city?: Maybe<Scalars['String']['output']>;
	countryCode?: Maybe<Scalars['String']['output']>;
	googlePlaceId?: Maybe<Scalars['String']['output']>;
	latitude?: Maybe<Scalars['Float']['output']>;
	longitude?: Maybe<Scalars['Float']['output']>;
	postalCode?: Maybe<Scalars['String']['output']>;
	stateCode?: Maybe<Scalars['String']['output']>;
};

export type OrderQuoteAddressInput = {
	addressLine1?: InputMaybe<Scalars['String']['input']>;
	addressLine2?: InputMaybe<Scalars['String']['input']>;
	city?: InputMaybe<Scalars['String']['input']>;
	countryCode?: InputMaybe<Scalars['String']['input']>;
	googlePlaceId?: InputMaybe<Scalars['String']['input']>;
	latitude?: InputMaybe<Scalars['Float']['input']>;
	longitude?: InputMaybe<Scalars['Float']['input']>;
	postalCode?: InputMaybe<Scalars['String']['input']>;
	stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type OrderQuoteGuestAcceptanceLinkResponse = {
	__typename?: 'OrderQuoteGuestAcceptanceLinkResponse';
	email?: Maybe<Scalars['String']['output']>;
	/** The full link URL, so the admin can also copy/share it manually. Null on failure. */
	link?: Maybe<Scalars['String']['output']>;
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
};

export type OrderQuoteGuestAccessToken = {
	__typename?: 'OrderQuoteGuestAccessToken';
	acceptedAt?: Maybe<Scalars['DateTime']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	email: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	/** The full acceptance link URL (embeds the token), so an admin can copy/re-share it any time — not just at creation. */
	link: Scalars['String']['output'];
	orderQuoteId: Scalars['ID']['output'];
	revokedAt?: Maybe<Scalars['DateTime']['output']>;
	status: OrderQuoteGuestAccessTokenStatus;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum OrderQuoteGuestAccessTokenStatus {
	Accepted = 'ACCEPTED',
	Active = 'ACTIVE',
	Revoked = 'REVOKED',
}

export type OrderQuoteGuestPreviewLinkResponse = {
	__typename?: 'OrderQuoteGuestPreviewLinkResponse';
	/** The plus-addressed staff identity the preview runs as, e.g. someone+preview-ab12cd34 at the staff domain. Null on failure. */
	email?: Maybe<Scalars['String']['output']>;
	/** When the link stops being redeemable. The session it mints outlives it; this is only the window to click it. Null on failure. */
	expiresAt?: Maybe<Scalars['DateTime']['output']>;
	/** Open this in a new tab to land in the guest view. Single-use — mint a new one for each preview. Null on failure. */
	link?: Maybe<Scalars['String']['output']>;
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
};

export type OrderQuoteItem = Base & {
	__typename?: 'OrderQuoteItem';
	/** Files for this product — artwork, mock-ups, tech packs. Uploaded once here and shown on every offer made for this product, in every batch. Admin-only: a client reads the same files through ClientOrderQuoteOffer.attachments, which only exposes batches already sent to them, and gets an empty list here. */
	attachments: Array<OrderQuoteItemAttachment>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deadline?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	orderQuoteId: Scalars['ID']['output'];
	productDescription?: Maybe<Scalars['String']['output']>;
	productDimensions?: Maybe<OrderProductDimensions>;
	productId: Scalars['ID']['output'];
	/** Quote-owned copies of the product's images. Urls are signed and short-lived; do not store them. */
	productImages?: Maybe<Array<OrderQuoteItemProductImage>>;
	/**
	 * The product as it stood when it was added to this quote. Everything prefixed productX is a
	 * frozen copy — editing or deleting the catalogue product does not change it, and the images
	 * are quote-owned copies of the files, not links into the product's storage. Read these on
	 * anything that has to state what was quoted. Only refreshOrderQuoteItemProductSnapshot moves them.
	 */
	productName?: Maybe<Scalars['String']['output']>;
	productSku?: Maybe<Scalars['String']['output']>;
	/** Null means no specifications were recorded on the product when the copy was taken. */
	productSpecifications?: Maybe<OrderProductSpecifications>;
	/**
	 * When the snapshot was taken — the whole snapshot, not just specifications. Null means this
	 * line predates snapshotting and its product fields may be empty; that is the only case where
	 * the live catalogue is worth consulting.
	 */
	productSpecificationsAt?: Maybe<Scalars['DateTime']['output']>;
	productWeight?: Maybe<Scalars['Float']['output']>;
	quantities: Array<OrderQuoteItemQuantity>;
	sortOrder: Scalars['Int']['output'];
	/** Unified deadline badge: the countdown merged with best-achievable feasibility across this item's offers. Color the badge on timelineStatus.level. */
	timelineStatus: TimelineStatus;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderQuoteItemAttachment = Base & {
	__typename?: 'OrderQuoteItemAttachment';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	/** What the file is and why it is here — which placement the artwork is for, what a spec sheet covers, that it replaces an earlier version. Null on files uploaded without one. */
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	mimeType: Scalars['String']['output'];
	name: Scalars['String']['output'];
	orderQuoteItemId: Scalars['ID']['output'];
	size: Scalars['Int']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	url: Scalars['String']['output'];
};

export type OrderQuoteItemAttachmentUploadResponse = {
	__typename?: 'OrderQuoteItemAttachmentUploadResponse';
	blobUrl?: Maybe<Scalars['String']['output']>;
	expiresAt?: Maybe<Scalars['DateTime']['output']>;
	fileId?: Maybe<Scalars['ID']['output']>;
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
	uploadUrl: Scalars['String']['output'];
};

export type OrderQuoteItemProductImage = {
	__typename?: 'OrderQuoteItemProductImage';
	altText?: Maybe<Scalars['String']['output']>;
	caption?: Maybe<Scalars['String']['output']>;
	crop?: Maybe<OrderProductImageCrop>;
	dimensions?: Maybe<OrderProductImageDimensions>;
	isPrimary?: Maybe<Scalars['Boolean']['output']>;
	sortOrder?: Maybe<Scalars['Int']['output']>;
	/** Signed, short-lived url for the quote-owned copy. Do not store it. */
	url: Scalars['String']['output'];
};

export type OrderQuoteItemQuantity = Base & {
	__typename?: 'OrderQuoteItemQuantity';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	orderQuoteItemId: Scalars['ID']['output'];
	quantity: Scalars['Int']['output'];
	sortOrder: Scalars['Int']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderQuoteItemQuantityChange = {
	__typename?: 'OrderQuoteItemQuantityChange';
	/** Value today. Null for ADDED. */
	currentQuantity?: Maybe<Scalars['Int']['output']>;
	impact: OrderQuoteItemQuantityImpact;
	/** Machine-readable reason, for icons and grouping. */
	key: Scalars['String']['output'];
	kind: OrderQuoteItemQuantityChangeKind;
	/** Ready-to-display, translated. Render it directly. */
	message: Scalars['String']['output'];
	/** Value afterwards. Null for REMOVED. */
	newQuantity?: Maybe<Scalars['Int']['output']>;
	/** The tier this is about. Null for ADDED, which has no row yet. */
	orderQuoteItemQuantityId?: Maybe<Scalars['ID']['output']>;
	severity: OrderQuoteItemQuantityChangeSeverity;
};

export type OrderQuoteItemQuantityChangeError = {
	__typename?: 'OrderQuoteItemQuantityChangeError';
	key: Scalars['String']['output'];
	message: Scalars['String']['output'];
};

/** What the payload does to one tier. */
export enum OrderQuoteItemQuantityChangeKind {
	/** A tier that does not exist yet. It starts with no pricing and no delivery options. */
	Added = 'ADDED',
	/** A tier the payload leaves out. It is deleted, and every price and delivery option on it goes with it. */
	Removed = 'REMOVED',
	/** Same tier and value, different position in the list. */
	Reordered = 'REORDERED',
	/** Same tier, new value. Its pricing and delivery options stay attached and totals are recomputed for the new volume. */
	Repriced = 'REPRICED',
	/** Same tier, same value, same position. */
	Unchanged = 'UNCHANGED',
}

export type OrderQuoteItemQuantityChangePreview = {
	__typename?: 'OrderQuoteItemQuantityChangePreview';
	/** False when the payload would be refused. Check this before offering the change at all — errors explain why. */
	accepted: Scalars['Boolean']['output'];
	/** One entry per tier involved, existing and new alike, in the order the payload lists them, with removals last. */
	changes: Array<OrderQuoteItemQuantityChange>;
	/** Why the payload would be refused. Same refusals updateOrderQuoteItem applies, so a clean preview means the mutation will not reject it. */
	errors: Array<OrderQuoteItemQuantityChangeError>;
	/** Loudest severity across every change. Drives how hard the confirmation should be. */
	severity: OrderQuoteItemQuantityChangeSeverity;
};

/** How much is at stake. The frontend colors on this and never works out the stakes itself. */
export enum OrderQuoteItemQuantityChangeSeverity {
	/** Priced work would be destroyed, or a client is already looking at it. */
	Destructive = 'DESTRUCTIVE',
	/** Nothing priced is touched. */
	None = 'NONE',
	/** Priced work is kept, but delivery prices and production days were quoted against the old volume and want a second look. */
	Review = 'REVIEW',
}

/** What is attached to a tier today, and therefore what the change puts at risk. All counts are of live rows. */
export type OrderQuoteItemQuantityImpact = {
	__typename?: 'OrderQuoteItemQuantityImpact';
	/** Clients whose saved combination points at this tier. */
	clientSelectionCount: Scalars['Int']['output'];
	/** Of the offers above, how many sit in a batch the client can already see. */
	clientVisibleOfferCount: Scalars['Int']['output'];
	/** Delivery options across those offers. */
	deliveryOptionCount: Scalars['Int']['output'];
	/** Clients whose committed combination — the one a quote PDF was generated for — points at this tier. The most expensive kind to disturb. */
	masterSelectionCount: Scalars['Int']['output'];
	offers: Array<OrderQuoteItemQuantityImpactOffer>;
	/** Offers carrying a price for this tier. */
	pricedOfferCount: Scalars['Int']['output'];
};

/** An offer that has priced the tier in question. */
export type OrderQuoteItemQuantityImpactOffer = {
	__typename?: 'OrderQuoteItemQuantityImpactOffer';
	batchName: Scalars['String']['output'];
	batchStatus: OrderQuoteOfferStatus;
	/** True once the batch has left draft, i.e. a client can see this price. */
	isVisibleToClient: Scalars['Boolean']['output'];
	offerName: Scalars['String']['output'];
	orderQuoteOfferBatchId: Scalars['ID']['output'];
	orderQuoteOfferId: Scalars['ID']['output'];
};

export type OrderQuoteItemQuantityInput = {
	/** Id of the tier this entry is. Provide it to edit an existing tier in place, keeping its pricing and delivery options attached. Omit it for a brand-new tier, which starts with no pricing. Editing a value with the id omitted, and leaving the old tier out of the list, is how you deliberately start over: the old tier and everything priced on it are removed. */
	id?: InputMaybe<Scalars['ID']['input']>;
	quantity: Scalars['Int']['input'];
};

export type OrderQuoteLifecycleStep = {
	__typename?: 'OrderQuoteLifecycleStep';
	completed: Scalars['Boolean']['output'];
	current: Scalars['Boolean']['output'];
	label: Scalars['String']['output'];
	/** Branch on this, never on label — labels are copy and get reworded. */
	step: OrderQuoteLifecycleStepEnum;
};

/**
 * The stages a quote passes through. REQUESTED only appears on client-requested quotes — an
 * admin-created quote goes straight CREATED -> OFFERED and never surfaces it, so branch on the
 * steps you are given rather than assuming a fixed list.
 */
export enum OrderQuoteLifecycleStepEnum {
	Accepted = 'ACCEPTED',
	Created = 'CREATED',
	Offered = 'OFFERED',
	Ordered = 'ORDERED',
	Requested = 'REQUESTED',
}

export type OrderQuoteOffer = Base & {
	__typename?: 'OrderQuoteOffer';
	acceptedDeliveryId?: Maybe<Scalars['ID']['output']>;
	acceptedPricingId?: Maybe<Scalars['ID']['output']>;
	acceptedQuantity?: Maybe<Scalars['Int']['output']>;
	adjustments: Array<OrderQuoteOfferAdjustment>;
	/** The quote line's files, read-only here. Attachments belong to the product, so upload and delete them on OrderQuoteItem — every offer for that product shows the same list. */
	attachments: Array<OrderQuoteItemAttachment>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	orderQuoteItemId: Scalars['ID']['output'];
	orderQuoteOfferBatchId: Scalars['ID']['output'];
	pricing: Array<OrderQuoteOfferPricing>;
	rejectionReason?: Maybe<Scalars['String']['output']>;
	respondedAt?: Maybe<Scalars['DateTime']['output']>;
	sample?: Maybe<OrderQuoteOfferSample>;
	sortOrder?: Maybe<Scalars['Int']['output']>;
	status: OrderQuoteOfferStatus;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	vetterEntity?: Maybe<VetterEntity>;
	vetterEntityId?: Maybe<Scalars['ID']['output']>;
	vetterId?: Maybe<Scalars['ID']['output']>;
};

export type OrderQuoteOfferAdjustment = Base & {
	__typename?: 'OrderQuoteOfferAdjustment';
	calculationType: OrderAdjustmentCalculationType;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	orderQuoteOfferId: Scalars['ID']['output'];
	sortOrder: Scalars['Int']['output'];
	type: OrderAdjustmentType;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	value: Scalars['Float']['output'];
};

export type OrderQuoteOfferAdjustmentValueArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderQuoteOfferBatch = Base & {
	__typename?: 'OrderQuoteOfferBatch';
	acceptDeadline?: Maybe<Scalars['DateTime']['output']>;
	availableActions?: Maybe<Array<OrderQuoteOfferBatchNextAction>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	/**
	 * Margin on the same combination summary prices — amount, base and percentage, all final.
	 *
	 * ADMIN-ONLY: null for every other role, and absent from the client schema entirely.
	 *
	 * Takes only the arguments that change which TIERS are chosen. Margin lives on the product line
	 * alone, so a different shipping option, a different sample decision or a different VAT rate
	 * cannot move it — passing those would suggest otherwise. The arguments it does take must match
	 * the ones given to summary, or the two cards describe different combinations.
	 */
	margin?: Maybe<OrderQuoteOfferBatchMargin>;
	name: Scalars['String']['output'];
	offers: Array<OrderQuoteOffer>;
	orderQuoteId: Scalars['ID']['output'];
	rejectionReason?: Maybe<Scalars['String']['output']>;
	respondedAt?: Maybe<Scalars['DateTime']['output']>;
	sentToClientAt?: Maybe<Scalars['DateTime']['output']>;
	status: OrderQuoteOfferStatus;
	submittedAt?: Maybe<Scalars['DateTime']['output']>;
	summary?: Maybe<OrderQuoteOfferBatchSummary>;
	/** Unified accept-by badge: a countdown to acceptDeadline (neutral / amber-if-imminent / red-if-expired). Color the badge on timelineStatus.level. */
	timelineStatus: TimelineStatus;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderQuoteOfferBatchMarginArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
	includedOfferIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	selectedPricingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OrderQuoteOfferBatchSummaryArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
	includedOfferIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	selectedDeliveryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	selectedPricingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	selectedSampleChoices?: InputMaybe<Array<OfferSampleChoiceInput>>;
};

export enum OrderQuoteOfferBatchAction {
	AddProducts = 'ADD_PRODUCTS',
	Delete = 'DELETE',
	Duplicate = 'DUPLICATE',
	EditContent = 'EDIT_CONTENT',
	PreviewAsClient = 'PREVIEW_AS_CLIENT',
	Recall = 'RECALL',
	SendToClient = 'SEND_TO_CLIENT',
}

/**
 * Margin on one combination, ADMIN-ONLY — it is derived from the vetter cost basis and must never
 * reach a client. It lives here rather than on OrderQuoteOfferBatchSummary because that type is
 * served to clients too, by ClientOrderQuoteOfferBatch.summary.
 *
 * Every figure is final: amount, the base it is measured over, and the percentage between them.
 * Nothing here needs dividing, and nothing here should be divided by a total taken from the summary
 * card — see percentage.
 */
export type OrderQuoteOfferBatchMargin = {
	__typename?: 'OrderQuoteOfferBatchMargin';
	/**
	 * What this combination earns, ex-VAT: its chosen tiers' margins, PLUS fees, LESS discounts.
	 *
	 * An adjustment lands on the product line and carries no cost of its own, so it moves margin
	 * one-for-one — a discount equal to the tiers' margin leaves zero here. Counting the tiers alone
	 * reported an unmoved margin beside a discount that had just cancelled it.
	 */
	amount: Scalars['Float']['output'];
	/**
	 * The revenue amount is earned on: summary.productsSubtotal + feesTotal − discountsTotal, for the
	 * same selection — by construction, not by coincidence: both come from one pass over the same
	 * tiers and adjustments. Exposed so the percentage can be checked rather than being a division by
	 * an invisible number.
	 */
	base: Scalars['Float']['output'];
	/**
	 * What this combination costs us: base − amount. The other half of the same subtraction, stated
	 * so markupPercentage can be checked the way percentage can.
	 */
	cost: Scalars['Float']['output'];
	/** Currency every amount here is stated in — the resolved inCurrency. */
	currency: Scalars['String']['output'];
	/**
	 * amount ÷ cost × 100 — the markup on what we pay, as an admin authors it.
	 *
	 * This IS the percentage typed into the pricing modal, where nothing else has moved it: DKK
	 * 1,000 of margin on DKK 10,000 of cost is a markup of 10 and a margin of 9.09, one sale read
	 * two ways. Adjustments still move it — a discount costs us nothing and comes straight off the
	 * amount — so it matches the authored figure only on a combination with no fees or discounts.
	 *
	 * Zero when cost is zero or negative, for the reason percentage is.
	 */
	markupPercentage: Scalars['Float']['output'];
	/**
	 * amount ÷ base × 100 — margin as a share of the PRODUCT revenue actually charged.
	 *
	 * NOT amount ÷ subtotal and NOT amount ÷ grandTotal. Nothing records what delivery or a sample
	 * costs us — the admin fee that once stood in for it is gone — so neither earns a margin, and a
	 * denominator carrying their revenue shrinks the percentage every time shipping is added without
	 * the margin having moved. On DKK 1,000 of margin over DKK 11,000 of product with DKK 1,000 of
	 * delivery, this is 9.09; dividing by the DKK 12,000 subtotal would say 8.33.
	 *
	 * Zero when base is zero or negative: discounts exceeding the products leave a percentage that
	 * would report the wrong sign, and the amount beside it already says what happened.
	 *
	 * One thing it is NOT equal to: the percentage an admin typed into the pricing modal. That is a
	 * markup on cost (base cost × (1 + pct/100)), so an authored 10% on DKK 10,000 of cost surfaces
	 * here as 9.09% of the DKK 11,000 revenue — and any adjustment moves it further. Show this one
	 * beside revenue figures; show markupPercentage, the same number the tier is authored in, where an admin thinks in markup.
	 */
	percentage: Scalars['Float']['output'];
};

export type OrderQuoteOfferBatchNextAction = {
	__typename?: 'OrderQuoteOfferBatchNextAction';
	action: OrderQuoteOfferBatchAction;
	blocked?: Maybe<Scalars['Boolean']['output']>;
	blockedReason?: Maybe<Scalars['String']['output']>;
	displayType: ActionDisplayType;
	label: Scalars['String']['output'];
};

export type OrderQuoteOfferBatchSummary = {
	__typename?: 'OrderQuoteOfferBatchSummary';
	/** Shipping for the selected (or default) delivery option of each offer's chosen tier. */
	deliveryTotal: Scalars['Float']['output'];
	/** Per-discount breakdown (name + amount). Amounts sum to discountsTotal. */
	discounts: Array<OrderSummaryLineItem>;
	discountsTotal: Scalars['Float']['output'];
	/** Per-fee breakdown (name + amount). Amounts sum to feesTotal. */
	fees: Array<OrderSummaryLineItem>;
	feesTotal: Scalars['Float']['output'];
	/** Net total (ex-VAT). Sum of products + samples + sample shipping + delivery + fees - discounts. */
	grandTotal: Scalars['Float']['output'];
	/** grandTotal + vatAmount (incl. VAT). */
	grossAmount: Scalars['Float']['output'];
	productsSubtotal: Scalars['Float']['output'];
	/**
	 * The part of the up-front sample charge that comes back: the GOODS of every PREPAID sample,
	 * credited on the production invoice and therefore excluded from samplesTotal by definition. Their
	 * freight is not in here — it is never credited, and lives in samplesShippingTotal.
	 *
	 * Exposed so the card can say "1,000 charged up front, credited on production" rather than showing
	 * nothing and then asking for 1,200 at checkout. Deriving it as payNow − samplesTotal would
	 * subtract money across two queries that need not have been resolved against the same offer state.
	 *
	 * The three sample figures partition what is charged up front:
	 * samplesTotal + samplesShippingTotal + samplesPrepaidTotal.
	 */
	samplesPrepaidTotal: Scalars['Float']['output'];
	/**
	 * Freight on the samples in this combination, whatever their paymentTreatment. Charged up front
	 * with the sample and never credited back, so it is real order value on every treatment except
	 * WAIVED.
	 *
	 * Zero unless SAMPLE_WITH_SHIPPING was chosen — a virtual sample ships nothing. Separate from
	 * deliveryTotal, which is freight on the GOODS: the two move independently and a client who reads
	 * one number for both cannot check either.
	 */
	samplesShippingTotal: Scalars['Float']['output'];
	/**
	 * What the SAMPLES THEMSELVES cost this combination, freight excluded and already net of anything
	 * credited back. Mirrors OrderSummary.samplesTotal, which is what this becomes on acceptance; the
	 * two must agree.
	 *
	 * A sample is always billed up front; paymentTreatment decides how much of that is a cost and how
	 * much is merely early. A deductible (PREPAID) sample has its goods credited against the
	 * production invoice, so it contributes nothing here — see samplesPrepaidTotal. CHARGED counts in
	 * full. WAIVED is never charged.
	 *
	 * Sample freight is NOT in this figure. It is charged and never credited, so on a deductible
	 * sample it is the only amount left — and a Samples line whose entire content is shipping reads
	 * as an error. It has its own field, samplesShippingTotal, so the card can name it.
	 *
	 * So a PREPAID physical sample of 1,200 (1,000 goods + 200 freight) shows 0 here, 200 in
	 * samplesShippingTotal and 1,000 in samplesPrepaidTotal; the client is charged 1,200 up front
	 * either way.
	 *
	 * This is NOT what the client is invoiced for samples — that is the full amount, and it is the
	 * pay-now section of previewAcceptOffers. This line is order value.
	 *
	 * Answers to selectedSampleChoices; without that argument every authored sample is counted as if
	 * taken with shipping.
	 */
	samplesTotal: Scalars['Float']['output'];
	/**
	 * Tiers in this combination carrying a cost but no margin. They contribute NOTHING to
	 * productsSubtotal, and therefore nothing to vatAmount or grandTotal.
	 *
	 * Greater than zero means the combination is not fully priced and the totals below are light by
	 * however much those tiers would have added. Say so rather than showing the total as final —
	 * and note the batch cannot be sent while this is non-zero.
	 */
	unpricedTierCount: Scalars['Int']['output'];
	/** VAT (moms) on grandTotal, for display before the client accepts. */
	vatAmount: Scalars['Float']['output'];
	/** Applied VAT (moms) rate as a percentage, e.g. 25 or 0. */
	vatRate: Scalars['Float']['output'];
};

export type OrderQuoteOfferBatchValidationError = {
	__typename?: 'OrderQuoteOfferBatchValidationError';
	key: Scalars['String']['output'];
	message: Scalars['String']['output'];
};

export type OrderQuoteOfferBatchValidationResult = {
	__typename?: 'OrderQuoteOfferBatchValidationResult';
	/** The only hard requirement: true when at least one tier has both pricing and a delivery option. Gate the Send button on THIS — not on valid. */
	canSend: Scalars['Boolean']['output'];
	/** Hard blockers (currently only the no-pricing+delivery floor). Non-empty means canSend is false. */
	errors: Array<OrderQuoteOfferBatchValidationError>;
	/** True only when every tier on every offer is fully specified. Drives the 'all requirements met' all-clear state. Does NOT gate sending — everything advisory stays advisory. */
	valid: Scalars['Boolean']['output'];
	/**
	 * Advisory gaps in what the offer STATES — missing pricing, no delivery option, a method with no
	 * lead time, no margin, a split that no longer adds up.
	 *
	 * Deliberately not about whether a route meets the deadline: every delivery option already
	 * carries its own projectedDelivery and timelineStatus, computed from the same rules, and
	 * restating that here gave two sources for one verdict.
	 */
	warnings: Array<OrderQuoteOfferBatchValidationWarning>;
};

export type OrderQuoteOfferBatchValidationWarning = {
	__typename?: 'OrderQuoteOfferBatchValidationWarning';
	/** Set on the accept-after-deadline warning: the deadline the accept-by date was judged against (item deadline, else quote deadline). */
	deadline?: Maybe<Scalars['DateTime']['output']>;
	/** Set on warnings about one specific delivery option — a stale split, or a method with no lead time. */
	deliveryId?: Maybe<Scalars['ID']['output']>;
	/** Machine-readable gap type, e.g. send_order_quote_offer_batch_tier_missing_pricing. Use for grouping/icons. */
	key: Scalars['String']['output'];
	/** Ready-to-display, translated, gap-specific message. Render this directly — no assembly needed. */
	message: Scalars['String']['output'];
	offerId: Scalars['ID']['output'];
	offerName: Scalars['String']['output'];
	/** Null on offer-level warnings, which belong to no single tier. Set on every per-tier gap. */
	orderQuoteItemQuantityId?: Maybe<Scalars['ID']['output']>;
	quantity?: Maybe<Scalars['Int']['output']>;
	shippingMethod?: Maybe<OrderShippingMethod>;
};

export type OrderQuoteOfferDelivery = Base & {
	__typename?: 'OrderQuoteOfferDelivery';
	/** Studio only: when this price was taken from a supplier's quote — which one, when, and whether it has been edited since. Null when typed by hand. */
	appliedFrom?: Maybe<OfferPricingAppliedFrom>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deliveryDaysMax?: Maybe<Scalars['Int']['output']>;
	/** Null until the lead time is known. A method may be priced first and given its days later; nothing that quotes the client a date uses an option whose days are unset. */
	deliveryDaysMin?: Maybe<Scalars['Int']['output']>;
	id: Scalars['ID']['output'];
	/** True when this option is a split. Its method, price and lead time are derived from its parts. */
	isSplit: Scalars['Boolean']['output'];
	/**
	 * False when a split's legs no longer add up to the tier quantity — which happens when the tier
	 * is re-quantified, without the split being touched. Never offer an invalid split to a client;
	 * show it in the authoring UI as needing a re-split.
	 *
	 * Always true for a plain option.
	 */
	isValid: Scalars['Boolean']['output'];
	orderQuoteOfferPricingId: Scalars['ID']['output'];
	/**
	 * The legs of a split, in sequence order. Empty on a plain Standard/Express option.
	 *
	 * A part is never selectable on its own — the client picks the OPTION, and the parts are what
	 * they are agreeing to. Render them as the detail under the option, the way the authoring modal
	 * shows "20 Express - 80 Standard".
	 */
	parts: Array<OrderQuoteOfferDeliveryPart>;
	/** Projected arrival window. Null when production time isn't set on the tier, or when this option has no lead time yet. */
	projectedDelivery?: Maybe<ProjectedDeliveryWindow>;
	quantity: Scalars['Int']['output'];
	shippingMethod: OrderShippingMethod;
	/** Studio only: what the supplier quoted to ship this through their price request. Null for anyone else, or before they have priced it. */
	supplierCost?: Maybe<VetterDeliveryCost>;
	/** What the client pays for this option. One entered price — there is no cost/fee split any more. */
	totalPrice?: Maybe<Scalars['Float']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderQuoteOfferDeliveryTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

/**
 * One leg of a split: part of the tier's quantity, by its own method, at its own price and lead time.
 *
 * Parts belong to one product at one quantity tier and always sum to exactly that tier's quantity —
 * a split decides how the quantity ships, never how much is bought.
 */
export type OrderQuoteOfferDeliveryPart = Base & {
	__typename?: 'OrderQuoteOfferDeliveryPart';
	/** Studio only: when this price was taken from a supplier's quote — which one, when, and whether it has been edited since. Null when typed by hand. */
	appliedFrom?: Maybe<OfferPricingAppliedFrom>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deliveryDaysMax?: Maybe<Scalars['Int']['output']>;
	/** Null until this leg's lead time is known. A split with any days-less leg cannot be quoted to a client. */
	deliveryDaysMin?: Maybe<Scalars['Int']['output']>;
	id: Scalars['ID']['output'];
	orderQuoteOfferDeliveryId: Scalars['ID']['output'];
	/** Projected arrival for THIS leg. Null when the tier has no production time, or this leg has no lead time yet. */
	projectedDelivery?: Maybe<ProjectedDeliveryWindow>;
	/** How much of the tier's quantity travels in this leg. */
	quantity: Scalars['Int']['output'];
	/** 1-based position in the option, from the order the legs were entered in. */
	sequence: Scalars['Int']['output'];
	shippingMethod: OrderShippingMethod;
	/** Studio only: what the supplier quoted to ship this through their price request. Null for anyone else, or before they have priced it. */
	supplierCost?: Maybe<VetterDeliveryCost>;
	/** What the client pays for this leg. The option's price is the sum of its parts. */
	totalPrice?: Maybe<Scalars['Float']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * One leg of a split: part of the tier's quantity, by its own method, at its own price and lead time.
 *
 * Parts belong to one product at one quantity tier and always sum to exactly that tier's quantity —
 * a split decides how the quantity ships, never how much is bought.
 */
export type OrderQuoteOfferDeliveryPartTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

/** One leg being entered. Sequence comes from array order, not from the caller. */
export type OrderQuoteOfferDeliveryPartInput = {
	currency: Scalars['String']['input'];
	deliveryDaysMax?: InputMaybe<Scalars['Int']['input']>;
	/** Optional, and optional per leg — a split can be priced before the forwarder answers. Give both or neither. */
	deliveryDaysMin?: InputMaybe<Scalars['Int']['input']>;
	/** What the client pays for this leg, in the currency named below. */
	price: Scalars['Float']['input'];
	/** How much of the tier's quantity travels in this leg. Across all legs this must equal the tier quantity exactly. */
	quantity: Scalars['Int']['input'];
	shippingMethod: OrderShippingMethod;
};

export type OrderQuoteOfferPricing = Base & {
	__typename?: 'OrderQuoteOfferPricing';
	adjustedTotalPrice?: Maybe<Scalars['Float']['output']>;
	/** Studio only: the supplier price this tier's cost was taken from, if it was. Null for a cost typed by hand. */
	appliedFrom?: Maybe<OfferPricingAppliedFrom>;
	/** The currency this tier's base price was actually typed in. Null on tiers priced before it was recorded — unknown, not a default. */
	authoredCurrency?: Maybe<Scalars['String']['output']>;
	baseTotalPrice?: Maybe<Scalars['Float']['output']>;
	baseUnitPrice?: Maybe<Scalars['Float']['output']>;
	/**
	 * How this tier's cost compares with the catalogue today, why, and what can be done about it.
	 * Admin only. Null when the catalogue has no price for this tier, or the difference is under 2%.
	 * Pass inCurrency (the header currency) and every amount in the strings is in it.
	 *
	 * Render label as the badge and explanation (plus caveat) as its detail. Render actions as the
	 * buttons, exactly as they come: available, label, unavailableReason, and warning to confirm
	 * before calling applyCatalogPriceToOfferTier.
	 */
	catalogPriceDrift?: Maybe<CatalogPriceDrift>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deliveries: Array<OrderQuoteOfferDelivery>;
	id: Scalars['ID']['output'];
	/** Margin as authored, when it was authored as a fixed amount PER UNIT, in marginAmountCurrency. Null on a tier priced with a percentage. */
	marginAmount?: Maybe<Scalars['Float']['output']>;
	marginAmountCurrency?: Maybe<Scalars['String']['output']>;
	/**
	 * Profit as a share of REVENUE: marginUnit / unitPrice x 100. This is the figure e-conomic shows
	 * as Avance i % on a quote line, and it is what the Danish UI should label Avance.
	 *
	 * NOT markupPercentage, which divides the same profit by COST. Cost 100 sold at 110 is a 10%
	 * markup and a 9.09% margin.
	 *
	 * WARNING for anyone with an older query cached: a field of this name used to exist on this type
	 * holding the markup, before it was renamed to markupPercentage. Its meaning is now inverted.
	 * Null on a tier with no margin set, or a zero sale price.
	 */
	marginPercentage?: Maybe<Scalars['Float']['output']>;
	/** Margin on the whole tier: marginUnit × the tier's quantity. This is the figure to show beside totalPrice. */
	marginTotal?: Maybe<Scalars['Float']['output']>;
	/** Margin per unit, however it was authored. This is the raw stored figure — it does not change when the tier's quantity does. */
	marginUnit?: Maybe<Scalars['Float']['output']>;
	/**
	 * The markup on cost this tier was authored with, when it was authored as a percentage.
	 * price = cost x (1 + markup/100). Null on a tier priced with a fixed amount — use marginUnit
	 * or marginTotal, which are populated either way.
	 *
	 * Not the same figure as OrderSummary.marginPercentage, which divides the same profit by
	 * revenue instead: 25 here is 20 there. OrderSummary now returns both under their right names.
	 */
	markupPercentage?: Maybe<Scalars['Float']['output']>;
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	orderQuoteItemQuantityId: Scalars['ID']['output'];
	orderQuoteOfferId: Scalars['ID']['output'];
	totalPrice?: Maybe<Scalars['Float']['output']>;
	unitPrice?: Maybe<Scalars['Float']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderQuoteOfferPricingAdjustedTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderQuoteOfferPricingBaseTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderQuoteOfferPricingBaseUnitPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderQuoteOfferPricingCatalogPriceDriftArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderQuoteOfferPricingMarginTotalArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderQuoteOfferPricingMarginUnitArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderQuoteOfferPricingTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderQuoteOfferPricingUnitPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderQuoteOfferSample = Base & {
	__typename?: 'OrderQuoteOfferSample';
	actualDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	approvedAt?: Maybe<Scalars['DateTime']['output']>;
	approvedBy?: Maybe<Scalars['ID']['output']>;
	/** The currency the sample price was typed in. Null on samples priced before it was recorded — unknown, not a default. */
	authoredCurrency?: Maybe<Scalars['String']['output']>;
	/** What the client pays for the sample itself. One entered price — no cost/fee split. */
	baseSamplePrice?: Maybe<Scalars['Float']['output']>;
	/** Freight for the sample. Separate because a deductible sample credits the sample and never its freight. */
	baseShippingPrice?: Maybe<Scalars['Float']['output']>;
	carrier?: Maybe<Scalars['String']['output']>;
	/**
	 * How this sample's price compares with the catalogue today. Admin only. Null when the catalogue
	 * has no sample price, the sample is WAIVED, or the difference is under 2%. Pass the header
	 * currency as inCurrency.
	 */
	catalogPriceDrift?: Maybe<CatalogSamplePriceDrift>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deliveryDaysMax?: Maybe<Scalars['Int']['output']>;
	deliveryDaysMin?: Maybe<Scalars['Int']['output']>;
	estimatedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	notes?: Maybe<Scalars['String']['output']>;
	orderQuoteOfferId: Scalars['ID']['output'];
	/** How this sample is paid for. */
	paymentTreatment: SamplePaymentTreatment;
	/**
	 * One entry per sample choice, so the admin preview can price each tile from the same numbers the
	 * client is shown. Identical to ClientOrderQuoteOfferSample.pricesByChoice — the admin card
	 * renders the same three options and must not quote different figures for them.
	 */
	pricesByChoice: Array<ClientOrderQuoteOfferSamplePrice>;
	rejectedAt?: Maybe<Scalars['DateTime']['output']>;
	rejectionReason?: Maybe<Scalars['String']['output']>;
	requestedAt?: Maybe<Scalars['DateTime']['output']>;
	shippedAt?: Maybe<Scalars['DateTime']['output']>;
	status: OrderSampleStatus;
	totalPrice?: Maybe<Scalars['Float']['output']>;
	trackingNumber?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderQuoteOfferSampleBaseSamplePriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderQuoteOfferSampleBaseShippingPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderQuoteOfferSampleCatalogPriceDriftArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderQuoteOfferSamplePricesByChoiceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderQuoteOfferSampleTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export enum OrderQuoteOfferStatus {
	Accepted = 'ACCEPTED',
	Cancelled = 'CANCELLED',
	Draft = 'DRAFT',
	Expired = 'EXPIRED',
	Pending = 'PENDING',
	/** Batch carries a client's post-deadline acceptance awaiting admin re-confirmation. Distinct from PENDING (sent, awaiting client). */
	PendingReview = 'PENDING_REVIEW',
	Rejected = 'REJECTED',
	Submitted = 'SUBMITTED',
}

/** The 4 stat cards on the quotes overview page. */
export type OrderQuoteOverviewStats = {
	__typename?: 'OrderQuoteOverviewStats';
	/** Quotes accepted by the client. */
	accepted: Scalars['Int']['output'];
	/** Quotes awaiting action. */
	pending: Scalars['Int']['output'];
	/** Quotes rejected by the client. */
	rejected: Scalars['Int']['output'];
	/** All quotes in scope. */
	total: Scalars['Int']['output'];
};

export type OrderQuotePage = {
	__typename?: 'OrderQuotePage';
	data: Array<OrderQuote>;
	pageInfo: PageInfo;
};

/** A batch the client can already see that prices this product. */
export type OrderQuoteProductSyncBatch = {
	__typename?: 'OrderQuoteProductSyncBatch';
	batchName: Scalars['String']['output'];
	batchStatus: OrderQuoteOfferStatus;
	orderQuoteOfferBatchId: Scalars['ID']['output'];
};

/** One field a sync would move. */
export type OrderQuoteProductSyncFieldChange = {
	__typename?: 'OrderQuoteProductSyncFieldChange';
	/** Machine-readable field key, for icons and grouping: name, sku, description, weight, dimensions, images, specifications. */
	field: Scalars['String']['output'];
	/** Value today. Null where the line has nothing recorded. */
	from?: Maybe<Scalars['String']['output']>;
	/** Ready-to-display label. Render it directly. */
	label: Scalars['String']['output'];
	/** Value after the sync. Null where the catalogue has nothing. For images this is a count, and for specifications a marker, since both documents are too big to render as a from/to. */
	to?: Maybe<Scalars['String']['output']>;
};

/** What syncing one quote line would do to it. */
export enum OrderQuoteProductSyncKind {
	/** The catalogue has moved. See changes for what a sync would rewrite. */
	Changed = 'CHANGED',
	/** This line predates snapshotting and holds almost nothing. A sync fills it in from the catalogue as it stands today, which is the best available record, not the one that was quoted. */
	NeverSnapshotted = 'NEVER_SNAPSHOTTED',
	/** An order was accepted from this line, so its product copy is what the client bought and an order reads. Frozen for good: a sync skips it, and so do refresh and remove. */
	Sold = 'SOLD',
	/** The product cannot be read — deleted, or the product service is unreachable. The frozen copy is all there will ever be, and a sync skips this line. */
	Unavailable = 'UNAVAILABLE',
	/** The catalogue says exactly what the line already says. Syncing it is a no-op. */
	Unchanged = 'UNCHANGED',
}

export type OrderQuoteProductSyncLine = {
	__typename?: 'OrderQuoteProductSyncLine';
	/** Empty unless kind is CHANGED. */
	changes: Array<OrderQuoteProductSyncFieldChange>;
	/** Empty when no client can see this product yet. Non-empty is the whole reason severity is REVIEW. */
	clientVisibleBatches: Array<OrderQuoteProductSyncBatch>;
	kind: OrderQuoteProductSyncKind;
	/** Ready-to-display, translated. Render it directly. */
	message: Scalars['String']['output'];
	orderQuoteItemId: Scalars['ID']['output'];
	productId: Scalars['ID']['output'];
	/** The frozen name, for labelling the row. Null on a line that never captured one. */
	productName?: Maybe<Scalars['String']['output']>;
	severity: OrderQuoteProductSyncSeverity;
	/** When this line was last copied from the catalogue. Null means never. */
	snapshotAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderQuoteProductSyncPreview = {
	__typename?: 'OrderQuoteProductSyncPreview';
	/** Lines a sync would actually change. Zero means the quote already matches the catalogue. */
	changedCount: Scalars['Int']['output'];
	/** Every line on the quote, unchanged ones included, so the preview doubles as a per-product last-checked list. */
	lines: Array<OrderQuoteProductSyncLine>;
	/** Loudest severity across every line. Color the confirm action on this. */
	severity: OrderQuoteProductSyncSeverity;
	/** Lines whose product cannot be read. A sync skips these. */
	unavailableCount: Scalars['Int']['output'];
};

/** How loudly to warn. The frontend colors on this and never works out the stakes itself. */
export enum OrderQuoteProductSyncSeverity {
	/** Nothing a client can see is affected. */
	None = 'NONE',
	/** A client is already looking at a batch that prices this product, so a sync rewrites what they are reading. */
	Review = 'REVIEW',
}

export enum OrderQuotePurpose {
	Event = 'EVENT',
	NotSpecified = 'NOT_SPECIFIED',
	Other = 'OTHER',
	Packaging = 'PACKAGING',
	Resell = 'RESELL',
}

export type OrderQuoteRequestItem = Base & {
	__typename?: 'OrderQuoteRequestItem';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deadline?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	orderQuoteId: Scalars['ID']['output'];
	quantity?: Maybe<Scalars['Int']['output']>;
	sortOrder: Scalars['Int']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderQuoteStatsByStatus = {
	__typename?: 'OrderQuoteStatsByStatus';
	dateRange?: Maybe<DateRange>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	statusBreakdown: Array<OrderQuoteStatusBreakdown>;
	total: Scalars['Int']['output'];
	totalClients: Scalars['Int']['output'];
};

export enum OrderQuoteStatus {
	Accepted = 'ACCEPTED',
	Draft = 'DRAFT',
	Expired = 'EXPIRED',
	Pending = 'PENDING',
	/** Client accepted an offer after its acceptDeadline; captured and awaiting admin re-confirmation. Distinct from PENDING (sent, awaiting client). */
	PendingReview = 'PENDING_REVIEW',
	Rejected = 'REJECTED',
	Requested = 'REQUESTED',
	Submitted = 'SUBMITTED',
}

export type OrderQuoteStatusBreakdown = {
	__typename?: 'OrderQuoteStatusBreakdown';
	clientCount: Scalars['Int']['output'];
	count: Scalars['Int']['output'];
	percentage: Scalars['Float']['output'];
	status: OrderQuoteStatus;
};

/** One product's share of an OrderQuoteValuePoint: its chosen tier, without delivery or sample. */
export type OrderQuoteValueLine = {
	__typename?: 'OrderQuoteValueLine';
	name: Scalars['String']['output'];
	/** The quote line this offer prices — stable across batches, so low and high can be lined up by it. */
	orderQuoteItemId: Scalars['ID']['output'];
	orderQuoteOfferId: Scalars['ID']['output'];
	/** productTotal + fees − discounts on this tier, net, ex-VAT. Delivery and sample excluded. */
	productsTotal: Scalars['Float']['output'];
	/** The quantity of the chosen tier. */
	quantity: Scalars['Int']['output'];
};

export type OrderQuoteValuePoint = {
	__typename?: 'OrderQuoteValuePoint';
	/** marginBase less marginAmount — what this combination costs us. */
	cost: Scalars['Float']['output'];
	/** Freight on the goods, each offer at its default delivery option. Same basis as OrderQuoteOfferBatchSummary.deliveryTotal. */
	deliveryTotal: Scalars['Float']['output'];
	/** Discounts on this combination, as a positive amount. Same basis as OrderQuoteOfferBatchSummary.discountsTotal. */
	discountsTotal: Scalars['Float']['output'];
	/** Fees on this combination. Same basis as OrderQuoteOfferBatchSummary.feesTotal. */
	feesTotal: Scalars['Float']['output'];
	/** total + vatAmount (incl. VAT). */
	grossAmount: Scalars['Float']['output'];
	/**
	 * Every product in this combination at the tier it was given, in the batch's order. The point
	 * assumes the client takes ALL of them; a client may take any subset, and these lines say what
	 * each one is worth on its own. They add up to productsTotal.
	 */
	lines: Array<OrderQuoteValueLine>;
	/**
	 * Margin on this combination: what its chosen tiers earn, plus fees, less discounts. An
	 * adjustment carries no cost of its own, so it moves margin one-for-one — a discount equal to the
	 * tiers' margin leaves zero here.
	 */
	marginAmount: Scalars['Float']['output'];
	/**
	 * The revenue marginAmount is earned on: productsSubtotal + fees − discounts. Exposed so the
	 * percentage can be checked rather than taken on trust.
	 */
	marginBase: Scalars['Float']['output'];
	/**
	 * marginAmount ÷ marginBase, as a percentage — margin as a share of the PRODUCT revenue actually
	 * charged, the same basis as OrderQuoteOfferBatchMargin.percentage, so the two cards agree.
	 *
	 * NOT marginAmount ÷ total: nothing records what delivery or a sample costs us, so neither earns
	 * a margin, and putting their revenue in the denominator would shrink the percentage every time
	 * shipping was added without the margin having moved. That is why marginBase is exposed beside
	 * it — a reader who divides marginAmount by total will get a different number, so the card should
	 * name the base it is measured on.
	 *
	 * Also not the percentage typed into the pricing modal: an authored percentage is a markup on
	 * cost, so an authored 10% on 10,000 of cost reads as 9.09% of the 11,000 of revenue here — and
	 * any fee or discount moves it further.
	 */
	marginPercentage: Scalars['Float']['output'];
	/** marginAmount over cost: the markup on cost. The same money marginPercentage states as a share of revenue. */
	markupPercentage: Scalars['Float']['output'];
	/** Which batch produced this point, so the card can link there. */
	orderQuoteOfferBatchId: Scalars['ID']['output'];
	/**
	 * This combination's product revenue BEFORE fees and discounts. Always ≤ total, which
	 * additionally carries samples, delivery and fees less discounts. Not the margin denominator —
	 * that is marginBase.
	 */
	productsSubtotal: Scalars['Float']['output'];
	/**
	 * This combination WITHOUT delivery and samples: productsSubtotal + fees − discounts, net,
	 * ex-VAT. total less deliveryTotal, samplesTotal and samplesShippingTotal. The same figure as
	 * marginBase, named for a reader of totals rather than of margins.
	 */
	productsTotal: Scalars['Float']['output'];
	/** Freight on the samples. Same basis as OrderQuoteOfferBatchSummary.samplesShippingTotal. */
	samplesShippingTotal: Scalars['Float']['output'];
	/** The samples themselves, net of PREPAID ones. Same basis as OrderQuoteOfferBatchSummary.samplesTotal. */
	samplesTotal: Scalars['Float']['output'];
	/** Same basis as OrderQuoteOfferBatchSummary.grandTotal — net, ex-VAT, incl. samples, delivery, fees and discounts. */
	total: Scalars['Float']['output'];
	/** VAT (moms) on total. */
	vatAmount: Scalars['Float']['output'];
};

export type OrderQuoteValueRange = {
	__typename?: 'OrderQuoteValueRange';
	/** How many batches actually contributed. Batches with nothing priced are not counted. */
	batchesConsidered: Scalars['Int']['output'];
	/** The DEAREST combination. Null when no batch qualifies; equal to low when only one exists. */
	high?: Maybe<OrderQuoteValuePoint>;
	/**
	 * The CHEAPEST combination. Null when no batch qualifies — show an em dash rather than a
	 * fabricated zero.
	 *
	 * low and high are ordered by total and by nothing else. Their margin figures are properties of
	 * those two combinations and routinely run the other way, because a small-quantity tier usually
	 * carries a fatter margin than a bulk one — so the cheapest combination is often the
	 * highest-margin one. To show a margin range, take the min and max of the two points' margin
	 * fields; rendering low.margin → high.margin will print backwards ranges.
	 */
	low?: Maybe<OrderQuoteValuePoint>;
	/** The quote this range was priced for. */
	orderQuoteId: Scalars['ID']['output'];
	/**
	 * The dearest combination by productsTotal: the best case for the deal's size. Ranking by total
	 * instead lets freight decide — 9,000 of products with 3,000 of delivery outranks 10,000 with
	 * 500 — so a figure about products should read this, not high. Null when no batch qualifies.
	 */
	productsHigh?: Maybe<OrderQuoteValuePoint>;
	/**
	 * The cheapest combination by productsTotal — delivery and samples kept out of the choice, of
	 * each tier and of the batch. Often the same combination as low; it differs where freight would
	 * otherwise decide which tier or batch is cheapest. Null when no batch qualifies.
	 */
	productsLow?: Maybe<OrderQuoteValuePoint>;
};

/** One supplier's price request on one quote. */
export type OrderQuoteVetterJob = {
	__typename?: 'OrderQuoteVetterJob';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	currency?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	/** Every link into this job, newest first, revoked ones included. */
	links: Array<OrderQuoteVetterLink>;
	note?: Maybe<Scalars['String']['output']>;
	orderQuoteId: Scalars['ID']['output'];
	/** The quote lines this supplier is asked to price. */
	orderQuoteItemIds: Array<Scalars['ID']['output']>;
	/** What the supplier submitted, one row per quantity tier, for lines still assigned. */
	prices: Array<OrderQuoteVetterPrice>;
	/** Per product the supplier priced: whether their prices are in use on the offer. */
	productUsage: Array<VetterJobProductUsage>;
	/** Where the job stands, as the supplier sees it. */
	stage: VetterJobStage;
	stageLabel: Scalars['String']['output'];
	status: OrderQuoteVetterJobStatus;
	/** When prices were last submitted. Null until the first submission. */
	submittedAt?: Maybe<Scalars['DateTime']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	vetterEntity?: Maybe<VetterEntity>;
	vetterEntityId: Scalars['ID']['output'];
	withdrawnAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum OrderQuoteVetterJobStatus {
	Active = 'ACTIVE',
	/** Withdrawn by the studio: gone from the supplier's list, and every link into it stops working. */
	Withdrawn = 'WITHDRAWN',
}

export type OrderQuoteVetterLink = {
	__typename?: 'OrderQuoteVetterLink';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	email: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	/** The full link, so an admin can copy or re-share it any time. */
	link: Scalars['String']['output'];
	/** The job's latest note. Read from the job. */
	note?: Maybe<Scalars['String']['output']>;
	orderQuoteId: Scalars['ID']['output'];
	/** The job's lines. Read from the job. */
	orderQuoteItemIds: Array<Scalars['ID']['output']>;
	/** The job this link opens. */
	orderQuoteVetterJobId: Scalars['ID']['output'];
	/** The job's submitted prices. Read from the job. */
	prices: Array<OrderQuoteVetterPrice>;
	revokedAt?: Maybe<Scalars['DateTime']['output']>;
	status: OrderQuoteVetterLinkStatus;
	/** The job's latest submission. Read from the job. */
	submittedAt?: Maybe<Scalars['DateTime']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	vetterEntity?: Maybe<VetterEntity>;
	vetterEntityId: Scalars['ID']['output'];
};

export type OrderQuoteVetterLinkResponse = {
	__typename?: 'OrderQuoteVetterLinkResponse';
	email?: Maybe<Scalars['String']['output']>;
	/** The full link, so the admin can also share it by hand. Null when no link was created. */
	link?: Maybe<Scalars['String']['output']>;
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
};

export enum OrderQuoteVetterLinkStatus {
	Active = 'ACTIVE',
	Revoked = 'REVOKED',
}

/**
 * A supplier's price for one quantity tier. Their cost, not the client's price: it prefills the
 * offer through suggestOrderQuoteItemPricing, where the studio adds its margin.
 */
export type OrderQuoteVetterPrice = {
	__typename?: 'OrderQuoteVetterPrice';
	baseUnitPrice: Scalars['Float']['output'];
	/**
	 * STUDIO ONLY: this price in another currency (the header currency), at today's rate, for
	 * showing beside what the supplier quoted. Null in the supplier's own portal, and when no rate is
	 * available. Shipping and delivery costs come converted too.
	 */
	converted?: Maybe<VetterPriceConversion>;
	currency: Scalars['String']['output'];
	/** The supplier's cost for each of the studio's delivery options on the tier, and each split part. */
	deliveryCosts: Array<VetterDeliveryCostEntry>;
	id: Scalars['ID']['output'];
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	orderQuoteItemId: Scalars['ID']['output'];
	orderQuoteItemQuantityId: Scalars['ID']['output'];
	/** The tier's quantity. */
	quantity: Scalars['Int']['output'];
	/** Shipping for the whole tier, per method, in the same currency. */
	shippingPrices: Array<VetterShippingPrice>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	/** Studio only: whether this price is in use on the offer. Null for anyone else. */
	usage?: Maybe<VetterPriceUsage>;
};

/**
 * A supplier's price for one quantity tier. Their cost, not the client's price: it prefills the
 * offer through suggestOrderQuoteItemPricing, where the studio adds its margin.
 */
export type OrderQuoteVetterPriceConvertedArgs = {
	currency: CurrencyEnum;
};

/** Where a viewer opened the quote from. */
export enum OrderQuoteViewChannel {
	AdminPortal = 'ADMIN_PORTAL',
	ClientPortal = 'CLIENT_PORTAL',
	GuestLink = 'GUEST_LINK',
}

export type OrderQuoteViewSummary = {
	__typename?: 'OrderQuoteViewSummary';
	/** How many different people have opened the quote. */
	distinctViewers: Scalars['Int']['output'];
	/** The very first time anyone opened it. Null when nobody has. */
	firstViewedAt?: Maybe<Scalars['DateTime']['output']>;
	/** The most recent time anyone opened it. Null when nobody has. */
	lastViewedAt?: Maybe<Scalars['DateTime']['output']>;
	orderQuoteId: Scalars['ID']['output'];
	/** Total viewing sessions across every viewer. */
	totalViews: Scalars['Int']['output'];
	/** One entry per person, most recently active first. */
	viewers: Array<OrderQuoteViewer>;
};

/** One person's viewing history on a quote (owned by the order service). Keyed on the viewer's auth id so the viewer list can show who they are. */
export type OrderQuoteViewer = {
	__typename?: 'OrderQuoteViewer';
	/** The viewer's authentication user id. */
	actorId: Scalars['ID']['output'];
	/** ADMIN | ORGANIZATION | … — for labelling the row. It does not exclude anyone from the totals. */
	actorRole?: Maybe<Scalars['String']['output']>;
	firstViewedAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	lastChannel: OrderQuoteViewChannel;
	lastViewedAt: Scalars['DateTime']['output'];
	user?: Maybe<AuthenticationUser>;
	viewCount: Scalars['Int']['output'];
};

export enum OrderSampleAttachmentType {
	Rejection = 'REJECTION',
	VirtualDelivery = 'VIRTUAL_DELIVERY',
}

export enum OrderSampleChoice {
	NoSample = 'NO_SAMPLE',
	SampleNoShipping = 'SAMPLE_NO_SHIPPING',
	SampleWithShipping = 'SAMPLE_WITH_SHIPPING',
}

export type OrderSampleLifecycleStep = {
	__typename?: 'OrderSampleLifecycleStep';
	/** Who this round is waiting for. Set on the current step only, as on the item stepper. */
	actor?: Maybe<SampleActionActor>;
	/** Actually DONE, never merely passed — see outstanding. */
	completed: Scalars['Boolean']['output'];
	current: Scalars['Boolean']['output'];
	/** Wording for this sample: DELIVERY reads 'Shipped' on a physical sample and 'Virtual delivery' on a virtual one. */
	label: Scalars['String']['output'];
	/** Not done, and the round has moved past it anyway: a sample in production unpaid leaves PAYMENT outstanding rather than ticked. Same contract as OrderItemLifecycleStep.outstanding. */
	outstanding: Scalars['Boolean']['output'];
	/** What is still owed or undone, worded for display. Null unless outstanding. */
	outstandingReason?: Maybe<Scalars['String']['output']>;
	/** Branch on this, never on label — labels are copy and get reworded. */
	step: OrderSampleLifecycleStepEnum;
};

/**
 * The stages one sample round passes through. PAYMENT is done the moment the round is settled —
 * paid, waived, or put on admin-manual terms — because that is the gate production waits on.
 */
export enum OrderSampleLifecycleStepEnum {
	Approved = 'APPROVED',
	Delivery = 'DELIVERY',
	Payment = 'PAYMENT',
	Production = 'PRODUCTION',
	Ready = 'READY',
	Review = 'REVIEW',
}

export enum OrderSampleStatus {
	Approved = 'APPROVED',
	AwaitingApproval = 'AWAITING_APPROVAL',
	Cancelled = 'CANCELLED',
	InProduction = 'IN_PRODUCTION',
	Pending = 'PENDING',
	ProductionCompleted = 'PRODUCTION_COMPLETED',
	Rejected = 'REJECTED',
	Shipped = 'SHIPPED',
	VirtualSubmitted = 'VIRTUAL_SUBMITTED',
}

/**
 * Where an order is in ITS OWN setup, which is not where its products are.
 *
 * The studio confirms each product — the real supplier and cost — before it can go into
 * production. That is an internal step and deliberately orthogonal to the item lifecycle: a product
 * can be awaiting its sample payment, or being sampled, while the order is still SETUP. Read this
 * for the page's phase and the item lifecycle for the product's, and expect them to disagree; that
 * disagreement is the system working, not a contradiction to reconcile.
 */
export enum OrderSetupStage {
	/** Every product is confirmed. The order runs on the item lifecycle from here. */
	Active = 'ACTIVE',
	/** Completed or cancelled. Nothing further is being set up. */
	Closed = 'CLOSED',
	/** At least one product has not been confirmed yet. The studio is still setting the order up. */
	Setup = 'SETUP',
}

/**
 * One physical shipment on an order, carrying both its agreed price (each shipment is its own
 * invoice line) and its fulfilment state. Orders that shipped per-product have none.
 */
export type OrderShipment = Base & {
	__typename?: 'OrderShipment';
	actualDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	/**
	 * Everything that can be done to this shipment now, including correcting its details, each with
	 * the fields it owns. Render this list and nothing else — there is no affordance that isn't here.
	 */
	availableActions?: Maybe<Array<OrderShipmentNextAction>>;
	/** Free text. Write a ShippingCarrier code when the carrier is in the list, so tracking links resolve. */
	carrier?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deliveryDaysMax: Scalars['Int']['output'];
	deliveryDaysMin: Scalars['Int']['output'];
	estimatedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	/**
	 * This shipment's own progress, in the same steps an item uses.
	 *
	 * Quoted through production come from the products it carries, taking the least advanced — a box
	 * is no further along than its slowest product. Delivery and arrival are the shipment's own. Show
	 * one of these per shipment under a split product, so 100 units arriving and 400 still in
	 * production can both be true at once.
	 */
	lifecycle?: Maybe<Array<OrderItemLifecycleStep>>;
	/** What this shipment carries, and how much of each. */
	lines: Array<OrderShipmentLine>;
	orderId: Scalars['ID']['output'];
	/** 1-based position among the order's shipments. */
	sequence: Scalars['Int']['output'];
	shippedAt?: Maybe<Scalars['DateTime']['output']>;
	/** Null when no shipping method was quoted for these goods — they still ship, and still need tracking. */
	shippingMethod?: Maybe<OrderShippingMethod>;
	/**
	 * The shipment whose agreed freight covers this one, or null when this shipment carries its own.
	 *
	 * Set when part of a shipment's goods were ready early and left ahead of the rest: the freight
	 * was agreed once, on the row this points at, and the new row reads totalPrice 0.
	 *
	 * Group by this to show one priced delivery with several parcels under it. Never sum the group's
	 * prices as if they were separate charges — only the bearer is billed. Historical orders shipped
	 * under combination plans carry these groups too.
	 */
	splitOfOrderShipmentId?: Maybe<Scalars['ID']['output']>;
	status: OrderShipmentStatus;
	/**
	 * What this shipment is invoiced for — the freight agreed for the goods it carries. Zero only on
	 * a shipment split off another one: see splitOfOrderShipmentId for where its freight is charged.
	 */
	totalPrice?: Maybe<Scalars['Float']['output']>;
	trackingNumber?: Maybe<Scalars['String']['output']>;
	/** A link to the carrier's tracking page. Null when the carrier is unrecognised or has no tracking page — never guessed. */
	trackingUrl?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * One physical shipment on an order, carrying both its agreed price (each shipment is its own
 * invoice line) and its fulfilment state. Orders that shipped per-product have none.
 */
export type OrderShipmentTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type OrderShipmentLine = Base & {
	__typename?: 'OrderShipmentLine';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	orderItemId: Scalars['ID']['output'];
	orderShipmentId: Scalars['ID']['output'];
	quantity: Scalars['Int']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * What can be done to a shipment right now, and what each action needs.
 *
 * Mirrors OrderItemNextAction. An action owns its fields, so the form renders and submits exactly
 * what the chosen action names — preconditions are never re-implemented in the UI, and a field the
 * action doesn't own is never sent.
 *
 * Field NAMES only. How a field is rendered — widget, copy, and the carrier list from
 * getShippingCarriers — stays presentation, like status labels and stage order.
 */
export type OrderShipmentNextAction = {
	__typename?: 'OrderShipmentNextAction';
	/** Who owes this move. Every shipment action is the studio's — a client never ships their own order — but it is here so a row can say who is waiting without special-casing shipments. */
	actor: SampleActionActor;
	blocked?: Maybe<Scalars['Boolean']['output']>;
	blockedReason?: Maybe<Scalars['String']['output']>;
	/**
	 * Stable identifier — SHIP, DELIVER, CANCEL, EDIT_DETAILS. Key behaviour off this, not the label.
	 *
	 * EDIT_DETAILS can appear ALONGSIDE a move: a shipment in transit can be marked delivered or
	 * have its carrier and tracking corrected. They are not equal choices — read kind to rank them.
	 */
	key: Scalars['String']['output'];
	/** Whether this is the pending move, a property change, or an escape. EDIT_DETAILS is PROPERTY: correcting a carrier is not a turn. */
	kind: ActionKind;
	label: Scalars['String']['output'];
	/** Fields this action may also write. */
	optionalFields: Array<Scalars['String']['output']>;
	/**
	 * Fields this action requires — e.g. carrier and trackingNumber to ship. Send exactly the
	 * action's own fields: one it does not own is rejected, so a form built from these cannot
	 * submit something the mutation refuses.
	 */
	requiredFields: Array<Scalars['String']['output']>;
	/** The status this action moves the shipment to. NULL means it writes fields without moving it. */
	status?: Maybe<OrderShipmentStatus>;
};

/**
 * Fulfilment state of one shipment.
 *
 * The progression is PENDING → SHIPPED → DELIVERED. CANCELLED is terminal and sits outside that
 * sequence — goods that stopped moving, not a later stage. Read availableActions rather than
 * hard-coding what can follow what; the transitions live on the server and this ordering is stated
 * here only so a progress display and the server can't quietly disagree.
 */
export enum OrderShipmentStatus {
	Cancelled = 'CANCELLED',
	Delivered = 'DELIVERED',
	Pending = 'PENDING',
	Shipped = 'SHIPPED',
}

/** How an order's shipments are getting on, for the orders list. Counts leave out cancelled shipments. */
export type OrderShipping = {
	__typename?: 'OrderShipping';
	delivered: Scalars['Int']['output'];
	/** Shipments on the road past their estimated delivery date. */
	overdue: Scalars['Int']['output'];
	/** Shipments that have left — shipped or delivered. */
	shipped: Scalars['Int']['output'];
	state: OrderShippingState;
	total: Scalars['Int']['output'];
};

export enum OrderShippingMethod {
	Express = 'EXPRESS',
	Standard = 'STANDARD',
}

/**
 * Where an ORDER stands on shipping, read from its shipments. Order status cannot say this — an order
 * is IN_PRODUCTION from the first product made until the last box lands.
 *
 * One value per order, chosen by what needs doing: a box ready to leave outranks one already on the
 * road. Cancelled shipments are ignored throughout, as is every shipment of a cancelled order.
 */
export enum OrderShippingState {
	/** Every box has arrived. */
	Delivered = 'DELIVERED',
	/** At least one box is on its way, and nothing waiting is ready. */
	InTransit = 'IN_TRANSIT',
	/** Nothing has left and no box is ready yet. */
	NotShipped = 'NOT_SHIPPED',
	/** The order has no live shipments — nothing to send, every shipment was cancelled, or the order was. */
	NoShipments = 'NO_SHIPMENTS',
	/** Some boxes have arrived; the rest are still being made. */
	PartiallyDelivered = 'PARTIALLY_DELIVERED',
	/** At least one box has everything made and is waiting to be sent. */
	ReadyToShip = 'READY_TO_SHIP',
}

export type OrderStats = {
	__typename?: 'OrderStats';
	averageDeliveryAmount: Scalars['Float']['output'];
	averageMargin: Scalars['Float']['output'];
	averageOrderAmount: Scalars['Float']['output'];
	currency?: Maybe<CurrencyEnum>;
	dateRange?: Maybe<DateRange>;
	medianDeliveryAmount: Scalars['Float']['output'];
	medianMargin: Scalars['Float']['output'];
	medianOrderAmount: Scalars['Float']['output'];
	organizationId?: Maybe<Scalars['ID']['output']>;
	totalOrderAmount: Scalars['Float']['output'];
	totalOrders: Scalars['Int']['output'];
};

export type OrderStatsByStatus = {
	__typename?: 'OrderStatsByStatus';
	currency?: Maybe<CurrencyEnum>;
	dateRange?: Maybe<DateRange>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	statusBreakdown: Array<OrderStatusBreakdown>;
	total: Scalars['Int']['output'];
	totalAmount: Scalars['Float']['output'];
};

export enum OrderStatus {
	Cancelled = 'CANCELLED',
	Completed = 'COMPLETED',
	InProduction = 'IN_PRODUCTION',
	Pending = 'PENDING',
}

export type OrderStatusBreakdown = {
	__typename?: 'OrderStatusBreakdown';
	count: Scalars['Int']['output'];
	percentage: Scalars['Float']['output'];
	status: OrderStatus;
	totalAmount: Scalars['Float']['output'];
};

export type OrderSummary = {
	__typename?: 'OrderSummary';
	deliveryTotal: Scalars['Float']['output'];
	/** Per-discount breakdown (name + amount). Amounts sum to discountsTotal. */
	discounts: Array<OrderSummaryLineItem>;
	discountsTotal: Scalars['Float']['output'];
	/** Per-fee breakdown (name + amount). Amounts sum to feesTotal. */
	fees: Array<OrderSummaryLineItem>;
	feesTotal: Scalars['Float']['output'];
	/** Net total (ex-VAT). products + samples + sample shipping + delivery + fees - discounts. samplesTotal is already net of any sample prepayment, so nothing further is subtracted. */
	grandTotal: Scalars['Float']['output'];
	/**
	 * What the client pays for this order, VAT included — grandTotal + vatAmount.
	 *
	 * THE headline figure. Order.totalAmount is a snapshot of line revenue taken at acceptance and
	 * answers a different question (no fees, no delivery, ex-VAT); grandTotal is this same total
	 * before VAT. Show this one.
	 */
	grossAmount: Scalars['Float']['output'];
	/**
	 * marginTotal as a percentage of productsSubtotal — the share of goods revenue that is ours.
	 *
	 * NOT the same number as OrderQuoteOfferPricing.markupPercentage, which is a markup ON COST
	 * (price = cost x (1 + markup/100)) used to set prices. A 25% markup is a 20% margin here. Null
	 * when there is no product revenue to divide by.
	 */
	marginPercentage?: Maybe<Scalars['Float']['output']>;
	/**
	 * Gross margin on the GOODS: what the client pays for products less what they cost us, summed
	 * over every non-cancelled item.
	 *
	 * Products only. Samples, freight, fees and discounts carry no vetter cost, so folding them in
	 * would describe something other than the margin on what we sell. Provisional until an item is
	 * confirmed — before that the cost is the one quoted on the offer, not the one agreed with the
	 * supplier — and it moves when confirmOrder records the real cost.
	 *
	 * ADMIN ONLY. Null on a client's own order: this field, markupPercentage, marginPercentage and
	 * productsCostTotal all say what we make on them. It is nullable for exactly that reason.
	 */
	marginTotal?: Maybe<Scalars['Float']['output']>;
	/**
	 * The same profit over COST rather than over revenue — the markup, as an admin prices in it.
	 *
	 * This is the number the offer builder is actually authored in: entering 25 there sets a price
	 * of cost x 1.25, which is a 25% markup and a 20% margin. Both readings are here so a page can
	 * show the one its reader thinks in without re-deriving it from a pair of totals.
	 *
	 * Null when we hold no cost for the goods — an undefined markup, not a zero one.
	 */
	markupPercentage?: Maybe<Scalars['Float']['output']>;
	/** What the goods cost us, summed over non-cancelled items — the base the markup is measured against. Admin-only, like the margin fields; null for a client. */
	productsCostTotal?: Maybe<Scalars['Float']['output']>;
	productsSubtotal: Scalars['Float']['output'];
	/** Deductible samples not yet paid. Paying for production first would forfeit the credit and cost the client this much, which is why that action is blocked while it is non-zero. */
	sampleCreditAtRisk: Scalars['Float']['output'];
	/** Paid sample credit that will never be applied to this order — either it exceeds what is being charged, or it belongs to a cancelled item that is never invoiced. Owed to the client; recovering it needs a credit note. */
	sampleCreditUncredited: Scalars['Float']['output'];
	/**
	 * Prepaid sample goods: charged up front and credited back on the production invoice, so they
	 * add nothing to the order and are deliberately NOT in samplesTotal. Report it beside a zero
	 * samples line so the zero explains itself — the same figure the offer batch summary gives.
	 */
	samplesPrepaidTotal: Scalars['Float']['output'];
	/**
	 * Freight on this order's samples, whatever their paymentTreatment: charged up front with the
	 * sample and never credited back. Zero for a sample that was never shipped.
	 *
	 * Separate from deliveryTotal, which is freight on the GOODS.
	 */
	samplesShippingTotal: Scalars['Float']['output'];
	/**
	 * What the SAMPLES THEMSELVES cost this order, freight excluded and already net of anything
	 * credited back.
	 *
	 * A sample is always billed up front; paymentTreatment decides how much of that is a cost and how
	 * much is merely early. A deductible (PREPAID) sample has its goods credited against the
	 * production invoice, so it contributes nothing here. CHARGED counts in full; WAIVED is never
	 * charged.
	 *
	 * Sample freight is reported separately as samplesShippingTotal — it is charged and never
	 * credited, so on a deductible sample it is all that is left, and a Samples line consisting
	 * entirely of shipping reads as an error.
	 *
	 * This is NOT what the client is invoiced for samples — that is the full amount, and it appears
	 * in the sample payment. This line is order value.
	 */
	samplesTotal: Scalars['Float']['output'];
	/** VAT (moms) on grandTotal, for display before payment. */
	vatAmount: Scalars['Float']['output'];
	/** Applied VAT (moms) rate as a percentage, e.g. 25 or 0. */
	vatRate: Scalars['Float']['output'];
};

/** A single named fee or discount with its rolled-up amount. Same-named adjustments are combined into one line. */
export type OrderSummaryLineItem = {
	__typename?: 'OrderSummaryLineItem';
	amount: Scalars['Float']['output'];
	name: Scalars['String']['output'];
};

export type OrderTransactionDescriptionV2 = {
	__typename?: 'OrderTransactionDescriptionV2';
	/** Only set for sample rows — sample round number. Always null for product rows. */
	sampleRound?: Maybe<Scalars['Int']['output']>;
	text: Scalars['String']['output'];
};

/** Discriminator on OrderTransactionRowV2 — sample-payment row vs product-payment row. */
export enum OrderTransactionKindV2 {
	Product = 'product',
	Sample = 'sample',
}

export type OrderTransactionRowV2 = {
	__typename?: 'OrderTransactionRowV2';
	currency: CurrencyEnum;
	/** ISO date used for ordering — invoice createdAt or transaction createdAt. */
	date: Scalars['DateTime']['output'];
	/** One entry per sample in a batch / per paymentProductLine in a product txn. */
	descriptions: Array<OrderTransactionDescriptionV2>;
	/**
	 * e-conomic booked invoice number when there is one. Pass it to
	 * getInvoicePdfUrl to fetch a viewable PDF link (org-scoped).
	 */
	invoiceNumber?: Maybe<Scalars['Int']['output']>;
	/** True for historical rows (cancelled / failed invoice attempts that have been superseded). */
	isHistory: Scalars['Boolean']['output'];
	/** Stable React key — invoice key for grouped sample rows, UUID for standalones / product rows. */
	key: Scalars['String']['output'];
	/** sample | product — drives UI affordances (e.g. cancel button is product-only today). */
	kind: OrderTransactionKindV2;
	/** 'Stripe' or 'Invoice'. */
	method?: Maybe<Scalars['String']['output']>;
	paidAt?: Maybe<Scalars['DateTime']['output']>;
	/** Parent paymentTransaction id for product rows. Null for sample rows. */
	paymentTransactionId?: Maybe<Scalars['ID']['output']>;
	/**
	 * The raw word the writing system used — completed, succeeded, invoiced, awaiting_payment.
	 *
	 * Support and debugging only: it says WHICH lifecycle produced the row, not what it means.
	 * Never branch on it; that is what status, tone and statusLabel are for.
	 */
	sourceStatus: Scalars['String']['output'];
	/**
	 * ONE vocabulary, whichever lifecycle the row came from:
	 * paid | awaiting | pending | failed | cancelled | refunded | partially_refunded | waived.
	 *
	 * It used to be the writing system's own word, so one settled order returned three of them —
	 * a sample invoice said paid, a product transaction said completed, and an e-conomic mirror of
	 * a Stripe payment said succeeded. All three mean the money arrived. Normalised here rather
	 * than in the page, which is where three vocabularies became three behaviours.
	 *
	 * tone is the coarser grouping of the same fact, for colour; statusLabel is the wording. Branch
	 * on either of those or on this — they can no longer disagree.
	 */
	status: Scalars['String']['output'];
	/** The status worded for display, e.g. 'Awaiting payment'. Backend-owned, like every other label on this page. */
	statusLabel: Scalars['String']['output'];
	/** What the status MEANS, for colour and wording. Branch on this rather than on status, which spans two lifecycles and will gain values. */
	tone: PaymentRowTone;
	totalPrice: Scalars['Float']['output'];
};

export enum OrderTypes {
	Asc = 'ASC',
	Desc = 'DESC',
}

export type Organization = Base & {
	__typename?: 'Organization';
	addresses?: Maybe<Array<OrganizationAddress>>;
	businessRegistrations?: Maybe<Array<BusinessRegistration>>;
	complianceConnections?: Maybe<Array<OrganizationComplianceConnection>>;
	compliances?: Maybe<Array<OrganizationCompliance>>;
	countryCode?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	kickbackBalance?: Maybe<Scalars['Float']['output']>;
	kickbackTransactions?: Maybe<Array<KickbackTransaction>>;
	/** Cropped/display version of the logo. Resolved as a time-limited SAS URL. */
	logo?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
	onboarded: Scalars['Boolean']['output'];
	/** Resolved industry record. Null when organizationIndustryId is null. */
	organizationIndustry?: Maybe<OrganizationIndustry>;
	/** FK to the organizationIndustry table. Null = no industry chosen. */
	organizationIndustryId?: Maybe<Scalars['ID']['output']>;
	organizationSetting?: Maybe<OrganizationSetting>;
	organizationUsers?: Maybe<Array<OrganizationUser>>;
	/** Original uploaded logo before cropping. Resolved as a time-limited SAS URL. */
	originalLogo?: Maybe<Scalars['String']['output']>;
	productInterests?: Maybe<Array<OrganizationProductInterest>>;
	projects?: Maybe<Array<Project>>;
	sourcingPreferenceConnections?: Maybe<Array<OrganizationSourcingPreferenceConnection>>;
	sourcingPreferences?: Maybe<Array<OrganizationSourcingPreference>>;
	subscription?: Maybe<OrganizationSubscription>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type OrganizationKickbackTransactionsArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationActiveActivities = {
	__typename?: 'OrganizationActiveActivities';
	activities: Array<OrganizationActivity>;
};

export type OrganizationActivity =
	| OrganizationOrderActivity
	| OrganizationOrderQuoteOfferBatchActivity
	| OrganizationQuoteActivity;

export enum OrganizationActivityType {
	DraftQuote = 'DRAFT_QUOTE',
	OrderSampleApprovalPending = 'ORDER_SAMPLE_APPROVAL_PENDING',
	OrderSamplePaymentPending = 'ORDER_SAMPLE_PAYMENT_PENDING',
	QuoteOfferClientReview = 'QUOTE_OFFER_CLIENT_REVIEW',
}

export type OrganizationAddress = Base & {
	__typename?: 'OrganizationAddress';
	addressLine1: Scalars['String']['output'];
	addressLine2?: Maybe<Scalars['String']['output']>;
	addressType: AddressType;
	city: Scalars['String']['output'];
	countryCode: Scalars['String']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	googlePlaceId?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	isPrimary: Scalars['Boolean']['output'];
	latitude?: Maybe<Scalars['Float']['output']>;
	longitude?: Maybe<Scalars['Float']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	organization?: Maybe<Organization>;
	organizationId: Scalars['ID']['output'];
	postalCode: Scalars['String']['output'];
	stateCode?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationAddressInput = {
	addressLine1: Scalars['String']['input'];
	addressLine2?: InputMaybe<Scalars['String']['input']>;
	addressType?: InputMaybe<AddressType>;
	city: Scalars['String']['input'];
	countryCode: Scalars['String']['input'];
	googlePlaceId?: InputMaybe<Scalars['String']['input']>;
	isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
	latitude?: InputMaybe<Scalars['Float']['input']>;
	longitude?: InputMaybe<Scalars['Float']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	postalCode: Scalars['String']['input'];
	stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationApprovalAndMargin = {
	__typename?: 'OrganizationApprovalAndMargin';
	defaultApproval: Scalars['Boolean']['output'];
	defaultMargin: Scalars['Float']['output'];
	organizationId: Scalars['ID']['output'];
};

export type OrganizationCompliance = Base & {
	__typename?: 'OrganizationCompliance';
	connections?: Maybe<Array<OrganizationComplianceConnection>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationComplianceConnection = Base & {
	__typename?: 'OrganizationComplianceConnection';
	certificationNumber?: Maybe<Scalars['String']['output']>;
	certifyingBody?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	expiryDate?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	issueDate?: Maybe<Scalars['DateTime']['output']>;
	organization?: Maybe<Organization>;
	organizationCompliance?: Maybe<OrganizationCompliance>;
	organizationComplianceId: Scalars['ID']['output'];
	organizationId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationComplianceConnectionCreateInput = {
	certificationNumber?: InputMaybe<Scalars['String']['input']>;
	certifyingBody?: InputMaybe<Scalars['String']['input']>;
	expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
	issueDate?: InputMaybe<Scalars['DateTime']['input']>;
	organizationComplianceId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
};

export type OrganizationComplianceConnectionListInput = {
	order?: InputMaybe<OrderInput>;
	organizationComplianceId?: InputMaybe<Scalars['ID']['input']>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination?: InputMaybe<PaginationInput>;
};

export type OrganizationComplianceConnectionListResponse = {
	__typename?: 'OrganizationComplianceConnectionListResponse';
	data: Array<OrganizationComplianceConnection>;
	pageInfo: PageInfo;
};

export type OrganizationComplianceConnectionUpdateInput = {
	certificationNumber?: InputMaybe<Scalars['String']['input']>;
	certifyingBody?: InputMaybe<Scalars['String']['input']>;
	expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
	id: Scalars['ID']['input'];
	issueDate?: InputMaybe<Scalars['DateTime']['input']>;
	organizationComplianceId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationComplianceCreateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
};

export type OrganizationComplianceListInput = {
	name?: InputMaybe<Scalars['String']['input']>;
	order?: InputMaybe<OrderInput>;
	pagination?: InputMaybe<PaginationInput>;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationComplianceListResponse = {
	__typename?: 'OrganizationComplianceListResponse';
	data?: Maybe<Array<OrganizationCompliance>>;
	pageInfo: PageInfo;
};

export type OrganizationComplianceUpdateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateInput = {
	address?: InputMaybe<OrganizationAddressInput>;
	businessRegistrations?: InputMaybe<Array<BusinessRegistrationInput>>;
	countryCode: Scalars['String']['input'];
	currency?: InputMaybe<CurrencyEnum>;
	/** Display label for the selected payment terms, cached for the UI. */
	economicPaymentTermsName?: InputMaybe<Scalars['String']['input']>;
	economicPaymentTermsNumber: Scalars['Int']['input'];
	email?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	/** FK to an existing organizationIndustry row. Use createOrganizationIndustry first to get an id for a custom industry. */
	organizationIndustryId?: InputMaybe<Scalars['ID']['input']>;
	users?: InputMaybe<Array<UserInput>>;
	websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationIndustry = Base & {
	__typename?: 'OrganizationIndustry';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	/** Org that submitted this industry via the Other flow. Null when admin-created. */
	createdByOrganizationId?: Maybe<Scalars['ID']['output']>;
	id: Scalars['ID']['output'];
	isPublished: Scalars['Boolean']['output'];
	name: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationIndustryReassignment = {
	organizationId: Scalars['ID']['input'];
	organizationIndustryId?: InputMaybe<Scalars['ID']['input']>;
};

/** A single invoice recipient — either an internal user (userId set) or an external email (email set). */
export type OrganizationInvoiceRecipient = {
	__typename?: 'OrganizationInvoiceRecipient';
	/** External email address. Set when type = EMAIL. */
	email?: Maybe<Scalars['String']['output']>;
	/** Optional display name. */
	name?: Maybe<Scalars['String']['output']>;
	type: InvoiceRecipientType;
	/** System user id. Set when type = USER. */
	userId?: Maybe<Scalars['ID']['output']>;
};

export type OrganizationInvoiceRecipientInput = {
	/** External email address. Required when type = EMAIL. */
	email?: InputMaybe<Scalars['String']['input']>;
	/** Optional display name. */
	name?: InputMaybe<Scalars['String']['input']>;
	type: InvoiceRecipientType;
	/** System user id. Required when type = USER. */
	userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum OrganizationLocationEnum {
	Africa = 'AFRICA',
	Asia = 'ASIA',
	Australia = 'AUSTRALIA',
	Europe = 'EUROPE',
	Global = 'GLOBAL',
	NorthernEurope = 'NORTHERN_EUROPE',
	NorthAmerica = 'NORTH_AMERICA',
	SouthAmerica = 'SOUTH_AMERICA',
}

export type OrganizationOnboardingInput = {
	compliances?: InputMaybe<Array<OnboardingComplianceInput>>;
	organizationId: Scalars['ID']['input'];
	productInterests?: InputMaybe<Array<OnboardingProductInterestInput>>;
	sourcingPreferences?: InputMaybe<Array<OnboardingSourcingPreferenceInput>>;
};

export type OrganizationOnboardingResponse = {
	__typename?: 'OrganizationOnboardingResponse';
	complianceConnections: Array<OrganizationComplianceConnection>;
	message: Scalars['String']['output'];
	organizationId: Scalars['ID']['output'];
	productInterests: Array<OrganizationProductInterest>;
	sourcingPreferenceConnections: Array<OrganizationSourcingPreferenceConnection>;
	success: Scalars['Boolean']['output'];
};

/** Client action required on an order — state transition blocked until the client acts. */
export type OrganizationOrderActivity = {
	__typename?: 'OrganizationOrderActivity';
	id: Scalars['ID']['output'];
	orderId: Scalars['ID']['output'];
	title?: Maybe<Scalars['String']['output']>;
	type: OrganizationActivityType;
};

/** An offer batch sent to the client that is awaiting their review (accept/reject). */
export type OrganizationOrderQuoteOfferBatchActivity = {
	__typename?: 'OrganizationOrderQuoteOfferBatchActivity';
	batch?: Maybe<ClientOrderQuoteOfferBatch>;
	batchId: Scalars['ID']['output'];
	id: Scalars['ID']['output'];
	title?: Maybe<Scalars['String']['output']>;
	type: OrganizationActivityType;
};

export type OrganizationPage = {
	__typename?: 'OrganizationPage';
	data: Array<Organization>;
	pageInfo: PageInfo;
};

export type OrganizationProductInterest = Base & {
	__typename?: 'OrganizationProductInterest';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	organization?: Maybe<Organization>;
	organizationId: Scalars['ID']['output'];
	productTagId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationProductInterestCreateInput = {
	organizationId: Scalars['ID']['input'];
	productTagId: Scalars['ID']['input'];
};

export type OrganizationProductInterestListInput = {
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination?: InputMaybe<PaginationInput>;
	productTagId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationProductInterestListResponse = {
	__typename?: 'OrganizationProductInterestListResponse';
	data?: Maybe<Array<OrganizationProductInterest>>;
	pageInfo: PageInfo;
};

export type OrganizationProductInterestUpdateInput = {
	id: Scalars['ID']['input'];
};

export type OrganizationQuoteActivity = {
	__typename?: 'OrganizationQuoteActivity';
	id: Scalars['ID']['output'];
	quoteId: Scalars['ID']['output'];
	/** Ready-to-display label for the activity. */
	title?: Maybe<Scalars['String']['output']>;
	type: OrganizationActivityType;
};

export type OrganizationResponse = {
	__typename?: 'OrganizationResponse';
	data?: Maybe<Organization>;
	message: Scalars['String']['output'];
	messageKey: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
};

export type OrganizationSetting = Base & {
	__typename?: 'OrganizationSetting';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	currency?: Maybe<CurrencyEnum>;
	/** Cached display label for the selected payment terms (e.g. 'Netto 8 dage'). */
	economicPaymentTermsName?: Maybe<Scalars['String']['output']>;
	/** e-conomic payment-terms number the org sits under (pushed onto the e-conomic customer). */
	economicPaymentTermsNumber: Scalars['Int']['output'];
	id: Scalars['ID']['output'];
	/** Per-org invoice minimum (DKK). Below → Stripe only. Null = system default (25,000). */
	invoiceMinimumThreshold?: Maybe<Scalars['Float']['output']>;
	/** Who receives this org's invoices — internal users and/or external emails. */
	invoiceRecipients?: Maybe<Array<OrganizationInvoiceRecipient>>;
	organizationId: Scalars['ID']['output'];
	/** Default payment mode for product payments. Snapshotted to the order at acceptance. */
	productPaymentMode: PaymentModeEnum;
	/** Default payment mode for sample payments. Snapshotted to the order at acceptance. */
	samplePaymentMode: PaymentModeEnum;
	/** Per-org Stripe checkout limit (EUR). Null = system default (3,000). */
	stripeCheckoutLimit?: Maybe<Scalars['Float']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationSettingUpdateInput = {
	currency?: InputMaybe<CurrencyEnum>;
	id: Scalars['ID']['input'];
};

export type OrganizationSettingsInput = {
	currency?: InputMaybe<CurrencyEnum>;
};

export type OrganizationSignupInput = {
	address?: InputMaybe<SignupAddressInput>;
	businessRegistrations?: InputMaybe<Array<BusinessRegistrationInput>>;
	countryCode: Scalars['String']['input'];
	currency?: InputMaybe<CurrencyEnum>;
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	inviteToken: Scalars['String']['input'];
	jobPosition: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	mfaMethod: MfaMethodEnum;
	/** Optional FK to an existing organizationIndustry row picked from the dropdown. */
	organizationIndustryId?: InputMaybe<Scalars['ID']['input']>;
	/** Optional free-text industry name (the 'Other' path). The org service creates a pending OrganizationIndustry row tied to the new org. */
	organizationIndustryName?: InputMaybe<Scalars['String']['input']>;
	organizationName: Scalars['String']['input'];
	password: Scalars['Password']['input'];
	role: AuthRoleEnum;
	websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationSourcingPreference = Base & {
	__typename?: 'OrganizationSourcingPreference';
	connections?: Maybe<Array<OrganizationSourcingPreferenceConnection>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationSourcingPreferenceConnection = Base & {
	__typename?: 'OrganizationSourcingPreferenceConnection';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	notes?: Maybe<Scalars['String']['output']>;
	organization?: Maybe<Organization>;
	organizationId: Scalars['ID']['output'];
	organizationSourcingPreference?: Maybe<OrganizationSourcingPreference>;
	organizationSourcingPreferenceId: Scalars['ID']['output'];
	priority?: Maybe<Scalars['Int']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationSourcingPreferenceConnectionCreateInput = {
	notes?: InputMaybe<Scalars['String']['input']>;
	organizationId: Scalars['ID']['input'];
	organizationSourcingPreferenceId: Scalars['ID']['input'];
	priority?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationSourcingPreferenceConnectionListInput = {
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	organizationSourcingPreferenceId?: InputMaybe<Scalars['ID']['input']>;
	pagination?: InputMaybe<PaginationInput>;
};

export type OrganizationSourcingPreferenceConnectionListResponse = {
	__typename?: 'OrganizationSourcingPreferenceConnectionListResponse';
	data: Array<OrganizationSourcingPreferenceConnection>;
	pageInfo: PageInfo;
};

export type OrganizationSourcingPreferenceConnectionUpdateInput = {
	id: Scalars['ID']['input'];
	notes?: InputMaybe<Scalars['String']['input']>;
	organizationSourcingPreferenceId?: InputMaybe<Scalars['ID']['input']>;
	priority?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationSourcingPreferenceCreateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
};

export type OrganizationSourcingPreferenceListInput = {
	name?: InputMaybe<Scalars['String']['input']>;
	order?: InputMaybe<OrderInput>;
	pagination?: InputMaybe<PaginationInput>;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationSourcingPreferenceListResponse = {
	__typename?: 'OrganizationSourcingPreferenceListResponse';
	data: Array<OrganizationSourcingPreference>;
	pageInfo: PageInfo;
};

export type OrganizationSourcingPreferenceUpdateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
};

/** Aggregate statistics across all organizations, for the admin overview. */
export type OrganizationStats = {
	__typename?: 'OrganizationStats';
	/** Organizations with at least one active (COMPLETED) user. */
	active: Scalars['Int']['output'];
	/** Distinct industries represented across all organizations. */
	industries: Scalars['Int']['output'];
	/** Organizations created in the last 30 days. */
	recent: Scalars['Int']['output'];
	/** All organizations (clients) in the system. */
	totalClients: Scalars['Int']['output'];
};

/** An organization's current subscription. */
export type OrganizationSubscription = {
	__typename?: 'OrganizationSubscription';
	cancelAtPeriodEnd: Scalars['Boolean']['output'];
	canceledAt?: Maybe<Scalars['DateTime']['output']>;
	createdAt: Scalars['DateTime']['output'];
	currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
	currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	organizationId: Scalars['ID']['output'];
	/** Set when a downgrade is scheduled; the tier the sub will switch to at pendingTierEffectiveAt. */
	pendingTier?: Maybe<SubscriptionTier>;
	pendingTierEffectiveAt?: Maybe<Scalars['DateTime']['output']>;
	status: SubscriptionStatus;
	stripeCustomerId?: Maybe<Scalars['String']['output']>;
	stripePriceId?: Maybe<Scalars['String']['output']>;
	stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
	tier: SubscriptionTier;
	trialEnd?: Maybe<Scalars['DateTime']['output']>;
	updatedAt: Scalars['DateTime']['output'];
};

export type OrganizationUpdateInput = {
	businessRegistrations?: InputMaybe<Array<BusinessRegistrationInput>>;
	countryCode?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
	/** FK to organizationIndustry. Pass null to clear. Pass undefined / omit to leave unchanged. */
	organizationIndustryId?: InputMaybe<Scalars['ID']['input']>;
	settings?: InputMaybe<OrganizationSettingsInput>;
	websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUser = Base & {
	__typename?: 'OrganizationUser';
	authenticationUser?: Maybe<AuthenticationUser>;
	authorizationUserRoles?: Maybe<Array<Maybe<AuthorizationUserRole>>>;
	avatar?: Maybe<Scalars['String']['output']>;
	/**
	 * Date of birth as a plain calendar date, 'YYYY-MM-DD'. Deliberately a String and
	 * not DateTime: a birthday has no time of day and must not shift with timezone.
	 */
	birthday?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	/**
	 * When the invitation email was last sent. Null means this contact person has never
	 * been emailed — status alone can't tell that apart from an invitation still waiting,
	 * since both are PENDING.
	 */
	invitedAt?: Maybe<Scalars['DateTime']['output']>;
	/** True when this member came from a guest acceptance link (password-less, quote-scoped) and hasn't converted to a full account. */
	isGuest: Scalars['Boolean']['output'];
	jobPosition?: Maybe<Scalars['String']['output']>;
	lastName: Scalars['String']['output'];
	/** Internal notes about this contact person. Admin-only — always null for anyone else. */
	notes?: Maybe<Scalars['String']['output']>;
	organization?: Maybe<Organization>;
	organizationId: Scalars['ID']['output'];
	phone?: Maybe<Scalars['String']['output']>;
	roles?: Maybe<Array<Scalars['ID']['output']>>;
	status: StatusEnum;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId: Scalars['ID']['output'];
};

export type OrganizationUserCreateInput = {
	avatar?: InputMaybe<FileInput>;
	/** Plain calendar date, 'YYYY-MM-DD'. */
	birthday?: InputMaybe<Scalars['String']['input']>;
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	jobPosition?: InputMaybe<Scalars['String']['input']>;
	lastName: Scalars['String']['input'];
	/** Internal notes. Ignored unless the caller is an admin. */
	notes?: InputMaybe<Scalars['String']['input']>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
	roles?: InputMaybe<Array<Scalars['ID']['input']>>;
	/**
	 * Set to false to record the contact person without emailing them an invitation.
	 * The account is created but stays PENDING until inviteOrganizationUser is called.
	 * Defaults to true, which is the historical behaviour.
	 */
	sendInvitation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationUserPage = {
	__typename?: 'OrganizationUserPage';
	data?: Maybe<Array<OrganizationUser>>;
	errors?: Maybe<Array<ResponseError>>;
	pageInfo?: Maybe<PageInfo>;
};

/** Aggregate organization user counts, broken down by lifecycle status. */
export type OrganizationUserStats = {
	__typename?: 'OrganizationUserStats';
	/** Users who have completed onboarding (status COMPLETED). */
	active: Scalars['Int']['output'];
	/** Users who have been invited but not yet activated (status PENDING). */
	pending: Scalars['Int']['output'];
	/** All users in the organization. */
	total: Scalars['Int']['output'];
};

export type OrganizationUserStub = {
	__typename?: 'OrganizationUserStub';
	firstName: Scalars['String']['output'];
	lastName: Scalars['String']['output'];
};

export type OrganizationUserUpdateInput = {
	avatar?: InputMaybe<FileInput>;
	/** Plain calendar date, 'YYYY-MM-DD'. Pass null to clear. */
	birthday?: InputMaybe<Scalars['String']['input']>;
	firstName?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	jobPosition?: InputMaybe<Scalars['String']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
	/** Internal notes. Admin-only — rejected for anyone else. Pass null to clear. */
	notes?: InputMaybe<Scalars['String']['input']>;
	/** Pass null to clear. */
	phone?: InputMaybe<Scalars['String']['input']>;
};

export type PageInfo = {
	__typename?: 'PageInfo';
	currentPage: Scalars['Int']['output'];
	hasNextPage: Scalars['Boolean']['output'];
	hasPreviousPage: Scalars['Boolean']['output'];
	totalCount: Scalars['Int']['output'];
	totalPages: Scalars['Int']['output'];
};

export type PaginationInput = {
	currentPage: Scalars['Int']['input'];
	limit: Scalars['Int']['input'];
};

export enum PantoneBook {
	PantoneColorBridgeCoated = 'pantoneColorBridgeCoated',
	PantoneColorBridgeUncoated = 'pantoneColorBridgeUncoated',
	PantoneExtendedGamutCoated = 'pantoneExtendedGamutCoated',
	PantoneMetallicsSolidCoated = 'pantoneMetallicsSolidCoated',
	PantonePastelsNeonsCoated = 'pantonePastelsNeonsCoated',
	PantonePastelsNeonsUncoated = 'pantonePastelsNeonsUncoated',
	PantoneSolidCoated = 'pantoneSolidCoated',
	PantoneSolidUncoated = 'pantoneSolidUncoated',
}

export type PantoneBookInfo = {
	__typename?: 'PantoneBookInfo';
	colorCount: Scalars['Int']['output'];
	finish: PantoneFinish;
	id: PantoneBook;
	title: Scalars['String']['output'];
};

export type PantoneColor = {
	__typename?: 'PantoneColor';
	book: PantoneBook;
	bookTitle: Scalars['String']['output'];
	code: Scalars['String']['output'];
	finish: PantoneFinish;
	hex: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	isNew: Scalars['Boolean']['output'];
	name?: Maybe<Scalars['String']['output']>;
	pageNumberInBook?: Maybe<Scalars['String']['output']>;
	positionInBook: Scalars['Int']['output'];
	rgb: PantoneRgb;
};

export type PantoneColorMatch = {
	__typename?: 'PantoneColorMatch';
	accuracy: PantoneMatchAccuracy;
	color: PantoneColor;
	deltaE: Scalars['Float']['output'];
};

export type PantoneColorPage = {
	__typename?: 'PantoneColorPage';
	data: Array<PantoneColor>;
	pageInfo: PageInfo;
};

export enum PantoneFinish {
	Coated = 'coated',
	Uncoated = 'uncoated',
}

export enum PantoneMatchAccuracy {
	Acceptable = 'acceptable',
	Close = 'close',
	Distant = 'distant',
	Exact = 'exact',
}

export type PantoneRgb = {
	__typename?: 'PantoneRgb';
	blue: Scalars['Int']['output'];
	green: Scalars['Int']['output'];
	red: Scalars['Int']['output'];
};

export type PasswordResetInput = {
	password: Scalars['Password']['input'];
	token: Scalars['String']['input'];
};

export type PasswordResetRequestInput = {
	authKey: Scalars['String']['input'];
};

export type PasswordResetValidateInput = {
	code: Scalars['String']['input'];
	token: Scalars['String']['input'];
};

export type PasswordUpdateInput = {
	newPassword: Scalars['Password']['input'];
	oldPassword: Scalars['Password']['input'];
	userId: Scalars['ID']['input'];
};

/**
 * How a given payment is collected. Configured per-org (default) and
 * per-order (override) for products and samples independently.
 *   - CLIENT_CHOICE: customer picks Stripe or invoice at checkout (default)
 *   - STRIPE_ONLY: lock to card payment
 *   - INVOICE_ONLY: lock to e-conomic invoice
 *   - ADMIN_MANUAL: pulled out of the auto-flow — production-gate is
 *     skipped, client-side pay buttons are hidden, admin invoices
 *     these items manually via the Billing tab.
 */
export enum PaymentModeEnum {
	AdminManual = 'ADMIN_MANUAL',
	ClientChoice = 'CLIENT_CHOICE',
	InvoiceOnly = 'INVOICE_ONLY',
	StripeOnly = 'STRIPE_ONLY',
}

export type PaymentProductInvoice = Base & {
	__typename?: 'PaymentProductInvoice';
	attempts: Scalars['Int']['output'];
	createdAt: Scalars['DateTime']['output'];
	economicBookedInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	economicCustomerNumber?: Maybe<Scalars['Int']['output']>;
	economicDraftInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	economicPdfUrl?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	lastAttemptAt?: Maybe<Scalars['DateTime']['output']>;
	lastError?: Maybe<Scalars['String']['output']>;
	lastPolledAt?: Maybe<Scalars['DateTime']['output']>;
	markedPaidByUserId?: Maybe<Scalars['ID']['output']>;
	markedPaidNote?: Maybe<Scalars['String']['output']>;
	paidAt?: Maybe<Scalars['DateTime']['output']>;
	paidVia?: Maybe<SamplePaymentInvoicePaidVia>;
	paymentTransactionId: Scalars['ID']['output'];
	status: PaymentProductInvoiceStatus;
	triggeredByUserId?: Maybe<Scalars['ID']['output']>;
	updatedAt: Scalars['DateTime']['output'];
};

/** paymentProductInvoice (bank-transfer) lifecycle. Mirrors SamplePaymentInvoiceStatus. */
export enum PaymentProductInvoiceStatus {
	Booked = 'booked',
	Cancelled = 'cancelled',
	Failed = 'failed',
	Paid = 'paid',
	Pending = 'pending',
}

export type PaymentProductLine = Base & {
	__typename?: 'PaymentProductLine';
	createdAt: Scalars['DateTime']['output'];
	currency: CurrencyEnum;
	/** Sum of deductible-paid-samples credited against this item. */
	deductibleAmount: Scalars['Float']['output'];
	/** Sample IDs whose paid amounts contributed to deductibleAmount. */
	deductibleSampleIds?: Maybe<Array<Scalars['ID']['output']>>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	/** productAmount - deductibleAmount. Sum of all lineNetAmount on a transaction equals the transaction's totalAmount. */
	lineNetAmount: Scalars['Float']['output'];
	orderId: Scalars['ID']['output'];
	orderItemId: Scalars['ID']['output'];
	paidAt?: Maybe<Scalars['DateTime']['output']>;
	paymentTransactionId: Scalars['ID']['output'];
	/** Sum of this item's products + fees + delivery, before deduction. */
	productAmount: Scalars['Float']['output'];
	status: PaymentProductLineStatus;
	updatedAt: Scalars['DateTime']['output'];
};

/** Per-line product status — pending until the parent transaction settles. */
export enum PaymentProductLineStatus {
	Failed = 'failed',
	Paid = 'paid',
	Pending = 'pending',
	Refunded = 'refunded',
}

/**
 * How a transaction row should READ, independent of which lifecycle its status came from.
 *
 * status spans two vocabularies — a sample invoice's and a product transaction's — and a page that
 * colours on the string goes silent the day either gains a value. This says what the row means, so
 * a new status is still rendered correctly.
 */
export enum PaymentRowTone {
	/** Waiting on someone: a booked invoice awaiting payment. */
	Awaiting = 'AWAITING',
	/** Ended without payment — failed or cancelled. Historical rows carry this. */
	Ended = 'ENDED',
	/** Nothing was charged: waived, or refunded back. */
	Neutral = 'NEUTRAL',
	/** In flight: raised, sent, or being processed. Nothing is wrong. */
	Pending = 'PENDING',
	/** Settled. Money received. */
	Settled = 'SETTLED',
}

export type PaymentTransaction = Base & {
	__typename?: 'PaymentTransaction';
	checkoutSessions: Array<StripeCheckoutSession>;
	completedAt?: Maybe<Scalars['DateTime']['output']>;
	createdAt: Scalars['DateTime']['output'];
	currency: CurrencyEnum;
	failureReason?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	orderId: Scalars['ID']['output'];
	organizationId: Scalars['ID']['output'];
	paymentMethod?: Maybe<Scalars['String']['output']>;
	/** Present on invoice-paid product transactions. */
	productInvoice?: Maybe<PaymentProductInvoice>;
	/** Present on product transactions, empty on sample. */
	productLines: Array<PaymentProductLine>;
	refundAmount?: Maybe<Scalars['Float']['output']>;
	refundedAt?: Maybe<Scalars['DateTime']['output']>;
	samplePayments: Array<SamplePayment>;
	status: PaymentTransactionStatus;
	stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
	totalAmount: Scalars['Float']['output'];
	/** Sample or product transaction. Defaults to 'sample' for legacy rows. */
	type: PaymentTransactionType;
	updatedAt: Scalars['DateTime']['output'];
};

/** paymentTransaction lifecycle. */
export enum PaymentTransactionStatus {
	/** Invoice booked and sent; awaiting out-of-band (bank transfer) settlement. Admin marks it paid manually. */
	AwaitingPayment = 'awaiting_payment',
	Completed = 'completed',
	Failed = 'failed',
	PartiallyRefunded = 'partially_refunded',
	Pending = 'pending',
	Processing = 'processing',
	Refunded = 'refunded',
}

/** Sample vs product transaction — same root row, different children. */
export enum PaymentTransactionType {
	/** Samples and production settled together — the pay-the-whole-order-up-front route. One transaction owning product lines AND sample rows, so a single payment clears both. */
	Order = 'order',
	Product = 'product',
	Sample = 'sample',
}

export type PhoneInput = {
	code: Scalars['String']['input'];
	number: Scalars['String']['input'];
	schema: Scalars['String']['input'];
};

export type PlaceAutocompleteResult = {
	__typename?: 'PlaceAutocompleteResult';
	description: Scalars['String']['output'];
	mainText: Scalars['String']['output'];
	placeId: Scalars['String']['output'];
	secondaryText: Scalars['String']['output'];
};

export type PlaceDetails = {
	__typename?: 'PlaceDetails';
	city?: Maybe<Scalars['String']['output']>;
	country?: Maybe<Scalars['String']['output']>;
	countryCode?: Maybe<Scalars['String']['output']>;
	formattedAddress: Scalars['String']['output'];
	latitude?: Maybe<Scalars['Float']['output']>;
	longitude?: Maybe<Scalars['Float']['output']>;
	placeId: Scalars['String']['output'];
	postalCode?: Maybe<Scalars['String']['output']>;
	state?: Maybe<Scalars['String']['output']>;
	stateCode?: Maybe<Scalars['String']['output']>;
	streetName?: Maybe<Scalars['String']['output']>;
	streetNumber?: Maybe<Scalars['String']['output']>;
	timezone?: Maybe<Scalars['String']['output']>;
};

/**
 * Breakdown of a plan change — shows the user exactly why they're paying
 * what they're paying (or what they'll save on a downgrade).
 * All amounts are in the subscription's currency (typically USD).
 */
export type PlanChangeBreakdown = {
	__typename?: 'PlanChangeBreakdown';
	/** Currency code (e.g. USD, DKK). */
	currency: Scalars['String']['output'];
	/** Net price of the current plan (monthly, ex-VAT). */
	currentPriceNet: Scalars['Float']['output'];
	/** Net price of the new plan (monthly, ex-VAT). */
	newPriceNet: Scalars['Float']['output'];
	/** Prorated net difference charged now (upgrade) or credited (downgrade). */
	proratedAmountNet?: Maybe<Scalars['Float']['output']>;
	/** Total amount charged now (proratedAmountNet + vatAmount). Null for downgrades. */
	totalAmount?: Maybe<Scalars['Float']['output']>;
	/** VAT amount on the prorated charge. */
	vatAmount?: Maybe<Scalars['Float']['output']>;
	/** VAT percentage applied (e.g. 25 for Denmark, 0 for EU reverse-charge). */
	vatRate: Scalars['Float']['output'];
};

export type PolygonPoint = {
	__typename?: 'PolygonPoint';
	x: Scalars['Float']['output'];
	y: Scalars['Float']['output'];
};

export type PolygonPointInput = {
	x: Scalars['Float']['input'];
	y: Scalars['Float']['input'];
};

export type PreviewAcceptOffersInput = {
	inCurrency?: InputMaybe<CurrencyEnum>;
	orderQuoteId: Scalars['ID']['input'];
	selections: Array<AcceptOrderQuoteOfferSelectionInput>;
};

export type PreviewOrderQuoteOfferFeasibilityDelivery = {
	__typename?: 'PreviewOrderQuoteOfferFeasibilityDelivery';
	/** The factors behind the verdict. Null when there's no deadline or production time. */
	breakdown?: Maybe<OfferFeasibilityBreakdown>;
	/** Projected arrival window (null when production time is missing). */
	projectedDelivery?: Maybe<ProjectedDeliveryWindow>;
	shippingMethod: OrderShippingMethod;
	/** Unified deadline+feasibility status — color the badge on this. */
	timelineStatus: TimelineStatus;
	verdict: OfferFeasibilityVerdict;
};

export type PreviewOrderQuoteOfferFeasibilityDeliveryInput = {
	deliveryDaysMax: Scalars['Int']['input'];
	deliveryDaysMin: Scalars['Int']['input'];
	/** Echoed back on the result so the caller can match verdicts to the row it's editing. */
	shippingMethod: OrderShippingMethod;
};

export type PreviewOrderQuoteOfferFeasibilityInput = {
	/** Worst-case anchor (the offer's accept-by date). Defaults to now when omitted. */
	acceptDeadline?: InputMaybe<Scalars['DateTime']['input']>;
	/** Target deadline to judge against. Omit to get projected dates without a verdict. */
	deadline?: InputMaybe<Scalars['DateTime']['input']>;
	/** Optional — omit while still building. Production-only feasibility is returned regardless. */
	deliveries?: InputMaybe<Array<PreviewOrderQuoteOfferFeasibilityDeliveryInput>>;
	maxProductionDays?: InputMaybe<Scalars['Int']['input']>;
	minProductionDays?: InputMaybe<Scalars['Int']['input']>;
};

export type PreviewOrderQuoteOfferFeasibilityResult = {
	__typename?: 'PreviewOrderQuoteOfferFeasibilityResult';
	deliveries: Array<PreviewOrderQuoteOfferFeasibilityDelivery>;
	/** Production-only feasibility (the floor). Always returned, even with no deliveries. */
	production?: Maybe<OfferFeasibilityProduction>;
};

export type Product = Base & {
	__typename?: 'Product';
	/** Actions the current viewer may take on this product. */
	availableActions: ProductAvailableActions;
	brand?: Maybe<Brand>;
	brandId?: Maybe<Scalars['ID']['output']>;
	/** Admin-only. How many products were copied from this one via the community page. Null for non-admins. */
	communityCopyCount?: Maybe<Scalars['Int']['output']>;
	/** Admin-only. Whether this product can be published to the community page now, and if not, why. Null for non-admins. */
	communityPublishability?: Maybe<CommunityPublishability>;
	/** When an admin published this product to the community page. Null when not published. */
	communityPublishedAt?: Maybe<Scalars['DateTime']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	dimensions?: Maybe<ProductDimensions>;
	id: Scalars['ID']['output'];
	images?: Maybe<Array<ProductImage>>;
	/** Whether this product is on the community page right now (published and ACTIVE). */
	isPublishedToCommunity: Scalars['Boolean']['output'];
	metadata?: Maybe<ProductMetadata>;
	name: Scalars['String']['output'];
	organization?: Maybe<Organization>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	/** The catalogue cost ladder for this product, every supplier and the house prices together. */
	prices: Array<ProductPrice>;
	recommendations: Array<ProductRecommendation>;
	/** The sample prices for this product: the house price and one per supplier. Admin only. */
	samplePrices: Array<ProductSamplePrice>;
	sku: Scalars['String']['output'];
	/** The community product this one was copied from, when it was taken from the community page. */
	sourceProductId?: Maybe<Scalars['ID']['output']>;
	specifications?: Maybe<ProductSpecifications>;
	status: ProductStatus;
	studioFile?: Maybe<StudioFile>;
	studioFileId?: Maybe<Scalars['ID']['output']>;
	tags?: Maybe<Array<ProductTag>>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	weight?: Maybe<Scalars['Float']['output']>;
};

export type ProductAvailableActions = {
	__typename?: 'ProductAvailableActions';
	canDelete: Scalars['Boolean']['output'];
	/** Copy into the viewer's own product library. */
	canDuplicate: Scalars['Boolean']['output'];
	canEdit: Scalars['Boolean']['output'];
	/** Start a studio remix from this product. */
	canRemix: Scalars['Boolean']['output'];
};

/** A colour used on the product, optionally scoped to the part it applies to. */
export type ProductColorSpec = {
	__typename?: 'ProductColorSpec';
	/** Where the colour is used, e.g. Main body, Lid, Logo. */
	appliesTo?: Maybe<Scalars['String']['output']>;
	/** Hex code such as #2E2E2E, or a free-form code when no hex applies. */
	code?: Maybe<Scalars['String']['output']>;
	/** Surface finish for this colour, e.g. matte, glossy, metallic. */
	finish?: Maybe<Scalars['String']['output']>;
	/** Marks the colour a viewer should treat as the product's headline colour. */
	isPrimary?: Maybe<Scalars['Boolean']['output']>;
	/** Human name, e.g. Matte Black. */
	name?: Maybe<Scalars['String']['output']>;
	/** Pantone / PMS reference when the colour is matched to a system. */
	pantone?: Maybe<Scalars['String']['output']>;
};

export type ProductColorSpecInput = {
	appliesTo?: InputMaybe<Scalars['String']['input']>;
	code?: InputMaybe<Scalars['String']['input']>;
	finish?: InputMaybe<Scalars['String']['input']>;
	isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	pantone?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCreateInput = {
	brandId?: InputMaybe<Scalars['ID']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	dimensions?: InputMaybe<ProductDimensionsInput>;
	imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	metadata?: InputMaybe<ProductMetadataInput>;
	name: Scalars['String']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	sku?: InputMaybe<Scalars['String']['input']>;
	specifications?: InputMaybe<ProductSpecificationsInput>;
	tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	weight?: InputMaybe<Scalars['Float']['input']>;
};

/** An arbitrary spec that has no typed field yet. Use sparingly: typed fields are filterable, these are not. */
export type ProductCustomSpec = {
	__typename?: 'ProductCustomSpec';
	/** Optional grouping label so related custom specs render together. */
	group?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	/** Label shown to the reader, e.g. Battery life. */
	label: Scalars['String']['output'];
	sortOrder?: Maybe<Scalars['Int']['output']>;
	/** Optional unit rendered after the value, e.g. hours. */
	unit?: Maybe<Scalars['String']['output']>;
	value: Scalars['String']['output'];
};

export type ProductCustomSpecInput = {
	group?: InputMaybe<Scalars['String']['input']>;
	/** Omit to have one generated. Pass the existing id to keep a custom spec stable across updates. */
	id?: InputMaybe<Scalars['ID']['input']>;
	label: Scalars['String']['input'];
	sortOrder?: InputMaybe<Scalars['Int']['input']>;
	unit?: InputMaybe<Scalars['String']['input']>;
	value: Scalars['String']['input'];
};

/** One decoration applied to the product. A product can carry several. */
export type ProductDecoration = {
	__typename?: 'ProductDecoration';
	area?: Maybe<ProductPrintArea>;
	/** Reference to the artwork file used for this decoration. */
	artworkUrl?: Maybe<Scalars['String']['output']>;
	/** Number of print colours. Drives price on most methods. */
	colorCount?: Maybe<Scalars['Int']['output']>;
	/** Specific colours used by this decoration. */
	colors?: Maybe<Array<ProductColorSpec>>;
	id: Scalars['ID']['output'];
	method: ProductDecorationMethod;
	/** Free-text method name. Required in practice when method is OTHER. */
	methodNote?: Maybe<Scalars['String']['output']>;
	notes?: Maybe<Scalars['String']['output']>;
	/** Where the decoration sits, e.g. Front centre, Left chest, Bottom of base. */
	placement?: Maybe<Scalars['String']['output']>;
	sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type ProductDecorationInput = {
	area?: InputMaybe<ProductPrintAreaInput>;
	artworkUrl?: InputMaybe<Scalars['String']['input']>;
	colorCount?: InputMaybe<Scalars['Int']['input']>;
	colors?: InputMaybe<Array<ProductColorSpecInput>>;
	/** Omit to have one generated. Pass the existing id to keep a decoration stable across updates. */
	id?: InputMaybe<Scalars['ID']['input']>;
	method: ProductDecorationMethod;
	methodNote?: InputMaybe<Scalars['String']['input']>;
	notes?: InputMaybe<Scalars['String']['input']>;
	placement?: InputMaybe<Scalars['String']['input']>;
	sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** How a decoration is applied to the product. OTHER carries a free-text methodNote. */
export enum ProductDecorationMethod {
	Debossing = 'DEBOSSING',
	DigitalPrint = 'DIGITAL_PRINT',
	Doming = 'DOMING',
	Dtg = 'DTG',
	Embossing = 'EMBOSSING',
	Embroidery = 'EMBROIDERY',
	Engraving = 'ENGRAVING',
	HeatTransfer = 'HEAT_TRANSFER',
	HotFoil = 'HOT_FOIL',
	LaserEngraving = 'LASER_ENGRAVING',
	Other = 'OTHER',
	PadPrint = 'PAD_PRINT',
	ScreenPrint = 'SCREEN_PRINT',
	Sticker = 'STICKER',
	Sublimation = 'SUBLIMATION',
	UvPrint = 'UV_PRINT',
	WovenLabel = 'WOVEN_LABEL',
}

export type ProductDimensions = {
	__typename?: 'ProductDimensions';
	height?: Maybe<Scalars['Float']['output']>;
	length?: Maybe<Scalars['Float']['output']>;
	unit: Scalars['String']['output'];
	width?: Maybe<Scalars['Float']['output']>;
};

export type ProductDimensionsInput = {
	height: Scalars['Float']['input'];
	length: Scalars['Float']['input'];
	unit: Scalars['String']['input'];
	width: Scalars['Float']['input'];
};

export type ProductImage = {
	__typename?: 'ProductImage';
	altText?: Maybe<Scalars['String']['output']>;
	caption?: Maybe<Scalars['String']['output']>;
	/** Crop applied for display. Null means show the full original image. */
	crop?: Maybe<ProductImageCrop>;
	dimensions?: Maybe<ImageDimensions>;
	id: Scalars['ID']['output'];
	isPrimary?: Maybe<Scalars['Boolean']['output']>;
	metadata?: Maybe<Array<ImageMetadata>>;
	mimeType: Scalars['String']['output'];
	name: Scalars['String']['output'];
	size: Scalars['Int']['output'];
	sortOrder?: Maybe<Scalars['Int']['output']>;
	studioFileVersionId?: Maybe<Scalars['ID']['output']>;
	uploadedAt: Scalars['DateTime']['output'];
	url?: Maybe<Scalars['String']['output']>;
};

/** Non-destructive crop applied to the original image at display time (e.g. for square thumbnails). */
export type ProductImageCrop = {
	__typename?: 'ProductImageCrop';
	/** Target aspect ratio of the crop, expressed as width:height (for example 1:1). */
	aspectRatio?: Maybe<Scalars['String']['output']>;
	/** Height of the crop region. */
	height: Scalars['Float']['output'];
	rotation?: Maybe<Scalars['Float']['output']>;
	/** Unit of x/y/width/height. PERCENT (of the original) is recommended so the crop survives resizes. Defaults to PERCENT. */
	unit?: Maybe<ProductImageCropUnit>;
	/** Width of the crop region. */
	width: Scalars['Float']['output'];
	/** Left offset of the crop region from the original's top-left. */
	x: Scalars['Float']['output'];
	/** Top offset of the crop region from the original's top-left. */
	y: Scalars['Float']['output'];
	zoom?: Maybe<Scalars['Float']['output']>;
};

export type ProductImageCropInput = {
	aspectRatio?: InputMaybe<Scalars['String']['input']>;
	height: Scalars['Float']['input'];
	rotation?: InputMaybe<Scalars['Float']['input']>;
	unit?: InputMaybe<ProductImageCropUnit>;
	width: Scalars['Float']['input'];
	x: Scalars['Float']['input'];
	y: Scalars['Float']['input'];
	zoom?: InputMaybe<Scalars['Float']['input']>;
};

export enum ProductImageCropUnit {
	Percent = 'PERCENT',
	Px = 'PX',
}

export type ProductImageUploadInput = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	productId: Scalars['ID']['input'];
};

/** A value with its unit, e.g. 350 ml. Unit is free text, matching ProductDimensions. */
export type ProductMeasure = {
	__typename?: 'ProductMeasure';
	unit: Scalars['String']['output'];
	value: Scalars['Float']['output'];
};

export type ProductMeasureInput = {
	unit: Scalars['String']['input'];
	value: Scalars['Float']['input'];
};

export type ProductMetadata = {
	__typename?: 'ProductMetadata';
	createdFromProject?: Maybe<Scalars['Boolean']['output']>;
	createdFromSplitGrid?: Maybe<Scalars['Boolean']['output']>;
	createdFromStudio?: Maybe<Scalars['Boolean']['output']>;
	inspirationImageUrls?: Maybe<Array<Scalars['String']['output']>>;
	isAIGenerated?: Maybe<Scalars['Boolean']['output']>;
	projectProductId?: Maybe<Scalars['ID']['output']>;
	studioVersionId?: Maybe<Scalars['ID']['output']>;
	studioVersionNumbers?: Maybe<Array<Scalars['Int']['output']>>;
};

export type ProductMetadataInput = {
	createdFromProject?: InputMaybe<Scalars['Boolean']['input']>;
	createdFromSplitGrid?: InputMaybe<Scalars['Boolean']['input']>;
	createdFromStudio?: InputMaybe<Scalars['Boolean']['input']>;
	inspirationImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	isAIGenerated?: InputMaybe<Scalars['Boolean']['input']>;
	projectProductId?: InputMaybe<Scalars['ID']['input']>;
	studioVersionId?: InputMaybe<Scalars['ID']['input']>;
	studioVersionNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** How the product is packed, for shipping and customs. */
export type ProductPackaging = {
	__typename?: 'ProductPackaging';
	/** Outer dimensions of a single packed unit. */
	dimensions?: Maybe<ProductDimensions>;
	notes?: Maybe<Scalars['String']['output']>;
	/** Packaging type, e.g. polybag, gift box, sleeve. */
	type?: Maybe<Scalars['String']['output']>;
	/** Weight of a single packed unit. */
	weight?: Maybe<Scalars['Float']['output']>;
	/** Unit for the packed weight, e.g. g or kg. */
	weightUnit?: Maybe<Scalars['String']['output']>;
};

export type ProductPackagingInput = {
	dimensions?: InputMaybe<ProductDimensionsInput>;
	notes?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<Scalars['String']['input']>;
	weight?: InputMaybe<Scalars['Float']['input']>;
	weightUnit?: InputMaybe<Scalars['String']['input']>;
};

export type ProductPage = {
	__typename?: 'ProductPage';
	data: Array<Product>;
	pageInfo: PageInfo;
};

export type ProductPaymentPreview = {
	__typename?: 'ProductPaymentPreview';
	currency: Scalars['String']['output'];
	/** Paid sample credit belonging to products not on this invoice — applied on a later one. Zero unless this is a partial payment. */
	deductionsDeferred: Scalars['Float']['output'];
	/** Paid sample credit this invoice cannot absorb, because it exceeds what is being charged. The client is owed it; recovering it needs a credit note. */
	deductionsUncredited: Scalars['Float']['output'];
	/**
	 * Shipping that belongs to the ORDER rather than to any one product — a box carrying several
	 * items. Counted in grandTotal but in no item's line, because attributing it to one would inflate
	 * that product and there is no honest way to split it.
	 */
	deliveries: Array<ProductPaymentPreviewDelivery>;
	/** Net total (ex-VAT). */
	grandTotal: Scalars['Float']['output'];
	/** grandTotal + vatAmount (incl. VAT). */
	grossAmount: Scalars['Float']['output'];
	items: Array<ProductPaymentPreviewLine>;
	/** VAT on grandTotal. */
	vatAmount: Scalars['Float']['output'];
	/** Applied VAT (moms) rate as a percentage. */
	vatRate: Scalars['Float']['output'];
};

export type ProductPaymentPreviewDeduction = {
	__typename?: 'ProductPaymentPreviewDeduction';
	/** Positive. It is subtracted, not added. */
	amount: Scalars['Float']['output'];
	description: Scalars['String']['output'];
	sampleId: Scalars['ID']['output'];
};

export type ProductPaymentPreviewDelivery = {
	__typename?: 'ProductPaymentPreviewDelivery';
	amount: Scalars['Float']['output'];
	method: Scalars['String']['output'];
};

export type ProductPaymentPreviewFee = {
	__typename?: 'ProductPaymentPreviewFee';
	amount: Scalars['Float']['output'];
	name: Scalars['String']['output'];
};

export type ProductPaymentPreviewLine = {
	__typename?: 'ProductPaymentPreviewLine';
	/** Paid deductible samples credited against this product. Appears on the invoice as its own negative line. */
	deductibleAmount: Scalars['Float']['output'];
	deductibleSamples: Array<ProductPaymentPreviewDeduction>;
	deliveries: Array<ProductPaymentPreviewDelivery>;
	deliveryAmount: Scalars['Float']['output'];
	description: Scalars['String']['output'];
	fees: Array<ProductPaymentPreviewFee>;
	feesAmount: Scalars['Float']['output'];
	/** lineSubtotal − deductibleAmount. */
	lineNetAmount: Scalars['Float']['output'];
	lineSubtotal: Scalars['Float']['output'];
	orderItemId: Scalars['ID']['output'];
	productsAmount: Scalars['Float']['output'];
};

/**
 * What a product costs at a given volume from a given supplier.
 *
 * This is a cost plus a default markup, never a client-facing sell price, and it holds one
 * authored amount in one currency rather than a converted set: a quote converts at the moment it
 * is quoted, which is the only moment the exchange rate means anything.
 */
export type ProductPrice = Base & {
	__typename?: 'ProductPrice';
	baseUnitPrice: Scalars['Float']['output'];
	/**
	 * This row's money figures in another currency, at today's rate. This is what to display: the
	 * admin app shows every figure in the header currency. Show baseUnitPrice and currency above
	 * as secondary text when they differ, for example stored as DKK 5.
	 *
	 * Null only when no rate is available, in which case show the stored figures.
	 */
	converted?: Maybe<ProductPriceFigures>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	currency: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	isActive: Scalars['Boolean']['output'];
	lastQuotedAt?: Maybe<Scalars['DateTime']['output']>;
	lastQuotedCurrency?: Maybe<Scalars['String']['output']>;
	lastQuotedOfferId?: Maybe<Scalars['ID']['output']>;
	/** What this tier was last quoted at, on any offer that priced it, accepted or not. Evidence about the price above, not a replacement for it; see lastQuotedAt and lastQuotedOfferId for which and when. */
	lastQuotedUnitPrice?: Maybe<Scalars['Float']['output']>;
	/** Profit as a share of REVENUE, the figure e-conomic calls Avance i %. Not markupPercentage, which divides the same profit by cost. Null on a row with no markup. */
	marginPercentage?: Maybe<Scalars['Float']['output']>;
	/** Profit per unit: unitSalePrice minus baseUnitPrice. Null on a row with no markup. */
	marginUnit?: Maybe<Scalars['Float']['output']>;
	/** Default markup on COST: price = cost x (1 + markup / 100). Always the larger of the two percentages. */
	markupPercentage?: Maybe<Scalars['Float']['output']>;
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	origin: ProductPriceOrigin;
	product?: Maybe<Product>;
	productId: Scalars['ID']['output'];
	/** The volume this price is quoted at, matching an offer quantity tier. */
	quantity: Scalars['Int']['output'];
	/** What the client would pay per unit at this tier, in currency. Derived from cost and markup, never stored. Null on a row with no markup. */
	unitSalePrice?: Maybe<Scalars['Float']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	validFrom?: Maybe<Scalars['DateTime']['output']>;
	validTo?: Maybe<Scalars['DateTime']['output']>;
	vetterEntity?: Maybe<VetterEntity>;
	/** The supplier this price belongs to. Null is the house price, used for any supplier with no row of its own. */
	vetterEntityId?: Maybe<Scalars['ID']['output']>;
};

/**
 * What a product costs at a given volume from a given supplier.
 *
 * This is a cost plus a default markup, never a client-facing sell price, and it holds one
 * authored amount in one currency rather than a converted set: a quote converts at the moment it
 * is quoted, which is the only moment the exchange rate means anything.
 */
export type ProductPriceConvertedArgs = {
	currency: CurrencyEnum;
};

/** A catalogue row's money figures restated in one currency. Percentages and days do not change with currency, so they are not repeated here. */
export type ProductPriceFigures = {
	__typename?: 'ProductPriceFigures';
	baseUnitPrice: Scalars['Float']['output'];
	currency: Scalars['String']['output'];
	/** One unit of the row's stored currency in this one. 1 when they are the same. */
	exchangeRate: Scalars['Float']['output'];
	/** lastQuotedUnitPrice converted from lastQuotedCurrency. Null when nothing was quoted. */
	lastQuotedUnitPrice?: Maybe<Scalars['Float']['output']>;
	marginUnit?: Maybe<Scalars['Float']['output']>;
	unitSalePrice?: Maybe<Scalars['Float']['output']>;
};

/**
 * Whether a person chose this price, or it was inferred from quote history.
 *
 * BACKFILLED is the latest price this product was quoted at, and it moves every time the product
 * is quoted again. It looks exactly like a decision and seeds offers just as readily. Mark
 * it in the UI, and prefer it visibly less than an AUTHORED price. confirmProductPrice is how an
 * admin says an inferred price is right, which promotes it to AUTHORED.
 */
export enum ProductPriceOrigin {
	Authored = 'AUTHORED',
	Backfilled = 'BACKFILLED',
}

/** Which catalogue row answered a price lookup: the supplier's own row, or the house fallback. */
export enum ProductPriceSource {
	House = 'HOUSE',
	Supplier = 'SUPPLIER',
}

export type ProductPriceTierInput = {
	baseUnitPrice: Scalars['Float']['input'];
	currency: Scalars['String']['input'];
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	/** Markup on cost. Mutually exclusive with unitSalePrice; if both arrive, unitSalePrice wins. */
	markupPercentage?: InputMaybe<Scalars['Float']['input']>;
	maxProductionDays?: InputMaybe<Scalars['Int']['input']>;
	minProductionDays?: InputMaybe<Scalars['Int']['input']>;
	quantity: Scalars['Int']['input'];
	/**
	 * Price the tier from the other end, the way e-conomic does: state what the client pays and let
	 * the markup fall out of it. Given in the same currency as baseUnitPrice.
	 *
	 * Converted to a markup on save, so a row entered either way is identical afterwards. A sale
	 * price below cost is rejected, as is any sale price on a zero cost.
	 */
	unitSalePrice?: InputMaybe<Scalars['Float']['input']>;
	validFrom?: InputMaybe<Scalars['DateTime']['input']>;
	validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The printable or decoratable area available for one decoration. */
export type ProductPrintArea = {
	__typename?: 'ProductPrintArea';
	height?: Maybe<Scalars['Float']['output']>;
	/** Unit for width/height, e.g. cm or mm. Defaults to cm. */
	unit: Scalars['String']['output'];
	width?: Maybe<Scalars['Float']['output']>;
};

export type ProductPrintAreaInput = {
	height?: InputMaybe<Scalars['Float']['input']>;
	/** Defaults to cm when omitted. */
	unit?: InputMaybe<Scalars['String']['input']>;
	width?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductRecommendation = Base & {
	__typename?: 'ProductRecommendation';
	actionLabel: Scalars['String']['output'];
	actionUrl?: Maybe<Scalars['String']['output']>;
	completedAt?: Maybe<Scalars['DateTime']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description: Scalars['String']['output'];
	dismissedAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	productId: Scalars['ID']['output'];
	status: ProductRecommendationStatus;
	title: Scalars['String']['output'];
	type: ProductRecommendationType;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ProductRecommendationStatus {
	Active = 'ACTIVE',
	Completed = 'COMPLETED',
	Dismissed = 'DISMISSED',
}

export enum ProductRecommendationType {
	EnhanceWithStudio = 'ENHANCE_WITH_STUDIO',
	MissingSpecifications = 'MISSING_SPECIFICATIONS',
}

/**
 * What a sample of a product goes out at, from a given supplier.
 *
 * Shaped like the offer sample it seeds: one sample price and its freight, both what the client
 * pays. There is no cost or markup on a sample, and no quantity — a supplier has at most one sample
 * price per product. Held in one currency, like ProductPrice.
 */
export type ProductSamplePrice = Base & {
	__typename?: 'ProductSamplePrice';
	/**
	 * This row's amounts in another currency, at today's rate. Display these, with the stored
	 * amounts as secondary text when the currency differs. Null only when no rate is available.
	 */
	converted?: Maybe<ProductSamplePriceFigures>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	currency: Scalars['String']['output'];
	deliveryDaysMax?: Maybe<Scalars['Int']['output']>;
	deliveryDaysMin?: Maybe<Scalars['Int']['output']>;
	id: Scalars['ID']['output'];
	isActive: Scalars['Boolean']['output'];
	lastQuotedAt?: Maybe<Scalars['DateTime']['output']>;
	lastQuotedCurrency?: Maybe<Scalars['String']['output']>;
	lastQuotedOfferId?: Maybe<Scalars['ID']['output']>;
	/** What a sample of this product was last quoted at, by this supplier, on any offer. Evidence, not a replacement for the price above. */
	lastQuotedSamplePrice?: Maybe<Scalars['Float']['output']>;
	lastQuotedShippingPrice?: Maybe<Scalars['Float']['output']>;
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	origin: ProductPriceOrigin;
	product?: Maybe<Product>;
	productId: Scalars['ID']['output'];
	/** The sample itself, excluding freight. An offer sample's baseSamplePrice. */
	samplePrice: Scalars['Float']['output'];
	/** Freight for the sample. Null when none is known — not the same as free. */
	shippingPrice?: Maybe<Scalars['Float']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	validFrom?: Maybe<Scalars['DateTime']['output']>;
	validTo?: Maybe<Scalars['DateTime']['output']>;
	vetterEntity?: Maybe<VetterEntity>;
	/** The supplier this price belongs to. Null is the house price, used for any supplier with no row of its own. */
	vetterEntityId?: Maybe<Scalars['ID']['output']>;
};

/**
 * What a sample of a product goes out at, from a given supplier.
 *
 * Shaped like the offer sample it seeds: one sample price and its freight, both what the client
 * pays. There is no cost or markup on a sample, and no quantity — a supplier has at most one sample
 * price per product. Held in one currency, like ProductPrice.
 */
export type ProductSamplePriceConvertedArgs = {
	currency: CurrencyEnum;
};

export type ProductSamplePriceFigures = {
	__typename?: 'ProductSamplePriceFigures';
	currency: Scalars['String']['output'];
	/** One unit of the row's stored currency in this one. 1 when they are the same. */
	exchangeRate: Scalars['Float']['output'];
	/** lastQuotedSamplePrice converted from lastQuotedCurrency. Null when nothing was quoted. */
	lastQuotedSamplePrice?: Maybe<Scalars['Float']['output']>;
	lastQuotedShippingPrice?: Maybe<Scalars['Float']['output']>;
	samplePrice: Scalars['Float']['output'];
	shippingPrice?: Maybe<Scalars['Float']['output']>;
};

/** OWN = your organization's products. COMMUNITY = the published community page. */
export enum ProductScope {
	Community = 'COMMUNITY',
	Own = 'OWN',
}

/** Physical and production specifications for a product. Every field is optional: products are filled in over time. */
export type ProductSpecifications = {
	__typename?: 'ProductSpecifications';
	/** Capacity or volume, for drinkware and containers. */
	capacity?: Maybe<ProductMeasure>;
	colors?: Maybe<Array<ProductColorSpec>>;
	/** Escape hatch for specs with no typed field. */
	custom?: Maybe<Array<ProductCustomSpec>>;
	/** Decorations available or applied, e.g. a screen print on the front and an engraving on the base. */
	decorations?: Maybe<Array<ProductDecoration>>;
	/** Short selling points or characteristics, e.g. dishwasher safe, BPA free. */
	features?: Maybe<Array<Scalars['String']['output']>>;
	/** Surface finish of the product as a whole, e.g. matte, brushed, powder coated. */
	finish?: Maybe<Scalars['String']['output']>;
	/** Primary material, e.g. stainless steel, organic cotton, recycled PET. */
	material?: Maybe<Scalars['String']['output']>;
	packaging?: Maybe<ProductPackaging>;
	/** Additional materials present in the product. */
	secondaryMaterials?: Maybe<Array<Scalars['String']['output']>>;
	/** Free-text description of texture and surface detail. */
	textureDescription?: Maybe<Scalars['String']['output']>;
};

/** Replaces the whole specification object. Fields left out are cleared, so send the full object you want stored. */
export type ProductSpecificationsInput = {
	capacity?: InputMaybe<ProductMeasureInput>;
	colors?: InputMaybe<Array<ProductColorSpecInput>>;
	custom?: InputMaybe<Array<ProductCustomSpecInput>>;
	decorations?: InputMaybe<Array<ProductDecorationInput>>;
	features?: InputMaybe<Array<Scalars['String']['input']>>;
	finish?: InputMaybe<Scalars['String']['input']>;
	material?: InputMaybe<Scalars['String']['input']>;
	packaging?: InputMaybe<ProductPackagingInput>;
	secondaryMaterials?: InputMaybe<Array<Scalars['String']['input']>>;
	textureDescription?: InputMaybe<Scalars['String']['input']>;
};

/** Aggregate statistics across all products, for the admin products overview. */
export type ProductStats = {
	__typename?: 'ProductStats';
	/** Admin products — not assigned to any organization (organizationId IS NULL). */
	admin: Scalars['Int']['output'];
	/** Products on the community page right now (published, ACTIVE house products). A subset of admin. */
	community: Scalars['Int']['output'];
	/** Products assigned to an organization (organizationId IS NOT NULL). */
	organization: Scalars['Int']['output'];
	/** Products created in the last 30 days. */
	recent: Scalars['Int']['output'];
	/** All products in the system. */
	total: Scalars['Int']['output'];
	/** Products with at least one image. */
	withImages: Scalars['Int']['output'];
};

export enum ProductStatus {
	Active = 'ACTIVE',
	Archived = 'ARCHIVED',
	PendingApproval = 'PENDING_APPROVAL',
}

export type ProductTag = {
	__typename?: 'ProductTag';
	color?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	parent?: Maybe<ProductTag>;
	parentId?: Maybe<Scalars['ID']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductTagCreateInput = {
	color?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductTagPage = {
	__typename?: 'ProductTagPage';
	data: Array<ProductTag>;
	pageInfo: PageInfo;
};

export type ProductTagUpdateInput = {
	color?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
	parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductUpdateInput = {
	brandId?: InputMaybe<Scalars['ID']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	dimensions?: InputMaybe<ProductDimensionsInput>;
	id: Scalars['ID']['input'];
	metadata?: InputMaybe<ProductMetadataInput>;
	name?: InputMaybe<Scalars['String']['input']>;
	sku?: InputMaybe<Scalars['String']['input']>;
	specifications?: InputMaybe<ProductSpecificationsInput>;
	tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	weight?: InputMaybe<Scalars['Float']['input']>;
};

export type Project = Base & {
	__typename?: 'Project';
	brand?: Maybe<Brand>;
	brandId?: Maybe<Scalars['ID']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	endDate?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	organization?: Maybe<Organization>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	projectProducts?: Maybe<Array<ProjectProduct>>;
	startDate?: Maybe<Scalars['DateTime']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProjectPage = {
	__typename?: 'ProjectPage';
	data: Array<Project>;
	pageInfo: PageInfo;
};

export type ProjectProduct = Base & {
	__typename?: 'ProjectProduct';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	imageUrls?: Maybe<Array<Scalars['String']['output']>>;
	inspirationImageUrls?: Maybe<Array<Scalars['String']['output']>>;
	isProductCreated: Scalars['Boolean']['output'];
	isStudioFileCreated: Scalars['Boolean']['output'];
	name?: Maybe<Scalars['String']['output']>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	product?: Maybe<Product>;
	productId?: Maybe<Scalars['ID']['output']>;
	projectId?: Maybe<Scalars['ID']['output']>;
	remixPrompt?: Maybe<Scalars['String']['output']>;
	sessionId?: Maybe<Scalars['ID']['output']>;
	studioFile?: Maybe<StudioFile>;
	studioFileId?: Maybe<Scalars['ID']['output']>;
	type: ProjectProductType;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ProjectProductImageType {
	InspirationImage = 'INSPIRATION_IMAGE',
	ProductImage = 'PRODUCT_IMAGE',
}

export type ProjectProductInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	inspirationImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	name?: InputMaybe<Scalars['String']['input']>;
	productId?: InputMaybe<Scalars['ID']['input']>;
	remixPrompt?: InputMaybe<Scalars['String']['input']>;
	type: ProjectProductType;
};

export enum ProjectProductType {
	Existing = 'EXISTING',
	Generated = 'GENERATED',
	Remix = 'REMIX',
	Uploaded = 'UPLOADED',
}

/**
 * A range whose two ends share one anchor, so its width is lead-time variance and nothing else,
 * together with the verdict for these exact dates.
 *
 * Read the verdict from the same range you display. The top-level verdict on a feasibility result is
 * always the conservative accept-by-anchored one, so pairing it with ifAcceptedNow dates prints
 * contradictions like a warning about missing a deadline next to an arrival comfortably inside it.
 */
export type ProjectedDateRange = {
	__typename?: 'ProjectedDateRange';
	earliest: Scalars['DateTime']['output'];
	latest: Scalars['DateTime']['output'];
	/** Whether THESE dates meet the deadline. NO_DEADLINE when there is nothing to judge against. */
	verdict: OfferFeasibilityVerdict;
};

/**
 * Projected arrival, derived from production + delivery time in business days.
 *
 * Two ranges, each under one assumption about when the client accepts, so the width of either is
 * lead-time variance and nothing else — and the two are directly comparable. The gap between them is
 * exactly the accept-by window, which makes the cost of waiting visible.
 *
 * The whole field is null when production time is unset and nothing can be projected; when it is
 * present, both ranges are.
 */
export type ProjectedDeliveryWindow = {
	__typename?: 'ProjectedDeliveryWindow';
	/** Accepted on the last allowed day: the same range shifted later. Equal to ifAcceptedNow when the offer has no accept-by date. */
	ifAcceptedAtDeadline: ProjectedDateRange;
	/** Accepted today: fastest to slowest lead time. Varies by production and shipping speed alone. */
	ifAcceptedNow: ProjectedDateRange;
};

export type Query = {
	__typename?: 'Query';
	addressAutocomplete: Array<PlaceAutocompleteResult>;
	checkEmailExists: EmailExistsResponse;
	/**
	 * Admin-only: the agreement's e-conomic payment-terms master data, for the
	 * payment-terms selector on the org create/settings form.
	 */
	economicPaymentTerms: Array<EconomicPaymentTerm>;
	findPantoneColor?: Maybe<PantoneColor>;
	findPantoneColorAcrossBooks: Array<PantoneColor>;
	formatVATNumber: Scalars['String']['output'];
	generateVATFromRegistration?: Maybe<Scalars['String']['output']>;
	/** Get admin active activities (Admin only) */
	getAdminActiveActivities: AdminActiveActivities;
	/** Get a single admin user by ID (Admin only) */
	getAdminUser?: Maybe<AdminUser>;
	/** Get aggregate admin user counts by status (Admin only) */
	getAdminUserStats: AdminUserStats;
	getAllAdminAuthenticationUser: AuthenticationUserPage;
	/** Get all admin users with pagination (Admin only) */
	getAllAdminUser: AdminUserPage;
	getAllAuthorizationRole?: Maybe<AuthorizationRolePage>;
	getAllAuthorizationUserRole?: Maybe<AuthorizationUserRolePage>;
	getAllBrand: BrandPage;
	/**
	 * Admin-only: every contact person across all client organizations, in one paginated list.
	 * Unlike getAllOrganizationUser this is not scoped to a single organization — pass
	 * organizationId only to narrow it down.
	 */
	getAllClientContact: OrganizationUserPage;
	getAllClientOrders: ClientOrderPage;
	getAllLocalizationCountries: Array<LocalizationCountry>;
	getAllLocalizationTimezones?: Maybe<Array<LocalizationTimezone>>;
	getAllLoggingAuditLog?: Maybe<LoggingAuditLogPage>;
	getAllLoggingLoginLog?: Maybe<LoggingLoginLogPage>;
	getAllManufacturer: ManufacturerPage;
	getAllOrderQuote: OrderQuotePage;
	getAllOrders: OrderPage;
	getAllOrganization: OrganizationPage;
	/**
	 * Industries the calling user is allowed to see. For authenticated
	 * users that's all published rows plus their own pending rows.
	 * For unauthenticated callers (public signup) it's just the
	 * published list — non-sensitive metadata used to populate the
	 * industry dropdown before the user has an account.
	 */
	getAllOrganizationIndustries: Array<OrganizationIndustry>;
	/** Admin-only: every industry regardless of publish state. */
	getAllOrganizationIndustriesAdmin: Array<OrganizationIndustry>;
	getAllOrganizationUser?: Maybe<OrganizationUserPage>;
	getAllPantoneColor: PantoneColorPage;
	getAllProduct: ProductPage;
	getAllProductTag: ProductTagPage;
	getAllProjects: ProjectPage;
	getAllStudioFile: StudioFilePage;
	getAllVetterEntity: VetterEntityPage;
	getAllVetterUser: VetterUserPage;
	getAuthenticationUser: AuthenticationUser;
	getAuthorizationRole?: Maybe<AuthorizationRole>;
	getAuthorizationRoleByName?: Maybe<AuthorizationRole>;
	getBrand: Brand;
	getBrandAIContext: BrandAiContext;
	getBrandFileDownloadUrl: FileUploadResponse;
	getBrandFontDownloadUrl: FileUploadResponse;
	getCheckoutSession?: Maybe<StripeCheckoutSession>;
	getClientAllOrderQuote: ClientOrderQuotePage;
	getClientOrder?: Maybe<ClientOrder>;
	getClientOrderQuote?: Maybe<ClientOrderQuote>;
	/**
	 * The offer batches the client can see on this quote — sent ones only.
	 *
	 * Admins additionally pass previewBatchIds to preview not-yet-sent batches exactly as the client
	 * would see them once sent. The sent-only rule is never lifted, only added to, and the argument is
	 * ignored for everyone else. A named batch belonging to another quote matches nothing.
	 */
	getClientOrderQuoteOfferBatches: Array<ClientOrderQuoteOfferBatch>;
	getClientOrders: Array<ClientOrder>;
	getDesignSpecsByChat: Array<StudioDesignSpec>;
	getDesignSpecsByVersion: Array<StudioDesignSpec>;
	getEarlyAccessByToken?: Maybe<EarlyAccessInvite>;
	/** Render one template with its sample data, for preview. Administrators only. */
	getEmailTemplatePreview: EmailTemplatePreview;
	/**
	 * Every email template the platform can send. Administrators only — this
	 * exposes all customer-facing copy in one place.
	 */
	getEmailTemplates: Array<EmailTemplateSummary>;
	/**
	 * What the pay-the-whole-order-up-front route would charge: every unpaid product, its freight,
	 * and the samples that would otherwise have been invoiced first — with prepaid samples credited
	 * on the same document. Its total is the order's grossAmount.
	 */
	getFullOrderPaymentPreview: FullOrderPaymentPreview;
	/**
	 * Short-lived SAS URL to a booked invoice's PDF (mirrored into our storage).
	 * Org-scoped — only the owning organization or an admin gets a link.
	 * Null when the number isn't one of our booked invoices. Call this on demand
	 * (e.g. when the user clicks "View invoice") using the row's invoiceNumber.
	 */
	getInvoicePdfUrl?: Maybe<Scalars['String']['output']>;
	getLocalizationCountry: LocalizationCountry;
	getLocalizationDefaults: LocalizationDefaults;
	getLocalizationOrganizationSetting?: Maybe<LocalizationOrganizationSetting>;
	getLocalizationStates: Array<LocalizationState>;
	getManufacturer: Manufacturer;
	/** Admin-only: system-wide aggregate statistics across all manufacturers. */
	getManufacturerStats: ManufacturerStats;
	/** Get current admin user's profile (Admin only) */
	getMyAdminProfile?: Maybe<AdminUser>;
	getMyAuthorizationUserRole?: Maybe<AuthorizationUserRolePage>;
	/** Kickback ledger for the caller's organization (most recent first). */
	getMyKickbackTransactions: Array<KickbackTransaction>;
	/** The signed-in user's notifications, newest first. */
	getMyNotifications: NotificationList;
	/** The organizations the signed-in user is a member of, one row per membership (oldest first). Feeds the organization switcher; switch with switchOrganization. A guest session gets only the organization it was let into. */
	getMyOrganizationMemberships: Array<OrganizationUser>;
	/** Current subscription for the caller's organization (null if no sub). */
	getMySubscription?: Maybe<OrganizationSubscription>;
	/** Unread count for the bell badge. Cheaper than fetching the list. */
	getMyUnreadNotificationCount: Scalars['Int']['output'];
	/** Supplier account: every active job for the caller's supplier, newest first. Not available to link sessions. */
	getMyVetterJobs: VetterJobPage;
	getMyVetterProfile?: Maybe<VetterUser>;
	/**
	 * Every notification type with its current switches, including types that
	 * have never been configured — those report the default (enabled).
	 * Administrators only.
	 */
	getNotificationSettings: Array<NotificationSetting>;
	/**
	 * Where an offer batch lives, for resolving a /n/offer-batch/:id
	 * notification link.
	 *
	 * Exists for the same reason as getSampleLocation: a batch id alone cannot
	 * reach its quote. getOrderQuoteOfferBatch returns null for any non-admin,
	 * and every client-facing batch query takes the orderQuoteId that is being
	 * looked for — so a client receiving an OFFER_SENT notification had no way
	 * to resolve it.
	 *
	 * Returns null when the batch does not exist **or** is not visible to the
	 * caller — the two are deliberately indistinguishable.
	 */
	getOfferBatchLocation?: Maybe<OfferBatchLocation>;
	getOrder?: Maybe<Order>;
	getOrderActivities: Array<OrderActivity>;
	/** Admin-only snapshot counts for the orders overview stat cards (whole book, current state). */
	getOrderOverviewStats: OrderOverviewStats;
	getOrderPayment?: Maybe<PaymentTransaction>;
	getOrderQuote?: Maybe<OrderQuote>;
	getOrderQuoteActivities: Array<OrderQuoteActivity>;
	/** Admin: list the guest acceptance links issued for a quote (to review, copy, or revoke them). Admin preview links are deliberately excluded — this list is the record of who was actually invited. */
	getOrderQuoteGuestAccessTokens: Array<OrderQuoteGuestAccessToken>;
	getOrderQuoteItemByProduct?: Maybe<OrderQuoteItem>;
	getOrderQuoteOfferBatch?: Maybe<OrderQuoteOfferBatch>;
	getOrderQuoteOfferBatches: Array<OrderQuoteOfferBatch>;
	/** Admin-only snapshot counts for the quotes overview stat cards (whole book, current state). */
	getOrderQuoteOverviewStats: OrderQuoteOverviewStats;
	/** Order-quote counts broken down by status. */
	getOrderQuoteStatsByStatus: OrderQuoteStatsByStatus;
	/**
	 * Worst → best case across the offers on a quote, as two REAL combinations rather than four
	 * independent numbers. Admin-only: margin is never shown to a client, and the field returns an
	 * empty range to anyone else.
	 *
	 * Each point is one combination a client could actually accept, evaluated whole through the same
	 * summary the batch card uses — so the total here and the total on the batch always agree. Every
	 * batch on the quote is considered, drafts included; a batch with nothing priced yet is skipped
	 * rather than counted as zero.
	 */
	getOrderQuoteValueRange: OrderQuoteValueRange;
	/**
	 * getOrderQuoteValueRange for several quotes at once — one list page's worth, so a quote list
	 * can show each row's range without a request per row. Admin-only, empty for anyone else.
	 *
	 * Capped at 100 ids. Unknown ids are left out rather than returned empty; key the result by
	 * orderQuoteId, never by position.
	 */
	getOrderQuoteValueRanges: Array<OrderQuoteValueRange>;
	/** Admin: every price request on a quote, one per supplier, newest first — with submitted prices and the links into each. */
	getOrderQuoteVetterJobs: Array<OrderQuoteVetterJob>;
	/**
	 * Admin: every vetter link issued for a quote, newest first.
	 * @deprecated Use getOrderQuoteVetterJobs: one row per supplier, with its links inside.
	 */
	getOrderQuoteVetterLinks: Array<OrderQuoteVetterLink>;
	/** Admin: who has opened this quote, when they first and last did, and how often. Counts are mixed — admin, client and guest-link views all count. */
	getOrderQuoteViewSummary: OrderQuoteViewSummary;
	/** Aggregate order amount / delivery / margin stats, resolved to a target currency. */
	getOrderStats: OrderStats;
	/** Order counts + amounts broken down by status. */
	getOrderStatsByStatus: OrderStatsByStatus;
	/** Unified transaction rows for the Transactions tab — sample + product payments combined, sorted newest-first. */
	getOrderTransactionsV2: Array<OrderTransactionRowV2>;
	getOrders: Array<Order>;
	getOrganization?: Maybe<Organization>;
	/** Get organization active activities (Organization users only) */
	getOrganizationActiveActivities: OrganizationActiveActivities;
	getOrganizationAddresses: Array<OrganizationAddress>;
	getOrganizationApprovalAndMargin?: Maybe<OrganizationApprovalAndMargin>;
	getOrganizationCompliance?: Maybe<OrganizationCompliance>;
	getOrganizationComplianceConnection?: Maybe<OrganizationComplianceConnection>;
	getOrganizationComplianceConnections: OrganizationComplianceConnectionListResponse;
	getOrganizationCompliances: OrganizationComplianceListResponse;
	getOrganizationProductInterest?: Maybe<OrganizationProductInterest>;
	getOrganizationProductInterests: OrganizationProductInterestListResponse;
	getOrganizationSetting?: Maybe<OrganizationSetting>;
	getOrganizationSourcingPreference?: Maybe<OrganizationSourcingPreference>;
	getOrganizationSourcingPreferenceConnection?: Maybe<OrganizationSourcingPreferenceConnection>;
	getOrganizationSourcingPreferenceConnections: OrganizationSourcingPreferenceConnectionListResponse;
	getOrganizationSourcingPreferences: OrganizationSourcingPreferenceListResponse;
	/** Admin-only: system-wide aggregate statistics across all client organizations. */
	getOrganizationStats: OrganizationStats;
	getOrganizationUser?: Maybe<OrganizationUser>;
	getOrganizationUserAvatarDownloadUrl: DownloadUrlResponse;
	/** Aggregate organization user counts by status, scoped to an organization. */
	getOrganizationUserStats: OrganizationUserStats;
	getPantoneBooks: Array<PantoneBookInfo>;
	getPantoneColor: PantoneColor;
	getPaymentTransaction?: Maybe<PaymentTransaction>;
	getPlaceDetails?: Maybe<PlaceDetails>;
	getProduct: Product;
	getProductImageDownloadUrl: ImageUploadResponse;
	/**
	 * What a production invoice would come to. Defaults to every product the client may pay for
	 * right now — pass orderItemIds to price a subset instead, for paying one product at a time.
	 *
	 * An id that is not currently payable (already paid, cancelled, or waiting on its sample)
	 * returns the empty preview rather than a trimmed one: the same rule createOrderPayment
	 * enforces, so nothing can be priced that would then be refused.
	 */
	getProductPaymentPreview: ProductPaymentPreview;
	getProductPrices: Array<ProductPrice>;
	getProductSamplePrices: Array<ProductSamplePrice>;
	/** Admin-only: system-wide aggregate statistics across all products. */
	getProductStats: ProductStats;
	getProductTag: ProductTag;
	getProject?: Maybe<Project>;
	getProjectProductsBySession: Array<ProjectProduct>;
	/** Where a message lives, for opening it from a bell or an email. Null when the caller cannot open it. */
	getQuoteProductCommentTarget?: Maybe<QuoteProductCommentTarget>;
	/** A thread's messages, oldest first. A supplier session may leave vetterEntityId out. */
	getQuoteProductComments: Array<QuoteProductComment>;
	/** Who can be tagged in a thread, studio people assigned to the quote first. */
	getQuoteProductMentionCandidates: Array<QuoteProductMentionCandidate>;
	/** Admin: every thread on a quote — per product, the studio notes plus one per supplier asked to price it — with counts. */
	getQuoteProductThreads: Array<QuoteProductThread>;
	/** Most recent order quotes, scoped by role (admin: all non-draft, vetter: by entity, org: own). */
	getRecentOrderQuotes: Array<OrderQuote>;
	/** Most recent orders, scoped by role. */
	getRecentOrders: Array<Order>;
	/**
	 * Where a sample lives, for resolving a /n/sample/:id notification link.
	 *
	 * Exists because a sample id alone cannot reach its order: nothing else on
	 * Query returns an OrderItemSample, so its orderItemId is unreachable, and
	 * every order entry point needs the order id that is being looked for.
	 *
	 * Returns null when the sample does not exist **or** is not visible to the
	 * caller — the two are deliberately indistinguishable, so a client cannot
	 * probe for the existence of samples outside their organisation.
	 */
	getSampleLocation?: Maybe<SampleLocation>;
	/**
	 * What a sample invoice would come to. Defaults to every sample currently payable — pass
	 * sampleIds to price a subset, for paying one product's sample at a time.
	 *
	 * An id that is not payable returns the empty preview rather than a trimmed one, mirroring
	 * createSamplePayment, so nothing can be priced that would then be refused.
	 */
	getSamplePaymentPreview: SamplePaymentPreview;
	/**
	 * Carriers the admin tracking form should offer. Held in code, not a database table, so the list
	 * and its tracking-URL templates stay in one place.
	 *
	 * The stored carrier is free text — rows predate this list and local couriers will never all be
	 * in it — so treat this as the picker's options, not a closed set.
	 */
	getShippingCarriers: Array<ShippingCarrier>;
	getStudioAgentTools: Array<StudioAgentTool>;
	getStudioFile?: Maybe<StudioFile>;
	getStudioFileChats: Array<StudioChat>;
	getStudioFileLock?: Maybe<StudioLock>;
	getStudioFileVersionTechPack?: Maybe<StudioFileVersionTechPack>;
	getStudioFileVersionTechPackById?: Maybe<StudioFileVersionTechPack>;
	getStudioFileVersions: Array<StudioFileVersion>;
	getStudioPromptTemplate?: Maybe<StudioPromptTemplate>;
	getStudioPromptTemplates: Array<StudioPromptTemplate>;
	/** Config for all subscription tiers (admin-editable rates). */
	getSubscriptionTierConfigs: Array<SubscriptionTierConfig>;
	getSystemSettings?: Maybe<AdminSystemSetting>;
	getVATFormat?: Maybe<Scalars['String']['output']>;
	getVetterEntity?: Maybe<VetterEntity>;
	/**
	 * A job — the lines to price, what has been submitted, and the order items and shipments that
	 * are the supplier's to act on once the client has ordered.
	 *
	 * A link session leaves id out and gets the job its link is for (passing its own id also
	 * works). A supplier account must pass id, and gets an error for a job of another supplier.
	 * Null for any other session.
	 */
	getVetterJob?: Maybe<VetterJob>;
	/** Admin-only: system-wide aggregate statistics across all vetters. */
	getVetterStats: VetterStats;
	getVetterUser?: Maybe<VetterUser>;
	isEUCountry: Scalars['Boolean']['output'];
	listEarlyAccessRequests: Array<EarlyAccessRequest>;
	/** Admin: messages sent through the public contact form, newest first. limit defaults to 50, at most 200. */
	listStudioMessages: Array<StudioMessage>;
	matchPantoneColor: Array<PantoneColorMatch>;
	/** Authoritative incl./excl. VAT preview for accepting a set of offer selections, split by pay-now (samples) vs pay-later (products+delivery). Handles multi-batch and subset selections. */
	previewAcceptOffers: AcceptOffersPreview;
	/**
	 * Admin: what applyVetterPrices would change, before and after, with nothing written. Same input,
	 * same checks and the same pricing calculation as the apply itself — call it whenever the
	 * picker's ticks change.
	 */
	previewApplyVetterPrices: ApplyVetterPricesPreview;
	/** Dry run of updateOrderQuoteItem's quantity list. Writes nothing. Feed it exactly the payload you intend to send and it reports, per tier, what would happen and what priced work is at stake — so an edited quantity is only ever kept or discarded on purpose. */
	previewOrderQuoteItemQuantityChange: OrderQuoteItemQuantityChangePreview;
	/** Stateless feasibility preview for an offer being composed — no batch needs to exist yet. Feed it the proposed production days, delivery options, and target deadline; get projected dates + a verdict per delivery. */
	previewOrderQuoteOfferFeasibility: PreviewOrderQuoteOfferFeasibilityResult;
	/**
	 * Dry run of syncOrderQuoteProducts. Writes nothing and copies no files. Reports per quote
	 * line what re-reading the catalogue would change and who is already looking at it — so an
	 * admin syncing a quote that has already gone out is never doing it blind.
	 */
	previewOrderQuoteProductSync: OrderQuoteProductSyncPreview;
	/**
	 * Admin-only: who would be emailed about this quote right now. Same rule the sends use, so
	 * it already accounts for nominated contacts, the fall back to everyone, and guest-link holders.
	 */
	previewQuoteRecipients?: Maybe<QuoteRecipientsPreview>;
	/**
	 * Admin: everything the send-price-request form needs once a supplier is picked — the
	 * supplier's people and how each would be reached, and a ready-to-show notice when this
	 * supplier already has a request on the quote.
	 */
	previewVetterPriceRequest: VetterPriceRequestPreview;
	remainingBackupCodes: Scalars['Int']['output'];
	root?: Maybe<Scalars['String']['output']>;
	searchBrandAssets: Array<BrandAsset>;
	/**
	 * The same suggestion keyed on the QUOTE LINE, for the create-offer wizard — which prices a tier
	 * before any offer exists to name.
	 *
	 * vetterEntityId is the supplier being quoted. Omit it, or pass null, and the house prices come
	 * back, which is the right answer before a supplier has been chosen. When that supplier has
	 * submitted prices for this line through a vetter link, those answer first (source VETTER)
	 * and the catalogue fills only the tiers they left out.
	 *
	 * inCurrency works as on suggestOrderQuoteOfferPricing.
	 */
	suggestOrderQuoteItemPricing: Array<CatalogPriceSuggestion>;
	/**
	 * The catalogue's sample price for a quote line, for prefilling the sample form in the
	 * create-offer wizard, where no offer exists yet. vetterEntityId is the supplier being quoted;
	 * omit it for the house price. Null when the catalogue has no sample price — leave the form
	 * empty, it is not a free sample. Read-only.
	 */
	suggestOrderQuoteItemSample?: Maybe<CatalogSampleSuggestion>;
	/**
	 * The catalogue's suggested cost for each of an offer's quantity tiers, for prefilling the
	 * pricing form. Read-only: nothing is written until the admin saves through
	 * setOrderQuoteOfferPricing. Tiers the catalogue cannot price are absent from the list.
	 *
	 * inCurrency is the currency the pricing form saves in. Pass it and every suggestion and ladder
	 * rung carries a converted block, so a price kept in another currency can still be used.
	 */
	suggestOrderQuoteOfferPricing: Array<CatalogPriceSuggestion>;
	/** The same, for an offer that already exists. It knows its own line and supplier. */
	suggestOrderQuoteOfferSample?: Maybe<CatalogSampleSuggestion>;
	validateAddress: AddressValidationResult;
	validateBusinessRegistration: ValidationResult;
	validateCVR: CvrValidationResult;
	validateOrderQuoteOfferBatchForClient?: Maybe<OrderQuoteOfferBatchValidationResult>;
	validateVAT: VatValidationResult;
};

export type QueryAddressAutocompleteArgs = {
	countryCode?: InputMaybe<Scalars['String']['input']>;
	input: Scalars['String']['input'];
	sessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCheckEmailExistsArgs = {
	email: Scalars['String']['input'];
};

export type QueryFindPantoneColorArgs = {
	book: PantoneBook;
	code: Scalars['String']['input'];
};

export type QueryFindPantoneColorAcrossBooksArgs = {
	code: Scalars['String']['input'];
};

export type QueryFormatVatNumberArgs = {
	countryCode: Scalars['String']['input'];
	rawNumber: Scalars['String']['input'];
};

export type QueryGenerateVatFromRegistrationArgs = {
	countryCode: Scalars['String']['input'];
	registrationNumber: Scalars['String']['input'];
	registrationType: Scalars['String']['input'];
};

export type QueryGetAdminActiveActivitiesArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetAdminUserArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetAllAdminAuthenticationUserArgs = {
	input: GetAllAdminAuthenticationUserInput;
};

export type QueryGetAllAdminUserArgs = {
	input: GetAllAdminUserInput;
};

export type QueryGetAllAuthorizationRoleArgs = {
	input: GetAllAuthorizationRoleInput;
};

export type QueryGetAllAuthorizationUserRoleArgs = {
	input: GetAllAuthorizationUserRoleInput;
};

export type QueryGetAllBrandArgs = {
	input: GetAllBrandInput;
};

export type QueryGetAllClientContactArgs = {
	input: GetAllClientContactInput;
};

export type QueryGetAllClientOrdersArgs = {
	input: GetAllClientOrdersInput;
};

export type QueryGetAllLoggingAuditLogArgs = {
	input: GetAllLoggingAuditLogInput;
};

export type QueryGetAllLoggingLoginLogArgs = {
	input: GetAllLoggingLoginLogInput;
};

export type QueryGetAllManufacturerArgs = {
	input: GetAllManufacturerInput;
};

export type QueryGetAllOrderQuoteArgs = {
	input: GetAllOrderQuoteInput;
};

export type QueryGetAllOrdersArgs = {
	input: GetAllOrdersInput;
};

export type QueryGetAllOrganizationArgs = {
	input: GetAllOrganizationInput;
};

export type QueryGetAllOrganizationUserArgs = {
	input: GetAllOrganizationUserInput;
};

export type QueryGetAllPantoneColorArgs = {
	input: GetAllPantoneColorInput;
};

export type QueryGetAllProductArgs = {
	input: GetAllProductInput;
};

export type QueryGetAllProductTagArgs = {
	input: GetAllProductTagInput;
};

export type QueryGetAllProjectsArgs = {
	input: GetAllProjectInput;
};

export type QueryGetAllStudioFileArgs = {
	input: GetAllStudioFileInput;
};

export type QueryGetAllVetterEntityArgs = {
	input: GetAllVetterEntityInput;
};

export type QueryGetAllVetterUserArgs = {
	input: GetAllVetterUserInput;
};

export type QueryGetAuthenticationUserArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetAuthorizationRoleArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetAuthorizationRoleByNameArgs = {
	name: Scalars['String']['input'];
};

export type QueryGetBrandArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetBrandAiContextArgs = {
	brandId: Scalars['ID']['input'];
};

export type QueryGetBrandFileDownloadUrlArgs = {
	brandId: Scalars['ID']['input'];
	fileId: Scalars['ID']['input'];
};

export type QueryGetBrandFontDownloadUrlArgs = {
	brandId: Scalars['ID']['input'];
	fontId: Scalars['ID']['input'];
};

export type QueryGetCheckoutSessionArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetClientAllOrderQuoteArgs = {
	input: ClientGetAllOrderQuoteInput;
};

export type QueryGetClientOrderArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetClientOrderQuoteArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetClientOrderQuoteOfferBatchesArgs = {
	orderQuoteId: Scalars['ID']['input'];
	previewBatchIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetClientOrdersArgs = {
	orderQuoteId: Scalars['ID']['input'];
};

export type QueryGetDesignSpecsByChatArgs = {
	studioChatId: Scalars['ID']['input'];
};

export type QueryGetDesignSpecsByVersionArgs = {
	studioFileVersionId: Scalars['ID']['input'];
};

export type QueryGetEarlyAccessByTokenArgs = {
	inviteToken: Scalars['String']['input'];
};

export type QueryGetEmailTemplatePreviewArgs = {
	key: Scalars['String']['input'];
};

export type QueryGetFullOrderPaymentPreviewArgs = {
	currency: Scalars['String']['input'];
	orderId: Scalars['ID']['input'];
};

export type QueryGetInvoicePdfUrlArgs = {
	invoiceNumber: Scalars['Int']['input'];
};

export type QueryGetLocalizationCountryArgs = {
	countryCode: Scalars['String']['input'];
};

export type QueryGetLocalizationDefaultsArgs = {
	placeId: Scalars['String']['input'];
};

export type QueryGetLocalizationOrganizationSettingArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryGetLocalizationStatesArgs = {
	countryCode: Scalars['String']['input'];
};

export type QueryGetManufacturerArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetMyAuthorizationUserRoleArgs = {
	input: GetMyAuthorizationUserRoleInput;
};

export type QueryGetMyKickbackTransactionsArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetMyNotificationsArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetMyVetterJobsArgs = {
	input: GetMyVetterJobsInput;
};

export type QueryGetOfferBatchLocationArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrderArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrderActivitiesArgs = {
	inCurrency?: InputMaybe<Scalars['String']['input']>;
	orderId: Scalars['ID']['input'];
};

export type QueryGetOrderPaymentArgs = {
	orderId: Scalars['ID']['input'];
};

export type QueryGetOrderQuoteArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrderQuoteActivitiesArgs = {
	inCurrency?: InputMaybe<Scalars['String']['input']>;
	orderQuoteId: Scalars['ID']['input'];
};

export type QueryGetOrderQuoteGuestAccessTokensArgs = {
	orderQuoteId: Scalars['ID']['input'];
};

export type QueryGetOrderQuoteItemByProductArgs = {
	orderQuoteId: Scalars['ID']['input'];
	productId: Scalars['ID']['input'];
};

export type QueryGetOrderQuoteOfferBatchArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrderQuoteOfferBatchesArgs = {
	orderQuoteId: Scalars['ID']['input'];
	statuses?: InputMaybe<Array<OrderQuoteOfferStatus>>;
};

export type QueryGetOrderQuoteStatsByStatusArgs = {
	dateRange?: InputMaybe<DateRangeInput>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetOrderQuoteValueRangeArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
	orderQuoteId: Scalars['ID']['input'];
};

export type QueryGetOrderQuoteValueRangesArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
	orderQuoteIds: Array<Scalars['ID']['input']>;
};

export type QueryGetOrderQuoteVetterJobsArgs = {
	orderQuoteId: Scalars['ID']['input'];
};

export type QueryGetOrderQuoteVetterLinksArgs = {
	orderQuoteId: Scalars['ID']['input'];
};

export type QueryGetOrderQuoteViewSummaryArgs = {
	orderQuoteId: Scalars['ID']['input'];
};

export type QueryGetOrderStatsArgs = {
	currency?: InputMaybe<CurrencyEnum>;
	dateRange?: InputMaybe<DateRangeInput>;
};

export type QueryGetOrderStatsByStatusArgs = {
	currency?: InputMaybe<CurrencyEnum>;
	dateRange?: InputMaybe<DateRangeInput>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetOrderTransactionsV2Args = {
	orderId: Scalars['ID']['input'];
};

export type QueryGetOrdersArgs = {
	orderQuoteId: Scalars['ID']['input'];
};

export type QueryGetOrganizationArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationActiveActivitiesArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetOrganizationAddressesArgs = {
	organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetOrganizationApprovalAndMarginArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryGetOrganizationComplianceArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationComplianceConnectionArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationComplianceConnectionsArgs = {
	input: OrganizationComplianceConnectionListInput;
};

export type QueryGetOrganizationCompliancesArgs = {
	input: OrganizationComplianceListInput;
};

export type QueryGetOrganizationProductInterestArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationProductInterestsArgs = {
	input: OrganizationProductInterestListInput;
};

export type QueryGetOrganizationSettingArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryGetOrganizationSourcingPreferenceArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationSourcingPreferenceConnectionArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationSourcingPreferenceConnectionsArgs = {
	input: OrganizationSourcingPreferenceConnectionListInput;
};

export type QueryGetOrganizationSourcingPreferencesArgs = {
	input: OrganizationSourcingPreferenceListInput;
};

export type QueryGetOrganizationUserArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryGetOrganizationUserAvatarDownloadUrlArgs = {
	input: GetDownloadUrlInput;
};

export type QueryGetOrganizationUserStatsArgs = {
	input?: InputMaybe<GetOrganizationUserStatsInput>;
};

export type QueryGetPantoneColorArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetPaymentTransactionArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetPlaceDetailsArgs = {
	placeId: Scalars['String']['input'];
	sessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetProductArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetProductImageDownloadUrlArgs = {
	imageId: Scalars['ID']['input'];
	productId: Scalars['ID']['input'];
};

export type QueryGetProductPaymentPreviewArgs = {
	currency: Scalars['String']['input'];
	orderId: Scalars['ID']['input'];
	orderItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetProductPricesArgs = {
	input: GetProductPricesInput;
};

export type QueryGetProductSamplePricesArgs = {
	input: GetProductSamplePricesInput;
};

export type QueryGetProductTagArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetProjectArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetProjectProductsBySessionArgs = {
	projectId?: InputMaybe<Scalars['ID']['input']>;
	sessionId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetQuoteProductCommentTargetArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetQuoteProductCommentsArgs = {
	input: QuoteProductThreadInput;
};

export type QueryGetQuoteProductMentionCandidatesArgs = {
	input: QuoteProductThreadInput;
};

export type QueryGetQuoteProductThreadsArgs = {
	orderQuoteId: Scalars['ID']['input'];
};

export type QueryGetRecentOrderQuotesArgs = {
	dateRange?: InputMaybe<DateRangeInput>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetRecentOrdersArgs = {
	dateRange?: InputMaybe<DateRangeInput>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetSampleLocationArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetSamplePaymentPreviewArgs = {
	currency: Scalars['String']['input'];
	orderId: Scalars['ID']['input'];
	sampleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetStudioAgentToolsArgs = {
	agentType: StudioAgentType;
};

export type QueryGetStudioFileArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetStudioFileChatsArgs = {
	studioFileId: Scalars['ID']['input'];
};

export type QueryGetStudioFileLockArgs = {
	studioFileId: Scalars['ID']['input'];
};

export type QueryGetStudioFileVersionTechPackArgs = {
	studioFileVersionId: Scalars['ID']['input'];
};

export type QueryGetStudioFileVersionTechPackByIdArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetStudioFileVersionsArgs = {
	studioFileId: Scalars['ID']['input'];
};

export type QueryGetStudioPromptTemplateArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetStudioPromptTemplatesArgs = {
	agentType?: InputMaybe<StudioAgentType>;
};

export type QueryGetVatFormatArgs = {
	countryCode: Scalars['String']['input'];
};

export type QueryGetVetterEntityArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetVetterJobArgs = {
	id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetVetterUserArgs = {
	id: Scalars['ID']['input'];
};

export type QueryIsEuCountryArgs = {
	countryCode: Scalars['String']['input'];
};

export type QueryListEarlyAccessRequestsArgs = {
	status?: InputMaybe<EarlyAccessStatusEnum>;
};

export type QueryListStudioMessagesArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryMatchPantoneColorArgs = {
	input: MatchPantoneColorInput;
};

export type QueryPreviewAcceptOffersArgs = {
	input: PreviewAcceptOffersInput;
};

export type QueryPreviewApplyVetterPricesArgs = {
	input: ApplyVetterPricesInput;
};

export type QueryPreviewOrderQuoteItemQuantityChangeArgs = {
	orderQuoteItemId: Scalars['ID']['input'];
	quantities: Array<OrderQuoteItemQuantityInput>;
};

export type QueryPreviewOrderQuoteOfferFeasibilityArgs = {
	input: PreviewOrderQuoteOfferFeasibilityInput;
};

export type QueryPreviewOrderQuoteProductSyncArgs = {
	orderQuoteId: Scalars['ID']['input'];
};

export type QueryPreviewQuoteRecipientsArgs = {
	orderQuoteId: Scalars['ID']['input'];
};

export type QueryPreviewVetterPriceRequestArgs = {
	orderQuoteId: Scalars['ID']['input'];
	vetterEntityId: Scalars['ID']['input'];
};

export type QueryRemainingBackupCodesArgs = {
	userId: Scalars['ID']['input'];
};

export type QuerySearchBrandAssetsArgs = {
	brandId: Scalars['ID']['input'];
	context?: InputMaybe<Array<Scalars['String']['input']>>;
	query: Scalars['String']['input'];
};

export type QuerySuggestOrderQuoteItemPricingArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
	orderQuoteItemId: Scalars['ID']['input'];
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerySuggestOrderQuoteItemSampleArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
	orderQuoteItemId: Scalars['ID']['input'];
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerySuggestOrderQuoteOfferPricingArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
	orderQuoteOfferId: Scalars['ID']['input'];
};

export type QuerySuggestOrderQuoteOfferSampleArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
	orderQuoteOfferId: Scalars['ID']['input'];
};

export type QueryValidateAddressArgs = {
	placeId: Scalars['String']['input'];
};

export type QueryValidateBusinessRegistrationArgs = {
	countryCode: Scalars['String']['input'];
	registrationNumber: Scalars['String']['input'];
	registrationType: Scalars['String']['input'];
};

export type QueryValidateCvrArgs = {
	cvrNumber: Scalars['String']['input'];
};

export type QueryValidateOrderQuoteOfferBatchForClientArgs = {
	id: Scalars['ID']['input'];
};

export type QueryValidateVatArgs = {
	countryCode?: InputMaybe<Scalars['String']['input']>;
	vatNumber: Scalars['String']['input'];
};

export type QuoteProductComment = {
	__typename?: 'QuoteProductComment';
	attachments: Array<QuoteProductCommentAttachment>;
	author: QuoteProductCommentAuthor;
	/** Plain text; a tag is the token <@userId>. Render tags from mentions. Empty once deleted. */
	body: Scalars['String']['output'];
	canDelete: Scalars['Boolean']['output'];
	canEdit: Scalars['Boolean']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deletedAt?: Maybe<Scalars['DateTime']['output']>;
	editedAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	isMine: Scalars['Boolean']['output'];
	mentions: Array<QuoteProductCommentMention>;
	orderQuoteItemId: Scalars['ID']['output'];
	vetterEntityId?: Maybe<Scalars['ID']['output']>;
};

export type QuoteProductCommentAttachment = {
	__typename?: 'QuoteProductCommentAttachment';
	mimeType: Scalars['String']['output'];
	name: Scalars['String']['output'];
	size: Scalars['Int']['output'];
	/** Signed and short-lived; do not store it. */
	url?: Maybe<Scalars['String']['output']>;
};

export type QuoteProductCommentAttachmentInput = {
	/** From generateQuoteProductCommentUploadUrl. */
	blobUrl: Scalars['String']['input'];
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
};

export type QuoteProductCommentAuthor = {
	__typename?: 'QuoteProductCommentAuthor';
	name: Scalars['String']['output'];
	side: QuoteProductCommentSide;
	userId: Scalars['ID']['output'];
};

export type QuoteProductCommentMention = {
	__typename?: 'QuoteProductCommentMention';
	name: Scalars['String']['output'];
	userId: Scalars['ID']['output'];
};

export enum QuoteProductCommentSide {
	Studio = 'STUDIO',
	Supplier = 'SUPPLIER',
}

export type QuoteProductCommentTarget = {
	__typename?: 'QuoteProductCommentTarget';
	orderQuoteId: Scalars['ID']['output'];
	orderQuoteItemId: Scalars['ID']['output'];
	/** Null for studio notes. */
	vetterEntityId?: Maybe<Scalars['ID']['output']>;
	/** For a supplier: the price request to open. Null for the studio. */
	vetterJobId?: Maybe<Scalars['ID']['output']>;
};

export type QuoteProductCommentUploadUrlResponse = {
	__typename?: 'QuoteProductCommentUploadUrlResponse';
	blobUrl?: Maybe<Scalars['String']['output']>;
	expiresAt?: Maybe<Scalars['DateTime']['output']>;
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
	uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type QuoteProductMentionCandidate = {
	__typename?: 'QuoteProductMentionCandidate';
	name: Scalars['String']['output'];
	side: QuoteProductCommentSide;
	/** Ready to show under the name. */
	subtitle: Scalars['String']['output'];
	userId: Scalars['ID']['output'];
};

export type QuoteProductThread = {
	__typename?: 'QuoteProductThread';
	/** Messages, deleted ones excluded. */
	commentCount: Scalars['Int']['output'];
	/** Stable key for the thread. */
	id: Scalars['ID']['output'];
	kind: QuoteProductThreadKind;
	lastCommentAt?: Maybe<Scalars['DateTime']['output']>;
	orderQuoteItemId: Scalars['ID']['output'];
	productName?: Maybe<Scalars['String']['output']>;
	/** Messages from others the caller has not read yet. */
	unreadCount: Scalars['Int']['output'];
	vetterEntity?: Maybe<VetterEntity>;
	vetterEntityId?: Maybe<Scalars['ID']['output']>;
};

export type QuoteProductThreadEvent = {
	__typename?: 'QuoteProductThreadEvent';
	/** The message as it is now — for DELETED, already emptied and with deletedAt set. */
	comment: QuoteProductComment;
	kind: QuoteProductThreadEventKind;
};

export enum QuoteProductThreadEventKind {
	Added = 'ADDED',
	Deleted = 'DELETED',
	Edited = 'EDITED',
}

export type QuoteProductThreadInput = {
	orderQuoteItemId: Scalars['ID']['input'];
	/** The supplier. Leave out for studio notes; a supplier session may always leave it out. */
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
};

export enum QuoteProductThreadKind {
	/** The studio's own notes on the product. Never shown to a supplier. */
	Studio = 'STUDIO',
	/** Between the studio and one supplier. */
	Supplier = 'SUPPLIER',
}

export type QuoteRecipientsPreview = {
	__typename?: 'QuoteRecipientsPreview';
	/** The addresses that would be emailed, de-duplicated. Empty when nobody can be resolved. */
	emails: Array<Scalars['String']['output']>;
	/** True when the nominated contacts were used. False means everyone at the client organisation. */
	nominated: Scalars['Boolean']['output'];
};

export type RecordOrderBankTransferInput = {
	note?: InputMaybe<Scalars['String']['input']>;
	orderId: Scalars['ID']['input'];
	/** PRODUCTS only: the products the transfer paid for. */
	orderItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	/** The date the money landed, YYYY-MM-DD. */
	receivedOn: Scalars['String']['input'];
	/** Statement text or reference the transfer arrived with. */
	reference: Scalars['String']['input'];
	scope: BankTransferScope;
	/** Also email the booked invoice to the client. Off by default — they have already paid. */
	sendInvoice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordOrderBankTransferResponse = {
	__typename?: 'RecordOrderBankTransferResponse';
	economicBookedInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	paymentTransactionId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
};

export type RegenerateBackupCodesInput = {
	mfaToken: Scalars['String']['input'];
	password: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type RegisterInput = {
	mfaMethod: MfaMethodEnum;
	password: Scalars['String']['input'];
	token: Scalars['String']['input'];
};

export type RegisterResponse = {
	__typename?: 'RegisterResponse';
	qrCodeDataURL?: Maybe<Scalars['String']['output']>;
	userId?: Maybe<Scalars['ID']['output']>;
};

export type RejectOrderQuoteOfferBatchInput = {
	batchId: Scalars['ID']['input'];
	reason: Scalars['String']['input'];
};

export type RejectOrderQuoteOfferInput = {
	offerId: Scalars['ID']['input'];
	reason: Scalars['String']['input'];
};

export type RemixProductToStudioInput = {
	additionalReferenceImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	productId: Scalars['ID']['input'];
	userPrompt?: InputMaybe<Scalars['String']['input']>;
};

export type RemixProductToStudioResponse = {
	__typename?: 'RemixProductToStudioResponse';
	message?: Maybe<Scalars['String']['output']>;
	studioFileId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
};

export type RemoveMetadataAttachmentInput = {
	attachmentIndex: Scalars['Int']['input'];
	metadataId: Scalars['ID']['input'];
};

export type RemovePermissionsFromRoleInput = {
	permissionIds: Array<Scalars['ID']['input']>;
	roleId: Scalars['ID']['input'];
};

export type RequestEarlyAccessInput = {
	companyName: Scalars['String']['input'];
	/** Free text, as typed. Optional. */
	country?: InputMaybe<Scalars['String']['input']>;
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	/** What they make. Zero or more. Optional. */
	makes?: InputMaybe<Array<EarlyAccessMakeEnum>>;
	/** Anything we should know. Optional, up to 2000 characters. */
	note?: InputMaybe<Scalars['String']['input']>;
	/** Free text, as typed (for example 4 people). Optional. */
	teamSize?: InputMaybe<Scalars['String']['input']>;
};

export type RequestGuestQuoteAccessCodeInput = {
	/** The email the guest typed — must match the nominated address for a code to be sent. */
	email: Scalars['String']['input'];
	/** The opaque token from the acceptance link (the ?token= query param). */
	token: Scalars['String']['input'];
};

export type RequestVetterJobAccessCodeInput = {
	/** The email the supplier typed. A code is sent only when it matches the address on the link. */
	email: Scalars['String']['input'];
	/** The opaque token from the link (the token query parameter). */
	token: Scalars['String']['input'];
};

export type ResponseError = {
	__typename?: 'ResponseError';
	code?: Maybe<Scalars['String']['output']>;
	details?: Maybe<Scalars['String']['output']>;
	field?: Maybe<Scalars['String']['output']>;
	index?: Maybe<Scalars['Int']['output']>;
	message: Scalars['String']['output'];
};

export enum SampleActionActor {
	Admin = 'ADMIN',
	Client = 'CLIENT',
}

export enum SampleActionType {
	ApproveNewRound = 'APPROVE_NEW_ROUND',
	/**
	 * Correct a physical sample's carrier, tracking or dates without moving it. Offered while the
	 * sample is in transit and once it has arrived; never on a virtual one, which has no journey to
	 * correct. Send it through updateSampleStatus with status OMITTED.
	 */
	EditDetails = 'EDIT_DETAILS',
	/**
	 * Add more files to a virtual sample's delivery, or remove one, after it has been submitted.
	 *
	 * A virtual delivery is not one image. Angles get added, a bad render gets replaced, and the
	 * client asks to see something else — all while the sample sits awaiting their review. Until
	 * now the only action carrying VIRTUAL_DELIVERY attachments was the submit itself, so the moment
	 * it was taken there was nothing left saying more files could be added.
	 *
	 * It moves nothing. Upload through generateSampleAttachmentUploadUrl and
	 * confirmSampleAttachmentUploads, remove through deleteSampleAttachment, exactly as during the
	 * submit — this only says the affordance is still open.
	 */
	ManageVirtualDeliveryFiles = 'MANAGE_VIRTUAL_DELIVERY_FILES',
	/** Client: pay for this sample on its own. Send its id to createSamplePayment. Blocked, with a reason, while it cannot be paid for. */
	PaySample = 'PAY_SAMPLE',
	/** Change how the sample is paid for — charged / prepaid / waived. Does not move the sample's status. */
	SetPaymentTreatment = 'SET_PAYMENT_TREATMENT',
	UpdateStatus = 'UPDATE_STATUS',
}

/**
 * The chain from a sample to the order it sits on. orderItemId is included so
 * the client app can deep-link to the specific sample within the order page
 * once it has an anchor for one, without needing another round trip.
 */
export type SampleLocation = {
	__typename?: 'SampleLocation';
	orderId: Scalars['ID']['output'];
	orderItemId: Scalars['ID']['output'];
	sampleId: Scalars['ID']['output'];
};

export type SampleNextAction = {
	__typename?: 'SampleNextAction';
	action: SampleActionType;
	actor: SampleActionActor;
	/** If true, this action cannot be performed yet */
	blocked?: Maybe<Scalars['Boolean']['output']>;
	/** Reason why the action is blocked */
	blockedReason?: Maybe<Scalars['String']['output']>;
	/** Whether the required attachments already exist (null if requiresAttachments is null) */
	hasAttachments?: Maybe<Scalars['Boolean']['output']>;
	/** Whether this is the pending move, a property change, or an escape. Read this rather than inferring it from status. */
	kind: ActionKind;
	label: Scalars['String']['output'];
	optionalFields: Array<Scalars['String']['output']>;
	requiredFields: Array<Scalars['String']['output']>;
	/** If set, at least one attachment of this type must exist before this transition is allowed */
	requiresAttachments?: Maybe<OrderSampleAttachmentType>;
	/** The status this action moves the sample to. Null for actions that change a property without moving the sample (SET_PAYMENT_TREATMENT). */
	status?: Maybe<OrderSampleStatus>;
	/** If set, attachments of this type can optionally be added before this transition */
	supportsAttachments?: Maybe<OrderSampleAttachmentType>;
	/**
	 * A reason to hesitate, not a reason to refuse: the action WILL go through.
	 *
	 * Starting production before the money is in is a commercial risk the studio is allowed to
	 * take — sometimes the client is good for it and the factory slot is today. Blocking that put
	 * the software in charge of a judgement call it cannot make, so these say what is at stake and
	 * let a human decide. Show it on the confirm step; do not disable the button.
	 *
	 * Null when there is nothing to warn about. Distinct from blockedReason, which means the action
	 * cannot happen at all.
	 */
	warningReason?: Maybe<Scalars['String']['output']>;
};

export type SamplePayment = Base & {
	__typename?: 'SamplePayment';
	createdAt: Scalars['DateTime']['output'];
	currency: CurrencyEnum;
	description?: Maybe<Scalars['String']['output']>;
	economicMirror?: Maybe<SamplePaymentEconomicMirror>;
	id: Scalars['ID']['output'];
	invoice?: Maybe<SamplePaymentInvoice>;
	invoices: Array<SamplePaymentInvoice>;
	orderItemId: Scalars['ID']['output'];
	paidAt?: Maybe<Scalars['DateTime']['output']>;
	paymentStatus: SamplePaymentStatus;
	sampleId: Scalars['ID']['output'];
	samplePrice: Scalars['Float']['output'];
	shippingPrice: Scalars['Float']['output'];
	totalPrice: Scalars['Float']['output'];
	updatedAt: Scalars['DateTime']['output'];
};

export type SamplePaymentEconomicMirror = Base & {
	__typename?: 'SamplePaymentEconomicMirror';
	attempts: Scalars['Int']['output'];
	createdAt: Scalars['DateTime']['output'];
	economicBookedInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	economicPdfUrl?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	lastError?: Maybe<Scalars['String']['output']>;
	status: SamplePaymentEconomicMirrorStatus;
	updatedAt: Scalars['DateTime']['output'];
};

export enum SamplePaymentEconomicMirrorStatus {
	Failed = 'failed',
	Pending = 'pending',
	Succeeded = 'succeeded',
}

export type SamplePaymentInvoice = Base & {
	__typename?: 'SamplePaymentInvoice';
	attempts: Scalars['Int']['output'];
	createdAt: Scalars['DateTime']['output'];
	economicBookedInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	economicPdfUrl?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	lastError?: Maybe<Scalars['String']['output']>;
	paidAt?: Maybe<Scalars['DateTime']['output']>;
	paidVia?: Maybe<SamplePaymentInvoicePaidVia>;
	status: SamplePaymentInvoiceStatus;
	updatedAt: Scalars['DateTime']['output'];
};

/** How a sample invoice ended up marked paid — poller vs admin override. */
export enum SamplePaymentInvoicePaidVia {
	AdminManual = 'admin_manual',
	Poller = 'poller',
}

/** samplePaymentInvoice (bank-transfer) lifecycle — separate from samplePayment. */
export enum SamplePaymentInvoiceStatus {
	Booked = 'booked',
	Cancelled = 'cancelled',
	Failed = 'failed',
	Paid = 'paid',
	Pending = 'pending',
}

export type SamplePaymentItemInput = {
	name: Scalars['String']['input'];
	orderItemId: Scalars['ID']['input'];
	price: Scalars['Float']['input'];
	sampleId: Scalars['ID']['input'];
};

export type SamplePaymentPreview = {
	__typename?: 'SamplePaymentPreview';
	currency: Scalars['String']['output'];
	/** Net total (ex-VAT): sample prices + shipping. */
	grandTotal: Scalars['Float']['output'];
	/** grandTotal + vatAmount (incl. VAT). */
	grossAmount: Scalars['Float']['output'];
	items: Array<SamplePaymentPreviewLine>;
	/** VAT on grandTotal. */
	vatAmount: Scalars['Float']['output'];
	/** Applied VAT (moms) rate as a percentage. */
	vatRate: Scalars['Float']['output'];
};

export type SamplePaymentPreviewLine = {
	__typename?: 'SamplePaymentPreviewLine';
	description: Scalars['String']['output'];
	orderItemId: Scalars['ID']['output'];
	sampleId: Scalars['ID']['output'];
	/** What the sample itself is billed at, excluding freight. Never the internal fee alone. */
	samplePrice: Scalars['Float']['output'];
	/** Shipping cost for this sample (0 when not shipped). */
	shippingPrice: Scalars['Float']['output'];
};

/** samplePayment lifecycle. */
export enum SamplePaymentStatus {
	Failed = 'failed',
	Invoiced = 'invoiced',
	Paid = 'paid',
	Refunded = 'refunded',
	Unpaid = 'unpaid',
	Waived = 'waived',
}

/**
 * How a sample is paid for. One value, because these are three mutually exclusive commercial terms —
 * two booleans could express a fourth, meaningless combination (waived AND credited).
 */
export enum SamplePaymentTreatment {
	/** Client pays for the sample and keeps paying for it. An additional cost on top of the order. */
	Charged = 'CHARGED',
	/** Client pays up front, and it is credited against their production invoice. Net zero — a prepayment. */
	Prepaid = 'PREPAID',
	/** Client is never charged for the sample. */
	Waived = 'WAIVED',
}

export type SaveOfferBatchSelectionInput = {
	batchId: Scalars['ID']['input'];
	selections: Array<AcceptOrderQuoteOfferSelectionInput>;
};

export type SaveOrganizationLogoInput = {
	/** Blob URL of the cropped image. */
	logo: Scalars['String']['input'];
	organizationId: Scalars['ID']['input'];
	/** Blob URL of the original (uncropped) image. */
	originalLogo: Scalars['String']['input'];
};

export type SendChatMessageInput = {
	content: Scalars['String']['input'];
	maskImage?: InputMaybe<Scalars['String']['input']>;
	maskImagePreview?: InputMaybe<Scalars['String']['input']>;
	referenceImages?: InputMaybe<Array<Scalars['String']['input']>>;
	studioFileId: Scalars['ID']['input'];
};

export type SendChatMessageResponse = {
	__typename?: 'SendChatMessageResponse';
	message: StudioChat;
	toolsUsed?: Maybe<Array<Scalars['String']['output']>>;
	versionCreated: Scalars['Boolean']['output'];
};

export type SendStudioMessageInput = {
	companyName?: InputMaybe<Scalars['String']['input']>;
	email: Scalars['String']['input'];
	/** Up to 5000 characters. */
	message: Scalars['String']['input'];
	/** First and last name, in one field. */
	name: Scalars['String']['input'];
	/** Spam trap. Render it hidden and leave it empty: people never fill it in, bots do. */
	website?: InputMaybe<Scalars['String']['input']>;
};

export type SendVetterPriceRequestInput = {
	orderQuoteId: Scalars['ID']['input'];
	/** The quote lines to price. At least one, all on this quote. */
	orderQuoteItemIds: Array<Scalars['ID']['input']>;
	/** Send to an address that is not one of the supplier's people yet. They join the supplier when they open the link. */
	recipientEmail?: InputMaybe<Scalars['String']['input']>;
	/** Send to one of the supplier's people. Leave out both recipient fields to email and notify everyone at the supplier with an account. */
	recipientVetterUserId?: InputMaybe<Scalars['ID']['input']>;
	vetterEntityId: Scalars['ID']['input'];
};

export type SendVetterPriceRequestResponse = {
	__typename?: 'SendVetterPriceRequestResponse';
	/** Who was emailed, comma-separated when every account holder was. Null when nobody was. */
	email?: Maybe<Scalars['String']['output']>;
	/** The secure link, when the recipient was reached by link — so the admin can also share it. Null for an account holder. */
	link?: Maybe<Scalars['String']['output']>;
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
	/** The job, created or updated. Null on failure. */
	vetterJobId?: Maybe<Scalars['ID']['output']>;
};

export type SetNotificationSettingInput = {
	bellEnabled?: InputMaybe<Scalars['Boolean']['input']>;
	emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
	type: NotificationType;
};

export type SetOrderQuoteOfferPricingInput = {
	items: Array<SetOrderQuoteOfferPricingItemInput>;
	orderQuoteOfferId: Scalars['ID']['input'];
};

export type SetOrderQuoteOfferPricingItemInput = {
	baseUnitPrice: Scalars['Float']['input'];
	currency: Scalars['String']['input'];
	marginAmount?: InputMaybe<Scalars['Float']['input']>;
	marginAmountCurrency?: InputMaybe<Scalars['String']['input']>;
	/** Markup on cost: price = cost x (1 + markup/100). Mutually exclusive with marginAmount and unitSalePrice. */
	markupPercentage?: InputMaybe<Scalars['Float']['input']>;
	maxProductionDays?: InputMaybe<Scalars['Int']['input']>;
	minProductionDays?: InputMaybe<Scalars['Int']['input']>;
	orderQuoteItemQuantityId: Scalars['ID']['input'];
	/**
	 * Price the tier the way e-conomic does: state what the client pays and let the markup fall out
	 * of it, rather than stating a markup and letting the price fall out.
	 *
	 * Given in the same currency as baseUnitPrice. The stored figures are identical
	 * either way — this only changes which end you enter from. Mutually exclusive with
	 * markupPercentage and marginAmount; a sale price below cost is rejected.
	 */
	unitSalePrice?: InputMaybe<Scalars['Float']['input']>;
};

export type SetOrganizationInvoiceRecipientsInput = {
	/** Target org. Used by ADMIN callers; ignored for ORGANIZATION users (their own org is derived from membership). */
	organizationId: Scalars['ID']['input'];
	/** Full recipient list. Replaces the existing list. Pass [] to clear. */
	recipients: Array<OrganizationInvoiceRecipientInput>;
};

/**
 * Send every tier in the currency the admin sees, edited or not. A tier whose figures match what
 * is stored, once converted into the currency it arrives in, is left exactly as stored: same
 * amount, same currency. So saving a ladder nobody touched re-prices nothing, whatever currency
 * the admin is viewing in. Only a figure that actually changed is stored in the currency it was
 * sent in.
 */
export type SetProductPricesInput = {
	productId: Scalars['ID']['input'];
	tiers: Array<ProductPriceTierInput>;
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Send both amounts in the currency the admin sees, edited or not. When they match what is stored,
 * once converted into that currency, the row keeps its stored amounts and currency — so saving a
 * row nobody re-priced, e.g. to change only its days, re-prices nothing.
 */
export type SetProductSamplePriceInput = {
	currency: Scalars['String']['input'];
	deliveryDaysMax?: InputMaybe<Scalars['Int']['input']>;
	deliveryDaysMin?: InputMaybe<Scalars['Int']['input']>;
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	maxProductionDays?: InputMaybe<Scalars['Int']['input']>;
	minProductionDays?: InputMaybe<Scalars['Int']['input']>;
	productId: Scalars['ID']['input'];
	samplePrice: Scalars['Float']['input'];
	/** Omit or null for no known freight. */
	shippingPrice?: InputMaybe<Scalars['Float']['input']>;
	validFrom?: InputMaybe<Scalars['DateTime']['input']>;
	validTo?: InputMaybe<Scalars['DateTime']['input']>;
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
};

export type SetQuoteClientContactsInput = {
	orderQuoteId: Scalars['ID']['input'];
	/** organizationUser ids of full members of the quote's organisation. Empty clears the list. */
	organizationUserIds: Array<Scalars['ID']['input']>;
};

export type SetQuotePaymentSettingsInput = {
	invoiceMinimum?: InputMaybe<Scalars['Float']['input']>;
	orderQuoteId: Scalars['ID']['input'];
	productPaymentMode?: InputMaybe<PaymentModeEnum>;
	samplePaymentMode?: InputMaybe<PaymentModeEnum>;
	stripeCheckoutLimit?: InputMaybe<Scalars['Float']['input']>;
};

export type ShippingCarrier = {
	__typename?: 'ShippingCarrier';
	/** Stable identifier. Write this to a shipment's carrier when picked from the list. */
	code: Scalars['String']['output'];
	/** Display name. */
	name: Scalars['String']['output'];
	/** True when a tracking link can be built for this carrier, so the form can say so. */
	supportsTracking: Scalars['Boolean']['output'];
};

export type SignupAddressInput = {
	addressLine1: Scalars['String']['input'];
	addressLine2?: InputMaybe<Scalars['String']['input']>;
	city: Scalars['String']['input'];
	countryCode: Scalars['String']['input'];
	googlePlaceId?: InputMaybe<Scalars['String']['input']>;
	latitude?: InputMaybe<Scalars['Float']['input']>;
	longitude?: InputMaybe<Scalars['Float']['input']>;
	postalCode: Scalars['String']['input'];
	stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type SpecificationCapacity = {
	__typename?: 'SpecificationCapacity';
	unit: Scalars['String']['output'];
	value: Scalars['Float']['output'];
};

export type SpecificationCapacityInput = {
	unit: Scalars['String']['input'];
	value: Scalars['Float']['input'];
};

export type SpecificationDimensions = {
	__typename?: 'SpecificationDimensions';
	depth?: Maybe<Scalars['Float']['output']>;
	diameter?: Maybe<Scalars['Float']['output']>;
	height?: Maybe<Scalars['Float']['output']>;
	unit: Scalars['String']['output'];
	width?: Maybe<Scalars['Float']['output']>;
};

export type SpecificationDimensionsInput = {
	depth?: InputMaybe<Scalars['Float']['input']>;
	diameter?: InputMaybe<Scalars['Float']['input']>;
	height?: InputMaybe<Scalars['Float']['input']>;
	unit: Scalars['String']['input'];
	width?: InputMaybe<Scalars['Float']['input']>;
};

export type SpecificationWeight = {
	__typename?: 'SpecificationWeight';
	unit: Scalars['String']['output'];
	value: Scalars['Float']['output'];
};

export type SpecificationWeightInput = {
	unit: Scalars['String']['input'];
	value: Scalars['Float']['input'];
};

export type SplitOrderShipmentInput = {
	/**
	 * What moves out, in quantities this shipment already carries. A line may take part of a
	 * product's quantity or all of it; taking everything on the shipment is refused.
	 */
	lines: Array<SplitOrderShipmentLineInput>;
};

export type SplitOrderShipmentLineInput = {
	orderItemId: Scalars['ID']['input'];
	quantity: Scalars['Int']['input'];
};

export enum StatusEnum {
	Canceled = 'CANCELED',
	Completed = 'COMPLETED',
	Pending = 'PENDING',
}

export type StripeCheckoutSession = Base & {
	__typename?: 'StripeCheckoutSession';
	completedAt?: Maybe<Scalars['DateTime']['output']>;
	createdAt: Scalars['DateTime']['output'];
	currency: CurrencyEnum;
	expiresAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	orderId: Scalars['ID']['output'];
	samplePayments: Array<SamplePayment>;
	status: CheckoutSessionStatus;
	stripeSessionId: Scalars['String']['output'];
	totalAmount: Scalars['Float']['output'];
	updatedAt: Scalars['DateTime']['output'];
};

export type Studio = Base & {
	__typename?: 'Studio';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StudioAgentTool = {
	__typename?: 'StudioAgentTool';
	description: Scalars['String']['output'];
	name: Scalars['String']['output'];
	parameters: Scalars['String']['output'];
	supportedProviders: Array<Scalars['String']['output']>;
};

export enum StudioAgentType {
	Packaging = 'Packaging',
	Product = 'Product',
}

export type StudioChat = Base & {
	__typename?: 'StudioChat';
	chatType: StudioChatType;
	content: Scalars['String']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	maskImage?: Maybe<Scalars['String']['output']>;
	maskImagePreview?: Maybe<Scalars['String']['output']>;
	referenceImages?: Maybe<Array<Scalars['String']['output']>>;
	role: ChatRole;
	status: StudioChatStatus;
	studioFile: StudioFile;
	studioFileId: Scalars['ID']['output'];
	toolCalls?: Maybe<Array<ToolCall>>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum StudioChatStatus {
	Completed = 'completed',
	Failed = 'failed',
	Pending = 'pending',
	Processing = 'processing',
}

export enum StudioChatType {
	Reasoning = 'reasoning',
	Text = 'text',
}

export type StudioDesignSpec = {
	__typename?: 'StudioDesignSpec';
	appliesTo?: Maybe<Scalars['String']['output']>;
	assetPurpose?: Maybe<Scalars['String']['output']>;
	assetType?: Maybe<Scalars['String']['output']>;
	assetUrl?: Maybe<Scalars['String']['output']>;
	colorHex?: Maybe<Scalars['String']['output']>;
	colorName?: Maybe<Scalars['String']['output']>;
	confidence?: Maybe<Scalars['Float']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	derivationMethod?: Maybe<Scalars['String']['output']>;
	derivedFromSpec?: Maybe<StudioDesignSpec>;
	derivedFromSpecId?: Maybe<Scalars['ID']['output']>;
	fontFamily?: Maybe<Scalars['String']['output']>;
	fontSize?: Maybe<Scalars['Float']['output']>;
	id: Scalars['ID']['output'];
	metadata?: Maybe<Scalars['JSON']['output']>;
	placement?: Maybe<DesignSpecPlacement>;
	promptSnippet?: Maybe<Scalars['String']['output']>;
	specType: DesignSpecType;
	studioChatId?: Maybe<Scalars['ID']['output']>;
	studioFileVersionId: Scalars['ID']['output'];
	textContent?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StudioFile = Base & {
	__typename?: 'StudioFile';
	canvasBackgroundColor: Scalars['String']['output'];
	canvasHeight: Scalars['Int']['output'];
	canvasWidth: Scalars['Int']['output'];
	chats?: Maybe<Array<StudioChat>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	currentVersion?: Maybe<StudioFileVersion>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	isAutoGenerated: Scalars['Boolean']['output'];
	isGenerating: Scalars['Boolean']['output'];
	name?: Maybe<Scalars['String']['output']>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	ownerRole: AuthRoleEnum;
	productId?: Maybe<Scalars['ID']['output']>;
	sourceProductId?: Maybe<Scalars['ID']['output']>;
	status: StudioFileStatus;
	type: StudioFileType;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	versions?: Maybe<Array<StudioFileVersion>>;
};

export type StudioFileCreateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	referenceImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	status: StudioFileStatus;
	type: StudioFileType;
	userPrompt?: InputMaybe<Scalars['String']['input']>;
};

export type StudioFilePage = {
	__typename?: 'StudioFilePage';
	data: Array<StudioFile>;
	pageInfo: PageInfo;
};

export type StudioFileSpecs = {
	__typename?: 'StudioFileSpecs';
	materialType?: Maybe<Scalars['String']['output']>;
	weight?: Maybe<Scalars['Float']['output']>;
};

export type StudioFileSpecsInput = {
	materialType?: InputMaybe<Scalars['String']['input']>;
	weight?: InputMaybe<Scalars['Float']['input']>;
};

export enum StudioFileStatus {
	Active = 'ACTIVE',
	Archived = 'ARCHIVED',
	Inactive = 'INACTIVE',
}

export enum StudioFileType {
	LabelDesign = 'LABEL_DESIGN',
	Other = 'OTHER',
	PackagingDesign = 'PACKAGING_DESIGN',
	ProductDesign = 'PRODUCT_DESIGN',
}

export type StudioFileUpdateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<StudioFileStatus>;
	type?: InputMaybe<StudioFileType>;
};

export type StudioFileVersion = Base & {
	__typename?: 'StudioFileVersion';
	changeNotes?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	createdBy: Scalars['ID']['output'];
	designSpecs?: Maybe<Array<StudioDesignSpec>>;
	id: Scalars['ID']['output'];
	imageDescription?: Maybe<Scalars['String']['output']>;
	imageUrls: Array<Scalars['String']['output']>;
	metadata?: Maybe<Array<StudioFileVersionMetadata>>;
	name: Scalars['String']['output'];
	slug: Scalars['String']['output'];
	specifications?: Maybe<Array<StudioFileVersionSpecification>>;
	specs?: Maybe<StudioFileSpecs>;
	studioFile: StudioFile;
	studioFileId: Scalars['ID']['output'];
	techPack?: Maybe<StudioFileVersionTechPack>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	versionNumber: Scalars['Int']['output'];
};

export type StudioFileVersionMetadata = {
	__typename?: 'StudioFileVersionMetadata';
	attachments?: Maybe<Array<MetadataAttachment>>;
	canvasHeight: Scalars['Float']['output'];
	canvasWidth: Scalars['Float']['output'];
	comment?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	height?: Maybe<Scalars['Float']['output']>;
	id: Scalars['ID']['output'];
	points?: Maybe<Array<PolygonPoint>>;
	studioFileVersionId: Scalars['ID']['output'];
	type: MetadataType;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	width?: Maybe<Scalars['Float']['output']>;
	x?: Maybe<Scalars['Float']['output']>;
	y?: Maybe<Scalars['Float']['output']>;
};

export type StudioFileVersionSpecification = {
	__typename?: 'StudioFileVersionSpecification';
	capacity?: Maybe<SpecificationCapacity>;
	colors?: Maybe<Array<Scalars['String']['output']>>;
	confidence?: Maybe<Scalars['Float']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	dimensions?: Maybe<SpecificationDimensions>;
	elementName: Scalars['String']['output'];
	elementType?: Maybe<Scalars['String']['output']>;
	features?: Maybe<Array<Scalars['String']['output']>>;
	finish?: Maybe<Scalars['String']['output']>;
	generatedAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	material?: Maybe<Scalars['String']['output']>;
	secondaryMaterials?: Maybe<Array<Scalars['String']['output']>>;
	studioFileVersionId: Scalars['ID']['output'];
	textureDescription?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	weight?: Maybe<SpecificationWeight>;
};

export type StudioFileVersionTechPack = Base & {
	__typename?: 'StudioFileVersionTechPack';
	additionalNotes?: Maybe<Scalars['String']['output']>;
	colorways?: Maybe<Array<TechPackColorway>>;
	construction?: Maybe<TechPackConstruction>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	createdBy: Scalars['ID']['output'];
	dimensions?: Maybe<TechPackDimensions>;
	id: Scalars['ID']['output'];
	labeling?: Maybe<TechPackLabeling>;
	materials?: Maybe<TechPackMaterials>;
	packaging?: Maybe<TechPackPackaging>;
	qualityControl?: Maybe<TechPackQualityControl>;
	studioFileVersion: StudioFileVersion;
	studioFileVersionId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	updatedBy?: Maybe<Scalars['ID']['output']>;
};

export type StudioLock = {
	__typename?: 'StudioLock';
	expiresAt: Scalars['DateTime']['output'];
	lockedAt: Scalars['DateTime']['output'];
	studioFileId: Scalars['ID']['output'];
	userId: Scalars['ID']['output'];
};

export type StudioMessage = {
	__typename?: 'StudioMessage';
	companyName?: Maybe<Scalars['String']['output']>;
	createdAt: Scalars['String']['output'];
	email: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	message: Scalars['String']['output'];
	name: Scalars['String']['output'];
};

export type StudioPromptTemplate = Base & {
	__typename?: 'StudioPromptTemplate';
	agentType: StudioAgentType;
	category: StudioPromptTemplateCategory;
	content: Scalars['String']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	isActive: Scalars['Boolean']['output'];
	key: Scalars['String']['output'];
	provider?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	variables?: Maybe<Array<Scalars['String']['output']>>;
};

export enum StudioPromptTemplateCategory {
	System = 'System',
	Tool = 'Tool',
}

export type SubmitVetterJobPricesInput = {
	/** One currency for the whole submission, e.g. EUR or DKK. */
	currency: Scalars['String']['input'];
	lines: Array<VetterJobPriceLineInput>;
	/** Anything the studio should know — minimums, assumptions, validity. */
	note?: InputMaybe<Scalars['String']['input']>;
	/** The job. Required from a supplier account; a link session may leave it out. */
	vetterJobId?: InputMaybe<Scalars['ID']['input']>;
};

export type Subscription = {
	__typename?: 'Subscription';
	/** Fires when a notification is created for the signed-in user. */
	notificationAdded: Notification;
	/** Pass inCurrency as on getOrderQuoteActivities and money changes arrive converted. */
	orderQuoteActivityAdded?: Maybe<OrderQuoteActivity>;
	/**
	 * Admin: live counts for a quote's threads. Fires with the thread whose counts changed — a
	 * message posted or deleted, or the viewer reading it elsewhere — with unreadCount for the viewer.
	 */
	quoteProductThreadCountsUpdated: QuoteProductThread;
	/**
	 * Live changes to one thread: a message added, edited or deleted. Same access as reading it;
	 * the stream ends if the caller loses access (a link revoked, a request withdrawn).
	 */
	quoteProductThreadUpdated: QuoteProductThreadEvent;
	studioChatUpdated?: Maybe<StudioChat>;
	studioFileVersionAdded?: Maybe<StudioFileVersion>;
	studioLockChanged?: Maybe<StudioLock>;
	/**
	 * Supplier account: live changes to the caller's job list — a message or a read in one of their
	 * threads, a stage change, a new request, a withdrawal. One event per changed job, with values
	 * worked out for the viewer. Refused for link sessions, which have no job list.
	 */
	vetterJobUpdated: VetterJobUpdate;
};

export type SubscriptionOrderQuoteActivityAddedArgs = {
	inCurrency?: InputMaybe<Scalars['String']['input']>;
	orderQuoteId: Scalars['ID']['input'];
};

export type SubscriptionQuoteProductThreadCountsUpdatedArgs = {
	orderQuoteId: Scalars['ID']['input'];
};

export type SubscriptionQuoteProductThreadUpdatedArgs = {
	input: QuoteProductThreadInput;
};

export type SubscriptionStudioChatUpdatedArgs = {
	studioFileId: Scalars['ID']['input'];
};

export type SubscriptionStudioFileVersionAddedArgs = {
	studioFileId: Scalars['ID']['input'];
};

export type SubscriptionStudioLockChangedArgs = {
	studioFileId: Scalars['ID']['input'];
};

/**
 * Generic subscription-mutation result.
 *
 * For changeSubscriptionPlan on upgrades: if Stripe needs SCA/3DS to
 * charge the prorated diff, requiresAction is true and the frontend
 * confirms the payment using clientSecret.
 */
export type SubscriptionMutationResponse = {
	__typename?: 'SubscriptionMutationResponse';
	/** Breakdown of the plan change (prices, proration, VAT). Present on successful changeSubscriptionPlan. */
	breakdown?: Maybe<PlanChangeBreakdown>;
	clientSecret?: Maybe<Scalars['String']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	requiresAction?: Maybe<Scalars['Boolean']['output']>;
	subscription?: Maybe<OrganizationSubscription>;
	success: Scalars['Boolean']['output'];
};

export enum SubscriptionStatus {
	Active = 'active',
	Canceled = 'canceled',
	Incomplete = 'incomplete',
	IncompleteExpired = 'incomplete_expired',
	PastDue = 'past_due',
	Trialing = 'trialing',
	Unpaid = 'unpaid',
}

export enum SubscriptionTier {
	Creator = 'creator',
	Enterprise = 'enterprise',
	Pro = 'pro',
}

/**
 * Admin-editable config for each subscription tier.
 * Lets the operator adjust monthly price, kickback rate, token rate, and fee %
 * without a deploy.
 */
export type SubscriptionTierConfig = {
	__typename?: 'SubscriptionTierConfig';
	aiTokenRatePerMillion?: Maybe<Scalars['Float']['output']>;
	/** ISO 4217 currency code, lower-case to match Stripe (e.g. eur, usd, dkk). Null if no Stripe Price is attached. */
	currency?: Maybe<Scalars['String']['output']>;
	isActive: Scalars['Boolean']['output'];
	kickbackRate: Scalars['Float']['output'];
	/** Monthly price for this tier. Synced from Stripe via webhook. See currency field for the unit. */
	monthlyPrice?: Maybe<Scalars['Float']['output']>;
	stripePriceId?: Maybe<Scalars['String']['output']>;
	tier: SubscriptionTier;
	updatedAt: Scalars['DateTime']['output'];
};

export type SyncOrderQuoteProductsInput = {
	orderQuoteId: Scalars['ID']['input'];
	/** The lines to sync. Omit to sync every line on the quote; pass an EMPTY list to sync nothing. */
	orderQuoteItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TechPackCareLabel = {
	__typename?: 'TechPackCareLabel';
	content?: Maybe<Scalars['String']['output']>;
	placement?: Maybe<Scalars['String']['output']>;
	symbols?: Maybe<Array<Scalars['String']['output']>>;
};

export type TechPackCareLabelInput = {
	content?: InputMaybe<Scalars['String']['input']>;
	placement?: InputMaybe<Scalars['String']['input']>;
	symbols?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TechPackColorway = {
	__typename?: 'TechPackColorway';
	code?: Maybe<Scalars['String']['output']>;
	fabricColors?: Maybe<Scalars['JSON']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	pantoneReferences?: Maybe<Array<Scalars['String']['output']>>;
	trimColors?: Maybe<Scalars['JSON']['output']>;
};

export type TechPackColorwayInput = {
	code?: InputMaybe<Scalars['String']['input']>;
	fabricColors?: InputMaybe<Scalars['JSON']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	pantoneReferences?: InputMaybe<Array<Scalars['String']['input']>>;
	trimColors?: InputMaybe<Scalars['JSON']['input']>;
};

export type TechPackConstruction = {
	__typename?: 'TechPackConstruction';
	seamAllowances?: Maybe<Array<TechPackSeamAllowance>>;
	specialInstructions?: Maybe<Array<Scalars['String']['output']>>;
	stitchTypes?: Maybe<Array<TechPackStitch>>;
};

export type TechPackConstructionInput = {
	seamAllowances?: InputMaybe<Array<TechPackSeamAllowanceInput>>;
	specialInstructions?: InputMaybe<Array<Scalars['String']['input']>>;
	stitchTypes?: InputMaybe<Array<TechPackStitchInput>>;
};

export type TechPackDimensions = {
	__typename?: 'TechPackDimensions';
	measurements?: Maybe<Array<TechPackMeasurement>>;
	sizeChart?: Maybe<Array<TechPackSize>>;
};

export type TechPackDimensionsInput = {
	measurements?: InputMaybe<Array<TechPackMeasurementInput>>;
	sizeChart?: InputMaybe<Array<TechPackSizeInput>>;
};

export type TechPackFabric = {
	__typename?: 'TechPackFabric';
	code?: Maybe<Scalars['String']['output']>;
	composition?: Maybe<Scalars['String']['output']>;
	supplier?: Maybe<Scalars['String']['output']>;
	type?: Maybe<Scalars['String']['output']>;
	weight?: Maybe<Scalars['String']['output']>;
	width?: Maybe<Scalars['String']['output']>;
};

export type TechPackFabricInput = {
	code?: InputMaybe<Scalars['String']['input']>;
	composition?: InputMaybe<Scalars['String']['input']>;
	supplier?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<Scalars['String']['input']>;
	weight?: InputMaybe<Scalars['String']['input']>;
	width?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackHardware = {
	__typename?: 'TechPackHardware';
	code?: Maybe<Scalars['String']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	quantity?: Maybe<Scalars['Int']['output']>;
	supplier?: Maybe<Scalars['String']['output']>;
	type?: Maybe<Scalars['String']['output']>;
};

export type TechPackHardwareInput = {
	code?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	quantity?: InputMaybe<Scalars['Int']['input']>;
	supplier?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackLabel = {
	__typename?: 'TechPackLabel';
	content?: Maybe<Scalars['String']['output']>;
	placement?: Maybe<Scalars['String']['output']>;
	type?: Maybe<Scalars['String']['output']>;
};

export type TechPackLabelInput = {
	content?: InputMaybe<Scalars['String']['input']>;
	placement?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackLabeling = {
	__typename?: 'TechPackLabeling';
	additionalLabels?: Maybe<Array<TechPackLabel>>;
	careLabel?: Maybe<TechPackCareLabel>;
	mainLabel?: Maybe<TechPackLabel>;
};

export type TechPackLabelingInput = {
	additionalLabels?: InputMaybe<Array<TechPackLabelInput>>;
	careLabel?: InputMaybe<TechPackCareLabelInput>;
	mainLabel?: InputMaybe<TechPackLabelInput>;
};

export type TechPackMaterials = {
	__typename?: 'TechPackMaterials';
	fabric?: Maybe<TechPackFabric>;
	hardware?: Maybe<Array<TechPackHardware>>;
	trims?: Maybe<Array<TechPackTrim>>;
};

export type TechPackMaterialsInput = {
	fabric?: InputMaybe<TechPackFabricInput>;
	hardware?: InputMaybe<Array<TechPackHardwareInput>>;
	trims?: InputMaybe<Array<TechPackTrimInput>>;
};

export type TechPackMeasurement = {
	__typename?: 'TechPackMeasurement';
	name?: Maybe<Scalars['String']['output']>;
	tolerance?: Maybe<Scalars['String']['output']>;
	value?: Maybe<Scalars['String']['output']>;
};

export type TechPackMeasurementInput = {
	name?: InputMaybe<Scalars['String']['input']>;
	tolerance?: InputMaybe<Scalars['String']['input']>;
	value?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackPackaging = {
	__typename?: 'TechPackPackaging';
	instructions?: Maybe<Array<Scalars['String']['output']>>;
	labeling?: Maybe<Array<Scalars['String']['output']>>;
	materials?: Maybe<Array<Scalars['String']['output']>>;
	type?: Maybe<Scalars['String']['output']>;
};

export type TechPackPackagingInput = {
	instructions?: InputMaybe<Array<Scalars['String']['input']>>;
	labeling?: InputMaybe<Array<Scalars['String']['input']>>;
	materials?: InputMaybe<Array<Scalars['String']['input']>>;
	type?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackQualityControl = {
	__typename?: 'TechPackQualityControl';
	acceptableDefects?: Maybe<Array<Scalars['String']['output']>>;
	inspectionPoints?: Maybe<Array<Scalars['String']['output']>>;
	testingRequirements?: Maybe<Array<Scalars['String']['output']>>;
};

export type TechPackQualityControlInput = {
	acceptableDefects?: InputMaybe<Array<Scalars['String']['input']>>;
	inspectionPoints?: InputMaybe<Array<Scalars['String']['input']>>;
	testingRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TechPackSeamAllowance = {
	__typename?: 'TechPackSeamAllowance';
	allowance?: Maybe<Scalars['String']['output']>;
	location?: Maybe<Scalars['String']['output']>;
};

export type TechPackSeamAllowanceInput = {
	allowance?: InputMaybe<Scalars['String']['input']>;
	location?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackSize = {
	__typename?: 'TechPackSize';
	measurements?: Maybe<Scalars['JSON']['output']>;
	size?: Maybe<Scalars['String']['output']>;
};

export type TechPackSizeInput = {
	measurements?: InputMaybe<Scalars['JSON']['input']>;
	size?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackStitch = {
	__typename?: 'TechPackStitch';
	location?: Maybe<Scalars['String']['output']>;
	stitchesPerInch?: Maybe<Scalars['Int']['output']>;
	threadColor?: Maybe<Scalars['String']['output']>;
	type?: Maybe<Scalars['String']['output']>;
};

export type TechPackStitchInput = {
	location?: InputMaybe<Scalars['String']['input']>;
	stitchesPerInch?: InputMaybe<Scalars['Int']['input']>;
	threadColor?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackTrim = {
	__typename?: 'TechPackTrim';
	code?: Maybe<Scalars['String']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	placement?: Maybe<Scalars['String']['output']>;
	supplier?: Maybe<Scalars['String']['output']>;
	type?: Maybe<Scalars['String']['output']>;
};

export type TechPackTrimInput = {
	code?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	placement?: InputMaybe<Scalars['String']['input']>;
	supplier?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<Scalars['String']['input']>;
};

export type TimelineStatus = {
	__typename?: 'TimelineStatus';
	/** Business days from now to the deadline; negative once past. Null when there's no deadline. */
	businessDaysLeft?: Maybe<Scalars['Int']['output']>;
	deadline?: Maybe<Scalars['DateTime']['output']>;
	isExpired: Scalars['Boolean']['output'];
	level: TimelineStatusLevel;
	reason: TimelineStatusReason;
};

/** One authoritative timeline status that merges the deadline countdown with feasibility. The frontend colors on the level and never decides urgency vs achievability itself. */
export enum TimelineStatusLevel {
	/** May slip, or a bare deadline that's imminent. Amber. */
	AtRisk = 'AT_RISK',
	/** Infeasible or expired. Red. */
	Critical = 'CRITICAL',
	/** Feasibility verified as OK. The only green. */
	OnTrack = 'ON_TRACK',
	/** No deadline, or a date whose feasibility isn't assessable yet. Neutral — never green. */
	Unknown = 'UNKNOWN',
}

export enum TimelineStatusReason {
	DeadlineImminent = 'DEADLINE_IMMINENT',
	Expired = 'EXPIRED',
	Feasible = 'FEASIBLE',
	Infeasible = 'INFEASIBLE',
	MaySlip = 'MAY_SLIP',
	NoDeadline = 'NO_DEADLINE',
	ProductionUnknown = 'PRODUCTION_UNKNOWN',
	Scheduled = 'SCHEDULED',
}

export type ToolCall = {
	__typename?: 'ToolCall';
	arguments?: Maybe<Scalars['JSON']['output']>;
	result?: Maybe<Scalars['JSON']['output']>;
	timestamp: Scalars['DateTime']['output'];
	tool: Scalars['String']['output'];
};

export type TypographyHierarchy = {
	__typename?: 'TypographyHierarchy';
	body?: Maybe<TypographyStyle>;
	caption?: Maybe<TypographyStyle>;
	h1?: Maybe<TypographyStyle>;
	h2?: Maybe<TypographyStyle>;
	h3?: Maybe<TypographyStyle>;
};

export type TypographyHierarchyInput = {
	body?: InputMaybe<TypographyStyleInput>;
	caption?: InputMaybe<TypographyStyleInput>;
	h1?: InputMaybe<TypographyStyleInput>;
	h2?: InputMaybe<TypographyStyleInput>;
	h3?: InputMaybe<TypographyStyleInput>;
};

export type TypographyStyle = {
	__typename?: 'TypographyStyle';
	fontFamily?: Maybe<Scalars['String']['output']>;
	fontSize?: Maybe<Scalars['String']['output']>;
	fontWeight?: Maybe<Scalars['String']['output']>;
	lineHeight?: Maybe<Scalars['String']['output']>;
	usage?: Maybe<Scalars['String']['output']>;
};

export type TypographyStyleInput = {
	fontFamily?: InputMaybe<Scalars['String']['input']>;
	fontSize?: InputMaybe<Scalars['String']['input']>;
	fontWeight?: InputMaybe<Scalars['String']['input']>;
	lineHeight?: InputMaybe<Scalars['String']['input']>;
	usage?: InputMaybe<Scalars['String']['input']>;
};

export type UnmappedProjectProductImage = {
	__typename?: 'UnmappedProjectProductImage';
	fileName: Scalars['String']['output'];
	imageUrl: Scalars['String']['output'];
};

export type UpdateAdminUserInput = {
	firstName?: InputMaybe<Scalars['String']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderInput = {
	invoiceMinimum?: InputMaybe<Scalars['Float']['input']>;
	/** Replaces the order's invoice recipient list wholesale. Omit to leave unchanged; pass [] to clear. */
	invoiceRecipients?: InputMaybe<Array<OrderInvoiceRecipientInput>>;
	name?: InputMaybe<Scalars['String']['input']>;
	productPaymentMode?: InputMaybe<PaymentModeEnum>;
	samplePaymentMode?: InputMaybe<PaymentModeEnum>;
	status?: InputMaybe<OrderStatus>;
	stripeCheckoutLimit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOrderItemStatusInput = {
	carrier?: InputMaybe<Scalars['String']['input']>;
	estimatedDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
	status: OrderItemStatus;
	/** Required when moving to SHIPPED */
	trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderQuoteInput = {
	adminUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	deadline?: InputMaybe<Scalars['DateTime']['input']>;
	deliveryAddress?: InputMaybe<OrderQuoteAddressInput>;
	description?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	purpose?: InputMaybe<OrderQuotePurpose>;
	purposeOther?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<OrderQuoteStatus>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateOrderQuoteItemAttachmentInput = {
	/** Send the text to set it, an empty string to clear it. Omitting it leaves the description alone. */
	description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderQuoteItemInput = {
	deadline?: InputMaybe<Scalars['DateTime']['input']>;
	/** The tier list as it should end up. Entries carry an id so an edited value is tracked as the same tier rather than read as a delete plus an add. */
	quantities?: InputMaybe<Array<OrderQuoteItemQuantityInput>>;
};

export type UpdateOrderQuoteOfferAdjustmentInput = {
	currency?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOrderQuoteOfferBatchAdjustmentInput = {
	calculationType: OrderAdjustmentCalculationType;
	currency?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	type: OrderAdjustmentType;
	value: Scalars['Float']['input'];
};

/**
 * One delivery option on a tier. See CreateOrderQuoteOfferBatchDeliveryInput for how parts makes
 * it a split.
 *
 * ALWAYS send id for an option that already exists. Plain options are matched by their method, but
 * a tier can carry several splits and they have no natural key — without an id a split is treated as
 * a new option, and the one it replaced is deleted along with any client selection pointing at it.
 */
export type UpdateOrderQuoteOfferBatchDeliveryInput = {
	currency: Scalars['String']['input'];
	deliveryDaysMax?: InputMaybe<Scalars['Int']['input']>;
	/** Optional — omit both to save a priced method whose lead time isn't settled yet. Such an option can't be sent to a client until they're set. */
	deliveryDaysMin?: InputMaybe<Scalars['Int']['input']>;
	/** The existing option this entry is. Omit only for an option being added. */
	id?: InputMaybe<Scalars['ID']['input']>;
	/** Two or more legs make this option a split. Their quantities must add up to exactly the tier quantity. */
	parts?: InputMaybe<Array<OrderQuoteOfferDeliveryPartInput>>;
	/** What the client pays for this option, in the currency named below. Replaces basePrice + adminFee. */
	price: Scalars['Float']['input'];
	quantity: Scalars['Int']['input'];
	shippingMethod: OrderShippingMethod;
};

export type UpdateOrderQuoteOfferBatchInput = {
	acceptDeadline?: InputMaybe<Scalars['DateTime']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	offers?: InputMaybe<Array<UpdateOrderQuoteOfferBatchOfferInput>>;
};

export type UpdateOrderQuoteOfferBatchOfferInput = {
	adjustments?: InputMaybe<Array<UpdateOrderQuoteOfferBatchAdjustmentInput>>;
	description?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	name: Scalars['String']['input'];
	orderQuoteItemId: Scalars['ID']['input'];
	pricing?: InputMaybe<Array<UpdateOrderQuoteOfferBatchPricingInput>>;
	sample?: InputMaybe<UpdateOrderQuoteOfferBatchSampleInput>;
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
	vetterId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOrderQuoteOfferBatchPricingInput = {
	baseUnitPrice: Scalars['Float']['input'];
	currency: Scalars['String']['input'];
	deliveries?: InputMaybe<Array<UpdateOrderQuoteOfferBatchDeliveryInput>>;
	marginAmount?: InputMaybe<Scalars['Float']['input']>;
	marginAmountCurrency?: InputMaybe<Scalars['String']['input']>;
	/** Markup on cost: price = cost x (1 + markup/100). Mutually exclusive with marginAmount and unitSalePrice. */
	markupPercentage?: InputMaybe<Scalars['Float']['input']>;
	maxProductionDays?: InputMaybe<Scalars['Int']['input']>;
	minProductionDays?: InputMaybe<Scalars['Int']['input']>;
	orderQuoteItemQuantityId: Scalars['ID']['input'];
	/** State what the client pays and let the markup fall out, the way e-conomic prices a line. Given in the same currency as baseUnitPrice. Mutually exclusive with markupPercentage and marginAmount. */
	unitSalePrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOrderQuoteOfferBatchSampleInput = {
	baseSamplePrice: Scalars['Float']['input'];
	baseShippingPrice?: InputMaybe<Scalars['Float']['input']>;
	currency: Scalars['String']['input'];
	deliveryDaysMax?: InputMaybe<Scalars['Int']['input']>;
	deliveryDaysMin?: InputMaybe<Scalars['Int']['input']>;
	maxProductionDays?: InputMaybe<Scalars['Int']['input']>;
	minProductionDays?: InputMaybe<Scalars['Int']['input']>;
	notes?: InputMaybe<Scalars['String']['input']>;
	/** How the client pays for this sample. Defaults to PREPAID when omitted. */
	paymentTreatment?: InputMaybe<SamplePaymentTreatment>;
};

export type UpdateOrderQuoteOfferDeliveryInput = {
	currency?: InputMaybe<Scalars['String']['input']>;
	deliveryDaysMax?: InputMaybe<Scalars['Int']['input']>;
	deliveryDaysMin?: InputMaybe<Scalars['Int']['input']>;
	/** Re-prices the option. Defaults to the currency it is already priced in when currency is omitted. */
	price?: InputMaybe<Scalars['Float']['input']>;
	quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOrderQuoteOfferDeliverySplitInput = {
	/** At least two. Replaces the existing legs; quantities must add up to exactly the tier's quantity. */
	parts: Array<OrderQuoteOfferDeliveryPartInput>;
};

export type UpdateOrderQuoteOfferInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
	vetterId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOrderQuoteOfferSampleInput = {
	baseSamplePrice?: InputMaybe<Scalars['Float']['input']>;
	baseShippingPrice?: InputMaybe<Scalars['Float']['input']>;
	currency?: InputMaybe<Scalars['String']['input']>;
	deliveryDaysMax?: InputMaybe<Scalars['Int']['input']>;
	deliveryDaysMin?: InputMaybe<Scalars['Int']['input']>;
	maxProductionDays?: InputMaybe<Scalars['Int']['input']>;
	minProductionDays?: InputMaybe<Scalars['Int']['input']>;
	notes?: InputMaybe<Scalars['String']['input']>;
	paymentTreatment?: InputMaybe<SamplePaymentTreatment>;
};

export type UpdateOrderQuoteRequestItemInput = {
	deadline?: InputMaybe<Scalars['DateTime']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOrderShipmentTrackingInput = {
	actualDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
	/** Free text. Write a ShippingCarrier code when the carrier is in the list, so tracking links resolve. */
	carrier?: InputMaybe<Scalars['String']['input']>;
	estimatedDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
	shippedAt?: InputMaybe<Scalars['DateTime']['input']>;
	status?: InputMaybe<OrderShipmentStatus>;
	trackingNumber?: InputMaybe<Scalars['String']['input']>;
	/** A link to the carrier's tracking page. Null when the carrier is unrecognised or has no tracking page — never guessed. */
	trackingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationApprovalAndMarginInput = {
	defaultApproval: Scalars['Boolean']['input'];
	defaultMargin: Scalars['Float']['input'];
	organizationId: Scalars['ID']['input'];
};

export type UpdateOrganizationIndustryInput = {
	id: Scalars['ID']['input'];
	/** Optional explicit publish flip (admin only). */
	isPublished?: InputMaybe<Scalars['Boolean']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInvoiceMinimumInput = {
	organizationId: Scalars['ID']['input'];
	/** Null clears the override — falls back to default (25,000 DKK). */
	threshold?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOrganizationPaymentModeInput = {
	organizationId: Scalars['ID']['input'];
	productPaymentMode: PaymentModeEnum;
	samplePaymentMode: PaymentModeEnum;
};

export type UpdateOrganizationPaymentTermsInput = {
	/** Display label to cache alongside the number. Optional. */
	economicPaymentTermsName?: InputMaybe<Scalars['String']['input']>;
	/** e-conomic payment-terms number (from the economicPaymentTerms selector). */
	economicPaymentTermsNumber: Scalars['Int']['input'];
	organizationId: Scalars['ID']['input'];
};

export type UpdateOrganizationStripeCheckoutLimitInput = {
	organizationId: Scalars['ID']['input'];
	/** Null clears the override — falls back to default (€3,000). */
	threshold?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateSampleStatusInput = {
	/** When it actually arrived, for the physical delivery step. Same default and same reason as shippedAt — a shipment's DELIVER takes one too. */
	actualDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
	/** Optional when moving to APPROVED */
	approvalNotes?: InputMaybe<Scalars['String']['input']>;
	/** Required when moving to SHIPPED. Write a ShippingCarrier code from getShippingCarriers so the tracking link resolves — same picker a shipment uses. */
	carrier?: InputMaybe<Scalars['String']['input']>;
	estimatedDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
	/** Required when moving to REJECTED */
	rejectionReason?: InputMaybe<Scalars['String']['input']>;
	requestNewSample?: InputMaybe<Scalars['Boolean']['input']>;
	/** When it actually went. Optional: defaults to now, which is wrong for a sample recorded the day after it left. */
	shippedAt?: InputMaybe<Scalars['DateTime']['input']>;
	/**
	 * The status to move the sample to.
	 *
	 * OMIT it to perform the EDIT_DETAILS action instead: the request then writes the logistics
	 * fields it sends and moves nothing. Null clears a field on that path — a transition treats
	 * null as "not stated" and defaults its date, an edit does not, which is the only way to remove
	 * a date recorded in error.
	 */
	status?: InputMaybe<OrderSampleStatus>;
	/** Required when moving to SHIPPED */
	trackingNumber?: InputMaybe<Scalars['String']['input']>;
	/** Optional when moving to AWAITING_APPROVAL via virtual submit */
	virtualDeliveryNotes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStudioFileVersionMetadataInput = {
	canvasHeight?: InputMaybe<Scalars['Float']['input']>;
	canvasWidth?: InputMaybe<Scalars['Float']['input']>;
	comment?: InputMaybe<Scalars['String']['input']>;
	height?: InputMaybe<Scalars['Float']['input']>;
	points?: InputMaybe<Array<PolygonPointInput>>;
	type?: InputMaybe<MetadataType>;
	width?: InputMaybe<Scalars['Float']['input']>;
	x?: InputMaybe<Scalars['Float']['input']>;
	y?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateStudioFileVersionSpecificationInput = {
	capacity?: InputMaybe<SpecificationCapacityInput>;
	colors?: InputMaybe<Array<Scalars['String']['input']>>;
	dimensions?: InputMaybe<SpecificationDimensionsInput>;
	elementName?: InputMaybe<Scalars['String']['input']>;
	elementType?: InputMaybe<Scalars['String']['input']>;
	features?: InputMaybe<Array<Scalars['String']['input']>>;
	finish?: InputMaybe<Scalars['String']['input']>;
	material?: InputMaybe<Scalars['String']['input']>;
	secondaryMaterials?: InputMaybe<Array<Scalars['String']['input']>>;
	textureDescription?: InputMaybe<Scalars['String']['input']>;
	weight?: InputMaybe<SpecificationWeightInput>;
};

export type UpdateStudioFileVersionTechPackInput = {
	additionalNotes?: InputMaybe<Scalars['String']['input']>;
	colorways?: InputMaybe<Array<TechPackColorwayInput>>;
	construction?: InputMaybe<TechPackConstructionInput>;
	dimensions?: InputMaybe<TechPackDimensionsInput>;
	labeling?: InputMaybe<TechPackLabelingInput>;
	materials?: InputMaybe<TechPackMaterialsInput>;
	packaging?: InputMaybe<TechPackPackagingInput>;
	qualityControl?: InputMaybe<TechPackQualityControlInput>;
};

export type UpdateStudioPromptTemplateInput = {
	content?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSystemSettingInput = {
	defaultApproval?: InputMaybe<Scalars['Boolean']['input']>;
	defaultInvoiceMinimumThreshold?: InputMaybe<Scalars['Float']['input']>;
	defaultMargin?: InputMaybe<Scalars['Float']['input']>;
	defaultProductPaymentMode?: InputMaybe<PaymentModeEnum>;
	defaultSamplePaymentMode?: InputMaybe<PaymentModeEnum>;
	defaultStripeCheckoutLimit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateVetterEntityInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	notes?: InputMaybe<Scalars['String']['input']>;
	/** Must reference a member of this same vetter entity. Pass null to clear. */
	primaryContactVetterUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateVetterJobShipmentTrackingInput = {
	/** Write a ShippingCarrier code when the carrier is in getShippingCarriers, so tracking links resolve. */
	carrier?: InputMaybe<Scalars['String']['input']>;
	estimatedDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
	/** When it left. Defaults to now when a shipment is marked shipped without one. */
	shippedAt?: InputMaybe<Scalars['DateTime']['input']>;
	trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVetterUserInput = {
	firstName?: InputMaybe<Scalars['String']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
	notes?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
};

export type UploadUrlResponse = {
	__typename?: 'UploadUrlResponse';
	blobUrl?: Maybe<Scalars['String']['output']>;
	errors?: Maybe<Array<ResponseError>>;
	expiresAt?: Maybe<Scalars['DateTime']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	success?: Maybe<Scalars['Boolean']['output']>;
	uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type UserInput = {
	birthday?: InputMaybe<Scalars['String']['input']>;
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	id?: InputMaybe<Scalars['ID']['input']>;
	image?: InputMaybe<FileInput>;
	lastName: Scalars['String']['input'];
	notes?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
};

export type VatAddress = {
	__typename?: 'VATAddress';
	city?: Maybe<Scalars['String']['output']>;
	country: Scalars['String']['output'];
	street?: Maybe<Scalars['String']['output']>;
	zipcode?: Maybe<Scalars['String']['output']>;
};

export type VatCompanyInfo = {
	__typename?: 'VATCompanyInfo';
	active?: Maybe<Scalars['Boolean']['output']>;
	address?: Maybe<VatAddress>;
	name?: Maybe<Scalars['String']['output']>;
	vat: Scalars['String']['output'];
};

export type VatValidationResult = {
	__typename?: 'VATValidationResult';
	companyInfo?: Maybe<VatCompanyInfo>;
	error?: Maybe<Scalars['String']['output']>;
	valid: Scalars['Boolean']['output'];
};

export type ValidationResult = {
	__typename?: 'ValidationResult';
	error?: Maybe<Scalars['String']['output']>;
	valid: Scalars['Boolean']['output'];
};

export type VerifyAuthenticatorMfaInput = {
	isBackupCode?: InputMaybe<Scalars['Boolean']['input']>;
	/** See VerifyEmailMfaInput.rememberMe. */
	rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
	token: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type VerifyAuthenticatorSetupInput = {
	/** See VerifyEmailMfaInput.rememberMe. */
	rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
	token: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type VerifyEmailMfaInput = {
	code: Scalars['String']['input'];
	/**
	 * If true, "remember this device for 30 days" was checked. The refresh
	 * token created downstream by loginValidate gets a 30-day trust window
	 * anchored at this MFA verification; subsequent refreshes inherit the
	 * same expiry rather than extending it. Default false → 1-day window.
	 */
	rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
	userId: Scalars['ID']['input'];
};

/** What a supplier charges to ship one delivery option, or one part of a split. */
export type VetterDeliveryCost = {
	__typename?: 'VetterDeliveryCost';
	/** STUDIO ONLY: this cost in another currency (the header currency), at today's rate. Null in the supplier's own portal. */
	converted?: Maybe<VetterDeliveryCostConversion>;
	currency: Scalars['String']['output'];
	deliveryDaysMax?: Maybe<Scalars['Int']['output']>;
	deliveryDaysMin?: Maybe<Scalars['Int']['output']>;
	price: Scalars['Float']['output'];
};

/** What a supplier charges to ship one delivery option, or one part of a split. */
export type VetterDeliveryCostConvertedArgs = {
	currency: CurrencyEnum;
};

/** A supplier's delivery cost restated in the studio's currency. Admin views only. */
export type VetterDeliveryCostConversion = {
	__typename?: 'VetterDeliveryCostConversion';
	currency: Scalars['String']['output'];
	exchangeRate: Scalars['Float']['output'];
	price: Scalars['Float']['output'];
};

export type VetterDeliveryCostEntry = {
	__typename?: 'VetterDeliveryCostEntry';
	deliveryDaysMax?: Maybe<Scalars['Int']['output']>;
	deliveryDaysMin?: Maybe<Scalars['Int']['output']>;
	orderQuoteOfferDeliveryId: Scalars['ID']['output'];
	/** Set for a part of a split; null for a plain option. */
	orderQuoteOfferDeliveryPartId?: Maybe<Scalars['ID']['output']>;
	price: Scalars['Float']['output'];
};

export type VetterDeliveryCostInput = {
	deliveryDaysMax?: InputMaybe<Scalars['Int']['input']>;
	deliveryDaysMin?: InputMaybe<Scalars['Int']['input']>;
	orderQuoteOfferDeliveryId: Scalars['ID']['input'];
	/** Required for a split's part; leave out for a plain option. */
	orderQuoteOfferDeliveryPartId?: InputMaybe<Scalars['ID']['input']>;
	price: Scalars['Float']['input'];
};

/** One rung of a catalogue ladder, offered as context beside the rung that was applied. */
export type VetterEntity = Base & {
	__typename?: 'VetterEntity';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	isActive: Scalars['Boolean']['output'];
	manufacturers?: Maybe<Array<Manufacturer>>;
	name: Scalars['String']['output'];
	notes?: Maybe<Scalars['String']['output']>;
	primaryContact?: Maybe<VetterUser>;
	/** The member who is this vetter's primary point of contact. Null if none is set or the member was deleted. */
	primaryContactVetterUserId?: Maybe<Scalars['ID']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	vetterUsers?: Maybe<Array<VetterUser>>;
};

export type VetterEntityPage = {
	__typename?: 'VetterEntityPage';
	data: Array<VetterEntity>;
	pageInfo: PageInfo;
};

/**
 * Everything a supplier sees through their link. Deliberately its own types rather than the
 * quote and order types: those carry the client's prices and the studio's margin.
 */
export type VetterJob = {
	__typename?: 'VetterJob';
	/**
	 * True in a link session whose person has no password yet — offer to create an account
	 * (requestVetterAccountInvite). False for accounts.
	 */
	canClaimAccount: Scalars['Boolean']['output'];
	/** Whether submitVetterJobPrices is accepted right now. */
	canSubmitPrices: Scalars['Boolean']['output'];
	/** When the request was first sent. */
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	/** The currency of the latest submission, to preselect in the form. Null before the first. */
	currency?: Maybe<Scalars['String']['output']>;
	/** The signed-in person's email. */
	email: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	/** The lines to price. */
	items: Array<VetterJobItem>;
	note?: Maybe<Scalars['String']['output']>;
	/**
	 * Once the client has ordered: the ordered products this supplier makes. Empty until then —
	 * and it stays empty for a supplier the studio did not pick.
	 */
	orderItems: Array<VetterJobOrderItem>;
	/** When the studio needs the goods by, if the quote has a deadline. */
	quoteDeadline?: Maybe<Scalars['DateTime']['output']>;
	quoteName: Scalars['String']['output'];
	/** Shipments carrying only this supplier's products, in order and sequence. */
	shipments: Array<VetterJobShipment>;
	/** Where the job stands. Use it for tabs and badges; never re-derive it. */
	stage: VetterJobStage;
	/** The stage, ready to show. */
	stageLabel: Scalars['String']['output'];
	/** Why not, when canSubmitPrices is false. Ready to display. */
	submitPricesBlockedReason?: Maybe<Scalars['String']['output']>;
	/** When prices were last submitted. Null until the first submission. */
	submittedAt?: Maybe<Scalars['DateTime']['output']>;
	/** Unread messages across this job's product threads — the job-list badge. */
	unreadCommentCount: Scalars['Int']['output'];
	vetterEntity?: Maybe<VetterEntity>;
};

export type VetterJobAction = {
	__typename?: 'VetterJobAction';
	/** Set when the action is shown but cannot be taken yet. Ready to display. */
	blockedReason?: Maybe<Scalars['String']['output']>;
	key: VetterJobActionKey;
	label: Scalars['String']['output'];
	optionalFields: Array<Scalars['String']['output']>;
	requiredFields: Array<Scalars['String']['output']>;
};

export enum VetterJobActionKey {
	/** completeVetterJobProduction */
	CompleteProduction = 'COMPLETE_PRODUCTION',
	/** updateVetterJobShipmentTracking on a shipment already shipped */
	EditTracking = 'EDIT_TRACKING',
	/** updateVetterJobShipmentTracking on a shipment that has not gone yet */
	Ship = 'SHIP',
}

/**
 * One of the studio's delivery options for a tier, as the supplier sees it: what ships how, never what
 * the client pays. A split lists its parts; the supplier prices each part.
 */
export type VetterJobDeliveryOption = {
	__typename?: 'VetterJobDeliveryOption';
	/** The supplier's cost for a plain option. Null until they enter one, and always null for a split. */
	cost?: Maybe<VetterDeliveryCost>;
	/** The studio's delivery option — pass it back in deliveryCosts. */
	id: Scalars['ID']['output'];
	isSplit: Scalars['Boolean']['output'];
	/** Ready to show, e.g. Standard, Express, or 10 Express + 490 Standard. */
	label: Scalars['String']['output'];
	/** A split's parts, in order. Empty for a plain option. */
	parts: Array<VetterJobDeliveryOptionPart>;
	quantity: Scalars['Int']['output'];
	/** The plain option's method. Null for a split. */
	shippingMethod?: Maybe<OrderShippingMethod>;
};

export type VetterJobDeliveryOptionPart = {
	__typename?: 'VetterJobDeliveryOptionPart';
	/** The supplier's cost for this part. Null until they enter one. */
	cost?: Maybe<VetterDeliveryCost>;
	/** The studio's split part — pass it back in deliveryCosts. */
	id: Scalars['ID']['output'];
	quantity: Scalars['Int']['output'];
	sequence: Scalars['Int']['output'];
	shippingMethod: OrderShippingMethod;
};

export type VetterJobItem = {
	__typename?: 'VetterJobItem';
	/** Artwork, mock-ups and tech packs for this product. */
	attachments: Array<OrderQuoteItemAttachment>;
	/** The supplier's thread with the studio about this product. */
	commentThread: QuoteProductThread;
	/** The line's own deadline, when it has one. */
	deadline?: Maybe<Scalars['DateTime']['output']>;
	orderQuoteItemId: Scalars['ID']['output'];
	productDescription?: Maybe<Scalars['String']['output']>;
	productDimensions?: Maybe<OrderProductDimensions>;
	/** Urls are signed and short-lived; do not store them. */
	productImages?: Maybe<Array<OrderQuoteItemProductImage>>;
	productName?: Maybe<Scalars['String']['output']>;
	productSku?: Maybe<Scalars['String']['output']>;
	productSpecifications?: Maybe<OrderProductSpecifications>;
	productWeight?: Maybe<Scalars['Float']['output']>;
	/** The quantities to price, smallest first, each with what was submitted for it. */
	tiers: Array<VetterJobTier>;
};

export type VetterJobLoginInput = {
	/** The one-time code emailed by requestVetterJobAccessCode. */
	code: Scalars['String']['input'];
	/** The email the supplier typed — must match the address the link was issued to. */
	email: Scalars['String']['input'];
	/** The opaque token from the link (the token query parameter). */
	token: Scalars['String']['input'];
};

export type VetterJobLoginResponse = {
	__typename?: 'VetterJobLoginResponse';
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
	/** Access token to send as the Bearer authorization. Null on failure. A refresh cookie is also set. */
	token?: Maybe<Scalars['String']['output']>;
};

export type VetterJobOrderItem = {
	__typename?: 'VetterJobOrderItem';
	/** What the supplier can do with this item now. Empty when nothing is theirs to do. */
	availableActions: Array<VetterJobAction>;
	id: Scalars['ID']['output'];
	orderId: Scalars['ID']['output'];
	orderNumber: Scalars['String']['output'];
	productName?: Maybe<Scalars['String']['output']>;
	productionCompletedAt?: Maybe<Scalars['DateTime']['output']>;
	productionStartedAt?: Maybe<Scalars['DateTime']['output']>;
	quantity: Scalars['Int']['output'];
	status: OrderItemStatus;
};

export type VetterJobPage = {
	__typename?: 'VetterJobPage';
	data: Array<VetterJob>;
	pageInfo: PageInfo;
};

export type VetterJobPriceLineInput = {
	/** Price per unit. */
	baseUnitPrice: Scalars['Float']['input'];
	/**
	 * The supplier's cost for the studio's delivery options on this tier (VetterJobTier.deliveryOptions):
	 * one entry per plain option, and one per PART of a split.
	 */
	deliveryCosts?: InputMaybe<Array<VetterDeliveryCostInput>>;
	maxProductionDays?: InputMaybe<Scalars['Int']['input']>;
	minProductionDays?: InputMaybe<Scalars['Int']['input']>;
	/** A tier of one of the job's lines. */
	orderQuoteItemQuantityId: Scalars['ID']['input'];
	/** Shipping for the whole tier, per method. Leave out a method you do not offer. */
	shippingPrices?: InputMaybe<Array<VetterShippingPriceInput>>;
};

/** Per product in the supplier-prices panel: one line and the button's label. */
export type VetterJobProductUsage = {
	__typename?: 'VetterJobProductUsage';
	/** Ready to show on the apply button, e.g. Use these prices, Use again, Use updated prices. */
	actionLabel: Scalars['String']['output'];
	appliedAt?: Maybe<Scalars['DateTime']['output']>;
	/** Ready to show next to the product. Null when NOT_USED. */
	label?: Maybe<Scalars['String']['output']>;
	orderQuoteItemId: Scalars['ID']['output'];
	status: VetterProductUsageStatus;
};

export type VetterJobShipment = {
	__typename?: 'VetterJobShipment';
	actualDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	/** What the supplier can do with this shipment now. */
	availableActions: Array<VetterJobAction>;
	carrier?: Maybe<Scalars['String']['output']>;
	estimatedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	lines: Array<VetterJobShipmentLine>;
	orderId: Scalars['ID']['output'];
	orderNumber: Scalars['String']['output'];
	sequence: Scalars['Int']['output'];
	shippedAt?: Maybe<Scalars['DateTime']['output']>;
	shippingMethod?: Maybe<OrderShippingMethod>;
	status: OrderShipmentStatus;
	trackingNumber?: Maybe<Scalars['String']['output']>;
	/** Link to the carrier's tracking page. Null when the carrier is unrecognised. */
	trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type VetterJobShipmentLine = {
	__typename?: 'VetterJobShipmentLine';
	orderItemId: Scalars['ID']['output'];
	productName?: Maybe<Scalars['String']['output']>;
	quantity: Scalars['Int']['output'];
};

/** Where a job stands for the supplier. Derived on the server — filter and badge on it, never re-derive it. */
export enum VetterJobStage {
	/** Asked to price, nothing submitted yet — the supplier's turn. */
	AwaitingPrices = 'AWAITING_PRICES',
	/** Not ordered from them, or nothing left for them to do. */
	Closed = 'CLOSED',
	/** Ordered; at least one of their products still to finish. */
	InProduction = 'IN_PRODUCTION',
	/** Priced; waiting on the studio and the client. */
	PricesSubmitted = 'PRICES_SUBMITTED',
	/** Everything of theirs has shipped. */
	Shipped = 'SHIPPED',
	/** Production done; at least one of their shipments not shipped yet. */
	ToShip = 'TO_SHIP',
}

export type VetterJobTier = {
	__typename?: 'VetterJobTier';
	/**
	 * The studio's delivery options for this tier on the supplier's offer, splits included. When
	 * non-empty the supplier prices THESE (deliveryCosts); when empty — the studio has not set up
	 * delivery yet — they use the per-method shippingPrices fields instead.
	 */
	deliveryOptions: Array<VetterJobDeliveryOption>;
	orderQuoteItemQuantityId: Scalars['ID']['output'];
	/** What this supplier submitted for the tier. Null until they do. */
	price?: Maybe<OrderQuoteVetterPrice>;
	quantity: Scalars['Int']['output'];
};

export type VetterJobUpdate = {
	__typename?: 'VetterJobUpdate';
	/** Set when the job left this supplier's list (the studio withdrew it). Remove the row. */
	removedAt?: Maybe<Scalars['DateTime']['output']>;
	stage: VetterJobStage;
	stageLabel: Scalars['String']['output'];
	/** The viewer's own unread messages across the job's threads. */
	unreadCommentCount: Scalars['Int']['output'];
	vetterJobId: Scalars['ID']['output'];
};

/** A supplier's price restated in the studio's currency. Admin views only. */
export type VetterPriceConversion = {
	__typename?: 'VetterPriceConversion';
	/** Per piece, up to 6 decimals. */
	baseUnitPrice: Scalars['Float']['output'];
	currency: Scalars['String']['output'];
	deliveryCosts: Array<VetterDeliveryCostEntry>;
	/** One unit of the supplier's currency in this one. */
	exchangeRate: Scalars['Float']['output'];
	shippingPrices: Array<VetterShippingPrice>;
};

export type VetterPriceRequestPreview = {
	__typename?: 'VetterPriceRequestPreview';
	/** The supplier's active request on this quote, when there is one. */
	existingJob?: Maybe<OrderQuoteVetterJob>;
	/** Whether anyone at the supplier has an account — if so the recipient may be left out. */
	hasAccountHolders: Scalars['Boolean']['output'];
	/** Ready to show above the form when existingJob is set. Null otherwise. */
	notice?: Maybe<Scalars['String']['output']>;
	/** The supplier's people, accounts first. */
	recipients: Array<VetterPriceRequestRecipient>;
};

export type VetterPriceRequestRecipient = {
	__typename?: 'VetterPriceRequestRecipient';
	/** How they would be reached, ready to show under their name. */
	deliveryLabel: Scalars['String']['output'];
	email?: Maybe<Scalars['String']['output']>;
	/** True when this person has set a password and can sign in. */
	hasAccount: Scalars['Boolean']['output'];
	name: Scalars['String']['output'];
	vetterUserId: Scalars['ID']['output'];
};

export type VetterPriceUsage = {
	__typename?: 'VetterPriceUsage';
	appliedAt?: Maybe<Scalars['DateTime']['output']>;
	/** Ready to show, e.g. Used on the offer · Sep 30. Null when NOT_APPLIED. */
	label?: Maybe<Scalars['String']['output']>;
	/** The offer it was used on. */
	orderQuoteOfferId?: Maybe<Scalars['ID']['output']>;
	status: VetterPriceUsageStatus;
};

export enum VetterPriceUsageStatus {
	/** The offer's cost is exactly this price. */
	Applied = 'APPLIED',
	/** Used on the offer, but the studio has since changed the cost there. */
	EditedOnOffer = 'EDITED_ON_OFFER',
	NotApplied = 'NOT_APPLIED',
	/** Used on the offer, but the supplier has since quoted a different cost. */
	SupplierUpdated = 'SUPPLIER_UPDATED',
}

export enum VetterProductUsageStatus {
	EditedOnOffer = 'EDITED_ON_OFFER',
	NotUsed = 'NOT_USED',
	PartlyUsed = 'PARTLY_USED',
	SupplierUpdated = 'SUPPLIER_UPDATED',
	Used = 'USED',
}

export type VetterShippingPrice = {
	__typename?: 'VetterShippingPrice';
	deliveryDaysMax?: Maybe<Scalars['Int']['output']>;
	deliveryDaysMin?: Maybe<Scalars['Int']['output']>;
	/** Shipping for the whole tier quantity, in the price row's currency. */
	price: Scalars['Float']['output'];
	shippingMethod: OrderShippingMethod;
};

export type VetterShippingPriceInput = {
	deliveryDaysMax?: InputMaybe<Scalars['Int']['input']>;
	deliveryDaysMin?: InputMaybe<Scalars['Int']['input']>;
	price: Scalars['Float']['input'];
	shippingMethod: OrderShippingMethod;
};

/** Aggregate statistics across all vetters, for the admin overview. */
export type VetterStats = {
	__typename?: 'VetterStats';
	/** Vetters that are active (isActive = true). */
	active: Scalars['Int']['output'];
	/** Vetters that are inactive (isActive = false). */
	inactive: Scalars['Int']['output'];
	/** Total team members (vetter users) across all vetters. */
	teamMembers: Scalars['Int']['output'];
	/** All vetter entities. */
	total: Scalars['Int']['output'];
};

export type VetterUser = Base & {
	__typename?: 'VetterUser';
	authenticationUser?: Maybe<AuthenticationUser>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	/** When the invitation email was last sent. Null means this vetter has never been emailed. */
	invitedAt?: Maybe<Scalars['DateTime']['output']>;
	lastName: Scalars['String']['output'];
	notes?: Maybe<Scalars['String']['output']>;
	phone?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId: Scalars['ID']['output'];
	vetterEntity?: Maybe<VetterEntity>;
	vetterEntityId: Scalars['ID']['output'];
};

export type VetterUserPage = {
	__typename?: 'VetterUserPage';
	data: Array<VetterUser>;
	pageInfo: PageInfo;
};

export type PageInfoFragmentFragment = {
	__typename?: 'PageInfo';
	totalPages: number;
	currentPage: number;
	totalCount: number;
	hasNextPage: boolean;
	hasPreviousPage: boolean;
};

export type ResponseErrorFragmentFragment = {
	__typename?: 'ResponseError';
	message: string;
	code?: string | null;
	field?: string | null;
	details?: string | null;
};

export type MessageResponseFragmentFragment = {
	__typename?: 'MessageResponse';
	success: boolean;
	message: string;
	referenceKey?: string | null;
	errors?: Array<{
		__typename?: 'ResponseError';
		message: string;
		code?: string | null;
		field?: string | null;
		details?: string | null;
	}> | null;
};

export type ProductSpecificationsFragmentFragment = {
	__typename?: 'ProductSpecifications';
	material?: string | null;
	secondaryMaterials?: Array<string> | null;
	finish?: string | null;
	textureDescription?: string | null;
	features?: Array<string> | null;
	capacity?: { __typename?: 'ProductMeasure'; value: number; unit: string } | null;
	colors?: Array<{
		__typename?: 'ProductColorSpec';
		name?: string | null;
		code?: string | null;
		pantone?: string | null;
		appliesTo?: string | null;
		finish?: string | null;
		isPrimary?: boolean | null;
	}> | null;
	packaging?: {
		__typename?: 'ProductPackaging';
		type?: string | null;
		weight?: number | null;
		weightUnit?: string | null;
		notes?: string | null;
		dimensions?: {
			__typename?: 'ProductDimensions';
			length?: number | null;
			width?: number | null;
			height?: number | null;
			unit: string;
		} | null;
	} | null;
	decorations?: Array<{
		__typename?: 'ProductDecoration';
		id: string;
		method: ProductDecorationMethod;
		methodNote?: string | null;
		placement?: string | null;
		colorCount?: number | null;
		artworkUrl?: string | null;
		notes?: string | null;
		sortOrder?: number | null;
		area?: {
			__typename?: 'ProductPrintArea';
			width?: number | null;
			height?: number | null;
			unit: string;
		} | null;
		colors?: Array<{
			__typename?: 'ProductColorSpec';
			name?: string | null;
			code?: string | null;
			pantone?: string | null;
			appliesTo?: string | null;
			finish?: string | null;
			isPrimary?: boolean | null;
		}> | null;
	}> | null;
	custom?: Array<{
		__typename?: 'ProductCustomSpec';
		id: string;
		label: string;
		value: string;
		unit?: string | null;
		group?: string | null;
		sortOrder?: number | null;
	}> | null;
};

export type OrderProductSpecificationsFragmentFragment = {
	__typename?: 'OrderProductSpecifications';
	material?: string | null;
	secondaryMaterials?: Array<string> | null;
	finish?: string | null;
	textureDescription?: string | null;
	features?: Array<string> | null;
	capacity?: { __typename?: 'OrderProductMeasure'; value: number; unit: string } | null;
	colors?: Array<{
		__typename?: 'OrderProductColorSpec';
		name?: string | null;
		code?: string | null;
		pantone?: string | null;
		appliesTo?: string | null;
		finish?: string | null;
		isPrimary?: boolean | null;
	}> | null;
	packaging?: {
		__typename?: 'OrderProductPackaging';
		type?: string | null;
		weight?: number | null;
		weightUnit?: string | null;
		notes?: string | null;
		dimensions?: {
			__typename?: 'OrderProductDimensions';
			length?: number | null;
			width?: number | null;
			height?: number | null;
			unit: string;
		} | null;
	} | null;
	decorations?: Array<{
		__typename?: 'OrderProductDecoration';
		id: string;
		method: OrderProductDecorationMethod;
		methodNote?: string | null;
		placement?: string | null;
		colorCount?: number | null;
		artworkUrl?: string | null;
		notes?: string | null;
		sortOrder?: number | null;
		area?: {
			__typename?: 'OrderProductPrintArea';
			width?: number | null;
			height?: number | null;
			unit: string;
		} | null;
		colors?: Array<{
			__typename?: 'OrderProductColorSpec';
			name?: string | null;
			code?: string | null;
			pantone?: string | null;
			appliesTo?: string | null;
			finish?: string | null;
			isPrimary?: boolean | null;
		}> | null;
	}> | null;
	custom?: Array<{
		__typename?: 'OrderProductCustomSpec';
		id: string;
		label: string;
		value: string;
		unit?: string | null;
		group?: string | null;
		sortOrder?: number | null;
	}> | null;
};

export type OrderQuoteItemProductImageFragmentFragment = {
	__typename?: 'OrderQuoteItemProductImage';
	url: string;
	isPrimary?: boolean | null;
	sortOrder?: number | null;
	altText?: string | null;
	caption?: string | null;
	dimensions?: {
		__typename?: 'OrderProductImageDimensions';
		width?: number | null;
		height?: number | null;
		aspectRatio?: string | null;
	} | null;
	crop?: {
		__typename?: 'OrderProductImageCrop';
		x: number;
		y: number;
		width: number;
		height: number;
		zoom?: number | null;
		rotation?: number | null;
		aspectRatio?: string | null;
		unit?: string | null;
	} | null;
};

export type OrderItemProductImageFragmentFragment = {
	__typename?: 'OrderItemProductImage';
	url: string;
	isPrimary?: boolean | null;
	sortOrder?: number | null;
	altText?: string | null;
	caption?: string | null;
	dimensions?: {
		__typename?: 'OrderProductImageDimensions';
		width?: number | null;
		height?: number | null;
		aspectRatio?: string | null;
	} | null;
	crop?: {
		__typename?: 'OrderProductImageCrop';
		x: number;
		y: number;
		width: number;
		height: number;
		zoom?: number | null;
		rotation?: number | null;
		aspectRatio?: string | null;
		unit?: string | null;
	} | null;
};

export type QuoteProductCommentFieldsFragment = {
	__typename?: 'QuoteProductComment';
	id: string;
	orderQuoteItemId: string;
	vetterEntityId?: string | null;
	body: string;
	isMine: boolean;
	canEdit: boolean;
	canDelete: boolean;
	createdAt?: string | null;
	editedAt?: string | null;
	deletedAt?: string | null;
	author: {
		__typename?: 'QuoteProductCommentAuthor';
		userId: string;
		name: string;
		side: QuoteProductCommentSide;
	};
	mentions: Array<{ __typename?: 'QuoteProductCommentMention'; userId: string; name: string }>;
	attachments: Array<{
		__typename?: 'QuoteProductCommentAttachment';
		name: string;
		url?: string | null;
		mimeType: string;
		size: number;
	}>;
};

export type QuoteProductThreadFieldsFragment = {
	__typename?: 'QuoteProductThread';
	id: string;
	kind: QuoteProductThreadKind;
	orderQuoteItemId: string;
	productName?: string | null;
	vetterEntityId?: string | null;
	commentCount: number;
	unreadCount: number;
	lastCommentAt?: string | null;
	vetterEntity?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
};

export type AcceptOrderQuoteOffersMutationVariables = Exact<{
	input: AcceptOrderQuoteOffersInput;
}>;

export type AcceptOrderQuoteOffersMutation = {
	__typename?: 'Mutation';
	acceptOrderQuoteOffers: {
		__typename?: 'AcceptOrderQuoteOffersResponse';
		success: boolean;
		message: string;
		orderId?: string | null;
		pendingReview?: boolean | null;
	};
};

export type CreateAdminUserMutationVariables = Exact<{
	input: CreateAdminUserInput;
}>;

export type CreateAdminUserMutation = {
	__typename?: 'Mutation';
	createAdminUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type UpdateAdminUserMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateAdminUserInput;
}>;

export type UpdateAdminUserMutation = {
	__typename?: 'Mutation';
	updateAdminUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteAdminUserMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteAdminUserMutation = {
	__typename?: 'Mutation';
	deleteAdminUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteManyAdminUserMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyAdminUserMutation = {
	__typename?: 'Mutation';
	deleteManyAdminUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type LoginMutationVariables = Exact<{
	input: LoginInput;
}>;

export type LoginMutation = {
	__typename?: 'Mutation';
	login: {
		__typename?: 'LoginResponse';
		token: string;
		userId: string;
		mfaRequired: boolean;
		mfaMethod?: MfaMethodEnum | null;
		role: AuthRoleEnum;
		supportsBackupCodes: boolean;
	};
};

export type LoginValidateMutationVariables = Exact<{
	input: LoginValidateInput;
}>;

export type LoginValidateMutation = {
	__typename?: 'Mutation';
	loginValidate: {
		__typename?: 'LoginValidateResponse';
		token: string;
		user: {
			__typename?: 'AuthenticationUser';
			id: string;
			role: AuthRoleEnum;
			language: string;
			email?: string | null;
			vetterUser?: {
				__typename?: 'VetterUser';
				vetterEntityId: string;
				firstName: string;
				lastName: string;
			} | null;
			organizationUser?: {
				__typename?: 'OrganizationUser';
				id: string;
				organizationId: string;
				firstName: string;
				lastName: string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
					onboarded: boolean;
					organizationSetting?: {
						__typename?: 'OrganizationSetting';
						currency?: CurrencyEnum | null;
					} | null;
				} | null;
			} | null;
		};
	};
};

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never }>;

export type RefreshTokenMutation = {
	__typename?: 'Mutation';
	refreshToken: {
		__typename?: 'LoginValidateResponse';
		token: string;
		user: {
			__typename?: 'AuthenticationUser';
			id: string;
			role: AuthRoleEnum;
			language: string;
			email?: string | null;
			vetterUser?: {
				__typename?: 'VetterUser';
				vetterEntityId: string;
				firstName: string;
				lastName: string;
			} | null;
			organizationUser?: {
				__typename?: 'OrganizationUser';
				id: string;
				organizationId: string;
				firstName: string;
				lastName: string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
					onboarded: boolean;
					organizationSetting?: {
						__typename?: 'OrganizationSetting';
						currency?: CurrencyEnum | null;
					} | null;
				} | null;
			} | null;
		};
	};
};

export type ValidateAuthenticationTokenMutationVariables = Exact<{
	token: Scalars['String']['input'];
}>;

export type ValidateAuthenticationTokenMutation = {
	__typename?: 'Mutation';
	validateAuthenticationToken: {
		__typename?: 'AuthenticationToken';
		token: string;
		user?: {
			__typename?: 'AuthenticationUser';
			id: string;
			email?: string | null;
			organizationUser?: {
				__typename?: 'OrganizationUser';
				id: string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
	};
};

export type RegisterMutationVariables = Exact<{
	input: RegisterInput;
}>;

export type RegisterMutation = {
	__typename?: 'Mutation';
	register: {
		__typename?: 'RegisterResponse';
		userId?: string | null;
		qrCodeDataURL?: string | null;
	};
};

export type PasswordResetRequestMutationVariables = Exact<{
	input: PasswordResetRequestInput;
}>;

export type PasswordResetRequestMutation = {
	__typename?: 'Mutation';
	passwordResetRequest: string;
};

export type PasswordResetValidateMutationVariables = Exact<{
	input: PasswordResetValidateInput;
}>;

export type PasswordResetValidateMutation = {
	__typename?: 'Mutation';
	passwordResetValidate: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type PasswordResetMutationVariables = Exact<{
	input: PasswordResetInput;
}>;

export type PasswordResetMutation = {
	__typename?: 'Mutation';
	passwordReset: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type ResendPasswordResetRequestMutationVariables = Exact<{
	input: PasswordResetRequestInput;
}>;

export type ResendPasswordResetRequestMutation = {
	__typename?: 'Mutation';
	resendPasswordResetRequest: string;
};

export type VerifyAuthenticatorSetupMutationVariables = Exact<{
	input: VerifyAuthenticatorSetupInput;
}>;

export type VerifyAuthenticatorSetupMutation = {
	__typename?: 'Mutation';
	verifyAuthenticatorSetup: {
		__typename?: 'LoginResponse';
		token: string;
		userId: string;
		role: AuthRoleEnum;
		backupCodes?: Array<string> | null;
	};
};

export type VerifyEmailMfaMutationVariables = Exact<{
	input: VerifyEmailMfaInput;
}>;

export type VerifyEmailMfaMutation = {
	__typename?: 'Mutation';
	verifyEmailMfa: { __typename?: 'LoginResponse'; token: string; role: AuthRoleEnum };
};

export type ResendEmailMfaCodeMutationVariables = Exact<{
	userId: Scalars['ID']['input'];
}>;

export type ResendEmailMfaCodeMutation = {
	__typename?: 'Mutation';
	resendEmailMfaCode: { __typename?: 'MessageResponse'; message: string; success: boolean };
};

export type VerifyAuthenticatorMfaMutationVariables = Exact<{
	input: VerifyAuthenticatorMfaInput;
}>;

export type VerifyAuthenticatorMfaMutation = {
	__typename?: 'Mutation';
	verifyAuthenticatorMfa: { __typename?: 'LoginResponse'; token: string; role: AuthRoleEnum };
};

export type LogoutMutationVariables = Exact<{
	input: LogoutInput;
}>;

export type LogoutMutation = {
	__typename?: 'Mutation';
	logout: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type CreateOrganizationSignupMutationVariables = Exact<{
	input: OrganizationSignupInput;
}>;

export type CreateOrganizationSignupMutation = {
	__typename?: 'Mutation';
	createOrganizationSignup: {
		__typename?: 'RegisterResponse';
		userId?: string | null;
		qrCodeDataURL?: string | null;
	};
};

export type SwitchOrganizationMutationVariables = Exact<{
	organizationId: Scalars['ID']['input'];
}>;

export type SwitchOrganizationMutation = {
	__typename?: 'Mutation';
	switchOrganization: { __typename?: 'LoginValidateResponse'; token: string };
};

export type CreateBrandMutationVariables = Exact<{
	input: BrandCreateInput;
}>;

export type CreateBrandMutation = {
	__typename?: 'Mutation';
	createBrand: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateBrandMutationVariables = Exact<{
	input: BrandUpdateInput;
}>;

export type UpdateBrandMutation = {
	__typename?: 'Mutation';
	updateBrand: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteBrandMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteBrandMutation = {
	__typename?: 'Mutation';
	deleteBrand: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type GenerateBrandFileUploadUrlMutationVariables = Exact<{
	input: BrandFileUploadInput;
}>;

export type GenerateBrandFileUploadUrlMutation = {
	__typename?: 'Mutation';
	generateBrandFileUploadUrl: {
		__typename?: 'FileUploadResponse';
		success: boolean;
		message: string;
		uploadUrl: string;
		blobUrl?: string | null;
		fileId?: string | null;
		expiresAt: string;
		errors: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}>;
	};
};

export type ConfirmBrandFileUploadMutationVariables = Exact<{
	input: ConfirmBrandFileUploadInput;
}>;

export type ConfirmBrandFileUploadMutation = {
	__typename?: 'Mutation';
	confirmBrandFileUpload: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type GenerateBrandFontUploadUrlMutationVariables = Exact<{
	input: FontFileUploadInput;
}>;

export type GenerateBrandFontUploadUrlMutation = {
	__typename?: 'Mutation';
	generateBrandFontUploadUrl: {
		__typename?: 'FileUploadResponse';
		success: boolean;
		message: string;
		uploadUrl: string;
		blobUrl?: string | null;
		fileId?: string | null;
		expiresAt: string;
		errors: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}>;
	};
};

export type ConfirmBrandFontUploadMutationVariables = Exact<{
	input: ConfirmBrandFontUploadInput;
}>;

export type ConfirmBrandFontUploadMutation = {
	__typename?: 'Mutation';
	confirmBrandFontUpload: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteBrandFontMutationVariables = Exact<{
	brandId: Scalars['ID']['input'];
	fontId: Scalars['ID']['input'];
}>;

export type DeleteBrandFontMutation = {
	__typename?: 'Mutation';
	deleteBrandFont: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteBrandFileMutationVariables = Exact<{
	brandId: Scalars['ID']['input'];
	fileId: Scalars['ID']['input'];
}>;

export type DeleteBrandFileMutation = {
	__typename?: 'Mutation';
	deleteBrandFile: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CloseOrderQuoteMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type CloseOrderQuoteMutation = {
	__typename?: 'Mutation';
	closeOrderQuote: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DuplicateOrderQuoteOfferBatchMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DuplicateOrderQuoteOfferBatchMutation = {
	__typename?: 'Mutation';
	duplicateOrderQuoteOfferBatch: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RequestEarlyAccessMutationVariables = Exact<{
	input: RequestEarlyAccessInput;
}>;

export type RequestEarlyAccessMutation = {
	__typename?: 'Mutation';
	requestEarlyAccess: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type ApproveEarlyAccessRequestMutationVariables = Exact<{
	input: ApproveEarlyAccessRequestInput;
}>;

export type ApproveEarlyAccessRequestMutation = {
	__typename?: 'Mutation';
	approveEarlyAccessRequest: {
		__typename?: 'ApproveEarlyAccessResponse';
		inviteToken: string;
		message: string;
	};
};

export type RejectEarlyAccessRequestMutationVariables = Exact<{
	requestId: Scalars['ID']['input'];
}>;

export type RejectEarlyAccessRequestMutation = {
	__typename?: 'Mutation';
	rejectEarlyAccessRequest: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type GenerateOfferEconomicQuotePdfMutationVariables = Exact<{
	input: GenerateOfferEconomicQuotePdfInput;
}>;

export type GenerateOfferEconomicQuotePdfMutation = {
	__typename?: 'Mutation';
	generateOfferEconomicQuotePdf: {
		__typename?: 'GenerateOfferEconomicQuotePdfResponse';
		success: boolean;
		message: string;
		pdfUrl?: string | null;
		economicQuoteNumber?: number | null;
	};
};

export type RequestGuestQuoteAccessCodeMutationVariables = Exact<{
	input: RequestGuestQuoteAccessCodeInput;
}>;

export type RequestGuestQuoteAccessCodeMutation = {
	__typename?: 'Mutation';
	requestGuestQuoteAccessCode: {
		__typename?: 'MessageResponse';
		messageKey?: string | null;
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type GuestQuoteLoginMutationVariables = Exact<{
	input: GuestQuoteLoginInput;
}>;

export type GuestQuoteLoginMutation = {
	__typename?: 'Mutation';
	guestQuoteLogin: {
		__typename?: 'GuestQuoteLoginResponse';
		success: boolean;
		message: string;
		token?: string | null;
		orderQuoteId?: string | null;
	};
};

export type GuestQuotePreviewLoginMutationVariables = Exact<{
	input: GuestQuotePreviewLoginInput;
}>;

export type GuestQuotePreviewLoginMutation = {
	__typename?: 'Mutation';
	guestQuotePreviewLogin: {
		__typename?: 'GuestQuoteLoginResponse';
		success: boolean;
		message: string;
		token?: string | null;
		orderQuoteId?: string | null;
	};
};

export type CreateManufacturerMutationVariables = Exact<{
	input: ManufacturerCreateInput;
}>;

export type CreateManufacturerMutation = {
	__typename?: 'Mutation';
	createManufacturer: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type UpdateManufacturerMutationVariables = Exact<{
	input: ManufacturerUpdateInput;
}>;

export type UpdateManufacturerMutation = {
	__typename?: 'Mutation';
	updateManufacturer: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteManufacturerMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteManufacturerMutation = {
	__typename?: 'Mutation';
	deleteManufacturer: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteManyManufacturersMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyManufacturersMutation = {
	__typename?: 'Mutation';
	deleteManyManufacturer: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type SetNotificationSettingMutationVariables = Exact<{
	input: SetNotificationSettingInput;
}>;

export type SetNotificationSettingMutation = {
	__typename?: 'Mutation';
	setNotificationSetting: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type MarkNotificationReadMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type MarkNotificationReadMutation = {
	__typename?: 'Mutation';
	markNotificationRead: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type MarkAllNotificationsReadMutationVariables = Exact<{ [key: string]: never }>;

export type MarkAllNotificationsReadMutation = {
	__typename?: 'Mutation';
	markAllNotificationsRead: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type UpdateOrderItemStatusMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateOrderItemStatusInput;
}>;

export type UpdateOrderItemStatusMutation = {
	__typename?: 'Mutation';
	updateOrderItemStatus: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrderMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateOrderInput;
}>;

export type UpdateOrderMutation = {
	__typename?: 'Mutation';
	updateOrder: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrderDeliveryAddressMutationVariables = Exact<{
	orderId: Scalars['ID']['input'];
	address: OrderQuoteAddressInput;
}>;

export type UpdateOrderDeliveryAddressMutation = {
	__typename?: 'Mutation';
	updateOrderDeliveryAddress: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type ConfirmOrderMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: ConfirmOrderInput;
}>;

export type ConfirmOrderMutation = {
	__typename?: 'Mutation';
	confirmOrder: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CancelOrderMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type CancelOrderMutation = {
	__typename?: 'Mutation';
	cancelOrder: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type MarkOrderProductInvoicePaidMutationVariables = Exact<{
	paymentTransactionId: Scalars['ID']['input'];
	note?: InputMaybe<Scalars['String']['input']>;
}>;

export type MarkOrderProductInvoicePaidMutation = {
	__typename?: 'Mutation';
	markOrderProductInvoicePaid: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type MarkOrderSampleInvoicePaidMutationVariables = Exact<{
	paymentTransactionId: Scalars['ID']['input'];
	note?: InputMaybe<Scalars['String']['input']>;
}>;

export type MarkOrderSampleInvoicePaidMutation = {
	__typename?: 'Mutation';
	markOrderSampleInvoicePaid: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RecordOrderBankTransferMutationVariables = Exact<{
	input: RecordOrderBankTransferInput;
}>;

export type RecordOrderBankTransferMutation = {
	__typename?: 'Mutation';
	recordOrderBankTransfer: {
		__typename?: 'RecordOrderBankTransferResponse';
		success: boolean;
		message?: string | null;
		paymentTransactionId?: string | null;
		economicBookedInvoiceNumber?: number | null;
	};
};

export type CreateSamplePaymentMutationVariables = Exact<{
	input: CreateSamplePaymentInput;
}>;

export type CreateSamplePaymentMutation = {
	__typename?: 'Mutation';
	createSamplePayment: {
		__typename?: 'CreateSamplePaymentResponse';
		success: boolean;
		message?: string | null;
		clientSecret?: string | null;
		sessionId?: string | null;
		economicBookedInvoiceNumber?: number | null;
		netAmount?: number | null;
		vatAmount?: number | null;
		vatRate?: number | null;
		grossAmount?: number | null;
	};
};

export type CreateFullOrderPaymentMutationVariables = Exact<{
	input: CreateFullOrderPaymentInput;
}>;

export type CreateFullOrderPaymentMutation = {
	__typename?: 'Mutation';
	createFullOrderPayment: {
		__typename?: 'CreateOrderPaymentResponse';
		success: boolean;
		message?: string | null;
		paymentMethod?: OrderPaymentMethod | null;
		clientSecret?: string | null;
		sessionId?: string | null;
		paymentTransactionId?: string | null;
		economicBookedInvoiceNumber?: number | null;
		netAmount?: number | null;
		vatAmount?: number | null;
		vatRate?: number | null;
		grossAmount?: number | null;
	};
};

export type CreateOrderPaymentMutationVariables = Exact<{
	input: CreateOrderPaymentInput;
}>;

export type CreateOrderPaymentMutation = {
	__typename?: 'Mutation';
	createOrderPayment: {
		__typename?: 'CreateOrderPaymentResponse';
		success: boolean;
		message?: string | null;
		paymentMethod?: OrderPaymentMethod | null;
		clientSecret?: string | null;
		sessionId?: string | null;
		paymentTransactionId?: string | null;
		economicBookedInvoiceNumber?: number | null;
		netAmount?: number | null;
		vatAmount?: number | null;
		vatRate?: number | null;
		grossAmount?: number | null;
	};
};

export type AddOrderQuoteItemsMutationVariables = Exact<{
	input: AddOrderQuoteItemsInput;
}>;

export type AddOrderQuoteItemsMutation = {
	__typename?: 'Mutation';
	addOrderQuoteItems: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrderQuoteMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteInput;
}>;

export type UpdateOrderQuoteMutation = {
	__typename?: 'Mutation';
	updateOrderQuote: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type SetQuotePaymentSettingsMutationVariables = Exact<{
	input: SetQuotePaymentSettingsInput;
}>;

export type SetQuotePaymentSettingsMutation = {
	__typename?: 'Mutation';
	setQuotePaymentSettings: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type SetQuoteClientContactsMutationVariables = Exact<{
	input: SetQuoteClientContactsInput;
}>;

export type SetQuoteClientContactsMutation = {
	__typename?: 'Mutation';
	setQuoteClientContacts: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteOrderQuoteMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteOrderQuoteMutation = {
	__typename?: 'Mutation';
	deleteOrderQuote: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RemoveOrderQuoteItemMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type RemoveOrderQuoteItemMutation = {
	__typename?: 'Mutation';
	removeOrderQuoteItem: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrderQuoteItemMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteItemInput;
}>;

export type UpdateOrderQuoteItemMutation = {
	__typename?: 'Mutation';
	updateOrderQuoteItem: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CreateOrderQuoteMutationVariables = Exact<{
	input: CreateOrderQuoteInput;
}>;

export type CreateOrderQuoteMutation = {
	__typename?: 'Mutation';
	createOrderQuote: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RequestOrderQuoteOfferMutationVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
}>;

export type RequestOrderQuoteOfferMutation = {
	__typename?: 'Mutation';
	requestOrderQuoteOffer: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type GenerateOrderQuoteItemAttachmentUploadUrlMutationVariables = Exact<{
	input: GenerateOrderQuoteItemAttachmentUploadUrlInput;
}>;

export type GenerateOrderQuoteItemAttachmentUploadUrlMutation = {
	__typename?: 'Mutation';
	generateOrderQuoteItemAttachmentUploadUrl: {
		__typename?: 'OrderQuoteItemAttachmentUploadResponse';
		success: boolean;
		message: string;
		fileId?: string | null;
		uploadUrl: string;
		blobUrl?: string | null;
		expiresAt?: string | null;
	};
};

export type ConfirmOrderQuoteItemAttachmentUploadsMutationVariables = Exact<{
	input: ConfirmOrderQuoteItemAttachmentUploadsInput;
}>;

export type ConfirmOrderQuoteItemAttachmentUploadsMutation = {
	__typename?: 'Mutation';
	confirmOrderQuoteItemAttachmentUploads: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrderQuoteItemAttachmentMutationVariables = Exact<{
	orderQuoteItemId: Scalars['ID']['input'];
	attachmentId: Scalars['ID']['input'];
	input: UpdateOrderQuoteItemAttachmentInput;
}>;

export type UpdateOrderQuoteItemAttachmentMutation = {
	__typename?: 'Mutation';
	updateOrderQuoteItemAttachment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteOrderQuoteItemAttachmentMutationVariables = Exact<{
	orderQuoteItemId: Scalars['ID']['input'];
	attachmentId: Scalars['ID']['input'];
}>;

export type DeleteOrderQuoteItemAttachmentMutation = {
	__typename?: 'Mutation';
	deleteOrderQuoteItemAttachment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DuplicateOrderQuoteMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input?: InputMaybe<DuplicateOrderQuoteInput>;
}>;

export type DuplicateOrderQuoteMutation = {
	__typename?: 'Mutation';
	duplicateOrderQuote: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type SyncOrderQuoteProductsMutationVariables = Exact<{
	input: SyncOrderQuoteProductsInput;
}>;

export type SyncOrderQuoteProductsMutation = {
	__typename?: 'Mutation';
	syncOrderQuoteProducts: {
		__typename?: 'MessageResponse';
		messageKey?: string | null;
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CreateOrderQuoteGuestAcceptanceLinkMutationVariables = Exact<{
	input: CreateOrderQuoteGuestAcceptanceLinkInput;
}>;

export type CreateOrderQuoteGuestAcceptanceLinkMutation = {
	__typename?: 'Mutation';
	createOrderQuoteGuestAcceptanceLink: {
		__typename?: 'OrderQuoteGuestAcceptanceLinkResponse';
		success: boolean;
		message: string;
		link?: string | null;
		email?: string | null;
	};
};

export type RevokeOrderQuoteGuestAcceptanceLinkMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type RevokeOrderQuoteGuestAcceptanceLinkMutation = {
	__typename?: 'Mutation';
	revokeOrderQuoteGuestAcceptanceLink: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CreateOrderQuoteGuestPreviewLinkMutationVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
}>;

export type CreateOrderQuoteGuestPreviewLinkMutation = {
	__typename?: 'Mutation';
	createOrderQuoteGuestPreviewLink: {
		__typename?: 'OrderQuoteGuestPreviewLinkResponse';
		success: boolean;
		message: string;
		link?: string | null;
		email?: string | null;
		expiresAt?: string | null;
	};
};

export type CreateOrderQuoteOfferBatchMutationVariables = Exact<{
	input: CreateOrderQuoteOfferBatchInput;
}>;

export type CreateOrderQuoteOfferBatchMutation = {
	__typename?: 'Mutation';
	createOrderQuoteOfferBatch: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrderQuoteOfferBatchMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteOfferBatchInput;
}>;

export type UpdateOrderQuoteOfferBatchMutation = {
	__typename?: 'Mutation';
	updateOrderQuoteOfferBatch: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteOrderQuoteOfferBatchMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteOrderQuoteOfferBatchMutation = {
	__typename?: 'Mutation';
	deleteOrderQuoteOfferBatch: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrderQuoteOfferMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteOfferInput;
}>;

export type UpdateOrderQuoteOfferMutation = {
	__typename?: 'Mutation';
	updateOrderQuoteOffer: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type AddOrderQuoteOfferMutationVariables = Exact<{
	input: AddOrderQuoteOfferInput;
}>;

export type AddOrderQuoteOfferMutation = {
	__typename?: 'Mutation';
	addOrderQuoteOffer: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type SetOrderQuoteOfferPricingMutationVariables = Exact<{
	input: SetOrderQuoteOfferPricingInput;
}>;

export type SetOrderQuoteOfferPricingMutation = {
	__typename?: 'Mutation';
	setOrderQuoteOfferPricing: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RemoveOrderQuoteOfferMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type RemoveOrderQuoteOfferMutation = {
	__typename?: 'Mutation';
	removeOrderQuoteOffer: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type AddOrderQuoteOfferAdjustmentMutationVariables = Exact<{
	input: AddOrderQuoteOfferAdjustmentInput;
}>;

export type AddOrderQuoteOfferAdjustmentMutation = {
	__typename?: 'Mutation';
	addOrderQuoteOfferAdjustment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrderQuoteOfferAdjustmentMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteOfferAdjustmentInput;
}>;

export type UpdateOrderQuoteOfferAdjustmentMutation = {
	__typename?: 'Mutation';
	updateOrderQuoteOfferAdjustment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RemoveOrderQuoteOfferAdjustmentMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type RemoveOrderQuoteOfferAdjustmentMutation = {
	__typename?: 'Mutation';
	removeOrderQuoteOfferAdjustment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type AddOrderQuoteOfferSampleMutationVariables = Exact<{
	input: AddOrderQuoteOfferSampleInput;
}>;

export type AddOrderQuoteOfferSampleMutation = {
	__typename?: 'Mutation';
	addOrderQuoteOfferSample: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrderQuoteOfferSampleMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteOfferSampleInput;
}>;

export type UpdateOrderQuoteOfferSampleMutation = {
	__typename?: 'Mutation';
	updateOrderQuoteOfferSample: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RemoveOrderQuoteOfferSampleMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type RemoveOrderQuoteOfferSampleMutation = {
	__typename?: 'Mutation';
	removeOrderQuoteOfferSample: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type AddOrderQuoteOfferDeliveryMutationVariables = Exact<{
	input: AddOrderQuoteOfferDeliveryInput;
}>;

export type AddOrderQuoteOfferDeliveryMutation = {
	__typename?: 'Mutation';
	addOrderQuoteOfferDelivery: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrderQuoteOfferDeliveryMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteOfferDeliveryInput;
}>;

export type UpdateOrderQuoteOfferDeliveryMutation = {
	__typename?: 'Mutation';
	updateOrderQuoteOfferDelivery: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type AddOrderQuoteOfferDeliverySplitMutationVariables = Exact<{
	input: AddOrderQuoteOfferDeliverySplitInput;
}>;

export type AddOrderQuoteOfferDeliverySplitMutation = {
	__typename?: 'Mutation';
	addOrderQuoteOfferDeliverySplit: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrderQuoteOfferDeliverySplitMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateOrderQuoteOfferDeliverySplitInput;
}>;

export type UpdateOrderQuoteOfferDeliverySplitMutation = {
	__typename?: 'Mutation';
	updateOrderQuoteOfferDeliverySplit: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RemoveOrderQuoteOfferDeliveryMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type RemoveOrderQuoteOfferDeliveryMutation = {
	__typename?: 'Mutation';
	removeOrderQuoteOfferDelivery: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type AddOffersToOrderQuoteOfferBatchMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	offers: Array<CreateOrderQuoteOfferBatchOfferInput> | CreateOrderQuoteOfferBatchOfferInput;
}>;

export type AddOffersToOrderQuoteOfferBatchMutation = {
	__typename?: 'Mutation';
	addOffersToOrderQuoteOfferBatch: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type SendOrderQuoteOfferBatchToClientMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type SendOrderQuoteOfferBatchToClientMutation = {
	__typename?: 'Mutation';
	sendOrderQuoteOfferBatchToClient: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RecallOrderQuoteOfferBatchMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type RecallOrderQuoteOfferBatchMutation = {
	__typename?: 'Mutation';
	recallOrderQuoteOfferBatch: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type ApplyCatalogPriceToOfferTierMutationVariables = Exact<{
	input: ApplyCatalogPriceToOfferTierInput;
}>;

export type ApplyCatalogPriceToOfferTierMutation = {
	__typename?: 'Mutation';
	applyCatalogPriceToOfferTier: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type ApplyCatalogPriceToOfferSampleMutationVariables = Exact<{
	input: ApplyCatalogPriceToOfferSampleInput;
}>;

export type ApplyCatalogPriceToOfferSampleMutation = {
	__typename?: 'Mutation';
	applyCatalogPriceToOfferSample: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type SendVetterPriceRequestMutationVariables = Exact<{
	input: SendVetterPriceRequestInput;
}>;

export type SendVetterPriceRequestMutation = {
	__typename?: 'Mutation';
	sendVetterPriceRequest: {
		__typename?: 'SendVetterPriceRequestResponse';
		success: boolean;
		message: string;
		vetterJobId?: string | null;
		email?: string | null;
		link?: string | null;
	};
};

export type SetOrderQuoteVetterJobItemsMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	orderQuoteItemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type SetOrderQuoteVetterJobItemsMutation = {
	__typename?: 'Mutation';
	setOrderQuoteVetterJobItems: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type WithdrawOrderQuoteVetterJobMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type WithdrawOrderQuoteVetterJobMutation = {
	__typename?: 'Mutation';
	withdrawOrderQuoteVetterJob: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RevokeOrderQuoteVetterLinkMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type RevokeOrderQuoteVetterLinkMutation = {
	__typename?: 'Mutation';
	revokeOrderQuoteVetterLink: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type ApplyVetterPricesMutationVariables = Exact<{
	input: ApplyVetterPricesInput;
}>;

export type ApplyVetterPricesMutation = {
	__typename?: 'Mutation';
	applyVetterPrices: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RecordOrderQuoteViewMutationVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
}>;

export type RecordOrderQuoteViewMutation = {
	__typename?: 'Mutation';
	recordOrderQuoteView: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrderShipmentTrackingMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateOrderShipmentTrackingInput;
}>;

export type UpdateOrderShipmentTrackingMutation = {
	__typename?: 'Mutation';
	updateOrderShipmentTracking: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type CreateOrderShipmentMutationVariables = Exact<{
	input: CreateOrderShipmentInput;
}>;

export type CreateOrderShipmentMutation = {
	__typename?: 'Mutation';
	createOrderShipment: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type CreateOrganizationMutationVariables = Exact<{
	input: OrganizationCreateInput;
}>;

export type CreateOrganizationMutation = {
	__typename?: 'Mutation';
	createOrganization: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CreateOrganizationUserMutationVariables = Exact<{
	input: OrganizationUserCreateInput;
}>;

export type CreateOrganizationUserMutation = {
	__typename?: 'Mutation';
	createOrganizationUser: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteOrganizationUserMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteOrganizationUserMutation = {
	__typename?: 'Mutation';
	deleteOrganizationUser: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteManyOrganizationUserMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyOrganizationUserMutation = {
	__typename?: 'Mutation';
	deleteManyOrganizationUser: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationUserMutationVariables = Exact<{
	input: OrganizationUserUpdateInput;
}>;

export type UpdateOrganizationUserMutation = {
	__typename?: 'Mutation';
	updateOrganizationUser: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationMutationVariables = Exact<{
	input: OrganizationUpdateInput;
}>;

export type UpdateOrganizationMutation = {
	__typename?: 'Mutation';
	updateOrganization: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteMyOrganizationMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteMyOrganizationMutation = {
	__typename?: 'Mutation';
	deleteMyOrganization: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteOrganizationMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteOrganizationMutation = {
	__typename?: 'Mutation';
	deleteOrganization?: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	} | null;
};

export type DeleteManyOrganizationMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyOrganizationMutation = {
	__typename?: 'Mutation';
	deleteManyOrganization?: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	} | null;
};

export type UpdateOrganizationStripeCheckoutLimitMutationVariables = Exact<{
	input: UpdateOrganizationStripeCheckoutLimitInput;
}>;

export type UpdateOrganizationStripeCheckoutLimitMutation = {
	__typename?: 'Mutation';
	updateOrganizationStripeCheckoutLimit: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationInvoiceMinimumMutationVariables = Exact<{
	input: UpdateOrganizationInvoiceMinimumInput;
}>;

export type UpdateOrganizationInvoiceMinimumMutation = {
	__typename?: 'Mutation';
	updateOrganizationInvoiceMinimum: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type GenerateOrganizationLogoUploadUrlMutationVariables = Exact<{
	input: GenerateOrganizationLogoUploadUrlInput;
}>;

export type GenerateOrganizationLogoUploadUrlMutation = {
	__typename?: 'Mutation';
	generateOrganizationLogoUploadUrl: {
		__typename?: 'UploadUrlResponse';
		success?: boolean | null;
		message?: string | null;
		uploadUrl?: string | null;
		blobUrl?: string | null;
		expiresAt?: string | null;
	};
};

export type SaveOrganizationLogoMutationVariables = Exact<{
	input: SaveOrganizationLogoInput;
}>;

export type SaveOrganizationLogoMutation = {
	__typename?: 'Mutation';
	saveOrganizationLogo: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationApprovalAndMarginMutationVariables = Exact<{
	input: UpdateOrganizationApprovalAndMarginInput;
}>;

export type UpdateOrganizationApprovalAndMarginMutation = {
	__typename?: 'Mutation';
	updateOrganizationApprovalAndMargin: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationPaymentModeMutationVariables = Exact<{
	input: UpdateOrganizationPaymentModeInput;
}>;

export type UpdateOrganizationPaymentModeMutation = {
	__typename?: 'Mutation';
	updateOrganizationPaymentMode: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationPaymentTermsMutationVariables = Exact<{
	input: UpdateOrganizationPaymentTermsInput;
}>;

export type UpdateOrganizationPaymentTermsMutation = {
	__typename?: 'Mutation';
	updateOrganizationPaymentTerms: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CreateOrganizationAddressMutationVariables = Exact<{
	organizationId: Scalars['ID']['input'];
	input: OrganizationAddressInput;
}>;

export type CreateOrganizationAddressMutation = {
	__typename?: 'Mutation';
	createOrganizationAddress: { __typename?: 'OrganizationAddress'; id: string };
};

export type UpdateOrganizationAddressMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: OrganizationAddressInput;
}>;

export type UpdateOrganizationAddressMutation = {
	__typename?: 'Mutation';
	updateOrganizationAddress: { __typename?: 'OrganizationAddress'; id: string };
};

export type DeleteOrganizationAddressMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteOrganizationAddressMutation = {
	__typename?: 'Mutation';
	deleteOrganizationAddress: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type SetOrganizationInvoiceRecipientsMutationVariables = Exact<{
	input: SetOrganizationInvoiceRecipientsInput;
}>;

export type SetOrganizationInvoiceRecipientsMutation = {
	__typename?: 'Mutation';
	setOrganizationInvoiceRecipients: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type InviteOrganizationUserMutationVariables = Exact<{
	input: InviteOrganizationUserInput;
}>;

export type InviteOrganizationUserMutation = {
	__typename?: 'Mutation';
	inviteOrganizationUser: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CreateOrganizationIndustryMutationVariables = Exact<{
	input: CreateOrganizationIndustryInput;
}>;

export type CreateOrganizationIndustryMutation = {
	__typename?: 'Mutation';
	createOrganizationIndustry: {
		__typename?: 'OrganizationIndustry';
		id: string;
		name: string;
		isPublished: boolean;
		createdByOrganizationId?: string | null;
	};
};

export type PublishOrganizationIndustryMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type PublishOrganizationIndustryMutation = {
	__typename?: 'Mutation';
	publishOrganizationIndustry: {
		__typename?: 'OrganizationIndustry';
		id: string;
		name: string;
		isPublished: boolean;
	};
};

export type UpdateOrganizationIndustryMutationVariables = Exact<{
	input: UpdateOrganizationIndustryInput;
}>;

export type UpdateOrganizationIndustryMutation = {
	__typename?: 'Mutation';
	updateOrganizationIndustry: {
		__typename?: 'OrganizationIndustry';
		id: string;
		name: string;
		isPublished: boolean;
	};
};

export type DeleteOrganizationIndustryMutationVariables = Exact<{
	input: DeleteOrganizationIndustryInput;
}>;

export type DeleteOrganizationIndustryMutation = {
	__typename?: 'Mutation';
	deleteOrganizationIndustry: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type ConfirmPendingOfferAcceptanceMutationVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
}>;

export type ConfirmPendingOfferAcceptanceMutation = {
	__typename?: 'Mutation';
	confirmPendingOfferAcceptance: {
		__typename?: 'AcceptOrderQuoteOffersResponse';
		success: boolean;
		message: string;
		orderId?: string | null;
		pendingReview?: boolean | null;
	};
};

export type RejectPendingOfferAcceptanceMutationVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
	reason?: InputMaybe<Scalars['String']['input']>;
}>;

export type RejectPendingOfferAcceptanceMutation = {
	__typename?: 'Mutation';
	rejectPendingOfferAcceptance: {
		__typename?: 'AcceptOrderQuoteOffersResponse';
		success: boolean;
		message: string;
		orderId?: string | null;
		pendingReview?: boolean | null;
	};
};

export type ReviseLateOfferAcceptanceMutationVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
}>;

export type ReviseLateOfferAcceptanceMutation = {
	__typename?: 'Mutation';
	reviseLateOfferAcceptance: {
		__typename?: 'AcceptOrderQuoteOffersResponse';
		success: boolean;
		message: string;
		orderId?: string | null;
		pendingReview?: boolean | null;
	};
};

export type CreateProductMutationVariables = Exact<{
	input: ProductCreateInput;
}>;

export type CreateProductMutation = {
	__typename?: 'Mutation';
	createProduct: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
	};
};

export type UpdateProductMutationVariables = Exact<{
	input: ProductUpdateInput;
}>;

export type UpdateProductMutation = {
	__typename?: 'Mutation';
	updateProduct: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type GenerateProductImageUploadUrlMutationVariables = Exact<{
	input: ProductImageUploadInput;
}>;

export type GenerateProductImageUploadUrlMutation = {
	__typename?: 'Mutation';
	generateProductImageUploadUrl: {
		__typename?: 'ImageUploadResponse';
		success: boolean;
		message: string;
		uploadUrl: string;
		imageId?: string | null;
		blobUrl?: string | null;
		expiresAt: string;
	};
};

export type ConfirmProductImageUploadMutationVariables = Exact<{
	input: ConfirmProductImageUploadInput;
}>;

export type ConfirmProductImageUploadMutation = {
	__typename?: 'Mutation';
	confirmProductImageUpload: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type DeleteProductImageMutationVariables = Exact<{
	productId: Scalars['ID']['input'];
	imageId: Scalars['ID']['input'];
}>;

export type DeleteProductImageMutation = {
	__typename?: 'Mutation';
	deleteProductImage: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type UpdateProductImagePrimaryMutationVariables = Exact<{
	productId: Scalars['ID']['input'];
	imageId: Scalars['ID']['input'];
}>;

export type UpdateProductImagePrimaryMutation = {
	__typename?: 'Mutation';
	updateProductImagePrimary: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type UpdateProductImageCropMutationVariables = Exact<{
	productId: Scalars['ID']['input'];
	imageId: Scalars['ID']['input'];
	crop?: InputMaybe<ProductImageCropInput>;
}>;

export type UpdateProductImageCropMutation = {
	__typename?: 'Mutation';
	updateProductImageCrop: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteProductMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteProductMutation = {
	__typename?: 'Mutation';
	deleteProduct: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DuplicateProductMutationVariables = Exact<{
	input: DuplicateProductInput;
}>;

export type DuplicateProductMutation = {
	__typename?: 'Mutation';
	duplicateProduct: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
	};
};

export type DeleteManyProductMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyProductMutation = {
	__typename?: 'Mutation';
	deleteManyProduct: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type AssignProductsToOrganizationMutationVariables = Exact<{
	productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	brandId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AssignProductsToOrganizationMutation = {
	__typename?: 'Mutation';
	assignProductsToOrganization: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type CompleteRecommendationMutationVariables = Exact<{
	input: CompleteRecommendationInput;
}>;

export type CompleteRecommendationMutation = {
	__typename?: 'Mutation';
	completeRecommendation: {
		__typename?: 'CompleteRecommendationResponse';
		success: boolean;
		message?: string | null;
		productId?: string | null;
		studioFileId?: string | null;
	};
};

export type PublishProductsToCommunityMutationVariables = Exact<{
	productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type PublishProductsToCommunityMutation = {
	__typename?: 'Mutation';
	publishProductsToCommunity: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			field?: string | null;
			message: string;
		}> | null;
	};
};

export type UnpublishProductsFromCommunityMutationVariables = Exact<{
	productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type UnpublishProductsFromCommunityMutation = {
	__typename?: 'Mutation';
	unpublishProductsFromCommunity: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
	};
};

export type CreateProductTagMutationVariables = Exact<{
	input: ProductTagCreateInput;
}>;

export type CreateProductTagMutation = {
	__typename?: 'Mutation';
	createProductTag: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
	};
};

export type SetProductPricesMutationVariables = Exact<{
	input: SetProductPricesInput;
}>;

export type SetProductPricesMutation = {
	__typename?: 'Mutation';
	setProductPrices: { __typename?: 'MessageResponse'; message: string };
};

export type DeleteProductPriceMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteProductPriceMutation = {
	__typename?: 'Mutation';
	deleteProductPrice: { __typename?: 'MessageResponse'; message: string };
};

export type SetProductSamplePriceMutationVariables = Exact<{
	input: SetProductSamplePriceInput;
}>;

export type SetProductSamplePriceMutation = {
	__typename?: 'Mutation';
	setProductSamplePrice: { __typename?: 'MessageResponse'; message: string };
};

export type DeleteProductSamplePriceMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteProductSamplePriceMutation = {
	__typename?: 'Mutation';
	deleteProductSamplePrice: { __typename?: 'MessageResponse'; message: string };
};

export type AddQuoteProductCommentMutationVariables = Exact<{
	input: AddQuoteProductCommentInput;
}>;

export type AddQuoteProductCommentMutation = {
	__typename?: 'Mutation';
	addQuoteProductComment: {
		__typename?: 'AddQuoteProductCommentResponse';
		success: boolean;
		message: string;
		comment?: {
			__typename?: 'QuoteProductComment';
			id: string;
			orderQuoteItemId: string;
			vetterEntityId?: string | null;
			body: string;
			isMine: boolean;
			canEdit: boolean;
			canDelete: boolean;
			createdAt?: string | null;
			editedAt?: string | null;
			deletedAt?: string | null;
			author: {
				__typename?: 'QuoteProductCommentAuthor';
				userId: string;
				name: string;
				side: QuoteProductCommentSide;
			};
			mentions: Array<{
				__typename?: 'QuoteProductCommentMention';
				userId: string;
				name: string;
			}>;
			attachments: Array<{
				__typename?: 'QuoteProductCommentAttachment';
				name: string;
				url?: string | null;
				mimeType: string;
				size: number;
			}>;
		} | null;
	};
};

export type EditQuoteProductCommentMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	body: Scalars['String']['input'];
}>;

export type EditQuoteProductCommentMutation = {
	__typename?: 'Mutation';
	editQuoteProductComment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteQuoteProductCommentMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteQuoteProductCommentMutation = {
	__typename?: 'Mutation';
	deleteQuoteProductComment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type GenerateQuoteProductCommentUploadUrlMutationVariables = Exact<{
	input: GenerateQuoteProductCommentUploadUrlInput;
}>;

export type GenerateQuoteProductCommentUploadUrlMutation = {
	__typename?: 'Mutation';
	generateQuoteProductCommentUploadUrl: {
		__typename?: 'QuoteProductCommentUploadUrlResponse';
		success: boolean;
		message: string;
		uploadUrl?: string | null;
		blobUrl?: string | null;
	};
};

export type MarkQuoteProductThreadReadMutationVariables = Exact<{
	input: QuoteProductThreadInput;
}>;

export type MarkQuoteProductThreadReadMutation = {
	__typename?: 'Mutation';
	markQuoteProductThreadRead: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RejectOrderQuoteOfferBatchMutationVariables = Exact<{
	input: RejectOrderQuoteOfferBatchInput;
}>;

export type RejectOrderQuoteOfferBatchMutation = {
	__typename?: 'Mutation';
	rejectOrderQuoteOfferBatch: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RejectOrderQuoteOfferMutationVariables = Exact<{
	input: RejectOrderQuoteOfferInput;
}>;

export type RejectOrderQuoteOfferMutation = {
	__typename?: 'Mutation';
	rejectOrderQuoteOffer: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateSampleStatusMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateSampleStatusInput;
}>;

export type UpdateSampleStatusMutation = {
	__typename?: 'Mutation';
	updateSampleStatus: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type ApproveNewSampleRoundMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input?: InputMaybe<ApproveNewSampleRoundInput>;
}>;

export type ApproveNewSampleRoundMutation = {
	__typename?: 'Mutation';
	approveNewSampleRound: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type SetSamplePaymentTreatmentMutationVariables = Exact<{
	sampleId: Scalars['ID']['input'];
	treatment: SamplePaymentTreatment;
}>;

export type SetSamplePaymentTreatmentMutation = {
	__typename?: 'Mutation';
	setSamplePaymentTreatment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type GenerateSampleAttachmentUploadUrlMutationVariables = Exact<{
	input: GenerateSampleAttachmentUploadUrlInput;
}>;

export type GenerateSampleAttachmentUploadUrlMutation = {
	__typename?: 'Mutation';
	generateSampleAttachmentUploadUrl: {
		__typename?: 'FileUploadResponse';
		uploadUrl: string;
		blobUrl?: string | null;
		fileId?: string | null;
		success: boolean;
		message: string;
	};
};

export type ConfirmSampleAttachmentUploadsMutationVariables = Exact<{
	input: ConfirmSampleAttachmentUploadsInput;
}>;

export type ConfirmSampleAttachmentUploadsMutation = {
	__typename?: 'Mutation';
	confirmSampleAttachmentUploads: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type SaveOfferBatchSelectionMutationVariables = Exact<{
	input: SaveOfferBatchSelectionInput;
}>;

export type SaveOfferBatchSelectionMutation = {
	__typename?: 'Mutation';
	saveOfferBatchSelection: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type SendTestNotificationMutationVariables = Exact<{
	type?: InputMaybe<NotificationType>;
	email?: InputMaybe<Scalars['String']['input']>;
}>;

export type SendTestNotificationMutation = {
	__typename?: 'Mutation';
	sendTestNotification: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type SendStudioMessageMutationVariables = Exact<{
	input: SendStudioMessageInput;
}>;

export type SendStudioMessageMutation = {
	__typename?: 'Mutation';
	sendStudioMessage: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type CreateSubscriptionCheckoutSessionMutationVariables = Exact<{
	tier: SubscriptionTier;
}>;

export type CreateSubscriptionCheckoutSessionMutation = {
	__typename?: 'Mutation';
	createSubscriptionCheckoutSession: {
		__typename?: 'CreateSubscriptionCheckoutResponse';
		success: boolean;
		clientSecret?: string | null;
		sessionId?: string | null;
		message?: string | null;
	};
};

export type ChangeSubscriptionPlanMutationVariables = Exact<{
	tier: SubscriptionTier;
}>;

export type ChangeSubscriptionPlanMutation = {
	__typename?: 'Mutation';
	changeSubscriptionPlan: {
		__typename?: 'SubscriptionMutationResponse';
		success: boolean;
		message?: string | null;
		requiresAction?: boolean | null;
		clientSecret?: string | null;
		subscription?: {
			__typename?: 'OrganizationSubscription';
			id: string;
			tier: SubscriptionTier;
			status: SubscriptionStatus;
			stripePriceId?: string | null;
			currentPeriodEnd?: string | null;
			cancelAtPeriodEnd: boolean;
			pendingTier?: SubscriptionTier | null;
			pendingTierEffectiveAt?: string | null;
		} | null;
	};
};

export type CancelScheduledPlanChangeMutationVariables = Exact<{ [key: string]: never }>;

export type CancelScheduledPlanChangeMutation = {
	__typename?: 'Mutation';
	cancelScheduledPlanChange: {
		__typename?: 'SubscriptionMutationResponse';
		success: boolean;
		message?: string | null;
		subscription?: {
			__typename?: 'OrganizationSubscription';
			id: string;
			tier: SubscriptionTier;
			pendingTier?: SubscriptionTier | null;
			pendingTierEffectiveAt?: string | null;
		} | null;
	};
};

export type CancelSubscriptionMutationVariables = Exact<{ [key: string]: never }>;

export type CancelSubscriptionMutation = {
	__typename?: 'Mutation';
	cancelSubscription: {
		__typename?: 'SubscriptionMutationResponse';
		success: boolean;
		message?: string | null;
		subscription?: {
			__typename?: 'OrganizationSubscription';
			id: string;
			status: SubscriptionStatus;
			cancelAtPeriodEnd: boolean;
			canceledAt?: string | null;
		} | null;
	};
};

export type ResumeSubscriptionMutationVariables = Exact<{ [key: string]: never }>;

export type ResumeSubscriptionMutation = {
	__typename?: 'Mutation';
	resumeSubscription: {
		__typename?: 'SubscriptionMutationResponse';
		success: boolean;
		message?: string | null;
		subscription?: {
			__typename?: 'OrganizationSubscription';
			id: string;
			status: SubscriptionStatus;
			cancelAtPeriodEnd: boolean;
		} | null;
	};
};

export type UpdateSubscriptionTierConfigMutationVariables = Exact<{
	tier: SubscriptionTier;
	kickbackRate?: InputMaybe<Scalars['Float']['input']>;
	aiTokenRatePerMillion?: InputMaybe<Scalars['Float']['input']>;
	stripePriceId?: InputMaybe<Scalars['String']['input']>;
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpdateSubscriptionTierConfigMutation = {
	__typename?: 'Mutation';
	updateSubscriptionTierConfig: {
		__typename?: 'SubscriptionTierConfig';
		tier: SubscriptionTier;
		monthlyPrice?: number | null;
		currency?: string | null;
		kickbackRate: number;
		aiTokenRatePerMillion?: number | null;
		stripePriceId?: string | null;
		isActive: boolean;
		updatedAt: string;
	};
};

export type UpdateSystemSettingsMutationVariables = Exact<{
	input: UpdateSystemSettingInput;
}>;

export type UpdateSystemSettingsMutation = {
	__typename?: 'Mutation';
	updateSystemSettings: { __typename?: 'MessageResponse'; message: string; success: boolean };
};

export type CreateVetterEntityMutationVariables = Exact<{
	input: CreateVetterEntityInput;
}>;

export type CreateVetterEntityMutation = {
	__typename?: 'Mutation';
	createVetterEntity: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
	};
};

export type UpdateVetterEntityMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateVetterEntityInput;
}>;

export type UpdateVetterEntityMutation = {
	__typename?: 'Mutation';
	updateVetterEntity: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteVetterEntityMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteVetterEntityMutation = {
	__typename?: 'Mutation';
	deleteVetterEntity: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type RequestVetterJobAccessCodeMutationVariables = Exact<{
	input: RequestVetterJobAccessCodeInput;
}>;

export type RequestVetterJobAccessCodeMutation = {
	__typename?: 'Mutation';
	requestVetterJobAccessCode: {
		__typename?: 'MessageResponse';
		messageKey?: string | null;
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type VetterJobLoginMutationVariables = Exact<{
	input: VetterJobLoginInput;
}>;

export type VetterJobLoginMutation = {
	__typename?: 'Mutation';
	vetterJobLogin: {
		__typename?: 'VetterJobLoginResponse';
		success: boolean;
		message: string;
		token?: string | null;
	};
};

export type SubmitVetterJobPricesMutationVariables = Exact<{
	input: SubmitVetterJobPricesInput;
}>;

export type SubmitVetterJobPricesMutation = {
	__typename?: 'Mutation';
	submitVetterJobPrices: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CompleteVetterJobProductionMutationVariables = Exact<{
	orderItemId: Scalars['ID']['input'];
}>;

export type CompleteVetterJobProductionMutation = {
	__typename?: 'Mutation';
	completeVetterJobProduction: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateVetterJobShipmentTrackingMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateVetterJobShipmentTrackingInput;
}>;

export type UpdateVetterJobShipmentTrackingMutation = {
	__typename?: 'Mutation';
	updateVetterJobShipmentTracking: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CreateVetterUserMutationVariables = Exact<{
	input: CreateVetterUserInput;
}>;

export type CreateVetterUserMutation = {
	__typename?: 'Mutation';
	createVetterUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type UpdateVetterUserMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateVetterUserInput;
}>;

export type UpdateVetterUserMutation = {
	__typename?: 'Mutation';
	updateVetterUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteVetterUserMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteVetterUserMutation = {
	__typename?: 'Mutation';
	deleteVetterUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type InviteVetterUserMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type InviteVetterUserMutation = {
	__typename?: 'Mutation';
	inviteVetterUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type GetAdminActiveActivitiesQueryVariables = Exact<{
	limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetAdminActiveActivitiesQuery = {
	__typename?: 'Query';
	getAdminActiveActivities: {
		__typename?: 'AdminActiveActivities';
		activities: Array<
			| {
					__typename: 'AdminOrderActivity';
					id: string;
					type: AdminActivityType;
					title?: string | null;
					orderId: string;
			  }
			| {
					__typename: 'AdminOrderQuoteOfferBatchActivity';
					id: string;
					type: AdminActivityType;
					title?: string | null;
					batchId: string;
					batch?: {
						__typename?: 'OrderQuoteOfferBatch';
						id: string;
						name: string;
						status: OrderQuoteOfferStatus;
						orderQuoteId: string;
						summary?: {
							__typename?: 'OrderQuoteOfferBatchSummary';
							grandTotal: number;
						} | null;
					} | null;
			  }
			| {
					__typename: 'AdminQuoteActivity';
					id: string;
					type: AdminActivityType;
					title?: string | null;
					quoteId: string;
			  }
		>;
	};
};

export type GetOrganizationActiveActivitiesQueryVariables = Exact<{
	limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetOrganizationActiveActivitiesQuery = {
	__typename?: 'Query';
	getOrganizationActiveActivities: {
		__typename?: 'OrganizationActiveActivities';
		activities: Array<
			| {
					__typename: 'OrganizationOrderActivity';
					id: string;
					type: OrganizationActivityType;
					title?: string | null;
					orderId: string;
			  }
			| {
					__typename: 'OrganizationOrderQuoteOfferBatchActivity';
					id: string;
					type: OrganizationActivityType;
					title?: string | null;
					batchId: string;
					batch?: {
						__typename?: 'ClientOrderQuoteOfferBatch';
						id: string;
						name: string;
						status: OrderQuoteOfferStatus;
						orderQuoteId: string;
					} | null;
			  }
			| {
					__typename: 'OrganizationQuoteActivity';
					id: string;
					type: OrganizationActivityType;
					title?: string | null;
					quoteId: string;
			  }
		>;
	};
};

export type GetAllAdminUserQueryVariables = Exact<{
	input: GetAllAdminUserInput;
}>;

export type GetAllAdminUserQuery = {
	__typename?: 'Query';
	getAllAdminUser: {
		__typename?: 'AdminUserPage';
		data: Array<{
			__typename?: 'AdminUser';
			id: string;
			userId: string;
			firstName: string;
			lastName: string;
			createdAt?: string | null;
			updatedAt?: string | null;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
				role: AuthRoleEnum;
				lockedAt?: string | null;
				lockReason?: string | null;
				mfaEnabled: boolean;
				language: string;
				lastActive?: string | null;
			} | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalCount: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetAdminUserStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAdminUserStatsQuery = {
	__typename?: 'Query';
	getAdminUserStats: {
		__typename?: 'AdminUserStats';
		active: number;
		pending: number;
		total: number;
	};
};

export type CheckEmailExistsQueryVariables = Exact<{
	email: Scalars['String']['input'];
}>;

export type CheckEmailExistsQuery = {
	__typename?: 'Query';
	checkEmailExists: { __typename?: 'EmailExistsResponse'; exists: boolean };
};

export type BrandPaletteColorFragmentFragment = {
	__typename?: 'BrandColor';
	name?: string | null;
	hex: string;
	usage?: string | null;
	pantone?: {
		__typename?: 'BrandPantoneRef';
		book: PantoneBook;
		code: string;
		hex?: string | null;
		color?: {
			__typename?: 'PantoneColor';
			bookTitle: string;
			finish: PantoneFinish;
			pageNumberInBook?: string | null;
		} | null;
	} | null;
};

export type GetAllBrandsQueryVariables = Exact<{
	input: GetAllBrandInput;
}>;

export type GetAllBrandsQuery = {
	__typename?: 'Query';
	getAllBrand: {
		__typename?: 'BrandPage';
		data: Array<{
			__typename?: 'Brand';
			id: string;
			name: string;
			organizationId: string;
			description?: string | null;
			brandguide?: string | null;
			website?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
			logo?: {
				__typename?: 'BrandLogo';
				id: string;
				name: string;
				url?: string | null;
				thumbnailUrl?: string | null;
				mimeType: string;
			} | null;
			colorPalette?: {
				__typename?: 'BrandColorPalette';
				primary?: Array<{
					__typename?: 'BrandColor';
					name?: string | null;
					hex: string;
				}> | null;
				secondary?: Array<{
					__typename?: 'BrandColor';
					name?: string | null;
					hex: string;
				}> | null;
				accent?: Array<{
					__typename?: 'BrandColor';
					name?: string | null;
					hex: string;
				}> | null;
				neutral?: Array<{
					__typename?: 'BrandColor';
					name?: string | null;
					hex: string;
				}> | null;
			} | null;
			typography?: {
				__typename?: 'BrandTypography';
				primaryFont?: string | null;
				secondaryFont?: string | null;
			} | null;
			address?: {
				__typename?: 'BrandAddress';
				formatted?: string | null;
				city?: string | null;
				state?: string | null;
				country?: string | null;
				postalCode?: string | null;
			} | null;
			brandFiles?: Array<{
				__typename?: 'BrandFile';
				id: string;
				name: string;
				url?: string | null;
				thumbnailUrl?: string | null;
				type: BrandFileType;
				mimeType: string;
				size: number;
				uploadedAt: string;
			}> | null;
			fontFiles?: Array<{
				__typename?: 'FontFile';
				id: string;
				family: string;
				name: string;
				style?: string | null;
				url?: string | null;
				weight?: string | null;
			}> | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetBrandQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetBrandQuery = {
	__typename?: 'Query';
	getBrand: {
		__typename?: 'Brand';
		id: string;
		name: string;
		organizationId: string;
		description?: string | null;
		brandguide?: string | null;
		website?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		logo?: {
			__typename?: 'BrandLogo';
			id: string;
			name: string;
			url?: string | null;
			thumbnailUrl?: string | null;
			mimeType: string;
		} | null;
		brandPersonality?: {
			__typename?: 'BrandPersonality';
			tone?: string | null;
			traits?: Array<string> | null;
			values?: Array<string> | null;
			aiGuidance?: string | null;
		} | null;
		typography?: {
			__typename?: 'BrandTypography';
			primaryFont?: string | null;
			secondaryFont?: string | null;
			guidelines?: string | null;
		} | null;
		usageGuidelines?: {
			__typename?: 'BrandUsageGuidelines';
			logoPlacement?: string | null;
			colorUsage?: string | null;
			typographyRules?: string | null;
			spacing?: string | null;
		} | null;
		address?: {
			__typename?: 'BrandAddress';
			formatted?: string | null;
			city?: string | null;
			country?: string | null;
		} | null;
		colorPalette?: {
			__typename?: 'BrandColorPalette';
			primary?: Array<{
				__typename?: 'BrandColor';
				name?: string | null;
				hex: string;
				usage?: string | null;
				pantone?: {
					__typename?: 'BrandPantoneRef';
					book: PantoneBook;
					code: string;
					hex?: string | null;
					color?: {
						__typename?: 'PantoneColor';
						bookTitle: string;
						finish: PantoneFinish;
						pageNumberInBook?: string | null;
					} | null;
				} | null;
			}> | null;
			secondary?: Array<{
				__typename?: 'BrandColor';
				name?: string | null;
				hex: string;
				usage?: string | null;
				pantone?: {
					__typename?: 'BrandPantoneRef';
					book: PantoneBook;
					code: string;
					hex?: string | null;
					color?: {
						__typename?: 'PantoneColor';
						bookTitle: string;
						finish: PantoneFinish;
						pageNumberInBook?: string | null;
					} | null;
				} | null;
			}> | null;
			accent?: Array<{
				__typename?: 'BrandColor';
				name?: string | null;
				hex: string;
				usage?: string | null;
				pantone?: {
					__typename?: 'BrandPantoneRef';
					book: PantoneBook;
					code: string;
					hex?: string | null;
					color?: {
						__typename?: 'PantoneColor';
						bookTitle: string;
						finish: PantoneFinish;
						pageNumberInBook?: string | null;
					} | null;
				} | null;
			}> | null;
			neutral?: Array<{
				__typename?: 'BrandColor';
				name?: string | null;
				hex: string;
				usage?: string | null;
				pantone?: {
					__typename?: 'BrandPantoneRef';
					book: PantoneBook;
					code: string;
					hex?: string | null;
					color?: {
						__typename?: 'PantoneColor';
						bookTitle: string;
						finish: PantoneFinish;
						pageNumberInBook?: string | null;
					} | null;
				} | null;
			}> | null;
		} | null;
		brandFiles?: Array<{
			__typename?: 'BrandFile';
			id: string;
			name: string;
			url?: string | null;
			thumbnailUrl?: string | null;
			type: BrandFileType;
			mimeType: string;
			size: number;
			uploadedAt: string;
			designVariant?: string | null;
			backgroundType?: Array<string> | null;
			usageContext?: Array<string> | null;
			tags?: Array<string> | null;
		}> | null;
		fontFiles?: Array<{
			__typename?: 'FontFile';
			id: string;
			family: string;
			name: string;
			style?: string | null;
			url?: string | null;
			weight?: string | null;
		}> | null;
	};
};

export type GetClientOrderQueryVariables = Exact<{
	id: Scalars['ID']['input'];
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type GetClientOrderQuery = {
	__typename?: 'Query';
	getClientOrder?: {
		__typename?: 'ClientOrder';
		id: string;
		name: string;
		orderNumber: string;
		status: OrderStatus;
		orderQuoteId: string;
		poNumber?: string | null;
		totalAmount?: number | null;
		totalQuantity?: number | null;
		setupStage?: OrderSetupStage | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		deliveryAddress?: {
			__typename?: 'OrderQuoteAddress';
			addressLine1?: string | null;
			addressLine2?: string | null;
			city?: string | null;
			stateCode?: string | null;
			postalCode?: string | null;
			countryCode?: string | null;
		} | null;
		summary?: {
			__typename?: 'OrderSummary';
			productsSubtotal: number;
			samplesTotal: number;
			samplesShippingTotal: number;
			samplesPrepaidTotal: number;
			deliveryTotal: number;
			feesTotal: number;
			discountsTotal: number;
			sampleCreditAtRisk: number;
			grandTotal: number;
			vatRate: number;
			vatAmount: number;
			grossAmount: number;
			fees: Array<{ __typename?: 'OrderSummaryLineItem'; name: string; amount: number }>;
			discounts: Array<{ __typename?: 'OrderSummaryLineItem'; name: string; amount: number }>;
		} | null;
		paymentSummary?: {
			__typename?: 'OrderPaymentSummary';
			productTotalAmount: number;
			productPaidAmount: number;
			productOutstandingAmount: number;
			productStatus: OrderPaymentStatus;
			sampleTotalAmount: number;
			samplePaidAmount: number;
			sampleOutstandingAmount: number;
			sampleStatus: OrderPaymentStatus;
			totalAmount: number;
			totalPaidAmount: number;
			totalOutstandingAmount: number;
			vatRate: number;
		} | null;
		availableActions?: Array<{
			__typename?: 'OrderNextAction';
			action: OrderAction;
			actor: SampleActionActor;
			kind: ActionKind;
			label: string;
			blocked?: boolean | null;
			blockedReason?: string | null;
			warningReason?: string | null;
			itemCount?: number | null;
			amount?: number | null;
			currency?: CurrencyEnum | null;
		}> | null;
		paymentOptions?: Array<{
			__typename?: 'OrderPaymentOption';
			key: string;
			scope: OrderPaymentOptionScope;
			targetIds: Array<string>;
			label: string;
			amount: number;
			currency: CurrencyEnum;
			blocked?: boolean | null;
			blockedReason?: string | null;
		}> | null;
		availablePaymentMethods?: Array<{
			__typename?: 'OrderPaymentMethodOption';
			method: OrderPaymentMethod;
			available: boolean;
			reason?: string | null;
		}> | null;
		availableSamplePaymentMethods?: Array<{
			__typename?: 'OrderPaymentMethodOption';
			method: OrderPaymentMethod;
			available: boolean;
			reason?: string | null;
		}> | null;
		items: Array<{
			__typename?: 'ClientOrderItem';
			id: string;
			productId?: string | null;
			productName?: string | null;
			productDescription?: string | null;
			productSku?: string | null;
			productSpecificationsAt?: string | null;
			productWeight?: number | null;
			quantity: number;
			sortOrder: number;
			status: OrderItemStatus;
			sampleChoice?: OrderSampleChoice | null;
			shippedQuantity?: number | null;
			deliveredQuantity?: number | null;
			unitPrice?: number | null;
			totalPrice?: number | null;
			adjustedTotalPrice?: number | null;
			lineTotal?: number | null;
			minProductionDays?: number | null;
			maxProductionDays?: number | null;
			waitingOn?: SampleActionActor | null;
			paidAt?: string | null;
			productionStartedAt?: string | null;
			productionCompletedAt?: string | null;
			shippedAt?: string | null;
			actualDeliveryDate?: string | null;
			carrier?: string | null;
			trackingNumber?: string | null;
			estimatedDeliveryDate?: string | null;
			createdAt?: string | null;
			productImages?: Array<{
				__typename?: 'OrderItemProductImage';
				url: string;
				isPrimary?: boolean | null;
				sortOrder?: number | null;
				altText?: string | null;
				caption?: string | null;
				dimensions?: {
					__typename?: 'OrderProductImageDimensions';
					width?: number | null;
					height?: number | null;
					aspectRatio?: string | null;
				} | null;
				crop?: {
					__typename?: 'OrderProductImageCrop';
					x: number;
					y: number;
					width: number;
					height: number;
					zoom?: number | null;
					rotation?: number | null;
					aspectRatio?: string | null;
					unit?: string | null;
				} | null;
			}> | null;
			productSpecifications?: {
				__typename?: 'OrderProductSpecifications';
				material?: string | null;
				secondaryMaterials?: Array<string> | null;
				finish?: string | null;
				textureDescription?: string | null;
				features?: Array<string> | null;
				capacity?: {
					__typename?: 'OrderProductMeasure';
					value: number;
					unit: string;
				} | null;
				colors?: Array<{
					__typename?: 'OrderProductColorSpec';
					name?: string | null;
					code?: string | null;
					pantone?: string | null;
					appliesTo?: string | null;
					finish?: string | null;
					isPrimary?: boolean | null;
				}> | null;
				packaging?: {
					__typename?: 'OrderProductPackaging';
					type?: string | null;
					weight?: number | null;
					weightUnit?: string | null;
					notes?: string | null;
					dimensions?: {
						__typename?: 'OrderProductDimensions';
						length?: number | null;
						width?: number | null;
						height?: number | null;
						unit: string;
					} | null;
				} | null;
				decorations?: Array<{
					__typename?: 'OrderProductDecoration';
					id: string;
					method: OrderProductDecorationMethod;
					methodNote?: string | null;
					placement?: string | null;
					colorCount?: number | null;
					artworkUrl?: string | null;
					notes?: string | null;
					sortOrder?: number | null;
					area?: {
						__typename?: 'OrderProductPrintArea';
						width?: number | null;
						height?: number | null;
						unit: string;
					} | null;
					colors?: Array<{
						__typename?: 'OrderProductColorSpec';
						name?: string | null;
						code?: string | null;
						pantone?: string | null;
						appliesTo?: string | null;
						finish?: string | null;
						isPrimary?: boolean | null;
					}> | null;
				}> | null;
				custom?: Array<{
					__typename?: 'OrderProductCustomSpec';
					id: string;
					label: string;
					value: string;
					unit?: string | null;
					group?: string | null;
					sortOrder?: number | null;
				}> | null;
			} | null;
			productDimensions?: {
				__typename?: 'OrderProductDimensions';
				length?: number | null;
				width?: number | null;
				height?: number | null;
				unit: string;
			} | null;
			attachments?: Array<{
				__typename?: 'OrderItemAttachment';
				id: string;
				name: string;
				description?: string | null;
				mimeType: string;
				size: number;
				url: string;
			}> | null;
			lifecycle?: Array<{
				__typename?: 'OrderItemLifecycleStep';
				step: OrderItemLifecycleStepEnum;
				label: string;
				completed: boolean;
				current: boolean;
				actor?: SampleActionActor | null;
				skipped: boolean;
				skippedReason?: string | null;
				outstanding: boolean;
				outstandingReason?: string | null;
			}> | null;
			availableActions?: Array<{
				__typename?: 'OrderItemNextAction';
				action: OrderItemActionType;
				actor: SampleActionActor;
				kind: ActionKind;
				status?: OrderItemStatus | null;
				label: string;
				blocked?: boolean | null;
				blockedReason?: string | null;
				warningReason?: string | null;
			}> | null;
			shipments?: Array<{
				__typename?: 'OrderItemShipment';
				quantity: number;
				shipment: {
					__typename?: 'OrderShipment';
					id: string;
					sequence: number;
					status: OrderShipmentStatus;
					shippingMethod?: OrderShippingMethod | null;
					carrier?: string | null;
					trackingNumber?: string | null;
					trackingUrl?: string | null;
					shippedAt?: string | null;
					estimatedDeliveryDate?: string | null;
					actualDeliveryDate?: string | null;
				};
			}> | null;
			delivery?: {
				__typename?: 'ClientOrderItemDelivery';
				id: string;
				shippingMethod: OrderShippingMethod;
				shippingMethodLabel?: string | null;
				quantity: number;
				deliveryDaysMin: number;
				deliveryDaysMax: number;
				totalPrice?: number | null;
			} | null;
			samples?: Array<{
				__typename?: 'ClientOrderItemSample';
				id: string;
				sampleChoice: OrderSampleChoice;
				sampleRound: number;
				status: OrderSampleStatus;
				totalPrice?: number | null;
				paymentTreatment: SamplePaymentTreatment;
				paidAt?: string | null;
				minProductionDays?: number | null;
				maxProductionDays?: number | null;
				deliveryDaysMin?: number | null;
				deliveryDaysMax?: number | null;
				approvedAt?: string | null;
				notes?: string | null;
				approvalNotes?: string | null;
				rejectedAt?: string | null;
				rejectionReason?: string | null;
				requestNewSample?: boolean | null;
				productionStartedAt?: string | null;
				productionCompletedAt?: string | null;
				shippedAt?: string | null;
				carrier?: string | null;
				trackingNumber?: string | null;
				trackingUrl?: string | null;
				estimatedDeliveryDate?: string | null;
				actualDeliveryDate?: string | null;
				virtualDeliverySubmittedAt?: string | null;
				virtualDeliveryNotes?: string | null;
				previousSampleId?: string | null;
				lifecycle?: Array<{
					__typename?: 'OrderSampleLifecycleStep';
					step: OrderSampleLifecycleStepEnum;
					label: string;
					completed: boolean;
					current: boolean;
					actor?: SampleActionActor | null;
					outstanding: boolean;
					outstandingReason?: string | null;
				}> | null;
				virtualDeliveryAttachments?: Array<{
					__typename?: 'ClientOrderItemSampleAttachment';
					id: string;
					name: string;
					mimeType: string;
					size: number;
					url: string;
					type: OrderSampleAttachmentType;
				}> | null;
				rejectionAttachments?: Array<{
					__typename?: 'ClientOrderItemSampleAttachment';
					id: string;
					name: string;
					mimeType: string;
					size: number;
					url: string;
					type: OrderSampleAttachmentType;
				}> | null;
				availableActions?: Array<{
					__typename?: 'SampleNextAction';
					action: SampleActionType;
					actor: SampleActionActor;
					kind: ActionKind;
					label: string;
					status?: OrderSampleStatus | null;
					blocked?: boolean | null;
					blockedReason?: string | null;
					warningReason?: string | null;
					requiredFields: Array<string>;
					optionalFields: Array<string>;
					requiresAttachments?: OrderSampleAttachmentType | null;
					supportsAttachments?: OrderSampleAttachmentType | null;
					hasAttachments?: boolean | null;
				}> | null;
			}> | null;
		}>;
		deliveries?: Array<{
			__typename?: 'OrderDelivery';
			id: string;
			kind: OrderDeliveryKind;
			isPhysical: boolean;
			reference: string;
			state: OrderDeliveryState;
			stateLabel: string;
			carrier?: string | null;
			trackingNumber?: string | null;
			trackingUrl?: string | null;
			shippingMethodLabel?: string | null;
			projected: boolean;
			expectedEarliest?: string | null;
			expectedLatest?: string | null;
			shippedAt?: string | null;
			actualDeliveryDate?: string | null;
			lines: Array<{
				__typename?: 'OrderDeliveryLine';
				orderItemId: string;
				productName?: string | null;
				quantity: number;
			}>;
		}> | null;
		shipments: Array<{
			__typename?: 'OrderShipment';
			id: string;
			sequence: number;
			shippingMethod?: OrderShippingMethod | null;
			status: OrderShipmentStatus;
			deliveryDaysMin: number;
			deliveryDaysMax: number;
			carrier?: string | null;
			trackingNumber?: string | null;
			trackingUrl?: string | null;
			shippedAt?: string | null;
			estimatedDeliveryDate?: string | null;
			actualDeliveryDate?: string | null;
			splitOfOrderShipmentId?: string | null;
			totalPrice?: number | null;
			lifecycle?: Array<{
				__typename?: 'OrderItemLifecycleStep';
				step: OrderItemLifecycleStepEnum;
				label: string;
				completed: boolean;
				current: boolean;
				actor?: SampleActionActor | null;
				skipped: boolean;
				outstanding: boolean;
				outstandingReason?: string | null;
			}> | null;
			lines: Array<{
				__typename?: 'OrderShipmentLine';
				id: string;
				orderItemId: string;
				quantity: number;
			}>;
		}>;
	} | null;
};

export type GetAllClientOrdersQueryVariables = Exact<{
	input: GetAllClientOrdersInput;
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type GetAllClientOrdersQuery = {
	__typename?: 'Query';
	getAllClientOrders: {
		__typename?: 'ClientOrderPage';
		data: Array<{
			__typename?: 'ClientOrder';
			id: string;
			name: string;
			orderNumber: string;
			status: OrderStatus;
			orderQuoteId: string;
			totalAmount?: number | null;
			createdAt?: string | null;
			updatedAt?: string | null;
			summary?: {
				__typename?: 'OrderSummary';
				grandTotal: number;
				grossAmount: number;
			} | null;
			items: Array<{
				__typename?: 'ClientOrderItem';
				id: string;
				quantity: number;
				productName?: string | null;
				status: OrderItemStatus;
				productImages?: Array<{
					__typename?: 'OrderItemProductImage';
					url: string;
					isPrimary?: boolean | null;
					sortOrder?: number | null;
					altText?: string | null;
					caption?: string | null;
					dimensions?: {
						__typename?: 'OrderProductImageDimensions';
						width?: number | null;
						height?: number | null;
						aspectRatio?: string | null;
					} | null;
					crop?: {
						__typename?: 'OrderProductImageCrop';
						x: number;
						y: number;
						width: number;
						height: number;
						zoom?: number | null;
						rotation?: number | null;
						aspectRatio?: string | null;
						unit?: string | null;
					} | null;
				}> | null;
			}>;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalCount: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetClientOrdersQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
}>;

export type GetClientOrdersQuery = {
	__typename?: 'Query';
	getClientOrders: Array<{
		__typename?: 'ClientOrder';
		id: string;
		name: string;
		orderNumber: string;
		status: OrderStatus;
		createdAt?: string | null;
	}>;
};

export type GetClientOrderQuoteQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetClientOrderQuoteQuery = {
	__typename?: 'Query';
	getClientOrderQuote?: {
		__typename?: 'ClientOrderQuote';
		id: string;
		name: string;
		description?: string | null;
		deadline?: string | null;
		status: OrderQuoteStatus;
		organizationId?: string | null;
		offerBatchCount: number;
		offerRequestedAt?: string | null;
		purpose?: OrderQuotePurpose | null;
		purposeOther?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		lifecycle?: Array<{
			__typename?: 'OrderQuoteLifecycleStep';
			step: OrderQuoteLifecycleStepEnum;
			label: string;
			completed: boolean;
			current: boolean;
		}> | null;
		deliveryAddress?: {
			__typename?: 'OrderQuoteAddress';
			addressLine1?: string | null;
			addressLine2?: string | null;
			city?: string | null;
			stateCode?: string | null;
			postalCode?: string | null;
			countryCode?: string | null;
			googlePlaceId?: string | null;
			latitude?: number | null;
			longitude?: number | null;
		} | null;
		items: Array<{
			__typename?: 'OrderQuoteItem';
			id: string;
			productId: string;
			productSpecificationsAt?: string | null;
			productName?: string | null;
			productSku?: string | null;
			productDescription?: string | null;
			productWeight?: number | null;
			deadline?: string | null;
			sortOrder: number;
			productSpecifications?: {
				__typename?: 'OrderProductSpecifications';
				material?: string | null;
				secondaryMaterials?: Array<string> | null;
				finish?: string | null;
				textureDescription?: string | null;
				features?: Array<string> | null;
				capacity?: {
					__typename?: 'OrderProductMeasure';
					value: number;
					unit: string;
				} | null;
				colors?: Array<{
					__typename?: 'OrderProductColorSpec';
					name?: string | null;
					code?: string | null;
					pantone?: string | null;
					appliesTo?: string | null;
					finish?: string | null;
					isPrimary?: boolean | null;
				}> | null;
				packaging?: {
					__typename?: 'OrderProductPackaging';
					type?: string | null;
					weight?: number | null;
					weightUnit?: string | null;
					notes?: string | null;
					dimensions?: {
						__typename?: 'OrderProductDimensions';
						length?: number | null;
						width?: number | null;
						height?: number | null;
						unit: string;
					} | null;
				} | null;
				decorations?: Array<{
					__typename?: 'OrderProductDecoration';
					id: string;
					method: OrderProductDecorationMethod;
					methodNote?: string | null;
					placement?: string | null;
					colorCount?: number | null;
					artworkUrl?: string | null;
					notes?: string | null;
					sortOrder?: number | null;
					area?: {
						__typename?: 'OrderProductPrintArea';
						width?: number | null;
						height?: number | null;
						unit: string;
					} | null;
					colors?: Array<{
						__typename?: 'OrderProductColorSpec';
						name?: string | null;
						code?: string | null;
						pantone?: string | null;
						appliesTo?: string | null;
						finish?: string | null;
						isPrimary?: boolean | null;
					}> | null;
				}> | null;
				custom?: Array<{
					__typename?: 'OrderProductCustomSpec';
					id: string;
					label: string;
					value: string;
					unit?: string | null;
					group?: string | null;
					sortOrder?: number | null;
				}> | null;
			} | null;
			productDimensions?: {
				__typename?: 'OrderProductDimensions';
				length?: number | null;
				width?: number | null;
				height?: number | null;
				unit: string;
			} | null;
			productImages?: Array<{
				__typename?: 'OrderQuoteItemProductImage';
				url: string;
				isPrimary?: boolean | null;
				sortOrder?: number | null;
				altText?: string | null;
				caption?: string | null;
				dimensions?: {
					__typename?: 'OrderProductImageDimensions';
					width?: number | null;
					height?: number | null;
					aspectRatio?: string | null;
				} | null;
				crop?: {
					__typename?: 'OrderProductImageCrop';
					x: number;
					y: number;
					width: number;
					height: number;
					zoom?: number | null;
					rotation?: number | null;
					aspectRatio?: string | null;
					unit?: string | null;
				} | null;
			}> | null;
			timelineStatus: {
				__typename?: 'TimelineStatus';
				level: TimelineStatusLevel;
				businessDaysLeft?: number | null;
				isExpired: boolean;
			};
			quantities: Array<{
				__typename?: 'OrderQuoteItemQuantity';
				id: string;
				quantity: number;
				sortOrder: number;
			}>;
		}>;
	} | null;
};

export type GetClientAllOrderQuoteQueryVariables = Exact<{
	input: ClientGetAllOrderQuoteInput;
}>;

export type GetClientAllOrderQuoteQuery = {
	__typename?: 'Query';
	getClientAllOrderQuote: {
		__typename?: 'ClientOrderQuotePage';
		data: Array<{
			__typename?: 'ClientOrderQuote';
			id: string;
			name: string;
			description?: string | null;
			deadline?: string | null;
			status: OrderQuoteStatus;
			purpose?: OrderQuotePurpose | null;
			createdAt?: string | null;
			updatedAt?: string | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalCount: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetClientOrderQuoteOfferBatchesQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type GetClientOrderQuoteOfferBatchesQuery = {
	__typename?: 'Query';
	getClientOrderQuoteOfferBatches: Array<{
		__typename?: 'ClientOrderQuoteOfferBatch';
		id: string;
		name: string;
		status: OrderQuoteOfferStatus;
		acceptDeadline?: string | null;
		sentToClientAt?: string | null;
		respondedAt?: string | null;
		rejectionReason?: string | null;
		orderQuoteId: string;
		createdAt?: string | null;
		updatedAt?: string | null;
		savedSelection?: {
			__typename?: 'OfferBatchSavedSelection';
			fromDownloadedQuote: boolean;
			updatedAt?: string | null;
			selections: Array<{
				__typename?: 'OfferBatchSelectionItem';
				offerId: string;
				pricingId: string;
				quantity: number;
				deliveryId?: string | null;
				sampleChoice?: OrderSampleChoice | null;
			}>;
		} | null;
		summary?: {
			__typename?: 'OrderQuoteOfferBatchSummary';
			productsSubtotal: number;
			samplesTotal: number;
			samplesShippingTotal: number;
			deliveryTotal: number;
			feesTotal: number;
			discountsTotal: number;
			grandTotal: number;
			vatRate: number;
			vatAmount: number;
			grossAmount: number;
			fees: Array<{ __typename?: 'OrderSummaryLineItem'; name: string; amount: number }>;
			discounts: Array<{ __typename?: 'OrderSummaryLineItem'; name: string; amount: number }>;
		} | null;
		offers: Array<{
			__typename?: 'ClientOrderQuoteOffer';
			id: string;
			name: string;
			description?: string | null;
			status: OrderQuoteOfferStatus;
			respondedAt?: string | null;
			rejectionReason?: string | null;
			orderQuoteItemId: string;
			sortOrder?: number | null;
			acceptedPricingId?: string | null;
			acceptedDeliveryId?: string | null;
			sample?: {
				__typename?: 'ClientOrderQuoteOfferSample';
				id: string;
				status: OrderSampleStatus;
				totalPrice?: number | null;
				minProductionDays?: number | null;
				maxProductionDays?: number | null;
				deliveryDaysMin?: number | null;
				deliveryDaysMax?: number | null;
				notes?: string | null;
				paymentTreatment: SamplePaymentTreatment;
				pricesByChoice: Array<{
					__typename?: 'ClientOrderQuoteOfferSamplePrice';
					sampleChoice: OrderSampleChoice;
					totalPrice: number;
				}>;
			} | null;
			attachments: Array<{
				__typename?: 'OrderQuoteItemAttachment';
				id: string;
				name: string;
				description?: string | null;
				mimeType: string;
				size: number;
				url: string;
			}>;
			adjustments: Array<{
				__typename?: 'ClientOrderQuoteOfferAdjustment';
				id: string;
				name: string;
				description?: string | null;
				type: OrderAdjustmentType;
				calculationType: OrderAdjustmentCalculationType;
				value: number;
			}>;
			pricing: Array<{
				__typename?: 'ClientOrderQuoteOfferPricing';
				id: string;
				orderQuoteItemQuantityId: string;
				unitPrice?: number | null;
				totalPrice?: number | null;
				adjustedTotalPrice?: number | null;
				minProductionDays?: number | null;
				maxProductionDays?: number | null;
				deliveries: Array<{
					__typename?: 'ClientOrderQuoteOfferDelivery';
					id: string;
					shippingMethod: OrderShippingMethod;
					totalPrice?: number | null;
					quantity: number;
					deliveryDaysMin: number;
					deliveryDaysMax: number;
					isSplit: boolean;
					parts: Array<{
						__typename?: 'ClientOrderQuoteOfferDeliveryPart';
						id: string;
						sequence: number;
						shippingMethod: OrderShippingMethod;
						quantity: number;
						totalPrice?: number | null;
						deliveryDaysMin: number;
						deliveryDaysMax: number;
						projectedDelivery?: {
							__typename?: 'ProjectedDeliveryWindow';
							ifAcceptedNow: {
								__typename?: 'ProjectedDateRange';
								earliest: string;
								latest: string;
								verdict: OfferFeasibilityVerdict;
							};
							ifAcceptedAtDeadline: {
								__typename?: 'ProjectedDateRange';
								earliest: string;
								latest: string;
								verdict: OfferFeasibilityVerdict;
							};
						} | null;
					}>;
					projectedDelivery?: {
						__typename?: 'ProjectedDeliveryWindow';
						ifAcceptedNow: {
							__typename?: 'ProjectedDateRange';
							earliest: string;
							latest: string;
							verdict: OfferFeasibilityVerdict;
						};
						ifAcceptedAtDeadline: {
							__typename?: 'ProjectedDateRange';
							earliest: string;
							latest: string;
							verdict: OfferFeasibilityVerdict;
						};
					} | null;
				}>;
			}>;
		}>;
	}>;
};

export type GetClientOrderQuoteOfferBatchSummaryQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
	inCurrency?: InputMaybe<CurrencyEnum>;
	selectedPricingIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
	selectedDeliveryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
	includedOfferIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
	selectedSampleChoices?: InputMaybe<Array<OfferSampleChoiceInput> | OfferSampleChoiceInput>;
}>;

export type GetClientOrderQuoteOfferBatchSummaryQuery = {
	__typename?: 'Query';
	getClientOrderQuoteOfferBatches: Array<{
		__typename?: 'ClientOrderQuoteOfferBatch';
		id: string;
		summary?: {
			__typename?: 'OrderQuoteOfferBatchSummary';
			productsSubtotal: number;
			samplesTotal: number;
			samplesShippingTotal: number;
			samplesPrepaidTotal: number;
			deliveryTotal: number;
			feesTotal: number;
			discountsTotal: number;
			grandTotal: number;
			vatRate: number;
			vatAmount: number;
			grossAmount: number;
			fees: Array<{ __typename?: 'OrderSummaryLineItem'; name: string; amount: number }>;
			discounts: Array<{ __typename?: 'OrderSummaryLineItem'; name: string; amount: number }>;
		} | null;
	}>;
};

export type PreviewAcceptOffersQueryVariables = Exact<{
	input: PreviewAcceptOffersInput;
}>;

export type PreviewAcceptOffersQuery = {
	__typename?: 'Query';
	previewAcceptOffers: {
		__typename?: 'AcceptOffersPreview';
		currency: CurrencyEnum;
		payNow: {
			__typename?: 'AcceptOffersPreviewSection';
			netAmount: number;
			vatRate: number;
			vatAmount: number;
			grossAmount: number;
		};
		payLater: {
			__typename?: 'AcceptOffersPreviewSection';
			netAmount: number;
			vatRate: number;
			vatAmount: number;
			grossAmount: number;
		};
		total: {
			__typename?: 'AcceptOffersPreviewSection';
			netAmount: number;
			vatRate: number;
			vatAmount: number;
			grossAmount: number;
		};
	};
};

export type GetClientOrderQuoteSummaryQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetClientOrderQuoteSummaryQuery = {
	__typename?: 'Query';
	getClientOrderQuote?: {
		__typename?: 'ClientOrderQuote';
		id: string;
		name: string;
		status: OrderQuoteStatus;
		createdAt?: string | null;
	} | null;
};

export type ListEarlyAccessRequestsQueryVariables = Exact<{
	status?: InputMaybe<EarlyAccessStatusEnum>;
}>;

export type ListEarlyAccessRequestsQuery = {
	__typename?: 'Query';
	listEarlyAccessRequests: Array<{
		__typename?: 'EarlyAccessRequest';
		id: string;
		firstName: string;
		lastName: string;
		email: string;
		companyName?: string | null;
		status: EarlyAccessStatusEnum;
		createdAt: string;
		approvedAt?: string | null;
		usedAt?: string | null;
	}>;
};

export type GetEarlyAccessByTokenQueryVariables = Exact<{
	inviteToken: Scalars['String']['input'];
}>;

export type GetEarlyAccessByTokenQuery = {
	__typename?: 'Query';
	getEarlyAccessByToken?: {
		__typename?: 'EarlyAccessInvite';
		firstName: string;
		lastName: string;
		email: string;
		companyName?: string | null;
	} | null;
};

export type GetEmailTemplatePreviewQueryVariables = Exact<{
	key: Scalars['String']['input'];
}>;

export type GetEmailTemplatePreviewQuery = {
	__typename?: 'Query';
	getEmailTemplatePreview: {
		__typename?: 'EmailTemplatePreview';
		key: string;
		description: string;
		fromName: string;
		fromEmail: string;
		subject: string;
		preheader?: string | null;
		html: string;
		text: string;
	};
};

export type GetAllLocalizationTimezonesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllLocalizationTimezonesQuery = {
	__typename?: 'Query';
	getAllLocalizationTimezones?: Array<{
		__typename?: 'LocalizationTimezone';
		name: string;
		offset: string;
	}> | null;
};

export type GetAllLocalizationCountriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllLocalizationCountriesQuery = {
	__typename?: 'Query';
	getAllLocalizationCountries: Array<{
		__typename?: 'LocalizationCountry';
		code: string;
		name: string;
		currency?: string | null;
		defaultTimezone?: string | null;
		defaultMeasurementSystem?: MeasurementSystemEnum | null;
		hasStates: boolean;
		isEU: boolean;
		phonePrefix?: string | null;
		nativeName?: string | null;
		registrations: Array<{
			__typename?: 'LocalizationBusinessRegistrationType';
			code: string;
			label: string;
			placeholder?: string | null;
			helpText?: string | null;
			isRequired: boolean;
			vatDerivationPattern?: string | null;
		}>;
		addressFormat: {
			__typename?: 'LocalizationAddressFormat';
			postalCodeLabel: string;
			stateLabel?: string | null;
			stateRequired: boolean;
		};
	}>;
};

export type GetLocalizationStatesQueryVariables = Exact<{
	countryCode: Scalars['String']['input'];
}>;

export type GetLocalizationStatesQuery = {
	__typename?: 'Query';
	getLocalizationStates: Array<{ __typename?: 'LocalizationState'; code: string; name: string }>;
};

export type AddressAutocompleteQueryVariables = Exact<{
	input: Scalars['String']['input'];
	countryCode?: InputMaybe<Scalars['String']['input']>;
	sessionToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type AddressAutocompleteQuery = {
	__typename?: 'Query';
	addressAutocomplete: Array<{
		__typename?: 'PlaceAutocompleteResult';
		placeId: string;
		description: string;
		mainText: string;
		secondaryText: string;
	}>;
};

export type GetPlaceDetailsQueryVariables = Exact<{
	placeId: Scalars['String']['input'];
	sessionToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetPlaceDetailsQuery = {
	__typename?: 'Query';
	getPlaceDetails?: {
		__typename?: 'PlaceDetails';
		placeId: string;
		formattedAddress: string;
		streetNumber?: string | null;
		streetName?: string | null;
		city?: string | null;
		state?: string | null;
		stateCode?: string | null;
		postalCode?: string | null;
		country?: string | null;
		countryCode?: string | null;
		latitude?: number | null;
		longitude?: number | null;
		timezone?: string | null;
	} | null;
};

export type ValidateCvrQueryVariables = Exact<{
	cvrNumber: Scalars['String']['input'];
}>;

export type ValidateCvrQuery = {
	__typename?: 'Query';
	validateCVR: {
		__typename?: 'CVRValidationResult';
		valid: boolean;
		error?: string | null;
		companyInfo?: {
			__typename?: 'CVRCompanyInfo';
			name: string;
			vat: string;
			active: boolean;
			startDate?: string | null;
			industryCode?: number | null;
			industryDescription?: string | null;
			employees?: string | null;
			phone?: string | null;
			email?: string | null;
			address: {
				__typename?: 'CVRAddress';
				street: string;
				zipcode: string;
				city: string;
				country: string;
			};
		} | null;
	};
};

export type GenerateVatFromRegistrationQueryVariables = Exact<{
	countryCode: Scalars['String']['input'];
	registrationNumber: Scalars['String']['input'];
	registrationType: Scalars['String']['input'];
}>;

export type GenerateVatFromRegistrationQuery = {
	__typename?: 'Query';
	generateVATFromRegistration?: string | null;
};

export type GetAllManufacturersQueryVariables = Exact<{
	input: GetAllManufacturerInput;
}>;

export type GetAllManufacturersQuery = {
	__typename?: 'Query';
	getAllManufacturer: {
		__typename?: 'ManufacturerPage';
		data: Array<{
			__typename?: 'Manufacturer';
			id: string;
			name: string;
			country?: string | null;
			description?: string | null;
			website?: string | null;
			logoUrl?: string | null;
			isActive: boolean;
			createdAt?: string | null;
			updatedAt?: string | null;
			vetterEntity?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalPages: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetManufacturerStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetManufacturerStatsQuery = {
	__typename?: 'Query';
	getManufacturerStats: {
		__typename?: 'ManufacturerStats';
		total: number;
		active: number;
		inactive: number;
		withVetter: number;
	};
};

export type GetManufacturerQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetManufacturerQuery = {
	__typename?: 'Query';
	getManufacturer: {
		__typename?: 'Manufacturer';
		id: string;
		name: string;
		country?: string | null;
		description?: string | null;
		website?: string | null;
		logoUrl?: string | null;
		isActive: boolean;
		createdAt?: string | null;
		updatedAt?: string | null;
		vetterEntity?: {
			__typename?: 'VetterEntity';
			id: string;
			name: string;
			description?: string | null;
			isActive: boolean;
			primaryContact?: {
				__typename?: 'VetterUser';
				id: string;
				firstName: string;
				lastName: string;
				phone?: string | null;
				authenticationUser?: {
					__typename?: 'AuthenticationUser';
					id: string;
					email?: string | null;
				} | null;
			} | null;
		} | null;
	};
};

export type GetOfferBatchLocationQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetOfferBatchLocationQuery = {
	__typename?: 'Query';
	getOfferBatchLocation?: {
		__typename?: 'OfferBatchLocation';
		offerBatchId: string;
		orderQuoteId: string;
	} | null;
};

export type GetSampleLocationQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetSampleLocationQuery = {
	__typename?: 'Query';
	getSampleLocation?: {
		__typename?: 'SampleLocation';
		sampleId: string;
		orderItemId: string;
		orderId: string;
	} | null;
};

export type GetNotificationSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetNotificationSettingsQuery = {
	__typename?: 'Query';
	getNotificationSettings: Array<{
		__typename?: 'NotificationSetting';
		type: NotificationType;
		label: string;
		description: string;
		category: NotificationCategory;
		audience: NotificationAudience;
		templateKey: string;
		emailEnabled: boolean;
		bellEnabled: boolean;
		alwaysOn: boolean;
	}>;
};

export type GetMyNotificationsQueryVariables = Exact<{
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetMyNotificationsQuery = {
	__typename?: 'Query';
	getMyNotifications: {
		__typename?: 'NotificationList';
		total: number;
		unreadCount: number;
		items: Array<{
			__typename?: 'Notification';
			id: string;
			type: NotificationType;
			title: string;
			body?: string | null;
			entityType?: string | null;
			entityId?: string | null;
			readAt?: string | null;
			emailSent: boolean;
			createdAt: string;
		}>;
	};
};

export type GetMyUnreadNotificationCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyUnreadNotificationCountQuery = {
	__typename?: 'Query';
	getMyUnreadNotificationCount: number;
};

export type GetOrderQueryVariables = Exact<{
	id: Scalars['ID']['input'];
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type GetOrderQuery = {
	__typename?: 'Query';
	getOrder?: {
		__typename?: 'Order';
		id: string;
		name: string;
		orderNumber: string;
		status: OrderStatus;
		orderQuoteId: string;
		organizationId?: string | null;
		deliveryAddressLockedReason?: string | null;
		deliveryAddressChangedAt?: string | null;
		productPaymentMode: PaymentModeEnum;
		samplePaymentMode: PaymentModeEnum;
		stripeCheckoutLimit?: number | null;
		invoiceMinimum?: number | null;
		baseTotalAmount?: number | null;
		totalAmount?: number | null;
		marginTotal?: number | null;
		totalQuantity?: number | null;
		itemsAwaitingConfirmation?: number | null;
		setupStage?: OrderSetupStage | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		deliveryAddress?: {
			__typename?: 'OrderQuoteAddress';
			addressLine1?: string | null;
			addressLine2?: string | null;
			city?: string | null;
			stateCode?: string | null;
			postalCode?: string | null;
			countryCode?: string | null;
		} | null;
		availableActions?: Array<{
			__typename?: 'OrderNextAction';
			action: OrderAction;
			actor: SampleActionActor;
			kind: ActionKind;
			label: string;
			displayType: ActionDisplayType;
			blocked?: boolean | null;
			blockedReason?: string | null;
			warningReason?: string | null;
			itemCount?: number | null;
			paymentTransactionId?: string | null;
			amount?: number | null;
			currency?: CurrencyEnum | null;
		}> | null;
		availablePaymentMethods?: Array<{
			__typename?: 'OrderPaymentMethodOption';
			method: OrderPaymentMethod;
			available: boolean;
			reason?: string | null;
		}> | null;
		availableSamplePaymentMethods?: Array<{
			__typename?: 'OrderPaymentMethodOption';
			method: OrderPaymentMethod;
			available: boolean;
			reason?: string | null;
		}> | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			countryCode?: string | null;
			createdAt?: string | null;
			addresses?: Array<{
				__typename?: 'OrganizationAddress';
				id: string;
				city: string;
				countryCode: string;
				isPrimary: boolean;
			}> | null;
		} | null;
		orderQuote?: {
			__typename?: 'OrderQuote';
			id: string;
			name: string;
			description?: string | null;
			purpose?: OrderQuotePurpose | null;
			purposeOther?: string | null;
			deadline?: string | null;
			adminUserIds?: Array<string> | null;
			clientContactUserIds: Array<string>;
			adminUsers?: Array<{
				__typename?: 'AdminUser';
				id: string;
				firstName: string;
				lastName: string;
			}> | null;
		} | null;
		items: Array<{
			__typename?: 'OrderItem';
			orderQuoteOfferId: string;
			id: string;
			productId?: string | null;
			productName?: string | null;
			productDescription?: string | null;
			productSku?: string | null;
			productWeight?: number | null;
			productSpecificationsAt?: string | null;
			quantity: number;
			sortOrder: number;
			status: OrderItemStatus;
			sampleChoice?: OrderSampleChoice | null;
			shippedQuantity?: number | null;
			deliveredQuantity?: number | null;
			baseUnitPrice?: number | null;
			unitPrice?: number | null;
			baseTotalPrice?: number | null;
			totalPrice?: number | null;
			adjustedTotalPrice?: number | null;
			lineTotal?: number | null;
			marginAmount?: number | null;
			confirmedAt?: string | null;
			vetterEntityId?: string | null;
			confirmedVetterEntityId?: string | null;
			minProductionDays?: number | null;
			maxProductionDays?: number | null;
			paidAt?: string | null;
			productionStartedAt?: string | null;
			productionCompletedAt?: string | null;
			shippedAt?: string | null;
			carrier?: string | null;
			trackingNumber?: string | null;
			estimatedDeliveryDate?: string | null;
			actualDeliveryDate?: string | null;
			waitingOn?: SampleActionActor | null;
			createdAt?: string | null;
			productImages?: Array<{
				__typename?: 'OrderItemProductImage';
				url: string;
				isPrimary?: boolean | null;
				sortOrder?: number | null;
				altText?: string | null;
				caption?: string | null;
				dimensions?: {
					__typename?: 'OrderProductImageDimensions';
					width?: number | null;
					height?: number | null;
					aspectRatio?: string | null;
				} | null;
				crop?: {
					__typename?: 'OrderProductImageCrop';
					x: number;
					y: number;
					width: number;
					height: number;
					zoom?: number | null;
					rotation?: number | null;
					aspectRatio?: string | null;
					unit?: string | null;
				} | null;
			}> | null;
			productDimensions?: {
				__typename?: 'OrderProductDimensions';
				length?: number | null;
				width?: number | null;
				height?: number | null;
				unit: string;
			} | null;
			productSpecifications?: {
				__typename?: 'OrderProductSpecifications';
				material?: string | null;
				secondaryMaterials?: Array<string> | null;
				finish?: string | null;
				textureDescription?: string | null;
				features?: Array<string> | null;
				capacity?: {
					__typename?: 'OrderProductMeasure';
					value: number;
					unit: string;
				} | null;
				colors?: Array<{
					__typename?: 'OrderProductColorSpec';
					name?: string | null;
					code?: string | null;
					pantone?: string | null;
					appliesTo?: string | null;
					finish?: string | null;
					isPrimary?: boolean | null;
				}> | null;
				packaging?: {
					__typename?: 'OrderProductPackaging';
					type?: string | null;
					weight?: number | null;
					weightUnit?: string | null;
					notes?: string | null;
					dimensions?: {
						__typename?: 'OrderProductDimensions';
						length?: number | null;
						width?: number | null;
						height?: number | null;
						unit: string;
					} | null;
				} | null;
				decorations?: Array<{
					__typename?: 'OrderProductDecoration';
					id: string;
					method: OrderProductDecorationMethod;
					methodNote?: string | null;
					placement?: string | null;
					colorCount?: number | null;
					artworkUrl?: string | null;
					notes?: string | null;
					sortOrder?: number | null;
					area?: {
						__typename?: 'OrderProductPrintArea';
						width?: number | null;
						height?: number | null;
						unit: string;
					} | null;
					colors?: Array<{
						__typename?: 'OrderProductColorSpec';
						name?: string | null;
						code?: string | null;
						pantone?: string | null;
						appliesTo?: string | null;
						finish?: string | null;
						isPrimary?: boolean | null;
					}> | null;
				}> | null;
				custom?: Array<{
					__typename?: 'OrderProductCustomSpec';
					id: string;
					label: string;
					value: string;
					unit?: string | null;
					group?: string | null;
					sortOrder?: number | null;
				}> | null;
			} | null;
			attachments?: Array<{
				__typename?: 'OrderItemAttachment';
				id: string;
				name: string;
				description?: string | null;
				mimeType: string;
				size: number;
				url: string;
			}> | null;
			lifecycle?: Array<{
				__typename?: 'OrderItemLifecycleStep';
				step: OrderItemLifecycleStepEnum;
				label: string;
				completed: boolean;
				current: boolean;
				actor?: SampleActionActor | null;
				skipped: boolean;
				skippedReason?: string | null;
				outstanding: boolean;
				outstandingReason?: string | null;
			}> | null;
			shipments?: Array<{
				__typename?: 'OrderItemShipment';
				quantity: number;
				shipment: {
					__typename?: 'OrderShipment';
					id: string;
					sequence: number;
					status: OrderShipmentStatus;
					shippingMethod?: OrderShippingMethod | null;
					carrier?: string | null;
					trackingNumber?: string | null;
					trackingUrl?: string | null;
					shippedAt?: string | null;
					estimatedDeliveryDate?: string | null;
					actualDeliveryDate?: string | null;
					availableActions?: Array<{
						__typename?: 'OrderShipmentNextAction';
						key: string;
						actor: SampleActionActor;
						kind: ActionKind;
						status?: OrderShipmentStatus | null;
						label: string;
						requiredFields: Array<string>;
						optionalFields: Array<string>;
						blocked?: boolean | null;
						blockedReason?: string | null;
					}> | null;
				};
			}> | null;
			availableActions?: Array<{
				__typename?: 'OrderItemNextAction';
				action: OrderItemActionType;
				actor: SampleActionActor;
				kind: ActionKind;
				label: string;
				status?: OrderItemStatus | null;
				displayType: ActionDisplayType;
				blocked?: boolean | null;
				blockedReason?: string | null;
				warningReason?: string | null;
				requiredFields: Array<string>;
				optionalFields: Array<string>;
			}> | null;
			delivery?: {
				__typename?: 'OrderItemDelivery';
				id: string;
				shippingMethod: OrderShippingMethod;
				shippingMethodLabel?: string | null;
				quantity: number;
				deliveryDaysMin: number;
				deliveryDaysMax: number;
				totalPrice?: number | null;
			} | null;
			samples?: Array<{
				__typename?: 'OrderItemSample';
				id: string;
				sampleChoice: OrderSampleChoice;
				sampleRound: number;
				status: OrderSampleStatus;
				totalPrice?: number | null;
				paymentTreatment: SamplePaymentTreatment;
				paidAt?: string | null;
				baseSamplePrice?: number | null;
				baseShippingPrice?: number | null;
				minProductionDays?: number | null;
				maxProductionDays?: number | null;
				deliveryDaysMin?: number | null;
				deliveryDaysMax?: number | null;
				approvedAt?: string | null;
				approvedBy?: string | null;
				notes?: string | null;
				approvalNotes?: string | null;
				rejectedAt?: string | null;
				rejectedBy?: string | null;
				rejectionReason?: string | null;
				requestNewSample?: boolean | null;
				productionStartedAt?: string | null;
				productionCompletedAt?: string | null;
				shippedAt?: string | null;
				carrier?: string | null;
				trackingNumber?: string | null;
				trackingUrl?: string | null;
				estimatedDeliveryDate?: string | null;
				actualDeliveryDate?: string | null;
				virtualDeliverySubmittedAt?: string | null;
				virtualDeliveryNotes?: string | null;
				previousSampleId?: string | null;
				orderItemId: string;
				lifecycle?: Array<{
					__typename?: 'OrderSampleLifecycleStep';
					step: OrderSampleLifecycleStepEnum;
					label: string;
					completed: boolean;
					current: boolean;
					actor?: SampleActionActor | null;
					outstanding: boolean;
					outstandingReason?: string | null;
				}> | null;
				attachments?: Array<{
					__typename?: 'OrderItemSampleAttachment';
					id: string;
					name: string;
					mimeType: string;
					size: number;
					url: string;
					type: OrderSampleAttachmentType;
				}> | null;
				availableActions?: Array<{
					__typename?: 'SampleNextAction';
					action: SampleActionType;
					actor: SampleActionActor;
					kind: ActionKind;
					label: string;
					status?: OrderSampleStatus | null;
					blocked?: boolean | null;
					blockedReason?: string | null;
					warningReason?: string | null;
					requiredFields: Array<string>;
					optionalFields: Array<string>;
					requiresAttachments?: OrderSampleAttachmentType | null;
					supportsAttachments?: OrderSampleAttachmentType | null;
					hasAttachments?: boolean | null;
				}> | null;
			}> | null;
			adjustments?: Array<{
				__typename?: 'OrderQuoteOfferAdjustment';
				id: string;
				name: string;
				description?: string | null;
				type: OrderAdjustmentType;
				calculationType: OrderAdjustmentCalculationType;
				value: number;
			}> | null;
		}>;
		summary?: {
			__typename?: 'OrderSummary';
			productsSubtotal: number;
			samplesTotal: number;
			samplesShippingTotal: number;
			samplesPrepaidTotal: number;
			deliveryTotal: number;
			feesTotal: number;
			discountsTotal: number;
			sampleCreditAtRisk: number;
			sampleCreditUncredited: number;
			marginTotal?: number | null;
			marginPercentage?: number | null;
			grandTotal: number;
			vatRate: number;
			vatAmount: number;
			grossAmount: number;
			fees: Array<{ __typename?: 'OrderSummaryLineItem'; name: string; amount: number }>;
			discounts: Array<{ __typename?: 'OrderSummaryLineItem'; name: string; amount: number }>;
		} | null;
		paymentSummary?: {
			__typename?: 'OrderPaymentSummary';
			productStatus: OrderPaymentStatus;
			productTotalAmount: number;
			productPaidAmount: number;
			productOutstandingAmount: number;
			sampleStatus: OrderPaymentStatus;
			sampleTotalAmount: number;
			samplePaidAmount: number;
			sampleOutstandingAmount: number;
			totalAmount: number;
			totalPaidAmount: number;
			totalOutstandingAmount: number;
			vatRate: number;
		} | null;
		deliveries?: Array<{
			__typename?: 'OrderDelivery';
			id: string;
			kind: OrderDeliveryKind;
			isPhysical: boolean;
			reference: string;
			state: OrderDeliveryState;
			stateLabel: string;
			carrier?: string | null;
			trackingNumber?: string | null;
			trackingUrl?: string | null;
			shippingMethodLabel?: string | null;
			projected: boolean;
			expectedEarliest?: string | null;
			expectedLatest?: string | null;
			shippedAt?: string | null;
			actualDeliveryDate?: string | null;
			lines: Array<{
				__typename?: 'OrderDeliveryLine';
				orderItemId: string;
				productName?: string | null;
				quantity: number;
			}>;
		}> | null;
		shipments: Array<{
			__typename?: 'OrderShipment';
			id: string;
			sequence: number;
			shippingMethod?: OrderShippingMethod | null;
			status: OrderShipmentStatus;
			deliveryDaysMin: number;
			deliveryDaysMax: number;
			carrier?: string | null;
			trackingNumber?: string | null;
			trackingUrl?: string | null;
			shippedAt?: string | null;
			estimatedDeliveryDate?: string | null;
			actualDeliveryDate?: string | null;
			splitOfOrderShipmentId?: string | null;
			totalPrice?: number | null;
			lifecycle?: Array<{
				__typename?: 'OrderItemLifecycleStep';
				step: OrderItemLifecycleStepEnum;
				label: string;
				completed: boolean;
				current: boolean;
				actor?: SampleActionActor | null;
				skipped: boolean;
				outstanding: boolean;
				outstandingReason?: string | null;
			}> | null;
			availableActions?: Array<{
				__typename?: 'OrderShipmentNextAction';
				key: string;
				actor: SampleActionActor;
				kind: ActionKind;
				status?: OrderShipmentStatus | null;
				label: string;
				requiredFields: Array<string>;
				optionalFields: Array<string>;
				blocked?: boolean | null;
				blockedReason?: string | null;
			}> | null;
			lines: Array<{
				__typename?: 'OrderShipmentLine';
				id: string;
				orderItemId: string;
				quantity: number;
			}>;
		}>;
	} | null;
};

export type GetOrderActivitiesQueryVariables = Exact<{
	orderId: Scalars['ID']['input'];
	inCurrency?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetOrderActivitiesQuery = {
	__typename?: 'Query';
	getOrderActivities: Array<{
		__typename?: 'OrderActivity';
		id: string;
		action: string;
		message?: string | null;
		actorId?: string | null;
		actorRole?: string | null;
		metadata?: any | null;
		orderId: string;
		createdAt?: string | null;
		adminUser?: { __typename?: 'AdminUserStub'; firstName: string; lastName: string } | null;
		organizationUser?: {
			__typename?: 'OrganizationUserStub';
			firstName: string;
			lastName: string;
		} | null;
	}>;
};

export type GetAllOrdersQueryVariables = Exact<{
	input: GetAllOrdersInput;
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type GetAllOrdersQuery = {
	__typename?: 'Query';
	getAllOrders: {
		__typename?: 'OrderPage';
		data: Array<{
			__typename?: 'Order';
			id: string;
			name: string;
			orderNumber: string;
			status: OrderStatus;
			organizationId?: string | null;
			orderQuoteId: string;
			baseTotalAmount?: number | null;
			totalAmount?: number | null;
			marginTotal?: number | null;
			createdAt?: string | null;
			updatedAt?: string | null;
			organization?: { __typename?: 'Organization'; id: string; name: string } | null;
			summary?: {
				__typename?: 'OrderSummary';
				grandTotal: number;
				grossAmount: number;
			} | null;
			paymentSummary?: {
				__typename?: 'OrderPaymentSummary';
				totalAmount: number;
				totalPaidAmount: number;
				totalOutstandingAmount: number;
			} | null;
			items: Array<{
				__typename?: 'OrderItem';
				id: string;
				quantity: number;
				productName?: string | null;
				status: OrderItemStatus;
				productImages?: Array<{
					__typename?: 'OrderItemProductImage';
					url: string;
					isPrimary?: boolean | null;
					sortOrder?: number | null;
					altText?: string | null;
					caption?: string | null;
					dimensions?: {
						__typename?: 'OrderProductImageDimensions';
						width?: number | null;
						height?: number | null;
						aspectRatio?: string | null;
					} | null;
					crop?: {
						__typename?: 'OrderProductImageCrop';
						x: number;
						y: number;
						width: number;
						height: number;
						zoom?: number | null;
						rotation?: number | null;
						aspectRatio?: string | null;
						unit?: string | null;
					} | null;
				}> | null;
			}>;
			shipping?: {
				__typename?: 'OrderShipping';
				state: OrderShippingState;
				total: number;
				shipped: number;
				overdue: number;
			} | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetOrderQuoteQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetOrderQuoteQuery = {
	__typename?: 'Query';
	getOrderQuote?: {
		__typename?: 'OrderQuote';
		id: string;
		name: string;
		description?: string | null;
		deadline?: string | null;
		status: OrderQuoteStatus;
		organizationId?: string | null;
		purpose?: OrderQuotePurpose | null;
		purposeOther?: string | null;
		pendingAcceptance?: any | null;
		supersededAcceptances?: any | null;
		adminUserIds?: Array<string> | null;
		vetterEntityIds?: Array<string> | null;
		offerBatchCount: number;
		lastClientViewedAt?: string | null;
		firstClientViewedAt?: string | null;
		clientViewCount: number;
		productPaymentMode?: PaymentModeEnum | null;
		samplePaymentMode?: PaymentModeEnum | null;
		stripeCheckoutLimit?: number | null;
		invoiceMinimum?: number | null;
		paymentSettingsSnapshotAt?: string | null;
		clientContactUserIds: Array<string>;
		createdAt?: string | null;
		updatedAt?: string | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			logo?: string | null;
		} | null;
		adminUsers?: Array<{
			__typename?: 'AdminUser';
			id: string;
			firstName: string;
			lastName: string;
		}> | null;
		vetterEntities?: Array<{ __typename?: 'VetterEntity'; id: string; name: string }> | null;
		deliveryAddress?: {
			__typename?: 'OrderQuoteAddress';
			addressLine1?: string | null;
			addressLine2?: string | null;
			city?: string | null;
			stateCode?: string | null;
			postalCode?: string | null;
			countryCode?: string | null;
		} | null;
		lifecycle?: Array<{
			__typename?: 'OrderQuoteLifecycleStep';
			step: OrderQuoteLifecycleStepEnum;
			label: string;
			completed: boolean;
			current: boolean;
		}> | null;
		items: Array<{
			__typename?: 'OrderQuoteItem';
			id: string;
			productId: string;
			productSpecificationsAt?: string | null;
			productName?: string | null;
			productSku?: string | null;
			productDescription?: string | null;
			productWeight?: number | null;
			deadline?: string | null;
			sortOrder: number;
			productSpecifications?: {
				__typename?: 'OrderProductSpecifications';
				material?: string | null;
				secondaryMaterials?: Array<string> | null;
				finish?: string | null;
				textureDescription?: string | null;
				features?: Array<string> | null;
				capacity?: {
					__typename?: 'OrderProductMeasure';
					value: number;
					unit: string;
				} | null;
				colors?: Array<{
					__typename?: 'OrderProductColorSpec';
					name?: string | null;
					code?: string | null;
					pantone?: string | null;
					appliesTo?: string | null;
					finish?: string | null;
					isPrimary?: boolean | null;
				}> | null;
				packaging?: {
					__typename?: 'OrderProductPackaging';
					type?: string | null;
					weight?: number | null;
					weightUnit?: string | null;
					notes?: string | null;
					dimensions?: {
						__typename?: 'OrderProductDimensions';
						length?: number | null;
						width?: number | null;
						height?: number | null;
						unit: string;
					} | null;
				} | null;
				decorations?: Array<{
					__typename?: 'OrderProductDecoration';
					id: string;
					method: OrderProductDecorationMethod;
					methodNote?: string | null;
					placement?: string | null;
					colorCount?: number | null;
					artworkUrl?: string | null;
					notes?: string | null;
					sortOrder?: number | null;
					area?: {
						__typename?: 'OrderProductPrintArea';
						width?: number | null;
						height?: number | null;
						unit: string;
					} | null;
					colors?: Array<{
						__typename?: 'OrderProductColorSpec';
						name?: string | null;
						code?: string | null;
						pantone?: string | null;
						appliesTo?: string | null;
						finish?: string | null;
						isPrimary?: boolean | null;
					}> | null;
				}> | null;
				custom?: Array<{
					__typename?: 'OrderProductCustomSpec';
					id: string;
					label: string;
					value: string;
					unit?: string | null;
					group?: string | null;
					sortOrder?: number | null;
				}> | null;
			} | null;
			productDimensions?: {
				__typename?: 'OrderProductDimensions';
				length?: number | null;
				width?: number | null;
				height?: number | null;
				unit: string;
			} | null;
			productImages?: Array<{
				__typename?: 'OrderQuoteItemProductImage';
				url: string;
				isPrimary?: boolean | null;
				sortOrder?: number | null;
				altText?: string | null;
				caption?: string | null;
				dimensions?: {
					__typename?: 'OrderProductImageDimensions';
					width?: number | null;
					height?: number | null;
					aspectRatio?: string | null;
				} | null;
				crop?: {
					__typename?: 'OrderProductImageCrop';
					x: number;
					y: number;
					width: number;
					height: number;
					zoom?: number | null;
					rotation?: number | null;
					aspectRatio?: string | null;
					unit?: string | null;
				} | null;
			}> | null;
			timelineStatus: {
				__typename?: 'TimelineStatus';
				level: TimelineStatusLevel;
				businessDaysLeft?: number | null;
				isExpired: boolean;
			};
			quantities: Array<{
				__typename?: 'OrderQuoteItemQuantity';
				id: string;
				quantity: number;
				sortOrder: number;
			}>;
			attachments: Array<{
				__typename?: 'OrderQuoteItemAttachment';
				id: string;
				name: string;
				description?: string | null;
				mimeType: string;
				size: number;
				url: string;
			}>;
		}>;
	} | null;
};

export type GetOrderQuoteItemByProductQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
	productId: Scalars['ID']['input'];
}>;

export type GetOrderQuoteItemByProductQuery = {
	__typename?: 'Query';
	getOrderQuoteItemByProduct?: {
		__typename?: 'OrderQuoteItem';
		id: string;
		productId: string;
		deadline?: string | null;
		quantities: Array<{
			__typename?: 'OrderQuoteItemQuantity';
			id: string;
			quantity: number;
			sortOrder: number;
		}>;
	} | null;
};

export type GetOrderQuoteActivitiesQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
	inCurrency?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetOrderQuoteActivitiesQuery = {
	__typename?: 'Query';
	getOrderQuoteActivities: Array<{
		__typename?: 'OrderQuoteActivity';
		id: string;
		action: string;
		message?: string | null;
		actorId?: string | null;
		actorRole?: string | null;
		metadata?: any | null;
		orderQuoteId: string;
		createdAt?: string | null;
		adminUser?: { __typename?: 'AdminUserStub'; firstName: string; lastName: string } | null;
		organizationUser?: {
			__typename?: 'OrganizationUserStub';
			firstName: string;
			lastName: string;
		} | null;
	}>;
};

export type GetAllOrderQuoteQueryVariables = Exact<{
	input: GetAllOrderQuoteInput;
}>;

export type GetAllOrderQuoteQuery = {
	__typename?: 'Query';
	getAllOrderQuote: {
		__typename?: 'OrderQuotePage';
		data: Array<{
			__typename?: 'OrderQuote';
			id: string;
			name: string;
			description?: string | null;
			deadline?: string | null;
			status: OrderQuoteStatus;
			organizationId?: string | null;
			purpose?: OrderQuotePurpose | null;
			lastClientViewedAt?: string | null;
			clientViewCount: number;
			createdAt?: string | null;
			updatedAt?: string | null;
			organization?: { __typename?: 'Organization'; id: string; name: string } | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalCount: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type PreviewOrderQuoteItemQuantityChangeQueryVariables = Exact<{
	orderQuoteItemId: Scalars['ID']['input'];
	quantities: Array<OrderQuoteItemQuantityInput> | OrderQuoteItemQuantityInput;
}>;

export type PreviewOrderQuoteItemQuantityChangeQuery = {
	__typename?: 'Query';
	previewOrderQuoteItemQuantityChange: {
		__typename?: 'OrderQuoteItemQuantityChangePreview';
		accepted: boolean;
		severity: OrderQuoteItemQuantityChangeSeverity;
		errors: Array<{
			__typename?: 'OrderQuoteItemQuantityChangeError';
			key: string;
			message: string;
		}>;
		changes: Array<{
			__typename?: 'OrderQuoteItemQuantityChange';
			kind: OrderQuoteItemQuantityChangeKind;
			severity: OrderQuoteItemQuantityChangeSeverity;
			key: string;
			message: string;
			orderQuoteItemQuantityId?: string | null;
			currentQuantity?: number | null;
			newQuantity?: number | null;
			impact: {
				__typename?: 'OrderQuoteItemQuantityImpact';
				pricedOfferCount: number;
				deliveryOptionCount: number;
				clientVisibleOfferCount: number;
				clientSelectionCount: number;
				masterSelectionCount: number;
				offers: Array<{
					__typename?: 'OrderQuoteItemQuantityImpactOffer';
					orderQuoteOfferId: string;
					offerName: string;
					orderQuoteOfferBatchId: string;
					batchName: string;
					batchStatus: OrderQuoteOfferStatus;
					isVisibleToClient: boolean;
				}>;
			};
		}>;
	};
};

export type GetOrderQuoteValueRangeQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type GetOrderQuoteValueRangeQuery = {
	__typename?: 'Query';
	getOrderQuoteValueRange: {
		__typename?: 'OrderQuoteValueRange';
		low?: {
			__typename?: 'OrderQuoteValuePoint';
			total: number;
			marginAmount: number;
			marginPercentage: number;
			markupPercentage: number;
			orderQuoteOfferBatchId: string;
		} | null;
		high?: {
			__typename?: 'OrderQuoteValuePoint';
			total: number;
			marginAmount: number;
			marginPercentage: number;
			markupPercentage: number;
			orderQuoteOfferBatchId: string;
		} | null;
	};
};

export type GetOrderQuoteValueRangesQueryVariables = Exact<{
	orderQuoteIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type GetOrderQuoteValueRangesQuery = {
	__typename?: 'Query';
	getOrderQuoteValueRanges: Array<{
		__typename?: 'OrderQuoteValueRange';
		orderQuoteId: string;
		batchesConsidered: number;
		productsLow?: {
			__typename?: 'OrderQuoteValuePoint';
			total: number;
			productsTotal: number;
			deliveryTotal: number;
			samplesTotal: number;
			samplesShippingTotal: number;
			orderQuoteOfferBatchId: string;
			lines: Array<{
				__typename?: 'OrderQuoteValueLine';
				orderQuoteOfferId: string;
				orderQuoteItemId: string;
				name: string;
				quantity: number;
				productsTotal: number;
			}>;
		} | null;
		productsHigh?: {
			__typename?: 'OrderQuoteValuePoint';
			total: number;
			productsTotal: number;
			deliveryTotal: number;
			samplesTotal: number;
			samplesShippingTotal: number;
			orderQuoteOfferBatchId: string;
			lines: Array<{
				__typename?: 'OrderQuoteValueLine';
				orderQuoteOfferId: string;
				orderQuoteItemId: string;
				name: string;
				quantity: number;
				productsTotal: number;
			}>;
		} | null;
	}>;
};

export type OrderQuoteValueBreakdownFragmentFragment = {
	__typename?: 'OrderQuoteValuePoint';
	total: number;
	productsTotal: number;
	deliveryTotal: number;
	samplesTotal: number;
	samplesShippingTotal: number;
	orderQuoteOfferBatchId: string;
	lines: Array<{
		__typename?: 'OrderQuoteValueLine';
		orderQuoteOfferId: string;
		orderQuoteItemId: string;
		name: string;
		quantity: number;
		productsTotal: number;
	}>;
};

export type OrderQuoteValuePointFragmentFragment = {
	__typename?: 'OrderQuoteValuePoint';
	total: number;
	marginAmount: number;
	marginPercentage: number;
	markupPercentage: number;
	orderQuoteOfferBatchId: string;
};

export type PreviewOrderQuoteProductSyncQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
}>;

export type PreviewOrderQuoteProductSyncQuery = {
	__typename?: 'Query';
	previewOrderQuoteProductSync: {
		__typename?: 'OrderQuoteProductSyncPreview';
		severity: OrderQuoteProductSyncSeverity;
		changedCount: number;
		unavailableCount: number;
		lines: Array<{
			__typename?: 'OrderQuoteProductSyncLine';
			orderQuoteItemId: string;
			productId: string;
			productName?: string | null;
			kind: OrderQuoteProductSyncKind;
			severity: OrderQuoteProductSyncSeverity;
			message: string;
			snapshotAt?: string | null;
			changes: Array<{
				__typename?: 'OrderQuoteProductSyncFieldChange';
				field: string;
				label: string;
				from?: string | null;
				to?: string | null;
			}>;
			clientVisibleBatches: Array<{
				__typename?: 'OrderQuoteProductSyncBatch';
				orderQuoteOfferBatchId: string;
				batchName: string;
				batchStatus: OrderQuoteOfferStatus;
			}>;
		}>;
	};
};

export type PreviewQuoteRecipientsQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
}>;

export type PreviewQuoteRecipientsQuery = {
	__typename?: 'Query';
	previewQuoteRecipients?: {
		__typename?: 'QuoteRecipientsPreview';
		emails: Array<string>;
		nominated: boolean;
	} | null;
};

export type GetOrderQuoteGuestAccessTokensQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
}>;

export type GetOrderQuoteGuestAccessTokensQuery = {
	__typename?: 'Query';
	getOrderQuoteGuestAccessTokens: Array<{
		__typename?: 'OrderQuoteGuestAccessToken';
		id: string;
		email: string;
		link: string;
		status: OrderQuoteGuestAccessTokenStatus;
		acceptedAt?: string | null;
		revokedAt?: string | null;
		createdAt?: string | null;
	}>;
};

export type GetOrderQuoteOfferBatchesQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
	statuses?: InputMaybe<Array<OrderQuoteOfferStatus> | OrderQuoteOfferStatus>;
	inCurrency: CurrencyEnum;
}>;

export type GetOrderQuoteOfferBatchesQuery = {
	__typename?: 'Query';
	getOrderQuoteOfferBatches: Array<{
		__typename?: 'OrderQuoteOfferBatch';
		id: string;
		name: string;
		status: OrderQuoteOfferStatus;
		acceptDeadline?: string | null;
		submittedAt?: string | null;
		sentToClientAt?: string | null;
		respondedAt?: string | null;
		rejectionReason?: string | null;
		orderQuoteId: string;
		createdAt?: string | null;
		updatedAt?: string | null;
		timelineStatus: {
			__typename?: 'TimelineStatus';
			level: TimelineStatusLevel;
			businessDaysLeft?: number | null;
			isExpired: boolean;
		};
		availableActions?: Array<{
			__typename?: 'OrderQuoteOfferBatchNextAction';
			action: OrderQuoteOfferBatchAction;
			displayType: ActionDisplayType;
			label: string;
			blocked?: boolean | null;
			blockedReason?: string | null;
		}> | null;
		summary?: {
			__typename?: 'OrderQuoteOfferBatchSummary';
			productsSubtotal: number;
			unpricedTierCount: number;
			samplesTotal: number;
			samplesShippingTotal: number;
			samplesPrepaidTotal: number;
			deliveryTotal: number;
			feesTotal: number;
			discountsTotal: number;
			grandTotal: number;
			vatRate: number;
			vatAmount: number;
			grossAmount: number;
			fees: Array<{ __typename?: 'OrderSummaryLineItem'; name: string; amount: number }>;
			discounts: Array<{ __typename?: 'OrderSummaryLineItem'; name: string; amount: number }>;
		} | null;
		margin?: {
			__typename?: 'OrderQuoteOfferBatchMargin';
			amount: number;
			base: number;
			percentage: number;
			markupPercentage: number;
			currency: string;
		} | null;
		offers: Array<{
			__typename?: 'OrderQuoteOffer';
			id: string;
			name: string;
			description?: string | null;
			status: OrderQuoteOfferStatus;
			rejectionReason?: string | null;
			respondedAt?: string | null;
			orderQuoteItemId: string;
			sortOrder?: number | null;
			vetterId?: string | null;
			vetterEntityId?: string | null;
			acceptedPricingId?: string | null;
			acceptedQuantity?: number | null;
			acceptedDeliveryId?: string | null;
			vetterEntity?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
			sample?: {
				__typename?: 'OrderQuoteOfferSample';
				id: string;
				status: OrderSampleStatus;
				baseSamplePrice?: number | null;
				baseShippingPrice?: number | null;
				totalPrice?: number | null;
				minProductionDays?: number | null;
				maxProductionDays?: number | null;
				deliveryDaysMin?: number | null;
				deliveryDaysMax?: number | null;
				notes?: string | null;
				paymentTreatment: SamplePaymentTreatment;
				pricesByChoice: Array<{
					__typename?: 'ClientOrderQuoteOfferSamplePrice';
					sampleChoice: OrderSampleChoice;
					totalPrice: number;
				}>;
				catalogPriceDrift?: {
					__typename?: 'CatalogSamplePriceDrift';
					label: string;
					direction: CatalogPriceDriftDirection;
					explanation: string;
					action: {
						__typename?: 'CatalogSamplePriceDriftAction';
						label: string;
						available: boolean;
						unavailableReason?: string | null;
						warning?: string | null;
					};
				} | null;
			} | null;
			attachments: Array<{
				__typename?: 'OrderQuoteItemAttachment';
				id: string;
				name: string;
				description?: string | null;
				mimeType: string;
				size: number;
				url: string;
			}>;
			adjustments: Array<{
				__typename?: 'OrderQuoteOfferAdjustment';
				id: string;
				name: string;
				description?: string | null;
				type: OrderAdjustmentType;
				calculationType: OrderAdjustmentCalculationType;
				value: number;
				sortOrder: number;
			}>;
			pricing: Array<{
				__typename?: 'OrderQuoteOfferPricing';
				id: string;
				orderQuoteItemQuantityId: string;
				orderQuoteOfferId: string;
				baseUnitPrice?: number | null;
				baseTotalPrice?: number | null;
				unitPrice?: number | null;
				totalPrice?: number | null;
				adjustedTotalPrice?: number | null;
				markupPercentage?: number | null;
				authoredCurrency?: string | null;
				marginAmount?: number | null;
				marginAmountCurrency?: string | null;
				marginTotal?: number | null;
				minProductionDays?: number | null;
				maxProductionDays?: number | null;
				appliedFrom?: {
					__typename?: 'OfferPricingAppliedFrom';
					label: string;
					stillMatches: boolean;
					appliedAt: string;
					vetterEntity?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
				} | null;
				catalogPriceDrift?: {
					__typename?: 'CatalogPriceDrift';
					label: string;
					direction: CatalogPriceDriftDirection;
					explanation: string;
					caveat?: string | null;
					actions: Array<{
						__typename?: 'CatalogPriceDriftAction';
						mode: CatalogPriceDriftActionMode;
						label: string;
						available: boolean;
						unavailableReason?: string | null;
						warning?: string | null;
					}>;
				} | null;
				deliveries: Array<{
					__typename?: 'OrderQuoteOfferDelivery';
					id: string;
					shippingMethod: OrderShippingMethod;
					totalPrice?: number | null;
					quantity: number;
					deliveryDaysMin?: number | null;
					deliveryDaysMax?: number | null;
					isSplit: boolean;
					isValid: boolean;
					supplierCost?: {
						__typename?: 'VetterDeliveryCost';
						price: number;
						currency: string;
						deliveryDaysMin?: number | null;
						deliveryDaysMax?: number | null;
						converted?: {
							__typename?: 'VetterDeliveryCostConversion';
							currency: string;
							price: number;
						} | null;
					} | null;
					appliedFrom?: {
						__typename?: 'OfferPricingAppliedFrom';
						label: string;
						stillMatches: boolean;
						appliedAt: string;
						vetterEntity?: {
							__typename?: 'VetterEntity';
							id: string;
							name: string;
						} | null;
					} | null;
					parts: Array<{
						__typename?: 'OrderQuoteOfferDeliveryPart';
						id: string;
						sequence: number;
						shippingMethod: OrderShippingMethod;
						quantity: number;
						totalPrice?: number | null;
						deliveryDaysMin?: number | null;
						deliveryDaysMax?: number | null;
						supplierCost?: {
							__typename?: 'VetterDeliveryCost';
							price: number;
							currency: string;
							deliveryDaysMin?: number | null;
							deliveryDaysMax?: number | null;
							converted?: {
								__typename?: 'VetterDeliveryCostConversion';
								currency: string;
								price: number;
							} | null;
						} | null;
						appliedFrom?: {
							__typename?: 'OfferPricingAppliedFrom';
							label: string;
							stillMatches: boolean;
							appliedAt: string;
							vetterEntity?: {
								__typename?: 'VetterEntity';
								id: string;
								name: string;
							} | null;
						} | null;
						projectedDelivery?: {
							__typename?: 'ProjectedDeliveryWindow';
							ifAcceptedNow: {
								__typename?: 'ProjectedDateRange';
								earliest: string;
								latest: string;
								verdict: OfferFeasibilityVerdict;
							};
							ifAcceptedAtDeadline: {
								__typename?: 'ProjectedDateRange';
								earliest: string;
								latest: string;
								verdict: OfferFeasibilityVerdict;
							};
						} | null;
					}>;
					projectedDelivery?: {
						__typename?: 'ProjectedDeliveryWindow';
						ifAcceptedNow: {
							__typename?: 'ProjectedDateRange';
							earliest: string;
							latest: string;
							verdict: OfferFeasibilityVerdict;
						};
						ifAcceptedAtDeadline: {
							__typename?: 'ProjectedDateRange';
							earliest: string;
							latest: string;
							verdict: OfferFeasibilityVerdict;
						};
					} | null;
				}>;
			}>;
		}>;
	}>;
};

export type GetOrderQuoteOfferBatchQueryVariables = Exact<{
	id: Scalars['ID']['input'];
	inCurrency?: InputMaybe<CurrencyEnum>;
	selectedPricingIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
	selectedDeliveryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
	selectedSampleChoices?: InputMaybe<Array<OfferSampleChoiceInput> | OfferSampleChoiceInput>;
	includedOfferIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type GetOrderQuoteOfferBatchQuery = {
	__typename?: 'Query';
	getOrderQuoteOfferBatch?: {
		__typename?: 'OrderQuoteOfferBatch';
		id: string;
		name: string;
		status: OrderQuoteOfferStatus;
		acceptDeadline?: string | null;
		submittedAt?: string | null;
		sentToClientAt?: string | null;
		respondedAt?: string | null;
		rejectionReason?: string | null;
		orderQuoteId: string;
		createdAt?: string | null;
		updatedAt?: string | null;
		timelineStatus: {
			__typename?: 'TimelineStatus';
			level: TimelineStatusLevel;
			businessDaysLeft?: number | null;
			isExpired: boolean;
		};
		availableActions?: Array<{
			__typename?: 'OrderQuoteOfferBatchNextAction';
			action: OrderQuoteOfferBatchAction;
			displayType: ActionDisplayType;
			label: string;
			blocked?: boolean | null;
			blockedReason?: string | null;
		}> | null;
		summary?: {
			__typename?: 'OrderQuoteOfferBatchSummary';
			productsSubtotal: number;
			unpricedTierCount: number;
			samplesTotal: number;
			samplesShippingTotal: number;
			samplesPrepaidTotal: number;
			deliveryTotal: number;
			feesTotal: number;
			discountsTotal: number;
			grandTotal: number;
			vatRate: number;
			vatAmount: number;
			grossAmount: number;
			fees: Array<{ __typename?: 'OrderSummaryLineItem'; name: string; amount: number }>;
			discounts: Array<{ __typename?: 'OrderSummaryLineItem'; name: string; amount: number }>;
		} | null;
		margin?: {
			__typename?: 'OrderQuoteOfferBatchMargin';
			amount: number;
			base: number;
			percentage: number;
			markupPercentage: number;
			currency: string;
		} | null;
		offers: Array<{
			__typename?: 'OrderQuoteOffer';
			id: string;
			name: string;
			description?: string | null;
			status: OrderQuoteOfferStatus;
			rejectionReason?: string | null;
			respondedAt?: string | null;
			orderQuoteItemId: string;
			sortOrder?: number | null;
			vetterId?: string | null;
			vetterEntityId?: string | null;
			acceptedPricingId?: string | null;
			acceptedQuantity?: number | null;
			acceptedDeliveryId?: string | null;
			vetterEntity?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
			sample?: {
				__typename?: 'OrderQuoteOfferSample';
				id: string;
				status: OrderSampleStatus;
				baseSamplePrice?: number | null;
				baseShippingPrice?: number | null;
				totalPrice?: number | null;
				minProductionDays?: number | null;
				maxProductionDays?: number | null;
				deliveryDaysMin?: number | null;
				deliveryDaysMax?: number | null;
				notes?: string | null;
				paymentTreatment: SamplePaymentTreatment;
				pricesByChoice: Array<{
					__typename?: 'ClientOrderQuoteOfferSamplePrice';
					sampleChoice: OrderSampleChoice;
					totalPrice: number;
				}>;
				catalogPriceDrift?: {
					__typename?: 'CatalogSamplePriceDrift';
					label: string;
					direction: CatalogPriceDriftDirection;
					explanation: string;
					action: {
						__typename?: 'CatalogSamplePriceDriftAction';
						label: string;
						available: boolean;
						unavailableReason?: string | null;
						warning?: string | null;
					};
				} | null;
			} | null;
			attachments: Array<{
				__typename?: 'OrderQuoteItemAttachment';
				id: string;
				name: string;
				description?: string | null;
				mimeType: string;
				size: number;
				url: string;
			}>;
			adjustments: Array<{
				__typename?: 'OrderQuoteOfferAdjustment';
				id: string;
				name: string;
				description?: string | null;
				type: OrderAdjustmentType;
				calculationType: OrderAdjustmentCalculationType;
				value: number;
				sortOrder: number;
			}>;
			pricing: Array<{
				__typename?: 'OrderQuoteOfferPricing';
				id: string;
				orderQuoteItemQuantityId: string;
				orderQuoteOfferId: string;
				baseUnitPrice?: number | null;
				baseTotalPrice?: number | null;
				unitPrice?: number | null;
				totalPrice?: number | null;
				adjustedTotalPrice?: number | null;
				markupPercentage?: number | null;
				authoredCurrency?: string | null;
				marginAmount?: number | null;
				marginAmountCurrency?: string | null;
				marginTotal?: number | null;
				minProductionDays?: number | null;
				maxProductionDays?: number | null;
				appliedFrom?: {
					__typename?: 'OfferPricingAppliedFrom';
					label: string;
					stillMatches: boolean;
					appliedAt: string;
					vetterEntity?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
				} | null;
				catalogPriceDrift?: {
					__typename?: 'CatalogPriceDrift';
					label: string;
					direction: CatalogPriceDriftDirection;
					explanation: string;
					caveat?: string | null;
					actions: Array<{
						__typename?: 'CatalogPriceDriftAction';
						mode: CatalogPriceDriftActionMode;
						label: string;
						available: boolean;
						unavailableReason?: string | null;
						warning?: string | null;
					}>;
				} | null;
				deliveries: Array<{
					__typename?: 'OrderQuoteOfferDelivery';
					id: string;
					shippingMethod: OrderShippingMethod;
					totalPrice?: number | null;
					quantity: number;
					deliveryDaysMin?: number | null;
					deliveryDaysMax?: number | null;
					isSplit: boolean;
					isValid: boolean;
					parts: Array<{
						__typename?: 'OrderQuoteOfferDeliveryPart';
						id: string;
						sequence: number;
						shippingMethod: OrderShippingMethod;
						quantity: number;
						totalPrice?: number | null;
						deliveryDaysMin?: number | null;
						deliveryDaysMax?: number | null;
						projectedDelivery?: {
							__typename?: 'ProjectedDeliveryWindow';
							ifAcceptedNow: {
								__typename?: 'ProjectedDateRange';
								earliest: string;
								latest: string;
								verdict: OfferFeasibilityVerdict;
							};
							ifAcceptedAtDeadline: {
								__typename?: 'ProjectedDateRange';
								earliest: string;
								latest: string;
								verdict: OfferFeasibilityVerdict;
							};
						} | null;
					}>;
					projectedDelivery?: {
						__typename?: 'ProjectedDeliveryWindow';
						ifAcceptedNow: {
							__typename?: 'ProjectedDateRange';
							earliest: string;
							latest: string;
							verdict: OfferFeasibilityVerdict;
						};
						ifAcceptedAtDeadline: {
							__typename?: 'ProjectedDateRange';
							earliest: string;
							latest: string;
							verdict: OfferFeasibilityVerdict;
						};
					} | null;
				}>;
			}>;
		}>;
	} | null;
};

export type PreviewOrderQuoteOfferFeasibilityQueryVariables = Exact<{
	input: PreviewOrderQuoteOfferFeasibilityInput;
}>;

export type PreviewOrderQuoteOfferFeasibilityQuery = {
	__typename?: 'Query';
	previewOrderQuoteOfferFeasibility: {
		__typename?: 'PreviewOrderQuoteOfferFeasibilityResult';
		production?: {
			__typename?: 'OfferFeasibilityProduction';
			verdict: OfferFeasibilityVerdict;
			projectedCompletion?: {
				__typename?: 'ProjectedDeliveryWindow';
				ifAcceptedNow: {
					__typename?: 'ProjectedDateRange';
					earliest: string;
					latest: string;
					verdict: OfferFeasibilityVerdict;
				};
				ifAcceptedAtDeadline: {
					__typename?: 'ProjectedDateRange';
					earliest: string;
					latest: string;
					verdict: OfferFeasibilityVerdict;
				};
			} | null;
			breakdown?: {
				__typename?: 'OfferFeasibilityBreakdown';
				anchorDate?: string | null;
				minProductionDays?: number | null;
				maxProductionDays?: number | null;
				deliveryDaysMin?: number | null;
				deliveryDaysMax?: number | null;
				leadTimeDaysMin?: number | null;
				leadTimeDaysMax?: number | null;
				projectedArrivalEarliest?: string | null;
				projectedArrivalLatest?: string | null;
				overshootBusinessDays?: number | null;
				overshootBestCaseBusinessDays?: number | null;
				deadlineCapacityBusinessDays?: number | null;
			} | null;
		} | null;
		deliveries: Array<{
			__typename?: 'PreviewOrderQuoteOfferFeasibilityDelivery';
			shippingMethod: OrderShippingMethod;
			verdict: OfferFeasibilityVerdict;
			projectedDelivery?: {
				__typename?: 'ProjectedDeliveryWindow';
				ifAcceptedNow: {
					__typename?: 'ProjectedDateRange';
					earliest: string;
					latest: string;
					verdict: OfferFeasibilityVerdict;
				};
				ifAcceptedAtDeadline: {
					__typename?: 'ProjectedDateRange';
					earliest: string;
					latest: string;
					verdict: OfferFeasibilityVerdict;
				};
			} | null;
			breakdown?: {
				__typename?: 'OfferFeasibilityBreakdown';
				anchorDate?: string | null;
				minProductionDays?: number | null;
				maxProductionDays?: number | null;
				deliveryDaysMin?: number | null;
				deliveryDaysMax?: number | null;
				leadTimeDaysMin?: number | null;
				leadTimeDaysMax?: number | null;
				projectedArrivalEarliest?: string | null;
				projectedArrivalLatest?: string | null;
				overshootBusinessDays?: number | null;
				overshootBestCaseBusinessDays?: number | null;
				deadlineCapacityBusinessDays?: number | null;
			} | null;
		}>;
	};
};

export type ValidateOrderQuoteOfferBatchForClientQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type ValidateOrderQuoteOfferBatchForClientQuery = {
	__typename?: 'Query';
	validateOrderQuoteOfferBatchForClient?: {
		__typename?: 'OrderQuoteOfferBatchValidationResult';
		canSend: boolean;
		valid: boolean;
		errors: Array<{
			__typename?: 'OrderQuoteOfferBatchValidationError';
			key: string;
			message: string;
		}>;
		warnings: Array<{
			__typename?: 'OrderQuoteOfferBatchValidationWarning';
			key: string;
			message: string;
			offerId: string;
			offerName: string;
			orderQuoteItemQuantityId?: string | null;
			quantity?: number | null;
			deliveryId?: string | null;
			shippingMethod?: OrderShippingMethod | null;
			deadline?: string | null;
		}>;
	} | null;
};

export type GetOrderQuoteVetterJobsQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
	currency: CurrencyEnum;
}>;

export type GetOrderQuoteVetterJobsQuery = {
	__typename?: 'Query';
	getOrderQuoteVetterJobs: Array<{
		__typename?: 'OrderQuoteVetterJob';
		id: string;
		status: OrderQuoteVetterJobStatus;
		stage: VetterJobStage;
		stageLabel: string;
		orderQuoteItemIds: Array<string>;
		submittedAt?: string | null;
		withdrawnAt?: string | null;
		createdAt?: string | null;
		note?: string | null;
		currency?: string | null;
		vetterEntityId: string;
		vetterEntity?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
		productUsage: Array<{
			__typename?: 'VetterJobProductUsage';
			orderQuoteItemId: string;
			status: VetterProductUsageStatus;
			label?: string | null;
			actionLabel: string;
			appliedAt?: string | null;
		}>;
		prices: Array<{
			__typename?: 'OrderQuoteVetterPrice';
			id: string;
			orderQuoteItemId: string;
			orderQuoteItemQuantityId: string;
			quantity: number;
			baseUnitPrice: number;
			currency: string;
			minProductionDays?: number | null;
			maxProductionDays?: number | null;
			usage?: {
				__typename?: 'VetterPriceUsage';
				status: VetterPriceUsageStatus;
				label?: string | null;
				appliedAt?: string | null;
				orderQuoteOfferId?: string | null;
			} | null;
			shippingPrices: Array<{
				__typename?: 'VetterShippingPrice';
				shippingMethod: OrderShippingMethod;
				price: number;
				deliveryDaysMin?: number | null;
				deliveryDaysMax?: number | null;
			}>;
			converted?: {
				__typename?: 'VetterPriceConversion';
				currency: string;
				baseUnitPrice: number;
				shippingPrices: Array<{
					__typename?: 'VetterShippingPrice';
					shippingMethod: OrderShippingMethod;
					price: number;
				}>;
			} | null;
		}>;
		links: Array<{
			__typename?: 'OrderQuoteVetterLink';
			id: string;
			email: string;
			link: string;
			status: OrderQuoteVetterLinkStatus;
			createdAt?: string | null;
			revokedAt?: string | null;
		}>;
	}>;
};

export type PreviewVetterPriceRequestQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
	vetterEntityId: Scalars['ID']['input'];
}>;

export type PreviewVetterPriceRequestQuery = {
	__typename?: 'Query';
	previewVetterPriceRequest: {
		__typename?: 'VetterPriceRequestPreview';
		notice?: string | null;
		hasAccountHolders: boolean;
		existingJob?: {
			__typename?: 'OrderQuoteVetterJob';
			id: string;
			orderQuoteItemIds: Array<string>;
		} | null;
		recipients: Array<{
			__typename?: 'VetterPriceRequestRecipient';
			vetterUserId: string;
			name: string;
			email?: string | null;
			hasAccount: boolean;
			deliveryLabel: string;
		}>;
	};
};

export type GetOfferBatchesForVetterPricesQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
}>;

export type GetOfferBatchesForVetterPricesQuery = {
	__typename?: 'Query';
	getOrderQuoteOfferBatches: Array<{
		__typename?: 'OrderQuoteOfferBatch';
		id: string;
		name: string;
		status: OrderQuoteOfferStatus;
		sentToClientAt?: string | null;
		offers: Array<{
			__typename?: 'OrderQuoteOffer';
			id: string;
			orderQuoteItemId: string;
			vetterEntityId?: string | null;
			pricing: Array<{
				__typename?: 'OrderQuoteOfferPricing';
				orderQuoteItemQuantityId: string;
				deliveries: Array<{
					__typename?: 'OrderQuoteOfferDelivery';
					id: string;
					parts: Array<{ __typename?: 'OrderQuoteOfferDeliveryPart'; id: string }>;
				}>;
			}>;
		}>;
	}>;
};

export type PreviewApplyVetterPricesQueryVariables = Exact<{
	input: ApplyVetterPricesInput;
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type PreviewApplyVetterPricesQuery = {
	__typename?: 'Query';
	previewApplyVetterPrices: {
		__typename?: 'ApplyVetterPricesPreview';
		canApply: boolean;
		blockedReason?: string | null;
		products: Array<{
			__typename?: 'ApplyVetterPricesProductPreview';
			orderQuoteItemId: string;
			productName: string;
			supplierChanges: boolean;
			supplierFrom?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
			supplierTo: { __typename?: 'VetterEntity'; id: string; name: string };
			quantities: Array<{
				__typename?: 'ApplyVetterPricesQuantityPreview';
				orderQuoteItemQuantityId: string;
				quantity: number;
				changed: boolean;
				marginRule: string;
				unpricedForClient: boolean;
				createsPrice: boolean;
				shipping: Array<{
					__typename?: 'ApplyVetterPricesShippingPreview';
					id: string;
					label: string;
					shippingMethod: OrderShippingMethod;
					quantity: number;
					source: ApplyVetterPricesShippingSource;
					createsOption: boolean;
					changed: boolean;
					before?: {
						__typename?: 'ApplyVetterPricesShippingState';
						price?: number | null;
						deliveryDaysMin?: number | null;
						deliveryDaysMax?: number | null;
					} | null;
					after: {
						__typename?: 'ApplyVetterPricesShippingState';
						price?: number | null;
						deliveryDaysMin?: number | null;
						deliveryDaysMax?: number | null;
					};
				}>;
				before?: {
					__typename?: 'ApplyVetterPricesTierState';
					cost?: number | null;
					unitPrice?: number | null;
					totalPrice?: number | null;
					marginUnit?: number | null;
					marginPercentage?: number | null;
					minProductionDays?: number | null;
					maxProductionDays?: number | null;
				} | null;
				after: {
					__typename?: 'ApplyVetterPricesTierState';
					cost?: number | null;
					unitPrice?: number | null;
					totalPrice?: number | null;
					marginUnit?: number | null;
					marginPercentage?: number | null;
					minProductionDays?: number | null;
					maxProductionDays?: number | null;
				};
			}>;
		}>;
	};
};

export type ApplyVetterPricesTierFieldsFragment = {
	__typename?: 'ApplyVetterPricesTierState';
	cost?: number | null;
	unitPrice?: number | null;
	totalPrice?: number | null;
	marginUnit?: number | null;
	marginPercentage?: number | null;
	minProductionDays?: number | null;
	maxProductionDays?: number | null;
};

export type ApplyVetterPricesShippingFieldsFragment = {
	__typename?: 'ApplyVetterPricesShippingState';
	price?: number | null;
	deliveryDaysMin?: number | null;
	deliveryDaysMax?: number | null;
};

export type GetOrderQuoteViewSummaryQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
}>;

export type GetOrderQuoteViewSummaryQuery = {
	__typename?: 'Query';
	getOrderQuoteViewSummary: {
		__typename?: 'OrderQuoteViewSummary';
		orderQuoteId: string;
		totalViews: number;
		distinctViewers: number;
		firstViewedAt?: string | null;
		lastViewedAt?: string | null;
		viewers: Array<{
			__typename?: 'OrderQuoteViewer';
			id: string;
			actorId: string;
			actorRole?: string | null;
			viewCount: number;
			firstViewedAt: string;
			lastViewedAt: string;
			lastChannel: OrderQuoteViewChannel;
			user?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
				role: AuthRoleEnum;
				organizationUser?: {
					__typename?: 'OrganizationUser';
					id: string;
					firstName: string;
					lastName: string;
				} | null;
			} | null;
		}>;
	};
};

export type GetOrderQuoteOverviewStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrderQuoteOverviewStatsQuery = {
	__typename?: 'Query';
	getOrderQuoteOverviewStats: {
		__typename?: 'OrderQuoteOverviewStats';
		total: number;
		pending: number;
		accepted: number;
		rejected: number;
	};
};

export type GetOrderOverviewStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrderOverviewStatsQuery = {
	__typename?: 'Query';
	getOrderOverviewStats: {
		__typename?: 'OrderOverviewStats';
		total: number;
		pending: number;
		inProduction: number;
		completed: number;
		readyToShip: number;
		inTransit: number;
		overdue: number;
	};
};

export type GetOrderStatsQueryVariables = Exact<{
	currency?: InputMaybe<CurrencyEnum>;
	dateRange?: InputMaybe<DateRangeInput>;
}>;

export type GetOrderStatsQuery = {
	__typename?: 'Query';
	getOrderStats: {
		__typename?: 'OrderStats';
		totalOrderAmount: number;
		totalOrders: number;
		averageOrderAmount: number;
		medianOrderAmount: number;
		averageDeliveryAmount: number;
		medianDeliveryAmount: number;
		averageMargin: number;
		medianMargin: number;
		currency?: CurrencyEnum | null;
	};
};

export type GetOrderQuoteStatsByStatusQueryVariables = Exact<{
	dateRange?: InputMaybe<DateRangeInput>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type GetOrderQuoteStatsByStatusQuery = {
	__typename?: 'Query';
	getOrderQuoteStatsByStatus: {
		__typename?: 'OrderQuoteStatsByStatus';
		total: number;
		totalClients: number;
		statusBreakdown: Array<{
			__typename?: 'OrderQuoteStatusBreakdown';
			status: OrderQuoteStatus;
			count: number;
			percentage: number;
			clientCount: number;
		}>;
	};
};

export type GetOrderStatsByStatusQueryVariables = Exact<{
	currency?: InputMaybe<CurrencyEnum>;
	dateRange?: InputMaybe<DateRangeInput>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type GetOrderStatsByStatusQuery = {
	__typename?: 'Query';
	getOrderStatsByStatus: {
		__typename?: 'OrderStatsByStatus';
		total: number;
		totalAmount: number;
		statusBreakdown: Array<{
			__typename?: 'OrderStatusBreakdown';
			status: OrderStatus;
			count: number;
			totalAmount: number;
			percentage: number;
		}>;
	};
};

export type GetRecentOrderQuotesQueryVariables = Exact<{
	limit?: InputMaybe<Scalars['Int']['input']>;
	dateRange?: InputMaybe<DateRangeInput>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type GetRecentOrderQuotesQuery = {
	__typename?: 'Query';
	getRecentOrderQuotes: Array<{
		__typename?: 'OrderQuote';
		id: string;
		name: string;
		status: OrderQuoteStatus;
		createdAt?: string | null;
		organization?: { __typename?: 'Organization'; id: string; name: string } | null;
	}>;
};

export type GetRecentOrdersQueryVariables = Exact<{
	limit?: InputMaybe<Scalars['Int']['input']>;
	dateRange?: InputMaybe<DateRangeInput>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
	currency?: InputMaybe<CurrencyEnum>;
}>;

export type GetRecentOrdersQuery = {
	__typename?: 'Query';
	getRecentOrders: Array<{
		__typename?: 'Order';
		id: string;
		name: string;
		status: OrderStatus;
		createdAt?: string | null;
		totalAmount?: number | null;
		organization?: { __typename?: 'Organization'; id: string; name: string } | null;
	}>;
};

export type GetInvoicePdfUrlQueryVariables = Exact<{
	invoiceNumber: Scalars['Int']['input'];
}>;

export type GetInvoicePdfUrlQuery = { __typename?: 'Query'; getInvoicePdfUrl?: string | null };

export type GetOrderTransactionsQueryVariables = Exact<{
	orderId: Scalars['ID']['input'];
}>;

export type GetOrderTransactionsQuery = {
	__typename?: 'Query';
	getOrderTransactionsV2: Array<{
		__typename?: 'OrderTransactionRowV2';
		key: string;
		kind: OrderTransactionKindV2;
		status: string;
		statusLabel: string;
		tone: PaymentRowTone;
		method?: string | null;
		totalPrice: number;
		currency: CurrencyEnum;
		date: string;
		paidAt?: string | null;
		invoiceNumber?: number | null;
		isHistory: boolean;
		paymentTransactionId?: string | null;
		descriptions: Array<{
			__typename?: 'OrderTransactionDescriptionV2';
			text: string;
			sampleRound?: number | null;
		}>;
	}>;
};

export type GetOrganizationSettingQueryVariables = Exact<{
	organizationId: Scalars['ID']['input'];
}>;

export type GetOrganizationSettingQuery = {
	__typename?: 'Query';
	getOrganizationSetting?: {
		__typename?: 'OrganizationSetting';
		id: string;
		currency?: CurrencyEnum | null;
		productPaymentMode: PaymentModeEnum;
		samplePaymentMode: PaymentModeEnum;
		stripeCheckoutLimit?: number | null;
		invoiceMinimumThreshold?: number | null;
		economicPaymentTermsNumber: number;
		economicPaymentTermsName?: string | null;
		invoiceRecipients?: Array<{
			__typename?: 'OrganizationInvoiceRecipient';
			type: InvoiceRecipientType;
			userId?: string | null;
			email?: string | null;
			name?: string | null;
		}> | null;
	} | null;
};

export type EconomicPaymentTermsQueryVariables = Exact<{ [key: string]: never }>;

export type EconomicPaymentTermsQuery = {
	__typename?: 'Query';
	economicPaymentTerms: Array<{
		__typename?: 'EconomicPaymentTerm';
		paymentTermsNumber: number;
		name: string;
		daysOfCredit?: number | null;
		paymentTermsType?: string | null;
		isDefault: boolean;
	}>;
};

export type GetOrganizationApprovalAndMarginQueryVariables = Exact<{
	organizationId: Scalars['ID']['input'];
}>;

export type GetOrganizationApprovalAndMarginQuery = {
	__typename?: 'Query';
	getOrganizationApprovalAndMargin?: {
		__typename?: 'OrganizationApprovalAndMargin';
		organizationId: string;
		defaultApproval: boolean;
		defaultMargin: number;
	} | null;
};

export type GetAllOrganizationUserQueryVariables = Exact<{
	input: GetAllOrganizationUserInput;
}>;

export type GetAllOrganizationUserQuery = {
	__typename?: 'Query';
	getAllOrganizationUser?: {
		__typename?: 'OrganizationUserPage';
		data?: Array<{
			__typename?: 'OrganizationUser';
			id: string;
			firstName: string;
			lastName: string;
			jobPosition?: string | null;
			avatar?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
				role: AuthRoleEnum;
				lockedAt?: string | null;
				lockReason?: string | null;
				lastActive?: string | null;
			} | null;
		}> | null;
		pageInfo?: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		} | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	} | null;
};

export type GetOrganizationUserStatsQueryVariables = Exact<{
	input?: InputMaybe<GetOrganizationUserStatsInput>;
}>;

export type GetOrganizationUserStatsQuery = {
	__typename?: 'Query';
	getOrganizationUserStats: {
		__typename?: 'OrganizationUserStats';
		active: number;
		pending: number;
		total: number;
	};
};

export type GetOrganizationQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetOrganizationQuery = {
	__typename?: 'Query';
	getOrganization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		logo?: string | null;
		originalLogo?: string | null;
		websiteUrl?: string | null;
		countryCode?: string | null;
		organizationIndustryId?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		organizationIndustry?: {
			__typename?: 'OrganizationIndustry';
			id: string;
			name: string;
			isPublished: boolean;
		} | null;
		businessRegistrations?: Array<{
			__typename?: 'BusinessRegistration';
			type: string;
			number: string;
			verified?: boolean | null;
		}> | null;
		organizationSetting?: {
			__typename?: 'OrganizationSetting';
			id: string;
			currency?: CurrencyEnum | null;
			productPaymentMode: PaymentModeEnum;
			samplePaymentMode: PaymentModeEnum;
			invoiceMinimumThreshold?: number | null;
			stripeCheckoutLimit?: number | null;
		} | null;
		addresses?: Array<{
			__typename?: 'OrganizationAddress';
			id: string;
			addressLine1: string;
			addressLine2?: string | null;
			addressType: AddressType;
			city: string;
			countryCode: string;
			postalCode: string;
			stateCode?: string | null;
			isPrimary: boolean;
			name?: string | null;
			googlePlaceId?: string | null;
			latitude?: number | null;
			longitude?: number | null;
		}> | null;
		organizationUsers?: Array<{
			__typename?: 'OrganizationUser';
			id: string;
			firstName: string;
			lastName: string;
			jobPosition?: string | null;
			phone?: string | null;
			birthday?: string | null;
			notes?: string | null;
			avatar?: string | null;
			status: StatusEnum;
			isGuest: boolean;
			invitedAt?: string | null;
			createdAt?: string | null;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
			} | null;
		}> | null;
	} | null;
};

export type GetAllOrganizationQueryVariables = Exact<{
	input: GetAllOrganizationInput;
}>;

export type GetAllOrganizationQuery = {
	__typename?: 'Query';
	getAllOrganization: {
		__typename?: 'OrganizationPage';
		data: Array<{
			__typename?: 'Organization';
			id: string;
			name: string;
			logo?: string | null;
			websiteUrl?: string | null;
			organizationIndustryId?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
			organizationIndustry?: {
				__typename?: 'OrganizationIndustry';
				id: string;
				name: string;
				isPublished: boolean;
			} | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetOrganizationStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrganizationStatsQuery = {
	__typename?: 'Query';
	getOrganizationStats: {
		__typename?: 'OrganizationStats';
		totalClients: number;
		active: number;
		industries: number;
		recent: number;
	};
};

export type GetOrganizationAddressesQueryVariables = Exact<{
	organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetOrganizationAddressesQuery = {
	__typename?: 'Query';
	getOrganizationAddresses: Array<{
		__typename?: 'OrganizationAddress';
		id: string;
		addressLine1: string;
		addressLine2?: string | null;
		addressType: AddressType;
		city: string;
		countryCode: string;
		postalCode: string;
		stateCode?: string | null;
		isPrimary: boolean;
		name?: string | null;
		googlePlaceId?: string | null;
		latitude?: number | null;
		longitude?: number | null;
	}>;
};

export type GetOrganizationGeneralQueryVariables = Exact<{
	organizationId: Scalars['ID']['input'];
}>;

export type GetOrganizationGeneralQuery = {
	__typename?: 'Query';
	getOrganization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		websiteUrl?: string | null;
	} | null;
};

export type GetAllClientContactQueryVariables = Exact<{
	input: GetAllClientContactInput;
}>;

export type GetAllClientContactQuery = {
	__typename?: 'Query';
	getAllClientContact: {
		__typename?: 'OrganizationUserPage';
		data?: Array<{
			__typename?: 'OrganizationUser';
			id: string;
			firstName: string;
			lastName: string;
			jobPosition?: string | null;
			phone?: string | null;
			birthday?: string | null;
			notes?: string | null;
			avatar?: string | null;
			isGuest: boolean;
			status: StatusEnum;
			invitedAt?: string | null;
			organizationId: string;
			createdAt?: string | null;
			updatedAt?: string | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				logo?: string | null;
			} | null;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
				lastActive?: string | null;
				lockedAt?: string | null;
			} | null;
		}> | null;
		pageInfo?: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		} | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type GetMyOrganizationMembershipsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyOrganizationMembershipsQuery = {
	__typename?: 'Query';
	getMyOrganizationMemberships: Array<{
		__typename?: 'OrganizationUser';
		id: string;
		organizationId: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			logo?: string | null;
		} | null;
	}>;
};

export type GetAllOrganizationIndustriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllOrganizationIndustriesQuery = {
	__typename?: 'Query';
	getAllOrganizationIndustries: Array<{
		__typename?: 'OrganizationIndustry';
		id: string;
		name: string;
		isPublished: boolean;
		createdByOrganizationId?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
	}>;
};

export type GetAllOrganizationIndustriesAdminQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllOrganizationIndustriesAdminQuery = {
	__typename?: 'Query';
	getAllOrganizationIndustriesAdmin: Array<{
		__typename?: 'OrganizationIndustry';
		id: string;
		name: string;
		isPublished: boolean;
		createdByOrganizationId?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
	}>;
};

export type GetPantoneBooksQueryVariables = Exact<{ [key: string]: never }>;

export type GetPantoneBooksQuery = {
	__typename?: 'Query';
	getPantoneBooks: Array<{
		__typename?: 'PantoneBookInfo';
		id: PantoneBook;
		title: string;
		finish: PantoneFinish;
		colorCount: number;
	}>;
};

export type MatchPantoneColorQueryVariables = Exact<{
	input: MatchPantoneColorInput;
}>;

export type MatchPantoneColorQuery = {
	__typename?: 'Query';
	matchPantoneColor: Array<{
		__typename?: 'PantoneColorMatch';
		accuracy: PantoneMatchAccuracy;
		deltaE: number;
		color: {
			__typename?: 'PantoneColor';
			id: string;
			book: PantoneBook;
			bookTitle: string;
			finish: PantoneFinish;
			code: string;
			name?: string | null;
			hex: string;
			pageNumberInBook?: string | null;
		};
	}>;
};

export type GetAllPantoneColorQueryVariables = Exact<{
	input: GetAllPantoneColorInput;
}>;

export type GetAllPantoneColorQuery = {
	__typename?: 'Query';
	getAllPantoneColor: {
		__typename?: 'PantoneColorPage';
		data: Array<{
			__typename?: 'PantoneColor';
			id: string;
			book: PantoneBook;
			bookTitle: string;
			finish: PantoneFinish;
			code: string;
			name?: string | null;
			hex: string;
			pageNumberInBook?: string | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type FindPantoneColorAcrossBooksQueryVariables = Exact<{
	code: Scalars['String']['input'];
}>;

export type FindPantoneColorAcrossBooksQuery = {
	__typename?: 'Query';
	findPantoneColorAcrossBooks: Array<{
		__typename?: 'PantoneColor';
		id: string;
		book: PantoneBook;
		bookTitle: string;
		finish: PantoneFinish;
		code: string;
		name?: string | null;
		hex: string;
	}>;
};

export type GetProductPaymentPreviewQueryVariables = Exact<{
	orderId: Scalars['ID']['input'];
	currency: Scalars['String']['input'];
	orderItemIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type GetProductPaymentPreviewQuery = {
	__typename?: 'Query';
	getProductPaymentPreview: {
		__typename?: 'ProductPaymentPreview';
		currency: string;
		grandTotal: number;
		vatRate: number;
		vatAmount: number;
		grossAmount: number;
		deductionsDeferred: number;
		deliveries: Array<{
			__typename?: 'ProductPaymentPreviewDelivery';
			method: string;
			amount: number;
		}>;
		items: Array<{
			__typename?: 'ProductPaymentPreviewLine';
			orderItemId: string;
			description: string;
			productsAmount: number;
			feesAmount: number;
			deliveryAmount: number;
			lineSubtotal: number;
			deductibleAmount: number;
			lineNetAmount: number;
			fees: Array<{ __typename?: 'ProductPaymentPreviewFee'; name: string; amount: number }>;
			deliveries: Array<{
				__typename?: 'ProductPaymentPreviewDelivery';
				method: string;
				amount: number;
			}>;
			deductibleSamples: Array<{
				__typename?: 'ProductPaymentPreviewDeduction';
				sampleId: string;
				description: string;
				amount: number;
			}>;
		}>;
	};
};

export type GetSamplePaymentPreviewQueryVariables = Exact<{
	orderId: Scalars['ID']['input'];
	currency: Scalars['String']['input'];
	sampleIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type GetSamplePaymentPreviewQuery = {
	__typename?: 'Query';
	getSamplePaymentPreview: {
		__typename?: 'SamplePaymentPreview';
		currency: string;
		grandTotal: number;
		vatRate: number;
		vatAmount: number;
		grossAmount: number;
		items: Array<{
			__typename?: 'SamplePaymentPreviewLine';
			orderItemId: string;
			sampleId: string;
			description: string;
			samplePrice: number;
			shippingPrice: number;
		}>;
	};
};

export type GetFullOrderPaymentPreviewQueryVariables = Exact<{
	orderId: Scalars['ID']['input'];
	currency: Scalars['String']['input'];
}>;

export type GetFullOrderPaymentPreviewQuery = {
	__typename?: 'Query';
	getFullOrderPaymentPreview: {
		__typename?: 'FullOrderPaymentPreview';
		currency: string;
		deductionsUncredited: number;
		deductionsDeferred: number;
		grandTotal: number;
		vatRate: number;
		vatAmount: number;
		grossAmount: number;
		items: Array<{
			__typename?: 'ProductPaymentPreviewLine';
			orderItemId: string;
			description: string;
			productsAmount: number;
			deliveryAmount: number;
			feesAmount: number;
			lineSubtotal: number;
			deductibleAmount: number;
			lineNetAmount: number;
		}>;
		samples: Array<{
			__typename?: 'FullOrderPaymentPreviewSampleLine';
			sampleId: string;
			orderItemId: string;
			description: string;
			sampleAmount: number;
			shippingAmount: number;
		}>;
		deliveries: Array<{
			__typename?: 'ProductPaymentPreviewDelivery';
			method: string;
			amount: number;
		}>;
	};
};

export type GetAllProductsQueryVariables = Exact<{
	input: GetAllProductInput;
}>;

export type GetAllProductsQuery = {
	__typename?: 'Query';
	getAllProduct: {
		__typename?: 'ProductPage';
		data: Array<{
			__typename?: 'Product';
			id: string;
			name: string;
			description?: string | null;
			sku: string;
			weight?: number | null;
			status: ProductStatus;
			brandId?: string | null;
			organizationId?: string | null;
			isPublishedToCommunity: boolean;
			communityPublishedAt?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				logo?: string | null;
			} | null;
			dimensions?: {
				__typename?: 'ProductDimensions';
				length?: number | null;
				width?: number | null;
				height?: number | null;
				unit: string;
			} | null;
			images?: Array<{
				__typename?: 'ProductImage';
				id: string;
				url?: string | null;
				name: string;
				isPrimary?: boolean | null;
				altText?: string | null;
				sortOrder?: number | null;
				mimeType: string;
				size: number;
				uploadedAt: string;
				crop?: {
					__typename?: 'ProductImageCrop';
					x: number;
					y: number;
					width: number;
					height: number;
					zoom?: number | null;
					rotation?: number | null;
					aspectRatio?: string | null;
					unit?: ProductImageCropUnit | null;
				} | null;
			}> | null;
			tags?: Array<{
				__typename?: 'ProductTag';
				id: string;
				name: string;
				color?: string | null;
			}> | null;
			recommendations: Array<{
				__typename?: 'ProductRecommendation';
				id: string;
				productId: string;
				type: ProductRecommendationType;
				title: string;
				description: string;
				actionLabel: string;
				actionUrl?: string | null;
				status: ProductRecommendationStatus;
			}>;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetCommunityProductsQueryVariables = Exact<{
	input: GetAllProductInput;
}>;

export type GetCommunityProductsQuery = {
	__typename?: 'Query';
	getAllProduct: {
		__typename?: 'ProductPage';
		data: Array<{
			__typename?: 'Product';
			id: string;
			name: string;
			description?: string | null;
			communityPublishedAt?: string | null;
			images?: Array<{
				__typename?: 'ProductImage';
				id: string;
				url?: string | null;
				name: string;
				isPrimary?: boolean | null;
				sortOrder?: number | null;
				crop?: {
					__typename?: 'ProductImageCrop';
					x: number;
					y: number;
					width: number;
					height: number;
					zoom?: number | null;
					rotation?: number | null;
					aspectRatio?: string | null;
					unit?: ProductImageCropUnit | null;
				} | null;
			}> | null;
			tags?: Array<{
				__typename?: 'ProductTag';
				id: string;
				name: string;
				color?: string | null;
			}> | null;
			availableActions: {
				__typename?: 'ProductAvailableActions';
				canDuplicate: boolean;
				canRemix: boolean;
			};
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetProductTagsQueryVariables = Exact<{
	input: GetAllProductTagInput;
}>;

export type GetProductTagsQuery = {
	__typename?: 'Query';
	getAllProductTag: {
		__typename?: 'ProductTagPage';
		data: Array<{
			__typename?: 'ProductTag';
			id: string;
			name: string;
			color?: string | null;
			parentId?: string | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetProductStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetProductStatsQuery = {
	__typename?: 'Query';
	getProductStats: {
		__typename?: 'ProductStats';
		total: number;
		admin: number;
		organization: number;
		community: number;
		withImages: number;
		recent: number;
	};
};

export type GetProductQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetProductQuery = {
	__typename?: 'Query';
	getProduct: {
		__typename?: 'Product';
		id: string;
		name: string;
		description?: string | null;
		sku: string;
		brandId?: string | null;
		weight?: number | null;
		studioFileId?: string | null;
		organizationId?: string | null;
		isPublishedToCommunity: boolean;
		communityPublishedAt?: string | null;
		communityCopyCount?: number | null;
		sourceProductId?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		metadata?: {
			__typename?: 'ProductMetadata';
			isAIGenerated?: boolean | null;
			createdFromProject?: boolean | null;
		} | null;
		dimensions?: {
			__typename?: 'ProductDimensions';
			length?: number | null;
			width?: number | null;
			height?: number | null;
			unit: string;
		} | null;
		specifications?: {
			__typename?: 'ProductSpecifications';
			material?: string | null;
			secondaryMaterials?: Array<string> | null;
			finish?: string | null;
			textureDescription?: string | null;
			features?: Array<string> | null;
			capacity?: { __typename?: 'ProductMeasure'; value: number; unit: string } | null;
			colors?: Array<{
				__typename?: 'ProductColorSpec';
				name?: string | null;
				code?: string | null;
				pantone?: string | null;
				appliesTo?: string | null;
				finish?: string | null;
				isPrimary?: boolean | null;
			}> | null;
			packaging?: {
				__typename?: 'ProductPackaging';
				type?: string | null;
				weight?: number | null;
				weightUnit?: string | null;
				notes?: string | null;
				dimensions?: {
					__typename?: 'ProductDimensions';
					length?: number | null;
					width?: number | null;
					height?: number | null;
					unit: string;
				} | null;
			} | null;
			decorations?: Array<{
				__typename?: 'ProductDecoration';
				id: string;
				method: ProductDecorationMethod;
				methodNote?: string | null;
				placement?: string | null;
				colorCount?: number | null;
				artworkUrl?: string | null;
				notes?: string | null;
				sortOrder?: number | null;
				area?: {
					__typename?: 'ProductPrintArea';
					width?: number | null;
					height?: number | null;
					unit: string;
				} | null;
				colors?: Array<{
					__typename?: 'ProductColorSpec';
					name?: string | null;
					code?: string | null;
					pantone?: string | null;
					appliesTo?: string | null;
					finish?: string | null;
					isPrimary?: boolean | null;
				}> | null;
			}> | null;
			custom?: Array<{
				__typename?: 'ProductCustomSpec';
				id: string;
				label: string;
				value: string;
				unit?: string | null;
				group?: string | null;
				sortOrder?: number | null;
			}> | null;
		} | null;
		images?: Array<{
			__typename?: 'ProductImage';
			id: string;
			url?: string | null;
			name: string;
			isPrimary?: boolean | null;
			altText?: string | null;
			mimeType: string;
			sortOrder?: number | null;
			crop?: {
				__typename?: 'ProductImageCrop';
				x: number;
				y: number;
				width: number;
				height: number;
				zoom?: number | null;
				rotation?: number | null;
				aspectRatio?: string | null;
				unit?: ProductImageCropUnit | null;
			} | null;
			metadata?: Array<{
				__typename?: 'ImageMetadata';
				type: string;
				x?: number | null;
				y?: number | null;
				width?: number | null;
				height?: number | null;
				comment?: string | null;
				canvasWidth: number;
				canvasHeight: number;
				points?: Array<{ __typename?: 'PolygonPoint'; x: number; y: number }> | null;
				attachments?: Array<{
					__typename?: 'MetadataAttachment';
					fileName: string;
					contentType: string;
					size: number;
					url: string;
				}> | null;
			}> | null;
		}> | null;
		brand?: {
			__typename?: 'Brand';
			id: string;
			name: string;
			brandFiles?: Array<{
				__typename?: 'BrandFile';
				id: string;
				name: string;
				url?: string | null;
				type: BrandFileType;
				mimeType: string;
				size: number;
				uploadedAt: string;
			}> | null;
		} | null;
		recommendations: Array<{
			__typename?: 'ProductRecommendation';
			id: string;
			productId: string;
			type: ProductRecommendationType;
			title: string;
			description: string;
			actionLabel: string;
			actionUrl?: string | null;
			status: ProductRecommendationStatus;
		}>;
		studioFile?: {
			__typename?: 'StudioFile';
			id: string;
			name?: string | null;
			currentVersion?: {
				__typename?: 'StudioFileVersion';
				id: string;
				imageUrls: Array<string>;
				versionNumber: number;
			} | null;
		} | null;
		tags?: Array<{
			__typename?: 'ProductTag';
			id: string;
			name: string;
			color?: string | null;
		}> | null;
		communityPublishability?: {
			__typename?: 'CommunityPublishability';
			canPublish: boolean;
			reason?: string | null;
		} | null;
		availableActions: {
			__typename?: 'ProductAvailableActions';
			canDuplicate: boolean;
			canRemix: boolean;
			canEdit: boolean;
			canDelete: boolean;
		};
	};
};

export type GetProductPricesQueryVariables = Exact<{
	input: GetProductPricesInput;
	currency: CurrencyEnum;
}>;

export type GetProductPricesQuery = {
	__typename?: 'Query';
	getProductPrices: Array<{
		__typename?: 'ProductPrice';
		id: string;
		productId: string;
		vetterEntityId?: string | null;
		quantity: number;
		baseUnitPrice: number;
		currency: string;
		markupPercentage?: number | null;
		unitSalePrice?: number | null;
		marginUnit?: number | null;
		marginPercentage?: number | null;
		minProductionDays?: number | null;
		maxProductionDays?: number | null;
		isActive: boolean;
		validFrom?: string | null;
		validTo?: string | null;
		lastQuotedUnitPrice?: number | null;
		lastQuotedCurrency?: string | null;
		lastQuotedAt?: string | null;
		lastQuotedOfferId?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		vetterEntity?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
		converted?: {
			__typename?: 'ProductPriceFigures';
			currency: string;
			baseUnitPrice: number;
			unitSalePrice?: number | null;
			marginUnit?: number | null;
			lastQuotedUnitPrice?: number | null;
			exchangeRate: number;
		} | null;
	}>;
};

export type SuggestOrderQuoteItemPricingQueryVariables = Exact<{
	orderQuoteItemId: Scalars['ID']['input'];
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type SuggestOrderQuoteItemPricingQuery = {
	__typename?: 'Query';
	suggestOrderQuoteItemPricing: Array<{
		__typename?: 'CatalogPriceSuggestion';
		orderQuoteItemQuantityId: string;
		quantity: number;
		baseUnitPrice: number;
		currency: string;
		markupPercentage?: number | null;
		minProductionDays?: number | null;
		maxProductionDays?: number | null;
		source: CatalogPriceSource;
		matchedQuantity: number;
		match: CatalogPriceMatch;
		note?: string | null;
		vetterEntity?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
		converted?: {
			__typename?: 'CatalogPriceConversion';
			currency: string;
			baseUnitPrice: number;
			exchangeRate: number;
			shippingPrices: Array<{
				__typename?: 'VetterShippingPrice';
				shippingMethod: OrderShippingMethod;
				price: number;
				deliveryDaysMin?: number | null;
				deliveryDaysMax?: number | null;
			}>;
		} | null;
		shippingPrices: Array<{
			__typename?: 'VetterShippingPrice';
			shippingMethod: OrderShippingMethod;
			price: number;
			deliveryDaysMin?: number | null;
			deliveryDaysMax?: number | null;
		}>;
		alternatives: Array<{
			__typename?: 'CatalogPriceBreak';
			quantity: number;
			baseUnitPrice: number;
			currency: string;
			markupPercentage?: number | null;
			minProductionDays?: number | null;
			maxProductionDays?: number | null;
			converted?: {
				__typename?: 'CatalogPriceConversion';
				currency: string;
				baseUnitPrice: number;
				exchangeRate: number;
			} | null;
		}>;
	}>;
};

export type SuggestOrderQuoteOfferPricingQueryVariables = Exact<{
	orderQuoteOfferId: Scalars['ID']['input'];
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type SuggestOrderQuoteOfferPricingQuery = {
	__typename?: 'Query';
	suggestOrderQuoteOfferPricing: Array<{
		__typename?: 'CatalogPriceSuggestion';
		orderQuoteItemQuantityId: string;
		quantity: number;
		baseUnitPrice: number;
		currency: string;
		markupPercentage?: number | null;
		minProductionDays?: number | null;
		maxProductionDays?: number | null;
		source: CatalogPriceSource;
		matchedQuantity: number;
		match: CatalogPriceMatch;
		vetterEntity?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
		converted?: {
			__typename?: 'CatalogPriceConversion';
			currency: string;
			baseUnitPrice: number;
			exchangeRate: number;
		} | null;
		alternatives: Array<{
			__typename?: 'CatalogPriceBreak';
			quantity: number;
			baseUnitPrice: number;
			currency: string;
			markupPercentage?: number | null;
			minProductionDays?: number | null;
			maxProductionDays?: number | null;
			converted?: {
				__typename?: 'CatalogPriceConversion';
				currency: string;
				baseUnitPrice: number;
				exchangeRate: number;
			} | null;
		}>;
	}>;
};

export type GetProductSamplePricesQueryVariables = Exact<{
	input: GetProductSamplePricesInput;
	currency: CurrencyEnum;
}>;

export type GetProductSamplePricesQuery = {
	__typename?: 'Query';
	getProductSamplePrices: Array<{
		__typename?: 'ProductSamplePrice';
		id: string;
		productId: string;
		vetterEntityId?: string | null;
		samplePrice: number;
		shippingPrice?: number | null;
		currency: string;
		minProductionDays?: number | null;
		maxProductionDays?: number | null;
		deliveryDaysMin?: number | null;
		deliveryDaysMax?: number | null;
		isActive: boolean;
		validFrom?: string | null;
		validTo?: string | null;
		lastQuotedSamplePrice?: number | null;
		lastQuotedShippingPrice?: number | null;
		lastQuotedCurrency?: string | null;
		lastQuotedAt?: string | null;
		lastQuotedOfferId?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		vetterEntity?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
		converted?: {
			__typename?: 'ProductSamplePriceFigures';
			currency: string;
			exchangeRate: number;
			samplePrice: number;
			shippingPrice?: number | null;
			lastQuotedSamplePrice?: number | null;
			lastQuotedShippingPrice?: number | null;
		} | null;
	}>;
};

export type GetQuoteProductCommentsQueryVariables = Exact<{
	input: QuoteProductThreadInput;
}>;

export type GetQuoteProductCommentsQuery = {
	__typename?: 'Query';
	getQuoteProductComments: Array<{
		__typename?: 'QuoteProductComment';
		id: string;
		orderQuoteItemId: string;
		vetterEntityId?: string | null;
		body: string;
		isMine: boolean;
		canEdit: boolean;
		canDelete: boolean;
		createdAt?: string | null;
		editedAt?: string | null;
		deletedAt?: string | null;
		author: {
			__typename?: 'QuoteProductCommentAuthor';
			userId: string;
			name: string;
			side: QuoteProductCommentSide;
		};
		mentions: Array<{
			__typename?: 'QuoteProductCommentMention';
			userId: string;
			name: string;
		}>;
		attachments: Array<{
			__typename?: 'QuoteProductCommentAttachment';
			name: string;
			url?: string | null;
			mimeType: string;
			size: number;
		}>;
	}>;
};

export type GetQuoteProductMentionCandidatesQueryVariables = Exact<{
	input: QuoteProductThreadInput;
}>;

export type GetQuoteProductMentionCandidatesQuery = {
	__typename?: 'Query';
	getQuoteProductMentionCandidates: Array<{
		__typename?: 'QuoteProductMentionCandidate';
		userId: string;
		name: string;
		side: QuoteProductCommentSide;
		subtitle: string;
	}>;
};

export type GetQuoteProductThreadsQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
}>;

export type GetQuoteProductThreadsQuery = {
	__typename?: 'Query';
	getQuoteProductThreads: Array<{
		__typename?: 'QuoteProductThread';
		id: string;
		kind: QuoteProductThreadKind;
		orderQuoteItemId: string;
		productName?: string | null;
		vetterEntityId?: string | null;
		commentCount: number;
		unreadCount: number;
		lastCommentAt?: string | null;
		vetterEntity?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
	}>;
};

export type GetQuoteProductCommentTargetQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetQuoteProductCommentTargetQuery = {
	__typename?: 'Query';
	getQuoteProductCommentTarget?: {
		__typename?: 'QuoteProductCommentTarget';
		orderQuoteId: string;
		orderQuoteItemId: string;
		vetterEntityId?: string | null;
		vetterJobId?: string | null;
	} | null;
};

export type GetQuoteOfferLinesQueryVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
}>;

export type GetQuoteOfferLinesQuery = {
	__typename?: 'Query';
	getOrderQuoteOfferBatches: Array<{
		__typename?: 'OrderQuoteOfferBatch';
		id: string;
		offers: Array<{ __typename?: 'OrderQuoteOffer'; id: string; orderQuoteItemId: string }>;
	}>;
};

export type GetShippingCarriersQueryVariables = Exact<{ [key: string]: never }>;

export type GetShippingCarriersQuery = {
	__typename?: 'Query';
	getShippingCarriers: Array<{
		__typename?: 'ShippingCarrier';
		code: string;
		name: string;
		supportsTracking: boolean;
	}>;
};

export type GetSubscriptionTierConfigsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSubscriptionTierConfigsQuery = {
	__typename?: 'Query';
	getSubscriptionTierConfigs: Array<{
		__typename?: 'SubscriptionTierConfig';
		tier: SubscriptionTier;
		monthlyPrice?: number | null;
		currency?: string | null;
		kickbackRate: number;
		aiTokenRatePerMillion?: number | null;
		stripePriceId?: string | null;
		isActive: boolean;
		updatedAt: string;
	}>;
};

export type GetMySubscriptionQueryVariables = Exact<{ [key: string]: never }>;

export type GetMySubscriptionQuery = {
	__typename?: 'Query';
	getMySubscription?: {
		__typename?: 'OrganizationSubscription';
		id: string;
		organizationId: string;
		tier: SubscriptionTier;
		status: SubscriptionStatus;
		stripeCustomerId?: string | null;
		stripeSubscriptionId?: string | null;
		stripePriceId?: string | null;
		currentPeriodStart?: string | null;
		currentPeriodEnd?: string | null;
		cancelAtPeriodEnd: boolean;
		canceledAt?: string | null;
		trialEnd?: string | null;
		pendingTier?: SubscriptionTier | null;
		pendingTierEffectiveAt?: string | null;
		createdAt: string;
		updatedAt: string;
	} | null;
};

export type GetSystemSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSystemSettingsQuery = {
	__typename?: 'Query';
	getSystemSettings?: {
		__typename?: 'AdminSystemSetting';
		id: string;
		defaultApproval: boolean;
		defaultMargin: number;
		defaultStripeCheckoutLimit: number;
		defaultInvoiceMinimumThreshold: number;
		defaultProductPaymentMode: PaymentModeEnum;
		defaultSamplePaymentMode: PaymentModeEnum;
		createdAt: string;
		updatedAt: string;
	} | null;
};

export type GetAllVetterEntitiesQueryVariables = Exact<{
	input: GetAllVetterEntityInput;
}>;

export type GetAllVetterEntitiesQuery = {
	__typename?: 'Query';
	getAllVetterEntity: {
		__typename?: 'VetterEntityPage';
		data: Array<{
			__typename?: 'VetterEntity';
			id: string;
			name: string;
			description?: string | null;
			notes?: string | null;
			isActive: boolean;
			createdAt?: string | null;
			primaryContactVetterUserId?: string | null;
			primaryContact?: {
				__typename?: 'VetterUser';
				id: string;
				firstName: string;
				lastName: string;
				phone?: string | null;
				authenticationUser?: {
					__typename?: 'AuthenticationUser';
					id: string;
					email?: string | null;
				} | null;
			} | null;
			vetterUsers?: Array<{
				__typename?: 'VetterUser';
				id: string;
				userId: string;
				firstName: string;
				lastName: string;
			}> | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalPages: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetVetterStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetVetterStatsQuery = {
	__typename?: 'Query';
	getVetterStats: {
		__typename?: 'VetterStats';
		total: number;
		active: number;
		inactive: number;
		teamMembers: number;
	};
};

export type GetVetterEntityQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetVetterEntityQuery = {
	__typename?: 'Query';
	getVetterEntity?: {
		__typename?: 'VetterEntity';
		id: string;
		name: string;
		description?: string | null;
		notes?: string | null;
		isActive: boolean;
		createdAt?: string | null;
		updatedAt?: string | null;
		primaryContactVetterUserId?: string | null;
		primaryContact?: {
			__typename?: 'VetterUser';
			id: string;
			firstName: string;
			lastName: string;
			phone?: string | null;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
			} | null;
		} | null;
		vetterUsers?: Array<{
			__typename?: 'VetterUser';
			id: string;
			firstName: string;
			lastName: string;
			userId: string;
			phone?: string | null;
			notes?: string | null;
			invitedAt?: string | null;
			createdAt?: string | null;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
				lastActive?: string | null;
			} | null;
		}> | null;
		manufacturers?: Array<{
			__typename?: 'Manufacturer';
			id: string;
			name: string;
			country?: string | null;
			description?: string | null;
			website?: string | null;
			logoUrl?: string | null;
			isActive: boolean;
			createdAt?: string | null;
			updatedAt?: string | null;
		}> | null;
	} | null;
};

export type GetVetterJobQueryVariables = Exact<{
	id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetVetterJobQuery = {
	__typename?: 'Query';
	getVetterJob?: {
		__typename?: 'VetterJob';
		id: string;
		email: string;
		quoteName: string;
		stage: VetterJobStage;
		stageLabel: string;
		createdAt?: string | null;
		quoteDeadline?: string | null;
		currency?: string | null;
		note?: string | null;
		submittedAt?: string | null;
		canSubmitPrices: boolean;
		submitPricesBlockedReason?: string | null;
		vetterEntity?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
		items: Array<{
			__typename?: 'VetterJobItem';
			orderQuoteItemId: string;
			productName?: string | null;
			productSku?: string | null;
			productDescription?: string | null;
			productWeight?: number | null;
			deadline?: string | null;
			productDimensions?: {
				__typename?: 'OrderProductDimensions';
				length?: number | null;
				width?: number | null;
				height?: number | null;
				unit: string;
			} | null;
			productSpecifications?: {
				__typename?: 'OrderProductSpecifications';
				material?: string | null;
				secondaryMaterials?: Array<string> | null;
				finish?: string | null;
				textureDescription?: string | null;
				features?: Array<string> | null;
				capacity?: {
					__typename?: 'OrderProductMeasure';
					value: number;
					unit: string;
				} | null;
				colors?: Array<{
					__typename?: 'OrderProductColorSpec';
					name?: string | null;
					code?: string | null;
					pantone?: string | null;
					appliesTo?: string | null;
					finish?: string | null;
					isPrimary?: boolean | null;
				}> | null;
				packaging?: {
					__typename?: 'OrderProductPackaging';
					type?: string | null;
					weight?: number | null;
					weightUnit?: string | null;
					notes?: string | null;
					dimensions?: {
						__typename?: 'OrderProductDimensions';
						length?: number | null;
						width?: number | null;
						height?: number | null;
						unit: string;
					} | null;
				} | null;
				decorations?: Array<{
					__typename?: 'OrderProductDecoration';
					id: string;
					method: OrderProductDecorationMethod;
					methodNote?: string | null;
					placement?: string | null;
					colorCount?: number | null;
					artworkUrl?: string | null;
					notes?: string | null;
					sortOrder?: number | null;
					area?: {
						__typename?: 'OrderProductPrintArea';
						width?: number | null;
						height?: number | null;
						unit: string;
					} | null;
					colors?: Array<{
						__typename?: 'OrderProductColorSpec';
						name?: string | null;
						code?: string | null;
						pantone?: string | null;
						appliesTo?: string | null;
						finish?: string | null;
						isPrimary?: boolean | null;
					}> | null;
				}> | null;
				custom?: Array<{
					__typename?: 'OrderProductCustomSpec';
					id: string;
					label: string;
					value: string;
					unit?: string | null;
					group?: string | null;
					sortOrder?: number | null;
				}> | null;
			} | null;
			productImages?: Array<{
				__typename?: 'OrderQuoteItemProductImage';
				url: string;
				isPrimary?: boolean | null;
				sortOrder?: number | null;
				altText?: string | null;
				caption?: string | null;
				dimensions?: {
					__typename?: 'OrderProductImageDimensions';
					width?: number | null;
					height?: number | null;
					aspectRatio?: string | null;
				} | null;
				crop?: {
					__typename?: 'OrderProductImageCrop';
					x: number;
					y: number;
					width: number;
					height: number;
					zoom?: number | null;
					rotation?: number | null;
					aspectRatio?: string | null;
					unit?: string | null;
				} | null;
			}> | null;
			attachments: Array<{
				__typename?: 'OrderQuoteItemAttachment';
				id: string;
				name: string;
				description?: string | null;
				mimeType: string;
				size: number;
				url: string;
			}>;
			commentThread: {
				__typename?: 'QuoteProductThread';
				id: string;
				commentCount: number;
				unreadCount: number;
				lastCommentAt?: string | null;
			};
			tiers: Array<{
				__typename?: 'VetterJobTier';
				orderQuoteItemQuantityId: string;
				quantity: number;
				deliveryOptions: Array<{
					__typename?: 'VetterJobDeliveryOption';
					id: string;
					label: string;
					isSplit: boolean;
					shippingMethod?: OrderShippingMethod | null;
					quantity: number;
					cost?: {
						__typename?: 'VetterDeliveryCost';
						price: number;
						currency: string;
						deliveryDaysMin?: number | null;
						deliveryDaysMax?: number | null;
					} | null;
					parts: Array<{
						__typename?: 'VetterJobDeliveryOptionPart';
						id: string;
						sequence: number;
						shippingMethod: OrderShippingMethod;
						quantity: number;
						cost?: {
							__typename?: 'VetterDeliveryCost';
							price: number;
							currency: string;
							deliveryDaysMin?: number | null;
							deliveryDaysMax?: number | null;
						} | null;
					}>;
				}>;
				price?: {
					__typename?: 'OrderQuoteVetterPrice';
					id: string;
					baseUnitPrice: number;
					currency: string;
					minProductionDays?: number | null;
					maxProductionDays?: number | null;
					shippingPrices: Array<{
						__typename?: 'VetterShippingPrice';
						shippingMethod: OrderShippingMethod;
						price: number;
						deliveryDaysMin?: number | null;
						deliveryDaysMax?: number | null;
					}>;
				} | null;
			}>;
		}>;
		orderItems: Array<{
			__typename?: 'VetterJobOrderItem';
			id: string;
			orderId: string;
			orderNumber: string;
			productName?: string | null;
			quantity: number;
			status: OrderItemStatus;
			productionStartedAt?: string | null;
			productionCompletedAt?: string | null;
			availableActions: Array<{
				__typename?: 'VetterJobAction';
				key: VetterJobActionKey;
				label: string;
				blockedReason?: string | null;
				requiredFields: Array<string>;
				optionalFields: Array<string>;
			}>;
		}>;
		shipments: Array<{
			__typename?: 'VetterJobShipment';
			id: string;
			orderId: string;
			orderNumber: string;
			sequence: number;
			status: OrderShipmentStatus;
			shippingMethod?: OrderShippingMethod | null;
			carrier?: string | null;
			trackingNumber?: string | null;
			trackingUrl?: string | null;
			shippedAt?: string | null;
			estimatedDeliveryDate?: string | null;
			actualDeliveryDate?: string | null;
			lines: Array<{
				__typename?: 'VetterJobShipmentLine';
				orderItemId: string;
				productName?: string | null;
				quantity: number;
			}>;
			availableActions: Array<{
				__typename?: 'VetterJobAction';
				key: VetterJobActionKey;
				label: string;
				blockedReason?: string | null;
				requiredFields: Array<string>;
				optionalFields: Array<string>;
			}>;
		}>;
	} | null;
};

export type VetterJobActionFieldsFragment = {
	__typename?: 'VetterJobAction';
	key: VetterJobActionKey;
	label: string;
	blockedReason?: string | null;
	requiredFields: Array<string>;
	optionalFields: Array<string>;
};

export type GetMyVetterJobsQueryVariables = Exact<{
	input: GetMyVetterJobsInput;
}>;

export type GetMyVetterJobsQuery = {
	__typename?: 'Query';
	getMyVetterJobs: {
		__typename?: 'VetterJobPage';
		data: Array<{
			__typename?: 'VetterJob';
			id: string;
			quoteName: string;
			quoteDeadline?: string | null;
			stage: VetterJobStage;
			stageLabel: string;
			submittedAt?: string | null;
			createdAt?: string | null;
			unreadCommentCount: number;
			items: Array<{
				__typename?: 'VetterJobItem';
				orderQuoteItemId: string;
				productName?: string | null;
			}>;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalPages: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type VetterDeliveryCostFieldsFragment = {
	__typename?: 'VetterDeliveryCost';
	price: number;
	currency: string;
	deliveryDaysMin?: number | null;
	deliveryDaysMax?: number | null;
};

export type GetMyVetterProfileQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyVetterProfileQuery = {
	__typename?: 'Query';
	getMyVetterProfile?: {
		__typename?: 'VetterUser';
		id: string;
		firstName: string;
		lastName: string;
		vetterEntityId: string;
		vetterEntity?: {
			__typename?: 'VetterEntity';
			id: string;
			name: string;
			description?: string | null;
			primaryContactVetterUserId?: string | null;
		} | null;
		authenticationUser?: {
			__typename?: 'AuthenticationUser';
			id: string;
			email?: string | null;
		} | null;
	} | null;
};

export type GetMyVetterTeamQueryVariables = Exact<{
	input: GetAllVetterUserInput;
}>;

export type GetMyVetterTeamQuery = {
	__typename?: 'Query';
	getAllVetterUser: {
		__typename?: 'VetterUserPage';
		data: Array<{
			__typename?: 'VetterUser';
			id: string;
			firstName: string;
			lastName: string;
			phone?: string | null;
			invitedAt?: string | null;
			createdAt?: string | null;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
				lastActive?: string | null;
			} | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalPages: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type OnNotificationAddedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type OnNotificationAddedSubscription = {
	__typename?: 'Subscription';
	notificationAdded: {
		__typename?: 'Notification';
		id: string;
		type: NotificationType;
		title: string;
		body?: string | null;
		entityType?: string | null;
		entityId?: string | null;
		readAt?: string | null;
		emailSent: boolean;
		createdAt: string;
	};
};

export type OnOrderQuoteActivityAddedSubscriptionVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
	inCurrency?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnOrderQuoteActivityAddedSubscription = {
	__typename?: 'Subscription';
	orderQuoteActivityAdded?: {
		__typename?: 'OrderQuoteActivity';
		id: string;
		action: string;
		message?: string | null;
		actorId?: string | null;
		actorRole?: string | null;
		metadata?: any | null;
		orderQuoteId: string;
		createdAt?: string | null;
		adminUser?: { __typename?: 'AdminUserStub'; firstName: string; lastName: string } | null;
		organizationUser?: {
			__typename?: 'OrganizationUserStub';
			firstName: string;
			lastName: string;
		} | null;
	} | null;
};

export type OnQuoteProductThreadUpdatedSubscriptionVariables = Exact<{
	input: QuoteProductThreadInput;
}>;

export type OnQuoteProductThreadUpdatedSubscription = {
	__typename?: 'Subscription';
	quoteProductThreadUpdated: {
		__typename?: 'QuoteProductThreadEvent';
		kind: QuoteProductThreadEventKind;
		comment: {
			__typename?: 'QuoteProductComment';
			id: string;
			orderQuoteItemId: string;
			vetterEntityId?: string | null;
			body: string;
			isMine: boolean;
			canEdit: boolean;
			canDelete: boolean;
			createdAt?: string | null;
			editedAt?: string | null;
			deletedAt?: string | null;
			author: {
				__typename?: 'QuoteProductCommentAuthor';
				userId: string;
				name: string;
				side: QuoteProductCommentSide;
			};
			mentions: Array<{
				__typename?: 'QuoteProductCommentMention';
				userId: string;
				name: string;
			}>;
			attachments: Array<{
				__typename?: 'QuoteProductCommentAttachment';
				name: string;
				url?: string | null;
				mimeType: string;
				size: number;
			}>;
		};
	};
};

export type OnQuoteProductThreadCountsUpdatedSubscriptionVariables = Exact<{
	orderQuoteId: Scalars['ID']['input'];
}>;

export type OnQuoteProductThreadCountsUpdatedSubscription = {
	__typename?: 'Subscription';
	quoteProductThreadCountsUpdated: {
		__typename?: 'QuoteProductThread';
		id: string;
		kind: QuoteProductThreadKind;
		orderQuoteItemId: string;
		productName?: string | null;
		vetterEntityId?: string | null;
		commentCount: number;
		unreadCount: number;
		lastCommentAt?: string | null;
		vetterEntity?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
	};
};

export type OnVetterJobUpdatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type OnVetterJobUpdatedSubscription = {
	__typename?: 'Subscription';
	vetterJobUpdated: {
		__typename?: 'VetterJobUpdate';
		vetterJobId: string;
		stage: VetterJobStage;
		stageLabel: string;
		unreadCommentCount: number;
		removedAt?: string | null;
	};
};

export const PageInfoFragmentFragmentDoc = gql`
	fragment PageInfoFragment on PageInfo {
		totalPages
		currentPage
		totalCount
		hasNextPage
		hasPreviousPage
	}
`;
export const ResponseErrorFragmentFragmentDoc = gql`
	fragment ResponseErrorFragment on ResponseError {
		message
		code
		field
		details
	}
`;
export const MessageResponseFragmentFragmentDoc = gql`
	fragment MessageResponseFragment on MessageResponse {
		success
		message
		referenceKey
		errors {
			...ResponseErrorFragment
		}
	}
	${ResponseErrorFragmentFragmentDoc}
`;
export const ProductSpecificationsFragmentFragmentDoc = gql`
	fragment ProductSpecificationsFragment on ProductSpecifications {
		material
		secondaryMaterials
		finish
		textureDescription
		features
		capacity {
			value
			unit
		}
		colors {
			name
			code
			pantone
			appliesTo
			finish
			isPrimary
		}
		packaging {
			type
			dimensions {
				length
				width
				height
				unit
			}
			weight
			weightUnit
			notes
		}
		decorations {
			id
			method
			methodNote
			placement
			colorCount
			artworkUrl
			notes
			sortOrder
			area {
				width
				height
				unit
			}
			colors {
				name
				code
				pantone
				appliesTo
				finish
				isPrimary
			}
		}
		custom {
			id
			label
			value
			unit
			group
			sortOrder
		}
	}
`;
export const OrderProductSpecificationsFragmentFragmentDoc = gql`
	fragment OrderProductSpecificationsFragment on OrderProductSpecifications {
		material
		secondaryMaterials
		finish
		textureDescription
		features
		capacity {
			value
			unit
		}
		colors {
			name
			code
			pantone
			appliesTo
			finish
			isPrimary
		}
		packaging {
			type
			dimensions {
				length
				width
				height
				unit
			}
			weight
			weightUnit
			notes
		}
		decorations {
			id
			method
			methodNote
			placement
			colorCount
			artworkUrl
			notes
			sortOrder
			area {
				width
				height
				unit
			}
			colors {
				name
				code
				pantone
				appliesTo
				finish
				isPrimary
			}
		}
		custom {
			id
			label
			value
			unit
			group
			sortOrder
		}
	}
`;
export const OrderQuoteItemProductImageFragmentFragmentDoc = gql`
	fragment OrderQuoteItemProductImageFragment on OrderQuoteItemProductImage {
		url
		isPrimary
		sortOrder
		altText
		caption
		dimensions {
			width
			height
			aspectRatio
		}
		crop {
			x
			y
			width
			height
			zoom
			rotation
			aspectRatio
			unit
		}
	}
`;
export const OrderItemProductImageFragmentFragmentDoc = gql`
	fragment OrderItemProductImageFragment on OrderItemProductImage {
		url
		isPrimary
		sortOrder
		altText
		caption
		dimensions {
			width
			height
			aspectRatio
		}
		crop {
			x
			y
			width
			height
			zoom
			rotation
			aspectRatio
			unit
		}
	}
`;
export const QuoteProductCommentFieldsFragmentDoc = gql`
	fragment QuoteProductCommentFields on QuoteProductComment {
		id
		orderQuoteItemId
		vetterEntityId
		body
		isMine
		canEdit
		canDelete
		createdAt
		editedAt
		deletedAt
		author {
			userId
			name
			side
		}
		mentions {
			userId
			name
		}
		attachments {
			name
			url
			mimeType
			size
		}
	}
`;
export const QuoteProductThreadFieldsFragmentDoc = gql`
	fragment QuoteProductThreadFields on QuoteProductThread {
		id
		kind
		orderQuoteItemId
		productName
		vetterEntityId
		vetterEntity {
			id
			name
		}
		commentCount
		unreadCount
		lastCommentAt
	}
`;
export const BrandPaletteColorFragmentFragmentDoc = gql`
	fragment BrandPaletteColorFragment on BrandColor {
		name
		hex
		usage
		pantone {
			book
			code
			hex
			color {
				bookTitle
				finish
				pageNumberInBook
			}
		}
	}
`;
export const OrderQuoteValueBreakdownFragmentFragmentDoc = gql`
	fragment OrderQuoteValueBreakdownFragment on OrderQuoteValuePoint {
		total
		productsTotal
		deliveryTotal
		samplesTotal
		samplesShippingTotal
		orderQuoteOfferBatchId
		lines {
			orderQuoteOfferId
			orderQuoteItemId
			name
			quantity
			productsTotal
		}
	}
`;
export const OrderQuoteValuePointFragmentFragmentDoc = gql`
	fragment OrderQuoteValuePointFragment on OrderQuoteValuePoint {
		total
		marginAmount
		marginPercentage
		markupPercentage
		orderQuoteOfferBatchId
	}
`;
export const ApplyVetterPricesTierFieldsFragmentDoc = gql`
	fragment ApplyVetterPricesTierFields on ApplyVetterPricesTierState {
		cost(inCurrency: $inCurrency)
		unitPrice(inCurrency: $inCurrency)
		totalPrice(inCurrency: $inCurrency)
		marginUnit(inCurrency: $inCurrency)
		marginPercentage
		minProductionDays
		maxProductionDays
	}
`;
export const ApplyVetterPricesShippingFieldsFragmentDoc = gql`
	fragment ApplyVetterPricesShippingFields on ApplyVetterPricesShippingState {
		price(inCurrency: $inCurrency)
		deliveryDaysMin
		deliveryDaysMax
	}
`;
export const VetterJobActionFieldsFragmentDoc = gql`
	fragment VetterJobActionFields on VetterJobAction {
		key
		label
		blockedReason
		requiredFields
		optionalFields
	}
`;
export const VetterDeliveryCostFieldsFragmentDoc = gql`
	fragment VetterDeliveryCostFields on VetterDeliveryCost {
		price
		currency
		deliveryDaysMin
		deliveryDaysMax
	}
`;
export const AcceptOrderQuoteOffersDocument = gql`
	mutation AcceptOrderQuoteOffers($input: AcceptOrderQuoteOffersInput!) {
		acceptOrderQuoteOffers(input: $input) {
			success
			message
			orderId
			pendingReview
		}
	}
`;
export type AcceptOrderQuoteOffersMutationFn = Apollo.MutationFunction<
	AcceptOrderQuoteOffersMutation,
	AcceptOrderQuoteOffersMutationVariables
>;

/**
 * __useAcceptOrderQuoteOffersMutation__
 *
 * To run a mutation, you first call `useAcceptOrderQuoteOffersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOrderQuoteOffersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptOrderQuoteOffersMutation, { data, loading, error }] = useAcceptOrderQuoteOffersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptOrderQuoteOffersMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AcceptOrderQuoteOffersMutation,
		AcceptOrderQuoteOffersMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AcceptOrderQuoteOffersMutation,
		AcceptOrderQuoteOffersMutationVariables
	>(AcceptOrderQuoteOffersDocument, options);
}
export type AcceptOrderQuoteOffersMutationHookResult = ReturnType<
	typeof useAcceptOrderQuoteOffersMutation
>;
export type AcceptOrderQuoteOffersMutationResult =
	Apollo.MutationResult<AcceptOrderQuoteOffersMutation>;
export type AcceptOrderQuoteOffersMutationOptions = Apollo.BaseMutationOptions<
	AcceptOrderQuoteOffersMutation,
	AcceptOrderQuoteOffersMutationVariables
>;
export const CreateAdminUserDocument = gql`
	mutation CreateAdminUser($input: CreateAdminUserInput!) {
		createAdminUser(input: $input) {
			success
			message
		}
	}
`;
export type CreateAdminUserMutationFn = Apollo.MutationFunction<
	CreateAdminUserMutation,
	CreateAdminUserMutationVariables
>;

/**
 * __useCreateAdminUserMutation__
 *
 * To run a mutation, you first call `useCreateAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminUserMutation, { data, loading, error }] = useCreateAdminUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateAdminUserMutation,
		CreateAdminUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateAdminUserMutation, CreateAdminUserMutationVariables>(
		CreateAdminUserDocument,
		options
	);
}
export type CreateAdminUserMutationHookResult = ReturnType<typeof useCreateAdminUserMutation>;
export type CreateAdminUserMutationResult = Apollo.MutationResult<CreateAdminUserMutation>;
export type CreateAdminUserMutationOptions = Apollo.BaseMutationOptions<
	CreateAdminUserMutation,
	CreateAdminUserMutationVariables
>;
export const UpdateAdminUserDocument = gql`
	mutation UpdateAdminUser($id: ID!, $input: UpdateAdminUserInput!) {
		updateAdminUser(id: $id, input: $input) {
			success
			message
		}
	}
`;
export type UpdateAdminUserMutationFn = Apollo.MutationFunction<
	UpdateAdminUserMutation,
	UpdateAdminUserMutationVariables
>;

/**
 * __useUpdateAdminUserMutation__
 *
 * To run a mutation, you first call `useUpdateAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminUserMutation, { data, loading, error }] = useUpdateAdminUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateAdminUserMutation,
		UpdateAdminUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>(
		UpdateAdminUserDocument,
		options
	);
}
export type UpdateAdminUserMutationHookResult = ReturnType<typeof useUpdateAdminUserMutation>;
export type UpdateAdminUserMutationResult = Apollo.MutationResult<UpdateAdminUserMutation>;
export type UpdateAdminUserMutationOptions = Apollo.BaseMutationOptions<
	UpdateAdminUserMutation,
	UpdateAdminUserMutationVariables
>;
export const DeleteAdminUserDocument = gql`
	mutation DeleteAdminUser($id: ID!) {
		deleteAdminUser(id: $id) {
			success
			message
		}
	}
`;
export type DeleteAdminUserMutationFn = Apollo.MutationFunction<
	DeleteAdminUserMutation,
	DeleteAdminUserMutationVariables
>;

/**
 * __useDeleteAdminUserMutation__
 *
 * To run a mutation, you first call `useDeleteAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminUserMutation, { data, loading, error }] = useDeleteAdminUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdminUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteAdminUserMutation,
		DeleteAdminUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>(
		DeleteAdminUserDocument,
		options
	);
}
export type DeleteAdminUserMutationHookResult = ReturnType<typeof useDeleteAdminUserMutation>;
export type DeleteAdminUserMutationResult = Apollo.MutationResult<DeleteAdminUserMutation>;
export type DeleteAdminUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteAdminUserMutation,
	DeleteAdminUserMutationVariables
>;
export const DeleteManyAdminUserDocument = gql`
	mutation DeleteManyAdminUser($input: DeleteManyInput!) {
		deleteManyAdminUser(input: $input) {
			success
			message
		}
	}
`;
export type DeleteManyAdminUserMutationFn = Apollo.MutationFunction<
	DeleteManyAdminUserMutation,
	DeleteManyAdminUserMutationVariables
>;

/**
 * __useDeleteManyAdminUserMutation__
 *
 * To run a mutation, you first call `useDeleteManyAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyAdminUserMutation, { data, loading, error }] = useDeleteManyAdminUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyAdminUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyAdminUserMutation,
		DeleteManyAdminUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteManyAdminUserMutation, DeleteManyAdminUserMutationVariables>(
		DeleteManyAdminUserDocument,
		options
	);
}
export type DeleteManyAdminUserMutationHookResult = ReturnType<
	typeof useDeleteManyAdminUserMutation
>;
export type DeleteManyAdminUserMutationResult = Apollo.MutationResult<DeleteManyAdminUserMutation>;
export type DeleteManyAdminUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyAdminUserMutation,
	DeleteManyAdminUserMutationVariables
>;
export const LoginDocument = gql`
	mutation Login($input: LoginInput!) {
		login(input: $input) {
			token
			userId
			mfaRequired
			mfaMethod
			role
			supportsBackupCodes
		}
	}
`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(
	baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<
	LoginMutation,
	LoginMutationVariables
>;
export const LoginValidateDocument = gql`
	mutation LoginValidate($input: LoginValidateInput!) {
		loginValidate(input: $input) {
			token
			user {
				id
				role
				language
				email
				vetterUser {
					vetterEntityId
					firstName
					lastName
				}
				organizationUser {
					id
					organizationId
					firstName
					lastName
					organization {
						id
						name
						onboarded
						organizationSetting {
							currency
						}
					}
				}
			}
		}
	}
`;
export type LoginValidateMutationFn = Apollo.MutationFunction<
	LoginValidateMutation,
	LoginValidateMutationVariables
>;

/**
 * __useLoginValidateMutation__
 *
 * To run a mutation, you first call `useLoginValidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginValidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginValidateMutation, { data, loading, error }] = useLoginValidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginValidateMutation(
	baseOptions?: Apollo.MutationHookOptions<LoginValidateMutation, LoginValidateMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LoginValidateMutation, LoginValidateMutationVariables>(
		LoginValidateDocument,
		options
	);
}
export type LoginValidateMutationHookResult = ReturnType<typeof useLoginValidateMutation>;
export type LoginValidateMutationResult = Apollo.MutationResult<LoginValidateMutation>;
export type LoginValidateMutationOptions = Apollo.BaseMutationOptions<
	LoginValidateMutation,
	LoginValidateMutationVariables
>;
export const RefreshTokenDocument = gql`
	mutation RefreshToken {
		refreshToken {
			token
			user {
				id
				role
				language
				email
				vetterUser {
					vetterEntityId
					firstName
					lastName
				}
				organizationUser {
					id
					organizationId
					firstName
					lastName
					organization {
						id
						name
						onboarded
						organizationSetting {
							currency
						}
					}
				}
			}
		}
	}
`;
export type RefreshTokenMutationFn = Apollo.MutationFunction<
	RefreshTokenMutation,
	RefreshTokenMutationVariables
>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshTokenMutation(
	baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(
		RefreshTokenDocument,
		options
	);
}
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<
	RefreshTokenMutation,
	RefreshTokenMutationVariables
>;
export const ValidateAuthenticationTokenDocument = gql`
	mutation ValidateAuthenticationToken($token: String!) {
		validateAuthenticationToken(token: $token) {
			token
			user {
				id
				email
				organizationUser {
					id
					firstName
					lastName
				}
			}
		}
	}
`;
export type ValidateAuthenticationTokenMutationFn = Apollo.MutationFunction<
	ValidateAuthenticationTokenMutation,
	ValidateAuthenticationTokenMutationVariables
>;

/**
 * __useValidateAuthenticationTokenMutation__
 *
 * To run a mutation, you first call `useValidateAuthenticationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateAuthenticationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateAuthenticationTokenMutation, { data, loading, error }] = useValidateAuthenticationTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateAuthenticationTokenMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ValidateAuthenticationTokenMutation,
		ValidateAuthenticationTokenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ValidateAuthenticationTokenMutation,
		ValidateAuthenticationTokenMutationVariables
	>(ValidateAuthenticationTokenDocument, options);
}
export type ValidateAuthenticationTokenMutationHookResult = ReturnType<
	typeof useValidateAuthenticationTokenMutation
>;
export type ValidateAuthenticationTokenMutationResult =
	Apollo.MutationResult<ValidateAuthenticationTokenMutation>;
export type ValidateAuthenticationTokenMutationOptions = Apollo.BaseMutationOptions<
	ValidateAuthenticationTokenMutation,
	ValidateAuthenticationTokenMutationVariables
>;
export const RegisterDocument = gql`
	mutation Register($input: RegisterInput!) {
		register(input: $input) {
			userId
			qrCodeDataURL
		}
	}
`;
export type RegisterMutationFn = Apollo.MutationFunction<
	RegisterMutation,
	RegisterMutationVariables
>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(
	baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(
		RegisterDocument,
		options
	);
}
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<
	RegisterMutation,
	RegisterMutationVariables
>;
export const PasswordResetRequestDocument = gql`
	mutation PasswordResetRequest($input: PasswordResetRequestInput!) {
		passwordResetRequest(input: $input)
	}
`;
export type PasswordResetRequestMutationFn = Apollo.MutationFunction<
	PasswordResetRequestMutation,
	PasswordResetRequestMutationVariables
>;

/**
 * __usePasswordResetRequestMutation__
 *
 * To run a mutation, you first call `usePasswordResetRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetRequestMutation, { data, loading, error }] = usePasswordResetRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasswordResetRequestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PasswordResetRequestMutation,
		PasswordResetRequestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PasswordResetRequestMutation, PasswordResetRequestMutationVariables>(
		PasswordResetRequestDocument,
		options
	);
}
export type PasswordResetRequestMutationHookResult = ReturnType<
	typeof usePasswordResetRequestMutation
>;
export type PasswordResetRequestMutationResult =
	Apollo.MutationResult<PasswordResetRequestMutation>;
export type PasswordResetRequestMutationOptions = Apollo.BaseMutationOptions<
	PasswordResetRequestMutation,
	PasswordResetRequestMutationVariables
>;
export const PasswordResetValidateDocument = gql`
	mutation PasswordResetValidate($input: PasswordResetValidateInput!) {
		passwordResetValidate(input: $input) {
			success
			message
		}
	}
`;
export type PasswordResetValidateMutationFn = Apollo.MutationFunction<
	PasswordResetValidateMutation,
	PasswordResetValidateMutationVariables
>;

/**
 * __usePasswordResetValidateMutation__
 *
 * To run a mutation, you first call `usePasswordResetValidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetValidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetValidateMutation, { data, loading, error }] = usePasswordResetValidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasswordResetValidateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PasswordResetValidateMutation,
		PasswordResetValidateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PasswordResetValidateMutation,
		PasswordResetValidateMutationVariables
	>(PasswordResetValidateDocument, options);
}
export type PasswordResetValidateMutationHookResult = ReturnType<
	typeof usePasswordResetValidateMutation
>;
export type PasswordResetValidateMutationResult =
	Apollo.MutationResult<PasswordResetValidateMutation>;
export type PasswordResetValidateMutationOptions = Apollo.BaseMutationOptions<
	PasswordResetValidateMutation,
	PasswordResetValidateMutationVariables
>;
export const PasswordResetDocument = gql`
	mutation PasswordReset($input: PasswordResetInput!) {
		passwordReset(input: $input) {
			success
			message
		}
	}
`;
export type PasswordResetMutationFn = Apollo.MutationFunction<
	PasswordResetMutation,
	PasswordResetMutationVariables
>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasswordResetMutation(
	baseOptions?: Apollo.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(
		PasswordResetDocument,
		options
	);
}
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<
	PasswordResetMutation,
	PasswordResetMutationVariables
>;
export const ResendPasswordResetRequestDocument = gql`
	mutation ResendPasswordResetRequest($input: PasswordResetRequestInput!) {
		resendPasswordResetRequest(input: $input)
	}
`;
export type ResendPasswordResetRequestMutationFn = Apollo.MutationFunction<
	ResendPasswordResetRequestMutation,
	ResendPasswordResetRequestMutationVariables
>;

/**
 * __useResendPasswordResetRequestMutation__
 *
 * To run a mutation, you first call `useResendPasswordResetRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendPasswordResetRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendPasswordResetRequestMutation, { data, loading, error }] = useResendPasswordResetRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendPasswordResetRequestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ResendPasswordResetRequestMutation,
		ResendPasswordResetRequestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ResendPasswordResetRequestMutation,
		ResendPasswordResetRequestMutationVariables
	>(ResendPasswordResetRequestDocument, options);
}
export type ResendPasswordResetRequestMutationHookResult = ReturnType<
	typeof useResendPasswordResetRequestMutation
>;
export type ResendPasswordResetRequestMutationResult =
	Apollo.MutationResult<ResendPasswordResetRequestMutation>;
export type ResendPasswordResetRequestMutationOptions = Apollo.BaseMutationOptions<
	ResendPasswordResetRequestMutation,
	ResendPasswordResetRequestMutationVariables
>;
export const VerifyAuthenticatorSetupDocument = gql`
	mutation VerifyAuthenticatorSetup($input: VerifyAuthenticatorSetupInput!) {
		verifyAuthenticatorSetup(input: $input) {
			token
			userId
			role
			backupCodes
		}
	}
`;
export type VerifyAuthenticatorSetupMutationFn = Apollo.MutationFunction<
	VerifyAuthenticatorSetupMutation,
	VerifyAuthenticatorSetupMutationVariables
>;

/**
 * __useVerifyAuthenticatorSetupMutation__
 *
 * To run a mutation, you first call `useVerifyAuthenticatorSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAuthenticatorSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAuthenticatorSetupMutation, { data, loading, error }] = useVerifyAuthenticatorSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyAuthenticatorSetupMutation(
	baseOptions?: Apollo.MutationHookOptions<
		VerifyAuthenticatorSetupMutation,
		VerifyAuthenticatorSetupMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		VerifyAuthenticatorSetupMutation,
		VerifyAuthenticatorSetupMutationVariables
	>(VerifyAuthenticatorSetupDocument, options);
}
export type VerifyAuthenticatorSetupMutationHookResult = ReturnType<
	typeof useVerifyAuthenticatorSetupMutation
>;
export type VerifyAuthenticatorSetupMutationResult =
	Apollo.MutationResult<VerifyAuthenticatorSetupMutation>;
export type VerifyAuthenticatorSetupMutationOptions = Apollo.BaseMutationOptions<
	VerifyAuthenticatorSetupMutation,
	VerifyAuthenticatorSetupMutationVariables
>;
export const VerifyEmailMfaDocument = gql`
	mutation VerifyEmailMfa($input: VerifyEmailMfaInput!) {
		verifyEmailMfa(input: $input) {
			token
			role
		}
	}
`;
export type VerifyEmailMfaMutationFn = Apollo.MutationFunction<
	VerifyEmailMfaMutation,
	VerifyEmailMfaMutationVariables
>;

/**
 * __useVerifyEmailMfaMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMfaMutation, { data, loading, error }] = useVerifyEmailMfaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailMfaMutation(
	baseOptions?: Apollo.MutationHookOptions<
		VerifyEmailMfaMutation,
		VerifyEmailMfaMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<VerifyEmailMfaMutation, VerifyEmailMfaMutationVariables>(
		VerifyEmailMfaDocument,
		options
	);
}
export type VerifyEmailMfaMutationHookResult = ReturnType<typeof useVerifyEmailMfaMutation>;
export type VerifyEmailMfaMutationResult = Apollo.MutationResult<VerifyEmailMfaMutation>;
export type VerifyEmailMfaMutationOptions = Apollo.BaseMutationOptions<
	VerifyEmailMfaMutation,
	VerifyEmailMfaMutationVariables
>;
export const ResendEmailMfaCodeDocument = gql`
	mutation ResendEmailMfaCode($userId: ID!) {
		resendEmailMfaCode(userId: $userId) {
			message
			success
		}
	}
`;
export type ResendEmailMfaCodeMutationFn = Apollo.MutationFunction<
	ResendEmailMfaCodeMutation,
	ResendEmailMfaCodeMutationVariables
>;

/**
 * __useResendEmailMfaCodeMutation__
 *
 * To run a mutation, you first call `useResendEmailMfaCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailMfaCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailMfaCodeMutation, { data, loading, error }] = useResendEmailMfaCodeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResendEmailMfaCodeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ResendEmailMfaCodeMutation,
		ResendEmailMfaCodeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ResendEmailMfaCodeMutation, ResendEmailMfaCodeMutationVariables>(
		ResendEmailMfaCodeDocument,
		options
	);
}
export type ResendEmailMfaCodeMutationHookResult = ReturnType<typeof useResendEmailMfaCodeMutation>;
export type ResendEmailMfaCodeMutationResult = Apollo.MutationResult<ResendEmailMfaCodeMutation>;
export type ResendEmailMfaCodeMutationOptions = Apollo.BaseMutationOptions<
	ResendEmailMfaCodeMutation,
	ResendEmailMfaCodeMutationVariables
>;
export const VerifyAuthenticatorMfaDocument = gql`
	mutation VerifyAuthenticatorMfa($input: VerifyAuthenticatorMfaInput!) {
		verifyAuthenticatorMfa(input: $input) {
			token
			role
		}
	}
`;
export type VerifyAuthenticatorMfaMutationFn = Apollo.MutationFunction<
	VerifyAuthenticatorMfaMutation,
	VerifyAuthenticatorMfaMutationVariables
>;

/**
 * __useVerifyAuthenticatorMfaMutation__
 *
 * To run a mutation, you first call `useVerifyAuthenticatorMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAuthenticatorMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAuthenticatorMfaMutation, { data, loading, error }] = useVerifyAuthenticatorMfaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyAuthenticatorMfaMutation(
	baseOptions?: Apollo.MutationHookOptions<
		VerifyAuthenticatorMfaMutation,
		VerifyAuthenticatorMfaMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		VerifyAuthenticatorMfaMutation,
		VerifyAuthenticatorMfaMutationVariables
	>(VerifyAuthenticatorMfaDocument, options);
}
export type VerifyAuthenticatorMfaMutationHookResult = ReturnType<
	typeof useVerifyAuthenticatorMfaMutation
>;
export type VerifyAuthenticatorMfaMutationResult =
	Apollo.MutationResult<VerifyAuthenticatorMfaMutation>;
export type VerifyAuthenticatorMfaMutationOptions = Apollo.BaseMutationOptions<
	VerifyAuthenticatorMfaMutation,
	VerifyAuthenticatorMfaMutationVariables
>;
export const LogoutDocument = gql`
	mutation Logout($input: LogoutInput!) {
		logout(input: $input) {
			success
			message
		}
	}
`;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogoutMutation(
	baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<
	LogoutMutation,
	LogoutMutationVariables
>;
export const CreateOrganizationSignupDocument = gql`
	mutation CreateOrganizationSignup($input: OrganizationSignupInput!) {
		createOrganizationSignup(input: $input) {
			userId
			qrCodeDataURL
		}
	}
`;
export type CreateOrganizationSignupMutationFn = Apollo.MutationFunction<
	CreateOrganizationSignupMutation,
	CreateOrganizationSignupMutationVariables
>;

/**
 * __useCreateOrganizationSignupMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationSignupMutation, { data, loading, error }] = useCreateOrganizationSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationSignupMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationSignupMutation,
		CreateOrganizationSignupMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationSignupMutation,
		CreateOrganizationSignupMutationVariables
	>(CreateOrganizationSignupDocument, options);
}
export type CreateOrganizationSignupMutationHookResult = ReturnType<
	typeof useCreateOrganizationSignupMutation
>;
export type CreateOrganizationSignupMutationResult =
	Apollo.MutationResult<CreateOrganizationSignupMutation>;
export type CreateOrganizationSignupMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationSignupMutation,
	CreateOrganizationSignupMutationVariables
>;
export const SwitchOrganizationDocument = gql`
	mutation SwitchOrganization($organizationId: ID!) {
		switchOrganization(organizationId: $organizationId) {
			token
		}
	}
`;
export type SwitchOrganizationMutationFn = Apollo.MutationFunction<
	SwitchOrganizationMutation,
	SwitchOrganizationMutationVariables
>;

/**
 * __useSwitchOrganizationMutation__
 *
 * To run a mutation, you first call `useSwitchOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchOrganizationMutation, { data, loading, error }] = useSwitchOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSwitchOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SwitchOrganizationMutation,
		SwitchOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SwitchOrganizationMutation, SwitchOrganizationMutationVariables>(
		SwitchOrganizationDocument,
		options
	);
}
export type SwitchOrganizationMutationHookResult = ReturnType<typeof useSwitchOrganizationMutation>;
export type SwitchOrganizationMutationResult = Apollo.MutationResult<SwitchOrganizationMutation>;
export type SwitchOrganizationMutationOptions = Apollo.BaseMutationOptions<
	SwitchOrganizationMutation,
	SwitchOrganizationMutationVariables
>;
export const CreateBrandDocument = gql`
	mutation CreateBrand($input: BrandCreateInput!) {
		createBrand(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateBrandMutationFn = Apollo.MutationFunction<
	CreateBrandMutation,
	CreateBrandMutationVariables
>;

/**
 * __useCreateBrandMutation__
 *
 * To run a mutation, you first call `useCreateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandMutation, { data, loading, error }] = useCreateBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBrandMutation(
	baseOptions?: Apollo.MutationHookOptions<CreateBrandMutation, CreateBrandMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateBrandMutation, CreateBrandMutationVariables>(
		CreateBrandDocument,
		options
	);
}
export type CreateBrandMutationHookResult = ReturnType<typeof useCreateBrandMutation>;
export type CreateBrandMutationResult = Apollo.MutationResult<CreateBrandMutation>;
export type CreateBrandMutationOptions = Apollo.BaseMutationOptions<
	CreateBrandMutation,
	CreateBrandMutationVariables
>;
export const UpdateBrandDocument = gql`
	mutation UpdateBrand($input: BrandUpdateInput!) {
		updateBrand(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateBrandMutationFn = Apollo.MutationFunction<
	UpdateBrandMutation,
	UpdateBrandMutationVariables
>;

/**
 * __useUpdateBrandMutation__
 *
 * To run a mutation, you first call `useUpdateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandMutation, { data, loading, error }] = useUpdateBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrandMutation(
	baseOptions?: Apollo.MutationHookOptions<UpdateBrandMutation, UpdateBrandMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateBrandMutation, UpdateBrandMutationVariables>(
		UpdateBrandDocument,
		options
	);
}
export type UpdateBrandMutationHookResult = ReturnType<typeof useUpdateBrandMutation>;
export type UpdateBrandMutationResult = Apollo.MutationResult<UpdateBrandMutation>;
export type UpdateBrandMutationOptions = Apollo.BaseMutationOptions<
	UpdateBrandMutation,
	UpdateBrandMutationVariables
>;
export const DeleteBrandDocument = gql`
	mutation DeleteBrand($input: DeleteInput!) {
		deleteBrand(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteBrandMutationFn = Apollo.MutationFunction<
	DeleteBrandMutation,
	DeleteBrandMutationVariables
>;

/**
 * __useDeleteBrandMutation__
 *
 * To run a mutation, you first call `useDeleteBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandMutation, { data, loading, error }] = useDeleteBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBrandMutation(
	baseOptions?: Apollo.MutationHookOptions<DeleteBrandMutation, DeleteBrandMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteBrandMutation, DeleteBrandMutationVariables>(
		DeleteBrandDocument,
		options
	);
}
export type DeleteBrandMutationHookResult = ReturnType<typeof useDeleteBrandMutation>;
export type DeleteBrandMutationResult = Apollo.MutationResult<DeleteBrandMutation>;
export type DeleteBrandMutationOptions = Apollo.BaseMutationOptions<
	DeleteBrandMutation,
	DeleteBrandMutationVariables
>;
export const GenerateBrandFileUploadUrlDocument = gql`
	mutation GenerateBrandFileUploadUrl($input: BrandFileUploadInput!) {
		generateBrandFileUploadUrl(input: $input) {
			success
			message
			uploadUrl
			blobUrl
			fileId
			expiresAt
			errors {
				message
				field
				code
			}
		}
	}
`;
export type GenerateBrandFileUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateBrandFileUploadUrlMutation,
	GenerateBrandFileUploadUrlMutationVariables
>;

/**
 * __useGenerateBrandFileUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateBrandFileUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBrandFileUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBrandFileUploadUrlMutation, { data, loading, error }] = useGenerateBrandFileUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateBrandFileUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateBrandFileUploadUrlMutation,
		GenerateBrandFileUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateBrandFileUploadUrlMutation,
		GenerateBrandFileUploadUrlMutationVariables
	>(GenerateBrandFileUploadUrlDocument, options);
}
export type GenerateBrandFileUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateBrandFileUploadUrlMutation
>;
export type GenerateBrandFileUploadUrlMutationResult =
	Apollo.MutationResult<GenerateBrandFileUploadUrlMutation>;
export type GenerateBrandFileUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateBrandFileUploadUrlMutation,
	GenerateBrandFileUploadUrlMutationVariables
>;
export const ConfirmBrandFileUploadDocument = gql`
	mutation ConfirmBrandFileUpload($input: ConfirmBrandFileUploadInput!) {
		confirmBrandFileUpload(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type ConfirmBrandFileUploadMutationFn = Apollo.MutationFunction<
	ConfirmBrandFileUploadMutation,
	ConfirmBrandFileUploadMutationVariables
>;

/**
 * __useConfirmBrandFileUploadMutation__
 *
 * To run a mutation, you first call `useConfirmBrandFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmBrandFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmBrandFileUploadMutation, { data, loading, error }] = useConfirmBrandFileUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmBrandFileUploadMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmBrandFileUploadMutation,
		ConfirmBrandFileUploadMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmBrandFileUploadMutation,
		ConfirmBrandFileUploadMutationVariables
	>(ConfirmBrandFileUploadDocument, options);
}
export type ConfirmBrandFileUploadMutationHookResult = ReturnType<
	typeof useConfirmBrandFileUploadMutation
>;
export type ConfirmBrandFileUploadMutationResult =
	Apollo.MutationResult<ConfirmBrandFileUploadMutation>;
export type ConfirmBrandFileUploadMutationOptions = Apollo.BaseMutationOptions<
	ConfirmBrandFileUploadMutation,
	ConfirmBrandFileUploadMutationVariables
>;
export const GenerateBrandFontUploadUrlDocument = gql`
	mutation GenerateBrandFontUploadUrl($input: FontFileUploadInput!) {
		generateBrandFontUploadUrl(input: $input) {
			success
			message
			uploadUrl
			blobUrl
			fileId
			expiresAt
			errors {
				message
				field
				code
			}
		}
	}
`;
export type GenerateBrandFontUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateBrandFontUploadUrlMutation,
	GenerateBrandFontUploadUrlMutationVariables
>;

/**
 * __useGenerateBrandFontUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateBrandFontUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBrandFontUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBrandFontUploadUrlMutation, { data, loading, error }] = useGenerateBrandFontUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateBrandFontUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateBrandFontUploadUrlMutation,
		GenerateBrandFontUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateBrandFontUploadUrlMutation,
		GenerateBrandFontUploadUrlMutationVariables
	>(GenerateBrandFontUploadUrlDocument, options);
}
export type GenerateBrandFontUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateBrandFontUploadUrlMutation
>;
export type GenerateBrandFontUploadUrlMutationResult =
	Apollo.MutationResult<GenerateBrandFontUploadUrlMutation>;
export type GenerateBrandFontUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateBrandFontUploadUrlMutation,
	GenerateBrandFontUploadUrlMutationVariables
>;
export const ConfirmBrandFontUploadDocument = gql`
	mutation ConfirmBrandFontUpload($input: ConfirmBrandFontUploadInput!) {
		confirmBrandFontUpload(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type ConfirmBrandFontUploadMutationFn = Apollo.MutationFunction<
	ConfirmBrandFontUploadMutation,
	ConfirmBrandFontUploadMutationVariables
>;

/**
 * __useConfirmBrandFontUploadMutation__
 *
 * To run a mutation, you first call `useConfirmBrandFontUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmBrandFontUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmBrandFontUploadMutation, { data, loading, error }] = useConfirmBrandFontUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmBrandFontUploadMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmBrandFontUploadMutation,
		ConfirmBrandFontUploadMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmBrandFontUploadMutation,
		ConfirmBrandFontUploadMutationVariables
	>(ConfirmBrandFontUploadDocument, options);
}
export type ConfirmBrandFontUploadMutationHookResult = ReturnType<
	typeof useConfirmBrandFontUploadMutation
>;
export type ConfirmBrandFontUploadMutationResult =
	Apollo.MutationResult<ConfirmBrandFontUploadMutation>;
export type ConfirmBrandFontUploadMutationOptions = Apollo.BaseMutationOptions<
	ConfirmBrandFontUploadMutation,
	ConfirmBrandFontUploadMutationVariables
>;
export const DeleteBrandFontDocument = gql`
	mutation DeleteBrandFont($brandId: ID!, $fontId: ID!) {
		deleteBrandFont(brandId: $brandId, fontId: $fontId) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteBrandFontMutationFn = Apollo.MutationFunction<
	DeleteBrandFontMutation,
	DeleteBrandFontMutationVariables
>;

/**
 * __useDeleteBrandFontMutation__
 *
 * To run a mutation, you first call `useDeleteBrandFontMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandFontMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandFontMutation, { data, loading, error }] = useDeleteBrandFontMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      fontId: // value for 'fontId'
 *   },
 * });
 */
export function useDeleteBrandFontMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteBrandFontMutation,
		DeleteBrandFontMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteBrandFontMutation, DeleteBrandFontMutationVariables>(
		DeleteBrandFontDocument,
		options
	);
}
export type DeleteBrandFontMutationHookResult = ReturnType<typeof useDeleteBrandFontMutation>;
export type DeleteBrandFontMutationResult = Apollo.MutationResult<DeleteBrandFontMutation>;
export type DeleteBrandFontMutationOptions = Apollo.BaseMutationOptions<
	DeleteBrandFontMutation,
	DeleteBrandFontMutationVariables
>;
export const DeleteBrandFileDocument = gql`
	mutation DeleteBrandFile($brandId: ID!, $fileId: ID!) {
		deleteBrandFile(brandId: $brandId, fileId: $fileId) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteBrandFileMutationFn = Apollo.MutationFunction<
	DeleteBrandFileMutation,
	DeleteBrandFileMutationVariables
>;

/**
 * __useDeleteBrandFileMutation__
 *
 * To run a mutation, you first call `useDeleteBrandFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandFileMutation, { data, loading, error }] = useDeleteBrandFileMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteBrandFileMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteBrandFileMutation,
		DeleteBrandFileMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteBrandFileMutation, DeleteBrandFileMutationVariables>(
		DeleteBrandFileDocument,
		options
	);
}
export type DeleteBrandFileMutationHookResult = ReturnType<typeof useDeleteBrandFileMutation>;
export type DeleteBrandFileMutationResult = Apollo.MutationResult<DeleteBrandFileMutation>;
export type DeleteBrandFileMutationOptions = Apollo.BaseMutationOptions<
	DeleteBrandFileMutation,
	DeleteBrandFileMutationVariables
>;
export const CloseOrderQuoteDocument = gql`
	mutation CloseOrderQuote($id: ID!) {
		closeOrderQuote(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CloseOrderQuoteMutationFn = Apollo.MutationFunction<
	CloseOrderQuoteMutation,
	CloseOrderQuoteMutationVariables
>;

/**
 * __useCloseOrderQuoteMutation__
 *
 * To run a mutation, you first call `useCloseOrderQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseOrderQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeOrderQuoteMutation, { data, loading, error }] = useCloseOrderQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseOrderQuoteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CloseOrderQuoteMutation,
		CloseOrderQuoteMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CloseOrderQuoteMutation, CloseOrderQuoteMutationVariables>(
		CloseOrderQuoteDocument,
		options
	);
}
export type CloseOrderQuoteMutationHookResult = ReturnType<typeof useCloseOrderQuoteMutation>;
export type CloseOrderQuoteMutationResult = Apollo.MutationResult<CloseOrderQuoteMutation>;
export type CloseOrderQuoteMutationOptions = Apollo.BaseMutationOptions<
	CloseOrderQuoteMutation,
	CloseOrderQuoteMutationVariables
>;
export const DuplicateOrderQuoteOfferBatchDocument = gql`
	mutation DuplicateOrderQuoteOfferBatch($id: ID!) {
		duplicateOrderQuoteOfferBatch(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DuplicateOrderQuoteOfferBatchMutationFn = Apollo.MutationFunction<
	DuplicateOrderQuoteOfferBatchMutation,
	DuplicateOrderQuoteOfferBatchMutationVariables
>;

/**
 * __useDuplicateOrderQuoteOfferBatchMutation__
 *
 * To run a mutation, you first call `useDuplicateOrderQuoteOfferBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateOrderQuoteOfferBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateOrderQuoteOfferBatchMutation, { data, loading, error }] = useDuplicateOrderQuoteOfferBatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateOrderQuoteOfferBatchMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DuplicateOrderQuoteOfferBatchMutation,
		DuplicateOrderQuoteOfferBatchMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DuplicateOrderQuoteOfferBatchMutation,
		DuplicateOrderQuoteOfferBatchMutationVariables
	>(DuplicateOrderQuoteOfferBatchDocument, options);
}
export type DuplicateOrderQuoteOfferBatchMutationHookResult = ReturnType<
	typeof useDuplicateOrderQuoteOfferBatchMutation
>;
export type DuplicateOrderQuoteOfferBatchMutationResult =
	Apollo.MutationResult<DuplicateOrderQuoteOfferBatchMutation>;
export type DuplicateOrderQuoteOfferBatchMutationOptions = Apollo.BaseMutationOptions<
	DuplicateOrderQuoteOfferBatchMutation,
	DuplicateOrderQuoteOfferBatchMutationVariables
>;
export const RequestEarlyAccessDocument = gql`
	mutation RequestEarlyAccess($input: RequestEarlyAccessInput!) {
		requestEarlyAccess(input: $input) {
			success
			message
		}
	}
`;
export type RequestEarlyAccessMutationFn = Apollo.MutationFunction<
	RequestEarlyAccessMutation,
	RequestEarlyAccessMutationVariables
>;

/**
 * __useRequestEarlyAccessMutation__
 *
 * To run a mutation, you first call `useRequestEarlyAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEarlyAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEarlyAccessMutation, { data, loading, error }] = useRequestEarlyAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestEarlyAccessMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RequestEarlyAccessMutation,
		RequestEarlyAccessMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RequestEarlyAccessMutation, RequestEarlyAccessMutationVariables>(
		RequestEarlyAccessDocument,
		options
	);
}
export type RequestEarlyAccessMutationHookResult = ReturnType<typeof useRequestEarlyAccessMutation>;
export type RequestEarlyAccessMutationResult = Apollo.MutationResult<RequestEarlyAccessMutation>;
export type RequestEarlyAccessMutationOptions = Apollo.BaseMutationOptions<
	RequestEarlyAccessMutation,
	RequestEarlyAccessMutationVariables
>;
export const ApproveEarlyAccessRequestDocument = gql`
	mutation ApproveEarlyAccessRequest($input: ApproveEarlyAccessRequestInput!) {
		approveEarlyAccessRequest(input: $input) {
			inviteToken
			message
		}
	}
`;
export type ApproveEarlyAccessRequestMutationFn = Apollo.MutationFunction<
	ApproveEarlyAccessRequestMutation,
	ApproveEarlyAccessRequestMutationVariables
>;

/**
 * __useApproveEarlyAccessRequestMutation__
 *
 * To run a mutation, you first call `useApproveEarlyAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveEarlyAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveEarlyAccessRequestMutation, { data, loading, error }] = useApproveEarlyAccessRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveEarlyAccessRequestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ApproveEarlyAccessRequestMutation,
		ApproveEarlyAccessRequestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ApproveEarlyAccessRequestMutation,
		ApproveEarlyAccessRequestMutationVariables
	>(ApproveEarlyAccessRequestDocument, options);
}
export type ApproveEarlyAccessRequestMutationHookResult = ReturnType<
	typeof useApproveEarlyAccessRequestMutation
>;
export type ApproveEarlyAccessRequestMutationResult =
	Apollo.MutationResult<ApproveEarlyAccessRequestMutation>;
export type ApproveEarlyAccessRequestMutationOptions = Apollo.BaseMutationOptions<
	ApproveEarlyAccessRequestMutation,
	ApproveEarlyAccessRequestMutationVariables
>;
export const RejectEarlyAccessRequestDocument = gql`
	mutation RejectEarlyAccessRequest($requestId: ID!) {
		rejectEarlyAccessRequest(requestId: $requestId) {
			success
			message
		}
	}
`;
export type RejectEarlyAccessRequestMutationFn = Apollo.MutationFunction<
	RejectEarlyAccessRequestMutation,
	RejectEarlyAccessRequestMutationVariables
>;

/**
 * __useRejectEarlyAccessRequestMutation__
 *
 * To run a mutation, you first call `useRejectEarlyAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectEarlyAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectEarlyAccessRequestMutation, { data, loading, error }] = useRejectEarlyAccessRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useRejectEarlyAccessRequestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RejectEarlyAccessRequestMutation,
		RejectEarlyAccessRequestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RejectEarlyAccessRequestMutation,
		RejectEarlyAccessRequestMutationVariables
	>(RejectEarlyAccessRequestDocument, options);
}
export type RejectEarlyAccessRequestMutationHookResult = ReturnType<
	typeof useRejectEarlyAccessRequestMutation
>;
export type RejectEarlyAccessRequestMutationResult =
	Apollo.MutationResult<RejectEarlyAccessRequestMutation>;
export type RejectEarlyAccessRequestMutationOptions = Apollo.BaseMutationOptions<
	RejectEarlyAccessRequestMutation,
	RejectEarlyAccessRequestMutationVariables
>;
export const GenerateOfferEconomicQuotePdfDocument = gql`
	mutation GenerateOfferEconomicQuotePdf($input: GenerateOfferEconomicQuotePdfInput!) {
		generateOfferEconomicQuotePdf(input: $input) {
			success
			message
			pdfUrl
			economicQuoteNumber
		}
	}
`;
export type GenerateOfferEconomicQuotePdfMutationFn = Apollo.MutationFunction<
	GenerateOfferEconomicQuotePdfMutation,
	GenerateOfferEconomicQuotePdfMutationVariables
>;

/**
 * __useGenerateOfferEconomicQuotePdfMutation__
 *
 * To run a mutation, you first call `useGenerateOfferEconomicQuotePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOfferEconomicQuotePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOfferEconomicQuotePdfMutation, { data, loading, error }] = useGenerateOfferEconomicQuotePdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateOfferEconomicQuotePdfMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateOfferEconomicQuotePdfMutation,
		GenerateOfferEconomicQuotePdfMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateOfferEconomicQuotePdfMutation,
		GenerateOfferEconomicQuotePdfMutationVariables
	>(GenerateOfferEconomicQuotePdfDocument, options);
}
export type GenerateOfferEconomicQuotePdfMutationHookResult = ReturnType<
	typeof useGenerateOfferEconomicQuotePdfMutation
>;
export type GenerateOfferEconomicQuotePdfMutationResult =
	Apollo.MutationResult<GenerateOfferEconomicQuotePdfMutation>;
export type GenerateOfferEconomicQuotePdfMutationOptions = Apollo.BaseMutationOptions<
	GenerateOfferEconomicQuotePdfMutation,
	GenerateOfferEconomicQuotePdfMutationVariables
>;
export const RequestGuestQuoteAccessCodeDocument = gql`
	mutation RequestGuestQuoteAccessCode($input: RequestGuestQuoteAccessCodeInput!) {
		requestGuestQuoteAccessCode(input: $input) {
			...MessageResponseFragment
			messageKey
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RequestGuestQuoteAccessCodeMutationFn = Apollo.MutationFunction<
	RequestGuestQuoteAccessCodeMutation,
	RequestGuestQuoteAccessCodeMutationVariables
>;

/**
 * __useRequestGuestQuoteAccessCodeMutation__
 *
 * To run a mutation, you first call `useRequestGuestQuoteAccessCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestGuestQuoteAccessCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestGuestQuoteAccessCodeMutation, { data, loading, error }] = useRequestGuestQuoteAccessCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestGuestQuoteAccessCodeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RequestGuestQuoteAccessCodeMutation,
		RequestGuestQuoteAccessCodeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RequestGuestQuoteAccessCodeMutation,
		RequestGuestQuoteAccessCodeMutationVariables
	>(RequestGuestQuoteAccessCodeDocument, options);
}
export type RequestGuestQuoteAccessCodeMutationHookResult = ReturnType<
	typeof useRequestGuestQuoteAccessCodeMutation
>;
export type RequestGuestQuoteAccessCodeMutationResult =
	Apollo.MutationResult<RequestGuestQuoteAccessCodeMutation>;
export type RequestGuestQuoteAccessCodeMutationOptions = Apollo.BaseMutationOptions<
	RequestGuestQuoteAccessCodeMutation,
	RequestGuestQuoteAccessCodeMutationVariables
>;
export const GuestQuoteLoginDocument = gql`
	mutation GuestQuoteLogin($input: GuestQuoteLoginInput!) {
		guestQuoteLogin(input: $input) {
			success
			message
			token
			orderQuoteId
		}
	}
`;
export type GuestQuoteLoginMutationFn = Apollo.MutationFunction<
	GuestQuoteLoginMutation,
	GuestQuoteLoginMutationVariables
>;

/**
 * __useGuestQuoteLoginMutation__
 *
 * To run a mutation, you first call `useGuestQuoteLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuestQuoteLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guestQuoteLoginMutation, { data, loading, error }] = useGuestQuoteLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGuestQuoteLoginMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GuestQuoteLoginMutation,
		GuestQuoteLoginMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<GuestQuoteLoginMutation, GuestQuoteLoginMutationVariables>(
		GuestQuoteLoginDocument,
		options
	);
}
export type GuestQuoteLoginMutationHookResult = ReturnType<typeof useGuestQuoteLoginMutation>;
export type GuestQuoteLoginMutationResult = Apollo.MutationResult<GuestQuoteLoginMutation>;
export type GuestQuoteLoginMutationOptions = Apollo.BaseMutationOptions<
	GuestQuoteLoginMutation,
	GuestQuoteLoginMutationVariables
>;
export const GuestQuotePreviewLoginDocument = gql`
	mutation GuestQuotePreviewLogin($input: GuestQuotePreviewLoginInput!) {
		guestQuotePreviewLogin(input: $input) {
			success
			message
			token
			orderQuoteId
		}
	}
`;
export type GuestQuotePreviewLoginMutationFn = Apollo.MutationFunction<
	GuestQuotePreviewLoginMutation,
	GuestQuotePreviewLoginMutationVariables
>;

/**
 * __useGuestQuotePreviewLoginMutation__
 *
 * To run a mutation, you first call `useGuestQuotePreviewLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuestQuotePreviewLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guestQuotePreviewLoginMutation, { data, loading, error }] = useGuestQuotePreviewLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGuestQuotePreviewLoginMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GuestQuotePreviewLoginMutation,
		GuestQuotePreviewLoginMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GuestQuotePreviewLoginMutation,
		GuestQuotePreviewLoginMutationVariables
	>(GuestQuotePreviewLoginDocument, options);
}
export type GuestQuotePreviewLoginMutationHookResult = ReturnType<
	typeof useGuestQuotePreviewLoginMutation
>;
export type GuestQuotePreviewLoginMutationResult =
	Apollo.MutationResult<GuestQuotePreviewLoginMutation>;
export type GuestQuotePreviewLoginMutationOptions = Apollo.BaseMutationOptions<
	GuestQuotePreviewLoginMutation,
	GuestQuotePreviewLoginMutationVariables
>;
export const CreateManufacturerDocument = gql`
	mutation CreateManufacturer($input: ManufacturerCreateInput!) {
		createManufacturer(input: $input) {
			success
			message
		}
	}
`;
export type CreateManufacturerMutationFn = Apollo.MutationFunction<
	CreateManufacturerMutation,
	CreateManufacturerMutationVariables
>;

/**
 * __useCreateManufacturerMutation__
 *
 * To run a mutation, you first call `useCreateManufacturerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManufacturerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManufacturerMutation, { data, loading, error }] = useCreateManufacturerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManufacturerMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateManufacturerMutation,
		CreateManufacturerMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateManufacturerMutation, CreateManufacturerMutationVariables>(
		CreateManufacturerDocument,
		options
	);
}
export type CreateManufacturerMutationHookResult = ReturnType<typeof useCreateManufacturerMutation>;
export type CreateManufacturerMutationResult = Apollo.MutationResult<CreateManufacturerMutation>;
export type CreateManufacturerMutationOptions = Apollo.BaseMutationOptions<
	CreateManufacturerMutation,
	CreateManufacturerMutationVariables
>;
export const UpdateManufacturerDocument = gql`
	mutation UpdateManufacturer($input: ManufacturerUpdateInput!) {
		updateManufacturer(input: $input) {
			success
			message
		}
	}
`;
export type UpdateManufacturerMutationFn = Apollo.MutationFunction<
	UpdateManufacturerMutation,
	UpdateManufacturerMutationVariables
>;

/**
 * __useUpdateManufacturerMutation__
 *
 * To run a mutation, you first call `useUpdateManufacturerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManufacturerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManufacturerMutation, { data, loading, error }] = useUpdateManufacturerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateManufacturerMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateManufacturerMutation,
		UpdateManufacturerMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateManufacturerMutation, UpdateManufacturerMutationVariables>(
		UpdateManufacturerDocument,
		options
	);
}
export type UpdateManufacturerMutationHookResult = ReturnType<typeof useUpdateManufacturerMutation>;
export type UpdateManufacturerMutationResult = Apollo.MutationResult<UpdateManufacturerMutation>;
export type UpdateManufacturerMutationOptions = Apollo.BaseMutationOptions<
	UpdateManufacturerMutation,
	UpdateManufacturerMutationVariables
>;
export const DeleteManufacturerDocument = gql`
	mutation DeleteManufacturer($input: DeleteInput!) {
		deleteManufacturer(input: $input) {
			success
			message
		}
	}
`;
export type DeleteManufacturerMutationFn = Apollo.MutationFunction<
	DeleteManufacturerMutation,
	DeleteManufacturerMutationVariables
>;

/**
 * __useDeleteManufacturerMutation__
 *
 * To run a mutation, you first call `useDeleteManufacturerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManufacturerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManufacturerMutation, { data, loading, error }] = useDeleteManufacturerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManufacturerMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManufacturerMutation,
		DeleteManufacturerMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteManufacturerMutation, DeleteManufacturerMutationVariables>(
		DeleteManufacturerDocument,
		options
	);
}
export type DeleteManufacturerMutationHookResult = ReturnType<typeof useDeleteManufacturerMutation>;
export type DeleteManufacturerMutationResult = Apollo.MutationResult<DeleteManufacturerMutation>;
export type DeleteManufacturerMutationOptions = Apollo.BaseMutationOptions<
	DeleteManufacturerMutation,
	DeleteManufacturerMutationVariables
>;
export const DeleteManyManufacturersDocument = gql`
	mutation DeleteManyManufacturers($input: DeleteManyInput!) {
		deleteManyManufacturer(input: $input) {
			success
			message
		}
	}
`;
export type DeleteManyManufacturersMutationFn = Apollo.MutationFunction<
	DeleteManyManufacturersMutation,
	DeleteManyManufacturersMutationVariables
>;

/**
 * __useDeleteManyManufacturersMutation__
 *
 * To run a mutation, you first call `useDeleteManyManufacturersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyManufacturersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyManufacturersMutation, { data, loading, error }] = useDeleteManyManufacturersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyManufacturersMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyManufacturersMutation,
		DeleteManyManufacturersMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteManyManufacturersMutation,
		DeleteManyManufacturersMutationVariables
	>(DeleteManyManufacturersDocument, options);
}
export type DeleteManyManufacturersMutationHookResult = ReturnType<
	typeof useDeleteManyManufacturersMutation
>;
export type DeleteManyManufacturersMutationResult =
	Apollo.MutationResult<DeleteManyManufacturersMutation>;
export type DeleteManyManufacturersMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyManufacturersMutation,
	DeleteManyManufacturersMutationVariables
>;
export const SetNotificationSettingDocument = gql`
	mutation SetNotificationSetting($input: SetNotificationSettingInput!) {
		setNotificationSetting(input: $input) {
			success
			message
		}
	}
`;
export type SetNotificationSettingMutationFn = Apollo.MutationFunction<
	SetNotificationSettingMutation,
	SetNotificationSettingMutationVariables
>;

/**
 * __useSetNotificationSettingMutation__
 *
 * To run a mutation, you first call `useSetNotificationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotificationSettingMutation, { data, loading, error }] = useSetNotificationSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetNotificationSettingMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetNotificationSettingMutation,
		SetNotificationSettingMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SetNotificationSettingMutation,
		SetNotificationSettingMutationVariables
	>(SetNotificationSettingDocument, options);
}
export type SetNotificationSettingMutationHookResult = ReturnType<
	typeof useSetNotificationSettingMutation
>;
export type SetNotificationSettingMutationResult =
	Apollo.MutationResult<SetNotificationSettingMutation>;
export type SetNotificationSettingMutationOptions = Apollo.BaseMutationOptions<
	SetNotificationSettingMutation,
	SetNotificationSettingMutationVariables
>;
export const MarkNotificationReadDocument = gql`
	mutation MarkNotificationRead($id: ID!) {
		markNotificationRead(id: $id) {
			success
			message
		}
	}
`;
export type MarkNotificationReadMutationFn = Apollo.MutationFunction<
	MarkNotificationReadMutation,
	MarkNotificationReadMutationVariables
>;

/**
 * __useMarkNotificationReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationReadMutation, { data, loading, error }] = useMarkNotificationReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationReadMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MarkNotificationReadMutation,
		MarkNotificationReadMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>(
		MarkNotificationReadDocument,
		options
	);
}
export type MarkNotificationReadMutationHookResult = ReturnType<
	typeof useMarkNotificationReadMutation
>;
export type MarkNotificationReadMutationResult =
	Apollo.MutationResult<MarkNotificationReadMutation>;
export type MarkNotificationReadMutationOptions = Apollo.BaseMutationOptions<
	MarkNotificationReadMutation,
	MarkNotificationReadMutationVariables
>;
export const MarkAllNotificationsReadDocument = gql`
	mutation MarkAllNotificationsRead {
		markAllNotificationsRead {
			success
			message
		}
	}
`;
export type MarkAllNotificationsReadMutationFn = Apollo.MutationFunction<
	MarkAllNotificationsReadMutation,
	MarkAllNotificationsReadMutationVariables
>;

/**
 * __useMarkAllNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsReadMutation, { data, loading, error }] = useMarkAllNotificationsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllNotificationsReadMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MarkAllNotificationsReadMutation,
		MarkAllNotificationsReadMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		MarkAllNotificationsReadMutation,
		MarkAllNotificationsReadMutationVariables
	>(MarkAllNotificationsReadDocument, options);
}
export type MarkAllNotificationsReadMutationHookResult = ReturnType<
	typeof useMarkAllNotificationsReadMutation
>;
export type MarkAllNotificationsReadMutationResult =
	Apollo.MutationResult<MarkAllNotificationsReadMutation>;
export type MarkAllNotificationsReadMutationOptions = Apollo.BaseMutationOptions<
	MarkAllNotificationsReadMutation,
	MarkAllNotificationsReadMutationVariables
>;
export const UpdateOrderItemStatusDocument = gql`
	mutation UpdateOrderItemStatus($id: ID!, $input: UpdateOrderItemStatusInput!) {
		updateOrderItemStatus(id: $id, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrderItemStatusMutationFn = Apollo.MutationFunction<
	UpdateOrderItemStatusMutation,
	UpdateOrderItemStatusMutationVariables
>;

/**
 * __useUpdateOrderItemStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderItemStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderItemStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderItemStatusMutation, { data, loading, error }] = useUpdateOrderItemStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderItemStatusMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderItemStatusMutation,
		UpdateOrderItemStatusMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrderItemStatusMutation,
		UpdateOrderItemStatusMutationVariables
	>(UpdateOrderItemStatusDocument, options);
}
export type UpdateOrderItemStatusMutationHookResult = ReturnType<
	typeof useUpdateOrderItemStatusMutation
>;
export type UpdateOrderItemStatusMutationResult =
	Apollo.MutationResult<UpdateOrderItemStatusMutation>;
export type UpdateOrderItemStatusMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderItemStatusMutation,
	UpdateOrderItemStatusMutationVariables
>;
export const UpdateOrderDocument = gql`
	mutation UpdateOrder($id: ID!, $input: UpdateOrderInput!) {
		updateOrder(id: $id, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrderMutationFn = Apollo.MutationFunction<
	UpdateOrderMutation,
	UpdateOrderMutationVariables
>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(
	baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(
		UpdateOrderDocument,
		options
	);
}
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderMutation,
	UpdateOrderMutationVariables
>;
export const UpdateOrderDeliveryAddressDocument = gql`
	mutation UpdateOrderDeliveryAddress($orderId: ID!, $address: OrderQuoteAddressInput!) {
		updateOrderDeliveryAddress(orderId: $orderId, address: $address) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrderDeliveryAddressMutationFn = Apollo.MutationFunction<
	UpdateOrderDeliveryAddressMutation,
	UpdateOrderDeliveryAddressMutationVariables
>;

/**
 * __useUpdateOrderDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useUpdateOrderDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderDeliveryAddressMutation, { data, loading, error }] = useUpdateOrderDeliveryAddressMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUpdateOrderDeliveryAddressMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderDeliveryAddressMutation,
		UpdateOrderDeliveryAddressMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrderDeliveryAddressMutation,
		UpdateOrderDeliveryAddressMutationVariables
	>(UpdateOrderDeliveryAddressDocument, options);
}
export type UpdateOrderDeliveryAddressMutationHookResult = ReturnType<
	typeof useUpdateOrderDeliveryAddressMutation
>;
export type UpdateOrderDeliveryAddressMutationResult =
	Apollo.MutationResult<UpdateOrderDeliveryAddressMutation>;
export type UpdateOrderDeliveryAddressMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderDeliveryAddressMutation,
	UpdateOrderDeliveryAddressMutationVariables
>;
export const ConfirmOrderDocument = gql`
	mutation ConfirmOrder($id: ID!, $input: ConfirmOrderInput!) {
		confirmOrder(id: $id, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type ConfirmOrderMutationFn = Apollo.MutationFunction<
	ConfirmOrderMutation,
	ConfirmOrderMutationVariables
>;

/**
 * __useConfirmOrderMutation__
 *
 * To run a mutation, you first call `useConfirmOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmOrderMutation, { data, loading, error }] = useConfirmOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmOrderMutation(
	baseOptions?: Apollo.MutationHookOptions<ConfirmOrderMutation, ConfirmOrderMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ConfirmOrderMutation, ConfirmOrderMutationVariables>(
		ConfirmOrderDocument,
		options
	);
}
export type ConfirmOrderMutationHookResult = ReturnType<typeof useConfirmOrderMutation>;
export type ConfirmOrderMutationResult = Apollo.MutationResult<ConfirmOrderMutation>;
export type ConfirmOrderMutationOptions = Apollo.BaseMutationOptions<
	ConfirmOrderMutation,
	ConfirmOrderMutationVariables
>;
export const CancelOrderDocument = gql`
	mutation CancelOrder($id: ID!) {
		cancelOrder(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CancelOrderMutationFn = Apollo.MutationFunction<
	CancelOrderMutation,
	CancelOrderMutationVariables
>;

/**
 * __useCancelOrderMutation__
 *
 * To run a mutation, you first call `useCancelOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOrderMutation, { data, loading, error }] = useCancelOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelOrderMutation(
	baseOptions?: Apollo.MutationHookOptions<CancelOrderMutation, CancelOrderMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CancelOrderMutation, CancelOrderMutationVariables>(
		CancelOrderDocument,
		options
	);
}
export type CancelOrderMutationHookResult = ReturnType<typeof useCancelOrderMutation>;
export type CancelOrderMutationResult = Apollo.MutationResult<CancelOrderMutation>;
export type CancelOrderMutationOptions = Apollo.BaseMutationOptions<
	CancelOrderMutation,
	CancelOrderMutationVariables
>;
export const MarkOrderProductInvoicePaidDocument = gql`
	mutation MarkOrderProductInvoicePaid($paymentTransactionId: ID!, $note: String) {
		markOrderProductInvoicePaid(paymentTransactionId: $paymentTransactionId, note: $note) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type MarkOrderProductInvoicePaidMutationFn = Apollo.MutationFunction<
	MarkOrderProductInvoicePaidMutation,
	MarkOrderProductInvoicePaidMutationVariables
>;

/**
 * __useMarkOrderProductInvoicePaidMutation__
 *
 * To run a mutation, you first call `useMarkOrderProductInvoicePaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOrderProductInvoicePaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOrderProductInvoicePaidMutation, { data, loading, error }] = useMarkOrderProductInvoicePaidMutation({
 *   variables: {
 *      paymentTransactionId: // value for 'paymentTransactionId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useMarkOrderProductInvoicePaidMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MarkOrderProductInvoicePaidMutation,
		MarkOrderProductInvoicePaidMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		MarkOrderProductInvoicePaidMutation,
		MarkOrderProductInvoicePaidMutationVariables
	>(MarkOrderProductInvoicePaidDocument, options);
}
export type MarkOrderProductInvoicePaidMutationHookResult = ReturnType<
	typeof useMarkOrderProductInvoicePaidMutation
>;
export type MarkOrderProductInvoicePaidMutationResult =
	Apollo.MutationResult<MarkOrderProductInvoicePaidMutation>;
export type MarkOrderProductInvoicePaidMutationOptions = Apollo.BaseMutationOptions<
	MarkOrderProductInvoicePaidMutation,
	MarkOrderProductInvoicePaidMutationVariables
>;
export const MarkOrderSampleInvoicePaidDocument = gql`
	mutation MarkOrderSampleInvoicePaid($paymentTransactionId: ID!, $note: String) {
		markOrderSampleInvoicePaid(paymentTransactionId: $paymentTransactionId, note: $note) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type MarkOrderSampleInvoicePaidMutationFn = Apollo.MutationFunction<
	MarkOrderSampleInvoicePaidMutation,
	MarkOrderSampleInvoicePaidMutationVariables
>;

/**
 * __useMarkOrderSampleInvoicePaidMutation__
 *
 * To run a mutation, you first call `useMarkOrderSampleInvoicePaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOrderSampleInvoicePaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOrderSampleInvoicePaidMutation, { data, loading, error }] = useMarkOrderSampleInvoicePaidMutation({
 *   variables: {
 *      paymentTransactionId: // value for 'paymentTransactionId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useMarkOrderSampleInvoicePaidMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MarkOrderSampleInvoicePaidMutation,
		MarkOrderSampleInvoicePaidMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		MarkOrderSampleInvoicePaidMutation,
		MarkOrderSampleInvoicePaidMutationVariables
	>(MarkOrderSampleInvoicePaidDocument, options);
}
export type MarkOrderSampleInvoicePaidMutationHookResult = ReturnType<
	typeof useMarkOrderSampleInvoicePaidMutation
>;
export type MarkOrderSampleInvoicePaidMutationResult =
	Apollo.MutationResult<MarkOrderSampleInvoicePaidMutation>;
export type MarkOrderSampleInvoicePaidMutationOptions = Apollo.BaseMutationOptions<
	MarkOrderSampleInvoicePaidMutation,
	MarkOrderSampleInvoicePaidMutationVariables
>;
export const RecordOrderBankTransferDocument = gql`
	mutation RecordOrderBankTransfer($input: RecordOrderBankTransferInput!) {
		recordOrderBankTransfer(input: $input) {
			success
			message
			paymentTransactionId
			economicBookedInvoiceNumber
		}
	}
`;
export type RecordOrderBankTransferMutationFn = Apollo.MutationFunction<
	RecordOrderBankTransferMutation,
	RecordOrderBankTransferMutationVariables
>;

/**
 * __useRecordOrderBankTransferMutation__
 *
 * To run a mutation, you first call `useRecordOrderBankTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordOrderBankTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordOrderBankTransferMutation, { data, loading, error }] = useRecordOrderBankTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordOrderBankTransferMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RecordOrderBankTransferMutation,
		RecordOrderBankTransferMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RecordOrderBankTransferMutation,
		RecordOrderBankTransferMutationVariables
	>(RecordOrderBankTransferDocument, options);
}
export type RecordOrderBankTransferMutationHookResult = ReturnType<
	typeof useRecordOrderBankTransferMutation
>;
export type RecordOrderBankTransferMutationResult =
	Apollo.MutationResult<RecordOrderBankTransferMutation>;
export type RecordOrderBankTransferMutationOptions = Apollo.BaseMutationOptions<
	RecordOrderBankTransferMutation,
	RecordOrderBankTransferMutationVariables
>;
export const CreateSamplePaymentDocument = gql`
	mutation CreateSamplePayment($input: CreateSamplePaymentInput!) {
		createSamplePayment(input: $input) {
			success
			message
			clientSecret
			sessionId
			economicBookedInvoiceNumber
			netAmount
			vatAmount
			vatRate
			grossAmount
		}
	}
`;
export type CreateSamplePaymentMutationFn = Apollo.MutationFunction<
	CreateSamplePaymentMutation,
	CreateSamplePaymentMutationVariables
>;

/**
 * __useCreateSamplePaymentMutation__
 *
 * To run a mutation, you first call `useCreateSamplePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSamplePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSamplePaymentMutation, { data, loading, error }] = useCreateSamplePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSamplePaymentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateSamplePaymentMutation,
		CreateSamplePaymentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateSamplePaymentMutation, CreateSamplePaymentMutationVariables>(
		CreateSamplePaymentDocument,
		options
	);
}
export type CreateSamplePaymentMutationHookResult = ReturnType<
	typeof useCreateSamplePaymentMutation
>;
export type CreateSamplePaymentMutationResult = Apollo.MutationResult<CreateSamplePaymentMutation>;
export type CreateSamplePaymentMutationOptions = Apollo.BaseMutationOptions<
	CreateSamplePaymentMutation,
	CreateSamplePaymentMutationVariables
>;
export const CreateFullOrderPaymentDocument = gql`
	mutation CreateFullOrderPayment($input: CreateFullOrderPaymentInput!) {
		createFullOrderPayment(input: $input) {
			success
			message
			paymentMethod
			clientSecret
			sessionId
			paymentTransactionId
			economicBookedInvoiceNumber
			netAmount
			vatAmount
			vatRate
			grossAmount
		}
	}
`;
export type CreateFullOrderPaymentMutationFn = Apollo.MutationFunction<
	CreateFullOrderPaymentMutation,
	CreateFullOrderPaymentMutationVariables
>;

/**
 * __useCreateFullOrderPaymentMutation__
 *
 * To run a mutation, you first call `useCreateFullOrderPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFullOrderPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFullOrderPaymentMutation, { data, loading, error }] = useCreateFullOrderPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFullOrderPaymentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateFullOrderPaymentMutation,
		CreateFullOrderPaymentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateFullOrderPaymentMutation,
		CreateFullOrderPaymentMutationVariables
	>(CreateFullOrderPaymentDocument, options);
}
export type CreateFullOrderPaymentMutationHookResult = ReturnType<
	typeof useCreateFullOrderPaymentMutation
>;
export type CreateFullOrderPaymentMutationResult =
	Apollo.MutationResult<CreateFullOrderPaymentMutation>;
export type CreateFullOrderPaymentMutationOptions = Apollo.BaseMutationOptions<
	CreateFullOrderPaymentMutation,
	CreateFullOrderPaymentMutationVariables
>;
export const CreateOrderPaymentDocument = gql`
	mutation CreateOrderPayment($input: CreateOrderPaymentInput!) {
		createOrderPayment(input: $input) {
			success
			message
			paymentMethod
			clientSecret
			sessionId
			paymentTransactionId
			economicBookedInvoiceNumber
			netAmount
			vatAmount
			vatRate
			grossAmount
		}
	}
`;
export type CreateOrderPaymentMutationFn = Apollo.MutationFunction<
	CreateOrderPaymentMutation,
	CreateOrderPaymentMutationVariables
>;

/**
 * __useCreateOrderPaymentMutation__
 *
 * To run a mutation, you first call `useCreateOrderPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderPaymentMutation, { data, loading, error }] = useCreateOrderPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderPaymentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrderPaymentMutation,
		CreateOrderPaymentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateOrderPaymentMutation, CreateOrderPaymentMutationVariables>(
		CreateOrderPaymentDocument,
		options
	);
}
export type CreateOrderPaymentMutationHookResult = ReturnType<typeof useCreateOrderPaymentMutation>;
export type CreateOrderPaymentMutationResult = Apollo.MutationResult<CreateOrderPaymentMutation>;
export type CreateOrderPaymentMutationOptions = Apollo.BaseMutationOptions<
	CreateOrderPaymentMutation,
	CreateOrderPaymentMutationVariables
>;
export const AddOrderQuoteItemsDocument = gql`
	mutation AddOrderQuoteItems($input: AddOrderQuoteItemsInput!) {
		addOrderQuoteItems(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type AddOrderQuoteItemsMutationFn = Apollo.MutationFunction<
	AddOrderQuoteItemsMutation,
	AddOrderQuoteItemsMutationVariables
>;

/**
 * __useAddOrderQuoteItemsMutation__
 *
 * To run a mutation, you first call `useAddOrderQuoteItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderQuoteItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderQuoteItemsMutation, { data, loading, error }] = useAddOrderQuoteItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrderQuoteItemsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddOrderQuoteItemsMutation,
		AddOrderQuoteItemsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AddOrderQuoteItemsMutation, AddOrderQuoteItemsMutationVariables>(
		AddOrderQuoteItemsDocument,
		options
	);
}
export type AddOrderQuoteItemsMutationHookResult = ReturnType<typeof useAddOrderQuoteItemsMutation>;
export type AddOrderQuoteItemsMutationResult = Apollo.MutationResult<AddOrderQuoteItemsMutation>;
export type AddOrderQuoteItemsMutationOptions = Apollo.BaseMutationOptions<
	AddOrderQuoteItemsMutation,
	AddOrderQuoteItemsMutationVariables
>;
export const UpdateOrderQuoteDocument = gql`
	mutation UpdateOrderQuote($id: ID!, $input: UpdateOrderQuoteInput!) {
		updateOrderQuote(id: $id, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrderQuoteMutationFn = Apollo.MutationFunction<
	UpdateOrderQuoteMutation,
	UpdateOrderQuoteMutationVariables
>;

/**
 * __useUpdateOrderQuoteMutation__
 *
 * To run a mutation, you first call `useUpdateOrderQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderQuoteMutation, { data, loading, error }] = useUpdateOrderQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderQuoteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderQuoteMutation,
		UpdateOrderQuoteMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateOrderQuoteMutation, UpdateOrderQuoteMutationVariables>(
		UpdateOrderQuoteDocument,
		options
	);
}
export type UpdateOrderQuoteMutationHookResult = ReturnType<typeof useUpdateOrderQuoteMutation>;
export type UpdateOrderQuoteMutationResult = Apollo.MutationResult<UpdateOrderQuoteMutation>;
export type UpdateOrderQuoteMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderQuoteMutation,
	UpdateOrderQuoteMutationVariables
>;
export const SetQuotePaymentSettingsDocument = gql`
	mutation SetQuotePaymentSettings($input: SetQuotePaymentSettingsInput!) {
		setQuotePaymentSettings(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type SetQuotePaymentSettingsMutationFn = Apollo.MutationFunction<
	SetQuotePaymentSettingsMutation,
	SetQuotePaymentSettingsMutationVariables
>;

/**
 * __useSetQuotePaymentSettingsMutation__
 *
 * To run a mutation, you first call `useSetQuotePaymentSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQuotePaymentSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQuotePaymentSettingsMutation, { data, loading, error }] = useSetQuotePaymentSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetQuotePaymentSettingsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetQuotePaymentSettingsMutation,
		SetQuotePaymentSettingsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SetQuotePaymentSettingsMutation,
		SetQuotePaymentSettingsMutationVariables
	>(SetQuotePaymentSettingsDocument, options);
}
export type SetQuotePaymentSettingsMutationHookResult = ReturnType<
	typeof useSetQuotePaymentSettingsMutation
>;
export type SetQuotePaymentSettingsMutationResult =
	Apollo.MutationResult<SetQuotePaymentSettingsMutation>;
export type SetQuotePaymentSettingsMutationOptions = Apollo.BaseMutationOptions<
	SetQuotePaymentSettingsMutation,
	SetQuotePaymentSettingsMutationVariables
>;
export const SetQuoteClientContactsDocument = gql`
	mutation SetQuoteClientContacts($input: SetQuoteClientContactsInput!) {
		setQuoteClientContacts(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type SetQuoteClientContactsMutationFn = Apollo.MutationFunction<
	SetQuoteClientContactsMutation,
	SetQuoteClientContactsMutationVariables
>;

/**
 * __useSetQuoteClientContactsMutation__
 *
 * To run a mutation, you first call `useSetQuoteClientContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQuoteClientContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQuoteClientContactsMutation, { data, loading, error }] = useSetQuoteClientContactsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetQuoteClientContactsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetQuoteClientContactsMutation,
		SetQuoteClientContactsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SetQuoteClientContactsMutation,
		SetQuoteClientContactsMutationVariables
	>(SetQuoteClientContactsDocument, options);
}
export type SetQuoteClientContactsMutationHookResult = ReturnType<
	typeof useSetQuoteClientContactsMutation
>;
export type SetQuoteClientContactsMutationResult =
	Apollo.MutationResult<SetQuoteClientContactsMutation>;
export type SetQuoteClientContactsMutationOptions = Apollo.BaseMutationOptions<
	SetQuoteClientContactsMutation,
	SetQuoteClientContactsMutationVariables
>;
export const DeleteOrderQuoteDocument = gql`
	mutation DeleteOrderQuote($id: ID!) {
		deleteOrderQuote(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteOrderQuoteMutationFn = Apollo.MutationFunction<
	DeleteOrderQuoteMutation,
	DeleteOrderQuoteMutationVariables
>;

/**
 * __useDeleteOrderQuoteMutation__
 *
 * To run a mutation, you first call `useDeleteOrderQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderQuoteMutation, { data, loading, error }] = useDeleteOrderQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrderQuoteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrderQuoteMutation,
		DeleteOrderQuoteMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteOrderQuoteMutation, DeleteOrderQuoteMutationVariables>(
		DeleteOrderQuoteDocument,
		options
	);
}
export type DeleteOrderQuoteMutationHookResult = ReturnType<typeof useDeleteOrderQuoteMutation>;
export type DeleteOrderQuoteMutationResult = Apollo.MutationResult<DeleteOrderQuoteMutation>;
export type DeleteOrderQuoteMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrderQuoteMutation,
	DeleteOrderQuoteMutationVariables
>;
export const RemoveOrderQuoteItemDocument = gql`
	mutation RemoveOrderQuoteItem($id: ID!) {
		removeOrderQuoteItem(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RemoveOrderQuoteItemMutationFn = Apollo.MutationFunction<
	RemoveOrderQuoteItemMutation,
	RemoveOrderQuoteItemMutationVariables
>;

/**
 * __useRemoveOrderQuoteItemMutation__
 *
 * To run a mutation, you first call `useRemoveOrderQuoteItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrderQuoteItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrderQuoteItemMutation, { data, loading, error }] = useRemoveOrderQuoteItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveOrderQuoteItemMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RemoveOrderQuoteItemMutation,
		RemoveOrderQuoteItemMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RemoveOrderQuoteItemMutation, RemoveOrderQuoteItemMutationVariables>(
		RemoveOrderQuoteItemDocument,
		options
	);
}
export type RemoveOrderQuoteItemMutationHookResult = ReturnType<
	typeof useRemoveOrderQuoteItemMutation
>;
export type RemoveOrderQuoteItemMutationResult =
	Apollo.MutationResult<RemoveOrderQuoteItemMutation>;
export type RemoveOrderQuoteItemMutationOptions = Apollo.BaseMutationOptions<
	RemoveOrderQuoteItemMutation,
	RemoveOrderQuoteItemMutationVariables
>;
export const UpdateOrderQuoteItemDocument = gql`
	mutation UpdateOrderQuoteItem($id: ID!, $input: UpdateOrderQuoteItemInput!) {
		updateOrderQuoteItem(id: $id, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrderQuoteItemMutationFn = Apollo.MutationFunction<
	UpdateOrderQuoteItemMutation,
	UpdateOrderQuoteItemMutationVariables
>;

/**
 * __useUpdateOrderQuoteItemMutation__
 *
 * To run a mutation, you first call `useUpdateOrderQuoteItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderQuoteItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderQuoteItemMutation, { data, loading, error }] = useUpdateOrderQuoteItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderQuoteItemMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderQuoteItemMutation,
		UpdateOrderQuoteItemMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateOrderQuoteItemMutation, UpdateOrderQuoteItemMutationVariables>(
		UpdateOrderQuoteItemDocument,
		options
	);
}
export type UpdateOrderQuoteItemMutationHookResult = ReturnType<
	typeof useUpdateOrderQuoteItemMutation
>;
export type UpdateOrderQuoteItemMutationResult =
	Apollo.MutationResult<UpdateOrderQuoteItemMutation>;
export type UpdateOrderQuoteItemMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderQuoteItemMutation,
	UpdateOrderQuoteItemMutationVariables
>;
export const CreateOrderQuoteDocument = gql`
	mutation CreateOrderQuote($input: CreateOrderQuoteInput!) {
		createOrderQuote(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateOrderQuoteMutationFn = Apollo.MutationFunction<
	CreateOrderQuoteMutation,
	CreateOrderQuoteMutationVariables
>;

/**
 * __useCreateOrderQuoteMutation__
 *
 * To run a mutation, you first call `useCreateOrderQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderQuoteMutation, { data, loading, error }] = useCreateOrderQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderQuoteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrderQuoteMutation,
		CreateOrderQuoteMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateOrderQuoteMutation, CreateOrderQuoteMutationVariables>(
		CreateOrderQuoteDocument,
		options
	);
}
export type CreateOrderQuoteMutationHookResult = ReturnType<typeof useCreateOrderQuoteMutation>;
export type CreateOrderQuoteMutationResult = Apollo.MutationResult<CreateOrderQuoteMutation>;
export type CreateOrderQuoteMutationOptions = Apollo.BaseMutationOptions<
	CreateOrderQuoteMutation,
	CreateOrderQuoteMutationVariables
>;
export const RequestOrderQuoteOfferDocument = gql`
	mutation RequestOrderQuoteOffer($orderQuoteId: ID!) {
		requestOrderQuoteOffer(orderQuoteId: $orderQuoteId) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RequestOrderQuoteOfferMutationFn = Apollo.MutationFunction<
	RequestOrderQuoteOfferMutation,
	RequestOrderQuoteOfferMutationVariables
>;

/**
 * __useRequestOrderQuoteOfferMutation__
 *
 * To run a mutation, you first call `useRequestOrderQuoteOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestOrderQuoteOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestOrderQuoteOfferMutation, { data, loading, error }] = useRequestOrderQuoteOfferMutation({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *   },
 * });
 */
export function useRequestOrderQuoteOfferMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RequestOrderQuoteOfferMutation,
		RequestOrderQuoteOfferMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RequestOrderQuoteOfferMutation,
		RequestOrderQuoteOfferMutationVariables
	>(RequestOrderQuoteOfferDocument, options);
}
export type RequestOrderQuoteOfferMutationHookResult = ReturnType<
	typeof useRequestOrderQuoteOfferMutation
>;
export type RequestOrderQuoteOfferMutationResult =
	Apollo.MutationResult<RequestOrderQuoteOfferMutation>;
export type RequestOrderQuoteOfferMutationOptions = Apollo.BaseMutationOptions<
	RequestOrderQuoteOfferMutation,
	RequestOrderQuoteOfferMutationVariables
>;
export const GenerateOrderQuoteItemAttachmentUploadUrlDocument = gql`
	mutation GenerateOrderQuoteItemAttachmentUploadUrl(
		$input: GenerateOrderQuoteItemAttachmentUploadUrlInput!
	) {
		generateOrderQuoteItemAttachmentUploadUrl(input: $input) {
			success
			message
			fileId
			uploadUrl
			blobUrl
			expiresAt
		}
	}
`;
export type GenerateOrderQuoteItemAttachmentUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateOrderQuoteItemAttachmentUploadUrlMutation,
	GenerateOrderQuoteItemAttachmentUploadUrlMutationVariables
>;

/**
 * __useGenerateOrderQuoteItemAttachmentUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateOrderQuoteItemAttachmentUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOrderQuoteItemAttachmentUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOrderQuoteItemAttachmentUploadUrlMutation, { data, loading, error }] = useGenerateOrderQuoteItemAttachmentUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateOrderQuoteItemAttachmentUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateOrderQuoteItemAttachmentUploadUrlMutation,
		GenerateOrderQuoteItemAttachmentUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateOrderQuoteItemAttachmentUploadUrlMutation,
		GenerateOrderQuoteItemAttachmentUploadUrlMutationVariables
	>(GenerateOrderQuoteItemAttachmentUploadUrlDocument, options);
}
export type GenerateOrderQuoteItemAttachmentUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateOrderQuoteItemAttachmentUploadUrlMutation
>;
export type GenerateOrderQuoteItemAttachmentUploadUrlMutationResult =
	Apollo.MutationResult<GenerateOrderQuoteItemAttachmentUploadUrlMutation>;
export type GenerateOrderQuoteItemAttachmentUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateOrderQuoteItemAttachmentUploadUrlMutation,
	GenerateOrderQuoteItemAttachmentUploadUrlMutationVariables
>;
export const ConfirmOrderQuoteItemAttachmentUploadsDocument = gql`
	mutation ConfirmOrderQuoteItemAttachmentUploads(
		$input: ConfirmOrderQuoteItemAttachmentUploadsInput!
	) {
		confirmOrderQuoteItemAttachmentUploads(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type ConfirmOrderQuoteItemAttachmentUploadsMutationFn = Apollo.MutationFunction<
	ConfirmOrderQuoteItemAttachmentUploadsMutation,
	ConfirmOrderQuoteItemAttachmentUploadsMutationVariables
>;

/**
 * __useConfirmOrderQuoteItemAttachmentUploadsMutation__
 *
 * To run a mutation, you first call `useConfirmOrderQuoteItemAttachmentUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmOrderQuoteItemAttachmentUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmOrderQuoteItemAttachmentUploadsMutation, { data, loading, error }] = useConfirmOrderQuoteItemAttachmentUploadsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmOrderQuoteItemAttachmentUploadsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmOrderQuoteItemAttachmentUploadsMutation,
		ConfirmOrderQuoteItemAttachmentUploadsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmOrderQuoteItemAttachmentUploadsMutation,
		ConfirmOrderQuoteItemAttachmentUploadsMutationVariables
	>(ConfirmOrderQuoteItemAttachmentUploadsDocument, options);
}
export type ConfirmOrderQuoteItemAttachmentUploadsMutationHookResult = ReturnType<
	typeof useConfirmOrderQuoteItemAttachmentUploadsMutation
>;
export type ConfirmOrderQuoteItemAttachmentUploadsMutationResult =
	Apollo.MutationResult<ConfirmOrderQuoteItemAttachmentUploadsMutation>;
export type ConfirmOrderQuoteItemAttachmentUploadsMutationOptions = Apollo.BaseMutationOptions<
	ConfirmOrderQuoteItemAttachmentUploadsMutation,
	ConfirmOrderQuoteItemAttachmentUploadsMutationVariables
>;
export const UpdateOrderQuoteItemAttachmentDocument = gql`
	mutation UpdateOrderQuoteItemAttachment(
		$orderQuoteItemId: ID!
		$attachmentId: ID!
		$input: UpdateOrderQuoteItemAttachmentInput!
	) {
		updateOrderQuoteItemAttachment(
			orderQuoteItemId: $orderQuoteItemId
			attachmentId: $attachmentId
			input: $input
		) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrderQuoteItemAttachmentMutationFn = Apollo.MutationFunction<
	UpdateOrderQuoteItemAttachmentMutation,
	UpdateOrderQuoteItemAttachmentMutationVariables
>;

/**
 * __useUpdateOrderQuoteItemAttachmentMutation__
 *
 * To run a mutation, you first call `useUpdateOrderQuoteItemAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderQuoteItemAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderQuoteItemAttachmentMutation, { data, loading, error }] = useUpdateOrderQuoteItemAttachmentMutation({
 *   variables: {
 *      orderQuoteItemId: // value for 'orderQuoteItemId'
 *      attachmentId: // value for 'attachmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderQuoteItemAttachmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderQuoteItemAttachmentMutation,
		UpdateOrderQuoteItemAttachmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrderQuoteItemAttachmentMutation,
		UpdateOrderQuoteItemAttachmentMutationVariables
	>(UpdateOrderQuoteItemAttachmentDocument, options);
}
export type UpdateOrderQuoteItemAttachmentMutationHookResult = ReturnType<
	typeof useUpdateOrderQuoteItemAttachmentMutation
>;
export type UpdateOrderQuoteItemAttachmentMutationResult =
	Apollo.MutationResult<UpdateOrderQuoteItemAttachmentMutation>;
export type UpdateOrderQuoteItemAttachmentMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderQuoteItemAttachmentMutation,
	UpdateOrderQuoteItemAttachmentMutationVariables
>;
export const DeleteOrderQuoteItemAttachmentDocument = gql`
	mutation DeleteOrderQuoteItemAttachment($orderQuoteItemId: ID!, $attachmentId: ID!) {
		deleteOrderQuoteItemAttachment(
			orderQuoteItemId: $orderQuoteItemId
			attachmentId: $attachmentId
		) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteOrderQuoteItemAttachmentMutationFn = Apollo.MutationFunction<
	DeleteOrderQuoteItemAttachmentMutation,
	DeleteOrderQuoteItemAttachmentMutationVariables
>;

/**
 * __useDeleteOrderQuoteItemAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteOrderQuoteItemAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderQuoteItemAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderQuoteItemAttachmentMutation, { data, loading, error }] = useDeleteOrderQuoteItemAttachmentMutation({
 *   variables: {
 *      orderQuoteItemId: // value for 'orderQuoteItemId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDeleteOrderQuoteItemAttachmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrderQuoteItemAttachmentMutation,
		DeleteOrderQuoteItemAttachmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteOrderQuoteItemAttachmentMutation,
		DeleteOrderQuoteItemAttachmentMutationVariables
	>(DeleteOrderQuoteItemAttachmentDocument, options);
}
export type DeleteOrderQuoteItemAttachmentMutationHookResult = ReturnType<
	typeof useDeleteOrderQuoteItemAttachmentMutation
>;
export type DeleteOrderQuoteItemAttachmentMutationResult =
	Apollo.MutationResult<DeleteOrderQuoteItemAttachmentMutation>;
export type DeleteOrderQuoteItemAttachmentMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrderQuoteItemAttachmentMutation,
	DeleteOrderQuoteItemAttachmentMutationVariables
>;
export const DuplicateOrderQuoteDocument = gql`
	mutation DuplicateOrderQuote($id: ID!, $input: DuplicateOrderQuoteInput) {
		duplicateOrderQuote(id: $id, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DuplicateOrderQuoteMutationFn = Apollo.MutationFunction<
	DuplicateOrderQuoteMutation,
	DuplicateOrderQuoteMutationVariables
>;

/**
 * __useDuplicateOrderQuoteMutation__
 *
 * To run a mutation, you first call `useDuplicateOrderQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateOrderQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateOrderQuoteMutation, { data, loading, error }] = useDuplicateOrderQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateOrderQuoteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DuplicateOrderQuoteMutation,
		DuplicateOrderQuoteMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DuplicateOrderQuoteMutation, DuplicateOrderQuoteMutationVariables>(
		DuplicateOrderQuoteDocument,
		options
	);
}
export type DuplicateOrderQuoteMutationHookResult = ReturnType<
	typeof useDuplicateOrderQuoteMutation
>;
export type DuplicateOrderQuoteMutationResult = Apollo.MutationResult<DuplicateOrderQuoteMutation>;
export type DuplicateOrderQuoteMutationOptions = Apollo.BaseMutationOptions<
	DuplicateOrderQuoteMutation,
	DuplicateOrderQuoteMutationVariables
>;
export const SyncOrderQuoteProductsDocument = gql`
	mutation SyncOrderQuoteProducts($input: SyncOrderQuoteProductsInput!) {
		syncOrderQuoteProducts(input: $input) {
			...MessageResponseFragment
			messageKey
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type SyncOrderQuoteProductsMutationFn = Apollo.MutationFunction<
	SyncOrderQuoteProductsMutation,
	SyncOrderQuoteProductsMutationVariables
>;

/**
 * __useSyncOrderQuoteProductsMutation__
 *
 * To run a mutation, you first call `useSyncOrderQuoteProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncOrderQuoteProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncOrderQuoteProductsMutation, { data, loading, error }] = useSyncOrderQuoteProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncOrderQuoteProductsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SyncOrderQuoteProductsMutation,
		SyncOrderQuoteProductsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SyncOrderQuoteProductsMutation,
		SyncOrderQuoteProductsMutationVariables
	>(SyncOrderQuoteProductsDocument, options);
}
export type SyncOrderQuoteProductsMutationHookResult = ReturnType<
	typeof useSyncOrderQuoteProductsMutation
>;
export type SyncOrderQuoteProductsMutationResult =
	Apollo.MutationResult<SyncOrderQuoteProductsMutation>;
export type SyncOrderQuoteProductsMutationOptions = Apollo.BaseMutationOptions<
	SyncOrderQuoteProductsMutation,
	SyncOrderQuoteProductsMutationVariables
>;
export const CreateOrderQuoteGuestAcceptanceLinkDocument = gql`
	mutation CreateOrderQuoteGuestAcceptanceLink(
		$input: CreateOrderQuoteGuestAcceptanceLinkInput!
	) {
		createOrderQuoteGuestAcceptanceLink(input: $input) {
			success
			message
			link
			email
		}
	}
`;
export type CreateOrderQuoteGuestAcceptanceLinkMutationFn = Apollo.MutationFunction<
	CreateOrderQuoteGuestAcceptanceLinkMutation,
	CreateOrderQuoteGuestAcceptanceLinkMutationVariables
>;

/**
 * __useCreateOrderQuoteGuestAcceptanceLinkMutation__
 *
 * To run a mutation, you first call `useCreateOrderQuoteGuestAcceptanceLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderQuoteGuestAcceptanceLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderQuoteGuestAcceptanceLinkMutation, { data, loading, error }] = useCreateOrderQuoteGuestAcceptanceLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderQuoteGuestAcceptanceLinkMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrderQuoteGuestAcceptanceLinkMutation,
		CreateOrderQuoteGuestAcceptanceLinkMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrderQuoteGuestAcceptanceLinkMutation,
		CreateOrderQuoteGuestAcceptanceLinkMutationVariables
	>(CreateOrderQuoteGuestAcceptanceLinkDocument, options);
}
export type CreateOrderQuoteGuestAcceptanceLinkMutationHookResult = ReturnType<
	typeof useCreateOrderQuoteGuestAcceptanceLinkMutation
>;
export type CreateOrderQuoteGuestAcceptanceLinkMutationResult =
	Apollo.MutationResult<CreateOrderQuoteGuestAcceptanceLinkMutation>;
export type CreateOrderQuoteGuestAcceptanceLinkMutationOptions = Apollo.BaseMutationOptions<
	CreateOrderQuoteGuestAcceptanceLinkMutation,
	CreateOrderQuoteGuestAcceptanceLinkMutationVariables
>;
export const RevokeOrderQuoteGuestAcceptanceLinkDocument = gql`
	mutation RevokeOrderQuoteGuestAcceptanceLink($id: ID!) {
		revokeOrderQuoteGuestAcceptanceLink(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RevokeOrderQuoteGuestAcceptanceLinkMutationFn = Apollo.MutationFunction<
	RevokeOrderQuoteGuestAcceptanceLinkMutation,
	RevokeOrderQuoteGuestAcceptanceLinkMutationVariables
>;

/**
 * __useRevokeOrderQuoteGuestAcceptanceLinkMutation__
 *
 * To run a mutation, you first call `useRevokeOrderQuoteGuestAcceptanceLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeOrderQuoteGuestAcceptanceLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeOrderQuoteGuestAcceptanceLinkMutation, { data, loading, error }] = useRevokeOrderQuoteGuestAcceptanceLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeOrderQuoteGuestAcceptanceLinkMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RevokeOrderQuoteGuestAcceptanceLinkMutation,
		RevokeOrderQuoteGuestAcceptanceLinkMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RevokeOrderQuoteGuestAcceptanceLinkMutation,
		RevokeOrderQuoteGuestAcceptanceLinkMutationVariables
	>(RevokeOrderQuoteGuestAcceptanceLinkDocument, options);
}
export type RevokeOrderQuoteGuestAcceptanceLinkMutationHookResult = ReturnType<
	typeof useRevokeOrderQuoteGuestAcceptanceLinkMutation
>;
export type RevokeOrderQuoteGuestAcceptanceLinkMutationResult =
	Apollo.MutationResult<RevokeOrderQuoteGuestAcceptanceLinkMutation>;
export type RevokeOrderQuoteGuestAcceptanceLinkMutationOptions = Apollo.BaseMutationOptions<
	RevokeOrderQuoteGuestAcceptanceLinkMutation,
	RevokeOrderQuoteGuestAcceptanceLinkMutationVariables
>;
export const CreateOrderQuoteGuestPreviewLinkDocument = gql`
	mutation CreateOrderQuoteGuestPreviewLink($orderQuoteId: ID!) {
		createOrderQuoteGuestPreviewLink(orderQuoteId: $orderQuoteId) {
			success
			message
			link
			email
			expiresAt
		}
	}
`;
export type CreateOrderQuoteGuestPreviewLinkMutationFn = Apollo.MutationFunction<
	CreateOrderQuoteGuestPreviewLinkMutation,
	CreateOrderQuoteGuestPreviewLinkMutationVariables
>;

/**
 * __useCreateOrderQuoteGuestPreviewLinkMutation__
 *
 * To run a mutation, you first call `useCreateOrderQuoteGuestPreviewLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderQuoteGuestPreviewLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderQuoteGuestPreviewLinkMutation, { data, loading, error }] = useCreateOrderQuoteGuestPreviewLinkMutation({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *   },
 * });
 */
export function useCreateOrderQuoteGuestPreviewLinkMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrderQuoteGuestPreviewLinkMutation,
		CreateOrderQuoteGuestPreviewLinkMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrderQuoteGuestPreviewLinkMutation,
		CreateOrderQuoteGuestPreviewLinkMutationVariables
	>(CreateOrderQuoteGuestPreviewLinkDocument, options);
}
export type CreateOrderQuoteGuestPreviewLinkMutationHookResult = ReturnType<
	typeof useCreateOrderQuoteGuestPreviewLinkMutation
>;
export type CreateOrderQuoteGuestPreviewLinkMutationResult =
	Apollo.MutationResult<CreateOrderQuoteGuestPreviewLinkMutation>;
export type CreateOrderQuoteGuestPreviewLinkMutationOptions = Apollo.BaseMutationOptions<
	CreateOrderQuoteGuestPreviewLinkMutation,
	CreateOrderQuoteGuestPreviewLinkMutationVariables
>;
export const CreateOrderQuoteOfferBatchDocument = gql`
	mutation CreateOrderQuoteOfferBatch($input: CreateOrderQuoteOfferBatchInput!) {
		createOrderQuoteOfferBatch(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateOrderQuoteOfferBatchMutationFn = Apollo.MutationFunction<
	CreateOrderQuoteOfferBatchMutation,
	CreateOrderQuoteOfferBatchMutationVariables
>;

/**
 * __useCreateOrderQuoteOfferBatchMutation__
 *
 * To run a mutation, you first call `useCreateOrderQuoteOfferBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderQuoteOfferBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderQuoteOfferBatchMutation, { data, loading, error }] = useCreateOrderQuoteOfferBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderQuoteOfferBatchMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrderQuoteOfferBatchMutation,
		CreateOrderQuoteOfferBatchMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrderQuoteOfferBatchMutation,
		CreateOrderQuoteOfferBatchMutationVariables
	>(CreateOrderQuoteOfferBatchDocument, options);
}
export type CreateOrderQuoteOfferBatchMutationHookResult = ReturnType<
	typeof useCreateOrderQuoteOfferBatchMutation
>;
export type CreateOrderQuoteOfferBatchMutationResult =
	Apollo.MutationResult<CreateOrderQuoteOfferBatchMutation>;
export type CreateOrderQuoteOfferBatchMutationOptions = Apollo.BaseMutationOptions<
	CreateOrderQuoteOfferBatchMutation,
	CreateOrderQuoteOfferBatchMutationVariables
>;
export const UpdateOrderQuoteOfferBatchDocument = gql`
	mutation UpdateOrderQuoteOfferBatch($id: ID!, $input: UpdateOrderQuoteOfferBatchInput!) {
		updateOrderQuoteOfferBatch(id: $id, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrderQuoteOfferBatchMutationFn = Apollo.MutationFunction<
	UpdateOrderQuoteOfferBatchMutation,
	UpdateOrderQuoteOfferBatchMutationVariables
>;

/**
 * __useUpdateOrderQuoteOfferBatchMutation__
 *
 * To run a mutation, you first call `useUpdateOrderQuoteOfferBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderQuoteOfferBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderQuoteOfferBatchMutation, { data, loading, error }] = useUpdateOrderQuoteOfferBatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderQuoteOfferBatchMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderQuoteOfferBatchMutation,
		UpdateOrderQuoteOfferBatchMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrderQuoteOfferBatchMutation,
		UpdateOrderQuoteOfferBatchMutationVariables
	>(UpdateOrderQuoteOfferBatchDocument, options);
}
export type UpdateOrderQuoteOfferBatchMutationHookResult = ReturnType<
	typeof useUpdateOrderQuoteOfferBatchMutation
>;
export type UpdateOrderQuoteOfferBatchMutationResult =
	Apollo.MutationResult<UpdateOrderQuoteOfferBatchMutation>;
export type UpdateOrderQuoteOfferBatchMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderQuoteOfferBatchMutation,
	UpdateOrderQuoteOfferBatchMutationVariables
>;
export const DeleteOrderQuoteOfferBatchDocument = gql`
	mutation DeleteOrderQuoteOfferBatch($id: ID!) {
		deleteOrderQuoteOfferBatch(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteOrderQuoteOfferBatchMutationFn = Apollo.MutationFunction<
	DeleteOrderQuoteOfferBatchMutation,
	DeleteOrderQuoteOfferBatchMutationVariables
>;

/**
 * __useDeleteOrderQuoteOfferBatchMutation__
 *
 * To run a mutation, you first call `useDeleteOrderQuoteOfferBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderQuoteOfferBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderQuoteOfferBatchMutation, { data, loading, error }] = useDeleteOrderQuoteOfferBatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrderQuoteOfferBatchMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrderQuoteOfferBatchMutation,
		DeleteOrderQuoteOfferBatchMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteOrderQuoteOfferBatchMutation,
		DeleteOrderQuoteOfferBatchMutationVariables
	>(DeleteOrderQuoteOfferBatchDocument, options);
}
export type DeleteOrderQuoteOfferBatchMutationHookResult = ReturnType<
	typeof useDeleteOrderQuoteOfferBatchMutation
>;
export type DeleteOrderQuoteOfferBatchMutationResult =
	Apollo.MutationResult<DeleteOrderQuoteOfferBatchMutation>;
export type DeleteOrderQuoteOfferBatchMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrderQuoteOfferBatchMutation,
	DeleteOrderQuoteOfferBatchMutationVariables
>;
export const UpdateOrderQuoteOfferDocument = gql`
	mutation UpdateOrderQuoteOffer($id: ID!, $input: UpdateOrderQuoteOfferInput!) {
		updateOrderQuoteOffer(id: $id, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrderQuoteOfferMutationFn = Apollo.MutationFunction<
	UpdateOrderQuoteOfferMutation,
	UpdateOrderQuoteOfferMutationVariables
>;

/**
 * __useUpdateOrderQuoteOfferMutation__
 *
 * To run a mutation, you first call `useUpdateOrderQuoteOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderQuoteOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderQuoteOfferMutation, { data, loading, error }] = useUpdateOrderQuoteOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderQuoteOfferMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderQuoteOfferMutation,
		UpdateOrderQuoteOfferMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrderQuoteOfferMutation,
		UpdateOrderQuoteOfferMutationVariables
	>(UpdateOrderQuoteOfferDocument, options);
}
export type UpdateOrderQuoteOfferMutationHookResult = ReturnType<
	typeof useUpdateOrderQuoteOfferMutation
>;
export type UpdateOrderQuoteOfferMutationResult =
	Apollo.MutationResult<UpdateOrderQuoteOfferMutation>;
export type UpdateOrderQuoteOfferMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderQuoteOfferMutation,
	UpdateOrderQuoteOfferMutationVariables
>;
export const AddOrderQuoteOfferDocument = gql`
	mutation AddOrderQuoteOffer($input: AddOrderQuoteOfferInput!) {
		addOrderQuoteOffer(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type AddOrderQuoteOfferMutationFn = Apollo.MutationFunction<
	AddOrderQuoteOfferMutation,
	AddOrderQuoteOfferMutationVariables
>;

/**
 * __useAddOrderQuoteOfferMutation__
 *
 * To run a mutation, you first call `useAddOrderQuoteOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderQuoteOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderQuoteOfferMutation, { data, loading, error }] = useAddOrderQuoteOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrderQuoteOfferMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddOrderQuoteOfferMutation,
		AddOrderQuoteOfferMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AddOrderQuoteOfferMutation, AddOrderQuoteOfferMutationVariables>(
		AddOrderQuoteOfferDocument,
		options
	);
}
export type AddOrderQuoteOfferMutationHookResult = ReturnType<typeof useAddOrderQuoteOfferMutation>;
export type AddOrderQuoteOfferMutationResult = Apollo.MutationResult<AddOrderQuoteOfferMutation>;
export type AddOrderQuoteOfferMutationOptions = Apollo.BaseMutationOptions<
	AddOrderQuoteOfferMutation,
	AddOrderQuoteOfferMutationVariables
>;
export const SetOrderQuoteOfferPricingDocument = gql`
	mutation SetOrderQuoteOfferPricing($input: SetOrderQuoteOfferPricingInput!) {
		setOrderQuoteOfferPricing(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type SetOrderQuoteOfferPricingMutationFn = Apollo.MutationFunction<
	SetOrderQuoteOfferPricingMutation,
	SetOrderQuoteOfferPricingMutationVariables
>;

/**
 * __useSetOrderQuoteOfferPricingMutation__
 *
 * To run a mutation, you first call `useSetOrderQuoteOfferPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrderQuoteOfferPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrderQuoteOfferPricingMutation, { data, loading, error }] = useSetOrderQuoteOfferPricingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetOrderQuoteOfferPricingMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetOrderQuoteOfferPricingMutation,
		SetOrderQuoteOfferPricingMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SetOrderQuoteOfferPricingMutation,
		SetOrderQuoteOfferPricingMutationVariables
	>(SetOrderQuoteOfferPricingDocument, options);
}
export type SetOrderQuoteOfferPricingMutationHookResult = ReturnType<
	typeof useSetOrderQuoteOfferPricingMutation
>;
export type SetOrderQuoteOfferPricingMutationResult =
	Apollo.MutationResult<SetOrderQuoteOfferPricingMutation>;
export type SetOrderQuoteOfferPricingMutationOptions = Apollo.BaseMutationOptions<
	SetOrderQuoteOfferPricingMutation,
	SetOrderQuoteOfferPricingMutationVariables
>;
export const RemoveOrderQuoteOfferDocument = gql`
	mutation RemoveOrderQuoteOffer($id: ID!) {
		removeOrderQuoteOffer(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RemoveOrderQuoteOfferMutationFn = Apollo.MutationFunction<
	RemoveOrderQuoteOfferMutation,
	RemoveOrderQuoteOfferMutationVariables
>;

/**
 * __useRemoveOrderQuoteOfferMutation__
 *
 * To run a mutation, you first call `useRemoveOrderQuoteOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrderQuoteOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrderQuoteOfferMutation, { data, loading, error }] = useRemoveOrderQuoteOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveOrderQuoteOfferMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RemoveOrderQuoteOfferMutation,
		RemoveOrderQuoteOfferMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RemoveOrderQuoteOfferMutation,
		RemoveOrderQuoteOfferMutationVariables
	>(RemoveOrderQuoteOfferDocument, options);
}
export type RemoveOrderQuoteOfferMutationHookResult = ReturnType<
	typeof useRemoveOrderQuoteOfferMutation
>;
export type RemoveOrderQuoteOfferMutationResult =
	Apollo.MutationResult<RemoveOrderQuoteOfferMutation>;
export type RemoveOrderQuoteOfferMutationOptions = Apollo.BaseMutationOptions<
	RemoveOrderQuoteOfferMutation,
	RemoveOrderQuoteOfferMutationVariables
>;
export const AddOrderQuoteOfferAdjustmentDocument = gql`
	mutation AddOrderQuoteOfferAdjustment($input: AddOrderQuoteOfferAdjustmentInput!) {
		addOrderQuoteOfferAdjustment(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type AddOrderQuoteOfferAdjustmentMutationFn = Apollo.MutationFunction<
	AddOrderQuoteOfferAdjustmentMutation,
	AddOrderQuoteOfferAdjustmentMutationVariables
>;

/**
 * __useAddOrderQuoteOfferAdjustmentMutation__
 *
 * To run a mutation, you first call `useAddOrderQuoteOfferAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderQuoteOfferAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderQuoteOfferAdjustmentMutation, { data, loading, error }] = useAddOrderQuoteOfferAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrderQuoteOfferAdjustmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddOrderQuoteOfferAdjustmentMutation,
		AddOrderQuoteOfferAdjustmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AddOrderQuoteOfferAdjustmentMutation,
		AddOrderQuoteOfferAdjustmentMutationVariables
	>(AddOrderQuoteOfferAdjustmentDocument, options);
}
export type AddOrderQuoteOfferAdjustmentMutationHookResult = ReturnType<
	typeof useAddOrderQuoteOfferAdjustmentMutation
>;
export type AddOrderQuoteOfferAdjustmentMutationResult =
	Apollo.MutationResult<AddOrderQuoteOfferAdjustmentMutation>;
export type AddOrderQuoteOfferAdjustmentMutationOptions = Apollo.BaseMutationOptions<
	AddOrderQuoteOfferAdjustmentMutation,
	AddOrderQuoteOfferAdjustmentMutationVariables
>;
export const UpdateOrderQuoteOfferAdjustmentDocument = gql`
	mutation UpdateOrderQuoteOfferAdjustment(
		$id: ID!
		$input: UpdateOrderQuoteOfferAdjustmentInput!
	) {
		updateOrderQuoteOfferAdjustment(id: $id, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrderQuoteOfferAdjustmentMutationFn = Apollo.MutationFunction<
	UpdateOrderQuoteOfferAdjustmentMutation,
	UpdateOrderQuoteOfferAdjustmentMutationVariables
>;

/**
 * __useUpdateOrderQuoteOfferAdjustmentMutation__
 *
 * To run a mutation, you first call `useUpdateOrderQuoteOfferAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderQuoteOfferAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderQuoteOfferAdjustmentMutation, { data, loading, error }] = useUpdateOrderQuoteOfferAdjustmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderQuoteOfferAdjustmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderQuoteOfferAdjustmentMutation,
		UpdateOrderQuoteOfferAdjustmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrderQuoteOfferAdjustmentMutation,
		UpdateOrderQuoteOfferAdjustmentMutationVariables
	>(UpdateOrderQuoteOfferAdjustmentDocument, options);
}
export type UpdateOrderQuoteOfferAdjustmentMutationHookResult = ReturnType<
	typeof useUpdateOrderQuoteOfferAdjustmentMutation
>;
export type UpdateOrderQuoteOfferAdjustmentMutationResult =
	Apollo.MutationResult<UpdateOrderQuoteOfferAdjustmentMutation>;
export type UpdateOrderQuoteOfferAdjustmentMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderQuoteOfferAdjustmentMutation,
	UpdateOrderQuoteOfferAdjustmentMutationVariables
>;
export const RemoveOrderQuoteOfferAdjustmentDocument = gql`
	mutation RemoveOrderQuoteOfferAdjustment($id: ID!) {
		removeOrderQuoteOfferAdjustment(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RemoveOrderQuoteOfferAdjustmentMutationFn = Apollo.MutationFunction<
	RemoveOrderQuoteOfferAdjustmentMutation,
	RemoveOrderQuoteOfferAdjustmentMutationVariables
>;

/**
 * __useRemoveOrderQuoteOfferAdjustmentMutation__
 *
 * To run a mutation, you first call `useRemoveOrderQuoteOfferAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrderQuoteOfferAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrderQuoteOfferAdjustmentMutation, { data, loading, error }] = useRemoveOrderQuoteOfferAdjustmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveOrderQuoteOfferAdjustmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RemoveOrderQuoteOfferAdjustmentMutation,
		RemoveOrderQuoteOfferAdjustmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RemoveOrderQuoteOfferAdjustmentMutation,
		RemoveOrderQuoteOfferAdjustmentMutationVariables
	>(RemoveOrderQuoteOfferAdjustmentDocument, options);
}
export type RemoveOrderQuoteOfferAdjustmentMutationHookResult = ReturnType<
	typeof useRemoveOrderQuoteOfferAdjustmentMutation
>;
export type RemoveOrderQuoteOfferAdjustmentMutationResult =
	Apollo.MutationResult<RemoveOrderQuoteOfferAdjustmentMutation>;
export type RemoveOrderQuoteOfferAdjustmentMutationOptions = Apollo.BaseMutationOptions<
	RemoveOrderQuoteOfferAdjustmentMutation,
	RemoveOrderQuoteOfferAdjustmentMutationVariables
>;
export const AddOrderQuoteOfferSampleDocument = gql`
	mutation AddOrderQuoteOfferSample($input: AddOrderQuoteOfferSampleInput!) {
		addOrderQuoteOfferSample(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type AddOrderQuoteOfferSampleMutationFn = Apollo.MutationFunction<
	AddOrderQuoteOfferSampleMutation,
	AddOrderQuoteOfferSampleMutationVariables
>;

/**
 * __useAddOrderQuoteOfferSampleMutation__
 *
 * To run a mutation, you first call `useAddOrderQuoteOfferSampleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderQuoteOfferSampleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderQuoteOfferSampleMutation, { data, loading, error }] = useAddOrderQuoteOfferSampleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrderQuoteOfferSampleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddOrderQuoteOfferSampleMutation,
		AddOrderQuoteOfferSampleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AddOrderQuoteOfferSampleMutation,
		AddOrderQuoteOfferSampleMutationVariables
	>(AddOrderQuoteOfferSampleDocument, options);
}
export type AddOrderQuoteOfferSampleMutationHookResult = ReturnType<
	typeof useAddOrderQuoteOfferSampleMutation
>;
export type AddOrderQuoteOfferSampleMutationResult =
	Apollo.MutationResult<AddOrderQuoteOfferSampleMutation>;
export type AddOrderQuoteOfferSampleMutationOptions = Apollo.BaseMutationOptions<
	AddOrderQuoteOfferSampleMutation,
	AddOrderQuoteOfferSampleMutationVariables
>;
export const UpdateOrderQuoteOfferSampleDocument = gql`
	mutation UpdateOrderQuoteOfferSample($id: ID!, $input: UpdateOrderQuoteOfferSampleInput!) {
		updateOrderQuoteOfferSample(id: $id, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrderQuoteOfferSampleMutationFn = Apollo.MutationFunction<
	UpdateOrderQuoteOfferSampleMutation,
	UpdateOrderQuoteOfferSampleMutationVariables
>;

/**
 * __useUpdateOrderQuoteOfferSampleMutation__
 *
 * To run a mutation, you first call `useUpdateOrderQuoteOfferSampleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderQuoteOfferSampleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderQuoteOfferSampleMutation, { data, loading, error }] = useUpdateOrderQuoteOfferSampleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderQuoteOfferSampleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderQuoteOfferSampleMutation,
		UpdateOrderQuoteOfferSampleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrderQuoteOfferSampleMutation,
		UpdateOrderQuoteOfferSampleMutationVariables
	>(UpdateOrderQuoteOfferSampleDocument, options);
}
export type UpdateOrderQuoteOfferSampleMutationHookResult = ReturnType<
	typeof useUpdateOrderQuoteOfferSampleMutation
>;
export type UpdateOrderQuoteOfferSampleMutationResult =
	Apollo.MutationResult<UpdateOrderQuoteOfferSampleMutation>;
export type UpdateOrderQuoteOfferSampleMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderQuoteOfferSampleMutation,
	UpdateOrderQuoteOfferSampleMutationVariables
>;
export const RemoveOrderQuoteOfferSampleDocument = gql`
	mutation RemoveOrderQuoteOfferSample($id: ID!) {
		removeOrderQuoteOfferSample(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RemoveOrderQuoteOfferSampleMutationFn = Apollo.MutationFunction<
	RemoveOrderQuoteOfferSampleMutation,
	RemoveOrderQuoteOfferSampleMutationVariables
>;

/**
 * __useRemoveOrderQuoteOfferSampleMutation__
 *
 * To run a mutation, you first call `useRemoveOrderQuoteOfferSampleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrderQuoteOfferSampleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrderQuoteOfferSampleMutation, { data, loading, error }] = useRemoveOrderQuoteOfferSampleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveOrderQuoteOfferSampleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RemoveOrderQuoteOfferSampleMutation,
		RemoveOrderQuoteOfferSampleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RemoveOrderQuoteOfferSampleMutation,
		RemoveOrderQuoteOfferSampleMutationVariables
	>(RemoveOrderQuoteOfferSampleDocument, options);
}
export type RemoveOrderQuoteOfferSampleMutationHookResult = ReturnType<
	typeof useRemoveOrderQuoteOfferSampleMutation
>;
export type RemoveOrderQuoteOfferSampleMutationResult =
	Apollo.MutationResult<RemoveOrderQuoteOfferSampleMutation>;
export type RemoveOrderQuoteOfferSampleMutationOptions = Apollo.BaseMutationOptions<
	RemoveOrderQuoteOfferSampleMutation,
	RemoveOrderQuoteOfferSampleMutationVariables
>;
export const AddOrderQuoteOfferDeliveryDocument = gql`
	mutation AddOrderQuoteOfferDelivery($input: AddOrderQuoteOfferDeliveryInput!) {
		addOrderQuoteOfferDelivery(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type AddOrderQuoteOfferDeliveryMutationFn = Apollo.MutationFunction<
	AddOrderQuoteOfferDeliveryMutation,
	AddOrderQuoteOfferDeliveryMutationVariables
>;

/**
 * __useAddOrderQuoteOfferDeliveryMutation__
 *
 * To run a mutation, you first call `useAddOrderQuoteOfferDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderQuoteOfferDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderQuoteOfferDeliveryMutation, { data, loading, error }] = useAddOrderQuoteOfferDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrderQuoteOfferDeliveryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddOrderQuoteOfferDeliveryMutation,
		AddOrderQuoteOfferDeliveryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AddOrderQuoteOfferDeliveryMutation,
		AddOrderQuoteOfferDeliveryMutationVariables
	>(AddOrderQuoteOfferDeliveryDocument, options);
}
export type AddOrderQuoteOfferDeliveryMutationHookResult = ReturnType<
	typeof useAddOrderQuoteOfferDeliveryMutation
>;
export type AddOrderQuoteOfferDeliveryMutationResult =
	Apollo.MutationResult<AddOrderQuoteOfferDeliveryMutation>;
export type AddOrderQuoteOfferDeliveryMutationOptions = Apollo.BaseMutationOptions<
	AddOrderQuoteOfferDeliveryMutation,
	AddOrderQuoteOfferDeliveryMutationVariables
>;
export const UpdateOrderQuoteOfferDeliveryDocument = gql`
	mutation UpdateOrderQuoteOfferDelivery($id: ID!, $input: UpdateOrderQuoteOfferDeliveryInput!) {
		updateOrderQuoteOfferDelivery(id: $id, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrderQuoteOfferDeliveryMutationFn = Apollo.MutationFunction<
	UpdateOrderQuoteOfferDeliveryMutation,
	UpdateOrderQuoteOfferDeliveryMutationVariables
>;

/**
 * __useUpdateOrderQuoteOfferDeliveryMutation__
 *
 * To run a mutation, you first call `useUpdateOrderQuoteOfferDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderQuoteOfferDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderQuoteOfferDeliveryMutation, { data, loading, error }] = useUpdateOrderQuoteOfferDeliveryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderQuoteOfferDeliveryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderQuoteOfferDeliveryMutation,
		UpdateOrderQuoteOfferDeliveryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrderQuoteOfferDeliveryMutation,
		UpdateOrderQuoteOfferDeliveryMutationVariables
	>(UpdateOrderQuoteOfferDeliveryDocument, options);
}
export type UpdateOrderQuoteOfferDeliveryMutationHookResult = ReturnType<
	typeof useUpdateOrderQuoteOfferDeliveryMutation
>;
export type UpdateOrderQuoteOfferDeliveryMutationResult =
	Apollo.MutationResult<UpdateOrderQuoteOfferDeliveryMutation>;
export type UpdateOrderQuoteOfferDeliveryMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderQuoteOfferDeliveryMutation,
	UpdateOrderQuoteOfferDeliveryMutationVariables
>;
export const AddOrderQuoteOfferDeliverySplitDocument = gql`
	mutation AddOrderQuoteOfferDeliverySplit($input: AddOrderQuoteOfferDeliverySplitInput!) {
		addOrderQuoteOfferDeliverySplit(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type AddOrderQuoteOfferDeliverySplitMutationFn = Apollo.MutationFunction<
	AddOrderQuoteOfferDeliverySplitMutation,
	AddOrderQuoteOfferDeliverySplitMutationVariables
>;

/**
 * __useAddOrderQuoteOfferDeliverySplitMutation__
 *
 * To run a mutation, you first call `useAddOrderQuoteOfferDeliverySplitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderQuoteOfferDeliverySplitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderQuoteOfferDeliverySplitMutation, { data, loading, error }] = useAddOrderQuoteOfferDeliverySplitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrderQuoteOfferDeliverySplitMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddOrderQuoteOfferDeliverySplitMutation,
		AddOrderQuoteOfferDeliverySplitMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AddOrderQuoteOfferDeliverySplitMutation,
		AddOrderQuoteOfferDeliverySplitMutationVariables
	>(AddOrderQuoteOfferDeliverySplitDocument, options);
}
export type AddOrderQuoteOfferDeliverySplitMutationHookResult = ReturnType<
	typeof useAddOrderQuoteOfferDeliverySplitMutation
>;
export type AddOrderQuoteOfferDeliverySplitMutationResult =
	Apollo.MutationResult<AddOrderQuoteOfferDeliverySplitMutation>;
export type AddOrderQuoteOfferDeliverySplitMutationOptions = Apollo.BaseMutationOptions<
	AddOrderQuoteOfferDeliverySplitMutation,
	AddOrderQuoteOfferDeliverySplitMutationVariables
>;
export const UpdateOrderQuoteOfferDeliverySplitDocument = gql`
	mutation UpdateOrderQuoteOfferDeliverySplit(
		$id: ID!
		$input: UpdateOrderQuoteOfferDeliverySplitInput!
	) {
		updateOrderQuoteOfferDeliverySplit(id: $id, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrderQuoteOfferDeliverySplitMutationFn = Apollo.MutationFunction<
	UpdateOrderQuoteOfferDeliverySplitMutation,
	UpdateOrderQuoteOfferDeliverySplitMutationVariables
>;

/**
 * __useUpdateOrderQuoteOfferDeliverySplitMutation__
 *
 * To run a mutation, you first call `useUpdateOrderQuoteOfferDeliverySplitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderQuoteOfferDeliverySplitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderQuoteOfferDeliverySplitMutation, { data, loading, error }] = useUpdateOrderQuoteOfferDeliverySplitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderQuoteOfferDeliverySplitMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderQuoteOfferDeliverySplitMutation,
		UpdateOrderQuoteOfferDeliverySplitMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrderQuoteOfferDeliverySplitMutation,
		UpdateOrderQuoteOfferDeliverySplitMutationVariables
	>(UpdateOrderQuoteOfferDeliverySplitDocument, options);
}
export type UpdateOrderQuoteOfferDeliverySplitMutationHookResult = ReturnType<
	typeof useUpdateOrderQuoteOfferDeliverySplitMutation
>;
export type UpdateOrderQuoteOfferDeliverySplitMutationResult =
	Apollo.MutationResult<UpdateOrderQuoteOfferDeliverySplitMutation>;
export type UpdateOrderQuoteOfferDeliverySplitMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderQuoteOfferDeliverySplitMutation,
	UpdateOrderQuoteOfferDeliverySplitMutationVariables
>;
export const RemoveOrderQuoteOfferDeliveryDocument = gql`
	mutation RemoveOrderQuoteOfferDelivery($id: ID!) {
		removeOrderQuoteOfferDelivery(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RemoveOrderQuoteOfferDeliveryMutationFn = Apollo.MutationFunction<
	RemoveOrderQuoteOfferDeliveryMutation,
	RemoveOrderQuoteOfferDeliveryMutationVariables
>;

/**
 * __useRemoveOrderQuoteOfferDeliveryMutation__
 *
 * To run a mutation, you first call `useRemoveOrderQuoteOfferDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrderQuoteOfferDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrderQuoteOfferDeliveryMutation, { data, loading, error }] = useRemoveOrderQuoteOfferDeliveryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveOrderQuoteOfferDeliveryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RemoveOrderQuoteOfferDeliveryMutation,
		RemoveOrderQuoteOfferDeliveryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RemoveOrderQuoteOfferDeliveryMutation,
		RemoveOrderQuoteOfferDeliveryMutationVariables
	>(RemoveOrderQuoteOfferDeliveryDocument, options);
}
export type RemoveOrderQuoteOfferDeliveryMutationHookResult = ReturnType<
	typeof useRemoveOrderQuoteOfferDeliveryMutation
>;
export type RemoveOrderQuoteOfferDeliveryMutationResult =
	Apollo.MutationResult<RemoveOrderQuoteOfferDeliveryMutation>;
export type RemoveOrderQuoteOfferDeliveryMutationOptions = Apollo.BaseMutationOptions<
	RemoveOrderQuoteOfferDeliveryMutation,
	RemoveOrderQuoteOfferDeliveryMutationVariables
>;
export const AddOffersToOrderQuoteOfferBatchDocument = gql`
	mutation AddOffersToOrderQuoteOfferBatch(
		$id: ID!
		$offers: [CreateOrderQuoteOfferBatchOfferInput!]!
	) {
		addOffersToOrderQuoteOfferBatch(id: $id, offers: $offers) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type AddOffersToOrderQuoteOfferBatchMutationFn = Apollo.MutationFunction<
	AddOffersToOrderQuoteOfferBatchMutation,
	AddOffersToOrderQuoteOfferBatchMutationVariables
>;

/**
 * __useAddOffersToOrderQuoteOfferBatchMutation__
 *
 * To run a mutation, you first call `useAddOffersToOrderQuoteOfferBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOffersToOrderQuoteOfferBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOffersToOrderQuoteOfferBatchMutation, { data, loading, error }] = useAddOffersToOrderQuoteOfferBatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      offers: // value for 'offers'
 *   },
 * });
 */
export function useAddOffersToOrderQuoteOfferBatchMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddOffersToOrderQuoteOfferBatchMutation,
		AddOffersToOrderQuoteOfferBatchMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AddOffersToOrderQuoteOfferBatchMutation,
		AddOffersToOrderQuoteOfferBatchMutationVariables
	>(AddOffersToOrderQuoteOfferBatchDocument, options);
}
export type AddOffersToOrderQuoteOfferBatchMutationHookResult = ReturnType<
	typeof useAddOffersToOrderQuoteOfferBatchMutation
>;
export type AddOffersToOrderQuoteOfferBatchMutationResult =
	Apollo.MutationResult<AddOffersToOrderQuoteOfferBatchMutation>;
export type AddOffersToOrderQuoteOfferBatchMutationOptions = Apollo.BaseMutationOptions<
	AddOffersToOrderQuoteOfferBatchMutation,
	AddOffersToOrderQuoteOfferBatchMutationVariables
>;
export const SendOrderQuoteOfferBatchToClientDocument = gql`
	mutation SendOrderQuoteOfferBatchToClient($id: ID!) {
		sendOrderQuoteOfferBatchToClient(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type SendOrderQuoteOfferBatchToClientMutationFn = Apollo.MutationFunction<
	SendOrderQuoteOfferBatchToClientMutation,
	SendOrderQuoteOfferBatchToClientMutationVariables
>;

/**
 * __useSendOrderQuoteOfferBatchToClientMutation__
 *
 * To run a mutation, you first call `useSendOrderQuoteOfferBatchToClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOrderQuoteOfferBatchToClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOrderQuoteOfferBatchToClientMutation, { data, loading, error }] = useSendOrderQuoteOfferBatchToClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendOrderQuoteOfferBatchToClientMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SendOrderQuoteOfferBatchToClientMutation,
		SendOrderQuoteOfferBatchToClientMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SendOrderQuoteOfferBatchToClientMutation,
		SendOrderQuoteOfferBatchToClientMutationVariables
	>(SendOrderQuoteOfferBatchToClientDocument, options);
}
export type SendOrderQuoteOfferBatchToClientMutationHookResult = ReturnType<
	typeof useSendOrderQuoteOfferBatchToClientMutation
>;
export type SendOrderQuoteOfferBatchToClientMutationResult =
	Apollo.MutationResult<SendOrderQuoteOfferBatchToClientMutation>;
export type SendOrderQuoteOfferBatchToClientMutationOptions = Apollo.BaseMutationOptions<
	SendOrderQuoteOfferBatchToClientMutation,
	SendOrderQuoteOfferBatchToClientMutationVariables
>;
export const RecallOrderQuoteOfferBatchDocument = gql`
	mutation RecallOrderQuoteOfferBatch($id: ID!) {
		recallOrderQuoteOfferBatch(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RecallOrderQuoteOfferBatchMutationFn = Apollo.MutationFunction<
	RecallOrderQuoteOfferBatchMutation,
	RecallOrderQuoteOfferBatchMutationVariables
>;

/**
 * __useRecallOrderQuoteOfferBatchMutation__
 *
 * To run a mutation, you first call `useRecallOrderQuoteOfferBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecallOrderQuoteOfferBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recallOrderQuoteOfferBatchMutation, { data, loading, error }] = useRecallOrderQuoteOfferBatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecallOrderQuoteOfferBatchMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RecallOrderQuoteOfferBatchMutation,
		RecallOrderQuoteOfferBatchMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RecallOrderQuoteOfferBatchMutation,
		RecallOrderQuoteOfferBatchMutationVariables
	>(RecallOrderQuoteOfferBatchDocument, options);
}
export type RecallOrderQuoteOfferBatchMutationHookResult = ReturnType<
	typeof useRecallOrderQuoteOfferBatchMutation
>;
export type RecallOrderQuoteOfferBatchMutationResult =
	Apollo.MutationResult<RecallOrderQuoteOfferBatchMutation>;
export type RecallOrderQuoteOfferBatchMutationOptions = Apollo.BaseMutationOptions<
	RecallOrderQuoteOfferBatchMutation,
	RecallOrderQuoteOfferBatchMutationVariables
>;
export const ApplyCatalogPriceToOfferTierDocument = gql`
	mutation ApplyCatalogPriceToOfferTier($input: ApplyCatalogPriceToOfferTierInput!) {
		applyCatalogPriceToOfferTier(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type ApplyCatalogPriceToOfferTierMutationFn = Apollo.MutationFunction<
	ApplyCatalogPriceToOfferTierMutation,
	ApplyCatalogPriceToOfferTierMutationVariables
>;

/**
 * __useApplyCatalogPriceToOfferTierMutation__
 *
 * To run a mutation, you first call `useApplyCatalogPriceToOfferTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCatalogPriceToOfferTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCatalogPriceToOfferTierMutation, { data, loading, error }] = useApplyCatalogPriceToOfferTierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyCatalogPriceToOfferTierMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ApplyCatalogPriceToOfferTierMutation,
		ApplyCatalogPriceToOfferTierMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ApplyCatalogPriceToOfferTierMutation,
		ApplyCatalogPriceToOfferTierMutationVariables
	>(ApplyCatalogPriceToOfferTierDocument, options);
}
export type ApplyCatalogPriceToOfferTierMutationHookResult = ReturnType<
	typeof useApplyCatalogPriceToOfferTierMutation
>;
export type ApplyCatalogPriceToOfferTierMutationResult =
	Apollo.MutationResult<ApplyCatalogPriceToOfferTierMutation>;
export type ApplyCatalogPriceToOfferTierMutationOptions = Apollo.BaseMutationOptions<
	ApplyCatalogPriceToOfferTierMutation,
	ApplyCatalogPriceToOfferTierMutationVariables
>;
export const ApplyCatalogPriceToOfferSampleDocument = gql`
	mutation ApplyCatalogPriceToOfferSample($input: ApplyCatalogPriceToOfferSampleInput!) {
		applyCatalogPriceToOfferSample(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type ApplyCatalogPriceToOfferSampleMutationFn = Apollo.MutationFunction<
	ApplyCatalogPriceToOfferSampleMutation,
	ApplyCatalogPriceToOfferSampleMutationVariables
>;

/**
 * __useApplyCatalogPriceToOfferSampleMutation__
 *
 * To run a mutation, you first call `useApplyCatalogPriceToOfferSampleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCatalogPriceToOfferSampleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCatalogPriceToOfferSampleMutation, { data, loading, error }] = useApplyCatalogPriceToOfferSampleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyCatalogPriceToOfferSampleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ApplyCatalogPriceToOfferSampleMutation,
		ApplyCatalogPriceToOfferSampleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ApplyCatalogPriceToOfferSampleMutation,
		ApplyCatalogPriceToOfferSampleMutationVariables
	>(ApplyCatalogPriceToOfferSampleDocument, options);
}
export type ApplyCatalogPriceToOfferSampleMutationHookResult = ReturnType<
	typeof useApplyCatalogPriceToOfferSampleMutation
>;
export type ApplyCatalogPriceToOfferSampleMutationResult =
	Apollo.MutationResult<ApplyCatalogPriceToOfferSampleMutation>;
export type ApplyCatalogPriceToOfferSampleMutationOptions = Apollo.BaseMutationOptions<
	ApplyCatalogPriceToOfferSampleMutation,
	ApplyCatalogPriceToOfferSampleMutationVariables
>;
export const SendVetterPriceRequestDocument = gql`
	mutation SendVetterPriceRequest($input: SendVetterPriceRequestInput!) {
		sendVetterPriceRequest(input: $input) {
			success
			message
			vetterJobId
			email
			link
		}
	}
`;
export type SendVetterPriceRequestMutationFn = Apollo.MutationFunction<
	SendVetterPriceRequestMutation,
	SendVetterPriceRequestMutationVariables
>;

/**
 * __useSendVetterPriceRequestMutation__
 *
 * To run a mutation, you first call `useSendVetterPriceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVetterPriceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVetterPriceRequestMutation, { data, loading, error }] = useSendVetterPriceRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendVetterPriceRequestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SendVetterPriceRequestMutation,
		SendVetterPriceRequestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SendVetterPriceRequestMutation,
		SendVetterPriceRequestMutationVariables
	>(SendVetterPriceRequestDocument, options);
}
export type SendVetterPriceRequestMutationHookResult = ReturnType<
	typeof useSendVetterPriceRequestMutation
>;
export type SendVetterPriceRequestMutationResult =
	Apollo.MutationResult<SendVetterPriceRequestMutation>;
export type SendVetterPriceRequestMutationOptions = Apollo.BaseMutationOptions<
	SendVetterPriceRequestMutation,
	SendVetterPriceRequestMutationVariables
>;
export const SetOrderQuoteVetterJobItemsDocument = gql`
	mutation SetOrderQuoteVetterJobItems($id: ID!, $orderQuoteItemIds: [ID!]!) {
		setOrderQuoteVetterJobItems(id: $id, orderQuoteItemIds: $orderQuoteItemIds) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type SetOrderQuoteVetterJobItemsMutationFn = Apollo.MutationFunction<
	SetOrderQuoteVetterJobItemsMutation,
	SetOrderQuoteVetterJobItemsMutationVariables
>;

/**
 * __useSetOrderQuoteVetterJobItemsMutation__
 *
 * To run a mutation, you first call `useSetOrderQuoteVetterJobItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrderQuoteVetterJobItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrderQuoteVetterJobItemsMutation, { data, loading, error }] = useSetOrderQuoteVetterJobItemsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      orderQuoteItemIds: // value for 'orderQuoteItemIds'
 *   },
 * });
 */
export function useSetOrderQuoteVetterJobItemsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetOrderQuoteVetterJobItemsMutation,
		SetOrderQuoteVetterJobItemsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SetOrderQuoteVetterJobItemsMutation,
		SetOrderQuoteVetterJobItemsMutationVariables
	>(SetOrderQuoteVetterJobItemsDocument, options);
}
export type SetOrderQuoteVetterJobItemsMutationHookResult = ReturnType<
	typeof useSetOrderQuoteVetterJobItemsMutation
>;
export type SetOrderQuoteVetterJobItemsMutationResult =
	Apollo.MutationResult<SetOrderQuoteVetterJobItemsMutation>;
export type SetOrderQuoteVetterJobItemsMutationOptions = Apollo.BaseMutationOptions<
	SetOrderQuoteVetterJobItemsMutation,
	SetOrderQuoteVetterJobItemsMutationVariables
>;
export const WithdrawOrderQuoteVetterJobDocument = gql`
	mutation WithdrawOrderQuoteVetterJob($id: ID!) {
		withdrawOrderQuoteVetterJob(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type WithdrawOrderQuoteVetterJobMutationFn = Apollo.MutationFunction<
	WithdrawOrderQuoteVetterJobMutation,
	WithdrawOrderQuoteVetterJobMutationVariables
>;

/**
 * __useWithdrawOrderQuoteVetterJobMutation__
 *
 * To run a mutation, you first call `useWithdrawOrderQuoteVetterJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawOrderQuoteVetterJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawOrderQuoteVetterJobMutation, { data, loading, error }] = useWithdrawOrderQuoteVetterJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWithdrawOrderQuoteVetterJobMutation(
	baseOptions?: Apollo.MutationHookOptions<
		WithdrawOrderQuoteVetterJobMutation,
		WithdrawOrderQuoteVetterJobMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		WithdrawOrderQuoteVetterJobMutation,
		WithdrawOrderQuoteVetterJobMutationVariables
	>(WithdrawOrderQuoteVetterJobDocument, options);
}
export type WithdrawOrderQuoteVetterJobMutationHookResult = ReturnType<
	typeof useWithdrawOrderQuoteVetterJobMutation
>;
export type WithdrawOrderQuoteVetterJobMutationResult =
	Apollo.MutationResult<WithdrawOrderQuoteVetterJobMutation>;
export type WithdrawOrderQuoteVetterJobMutationOptions = Apollo.BaseMutationOptions<
	WithdrawOrderQuoteVetterJobMutation,
	WithdrawOrderQuoteVetterJobMutationVariables
>;
export const RevokeOrderQuoteVetterLinkDocument = gql`
	mutation RevokeOrderQuoteVetterLink($id: ID!) {
		revokeOrderQuoteVetterLink(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RevokeOrderQuoteVetterLinkMutationFn = Apollo.MutationFunction<
	RevokeOrderQuoteVetterLinkMutation,
	RevokeOrderQuoteVetterLinkMutationVariables
>;

/**
 * __useRevokeOrderQuoteVetterLinkMutation__
 *
 * To run a mutation, you first call `useRevokeOrderQuoteVetterLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeOrderQuoteVetterLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeOrderQuoteVetterLinkMutation, { data, loading, error }] = useRevokeOrderQuoteVetterLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeOrderQuoteVetterLinkMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RevokeOrderQuoteVetterLinkMutation,
		RevokeOrderQuoteVetterLinkMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RevokeOrderQuoteVetterLinkMutation,
		RevokeOrderQuoteVetterLinkMutationVariables
	>(RevokeOrderQuoteVetterLinkDocument, options);
}
export type RevokeOrderQuoteVetterLinkMutationHookResult = ReturnType<
	typeof useRevokeOrderQuoteVetterLinkMutation
>;
export type RevokeOrderQuoteVetterLinkMutationResult =
	Apollo.MutationResult<RevokeOrderQuoteVetterLinkMutation>;
export type RevokeOrderQuoteVetterLinkMutationOptions = Apollo.BaseMutationOptions<
	RevokeOrderQuoteVetterLinkMutation,
	RevokeOrderQuoteVetterLinkMutationVariables
>;
export const ApplyVetterPricesDocument = gql`
	mutation ApplyVetterPrices($input: ApplyVetterPricesInput!) {
		applyVetterPrices(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type ApplyVetterPricesMutationFn = Apollo.MutationFunction<
	ApplyVetterPricesMutation,
	ApplyVetterPricesMutationVariables
>;

/**
 * __useApplyVetterPricesMutation__
 *
 * To run a mutation, you first call `useApplyVetterPricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyVetterPricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyVetterPricesMutation, { data, loading, error }] = useApplyVetterPricesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyVetterPricesMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ApplyVetterPricesMutation,
		ApplyVetterPricesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ApplyVetterPricesMutation, ApplyVetterPricesMutationVariables>(
		ApplyVetterPricesDocument,
		options
	);
}
export type ApplyVetterPricesMutationHookResult = ReturnType<typeof useApplyVetterPricesMutation>;
export type ApplyVetterPricesMutationResult = Apollo.MutationResult<ApplyVetterPricesMutation>;
export type ApplyVetterPricesMutationOptions = Apollo.BaseMutationOptions<
	ApplyVetterPricesMutation,
	ApplyVetterPricesMutationVariables
>;
export const RecordOrderQuoteViewDocument = gql`
	mutation RecordOrderQuoteView($orderQuoteId: ID!) {
		recordOrderQuoteView(orderQuoteId: $orderQuoteId) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RecordOrderQuoteViewMutationFn = Apollo.MutationFunction<
	RecordOrderQuoteViewMutation,
	RecordOrderQuoteViewMutationVariables
>;

/**
 * __useRecordOrderQuoteViewMutation__
 *
 * To run a mutation, you first call `useRecordOrderQuoteViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordOrderQuoteViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordOrderQuoteViewMutation, { data, loading, error }] = useRecordOrderQuoteViewMutation({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *   },
 * });
 */
export function useRecordOrderQuoteViewMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RecordOrderQuoteViewMutation,
		RecordOrderQuoteViewMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RecordOrderQuoteViewMutation, RecordOrderQuoteViewMutationVariables>(
		RecordOrderQuoteViewDocument,
		options
	);
}
export type RecordOrderQuoteViewMutationHookResult = ReturnType<
	typeof useRecordOrderQuoteViewMutation
>;
export type RecordOrderQuoteViewMutationResult =
	Apollo.MutationResult<RecordOrderQuoteViewMutation>;
export type RecordOrderQuoteViewMutationOptions = Apollo.BaseMutationOptions<
	RecordOrderQuoteViewMutation,
	RecordOrderQuoteViewMutationVariables
>;
export const UpdateOrderShipmentTrackingDocument = gql`
	mutation UpdateOrderShipmentTracking($id: ID!, $input: UpdateOrderShipmentTrackingInput!) {
		updateOrderShipmentTracking(id: $id, input: $input) {
			success
			message
		}
	}
`;
export type UpdateOrderShipmentTrackingMutationFn = Apollo.MutationFunction<
	UpdateOrderShipmentTrackingMutation,
	UpdateOrderShipmentTrackingMutationVariables
>;

/**
 * __useUpdateOrderShipmentTrackingMutation__
 *
 * To run a mutation, you first call `useUpdateOrderShipmentTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderShipmentTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderShipmentTrackingMutation, { data, loading, error }] = useUpdateOrderShipmentTrackingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderShipmentTrackingMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderShipmentTrackingMutation,
		UpdateOrderShipmentTrackingMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrderShipmentTrackingMutation,
		UpdateOrderShipmentTrackingMutationVariables
	>(UpdateOrderShipmentTrackingDocument, options);
}
export type UpdateOrderShipmentTrackingMutationHookResult = ReturnType<
	typeof useUpdateOrderShipmentTrackingMutation
>;
export type UpdateOrderShipmentTrackingMutationResult =
	Apollo.MutationResult<UpdateOrderShipmentTrackingMutation>;
export type UpdateOrderShipmentTrackingMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderShipmentTrackingMutation,
	UpdateOrderShipmentTrackingMutationVariables
>;
export const CreateOrderShipmentDocument = gql`
	mutation CreateOrderShipment($input: CreateOrderShipmentInput!) {
		createOrderShipment(input: $input) {
			success
			message
		}
	}
`;
export type CreateOrderShipmentMutationFn = Apollo.MutationFunction<
	CreateOrderShipmentMutation,
	CreateOrderShipmentMutationVariables
>;

/**
 * __useCreateOrderShipmentMutation__
 *
 * To run a mutation, you first call `useCreateOrderShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderShipmentMutation, { data, loading, error }] = useCreateOrderShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderShipmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrderShipmentMutation,
		CreateOrderShipmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateOrderShipmentMutation, CreateOrderShipmentMutationVariables>(
		CreateOrderShipmentDocument,
		options
	);
}
export type CreateOrderShipmentMutationHookResult = ReturnType<
	typeof useCreateOrderShipmentMutation
>;
export type CreateOrderShipmentMutationResult = Apollo.MutationResult<CreateOrderShipmentMutation>;
export type CreateOrderShipmentMutationOptions = Apollo.BaseMutationOptions<
	CreateOrderShipmentMutation,
	CreateOrderShipmentMutationVariables
>;
export const CreateOrganizationDocument = gql`
	mutation CreateOrganization($input: OrganizationCreateInput!) {
		createOrganization(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<
	CreateOrganizationMutation,
	CreateOrganizationMutationVariables
>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationMutation,
		CreateOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(
		CreateOrganizationDocument,
		options
	);
}
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationMutation,
	CreateOrganizationMutationVariables
>;
export const CreateOrganizationUserDocument = gql`
	mutation CreateOrganizationUser($input: OrganizationUserCreateInput!) {
		createOrganizationUser(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateOrganizationUserMutationFn = Apollo.MutationFunction<
	CreateOrganizationUserMutation,
	CreateOrganizationUserMutationVariables
>;

/**
 * __useCreateOrganizationUserMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationUserMutation, { data, loading, error }] = useCreateOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationUserMutation,
		CreateOrganizationUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationUserMutation,
		CreateOrganizationUserMutationVariables
	>(CreateOrganizationUserDocument, options);
}
export type CreateOrganizationUserMutationHookResult = ReturnType<
	typeof useCreateOrganizationUserMutation
>;
export type CreateOrganizationUserMutationResult =
	Apollo.MutationResult<CreateOrganizationUserMutation>;
export type CreateOrganizationUserMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationUserMutation,
	CreateOrganizationUserMutationVariables
>;
export const DeleteOrganizationUserDocument = gql`
	mutation DeleteOrganizationUser($input: DeleteInput!) {
		deleteOrganizationUser(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteOrganizationUserMutationFn = Apollo.MutationFunction<
	DeleteOrganizationUserMutation,
	DeleteOrganizationUserMutationVariables
>;

/**
 * __useDeleteOrganizationUserMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationUserMutation, { data, loading, error }] = useDeleteOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganizationUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationUserMutation,
		DeleteOrganizationUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteOrganizationUserMutation,
		DeleteOrganizationUserMutationVariables
	>(DeleteOrganizationUserDocument, options);
}
export type DeleteOrganizationUserMutationHookResult = ReturnType<
	typeof useDeleteOrganizationUserMutation
>;
export type DeleteOrganizationUserMutationResult =
	Apollo.MutationResult<DeleteOrganizationUserMutation>;
export type DeleteOrganizationUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrganizationUserMutation,
	DeleteOrganizationUserMutationVariables
>;
export const DeleteManyOrganizationUserDocument = gql`
	mutation DeleteManyOrganizationUser($input: DeleteManyInput!) {
		deleteManyOrganizationUser(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteManyOrganizationUserMutationFn = Apollo.MutationFunction<
	DeleteManyOrganizationUserMutation,
	DeleteManyOrganizationUserMutationVariables
>;

/**
 * __useDeleteManyOrganizationUserMutation__
 *
 * To run a mutation, you first call `useDeleteManyOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyOrganizationUserMutation, { data, loading, error }] = useDeleteManyOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyOrganizationUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyOrganizationUserMutation,
		DeleteManyOrganizationUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteManyOrganizationUserMutation,
		DeleteManyOrganizationUserMutationVariables
	>(DeleteManyOrganizationUserDocument, options);
}
export type DeleteManyOrganizationUserMutationHookResult = ReturnType<
	typeof useDeleteManyOrganizationUserMutation
>;
export type DeleteManyOrganizationUserMutationResult =
	Apollo.MutationResult<DeleteManyOrganizationUserMutation>;
export type DeleteManyOrganizationUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyOrganizationUserMutation,
	DeleteManyOrganizationUserMutationVariables
>;
export const UpdateOrganizationUserDocument = gql`
	mutation UpdateOrganizationUser($input: OrganizationUserUpdateInput!) {
		updateOrganizationUser(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationUserMutationFn = Apollo.MutationFunction<
	UpdateOrganizationUserMutation,
	UpdateOrganizationUserMutationVariables
>;

/**
 * __useUpdateOrganizationUserMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationUserMutation, { data, loading, error }] = useUpdateOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationUserMutation,
		UpdateOrganizationUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationUserMutation,
		UpdateOrganizationUserMutationVariables
	>(UpdateOrganizationUserDocument, options);
}
export type UpdateOrganizationUserMutationHookResult = ReturnType<
	typeof useUpdateOrganizationUserMutation
>;
export type UpdateOrganizationUserMutationResult =
	Apollo.MutationResult<UpdateOrganizationUserMutation>;
export type UpdateOrganizationUserMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationUserMutation,
	UpdateOrganizationUserMutationVariables
>;
export const UpdateOrganizationDocument = gql`
	mutation UpdateOrganization($input: OrganizationUpdateInput!) {
		updateOrganization(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<
	UpdateOrganizationMutation,
	UpdateOrganizationMutationVariables
>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationMutation,
		UpdateOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(
		UpdateOrganizationDocument,
		options
	);
}
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationMutation,
	UpdateOrganizationMutationVariables
>;
export const DeleteMyOrganizationDocument = gql`
	mutation DeleteMyOrganization {
		deleteMyOrganization {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteMyOrganizationMutationFn = Apollo.MutationFunction<
	DeleteMyOrganizationMutation,
	DeleteMyOrganizationMutationVariables
>;

/**
 * __useDeleteMyOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteMyOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyOrganizationMutation, { data, loading, error }] = useDeleteMyOrganizationMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteMyOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteMyOrganizationMutation,
		DeleteMyOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteMyOrganizationMutation, DeleteMyOrganizationMutationVariables>(
		DeleteMyOrganizationDocument,
		options
	);
}
export type DeleteMyOrganizationMutationHookResult = ReturnType<
	typeof useDeleteMyOrganizationMutation
>;
export type DeleteMyOrganizationMutationResult =
	Apollo.MutationResult<DeleteMyOrganizationMutation>;
export type DeleteMyOrganizationMutationOptions = Apollo.BaseMutationOptions<
	DeleteMyOrganizationMutation,
	DeleteMyOrganizationMutationVariables
>;
export const DeleteOrganizationDocument = gql`
	mutation DeleteOrganization($input: DeleteInput!) {
		deleteOrganization(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<
	DeleteOrganizationMutation,
	DeleteOrganizationMutationVariables
>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationMutation,
		DeleteOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(
		DeleteOrganizationDocument,
		options
	);
}
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrganizationMutation,
	DeleteOrganizationMutationVariables
>;
export const DeleteManyOrganizationDocument = gql`
	mutation DeleteManyOrganization($input: DeleteManyInput!) {
		deleteManyOrganization(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteManyOrganizationMutationFn = Apollo.MutationFunction<
	DeleteManyOrganizationMutation,
	DeleteManyOrganizationMutationVariables
>;

/**
 * __useDeleteManyOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteManyOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyOrganizationMutation, { data, loading, error }] = useDeleteManyOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyOrganizationMutation,
		DeleteManyOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteManyOrganizationMutation,
		DeleteManyOrganizationMutationVariables
	>(DeleteManyOrganizationDocument, options);
}
export type DeleteManyOrganizationMutationHookResult = ReturnType<
	typeof useDeleteManyOrganizationMutation
>;
export type DeleteManyOrganizationMutationResult =
	Apollo.MutationResult<DeleteManyOrganizationMutation>;
export type DeleteManyOrganizationMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyOrganizationMutation,
	DeleteManyOrganizationMutationVariables
>;
export const UpdateOrganizationStripeCheckoutLimitDocument = gql`
	mutation UpdateOrganizationStripeCheckoutLimit(
		$input: UpdateOrganizationStripeCheckoutLimitInput!
	) {
		updateOrganizationStripeCheckoutLimit(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationStripeCheckoutLimitMutationFn = Apollo.MutationFunction<
	UpdateOrganizationStripeCheckoutLimitMutation,
	UpdateOrganizationStripeCheckoutLimitMutationVariables
>;

/**
 * __useUpdateOrganizationStripeCheckoutLimitMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationStripeCheckoutLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationStripeCheckoutLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationStripeCheckoutLimitMutation, { data, loading, error }] = useUpdateOrganizationStripeCheckoutLimitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationStripeCheckoutLimitMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationStripeCheckoutLimitMutation,
		UpdateOrganizationStripeCheckoutLimitMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationStripeCheckoutLimitMutation,
		UpdateOrganizationStripeCheckoutLimitMutationVariables
	>(UpdateOrganizationStripeCheckoutLimitDocument, options);
}
export type UpdateOrganizationStripeCheckoutLimitMutationHookResult = ReturnType<
	typeof useUpdateOrganizationStripeCheckoutLimitMutation
>;
export type UpdateOrganizationStripeCheckoutLimitMutationResult =
	Apollo.MutationResult<UpdateOrganizationStripeCheckoutLimitMutation>;
export type UpdateOrganizationStripeCheckoutLimitMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationStripeCheckoutLimitMutation,
	UpdateOrganizationStripeCheckoutLimitMutationVariables
>;
export const UpdateOrganizationInvoiceMinimumDocument = gql`
	mutation UpdateOrganizationInvoiceMinimum($input: UpdateOrganizationInvoiceMinimumInput!) {
		updateOrganizationInvoiceMinimum(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationInvoiceMinimumMutationFn = Apollo.MutationFunction<
	UpdateOrganizationInvoiceMinimumMutation,
	UpdateOrganizationInvoiceMinimumMutationVariables
>;

/**
 * __useUpdateOrganizationInvoiceMinimumMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationInvoiceMinimumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationInvoiceMinimumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationInvoiceMinimumMutation, { data, loading, error }] = useUpdateOrganizationInvoiceMinimumMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationInvoiceMinimumMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationInvoiceMinimumMutation,
		UpdateOrganizationInvoiceMinimumMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationInvoiceMinimumMutation,
		UpdateOrganizationInvoiceMinimumMutationVariables
	>(UpdateOrganizationInvoiceMinimumDocument, options);
}
export type UpdateOrganizationInvoiceMinimumMutationHookResult = ReturnType<
	typeof useUpdateOrganizationInvoiceMinimumMutation
>;
export type UpdateOrganizationInvoiceMinimumMutationResult =
	Apollo.MutationResult<UpdateOrganizationInvoiceMinimumMutation>;
export type UpdateOrganizationInvoiceMinimumMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationInvoiceMinimumMutation,
	UpdateOrganizationInvoiceMinimumMutationVariables
>;
export const GenerateOrganizationLogoUploadUrlDocument = gql`
	mutation GenerateOrganizationLogoUploadUrl($input: GenerateOrganizationLogoUploadUrlInput!) {
		generateOrganizationLogoUploadUrl(input: $input) {
			success
			message
			uploadUrl
			blobUrl
			expiresAt
		}
	}
`;
export type GenerateOrganizationLogoUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateOrganizationLogoUploadUrlMutation,
	GenerateOrganizationLogoUploadUrlMutationVariables
>;

/**
 * __useGenerateOrganizationLogoUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateOrganizationLogoUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOrganizationLogoUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOrganizationLogoUploadUrlMutation, { data, loading, error }] = useGenerateOrganizationLogoUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateOrganizationLogoUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateOrganizationLogoUploadUrlMutation,
		GenerateOrganizationLogoUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateOrganizationLogoUploadUrlMutation,
		GenerateOrganizationLogoUploadUrlMutationVariables
	>(GenerateOrganizationLogoUploadUrlDocument, options);
}
export type GenerateOrganizationLogoUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateOrganizationLogoUploadUrlMutation
>;
export type GenerateOrganizationLogoUploadUrlMutationResult =
	Apollo.MutationResult<GenerateOrganizationLogoUploadUrlMutation>;
export type GenerateOrganizationLogoUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateOrganizationLogoUploadUrlMutation,
	GenerateOrganizationLogoUploadUrlMutationVariables
>;
export const SaveOrganizationLogoDocument = gql`
	mutation SaveOrganizationLogo($input: SaveOrganizationLogoInput!) {
		saveOrganizationLogo(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type SaveOrganizationLogoMutationFn = Apollo.MutationFunction<
	SaveOrganizationLogoMutation,
	SaveOrganizationLogoMutationVariables
>;

/**
 * __useSaveOrganizationLogoMutation__
 *
 * To run a mutation, you first call `useSaveOrganizationLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOrganizationLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOrganizationLogoMutation, { data, loading, error }] = useSaveOrganizationLogoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveOrganizationLogoMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SaveOrganizationLogoMutation,
		SaveOrganizationLogoMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SaveOrganizationLogoMutation, SaveOrganizationLogoMutationVariables>(
		SaveOrganizationLogoDocument,
		options
	);
}
export type SaveOrganizationLogoMutationHookResult = ReturnType<
	typeof useSaveOrganizationLogoMutation
>;
export type SaveOrganizationLogoMutationResult =
	Apollo.MutationResult<SaveOrganizationLogoMutation>;
export type SaveOrganizationLogoMutationOptions = Apollo.BaseMutationOptions<
	SaveOrganizationLogoMutation,
	SaveOrganizationLogoMutationVariables
>;
export const UpdateOrganizationApprovalAndMarginDocument = gql`
	mutation UpdateOrganizationApprovalAndMargin(
		$input: UpdateOrganizationApprovalAndMarginInput!
	) {
		updateOrganizationApprovalAndMargin(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationApprovalAndMarginMutationFn = Apollo.MutationFunction<
	UpdateOrganizationApprovalAndMarginMutation,
	UpdateOrganizationApprovalAndMarginMutationVariables
>;

/**
 * __useUpdateOrganizationApprovalAndMarginMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationApprovalAndMarginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationApprovalAndMarginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationApprovalAndMarginMutation, { data, loading, error }] = useUpdateOrganizationApprovalAndMarginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationApprovalAndMarginMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationApprovalAndMarginMutation,
		UpdateOrganizationApprovalAndMarginMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationApprovalAndMarginMutation,
		UpdateOrganizationApprovalAndMarginMutationVariables
	>(UpdateOrganizationApprovalAndMarginDocument, options);
}
export type UpdateOrganizationApprovalAndMarginMutationHookResult = ReturnType<
	typeof useUpdateOrganizationApprovalAndMarginMutation
>;
export type UpdateOrganizationApprovalAndMarginMutationResult =
	Apollo.MutationResult<UpdateOrganizationApprovalAndMarginMutation>;
export type UpdateOrganizationApprovalAndMarginMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationApprovalAndMarginMutation,
	UpdateOrganizationApprovalAndMarginMutationVariables
>;
export const UpdateOrganizationPaymentModeDocument = gql`
	mutation UpdateOrganizationPaymentMode($input: UpdateOrganizationPaymentModeInput!) {
		updateOrganizationPaymentMode(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationPaymentModeMutationFn = Apollo.MutationFunction<
	UpdateOrganizationPaymentModeMutation,
	UpdateOrganizationPaymentModeMutationVariables
>;

/**
 * __useUpdateOrganizationPaymentModeMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationPaymentModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationPaymentModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationPaymentModeMutation, { data, loading, error }] = useUpdateOrganizationPaymentModeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationPaymentModeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationPaymentModeMutation,
		UpdateOrganizationPaymentModeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationPaymentModeMutation,
		UpdateOrganizationPaymentModeMutationVariables
	>(UpdateOrganizationPaymentModeDocument, options);
}
export type UpdateOrganizationPaymentModeMutationHookResult = ReturnType<
	typeof useUpdateOrganizationPaymentModeMutation
>;
export type UpdateOrganizationPaymentModeMutationResult =
	Apollo.MutationResult<UpdateOrganizationPaymentModeMutation>;
export type UpdateOrganizationPaymentModeMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationPaymentModeMutation,
	UpdateOrganizationPaymentModeMutationVariables
>;
export const UpdateOrganizationPaymentTermsDocument = gql`
	mutation UpdateOrganizationPaymentTerms($input: UpdateOrganizationPaymentTermsInput!) {
		updateOrganizationPaymentTerms(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationPaymentTermsMutationFn = Apollo.MutationFunction<
	UpdateOrganizationPaymentTermsMutation,
	UpdateOrganizationPaymentTermsMutationVariables
>;

/**
 * __useUpdateOrganizationPaymentTermsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationPaymentTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationPaymentTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationPaymentTermsMutation, { data, loading, error }] = useUpdateOrganizationPaymentTermsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationPaymentTermsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationPaymentTermsMutation,
		UpdateOrganizationPaymentTermsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationPaymentTermsMutation,
		UpdateOrganizationPaymentTermsMutationVariables
	>(UpdateOrganizationPaymentTermsDocument, options);
}
export type UpdateOrganizationPaymentTermsMutationHookResult = ReturnType<
	typeof useUpdateOrganizationPaymentTermsMutation
>;
export type UpdateOrganizationPaymentTermsMutationResult =
	Apollo.MutationResult<UpdateOrganizationPaymentTermsMutation>;
export type UpdateOrganizationPaymentTermsMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationPaymentTermsMutation,
	UpdateOrganizationPaymentTermsMutationVariables
>;
export const CreateOrganizationAddressDocument = gql`
	mutation CreateOrganizationAddress($organizationId: ID!, $input: OrganizationAddressInput!) {
		createOrganizationAddress(organizationId: $organizationId, input: $input) {
			id
		}
	}
`;
export type CreateOrganizationAddressMutationFn = Apollo.MutationFunction<
	CreateOrganizationAddressMutation,
	CreateOrganizationAddressMutationVariables
>;

/**
 * __useCreateOrganizationAddressMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationAddressMutation, { data, loading, error }] = useCreateOrganizationAddressMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationAddressMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationAddressMutation,
		CreateOrganizationAddressMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationAddressMutation,
		CreateOrganizationAddressMutationVariables
	>(CreateOrganizationAddressDocument, options);
}
export type CreateOrganizationAddressMutationHookResult = ReturnType<
	typeof useCreateOrganizationAddressMutation
>;
export type CreateOrganizationAddressMutationResult =
	Apollo.MutationResult<CreateOrganizationAddressMutation>;
export type CreateOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationAddressMutation,
	CreateOrganizationAddressMutationVariables
>;
export const UpdateOrganizationAddressDocument = gql`
	mutation UpdateOrganizationAddress($id: ID!, $input: OrganizationAddressInput!) {
		updateOrganizationAddress(id: $id, input: $input) {
			id
		}
	}
`;
export type UpdateOrganizationAddressMutationFn = Apollo.MutationFunction<
	UpdateOrganizationAddressMutation,
	UpdateOrganizationAddressMutationVariables
>;

/**
 * __useUpdateOrganizationAddressMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAddressMutation, { data, loading, error }] = useUpdateOrganizationAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationAddressMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationAddressMutation,
		UpdateOrganizationAddressMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationAddressMutation,
		UpdateOrganizationAddressMutationVariables
	>(UpdateOrganizationAddressDocument, options);
}
export type UpdateOrganizationAddressMutationHookResult = ReturnType<
	typeof useUpdateOrganizationAddressMutation
>;
export type UpdateOrganizationAddressMutationResult =
	Apollo.MutationResult<UpdateOrganizationAddressMutation>;
export type UpdateOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationAddressMutation,
	UpdateOrganizationAddressMutationVariables
>;
export const DeleteOrganizationAddressDocument = gql`
	mutation DeleteOrganizationAddress($id: ID!) {
		deleteOrganizationAddress(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteOrganizationAddressMutationFn = Apollo.MutationFunction<
	DeleteOrganizationAddressMutation,
	DeleteOrganizationAddressMutationVariables
>;

/**
 * __useDeleteOrganizationAddressMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationAddressMutation, { data, loading, error }] = useDeleteOrganizationAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationAddressMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationAddressMutation,
		DeleteOrganizationAddressMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteOrganizationAddressMutation,
		DeleteOrganizationAddressMutationVariables
	>(DeleteOrganizationAddressDocument, options);
}
export type DeleteOrganizationAddressMutationHookResult = ReturnType<
	typeof useDeleteOrganizationAddressMutation
>;
export type DeleteOrganizationAddressMutationResult =
	Apollo.MutationResult<DeleteOrganizationAddressMutation>;
export type DeleteOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrganizationAddressMutation,
	DeleteOrganizationAddressMutationVariables
>;
export const SetOrganizationInvoiceRecipientsDocument = gql`
	mutation SetOrganizationInvoiceRecipients($input: SetOrganizationInvoiceRecipientsInput!) {
		setOrganizationInvoiceRecipients(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type SetOrganizationInvoiceRecipientsMutationFn = Apollo.MutationFunction<
	SetOrganizationInvoiceRecipientsMutation,
	SetOrganizationInvoiceRecipientsMutationVariables
>;

/**
 * __useSetOrganizationInvoiceRecipientsMutation__
 *
 * To run a mutation, you first call `useSetOrganizationInvoiceRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganizationInvoiceRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganizationInvoiceRecipientsMutation, { data, loading, error }] = useSetOrganizationInvoiceRecipientsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetOrganizationInvoiceRecipientsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetOrganizationInvoiceRecipientsMutation,
		SetOrganizationInvoiceRecipientsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SetOrganizationInvoiceRecipientsMutation,
		SetOrganizationInvoiceRecipientsMutationVariables
	>(SetOrganizationInvoiceRecipientsDocument, options);
}
export type SetOrganizationInvoiceRecipientsMutationHookResult = ReturnType<
	typeof useSetOrganizationInvoiceRecipientsMutation
>;
export type SetOrganizationInvoiceRecipientsMutationResult =
	Apollo.MutationResult<SetOrganizationInvoiceRecipientsMutation>;
export type SetOrganizationInvoiceRecipientsMutationOptions = Apollo.BaseMutationOptions<
	SetOrganizationInvoiceRecipientsMutation,
	SetOrganizationInvoiceRecipientsMutationVariables
>;
export const InviteOrganizationUserDocument = gql`
	mutation InviteOrganizationUser($input: InviteOrganizationUserInput!) {
		inviteOrganizationUser(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type InviteOrganizationUserMutationFn = Apollo.MutationFunction<
	InviteOrganizationUserMutation,
	InviteOrganizationUserMutationVariables
>;

/**
 * __useInviteOrganizationUserMutation__
 *
 * To run a mutation, you first call `useInviteOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteOrganizationUserMutation, { data, loading, error }] = useInviteOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteOrganizationUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InviteOrganizationUserMutation,
		InviteOrganizationUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InviteOrganizationUserMutation,
		InviteOrganizationUserMutationVariables
	>(InviteOrganizationUserDocument, options);
}
export type InviteOrganizationUserMutationHookResult = ReturnType<
	typeof useInviteOrganizationUserMutation
>;
export type InviteOrganizationUserMutationResult =
	Apollo.MutationResult<InviteOrganizationUserMutation>;
export type InviteOrganizationUserMutationOptions = Apollo.BaseMutationOptions<
	InviteOrganizationUserMutation,
	InviteOrganizationUserMutationVariables
>;
export const CreateOrganizationIndustryDocument = gql`
	mutation CreateOrganizationIndustry($input: CreateOrganizationIndustryInput!) {
		createOrganizationIndustry(input: $input) {
			id
			name
			isPublished
			createdByOrganizationId
		}
	}
`;
export type CreateOrganizationIndustryMutationFn = Apollo.MutationFunction<
	CreateOrganizationIndustryMutation,
	CreateOrganizationIndustryMutationVariables
>;

/**
 * __useCreateOrganizationIndustryMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationIndustryMutation, { data, loading, error }] = useCreateOrganizationIndustryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationIndustryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationIndustryMutation,
		CreateOrganizationIndustryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationIndustryMutation,
		CreateOrganizationIndustryMutationVariables
	>(CreateOrganizationIndustryDocument, options);
}
export type CreateOrganizationIndustryMutationHookResult = ReturnType<
	typeof useCreateOrganizationIndustryMutation
>;
export type CreateOrganizationIndustryMutationResult =
	Apollo.MutationResult<CreateOrganizationIndustryMutation>;
export type CreateOrganizationIndustryMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationIndustryMutation,
	CreateOrganizationIndustryMutationVariables
>;
export const PublishOrganizationIndustryDocument = gql`
	mutation PublishOrganizationIndustry($id: ID!) {
		publishOrganizationIndustry(id: $id) {
			id
			name
			isPublished
		}
	}
`;
export type PublishOrganizationIndustryMutationFn = Apollo.MutationFunction<
	PublishOrganizationIndustryMutation,
	PublishOrganizationIndustryMutationVariables
>;

/**
 * __usePublishOrganizationIndustryMutation__
 *
 * To run a mutation, you first call `usePublishOrganizationIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishOrganizationIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishOrganizationIndustryMutation, { data, loading, error }] = usePublishOrganizationIndustryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishOrganizationIndustryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PublishOrganizationIndustryMutation,
		PublishOrganizationIndustryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PublishOrganizationIndustryMutation,
		PublishOrganizationIndustryMutationVariables
	>(PublishOrganizationIndustryDocument, options);
}
export type PublishOrganizationIndustryMutationHookResult = ReturnType<
	typeof usePublishOrganizationIndustryMutation
>;
export type PublishOrganizationIndustryMutationResult =
	Apollo.MutationResult<PublishOrganizationIndustryMutation>;
export type PublishOrganizationIndustryMutationOptions = Apollo.BaseMutationOptions<
	PublishOrganizationIndustryMutation,
	PublishOrganizationIndustryMutationVariables
>;
export const UpdateOrganizationIndustryDocument = gql`
	mutation UpdateOrganizationIndustry($input: UpdateOrganizationIndustryInput!) {
		updateOrganizationIndustry(input: $input) {
			id
			name
			isPublished
		}
	}
`;
export type UpdateOrganizationIndustryMutationFn = Apollo.MutationFunction<
	UpdateOrganizationIndustryMutation,
	UpdateOrganizationIndustryMutationVariables
>;

/**
 * __useUpdateOrganizationIndustryMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationIndustryMutation, { data, loading, error }] = useUpdateOrganizationIndustryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationIndustryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationIndustryMutation,
		UpdateOrganizationIndustryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationIndustryMutation,
		UpdateOrganizationIndustryMutationVariables
	>(UpdateOrganizationIndustryDocument, options);
}
export type UpdateOrganizationIndustryMutationHookResult = ReturnType<
	typeof useUpdateOrganizationIndustryMutation
>;
export type UpdateOrganizationIndustryMutationResult =
	Apollo.MutationResult<UpdateOrganizationIndustryMutation>;
export type UpdateOrganizationIndustryMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationIndustryMutation,
	UpdateOrganizationIndustryMutationVariables
>;
export const DeleteOrganizationIndustryDocument = gql`
	mutation DeleteOrganizationIndustry($input: DeleteOrganizationIndustryInput!) {
		deleteOrganizationIndustry(input: $input) {
			success
			message
		}
	}
`;
export type DeleteOrganizationIndustryMutationFn = Apollo.MutationFunction<
	DeleteOrganizationIndustryMutation,
	DeleteOrganizationIndustryMutationVariables
>;

/**
 * __useDeleteOrganizationIndustryMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationIndustryMutation, { data, loading, error }] = useDeleteOrganizationIndustryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganizationIndustryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationIndustryMutation,
		DeleteOrganizationIndustryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteOrganizationIndustryMutation,
		DeleteOrganizationIndustryMutationVariables
	>(DeleteOrganizationIndustryDocument, options);
}
export type DeleteOrganizationIndustryMutationHookResult = ReturnType<
	typeof useDeleteOrganizationIndustryMutation
>;
export type DeleteOrganizationIndustryMutationResult =
	Apollo.MutationResult<DeleteOrganizationIndustryMutation>;
export type DeleteOrganizationIndustryMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrganizationIndustryMutation,
	DeleteOrganizationIndustryMutationVariables
>;
export const ConfirmPendingOfferAcceptanceDocument = gql`
	mutation ConfirmPendingOfferAcceptance($orderQuoteId: ID!) {
		confirmPendingOfferAcceptance(orderQuoteId: $orderQuoteId) {
			success
			message
			orderId
			pendingReview
		}
	}
`;
export type ConfirmPendingOfferAcceptanceMutationFn = Apollo.MutationFunction<
	ConfirmPendingOfferAcceptanceMutation,
	ConfirmPendingOfferAcceptanceMutationVariables
>;

/**
 * __useConfirmPendingOfferAcceptanceMutation__
 *
 * To run a mutation, you first call `useConfirmPendingOfferAcceptanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPendingOfferAcceptanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPendingOfferAcceptanceMutation, { data, loading, error }] = useConfirmPendingOfferAcceptanceMutation({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *   },
 * });
 */
export function useConfirmPendingOfferAcceptanceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmPendingOfferAcceptanceMutation,
		ConfirmPendingOfferAcceptanceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmPendingOfferAcceptanceMutation,
		ConfirmPendingOfferAcceptanceMutationVariables
	>(ConfirmPendingOfferAcceptanceDocument, options);
}
export type ConfirmPendingOfferAcceptanceMutationHookResult = ReturnType<
	typeof useConfirmPendingOfferAcceptanceMutation
>;
export type ConfirmPendingOfferAcceptanceMutationResult =
	Apollo.MutationResult<ConfirmPendingOfferAcceptanceMutation>;
export type ConfirmPendingOfferAcceptanceMutationOptions = Apollo.BaseMutationOptions<
	ConfirmPendingOfferAcceptanceMutation,
	ConfirmPendingOfferAcceptanceMutationVariables
>;
export const RejectPendingOfferAcceptanceDocument = gql`
	mutation RejectPendingOfferAcceptance($orderQuoteId: ID!, $reason: String) {
		rejectPendingOfferAcceptance(orderQuoteId: $orderQuoteId, reason: $reason) {
			success
			message
			orderId
			pendingReview
		}
	}
`;
export type RejectPendingOfferAcceptanceMutationFn = Apollo.MutationFunction<
	RejectPendingOfferAcceptanceMutation,
	RejectPendingOfferAcceptanceMutationVariables
>;

/**
 * __useRejectPendingOfferAcceptanceMutation__
 *
 * To run a mutation, you first call `useRejectPendingOfferAcceptanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectPendingOfferAcceptanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectPendingOfferAcceptanceMutation, { data, loading, error }] = useRejectPendingOfferAcceptanceMutation({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectPendingOfferAcceptanceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RejectPendingOfferAcceptanceMutation,
		RejectPendingOfferAcceptanceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RejectPendingOfferAcceptanceMutation,
		RejectPendingOfferAcceptanceMutationVariables
	>(RejectPendingOfferAcceptanceDocument, options);
}
export type RejectPendingOfferAcceptanceMutationHookResult = ReturnType<
	typeof useRejectPendingOfferAcceptanceMutation
>;
export type RejectPendingOfferAcceptanceMutationResult =
	Apollo.MutationResult<RejectPendingOfferAcceptanceMutation>;
export type RejectPendingOfferAcceptanceMutationOptions = Apollo.BaseMutationOptions<
	RejectPendingOfferAcceptanceMutation,
	RejectPendingOfferAcceptanceMutationVariables
>;
export const ReviseLateOfferAcceptanceDocument = gql`
	mutation ReviseLateOfferAcceptance($orderQuoteId: ID!) {
		reviseLateOfferAcceptance(orderQuoteId: $orderQuoteId) {
			success
			message
			orderId
			pendingReview
		}
	}
`;
export type ReviseLateOfferAcceptanceMutationFn = Apollo.MutationFunction<
	ReviseLateOfferAcceptanceMutation,
	ReviseLateOfferAcceptanceMutationVariables
>;

/**
 * __useReviseLateOfferAcceptanceMutation__
 *
 * To run a mutation, you first call `useReviseLateOfferAcceptanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviseLateOfferAcceptanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviseLateOfferAcceptanceMutation, { data, loading, error }] = useReviseLateOfferAcceptanceMutation({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *   },
 * });
 */
export function useReviseLateOfferAcceptanceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReviseLateOfferAcceptanceMutation,
		ReviseLateOfferAcceptanceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ReviseLateOfferAcceptanceMutation,
		ReviseLateOfferAcceptanceMutationVariables
	>(ReviseLateOfferAcceptanceDocument, options);
}
export type ReviseLateOfferAcceptanceMutationHookResult = ReturnType<
	typeof useReviseLateOfferAcceptanceMutation
>;
export type ReviseLateOfferAcceptanceMutationResult =
	Apollo.MutationResult<ReviseLateOfferAcceptanceMutation>;
export type ReviseLateOfferAcceptanceMutationOptions = Apollo.BaseMutationOptions<
	ReviseLateOfferAcceptanceMutation,
	ReviseLateOfferAcceptanceMutationVariables
>;
export const CreateProductDocument = gql`
	mutation CreateProduct($input: ProductCreateInput!) {
		createProduct(input: $input) {
			success
			message
			referenceKey
		}
	}
`;
export type CreateProductMutationFn = Apollo.MutationFunction<
	CreateProductMutation,
	CreateProductMutationVariables
>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(
	baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(
		CreateProductDocument,
		options
	);
}
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<
	CreateProductMutation,
	CreateProductMutationVariables
>;
export const UpdateProductDocument = gql`
	mutation UpdateProduct($input: ProductUpdateInput!) {
		updateProduct(input: $input) {
			success
			message
		}
	}
`;
export type UpdateProductMutationFn = Apollo.MutationFunction<
	UpdateProductMutation,
	UpdateProductMutationVariables
>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(
	baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(
		UpdateProductDocument,
		options
	);
}
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<
	UpdateProductMutation,
	UpdateProductMutationVariables
>;
export const GenerateProductImageUploadUrlDocument = gql`
	mutation GenerateProductImageUploadUrl($input: ProductImageUploadInput!) {
		generateProductImageUploadUrl(input: $input) {
			success
			message
			uploadUrl
			imageId
			blobUrl
			expiresAt
		}
	}
`;
export type GenerateProductImageUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateProductImageUploadUrlMutation,
	GenerateProductImageUploadUrlMutationVariables
>;

/**
 * __useGenerateProductImageUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateProductImageUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProductImageUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProductImageUploadUrlMutation, { data, loading, error }] = useGenerateProductImageUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateProductImageUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateProductImageUploadUrlMutation,
		GenerateProductImageUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateProductImageUploadUrlMutation,
		GenerateProductImageUploadUrlMutationVariables
	>(GenerateProductImageUploadUrlDocument, options);
}
export type GenerateProductImageUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateProductImageUploadUrlMutation
>;
export type GenerateProductImageUploadUrlMutationResult =
	Apollo.MutationResult<GenerateProductImageUploadUrlMutation>;
export type GenerateProductImageUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateProductImageUploadUrlMutation,
	GenerateProductImageUploadUrlMutationVariables
>;
export const ConfirmProductImageUploadDocument = gql`
	mutation ConfirmProductImageUpload($input: ConfirmProductImageUploadInput!) {
		confirmProductImageUpload(input: $input) {
			success
			message
		}
	}
`;
export type ConfirmProductImageUploadMutationFn = Apollo.MutationFunction<
	ConfirmProductImageUploadMutation,
	ConfirmProductImageUploadMutationVariables
>;

/**
 * __useConfirmProductImageUploadMutation__
 *
 * To run a mutation, you first call `useConfirmProductImageUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmProductImageUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmProductImageUploadMutation, { data, loading, error }] = useConfirmProductImageUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmProductImageUploadMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmProductImageUploadMutation,
		ConfirmProductImageUploadMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmProductImageUploadMutation,
		ConfirmProductImageUploadMutationVariables
	>(ConfirmProductImageUploadDocument, options);
}
export type ConfirmProductImageUploadMutationHookResult = ReturnType<
	typeof useConfirmProductImageUploadMutation
>;
export type ConfirmProductImageUploadMutationResult =
	Apollo.MutationResult<ConfirmProductImageUploadMutation>;
export type ConfirmProductImageUploadMutationOptions = Apollo.BaseMutationOptions<
	ConfirmProductImageUploadMutation,
	ConfirmProductImageUploadMutationVariables
>;
export const DeleteProductImageDocument = gql`
	mutation DeleteProductImage($productId: ID!, $imageId: ID!) {
		deleteProductImage(productId: $productId, imageId: $imageId) {
			success
			message
		}
	}
`;
export type DeleteProductImageMutationFn = Apollo.MutationFunction<
	DeleteProductImageMutation,
	DeleteProductImageMutationVariables
>;

/**
 * __useDeleteProductImageMutation__
 *
 * To run a mutation, you first call `useDeleteProductImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductImageMutation, { data, loading, error }] = useDeleteProductImageMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useDeleteProductImageMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteProductImageMutation,
		DeleteProductImageMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteProductImageMutation, DeleteProductImageMutationVariables>(
		DeleteProductImageDocument,
		options
	);
}
export type DeleteProductImageMutationHookResult = ReturnType<typeof useDeleteProductImageMutation>;
export type DeleteProductImageMutationResult = Apollo.MutationResult<DeleteProductImageMutation>;
export type DeleteProductImageMutationOptions = Apollo.BaseMutationOptions<
	DeleteProductImageMutation,
	DeleteProductImageMutationVariables
>;
export const UpdateProductImagePrimaryDocument = gql`
	mutation UpdateProductImagePrimary($productId: ID!, $imageId: ID!) {
		updateProductImagePrimary(productId: $productId, imageId: $imageId) {
			success
			message
		}
	}
`;
export type UpdateProductImagePrimaryMutationFn = Apollo.MutationFunction<
	UpdateProductImagePrimaryMutation,
	UpdateProductImagePrimaryMutationVariables
>;

/**
 * __useUpdateProductImagePrimaryMutation__
 *
 * To run a mutation, you first call `useUpdateProductImagePrimaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductImagePrimaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductImagePrimaryMutation, { data, loading, error }] = useUpdateProductImagePrimaryMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useUpdateProductImagePrimaryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateProductImagePrimaryMutation,
		UpdateProductImagePrimaryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateProductImagePrimaryMutation,
		UpdateProductImagePrimaryMutationVariables
	>(UpdateProductImagePrimaryDocument, options);
}
export type UpdateProductImagePrimaryMutationHookResult = ReturnType<
	typeof useUpdateProductImagePrimaryMutation
>;
export type UpdateProductImagePrimaryMutationResult =
	Apollo.MutationResult<UpdateProductImagePrimaryMutation>;
export type UpdateProductImagePrimaryMutationOptions = Apollo.BaseMutationOptions<
	UpdateProductImagePrimaryMutation,
	UpdateProductImagePrimaryMutationVariables
>;
export const UpdateProductImageCropDocument = gql`
	mutation UpdateProductImageCrop($productId: ID!, $imageId: ID!, $crop: ProductImageCropInput) {
		updateProductImageCrop(productId: $productId, imageId: $imageId, crop: $crop) {
			success
			message
		}
	}
`;
export type UpdateProductImageCropMutationFn = Apollo.MutationFunction<
	UpdateProductImageCropMutation,
	UpdateProductImageCropMutationVariables
>;

/**
 * __useUpdateProductImageCropMutation__
 *
 * To run a mutation, you first call `useUpdateProductImageCropMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductImageCropMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductImageCropMutation, { data, loading, error }] = useUpdateProductImageCropMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      imageId: // value for 'imageId'
 *      crop: // value for 'crop'
 *   },
 * });
 */
export function useUpdateProductImageCropMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateProductImageCropMutation,
		UpdateProductImageCropMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateProductImageCropMutation,
		UpdateProductImageCropMutationVariables
	>(UpdateProductImageCropDocument, options);
}
export type UpdateProductImageCropMutationHookResult = ReturnType<
	typeof useUpdateProductImageCropMutation
>;
export type UpdateProductImageCropMutationResult =
	Apollo.MutationResult<UpdateProductImageCropMutation>;
export type UpdateProductImageCropMutationOptions = Apollo.BaseMutationOptions<
	UpdateProductImageCropMutation,
	UpdateProductImageCropMutationVariables
>;
export const DeleteProductDocument = gql`
	mutation DeleteProduct($input: DeleteInput!) {
		deleteProduct(input: $input) {
			success
			message
		}
	}
`;
export type DeleteProductMutationFn = Apollo.MutationFunction<
	DeleteProductMutation,
	DeleteProductMutationVariables
>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductMutation(
	baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(
		DeleteProductDocument,
		options
	);
}
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<
	DeleteProductMutation,
	DeleteProductMutationVariables
>;
export const DuplicateProductDocument = gql`
	mutation DuplicateProduct($input: DuplicateProductInput!) {
		duplicateProduct(input: $input) {
			success
			message
			referenceKey
		}
	}
`;
export type DuplicateProductMutationFn = Apollo.MutationFunction<
	DuplicateProductMutation,
	DuplicateProductMutationVariables
>;

/**
 * __useDuplicateProductMutation__
 *
 * To run a mutation, you first call `useDuplicateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateProductMutation, { data, loading, error }] = useDuplicateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateProductMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DuplicateProductMutation,
		DuplicateProductMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DuplicateProductMutation, DuplicateProductMutationVariables>(
		DuplicateProductDocument,
		options
	);
}
export type DuplicateProductMutationHookResult = ReturnType<typeof useDuplicateProductMutation>;
export type DuplicateProductMutationResult = Apollo.MutationResult<DuplicateProductMutation>;
export type DuplicateProductMutationOptions = Apollo.BaseMutationOptions<
	DuplicateProductMutation,
	DuplicateProductMutationVariables
>;
export const DeleteManyProductDocument = gql`
	mutation DeleteManyProduct($input: DeleteManyInput!) {
		deleteManyProduct(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteManyProductMutationFn = Apollo.MutationFunction<
	DeleteManyProductMutation,
	DeleteManyProductMutationVariables
>;

/**
 * __useDeleteManyProductMutation__
 *
 * To run a mutation, you first call `useDeleteManyProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyProductMutation, { data, loading, error }] = useDeleteManyProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyProductMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyProductMutation,
		DeleteManyProductMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteManyProductMutation, DeleteManyProductMutationVariables>(
		DeleteManyProductDocument,
		options
	);
}
export type DeleteManyProductMutationHookResult = ReturnType<typeof useDeleteManyProductMutation>;
export type DeleteManyProductMutationResult = Apollo.MutationResult<DeleteManyProductMutation>;
export type DeleteManyProductMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyProductMutation,
	DeleteManyProductMutationVariables
>;
export const AssignProductsToOrganizationDocument = gql`
	mutation AssignProductsToOrganization($productIds: [ID!]!, $organizationId: ID, $brandId: ID) {
		assignProductsToOrganization(
			productIds: $productIds
			organizationId: $organizationId
			brandId: $brandId
		) {
			success
			message
		}
	}
`;
export type AssignProductsToOrganizationMutationFn = Apollo.MutationFunction<
	AssignProductsToOrganizationMutation,
	AssignProductsToOrganizationMutationVariables
>;

/**
 * __useAssignProductsToOrganizationMutation__
 *
 * To run a mutation, you first call `useAssignProductsToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignProductsToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignProductsToOrganizationMutation, { data, loading, error }] = useAssignProductsToOrganizationMutation({
 *   variables: {
 *      productIds: // value for 'productIds'
 *      organizationId: // value for 'organizationId'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useAssignProductsToOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AssignProductsToOrganizationMutation,
		AssignProductsToOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AssignProductsToOrganizationMutation,
		AssignProductsToOrganizationMutationVariables
	>(AssignProductsToOrganizationDocument, options);
}
export type AssignProductsToOrganizationMutationHookResult = ReturnType<
	typeof useAssignProductsToOrganizationMutation
>;
export type AssignProductsToOrganizationMutationResult =
	Apollo.MutationResult<AssignProductsToOrganizationMutation>;
export type AssignProductsToOrganizationMutationOptions = Apollo.BaseMutationOptions<
	AssignProductsToOrganizationMutation,
	AssignProductsToOrganizationMutationVariables
>;
export const CompleteRecommendationDocument = gql`
	mutation CompleteRecommendation($input: CompleteRecommendationInput!) {
		completeRecommendation(input: $input) {
			success
			message
			productId
			studioFileId
		}
	}
`;
export type CompleteRecommendationMutationFn = Apollo.MutationFunction<
	CompleteRecommendationMutation,
	CompleteRecommendationMutationVariables
>;

/**
 * __useCompleteRecommendationMutation__
 *
 * To run a mutation, you first call `useCompleteRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeRecommendationMutation, { data, loading, error }] = useCompleteRecommendationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteRecommendationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CompleteRecommendationMutation,
		CompleteRecommendationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CompleteRecommendationMutation,
		CompleteRecommendationMutationVariables
	>(CompleteRecommendationDocument, options);
}
export type CompleteRecommendationMutationHookResult = ReturnType<
	typeof useCompleteRecommendationMutation
>;
export type CompleteRecommendationMutationResult =
	Apollo.MutationResult<CompleteRecommendationMutation>;
export type CompleteRecommendationMutationOptions = Apollo.BaseMutationOptions<
	CompleteRecommendationMutation,
	CompleteRecommendationMutationVariables
>;
export const PublishProductsToCommunityDocument = gql`
	mutation PublishProductsToCommunity($productIds: [ID!]!) {
		publishProductsToCommunity(productIds: $productIds) {
			success
			message
			referenceKey
			errors {
				field
				message
			}
		}
	}
`;
export type PublishProductsToCommunityMutationFn = Apollo.MutationFunction<
	PublishProductsToCommunityMutation,
	PublishProductsToCommunityMutationVariables
>;

/**
 * __usePublishProductsToCommunityMutation__
 *
 * To run a mutation, you first call `usePublishProductsToCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishProductsToCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishProductsToCommunityMutation, { data, loading, error }] = usePublishProductsToCommunityMutation({
 *   variables: {
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function usePublishProductsToCommunityMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PublishProductsToCommunityMutation,
		PublishProductsToCommunityMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PublishProductsToCommunityMutation,
		PublishProductsToCommunityMutationVariables
	>(PublishProductsToCommunityDocument, options);
}
export type PublishProductsToCommunityMutationHookResult = ReturnType<
	typeof usePublishProductsToCommunityMutation
>;
export type PublishProductsToCommunityMutationResult =
	Apollo.MutationResult<PublishProductsToCommunityMutation>;
export type PublishProductsToCommunityMutationOptions = Apollo.BaseMutationOptions<
	PublishProductsToCommunityMutation,
	PublishProductsToCommunityMutationVariables
>;
export const UnpublishProductsFromCommunityDocument = gql`
	mutation UnpublishProductsFromCommunity($productIds: [ID!]!) {
		unpublishProductsFromCommunity(productIds: $productIds) {
			success
			message
			referenceKey
		}
	}
`;
export type UnpublishProductsFromCommunityMutationFn = Apollo.MutationFunction<
	UnpublishProductsFromCommunityMutation,
	UnpublishProductsFromCommunityMutationVariables
>;

/**
 * __useUnpublishProductsFromCommunityMutation__
 *
 * To run a mutation, you first call `useUnpublishProductsFromCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishProductsFromCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishProductsFromCommunityMutation, { data, loading, error }] = useUnpublishProductsFromCommunityMutation({
 *   variables: {
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useUnpublishProductsFromCommunityMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UnpublishProductsFromCommunityMutation,
		UnpublishProductsFromCommunityMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UnpublishProductsFromCommunityMutation,
		UnpublishProductsFromCommunityMutationVariables
	>(UnpublishProductsFromCommunityDocument, options);
}
export type UnpublishProductsFromCommunityMutationHookResult = ReturnType<
	typeof useUnpublishProductsFromCommunityMutation
>;
export type UnpublishProductsFromCommunityMutationResult =
	Apollo.MutationResult<UnpublishProductsFromCommunityMutation>;
export type UnpublishProductsFromCommunityMutationOptions = Apollo.BaseMutationOptions<
	UnpublishProductsFromCommunityMutation,
	UnpublishProductsFromCommunityMutationVariables
>;
export const CreateProductTagDocument = gql`
	mutation CreateProductTag($input: ProductTagCreateInput!) {
		createProductTag(input: $input) {
			success
			message
			referenceKey
		}
	}
`;
export type CreateProductTagMutationFn = Apollo.MutationFunction<
	CreateProductTagMutation,
	CreateProductTagMutationVariables
>;

/**
 * __useCreateProductTagMutation__
 *
 * To run a mutation, you first call `useCreateProductTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductTagMutation, { data, loading, error }] = useCreateProductTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductTagMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateProductTagMutation,
		CreateProductTagMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateProductTagMutation, CreateProductTagMutationVariables>(
		CreateProductTagDocument,
		options
	);
}
export type CreateProductTagMutationHookResult = ReturnType<typeof useCreateProductTagMutation>;
export type CreateProductTagMutationResult = Apollo.MutationResult<CreateProductTagMutation>;
export type CreateProductTagMutationOptions = Apollo.BaseMutationOptions<
	CreateProductTagMutation,
	CreateProductTagMutationVariables
>;
export const SetProductPricesDocument = gql`
	mutation SetProductPrices($input: SetProductPricesInput!) {
		setProductPrices(input: $input) {
			message
		}
	}
`;
export type SetProductPricesMutationFn = Apollo.MutationFunction<
	SetProductPricesMutation,
	SetProductPricesMutationVariables
>;

/**
 * __useSetProductPricesMutation__
 *
 * To run a mutation, you first call `useSetProductPricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProductPricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProductPricesMutation, { data, loading, error }] = useSetProductPricesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetProductPricesMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetProductPricesMutation,
		SetProductPricesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SetProductPricesMutation, SetProductPricesMutationVariables>(
		SetProductPricesDocument,
		options
	);
}
export type SetProductPricesMutationHookResult = ReturnType<typeof useSetProductPricesMutation>;
export type SetProductPricesMutationResult = Apollo.MutationResult<SetProductPricesMutation>;
export type SetProductPricesMutationOptions = Apollo.BaseMutationOptions<
	SetProductPricesMutation,
	SetProductPricesMutationVariables
>;
export const DeleteProductPriceDocument = gql`
	mutation DeleteProductPrice($input: DeleteInput!) {
		deleteProductPrice(input: $input) {
			message
		}
	}
`;
export type DeleteProductPriceMutationFn = Apollo.MutationFunction<
	DeleteProductPriceMutation,
	DeleteProductPriceMutationVariables
>;

/**
 * __useDeleteProductPriceMutation__
 *
 * To run a mutation, you first call `useDeleteProductPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductPriceMutation, { data, loading, error }] = useDeleteProductPriceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductPriceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteProductPriceMutation,
		DeleteProductPriceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteProductPriceMutation, DeleteProductPriceMutationVariables>(
		DeleteProductPriceDocument,
		options
	);
}
export type DeleteProductPriceMutationHookResult = ReturnType<typeof useDeleteProductPriceMutation>;
export type DeleteProductPriceMutationResult = Apollo.MutationResult<DeleteProductPriceMutation>;
export type DeleteProductPriceMutationOptions = Apollo.BaseMutationOptions<
	DeleteProductPriceMutation,
	DeleteProductPriceMutationVariables
>;
export const SetProductSamplePriceDocument = gql`
	mutation SetProductSamplePrice($input: SetProductSamplePriceInput!) {
		setProductSamplePrice(input: $input) {
			message
		}
	}
`;
export type SetProductSamplePriceMutationFn = Apollo.MutationFunction<
	SetProductSamplePriceMutation,
	SetProductSamplePriceMutationVariables
>;

/**
 * __useSetProductSamplePriceMutation__
 *
 * To run a mutation, you first call `useSetProductSamplePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProductSamplePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProductSamplePriceMutation, { data, loading, error }] = useSetProductSamplePriceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetProductSamplePriceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetProductSamplePriceMutation,
		SetProductSamplePriceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SetProductSamplePriceMutation,
		SetProductSamplePriceMutationVariables
	>(SetProductSamplePriceDocument, options);
}
export type SetProductSamplePriceMutationHookResult = ReturnType<
	typeof useSetProductSamplePriceMutation
>;
export type SetProductSamplePriceMutationResult =
	Apollo.MutationResult<SetProductSamplePriceMutation>;
export type SetProductSamplePriceMutationOptions = Apollo.BaseMutationOptions<
	SetProductSamplePriceMutation,
	SetProductSamplePriceMutationVariables
>;
export const DeleteProductSamplePriceDocument = gql`
	mutation DeleteProductSamplePrice($input: DeleteInput!) {
		deleteProductSamplePrice(input: $input) {
			message
		}
	}
`;
export type DeleteProductSamplePriceMutationFn = Apollo.MutationFunction<
	DeleteProductSamplePriceMutation,
	DeleteProductSamplePriceMutationVariables
>;

/**
 * __useDeleteProductSamplePriceMutation__
 *
 * To run a mutation, you first call `useDeleteProductSamplePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductSamplePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductSamplePriceMutation, { data, loading, error }] = useDeleteProductSamplePriceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductSamplePriceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteProductSamplePriceMutation,
		DeleteProductSamplePriceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteProductSamplePriceMutation,
		DeleteProductSamplePriceMutationVariables
	>(DeleteProductSamplePriceDocument, options);
}
export type DeleteProductSamplePriceMutationHookResult = ReturnType<
	typeof useDeleteProductSamplePriceMutation
>;
export type DeleteProductSamplePriceMutationResult =
	Apollo.MutationResult<DeleteProductSamplePriceMutation>;
export type DeleteProductSamplePriceMutationOptions = Apollo.BaseMutationOptions<
	DeleteProductSamplePriceMutation,
	DeleteProductSamplePriceMutationVariables
>;
export const AddQuoteProductCommentDocument = gql`
	mutation AddQuoteProductComment($input: AddQuoteProductCommentInput!) {
		addQuoteProductComment(input: $input) {
			success
			message
			comment {
				...QuoteProductCommentFields
			}
		}
	}
	${QuoteProductCommentFieldsFragmentDoc}
`;
export type AddQuoteProductCommentMutationFn = Apollo.MutationFunction<
	AddQuoteProductCommentMutation,
	AddQuoteProductCommentMutationVariables
>;

/**
 * __useAddQuoteProductCommentMutation__
 *
 * To run a mutation, you first call `useAddQuoteProductCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuoteProductCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuoteProductCommentMutation, { data, loading, error }] = useAddQuoteProductCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddQuoteProductCommentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddQuoteProductCommentMutation,
		AddQuoteProductCommentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AddQuoteProductCommentMutation,
		AddQuoteProductCommentMutationVariables
	>(AddQuoteProductCommentDocument, options);
}
export type AddQuoteProductCommentMutationHookResult = ReturnType<
	typeof useAddQuoteProductCommentMutation
>;
export type AddQuoteProductCommentMutationResult =
	Apollo.MutationResult<AddQuoteProductCommentMutation>;
export type AddQuoteProductCommentMutationOptions = Apollo.BaseMutationOptions<
	AddQuoteProductCommentMutation,
	AddQuoteProductCommentMutationVariables
>;
export const EditQuoteProductCommentDocument = gql`
	mutation EditQuoteProductComment($id: ID!, $body: String!) {
		editQuoteProductComment(id: $id, body: $body) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type EditQuoteProductCommentMutationFn = Apollo.MutationFunction<
	EditQuoteProductCommentMutation,
	EditQuoteProductCommentMutationVariables
>;

/**
 * __useEditQuoteProductCommentMutation__
 *
 * To run a mutation, you first call `useEditQuoteProductCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditQuoteProductCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editQuoteProductCommentMutation, { data, loading, error }] = useEditQuoteProductCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useEditQuoteProductCommentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EditQuoteProductCommentMutation,
		EditQuoteProductCommentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		EditQuoteProductCommentMutation,
		EditQuoteProductCommentMutationVariables
	>(EditQuoteProductCommentDocument, options);
}
export type EditQuoteProductCommentMutationHookResult = ReturnType<
	typeof useEditQuoteProductCommentMutation
>;
export type EditQuoteProductCommentMutationResult =
	Apollo.MutationResult<EditQuoteProductCommentMutation>;
export type EditQuoteProductCommentMutationOptions = Apollo.BaseMutationOptions<
	EditQuoteProductCommentMutation,
	EditQuoteProductCommentMutationVariables
>;
export const DeleteQuoteProductCommentDocument = gql`
	mutation DeleteQuoteProductComment($id: ID!) {
		deleteQuoteProductComment(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteQuoteProductCommentMutationFn = Apollo.MutationFunction<
	DeleteQuoteProductCommentMutation,
	DeleteQuoteProductCommentMutationVariables
>;

/**
 * __useDeleteQuoteProductCommentMutation__
 *
 * To run a mutation, you first call `useDeleteQuoteProductCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuoteProductCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuoteProductCommentMutation, { data, loading, error }] = useDeleteQuoteProductCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQuoteProductCommentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteQuoteProductCommentMutation,
		DeleteQuoteProductCommentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteQuoteProductCommentMutation,
		DeleteQuoteProductCommentMutationVariables
	>(DeleteQuoteProductCommentDocument, options);
}
export type DeleteQuoteProductCommentMutationHookResult = ReturnType<
	typeof useDeleteQuoteProductCommentMutation
>;
export type DeleteQuoteProductCommentMutationResult =
	Apollo.MutationResult<DeleteQuoteProductCommentMutation>;
export type DeleteQuoteProductCommentMutationOptions = Apollo.BaseMutationOptions<
	DeleteQuoteProductCommentMutation,
	DeleteQuoteProductCommentMutationVariables
>;
export const GenerateQuoteProductCommentUploadUrlDocument = gql`
	mutation GenerateQuoteProductCommentUploadUrl(
		$input: GenerateQuoteProductCommentUploadUrlInput!
	) {
		generateQuoteProductCommentUploadUrl(input: $input) {
			success
			message
			uploadUrl
			blobUrl
		}
	}
`;
export type GenerateQuoteProductCommentUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateQuoteProductCommentUploadUrlMutation,
	GenerateQuoteProductCommentUploadUrlMutationVariables
>;

/**
 * __useGenerateQuoteProductCommentUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateQuoteProductCommentUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateQuoteProductCommentUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateQuoteProductCommentUploadUrlMutation, { data, loading, error }] = useGenerateQuoteProductCommentUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateQuoteProductCommentUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateQuoteProductCommentUploadUrlMutation,
		GenerateQuoteProductCommentUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateQuoteProductCommentUploadUrlMutation,
		GenerateQuoteProductCommentUploadUrlMutationVariables
	>(GenerateQuoteProductCommentUploadUrlDocument, options);
}
export type GenerateQuoteProductCommentUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateQuoteProductCommentUploadUrlMutation
>;
export type GenerateQuoteProductCommentUploadUrlMutationResult =
	Apollo.MutationResult<GenerateQuoteProductCommentUploadUrlMutation>;
export type GenerateQuoteProductCommentUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateQuoteProductCommentUploadUrlMutation,
	GenerateQuoteProductCommentUploadUrlMutationVariables
>;
export const MarkQuoteProductThreadReadDocument = gql`
	mutation MarkQuoteProductThreadRead($input: QuoteProductThreadInput!) {
		markQuoteProductThreadRead(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type MarkQuoteProductThreadReadMutationFn = Apollo.MutationFunction<
	MarkQuoteProductThreadReadMutation,
	MarkQuoteProductThreadReadMutationVariables
>;

/**
 * __useMarkQuoteProductThreadReadMutation__
 *
 * To run a mutation, you first call `useMarkQuoteProductThreadReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkQuoteProductThreadReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markQuoteProductThreadReadMutation, { data, loading, error }] = useMarkQuoteProductThreadReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkQuoteProductThreadReadMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MarkQuoteProductThreadReadMutation,
		MarkQuoteProductThreadReadMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		MarkQuoteProductThreadReadMutation,
		MarkQuoteProductThreadReadMutationVariables
	>(MarkQuoteProductThreadReadDocument, options);
}
export type MarkQuoteProductThreadReadMutationHookResult = ReturnType<
	typeof useMarkQuoteProductThreadReadMutation
>;
export type MarkQuoteProductThreadReadMutationResult =
	Apollo.MutationResult<MarkQuoteProductThreadReadMutation>;
export type MarkQuoteProductThreadReadMutationOptions = Apollo.BaseMutationOptions<
	MarkQuoteProductThreadReadMutation,
	MarkQuoteProductThreadReadMutationVariables
>;
export const RejectOrderQuoteOfferBatchDocument = gql`
	mutation RejectOrderQuoteOfferBatch($input: RejectOrderQuoteOfferBatchInput!) {
		rejectOrderQuoteOfferBatch(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RejectOrderQuoteOfferBatchMutationFn = Apollo.MutationFunction<
	RejectOrderQuoteOfferBatchMutation,
	RejectOrderQuoteOfferBatchMutationVariables
>;

/**
 * __useRejectOrderQuoteOfferBatchMutation__
 *
 * To run a mutation, you first call `useRejectOrderQuoteOfferBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectOrderQuoteOfferBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectOrderQuoteOfferBatchMutation, { data, loading, error }] = useRejectOrderQuoteOfferBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectOrderQuoteOfferBatchMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RejectOrderQuoteOfferBatchMutation,
		RejectOrderQuoteOfferBatchMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RejectOrderQuoteOfferBatchMutation,
		RejectOrderQuoteOfferBatchMutationVariables
	>(RejectOrderQuoteOfferBatchDocument, options);
}
export type RejectOrderQuoteOfferBatchMutationHookResult = ReturnType<
	typeof useRejectOrderQuoteOfferBatchMutation
>;
export type RejectOrderQuoteOfferBatchMutationResult =
	Apollo.MutationResult<RejectOrderQuoteOfferBatchMutation>;
export type RejectOrderQuoteOfferBatchMutationOptions = Apollo.BaseMutationOptions<
	RejectOrderQuoteOfferBatchMutation,
	RejectOrderQuoteOfferBatchMutationVariables
>;
export const RejectOrderQuoteOfferDocument = gql`
	mutation RejectOrderQuoteOffer($input: RejectOrderQuoteOfferInput!) {
		rejectOrderQuoteOffer(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RejectOrderQuoteOfferMutationFn = Apollo.MutationFunction<
	RejectOrderQuoteOfferMutation,
	RejectOrderQuoteOfferMutationVariables
>;

/**
 * __useRejectOrderQuoteOfferMutation__
 *
 * To run a mutation, you first call `useRejectOrderQuoteOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectOrderQuoteOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectOrderQuoteOfferMutation, { data, loading, error }] = useRejectOrderQuoteOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectOrderQuoteOfferMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RejectOrderQuoteOfferMutation,
		RejectOrderQuoteOfferMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RejectOrderQuoteOfferMutation,
		RejectOrderQuoteOfferMutationVariables
	>(RejectOrderQuoteOfferDocument, options);
}
export type RejectOrderQuoteOfferMutationHookResult = ReturnType<
	typeof useRejectOrderQuoteOfferMutation
>;
export type RejectOrderQuoteOfferMutationResult =
	Apollo.MutationResult<RejectOrderQuoteOfferMutation>;
export type RejectOrderQuoteOfferMutationOptions = Apollo.BaseMutationOptions<
	RejectOrderQuoteOfferMutation,
	RejectOrderQuoteOfferMutationVariables
>;
export const UpdateSampleStatusDocument = gql`
	mutation UpdateSampleStatus($id: ID!, $input: UpdateSampleStatusInput!) {
		updateSampleStatus(id: $id, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateSampleStatusMutationFn = Apollo.MutationFunction<
	UpdateSampleStatusMutation,
	UpdateSampleStatusMutationVariables
>;

/**
 * __useUpdateSampleStatusMutation__
 *
 * To run a mutation, you first call `useUpdateSampleStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSampleStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSampleStatusMutation, { data, loading, error }] = useUpdateSampleStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSampleStatusMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateSampleStatusMutation,
		UpdateSampleStatusMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateSampleStatusMutation, UpdateSampleStatusMutationVariables>(
		UpdateSampleStatusDocument,
		options
	);
}
export type UpdateSampleStatusMutationHookResult = ReturnType<typeof useUpdateSampleStatusMutation>;
export type UpdateSampleStatusMutationResult = Apollo.MutationResult<UpdateSampleStatusMutation>;
export type UpdateSampleStatusMutationOptions = Apollo.BaseMutationOptions<
	UpdateSampleStatusMutation,
	UpdateSampleStatusMutationVariables
>;
export const ApproveNewSampleRoundDocument = gql`
	mutation ApproveNewSampleRound($id: ID!, $input: ApproveNewSampleRoundInput) {
		approveNewSampleRound(id: $id, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type ApproveNewSampleRoundMutationFn = Apollo.MutationFunction<
	ApproveNewSampleRoundMutation,
	ApproveNewSampleRoundMutationVariables
>;

/**
 * __useApproveNewSampleRoundMutation__
 *
 * To run a mutation, you first call `useApproveNewSampleRoundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveNewSampleRoundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveNewSampleRoundMutation, { data, loading, error }] = useApproveNewSampleRoundMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveNewSampleRoundMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ApproveNewSampleRoundMutation,
		ApproveNewSampleRoundMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ApproveNewSampleRoundMutation,
		ApproveNewSampleRoundMutationVariables
	>(ApproveNewSampleRoundDocument, options);
}
export type ApproveNewSampleRoundMutationHookResult = ReturnType<
	typeof useApproveNewSampleRoundMutation
>;
export type ApproveNewSampleRoundMutationResult =
	Apollo.MutationResult<ApproveNewSampleRoundMutation>;
export type ApproveNewSampleRoundMutationOptions = Apollo.BaseMutationOptions<
	ApproveNewSampleRoundMutation,
	ApproveNewSampleRoundMutationVariables
>;
export const SetSamplePaymentTreatmentDocument = gql`
	mutation SetSamplePaymentTreatment($sampleId: ID!, $treatment: SamplePaymentTreatment!) {
		setSamplePaymentTreatment(sampleId: $sampleId, treatment: $treatment) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type SetSamplePaymentTreatmentMutationFn = Apollo.MutationFunction<
	SetSamplePaymentTreatmentMutation,
	SetSamplePaymentTreatmentMutationVariables
>;

/**
 * __useSetSamplePaymentTreatmentMutation__
 *
 * To run a mutation, you first call `useSetSamplePaymentTreatmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSamplePaymentTreatmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSamplePaymentTreatmentMutation, { data, loading, error }] = useSetSamplePaymentTreatmentMutation({
 *   variables: {
 *      sampleId: // value for 'sampleId'
 *      treatment: // value for 'treatment'
 *   },
 * });
 */
export function useSetSamplePaymentTreatmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetSamplePaymentTreatmentMutation,
		SetSamplePaymentTreatmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SetSamplePaymentTreatmentMutation,
		SetSamplePaymentTreatmentMutationVariables
	>(SetSamplePaymentTreatmentDocument, options);
}
export type SetSamplePaymentTreatmentMutationHookResult = ReturnType<
	typeof useSetSamplePaymentTreatmentMutation
>;
export type SetSamplePaymentTreatmentMutationResult =
	Apollo.MutationResult<SetSamplePaymentTreatmentMutation>;
export type SetSamplePaymentTreatmentMutationOptions = Apollo.BaseMutationOptions<
	SetSamplePaymentTreatmentMutation,
	SetSamplePaymentTreatmentMutationVariables
>;
export const GenerateSampleAttachmentUploadUrlDocument = gql`
	mutation GenerateSampleAttachmentUploadUrl($input: GenerateSampleAttachmentUploadUrlInput!) {
		generateSampleAttachmentUploadUrl(input: $input) {
			uploadUrl
			blobUrl
			fileId
			success
			message
		}
	}
`;
export type GenerateSampleAttachmentUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateSampleAttachmentUploadUrlMutation,
	GenerateSampleAttachmentUploadUrlMutationVariables
>;

/**
 * __useGenerateSampleAttachmentUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateSampleAttachmentUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSampleAttachmentUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSampleAttachmentUploadUrlMutation, { data, loading, error }] = useGenerateSampleAttachmentUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSampleAttachmentUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateSampleAttachmentUploadUrlMutation,
		GenerateSampleAttachmentUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateSampleAttachmentUploadUrlMutation,
		GenerateSampleAttachmentUploadUrlMutationVariables
	>(GenerateSampleAttachmentUploadUrlDocument, options);
}
export type GenerateSampleAttachmentUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateSampleAttachmentUploadUrlMutation
>;
export type GenerateSampleAttachmentUploadUrlMutationResult =
	Apollo.MutationResult<GenerateSampleAttachmentUploadUrlMutation>;
export type GenerateSampleAttachmentUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateSampleAttachmentUploadUrlMutation,
	GenerateSampleAttachmentUploadUrlMutationVariables
>;
export const ConfirmSampleAttachmentUploadsDocument = gql`
	mutation ConfirmSampleAttachmentUploads($input: ConfirmSampleAttachmentUploadsInput!) {
		confirmSampleAttachmentUploads(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type ConfirmSampleAttachmentUploadsMutationFn = Apollo.MutationFunction<
	ConfirmSampleAttachmentUploadsMutation,
	ConfirmSampleAttachmentUploadsMutationVariables
>;

/**
 * __useConfirmSampleAttachmentUploadsMutation__
 *
 * To run a mutation, you first call `useConfirmSampleAttachmentUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmSampleAttachmentUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmSampleAttachmentUploadsMutation, { data, loading, error }] = useConfirmSampleAttachmentUploadsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmSampleAttachmentUploadsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmSampleAttachmentUploadsMutation,
		ConfirmSampleAttachmentUploadsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmSampleAttachmentUploadsMutation,
		ConfirmSampleAttachmentUploadsMutationVariables
	>(ConfirmSampleAttachmentUploadsDocument, options);
}
export type ConfirmSampleAttachmentUploadsMutationHookResult = ReturnType<
	typeof useConfirmSampleAttachmentUploadsMutation
>;
export type ConfirmSampleAttachmentUploadsMutationResult =
	Apollo.MutationResult<ConfirmSampleAttachmentUploadsMutation>;
export type ConfirmSampleAttachmentUploadsMutationOptions = Apollo.BaseMutationOptions<
	ConfirmSampleAttachmentUploadsMutation,
	ConfirmSampleAttachmentUploadsMutationVariables
>;
export const SaveOfferBatchSelectionDocument = gql`
	mutation SaveOfferBatchSelection($input: SaveOfferBatchSelectionInput!) {
		saveOfferBatchSelection(input: $input) {
			success
			message
		}
	}
`;
export type SaveOfferBatchSelectionMutationFn = Apollo.MutationFunction<
	SaveOfferBatchSelectionMutation,
	SaveOfferBatchSelectionMutationVariables
>;

/**
 * __useSaveOfferBatchSelectionMutation__
 *
 * To run a mutation, you first call `useSaveOfferBatchSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOfferBatchSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOfferBatchSelectionMutation, { data, loading, error }] = useSaveOfferBatchSelectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveOfferBatchSelectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SaveOfferBatchSelectionMutation,
		SaveOfferBatchSelectionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SaveOfferBatchSelectionMutation,
		SaveOfferBatchSelectionMutationVariables
	>(SaveOfferBatchSelectionDocument, options);
}
export type SaveOfferBatchSelectionMutationHookResult = ReturnType<
	typeof useSaveOfferBatchSelectionMutation
>;
export type SaveOfferBatchSelectionMutationResult =
	Apollo.MutationResult<SaveOfferBatchSelectionMutation>;
export type SaveOfferBatchSelectionMutationOptions = Apollo.BaseMutationOptions<
	SaveOfferBatchSelectionMutation,
	SaveOfferBatchSelectionMutationVariables
>;
export const SendTestNotificationDocument = gql`
	mutation SendTestNotification($type: NotificationType, $email: String) {
		sendTestNotification(type: $type, email: $email) {
			success
			message
		}
	}
`;
export type SendTestNotificationMutationFn = Apollo.MutationFunction<
	SendTestNotificationMutation,
	SendTestNotificationMutationVariables
>;

/**
 * __useSendTestNotificationMutation__
 *
 * To run a mutation, you first call `useSendTestNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestNotificationMutation, { data, loading, error }] = useSendTestNotificationMutation({
 *   variables: {
 *      type: // value for 'type'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendTestNotificationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SendTestNotificationMutation,
		SendTestNotificationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SendTestNotificationMutation, SendTestNotificationMutationVariables>(
		SendTestNotificationDocument,
		options
	);
}
export type SendTestNotificationMutationHookResult = ReturnType<
	typeof useSendTestNotificationMutation
>;
export type SendTestNotificationMutationResult =
	Apollo.MutationResult<SendTestNotificationMutation>;
export type SendTestNotificationMutationOptions = Apollo.BaseMutationOptions<
	SendTestNotificationMutation,
	SendTestNotificationMutationVariables
>;
export const SendStudioMessageDocument = gql`
	mutation SendStudioMessage($input: SendStudioMessageInput!) {
		sendStudioMessage(input: $input) {
			success
			message
		}
	}
`;
export type SendStudioMessageMutationFn = Apollo.MutationFunction<
	SendStudioMessageMutation,
	SendStudioMessageMutationVariables
>;

/**
 * __useSendStudioMessageMutation__
 *
 * To run a mutation, you first call `useSendStudioMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendStudioMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendStudioMessageMutation, { data, loading, error }] = useSendStudioMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendStudioMessageMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SendStudioMessageMutation,
		SendStudioMessageMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SendStudioMessageMutation, SendStudioMessageMutationVariables>(
		SendStudioMessageDocument,
		options
	);
}
export type SendStudioMessageMutationHookResult = ReturnType<typeof useSendStudioMessageMutation>;
export type SendStudioMessageMutationResult = Apollo.MutationResult<SendStudioMessageMutation>;
export type SendStudioMessageMutationOptions = Apollo.BaseMutationOptions<
	SendStudioMessageMutation,
	SendStudioMessageMutationVariables
>;
export const CreateSubscriptionCheckoutSessionDocument = gql`
	mutation CreateSubscriptionCheckoutSession($tier: SubscriptionTier!) {
		createSubscriptionCheckoutSession(tier: $tier) {
			success
			clientSecret
			sessionId
			message
		}
	}
`;
export type CreateSubscriptionCheckoutSessionMutationFn = Apollo.MutationFunction<
	CreateSubscriptionCheckoutSessionMutation,
	CreateSubscriptionCheckoutSessionMutationVariables
>;

/**
 * __useCreateSubscriptionCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionCheckoutSessionMutation, { data, loading, error }] = useCreateSubscriptionCheckoutSessionMutation({
 *   variables: {
 *      tier: // value for 'tier'
 *   },
 * });
 */
export function useCreateSubscriptionCheckoutSessionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateSubscriptionCheckoutSessionMutation,
		CreateSubscriptionCheckoutSessionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateSubscriptionCheckoutSessionMutation,
		CreateSubscriptionCheckoutSessionMutationVariables
	>(CreateSubscriptionCheckoutSessionDocument, options);
}
export type CreateSubscriptionCheckoutSessionMutationHookResult = ReturnType<
	typeof useCreateSubscriptionCheckoutSessionMutation
>;
export type CreateSubscriptionCheckoutSessionMutationResult =
	Apollo.MutationResult<CreateSubscriptionCheckoutSessionMutation>;
export type CreateSubscriptionCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<
	CreateSubscriptionCheckoutSessionMutation,
	CreateSubscriptionCheckoutSessionMutationVariables
>;
export const ChangeSubscriptionPlanDocument = gql`
	mutation ChangeSubscriptionPlan($tier: SubscriptionTier!) {
		changeSubscriptionPlan(tier: $tier) {
			success
			message
			requiresAction
			clientSecret
			subscription {
				id
				tier
				status
				stripePriceId
				currentPeriodEnd
				cancelAtPeriodEnd
				pendingTier
				pendingTierEffectiveAt
			}
		}
	}
`;
export type ChangeSubscriptionPlanMutationFn = Apollo.MutationFunction<
	ChangeSubscriptionPlanMutation,
	ChangeSubscriptionPlanMutationVariables
>;

/**
 * __useChangeSubscriptionPlanMutation__
 *
 * To run a mutation, you first call `useChangeSubscriptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSubscriptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSubscriptionPlanMutation, { data, loading, error }] = useChangeSubscriptionPlanMutation({
 *   variables: {
 *      tier: // value for 'tier'
 *   },
 * });
 */
export function useChangeSubscriptionPlanMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ChangeSubscriptionPlanMutation,
		ChangeSubscriptionPlanMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ChangeSubscriptionPlanMutation,
		ChangeSubscriptionPlanMutationVariables
	>(ChangeSubscriptionPlanDocument, options);
}
export type ChangeSubscriptionPlanMutationHookResult = ReturnType<
	typeof useChangeSubscriptionPlanMutation
>;
export type ChangeSubscriptionPlanMutationResult =
	Apollo.MutationResult<ChangeSubscriptionPlanMutation>;
export type ChangeSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<
	ChangeSubscriptionPlanMutation,
	ChangeSubscriptionPlanMutationVariables
>;
export const CancelScheduledPlanChangeDocument = gql`
	mutation CancelScheduledPlanChange {
		cancelScheduledPlanChange {
			success
			message
			subscription {
				id
				tier
				pendingTier
				pendingTierEffectiveAt
			}
		}
	}
`;
export type CancelScheduledPlanChangeMutationFn = Apollo.MutationFunction<
	CancelScheduledPlanChangeMutation,
	CancelScheduledPlanChangeMutationVariables
>;

/**
 * __useCancelScheduledPlanChangeMutation__
 *
 * To run a mutation, you first call `useCancelScheduledPlanChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledPlanChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledPlanChangeMutation, { data, loading, error }] = useCancelScheduledPlanChangeMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelScheduledPlanChangeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CancelScheduledPlanChangeMutation,
		CancelScheduledPlanChangeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CancelScheduledPlanChangeMutation,
		CancelScheduledPlanChangeMutationVariables
	>(CancelScheduledPlanChangeDocument, options);
}
export type CancelScheduledPlanChangeMutationHookResult = ReturnType<
	typeof useCancelScheduledPlanChangeMutation
>;
export type CancelScheduledPlanChangeMutationResult =
	Apollo.MutationResult<CancelScheduledPlanChangeMutation>;
export type CancelScheduledPlanChangeMutationOptions = Apollo.BaseMutationOptions<
	CancelScheduledPlanChangeMutation,
	CancelScheduledPlanChangeMutationVariables
>;
export const CancelSubscriptionDocument = gql`
	mutation CancelSubscription {
		cancelSubscription {
			success
			message
			subscription {
				id
				status
				cancelAtPeriodEnd
				canceledAt
			}
		}
	}
`;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<
	CancelSubscriptionMutation,
	CancelSubscriptionMutationVariables
>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelSubscriptionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CancelSubscriptionMutation,
		CancelSubscriptionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(
		CancelSubscriptionDocument,
		options
	);
}
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<
	CancelSubscriptionMutation,
	CancelSubscriptionMutationVariables
>;
export const ResumeSubscriptionDocument = gql`
	mutation ResumeSubscription {
		resumeSubscription {
			success
			message
			subscription {
				id
				status
				cancelAtPeriodEnd
			}
		}
	}
`;
export type ResumeSubscriptionMutationFn = Apollo.MutationFunction<
	ResumeSubscriptionMutation,
	ResumeSubscriptionMutationVariables
>;

/**
 * __useResumeSubscriptionMutation__
 *
 * To run a mutation, you first call `useResumeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSubscriptionMutation, { data, loading, error }] = useResumeSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useResumeSubscriptionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ResumeSubscriptionMutation,
		ResumeSubscriptionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>(
		ResumeSubscriptionDocument,
		options
	);
}
export type ResumeSubscriptionMutationHookResult = ReturnType<typeof useResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationResult = Apollo.MutationResult<ResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationOptions = Apollo.BaseMutationOptions<
	ResumeSubscriptionMutation,
	ResumeSubscriptionMutationVariables
>;
export const UpdateSubscriptionTierConfigDocument = gql`
	mutation UpdateSubscriptionTierConfig(
		$tier: SubscriptionTier!
		$kickbackRate: Float
		$aiTokenRatePerMillion: Float
		$stripePriceId: String
		$isActive: Boolean
	) {
		updateSubscriptionTierConfig(
			tier: $tier
			kickbackRate: $kickbackRate
			aiTokenRatePerMillion: $aiTokenRatePerMillion
			stripePriceId: $stripePriceId
			isActive: $isActive
		) {
			tier
			monthlyPrice
			currency
			kickbackRate
			aiTokenRatePerMillion
			stripePriceId
			isActive
			updatedAt
		}
	}
`;
export type UpdateSubscriptionTierConfigMutationFn = Apollo.MutationFunction<
	UpdateSubscriptionTierConfigMutation,
	UpdateSubscriptionTierConfigMutationVariables
>;

/**
 * __useUpdateSubscriptionTierConfigMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionTierConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionTierConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionTierConfigMutation, { data, loading, error }] = useUpdateSubscriptionTierConfigMutation({
 *   variables: {
 *      tier: // value for 'tier'
 *      kickbackRate: // value for 'kickbackRate'
 *      aiTokenRatePerMillion: // value for 'aiTokenRatePerMillion'
 *      stripePriceId: // value for 'stripePriceId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useUpdateSubscriptionTierConfigMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateSubscriptionTierConfigMutation,
		UpdateSubscriptionTierConfigMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateSubscriptionTierConfigMutation,
		UpdateSubscriptionTierConfigMutationVariables
	>(UpdateSubscriptionTierConfigDocument, options);
}
export type UpdateSubscriptionTierConfigMutationHookResult = ReturnType<
	typeof useUpdateSubscriptionTierConfigMutation
>;
export type UpdateSubscriptionTierConfigMutationResult =
	Apollo.MutationResult<UpdateSubscriptionTierConfigMutation>;
export type UpdateSubscriptionTierConfigMutationOptions = Apollo.BaseMutationOptions<
	UpdateSubscriptionTierConfigMutation,
	UpdateSubscriptionTierConfigMutationVariables
>;
export const UpdateSystemSettingsDocument = gql`
	mutation UpdateSystemSettings($input: UpdateSystemSettingInput!) {
		updateSystemSettings(input: $input) {
			message
			success
		}
	}
`;
export type UpdateSystemSettingsMutationFn = Apollo.MutationFunction<
	UpdateSystemSettingsMutation,
	UpdateSystemSettingsMutationVariables
>;

/**
 * __useUpdateSystemSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSystemSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSystemSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSystemSettingsMutation, { data, loading, error }] = useUpdateSystemSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSystemSettingsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateSystemSettingsMutation,
		UpdateSystemSettingsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateSystemSettingsMutation, UpdateSystemSettingsMutationVariables>(
		UpdateSystemSettingsDocument,
		options
	);
}
export type UpdateSystemSettingsMutationHookResult = ReturnType<
	typeof useUpdateSystemSettingsMutation
>;
export type UpdateSystemSettingsMutationResult =
	Apollo.MutationResult<UpdateSystemSettingsMutation>;
export type UpdateSystemSettingsMutationOptions = Apollo.BaseMutationOptions<
	UpdateSystemSettingsMutation,
	UpdateSystemSettingsMutationVariables
>;
export const CreateVetterEntityDocument = gql`
	mutation CreateVetterEntity($input: CreateVetterEntityInput!) {
		createVetterEntity(input: $input) {
			success
			message
			referenceKey
		}
	}
`;
export type CreateVetterEntityMutationFn = Apollo.MutationFunction<
	CreateVetterEntityMutation,
	CreateVetterEntityMutationVariables
>;

/**
 * __useCreateVetterEntityMutation__
 *
 * To run a mutation, you first call `useCreateVetterEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVetterEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVetterEntityMutation, { data, loading, error }] = useCreateVetterEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVetterEntityMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateVetterEntityMutation,
		CreateVetterEntityMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateVetterEntityMutation, CreateVetterEntityMutationVariables>(
		CreateVetterEntityDocument,
		options
	);
}
export type CreateVetterEntityMutationHookResult = ReturnType<typeof useCreateVetterEntityMutation>;
export type CreateVetterEntityMutationResult = Apollo.MutationResult<CreateVetterEntityMutation>;
export type CreateVetterEntityMutationOptions = Apollo.BaseMutationOptions<
	CreateVetterEntityMutation,
	CreateVetterEntityMutationVariables
>;
export const UpdateVetterEntityDocument = gql`
	mutation UpdateVetterEntity($id: ID!, $input: UpdateVetterEntityInput!) {
		updateVetterEntity(id: $id, input: $input) {
			success
			message
		}
	}
`;
export type UpdateVetterEntityMutationFn = Apollo.MutationFunction<
	UpdateVetterEntityMutation,
	UpdateVetterEntityMutationVariables
>;

/**
 * __useUpdateVetterEntityMutation__
 *
 * To run a mutation, you first call `useUpdateVetterEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVetterEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVetterEntityMutation, { data, loading, error }] = useUpdateVetterEntityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVetterEntityMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateVetterEntityMutation,
		UpdateVetterEntityMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateVetterEntityMutation, UpdateVetterEntityMutationVariables>(
		UpdateVetterEntityDocument,
		options
	);
}
export type UpdateVetterEntityMutationHookResult = ReturnType<typeof useUpdateVetterEntityMutation>;
export type UpdateVetterEntityMutationResult = Apollo.MutationResult<UpdateVetterEntityMutation>;
export type UpdateVetterEntityMutationOptions = Apollo.BaseMutationOptions<
	UpdateVetterEntityMutation,
	UpdateVetterEntityMutationVariables
>;
export const DeleteVetterEntityDocument = gql`
	mutation DeleteVetterEntity($id: ID!) {
		deleteVetterEntity(id: $id) {
			success
			message
		}
	}
`;
export type DeleteVetterEntityMutationFn = Apollo.MutationFunction<
	DeleteVetterEntityMutation,
	DeleteVetterEntityMutationVariables
>;

/**
 * __useDeleteVetterEntityMutation__
 *
 * To run a mutation, you first call `useDeleteVetterEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVetterEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVetterEntityMutation, { data, loading, error }] = useDeleteVetterEntityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVetterEntityMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteVetterEntityMutation,
		DeleteVetterEntityMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteVetterEntityMutation, DeleteVetterEntityMutationVariables>(
		DeleteVetterEntityDocument,
		options
	);
}
export type DeleteVetterEntityMutationHookResult = ReturnType<typeof useDeleteVetterEntityMutation>;
export type DeleteVetterEntityMutationResult = Apollo.MutationResult<DeleteVetterEntityMutation>;
export type DeleteVetterEntityMutationOptions = Apollo.BaseMutationOptions<
	DeleteVetterEntityMutation,
	DeleteVetterEntityMutationVariables
>;
export const RequestVetterJobAccessCodeDocument = gql`
	mutation RequestVetterJobAccessCode($input: RequestVetterJobAccessCodeInput!) {
		requestVetterJobAccessCode(input: $input) {
			...MessageResponseFragment
			messageKey
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RequestVetterJobAccessCodeMutationFn = Apollo.MutationFunction<
	RequestVetterJobAccessCodeMutation,
	RequestVetterJobAccessCodeMutationVariables
>;

/**
 * __useRequestVetterJobAccessCodeMutation__
 *
 * To run a mutation, you first call `useRequestVetterJobAccessCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestVetterJobAccessCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestVetterJobAccessCodeMutation, { data, loading, error }] = useRequestVetterJobAccessCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestVetterJobAccessCodeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RequestVetterJobAccessCodeMutation,
		RequestVetterJobAccessCodeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RequestVetterJobAccessCodeMutation,
		RequestVetterJobAccessCodeMutationVariables
	>(RequestVetterJobAccessCodeDocument, options);
}
export type RequestVetterJobAccessCodeMutationHookResult = ReturnType<
	typeof useRequestVetterJobAccessCodeMutation
>;
export type RequestVetterJobAccessCodeMutationResult =
	Apollo.MutationResult<RequestVetterJobAccessCodeMutation>;
export type RequestVetterJobAccessCodeMutationOptions = Apollo.BaseMutationOptions<
	RequestVetterJobAccessCodeMutation,
	RequestVetterJobAccessCodeMutationVariables
>;
export const VetterJobLoginDocument = gql`
	mutation VetterJobLogin($input: VetterJobLoginInput!) {
		vetterJobLogin(input: $input) {
			success
			message
			token
		}
	}
`;
export type VetterJobLoginMutationFn = Apollo.MutationFunction<
	VetterJobLoginMutation,
	VetterJobLoginMutationVariables
>;

/**
 * __useVetterJobLoginMutation__
 *
 * To run a mutation, you first call `useVetterJobLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVetterJobLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vetterJobLoginMutation, { data, loading, error }] = useVetterJobLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVetterJobLoginMutation(
	baseOptions?: Apollo.MutationHookOptions<
		VetterJobLoginMutation,
		VetterJobLoginMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<VetterJobLoginMutation, VetterJobLoginMutationVariables>(
		VetterJobLoginDocument,
		options
	);
}
export type VetterJobLoginMutationHookResult = ReturnType<typeof useVetterJobLoginMutation>;
export type VetterJobLoginMutationResult = Apollo.MutationResult<VetterJobLoginMutation>;
export type VetterJobLoginMutationOptions = Apollo.BaseMutationOptions<
	VetterJobLoginMutation,
	VetterJobLoginMutationVariables
>;
export const SubmitVetterJobPricesDocument = gql`
	mutation SubmitVetterJobPrices($input: SubmitVetterJobPricesInput!) {
		submitVetterJobPrices(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type SubmitVetterJobPricesMutationFn = Apollo.MutationFunction<
	SubmitVetterJobPricesMutation,
	SubmitVetterJobPricesMutationVariables
>;

/**
 * __useSubmitVetterJobPricesMutation__
 *
 * To run a mutation, you first call `useSubmitVetterJobPricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitVetterJobPricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitVetterJobPricesMutation, { data, loading, error }] = useSubmitVetterJobPricesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitVetterJobPricesMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SubmitVetterJobPricesMutation,
		SubmitVetterJobPricesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SubmitVetterJobPricesMutation,
		SubmitVetterJobPricesMutationVariables
	>(SubmitVetterJobPricesDocument, options);
}
export type SubmitVetterJobPricesMutationHookResult = ReturnType<
	typeof useSubmitVetterJobPricesMutation
>;
export type SubmitVetterJobPricesMutationResult =
	Apollo.MutationResult<SubmitVetterJobPricesMutation>;
export type SubmitVetterJobPricesMutationOptions = Apollo.BaseMutationOptions<
	SubmitVetterJobPricesMutation,
	SubmitVetterJobPricesMutationVariables
>;
export const CompleteVetterJobProductionDocument = gql`
	mutation CompleteVetterJobProduction($orderItemId: ID!) {
		completeVetterJobProduction(orderItemId: $orderItemId) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CompleteVetterJobProductionMutationFn = Apollo.MutationFunction<
	CompleteVetterJobProductionMutation,
	CompleteVetterJobProductionMutationVariables
>;

/**
 * __useCompleteVetterJobProductionMutation__
 *
 * To run a mutation, you first call `useCompleteVetterJobProductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteVetterJobProductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeVetterJobProductionMutation, { data, loading, error }] = useCompleteVetterJobProductionMutation({
 *   variables: {
 *      orderItemId: // value for 'orderItemId'
 *   },
 * });
 */
export function useCompleteVetterJobProductionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CompleteVetterJobProductionMutation,
		CompleteVetterJobProductionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CompleteVetterJobProductionMutation,
		CompleteVetterJobProductionMutationVariables
	>(CompleteVetterJobProductionDocument, options);
}
export type CompleteVetterJobProductionMutationHookResult = ReturnType<
	typeof useCompleteVetterJobProductionMutation
>;
export type CompleteVetterJobProductionMutationResult =
	Apollo.MutationResult<CompleteVetterJobProductionMutation>;
export type CompleteVetterJobProductionMutationOptions = Apollo.BaseMutationOptions<
	CompleteVetterJobProductionMutation,
	CompleteVetterJobProductionMutationVariables
>;
export const UpdateVetterJobShipmentTrackingDocument = gql`
	mutation UpdateVetterJobShipmentTracking(
		$id: ID!
		$input: UpdateVetterJobShipmentTrackingInput!
	) {
		updateVetterJobShipmentTracking(id: $id, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateVetterJobShipmentTrackingMutationFn = Apollo.MutationFunction<
	UpdateVetterJobShipmentTrackingMutation,
	UpdateVetterJobShipmentTrackingMutationVariables
>;

/**
 * __useUpdateVetterJobShipmentTrackingMutation__
 *
 * To run a mutation, you first call `useUpdateVetterJobShipmentTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVetterJobShipmentTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVetterJobShipmentTrackingMutation, { data, loading, error }] = useUpdateVetterJobShipmentTrackingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVetterJobShipmentTrackingMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateVetterJobShipmentTrackingMutation,
		UpdateVetterJobShipmentTrackingMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateVetterJobShipmentTrackingMutation,
		UpdateVetterJobShipmentTrackingMutationVariables
	>(UpdateVetterJobShipmentTrackingDocument, options);
}
export type UpdateVetterJobShipmentTrackingMutationHookResult = ReturnType<
	typeof useUpdateVetterJobShipmentTrackingMutation
>;
export type UpdateVetterJobShipmentTrackingMutationResult =
	Apollo.MutationResult<UpdateVetterJobShipmentTrackingMutation>;
export type UpdateVetterJobShipmentTrackingMutationOptions = Apollo.BaseMutationOptions<
	UpdateVetterJobShipmentTrackingMutation,
	UpdateVetterJobShipmentTrackingMutationVariables
>;
export const CreateVetterUserDocument = gql`
	mutation CreateVetterUser($input: CreateVetterUserInput!) {
		createVetterUser(input: $input) {
			success
			message
		}
	}
`;
export type CreateVetterUserMutationFn = Apollo.MutationFunction<
	CreateVetterUserMutation,
	CreateVetterUserMutationVariables
>;

/**
 * __useCreateVetterUserMutation__
 *
 * To run a mutation, you first call `useCreateVetterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVetterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVetterUserMutation, { data, loading, error }] = useCreateVetterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVetterUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateVetterUserMutation,
		CreateVetterUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateVetterUserMutation, CreateVetterUserMutationVariables>(
		CreateVetterUserDocument,
		options
	);
}
export type CreateVetterUserMutationHookResult = ReturnType<typeof useCreateVetterUserMutation>;
export type CreateVetterUserMutationResult = Apollo.MutationResult<CreateVetterUserMutation>;
export type CreateVetterUserMutationOptions = Apollo.BaseMutationOptions<
	CreateVetterUserMutation,
	CreateVetterUserMutationVariables
>;
export const UpdateVetterUserDocument = gql`
	mutation UpdateVetterUser($id: ID!, $input: UpdateVetterUserInput!) {
		updateVetterUser(id: $id, input: $input) {
			success
			message
		}
	}
`;
export type UpdateVetterUserMutationFn = Apollo.MutationFunction<
	UpdateVetterUserMutation,
	UpdateVetterUserMutationVariables
>;

/**
 * __useUpdateVetterUserMutation__
 *
 * To run a mutation, you first call `useUpdateVetterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVetterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVetterUserMutation, { data, loading, error }] = useUpdateVetterUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVetterUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateVetterUserMutation,
		UpdateVetterUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateVetterUserMutation, UpdateVetterUserMutationVariables>(
		UpdateVetterUserDocument,
		options
	);
}
export type UpdateVetterUserMutationHookResult = ReturnType<typeof useUpdateVetterUserMutation>;
export type UpdateVetterUserMutationResult = Apollo.MutationResult<UpdateVetterUserMutation>;
export type UpdateVetterUserMutationOptions = Apollo.BaseMutationOptions<
	UpdateVetterUserMutation,
	UpdateVetterUserMutationVariables
>;
export const DeleteVetterUserDocument = gql`
	mutation DeleteVetterUser($id: ID!) {
		deleteVetterUser(id: $id) {
			success
			message
		}
	}
`;
export type DeleteVetterUserMutationFn = Apollo.MutationFunction<
	DeleteVetterUserMutation,
	DeleteVetterUserMutationVariables
>;

/**
 * __useDeleteVetterUserMutation__
 *
 * To run a mutation, you first call `useDeleteVetterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVetterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVetterUserMutation, { data, loading, error }] = useDeleteVetterUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVetterUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteVetterUserMutation,
		DeleteVetterUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteVetterUserMutation, DeleteVetterUserMutationVariables>(
		DeleteVetterUserDocument,
		options
	);
}
export type DeleteVetterUserMutationHookResult = ReturnType<typeof useDeleteVetterUserMutation>;
export type DeleteVetterUserMutationResult = Apollo.MutationResult<DeleteVetterUserMutation>;
export type DeleteVetterUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteVetterUserMutation,
	DeleteVetterUserMutationVariables
>;
export const InviteVetterUserDocument = gql`
	mutation InviteVetterUser($id: ID!) {
		inviteVetterUser(id: $id) {
			success
			message
		}
	}
`;
export type InviteVetterUserMutationFn = Apollo.MutationFunction<
	InviteVetterUserMutation,
	InviteVetterUserMutationVariables
>;

/**
 * __useInviteVetterUserMutation__
 *
 * To run a mutation, you first call `useInviteVetterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteVetterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteVetterUserMutation, { data, loading, error }] = useInviteVetterUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInviteVetterUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InviteVetterUserMutation,
		InviteVetterUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<InviteVetterUserMutation, InviteVetterUserMutationVariables>(
		InviteVetterUserDocument,
		options
	);
}
export type InviteVetterUserMutationHookResult = ReturnType<typeof useInviteVetterUserMutation>;
export type InviteVetterUserMutationResult = Apollo.MutationResult<InviteVetterUserMutation>;
export type InviteVetterUserMutationOptions = Apollo.BaseMutationOptions<
	InviteVetterUserMutation,
	InviteVetterUserMutationVariables
>;
export const GetAdminActiveActivitiesDocument = gql`
	query GetAdminActiveActivities($limit: Int) {
		getAdminActiveActivities(limit: $limit) {
			activities {
				__typename
				... on AdminQuoteActivity {
					id
					type
					title
					quoteId
				}
				... on AdminOrderActivity {
					id
					type
					title
					orderId
				}
				... on AdminOrderQuoteOfferBatchActivity {
					id
					type
					title
					batchId
					batch {
						id
						name
						status
						orderQuoteId
						summary {
							grandTotal
						}
					}
				}
			}
		}
	}
`;

/**
 * __useGetAdminActiveActivitiesQuery__
 *
 * To run a query within a React component, call `useGetAdminActiveActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminActiveActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminActiveActivitiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAdminActiveActivitiesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAdminActiveActivitiesQuery,
		GetAdminActiveActivitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAdminActiveActivitiesQuery, GetAdminActiveActivitiesQueryVariables>(
		GetAdminActiveActivitiesDocument,
		options
	);
}
export function useGetAdminActiveActivitiesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAdminActiveActivitiesQuery,
		GetAdminActiveActivitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAdminActiveActivitiesQuery,
		GetAdminActiveActivitiesQueryVariables
	>(GetAdminActiveActivitiesDocument, options);
}
export function useGetAdminActiveActivitiesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAdminActiveActivitiesQuery,
				GetAdminActiveActivitiesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAdminActiveActivitiesQuery,
		GetAdminActiveActivitiesQueryVariables
	>(GetAdminActiveActivitiesDocument, options);
}
export type GetAdminActiveActivitiesQueryHookResult = ReturnType<
	typeof useGetAdminActiveActivitiesQuery
>;
export type GetAdminActiveActivitiesLazyQueryHookResult = ReturnType<
	typeof useGetAdminActiveActivitiesLazyQuery
>;
export type GetAdminActiveActivitiesSuspenseQueryHookResult = ReturnType<
	typeof useGetAdminActiveActivitiesSuspenseQuery
>;
export type GetAdminActiveActivitiesQueryResult = Apollo.QueryResult<
	GetAdminActiveActivitiesQuery,
	GetAdminActiveActivitiesQueryVariables
>;
export const GetOrganizationActiveActivitiesDocument = gql`
	query GetOrganizationActiveActivities($limit: Int) {
		getOrganizationActiveActivities(limit: $limit) {
			activities {
				__typename
				... on OrganizationQuoteActivity {
					id
					type
					title
					quoteId
				}
				... on OrganizationOrderActivity {
					id
					type
					title
					orderId
				}
				... on OrganizationOrderQuoteOfferBatchActivity {
					id
					type
					title
					batchId
					batch {
						id
						name
						status
						orderQuoteId
					}
				}
			}
		}
	}
`;

/**
 * __useGetOrganizationActiveActivitiesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationActiveActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationActiveActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationActiveActivitiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetOrganizationActiveActivitiesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetOrganizationActiveActivitiesQuery,
		GetOrganizationActiveActivitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationActiveActivitiesQuery,
		GetOrganizationActiveActivitiesQueryVariables
	>(GetOrganizationActiveActivitiesDocument, options);
}
export function useGetOrganizationActiveActivitiesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationActiveActivitiesQuery,
		GetOrganizationActiveActivitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationActiveActivitiesQuery,
		GetOrganizationActiveActivitiesQueryVariables
	>(GetOrganizationActiveActivitiesDocument, options);
}
export function useGetOrganizationActiveActivitiesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationActiveActivitiesQuery,
				GetOrganizationActiveActivitiesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationActiveActivitiesQuery,
		GetOrganizationActiveActivitiesQueryVariables
	>(GetOrganizationActiveActivitiesDocument, options);
}
export type GetOrganizationActiveActivitiesQueryHookResult = ReturnType<
	typeof useGetOrganizationActiveActivitiesQuery
>;
export type GetOrganizationActiveActivitiesLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationActiveActivitiesLazyQuery
>;
export type GetOrganizationActiveActivitiesSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationActiveActivitiesSuspenseQuery
>;
export type GetOrganizationActiveActivitiesQueryResult = Apollo.QueryResult<
	GetOrganizationActiveActivitiesQuery,
	GetOrganizationActiveActivitiesQueryVariables
>;
export const GetAllAdminUserDocument = gql`
	query GetAllAdminUser($input: GetAllAdminUserInput!) {
		getAllAdminUser(input: $input) {
			data {
				id
				userId
				firstName
				lastName
				createdAt
				updatedAt
				authenticationUser {
					id
					email
					role
					lockedAt
					lockReason
					mfaEnabled
					language
					lastActive
				}
			}
			pageInfo {
				currentPage
				totalCount
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllAdminUserQuery__
 *
 * To run a query within a React component, call `useGetAllAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAdminUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllAdminUserQuery(
	baseOptions: Apollo.QueryHookOptions<GetAllAdminUserQuery, GetAllAdminUserQueryVariables> &
		({ variables: GetAllAdminUserQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>(
		GetAllAdminUserDocument,
		options
	);
}
export function useGetAllAdminUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>(
		GetAllAdminUserDocument,
		options
	);
}
export function useGetAllAdminUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>(
		GetAllAdminUserDocument,
		options
	);
}
export type GetAllAdminUserQueryHookResult = ReturnType<typeof useGetAllAdminUserQuery>;
export type GetAllAdminUserLazyQueryHookResult = ReturnType<typeof useGetAllAdminUserLazyQuery>;
export type GetAllAdminUserSuspenseQueryHookResult = ReturnType<
	typeof useGetAllAdminUserSuspenseQuery
>;
export type GetAllAdminUserQueryResult = Apollo.QueryResult<
	GetAllAdminUserQuery,
	GetAllAdminUserQueryVariables
>;
export const GetAdminUserStatsDocument = gql`
	query GetAdminUserStats {
		getAdminUserStats {
			active
			pending
			total
		}
	}
`;

/**
 * __useGetAdminUserStatsQuery__
 *
 * To run a query within a React component, call `useGetAdminUserStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUserStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUserStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminUserStatsQuery(
	baseOptions?: Apollo.QueryHookOptions<GetAdminUserStatsQuery, GetAdminUserStatsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAdminUserStatsQuery, GetAdminUserStatsQueryVariables>(
		GetAdminUserStatsDocument,
		options
	);
}
export function useGetAdminUserStatsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAdminUserStatsQuery,
		GetAdminUserStatsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAdminUserStatsQuery, GetAdminUserStatsQueryVariables>(
		GetAdminUserStatsDocument,
		options
	);
}
export function useGetAdminUserStatsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAdminUserStatsQuery, GetAdminUserStatsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAdminUserStatsQuery, GetAdminUserStatsQueryVariables>(
		GetAdminUserStatsDocument,
		options
	);
}
export type GetAdminUserStatsQueryHookResult = ReturnType<typeof useGetAdminUserStatsQuery>;
export type GetAdminUserStatsLazyQueryHookResult = ReturnType<typeof useGetAdminUserStatsLazyQuery>;
export type GetAdminUserStatsSuspenseQueryHookResult = ReturnType<
	typeof useGetAdminUserStatsSuspenseQuery
>;
export type GetAdminUserStatsQueryResult = Apollo.QueryResult<
	GetAdminUserStatsQuery,
	GetAdminUserStatsQueryVariables
>;
export const CheckEmailExistsDocument = gql`
	query CheckEmailExists($email: String!) {
		checkEmailExists(email: $email) {
			exists
		}
	}
`;

/**
 * __useCheckEmailExistsQuery__
 *
 * To run a query within a React component, call `useCheckEmailExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEmailExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEmailExistsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckEmailExistsQuery(
	baseOptions: Apollo.QueryHookOptions<CheckEmailExistsQuery, CheckEmailExistsQueryVariables> &
		({ variables: CheckEmailExistsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CheckEmailExistsQuery, CheckEmailExistsQueryVariables>(
		CheckEmailExistsDocument,
		options
	);
}
export function useCheckEmailExistsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CheckEmailExistsQuery, CheckEmailExistsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CheckEmailExistsQuery, CheckEmailExistsQueryVariables>(
		CheckEmailExistsDocument,
		options
	);
}
export function useCheckEmailExistsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<CheckEmailExistsQuery, CheckEmailExistsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CheckEmailExistsQuery, CheckEmailExistsQueryVariables>(
		CheckEmailExistsDocument,
		options
	);
}
export type CheckEmailExistsQueryHookResult = ReturnType<typeof useCheckEmailExistsQuery>;
export type CheckEmailExistsLazyQueryHookResult = ReturnType<typeof useCheckEmailExistsLazyQuery>;
export type CheckEmailExistsSuspenseQueryHookResult = ReturnType<
	typeof useCheckEmailExistsSuspenseQuery
>;
export type CheckEmailExistsQueryResult = Apollo.QueryResult<
	CheckEmailExistsQuery,
	CheckEmailExistsQueryVariables
>;
export const GetAllBrandsDocument = gql`
	query GetAllBrands($input: GetAllBrandInput!) {
		getAllBrand(input: $input) {
			data {
				id
				name
				organizationId
				description
				brandguide
				website
				logo {
					id
					name
					url
					thumbnailUrl
					mimeType
				}
				colorPalette {
					primary {
						name
						hex
					}
					secondary {
						name
						hex
					}
					accent {
						name
						hex
					}
					neutral {
						name
						hex
					}
				}
				typography {
					primaryFont
					secondaryFont
				}
				address {
					formatted
					city
					state
					country
					postalCode
				}
				brandFiles {
					id
					name
					url
					thumbnailUrl
					type
					mimeType
					size
					uploadedAt
				}
				fontFiles {
					id
					family
					name
					style
					url
					weight
				}
				createdAt
				updatedAt
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllBrandsQuery__
 *
 * To run a query within a React component, call `useGetAllBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBrandsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllBrandsQuery(
	baseOptions: Apollo.QueryHookOptions<GetAllBrandsQuery, GetAllBrandsQueryVariables> &
		({ variables: GetAllBrandsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllBrandsQuery, GetAllBrandsQueryVariables>(
		GetAllBrandsDocument,
		options
	);
}
export function useGetAllBrandsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetAllBrandsQuery, GetAllBrandsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllBrandsQuery, GetAllBrandsQueryVariables>(
		GetAllBrandsDocument,
		options
	);
}
export function useGetAllBrandsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllBrandsQuery, GetAllBrandsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllBrandsQuery, GetAllBrandsQueryVariables>(
		GetAllBrandsDocument,
		options
	);
}
export type GetAllBrandsQueryHookResult = ReturnType<typeof useGetAllBrandsQuery>;
export type GetAllBrandsLazyQueryHookResult = ReturnType<typeof useGetAllBrandsLazyQuery>;
export type GetAllBrandsSuspenseQueryHookResult = ReturnType<typeof useGetAllBrandsSuspenseQuery>;
export type GetAllBrandsQueryResult = Apollo.QueryResult<
	GetAllBrandsQuery,
	GetAllBrandsQueryVariables
>;
export const GetBrandDocument = gql`
	query GetBrand($id: ID!) {
		getBrand(id: $id) {
			id
			name
			organizationId
			description
			brandguide
			website
			logo {
				id
				name
				url
				thumbnailUrl
				mimeType
			}
			brandPersonality {
				tone
				traits
				values
				aiGuidance
			}
			typography {
				primaryFont
				secondaryFont
				guidelines
			}
			usageGuidelines {
				logoPlacement
				colorUsage
				typographyRules
				spacing
			}
			address {
				formatted
				city
				country
			}
			colorPalette {
				primary {
					...BrandPaletteColorFragment
				}
				secondary {
					...BrandPaletteColorFragment
				}
				accent {
					...BrandPaletteColorFragment
				}
				neutral {
					...BrandPaletteColorFragment
				}
			}
			brandFiles {
				id
				name
				url
				thumbnailUrl
				type
				mimeType
				size
				uploadedAt
				designVariant
				backgroundType
				usageContext
				tags
			}
			fontFiles {
				id
				family
				name
				style
				url
				weight
			}
			createdAt
			updatedAt
		}
	}
	${BrandPaletteColorFragmentFragmentDoc}
`;

/**
 * __useGetBrandQuery__
 *
 * To run a query within a React component, call `useGetBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandQuery(
	baseOptions: Apollo.QueryHookOptions<GetBrandQuery, GetBrandQueryVariables> &
		({ variables: GetBrandQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetBrandQuery, GetBrandQueryVariables>(GetBrandDocument, options);
}
export function useGetBrandLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetBrandQuery, GetBrandQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetBrandQuery, GetBrandQueryVariables>(GetBrandDocument, options);
}
export function useGetBrandSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetBrandQuery, GetBrandQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetBrandQuery, GetBrandQueryVariables>(
		GetBrandDocument,
		options
	);
}
export type GetBrandQueryHookResult = ReturnType<typeof useGetBrandQuery>;
export type GetBrandLazyQueryHookResult = ReturnType<typeof useGetBrandLazyQuery>;
export type GetBrandSuspenseQueryHookResult = ReturnType<typeof useGetBrandSuspenseQuery>;
export type GetBrandQueryResult = Apollo.QueryResult<GetBrandQuery, GetBrandQueryVariables>;
export const GetClientOrderDocument = gql`
	query GetClientOrder($id: ID!, $inCurrency: CurrencyEnum) {
		getClientOrder(id: $id) {
			id
			name
			orderNumber
			status
			orderQuoteId
			poNumber
			deliveryAddress {
				addressLine1
				addressLine2
				city
				stateCode
				postalCode
				countryCode
			}
			totalAmount(inCurrency: $inCurrency)
			totalQuantity
			setupStage
			summary(inCurrency: $inCurrency) {
				productsSubtotal
				samplesTotal
				samplesShippingTotal
				samplesPrepaidTotal
				deliveryTotal
				feesTotal
				fees {
					name
					amount
				}
				discountsTotal
				discounts {
					name
					amount
				}
				sampleCreditAtRisk
				grandTotal
				vatRate
				vatAmount
				grossAmount
			}
			paymentSummary(inCurrency: $inCurrency) {
				productTotalAmount
				productPaidAmount
				productOutstandingAmount
				productStatus
				sampleTotalAmount
				samplePaidAmount
				sampleOutstandingAmount
				sampleStatus
				totalAmount
				totalPaidAmount
				totalOutstandingAmount
				vatRate
			}
			availableActions(inCurrency: $inCurrency) {
				action
				actor
				kind
				label
				blocked
				blockedReason
				warningReason
				itemCount
				amount
				currency
			}
			paymentOptions(inCurrency: $inCurrency) {
				key
				scope
				targetIds
				label
				amount
				currency
				blocked
				blockedReason
			}
			availablePaymentMethods {
				method
				available
				reason
			}
			availableSamplePaymentMethods {
				method
				available
				reason
			}
			items {
				id
				productId
				productName
				productImages {
					...OrderItemProductImageFragment
				}
				productDescription
				productSku
				productSpecificationsAt
				productSpecifications {
					...OrderProductSpecificationsFragment
				}
				productWeight
				productDimensions {
					length
					width
					height
					unit
				}
				quantity
				sortOrder
				status
				sampleChoice
				attachments {
					id
					name
					description
					mimeType
					size
					url
				}
				lifecycle {
					step
					label
					completed
					current
					actor
					skipped
					skippedReason
					outstanding
					outstandingReason
				}
				shippedQuantity
				deliveredQuantity
				unitPrice(inCurrency: $inCurrency)
				totalPrice(inCurrency: $inCurrency)
				adjustedTotalPrice(inCurrency: $inCurrency)
				lineTotal(inCurrency: $inCurrency)
				minProductionDays
				maxProductionDays
				waitingOn
				availableActions {
					action
					actor
					kind
					status
					label
					blocked
					blockedReason
					warningReason
				}
				paidAt
				productionStartedAt
				productionCompletedAt
				shippedAt
				actualDeliveryDate
				carrier
				trackingNumber
				estimatedDeliveryDate
				shipments {
					quantity
					shipment {
						id
						sequence
						status
						shippingMethod
						carrier
						trackingNumber
						trackingUrl
						shippedAt
						estimatedDeliveryDate
						actualDeliveryDate
					}
				}
				delivery {
					id
					shippingMethod
					shippingMethodLabel
					quantity
					deliveryDaysMin
					deliveryDaysMax
					totalPrice(inCurrency: $inCurrency)
				}
				samples {
					id
					sampleChoice
					sampleRound
					status
					lifecycle {
						step
						label
						completed
						current
						actor
						outstanding
						outstandingReason
					}
					totalPrice(inCurrency: $inCurrency)
					paymentTreatment
					paidAt
					minProductionDays
					maxProductionDays
					deliveryDaysMin
					deliveryDaysMax
					approvedAt
					notes
					approvalNotes
					rejectedAt
					rejectionReason
					requestNewSample
					productionStartedAt
					productionCompletedAt
					shippedAt
					carrier
					trackingNumber
					trackingUrl
					estimatedDeliveryDate
					actualDeliveryDate
					virtualDeliverySubmittedAt
					virtualDeliveryNotes
					virtualDeliveryAttachments {
						id
						name
						mimeType
						size
						url
						type
					}
					rejectionAttachments {
						id
						name
						mimeType
						size
						url
						type
					}
					availableActions {
						action
						actor
						kind
						label
						status
						blocked
						blockedReason
						warningReason
						requiredFields
						optionalFields
						requiresAttachments
						supportsAttachments
						hasAttachments
					}
					previousSampleId
				}
				createdAt
			}
			deliveries {
				id
				kind
				isPhysical
				reference
				state
				stateLabel
				carrier
				trackingNumber
				trackingUrl
				shippingMethodLabel
				projected
				expectedEarliest
				expectedLatest
				shippedAt
				actualDeliveryDate
				lines {
					orderItemId
					productName
					quantity
				}
			}
			shipments {
				id
				sequence
				shippingMethod
				status
				lifecycle {
					step
					label
					completed
					current
					actor
					skipped
					outstanding
					outstandingReason
				}
				deliveryDaysMin
				deliveryDaysMax
				carrier
				trackingNumber
				trackingUrl
				shippedAt
				estimatedDeliveryDate
				actualDeliveryDate
				splitOfOrderShipmentId
				totalPrice(inCurrency: $inCurrency)
				lines {
					id
					orderItemId
					quantity
				}
			}
			createdAt
			updatedAt
		}
	}
	${OrderItemProductImageFragmentFragmentDoc}
	${OrderProductSpecificationsFragmentFragmentDoc}
`;

/**
 * __useGetClientOrderQuery__
 *
 * To run a query within a React component, call `useGetClientOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetClientOrderQuery(
	baseOptions: Apollo.QueryHookOptions<GetClientOrderQuery, GetClientOrderQueryVariables> &
		({ variables: GetClientOrderQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetClientOrderQuery, GetClientOrderQueryVariables>(
		GetClientOrderDocument,
		options
	);
}
export function useGetClientOrderLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetClientOrderQuery, GetClientOrderQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetClientOrderQuery, GetClientOrderQueryVariables>(
		GetClientOrderDocument,
		options
	);
}
export function useGetClientOrderSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetClientOrderQuery, GetClientOrderQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetClientOrderQuery, GetClientOrderQueryVariables>(
		GetClientOrderDocument,
		options
	);
}
export type GetClientOrderQueryHookResult = ReturnType<typeof useGetClientOrderQuery>;
export type GetClientOrderLazyQueryHookResult = ReturnType<typeof useGetClientOrderLazyQuery>;
export type GetClientOrderSuspenseQueryHookResult = ReturnType<
	typeof useGetClientOrderSuspenseQuery
>;
export type GetClientOrderQueryResult = Apollo.QueryResult<
	GetClientOrderQuery,
	GetClientOrderQueryVariables
>;
export const GetAllClientOrdersDocument = gql`
	query GetAllClientOrders($input: GetAllClientOrdersInput!, $inCurrency: CurrencyEnum) {
		getAllClientOrders(input: $input) {
			data {
				id
				name
				orderNumber
				status
				orderQuoteId
				totalAmount(inCurrency: $inCurrency)
				summary(inCurrency: $inCurrency) {
					grandTotal
					grossAmount
				}
				items {
					id
					quantity
					productName
					productImages {
						...OrderItemProductImageFragment
					}
					status
				}
				createdAt
				updatedAt
			}
			pageInfo {
				currentPage
				totalCount
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
	${OrderItemProductImageFragmentFragmentDoc}
`;

/**
 * __useGetAllClientOrdersQuery__
 *
 * To run a query within a React component, call `useGetAllClientOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClientOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClientOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetAllClientOrdersQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllClientOrdersQuery,
		GetAllClientOrdersQueryVariables
	> &
		({ variables: GetAllClientOrdersQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllClientOrdersQuery, GetAllClientOrdersQueryVariables>(
		GetAllClientOrdersDocument,
		options
	);
}
export function useGetAllClientOrdersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllClientOrdersQuery,
		GetAllClientOrdersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllClientOrdersQuery, GetAllClientOrdersQueryVariables>(
		GetAllClientOrdersDocument,
		options
	);
}
export function useGetAllClientOrdersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllClientOrdersQuery, GetAllClientOrdersQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllClientOrdersQuery, GetAllClientOrdersQueryVariables>(
		GetAllClientOrdersDocument,
		options
	);
}
export type GetAllClientOrdersQueryHookResult = ReturnType<typeof useGetAllClientOrdersQuery>;
export type GetAllClientOrdersLazyQueryHookResult = ReturnType<
	typeof useGetAllClientOrdersLazyQuery
>;
export type GetAllClientOrdersSuspenseQueryHookResult = ReturnType<
	typeof useGetAllClientOrdersSuspenseQuery
>;
export type GetAllClientOrdersQueryResult = Apollo.QueryResult<
	GetAllClientOrdersQuery,
	GetAllClientOrdersQueryVariables
>;
export const GetClientOrdersDocument = gql`
	query GetClientOrders($orderQuoteId: ID!) {
		getClientOrders(orderQuoteId: $orderQuoteId) {
			id
			name
			orderNumber
			status
			createdAt
		}
	}
`;

/**
 * __useGetClientOrdersQuery__
 *
 * To run a query within a React component, call `useGetClientOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientOrdersQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *   },
 * });
 */
export function useGetClientOrdersQuery(
	baseOptions: Apollo.QueryHookOptions<GetClientOrdersQuery, GetClientOrdersQueryVariables> &
		({ variables: GetClientOrdersQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetClientOrdersQuery, GetClientOrdersQueryVariables>(
		GetClientOrdersDocument,
		options
	);
}
export function useGetClientOrdersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetClientOrdersQuery, GetClientOrdersQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetClientOrdersQuery, GetClientOrdersQueryVariables>(
		GetClientOrdersDocument,
		options
	);
}
export function useGetClientOrdersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetClientOrdersQuery, GetClientOrdersQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetClientOrdersQuery, GetClientOrdersQueryVariables>(
		GetClientOrdersDocument,
		options
	);
}
export type GetClientOrdersQueryHookResult = ReturnType<typeof useGetClientOrdersQuery>;
export type GetClientOrdersLazyQueryHookResult = ReturnType<typeof useGetClientOrdersLazyQuery>;
export type GetClientOrdersSuspenseQueryHookResult = ReturnType<
	typeof useGetClientOrdersSuspenseQuery
>;
export type GetClientOrdersQueryResult = Apollo.QueryResult<
	GetClientOrdersQuery,
	GetClientOrdersQueryVariables
>;
export const GetClientOrderQuoteDocument = gql`
	query GetClientOrderQuote($id: ID!) {
		getClientOrderQuote(id: $id) {
			id
			name
			description
			deadline
			status
			organizationId
			offerBatchCount
			offerRequestedAt
			purpose
			purposeOther
			lifecycle {
				step
				label
				completed
				current
			}
			deliveryAddress {
				addressLine1
				addressLine2
				city
				stateCode
				postalCode
				countryCode
				googlePlaceId
				latitude
				longitude
			}
			items {
				id
				productId
				productSpecificationsAt
				productSpecifications {
					...OrderProductSpecificationsFragment
				}
				productName
				productSku
				productDescription
				productWeight
				productDimensions {
					length
					width
					height
					unit
				}
				productImages {
					...OrderQuoteItemProductImageFragment
				}
				deadline
				timelineStatus {
					level
					businessDaysLeft
					isExpired
				}
				sortOrder
				quantities {
					id
					quantity
					sortOrder
				}
			}
			createdAt
			updatedAt
		}
	}
	${OrderProductSpecificationsFragmentFragmentDoc}
	${OrderQuoteItemProductImageFragmentFragmentDoc}
`;

/**
 * __useGetClientOrderQuoteQuery__
 *
 * To run a query within a React component, call `useGetClientOrderQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientOrderQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientOrderQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientOrderQuoteQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetClientOrderQuoteQuery,
		GetClientOrderQuoteQueryVariables
	> &
		({ variables: GetClientOrderQuoteQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetClientOrderQuoteQuery, GetClientOrderQuoteQueryVariables>(
		GetClientOrderQuoteDocument,
		options
	);
}
export function useGetClientOrderQuoteLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetClientOrderQuoteQuery,
		GetClientOrderQuoteQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetClientOrderQuoteQuery, GetClientOrderQuoteQueryVariables>(
		GetClientOrderQuoteDocument,
		options
	);
}
export function useGetClientOrderQuoteSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetClientOrderQuoteQuery,
				GetClientOrderQuoteQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetClientOrderQuoteQuery, GetClientOrderQuoteQueryVariables>(
		GetClientOrderQuoteDocument,
		options
	);
}
export type GetClientOrderQuoteQueryHookResult = ReturnType<typeof useGetClientOrderQuoteQuery>;
export type GetClientOrderQuoteLazyQueryHookResult = ReturnType<
	typeof useGetClientOrderQuoteLazyQuery
>;
export type GetClientOrderQuoteSuspenseQueryHookResult = ReturnType<
	typeof useGetClientOrderQuoteSuspenseQuery
>;
export type GetClientOrderQuoteQueryResult = Apollo.QueryResult<
	GetClientOrderQuoteQuery,
	GetClientOrderQuoteQueryVariables
>;
export const GetClientAllOrderQuoteDocument = gql`
	query GetClientAllOrderQuote($input: ClientGetAllOrderQuoteInput!) {
		getClientAllOrderQuote(input: $input) {
			data {
				id
				name
				description
				deadline
				status
				purpose
				createdAt
				updatedAt
			}
			pageInfo {
				currentPage
				totalCount
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetClientAllOrderQuoteQuery__
 *
 * To run a query within a React component, call `useGetClientAllOrderQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientAllOrderQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientAllOrderQuoteQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientAllOrderQuoteQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetClientAllOrderQuoteQuery,
		GetClientAllOrderQuoteQueryVariables
	> &
		({ variables: GetClientAllOrderQuoteQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetClientAllOrderQuoteQuery, GetClientAllOrderQuoteQueryVariables>(
		GetClientAllOrderQuoteDocument,
		options
	);
}
export function useGetClientAllOrderQuoteLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetClientAllOrderQuoteQuery,
		GetClientAllOrderQuoteQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetClientAllOrderQuoteQuery, GetClientAllOrderQuoteQueryVariables>(
		GetClientAllOrderQuoteDocument,
		options
	);
}
export function useGetClientAllOrderQuoteSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetClientAllOrderQuoteQuery,
				GetClientAllOrderQuoteQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetClientAllOrderQuoteQuery,
		GetClientAllOrderQuoteQueryVariables
	>(GetClientAllOrderQuoteDocument, options);
}
export type GetClientAllOrderQuoteQueryHookResult = ReturnType<
	typeof useGetClientAllOrderQuoteQuery
>;
export type GetClientAllOrderQuoteLazyQueryHookResult = ReturnType<
	typeof useGetClientAllOrderQuoteLazyQuery
>;
export type GetClientAllOrderQuoteSuspenseQueryHookResult = ReturnType<
	typeof useGetClientAllOrderQuoteSuspenseQuery
>;
export type GetClientAllOrderQuoteQueryResult = Apollo.QueryResult<
	GetClientAllOrderQuoteQuery,
	GetClientAllOrderQuoteQueryVariables
>;
export const GetClientOrderQuoteOfferBatchesDocument = gql`
	query GetClientOrderQuoteOfferBatches($orderQuoteId: ID!, $inCurrency: CurrencyEnum) {
		getClientOrderQuoteOfferBatches(orderQuoteId: $orderQuoteId) {
			id
			name
			status
			acceptDeadline
			sentToClientAt
			respondedAt
			rejectionReason
			orderQuoteId
			savedSelection {
				fromDownloadedQuote
				updatedAt
				selections {
					offerId
					pricingId
					quantity
					deliveryId
					sampleChoice
				}
			}
			summary(inCurrency: $inCurrency) {
				productsSubtotal
				samplesTotal
				samplesShippingTotal
				deliveryTotal
				feesTotal
				fees {
					name
					amount
				}
				discountsTotal
				discounts {
					name
					amount
				}
				grandTotal
				vatRate
				vatAmount
				grossAmount
			}
			offers {
				id
				name
				description
				status
				respondedAt
				rejectionReason
				orderQuoteItemId
				sortOrder
				acceptedPricingId
				acceptedDeliveryId
				sample {
					id
					status
					totalPrice(inCurrency: $inCurrency)
					pricesByChoice(inCurrency: $inCurrency) {
						sampleChoice
						totalPrice
					}
					minProductionDays
					maxProductionDays
					deliveryDaysMin
					deliveryDaysMax
					notes
					paymentTreatment
				}
				attachments {
					id
					name
					description
					mimeType
					size
					url
				}
				adjustments {
					id
					name
					description
					type
					calculationType
					value(inCurrency: $inCurrency)
				}
				pricing {
					id
					orderQuoteItemQuantityId
					unitPrice(inCurrency: $inCurrency)
					totalPrice(inCurrency: $inCurrency)
					adjustedTotalPrice(inCurrency: $inCurrency)
					minProductionDays
					maxProductionDays
					deliveries {
						id
						shippingMethod
						totalPrice(inCurrency: $inCurrency)
						quantity
						deliveryDaysMin
						deliveryDaysMax
						isSplit
						parts {
							id
							sequence
							shippingMethod
							quantity
							totalPrice(inCurrency: $inCurrency)
							deliveryDaysMin
							deliveryDaysMax
							projectedDelivery {
								ifAcceptedNow {
									earliest
									latest
									verdict
								}
								ifAcceptedAtDeadline {
									earliest
									latest
									verdict
								}
							}
						}
						projectedDelivery {
							ifAcceptedNow {
								earliest
								latest
								verdict
							}
							ifAcceptedAtDeadline {
								earliest
								latest
								verdict
							}
						}
					}
				}
			}
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetClientOrderQuoteOfferBatchesQuery__
 *
 * To run a query within a React component, call `useGetClientOrderQuoteOfferBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientOrderQuoteOfferBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientOrderQuoteOfferBatchesQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetClientOrderQuoteOfferBatchesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetClientOrderQuoteOfferBatchesQuery,
		GetClientOrderQuoteOfferBatchesQueryVariables
	> &
		(
			| { variables: GetClientOrderQuoteOfferBatchesQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetClientOrderQuoteOfferBatchesQuery,
		GetClientOrderQuoteOfferBatchesQueryVariables
	>(GetClientOrderQuoteOfferBatchesDocument, options);
}
export function useGetClientOrderQuoteOfferBatchesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetClientOrderQuoteOfferBatchesQuery,
		GetClientOrderQuoteOfferBatchesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetClientOrderQuoteOfferBatchesQuery,
		GetClientOrderQuoteOfferBatchesQueryVariables
	>(GetClientOrderQuoteOfferBatchesDocument, options);
}
export function useGetClientOrderQuoteOfferBatchesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetClientOrderQuoteOfferBatchesQuery,
				GetClientOrderQuoteOfferBatchesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetClientOrderQuoteOfferBatchesQuery,
		GetClientOrderQuoteOfferBatchesQueryVariables
	>(GetClientOrderQuoteOfferBatchesDocument, options);
}
export type GetClientOrderQuoteOfferBatchesQueryHookResult = ReturnType<
	typeof useGetClientOrderQuoteOfferBatchesQuery
>;
export type GetClientOrderQuoteOfferBatchesLazyQueryHookResult = ReturnType<
	typeof useGetClientOrderQuoteOfferBatchesLazyQuery
>;
export type GetClientOrderQuoteOfferBatchesSuspenseQueryHookResult = ReturnType<
	typeof useGetClientOrderQuoteOfferBatchesSuspenseQuery
>;
export type GetClientOrderQuoteOfferBatchesQueryResult = Apollo.QueryResult<
	GetClientOrderQuoteOfferBatchesQuery,
	GetClientOrderQuoteOfferBatchesQueryVariables
>;
export const GetClientOrderQuoteOfferBatchSummaryDocument = gql`
	query GetClientOrderQuoteOfferBatchSummary(
		$orderQuoteId: ID!
		$inCurrency: CurrencyEnum
		$selectedPricingIds: [ID!]
		$selectedDeliveryIds: [ID!]
		$includedOfferIds: [ID!]
		$selectedSampleChoices: [OfferSampleChoiceInput!]
	) {
		getClientOrderQuoteOfferBatches(orderQuoteId: $orderQuoteId) {
			id
			summary(
				inCurrency: $inCurrency
				selectedPricingIds: $selectedPricingIds
				selectedDeliveryIds: $selectedDeliveryIds
				includedOfferIds: $includedOfferIds
				selectedSampleChoices: $selectedSampleChoices
			) {
				productsSubtotal
				samplesTotal
				samplesShippingTotal
				samplesPrepaidTotal
				deliveryTotal
				feesTotal
				fees {
					name
					amount
				}
				discountsTotal
				discounts {
					name
					amount
				}
				grandTotal
				vatRate
				vatAmount
				grossAmount
			}
		}
	}
`;

/**
 * __useGetClientOrderQuoteOfferBatchSummaryQuery__
 *
 * To run a query within a React component, call `useGetClientOrderQuoteOfferBatchSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientOrderQuoteOfferBatchSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientOrderQuoteOfferBatchSummaryQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *      inCurrency: // value for 'inCurrency'
 *      selectedPricingIds: // value for 'selectedPricingIds'
 *      selectedDeliveryIds: // value for 'selectedDeliveryIds'
 *      includedOfferIds: // value for 'includedOfferIds'
 *      selectedSampleChoices: // value for 'selectedSampleChoices'
 *   },
 * });
 */
export function useGetClientOrderQuoteOfferBatchSummaryQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetClientOrderQuoteOfferBatchSummaryQuery,
		GetClientOrderQuoteOfferBatchSummaryQueryVariables
	> &
		(
			| { variables: GetClientOrderQuoteOfferBatchSummaryQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetClientOrderQuoteOfferBatchSummaryQuery,
		GetClientOrderQuoteOfferBatchSummaryQueryVariables
	>(GetClientOrderQuoteOfferBatchSummaryDocument, options);
}
export function useGetClientOrderQuoteOfferBatchSummaryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetClientOrderQuoteOfferBatchSummaryQuery,
		GetClientOrderQuoteOfferBatchSummaryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetClientOrderQuoteOfferBatchSummaryQuery,
		GetClientOrderQuoteOfferBatchSummaryQueryVariables
	>(GetClientOrderQuoteOfferBatchSummaryDocument, options);
}
export function useGetClientOrderQuoteOfferBatchSummarySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetClientOrderQuoteOfferBatchSummaryQuery,
				GetClientOrderQuoteOfferBatchSummaryQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetClientOrderQuoteOfferBatchSummaryQuery,
		GetClientOrderQuoteOfferBatchSummaryQueryVariables
	>(GetClientOrderQuoteOfferBatchSummaryDocument, options);
}
export type GetClientOrderQuoteOfferBatchSummaryQueryHookResult = ReturnType<
	typeof useGetClientOrderQuoteOfferBatchSummaryQuery
>;
export type GetClientOrderQuoteOfferBatchSummaryLazyQueryHookResult = ReturnType<
	typeof useGetClientOrderQuoteOfferBatchSummaryLazyQuery
>;
export type GetClientOrderQuoteOfferBatchSummarySuspenseQueryHookResult = ReturnType<
	typeof useGetClientOrderQuoteOfferBatchSummarySuspenseQuery
>;
export type GetClientOrderQuoteOfferBatchSummaryQueryResult = Apollo.QueryResult<
	GetClientOrderQuoteOfferBatchSummaryQuery,
	GetClientOrderQuoteOfferBatchSummaryQueryVariables
>;
export const PreviewAcceptOffersDocument = gql`
	query PreviewAcceptOffers($input: PreviewAcceptOffersInput!) {
		previewAcceptOffers(input: $input) {
			currency
			payNow {
				netAmount
				vatRate
				vatAmount
				grossAmount
			}
			payLater {
				netAmount
				vatRate
				vatAmount
				grossAmount
			}
			total {
				netAmount
				vatRate
				vatAmount
				grossAmount
			}
		}
	}
`;

/**
 * __usePreviewAcceptOffersQuery__
 *
 * To run a query within a React component, call `usePreviewAcceptOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewAcceptOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewAcceptOffersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewAcceptOffersQuery(
	baseOptions: Apollo.QueryHookOptions<
		PreviewAcceptOffersQuery,
		PreviewAcceptOffersQueryVariables
	> &
		({ variables: PreviewAcceptOffersQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PreviewAcceptOffersQuery, PreviewAcceptOffersQueryVariables>(
		PreviewAcceptOffersDocument,
		options
	);
}
export function usePreviewAcceptOffersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PreviewAcceptOffersQuery,
		PreviewAcceptOffersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PreviewAcceptOffersQuery, PreviewAcceptOffersQueryVariables>(
		PreviewAcceptOffersDocument,
		options
	);
}
export function usePreviewAcceptOffersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				PreviewAcceptOffersQuery,
				PreviewAcceptOffersQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PreviewAcceptOffersQuery, PreviewAcceptOffersQueryVariables>(
		PreviewAcceptOffersDocument,
		options
	);
}
export type PreviewAcceptOffersQueryHookResult = ReturnType<typeof usePreviewAcceptOffersQuery>;
export type PreviewAcceptOffersLazyQueryHookResult = ReturnType<
	typeof usePreviewAcceptOffersLazyQuery
>;
export type PreviewAcceptOffersSuspenseQueryHookResult = ReturnType<
	typeof usePreviewAcceptOffersSuspenseQuery
>;
export type PreviewAcceptOffersQueryResult = Apollo.QueryResult<
	PreviewAcceptOffersQuery,
	PreviewAcceptOffersQueryVariables
>;
export const GetClientOrderQuoteSummaryDocument = gql`
	query GetClientOrderQuoteSummary($id: ID!) {
		getClientOrderQuote(id: $id) {
			id
			name
			status
			createdAt
		}
	}
`;

/**
 * __useGetClientOrderQuoteSummaryQuery__
 *
 * To run a query within a React component, call `useGetClientOrderQuoteSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientOrderQuoteSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientOrderQuoteSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientOrderQuoteSummaryQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetClientOrderQuoteSummaryQuery,
		GetClientOrderQuoteSummaryQueryVariables
	> &
		(
			| { variables: GetClientOrderQuoteSummaryQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetClientOrderQuoteSummaryQuery,
		GetClientOrderQuoteSummaryQueryVariables
	>(GetClientOrderQuoteSummaryDocument, options);
}
export function useGetClientOrderQuoteSummaryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetClientOrderQuoteSummaryQuery,
		GetClientOrderQuoteSummaryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetClientOrderQuoteSummaryQuery,
		GetClientOrderQuoteSummaryQueryVariables
	>(GetClientOrderQuoteSummaryDocument, options);
}
export function useGetClientOrderQuoteSummarySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetClientOrderQuoteSummaryQuery,
				GetClientOrderQuoteSummaryQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetClientOrderQuoteSummaryQuery,
		GetClientOrderQuoteSummaryQueryVariables
	>(GetClientOrderQuoteSummaryDocument, options);
}
export type GetClientOrderQuoteSummaryQueryHookResult = ReturnType<
	typeof useGetClientOrderQuoteSummaryQuery
>;
export type GetClientOrderQuoteSummaryLazyQueryHookResult = ReturnType<
	typeof useGetClientOrderQuoteSummaryLazyQuery
>;
export type GetClientOrderQuoteSummarySuspenseQueryHookResult = ReturnType<
	typeof useGetClientOrderQuoteSummarySuspenseQuery
>;
export type GetClientOrderQuoteSummaryQueryResult = Apollo.QueryResult<
	GetClientOrderQuoteSummaryQuery,
	GetClientOrderQuoteSummaryQueryVariables
>;
export const ListEarlyAccessRequestsDocument = gql`
	query ListEarlyAccessRequests($status: EarlyAccessStatusEnum) {
		listEarlyAccessRequests(status: $status) {
			id
			firstName
			lastName
			email
			companyName
			status
			createdAt
			approvedAt
			usedAt
		}
	}
`;

/**
 * __useListEarlyAccessRequestsQuery__
 *
 * To run a query within a React component, call `useListEarlyAccessRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEarlyAccessRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEarlyAccessRequestsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useListEarlyAccessRequestsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ListEarlyAccessRequestsQuery,
		ListEarlyAccessRequestsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ListEarlyAccessRequestsQuery, ListEarlyAccessRequestsQueryVariables>(
		ListEarlyAccessRequestsDocument,
		options
	);
}
export function useListEarlyAccessRequestsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ListEarlyAccessRequestsQuery,
		ListEarlyAccessRequestsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ListEarlyAccessRequestsQuery, ListEarlyAccessRequestsQueryVariables>(
		ListEarlyAccessRequestsDocument,
		options
	);
}
export function useListEarlyAccessRequestsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				ListEarlyAccessRequestsQuery,
				ListEarlyAccessRequestsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ListEarlyAccessRequestsQuery,
		ListEarlyAccessRequestsQueryVariables
	>(ListEarlyAccessRequestsDocument, options);
}
export type ListEarlyAccessRequestsQueryHookResult = ReturnType<
	typeof useListEarlyAccessRequestsQuery
>;
export type ListEarlyAccessRequestsLazyQueryHookResult = ReturnType<
	typeof useListEarlyAccessRequestsLazyQuery
>;
export type ListEarlyAccessRequestsSuspenseQueryHookResult = ReturnType<
	typeof useListEarlyAccessRequestsSuspenseQuery
>;
export type ListEarlyAccessRequestsQueryResult = Apollo.QueryResult<
	ListEarlyAccessRequestsQuery,
	ListEarlyAccessRequestsQueryVariables
>;
export const GetEarlyAccessByTokenDocument = gql`
	query GetEarlyAccessByToken($inviteToken: String!) {
		getEarlyAccessByToken(inviteToken: $inviteToken) {
			firstName
			lastName
			email
			companyName
		}
	}
`;

/**
 * __useGetEarlyAccessByTokenQuery__
 *
 * To run a query within a React component, call `useGetEarlyAccessByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEarlyAccessByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEarlyAccessByTokenQuery({
 *   variables: {
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useGetEarlyAccessByTokenQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetEarlyAccessByTokenQuery,
		GetEarlyAccessByTokenQueryVariables
	> &
		({ variables: GetEarlyAccessByTokenQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetEarlyAccessByTokenQuery, GetEarlyAccessByTokenQueryVariables>(
		GetEarlyAccessByTokenDocument,
		options
	);
}
export function useGetEarlyAccessByTokenLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetEarlyAccessByTokenQuery,
		GetEarlyAccessByTokenQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetEarlyAccessByTokenQuery, GetEarlyAccessByTokenQueryVariables>(
		GetEarlyAccessByTokenDocument,
		options
	);
}
export function useGetEarlyAccessByTokenSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetEarlyAccessByTokenQuery,
				GetEarlyAccessByTokenQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetEarlyAccessByTokenQuery, GetEarlyAccessByTokenQueryVariables>(
		GetEarlyAccessByTokenDocument,
		options
	);
}
export type GetEarlyAccessByTokenQueryHookResult = ReturnType<typeof useGetEarlyAccessByTokenQuery>;
export type GetEarlyAccessByTokenLazyQueryHookResult = ReturnType<
	typeof useGetEarlyAccessByTokenLazyQuery
>;
export type GetEarlyAccessByTokenSuspenseQueryHookResult = ReturnType<
	typeof useGetEarlyAccessByTokenSuspenseQuery
>;
export type GetEarlyAccessByTokenQueryResult = Apollo.QueryResult<
	GetEarlyAccessByTokenQuery,
	GetEarlyAccessByTokenQueryVariables
>;
export const GetEmailTemplatePreviewDocument = gql`
	query GetEmailTemplatePreview($key: String!) {
		getEmailTemplatePreview(key: $key) {
			key
			description
			fromName
			fromEmail
			subject
			preheader
			html
			text
		}
	}
`;

/**
 * __useGetEmailTemplatePreviewQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplatePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplatePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplatePreviewQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetEmailTemplatePreviewQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetEmailTemplatePreviewQuery,
		GetEmailTemplatePreviewQueryVariables
	> &
		({ variables: GetEmailTemplatePreviewQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetEmailTemplatePreviewQuery, GetEmailTemplatePreviewQueryVariables>(
		GetEmailTemplatePreviewDocument,
		options
	);
}
export function useGetEmailTemplatePreviewLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetEmailTemplatePreviewQuery,
		GetEmailTemplatePreviewQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetEmailTemplatePreviewQuery, GetEmailTemplatePreviewQueryVariables>(
		GetEmailTemplatePreviewDocument,
		options
	);
}
export function useGetEmailTemplatePreviewSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetEmailTemplatePreviewQuery,
				GetEmailTemplatePreviewQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetEmailTemplatePreviewQuery,
		GetEmailTemplatePreviewQueryVariables
	>(GetEmailTemplatePreviewDocument, options);
}
export type GetEmailTemplatePreviewQueryHookResult = ReturnType<
	typeof useGetEmailTemplatePreviewQuery
>;
export type GetEmailTemplatePreviewLazyQueryHookResult = ReturnType<
	typeof useGetEmailTemplatePreviewLazyQuery
>;
export type GetEmailTemplatePreviewSuspenseQueryHookResult = ReturnType<
	typeof useGetEmailTemplatePreviewSuspenseQuery
>;
export type GetEmailTemplatePreviewQueryResult = Apollo.QueryResult<
	GetEmailTemplatePreviewQuery,
	GetEmailTemplatePreviewQueryVariables
>;
export const GetAllLocalizationTimezonesDocument = gql`
	query GetAllLocalizationTimezones {
		getAllLocalizationTimezones {
			name
			offset
		}
	}
`;

/**
 * __useGetAllLocalizationTimezonesQuery__
 *
 * To run a query within a React component, call `useGetAllLocalizationTimezonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocalizationTimezonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocalizationTimezonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllLocalizationTimezonesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>(GetAllLocalizationTimezonesDocument, options);
}
export function useGetAllLocalizationTimezonesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>(GetAllLocalizationTimezonesDocument, options);
}
export function useGetAllLocalizationTimezonesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllLocalizationTimezonesQuery,
				GetAllLocalizationTimezonesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>(GetAllLocalizationTimezonesDocument, options);
}
export type GetAllLocalizationTimezonesQueryHookResult = ReturnType<
	typeof useGetAllLocalizationTimezonesQuery
>;
export type GetAllLocalizationTimezonesLazyQueryHookResult = ReturnType<
	typeof useGetAllLocalizationTimezonesLazyQuery
>;
export type GetAllLocalizationTimezonesSuspenseQueryHookResult = ReturnType<
	typeof useGetAllLocalizationTimezonesSuspenseQuery
>;
export type GetAllLocalizationTimezonesQueryResult = Apollo.QueryResult<
	GetAllLocalizationTimezonesQuery,
	GetAllLocalizationTimezonesQueryVariables
>;
export const GetAllLocalizationCountriesDocument = gql`
	query GetAllLocalizationCountries {
		getAllLocalizationCountries {
			code
			name
			currency
			defaultTimezone
			defaultMeasurementSystem
			hasStates
			isEU
			phonePrefix
			nativeName
			registrations {
				code
				label
				placeholder
				helpText
				isRequired
				vatDerivationPattern
			}
			addressFormat {
				postalCodeLabel
				stateLabel
				stateRequired
			}
		}
	}
`;

/**
 * __useGetAllLocalizationCountriesQuery__
 *
 * To run a query within a React component, call `useGetAllLocalizationCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocalizationCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocalizationCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllLocalizationCountriesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>(GetAllLocalizationCountriesDocument, options);
}
export function useGetAllLocalizationCountriesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>(GetAllLocalizationCountriesDocument, options);
}
export function useGetAllLocalizationCountriesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllLocalizationCountriesQuery,
				GetAllLocalizationCountriesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>(GetAllLocalizationCountriesDocument, options);
}
export type GetAllLocalizationCountriesQueryHookResult = ReturnType<
	typeof useGetAllLocalizationCountriesQuery
>;
export type GetAllLocalizationCountriesLazyQueryHookResult = ReturnType<
	typeof useGetAllLocalizationCountriesLazyQuery
>;
export type GetAllLocalizationCountriesSuspenseQueryHookResult = ReturnType<
	typeof useGetAllLocalizationCountriesSuspenseQuery
>;
export type GetAllLocalizationCountriesQueryResult = Apollo.QueryResult<
	GetAllLocalizationCountriesQuery,
	GetAllLocalizationCountriesQueryVariables
>;
export const GetLocalizationStatesDocument = gql`
	query GetLocalizationStates($countryCode: String!) {
		getLocalizationStates(countryCode: $countryCode) {
			code
			name
		}
	}
`;

/**
 * __useGetLocalizationStatesQuery__
 *
 * To run a query within a React component, call `useGetLocalizationStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalizationStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalizationStatesQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetLocalizationStatesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetLocalizationStatesQuery,
		GetLocalizationStatesQueryVariables
	> &
		({ variables: GetLocalizationStatesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetLocalizationStatesQuery, GetLocalizationStatesQueryVariables>(
		GetLocalizationStatesDocument,
		options
	);
}
export function useGetLocalizationStatesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetLocalizationStatesQuery,
		GetLocalizationStatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetLocalizationStatesQuery, GetLocalizationStatesQueryVariables>(
		GetLocalizationStatesDocument,
		options
	);
}
export function useGetLocalizationStatesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetLocalizationStatesQuery,
				GetLocalizationStatesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetLocalizationStatesQuery, GetLocalizationStatesQueryVariables>(
		GetLocalizationStatesDocument,
		options
	);
}
export type GetLocalizationStatesQueryHookResult = ReturnType<typeof useGetLocalizationStatesQuery>;
export type GetLocalizationStatesLazyQueryHookResult = ReturnType<
	typeof useGetLocalizationStatesLazyQuery
>;
export type GetLocalizationStatesSuspenseQueryHookResult = ReturnType<
	typeof useGetLocalizationStatesSuspenseQuery
>;
export type GetLocalizationStatesQueryResult = Apollo.QueryResult<
	GetLocalizationStatesQuery,
	GetLocalizationStatesQueryVariables
>;
export const AddressAutocompleteDocument = gql`
	query AddressAutocomplete($input: String!, $countryCode: String, $sessionToken: String) {
		addressAutocomplete(input: $input, countryCode: $countryCode, sessionToken: $sessionToken) {
			placeId
			description
			mainText
			secondaryText
		}
	}
`;

/**
 * __useAddressAutocompleteQuery__
 *
 * To run a query within a React component, call `useAddressAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressAutocompleteQuery({
 *   variables: {
 *      input: // value for 'input'
 *      countryCode: // value for 'countryCode'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useAddressAutocompleteQuery(
	baseOptions: Apollo.QueryHookOptions<
		AddressAutocompleteQuery,
		AddressAutocompleteQueryVariables
	> &
		({ variables: AddressAutocompleteQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AddressAutocompleteQuery, AddressAutocompleteQueryVariables>(
		AddressAutocompleteDocument,
		options
	);
}
export function useAddressAutocompleteLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AddressAutocompleteQuery,
		AddressAutocompleteQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AddressAutocompleteQuery, AddressAutocompleteQueryVariables>(
		AddressAutocompleteDocument,
		options
	);
}
export function useAddressAutocompleteSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				AddressAutocompleteQuery,
				AddressAutocompleteQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AddressAutocompleteQuery, AddressAutocompleteQueryVariables>(
		AddressAutocompleteDocument,
		options
	);
}
export type AddressAutocompleteQueryHookResult = ReturnType<typeof useAddressAutocompleteQuery>;
export type AddressAutocompleteLazyQueryHookResult = ReturnType<
	typeof useAddressAutocompleteLazyQuery
>;
export type AddressAutocompleteSuspenseQueryHookResult = ReturnType<
	typeof useAddressAutocompleteSuspenseQuery
>;
export type AddressAutocompleteQueryResult = Apollo.QueryResult<
	AddressAutocompleteQuery,
	AddressAutocompleteQueryVariables
>;
export const GetPlaceDetailsDocument = gql`
	query GetPlaceDetails($placeId: String!, $sessionToken: String) {
		getPlaceDetails(placeId: $placeId, sessionToken: $sessionToken) {
			placeId
			formattedAddress
			streetNumber
			streetName
			city
			state
			stateCode
			postalCode
			country
			countryCode
			latitude
			longitude
			timezone
		}
	}
`;

/**
 * __useGetPlaceDetailsQuery__
 *
 * To run a query within a React component, call `useGetPlaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaceDetailsQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useGetPlaceDetailsQuery(
	baseOptions: Apollo.QueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables> &
		({ variables: GetPlaceDetailsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>(
		GetPlaceDetailsDocument,
		options
	);
}
export function useGetPlaceDetailsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>(
		GetPlaceDetailsDocument,
		options
	);
}
export function useGetPlaceDetailsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>(
		GetPlaceDetailsDocument,
		options
	);
}
export type GetPlaceDetailsQueryHookResult = ReturnType<typeof useGetPlaceDetailsQuery>;
export type GetPlaceDetailsLazyQueryHookResult = ReturnType<typeof useGetPlaceDetailsLazyQuery>;
export type GetPlaceDetailsSuspenseQueryHookResult = ReturnType<
	typeof useGetPlaceDetailsSuspenseQuery
>;
export type GetPlaceDetailsQueryResult = Apollo.QueryResult<
	GetPlaceDetailsQuery,
	GetPlaceDetailsQueryVariables
>;
export const ValidateCvrDocument = gql`
	query ValidateCVR($cvrNumber: String!) {
		validateCVR(cvrNumber: $cvrNumber) {
			valid
			companyInfo {
				name
				vat
				address {
					street
					zipcode
					city
					country
				}
				active
				startDate
				industryCode
				industryDescription
				employees
				phone
				email
			}
			error
		}
	}
`;

/**
 * __useValidateCvrQuery__
 *
 * To run a query within a React component, call `useValidateCvrQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCvrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCvrQuery({
 *   variables: {
 *      cvrNumber: // value for 'cvrNumber'
 *   },
 * });
 */
export function useValidateCvrQuery(
	baseOptions: Apollo.QueryHookOptions<ValidateCvrQuery, ValidateCvrQueryVariables> &
		({ variables: ValidateCvrQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ValidateCvrQuery, ValidateCvrQueryVariables>(
		ValidateCvrDocument,
		options
	);
}
export function useValidateCvrLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ValidateCvrQuery, ValidateCvrQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ValidateCvrQuery, ValidateCvrQueryVariables>(
		ValidateCvrDocument,
		options
	);
}
export function useValidateCvrSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<ValidateCvrQuery, ValidateCvrQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ValidateCvrQuery, ValidateCvrQueryVariables>(
		ValidateCvrDocument,
		options
	);
}
export type ValidateCvrQueryHookResult = ReturnType<typeof useValidateCvrQuery>;
export type ValidateCvrLazyQueryHookResult = ReturnType<typeof useValidateCvrLazyQuery>;
export type ValidateCvrSuspenseQueryHookResult = ReturnType<typeof useValidateCvrSuspenseQuery>;
export type ValidateCvrQueryResult = Apollo.QueryResult<
	ValidateCvrQuery,
	ValidateCvrQueryVariables
>;
export const GenerateVatFromRegistrationDocument = gql`
	query GenerateVATFromRegistration(
		$countryCode: String!
		$registrationNumber: String!
		$registrationType: String!
	) {
		generateVATFromRegistration(
			countryCode: $countryCode
			registrationNumber: $registrationNumber
			registrationType: $registrationType
		)
	}
`;

/**
 * __useGenerateVatFromRegistrationQuery__
 *
 * To run a query within a React component, call `useGenerateVatFromRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateVatFromRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateVatFromRegistrationQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      registrationNumber: // value for 'registrationNumber'
 *      registrationType: // value for 'registrationType'
 *   },
 * });
 */
export function useGenerateVatFromRegistrationQuery(
	baseOptions: Apollo.QueryHookOptions<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	> &
		(
			| { variables: GenerateVatFromRegistrationQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	>(GenerateVatFromRegistrationDocument, options);
}
export function useGenerateVatFromRegistrationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	>(GenerateVatFromRegistrationDocument, options);
}
export function useGenerateVatFromRegistrationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GenerateVatFromRegistrationQuery,
				GenerateVatFromRegistrationQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	>(GenerateVatFromRegistrationDocument, options);
}
export type GenerateVatFromRegistrationQueryHookResult = ReturnType<
	typeof useGenerateVatFromRegistrationQuery
>;
export type GenerateVatFromRegistrationLazyQueryHookResult = ReturnType<
	typeof useGenerateVatFromRegistrationLazyQuery
>;
export type GenerateVatFromRegistrationSuspenseQueryHookResult = ReturnType<
	typeof useGenerateVatFromRegistrationSuspenseQuery
>;
export type GenerateVatFromRegistrationQueryResult = Apollo.QueryResult<
	GenerateVatFromRegistrationQuery,
	GenerateVatFromRegistrationQueryVariables
>;
export const GetAllManufacturersDocument = gql`
	query GetAllManufacturers($input: GetAllManufacturerInput!) {
		getAllManufacturer(input: $input) {
			data {
				id
				name
				country
				description
				website
				logoUrl
				isActive
				createdAt
				updatedAt
				vetterEntity {
					id
					name
				}
			}
			pageInfo {
				currentPage
				totalPages
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllManufacturersQuery__
 *
 * To run a query within a React component, call `useGetAllManufacturersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllManufacturersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllManufacturersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllManufacturersQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllManufacturersQuery,
		GetAllManufacturersQueryVariables
	> &
		({ variables: GetAllManufacturersQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllManufacturersQuery, GetAllManufacturersQueryVariables>(
		GetAllManufacturersDocument,
		options
	);
}
export function useGetAllManufacturersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllManufacturersQuery,
		GetAllManufacturersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllManufacturersQuery, GetAllManufacturersQueryVariables>(
		GetAllManufacturersDocument,
		options
	);
}
export function useGetAllManufacturersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllManufacturersQuery,
				GetAllManufacturersQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllManufacturersQuery, GetAllManufacturersQueryVariables>(
		GetAllManufacturersDocument,
		options
	);
}
export type GetAllManufacturersQueryHookResult = ReturnType<typeof useGetAllManufacturersQuery>;
export type GetAllManufacturersLazyQueryHookResult = ReturnType<
	typeof useGetAllManufacturersLazyQuery
>;
export type GetAllManufacturersSuspenseQueryHookResult = ReturnType<
	typeof useGetAllManufacturersSuspenseQuery
>;
export type GetAllManufacturersQueryResult = Apollo.QueryResult<
	GetAllManufacturersQuery,
	GetAllManufacturersQueryVariables
>;
export const GetManufacturerStatsDocument = gql`
	query GetManufacturerStats {
		getManufacturerStats {
			total
			active
			inactive
			withVetter
		}
	}
`;

/**
 * __useGetManufacturerStatsQuery__
 *
 * To run a query within a React component, call `useGetManufacturerStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManufacturerStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManufacturerStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManufacturerStatsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetManufacturerStatsQuery,
		GetManufacturerStatsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetManufacturerStatsQuery, GetManufacturerStatsQueryVariables>(
		GetManufacturerStatsDocument,
		options
	);
}
export function useGetManufacturerStatsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetManufacturerStatsQuery,
		GetManufacturerStatsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetManufacturerStatsQuery, GetManufacturerStatsQueryVariables>(
		GetManufacturerStatsDocument,
		options
	);
}
export function useGetManufacturerStatsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetManufacturerStatsQuery,
				GetManufacturerStatsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetManufacturerStatsQuery, GetManufacturerStatsQueryVariables>(
		GetManufacturerStatsDocument,
		options
	);
}
export type GetManufacturerStatsQueryHookResult = ReturnType<typeof useGetManufacturerStatsQuery>;
export type GetManufacturerStatsLazyQueryHookResult = ReturnType<
	typeof useGetManufacturerStatsLazyQuery
>;
export type GetManufacturerStatsSuspenseQueryHookResult = ReturnType<
	typeof useGetManufacturerStatsSuspenseQuery
>;
export type GetManufacturerStatsQueryResult = Apollo.QueryResult<
	GetManufacturerStatsQuery,
	GetManufacturerStatsQueryVariables
>;
export const GetManufacturerDocument = gql`
	query GetManufacturer($id: ID!) {
		getManufacturer(id: $id) {
			id
			name
			country
			description
			website
			logoUrl
			isActive
			createdAt
			updatedAt
			vetterEntity {
				id
				name
				description
				isActive
				primaryContact {
					id
					firstName
					lastName
					phone
					authenticationUser {
						id
						email
					}
				}
			}
		}
	}
`;

/**
 * __useGetManufacturerQuery__
 *
 * To run a query within a React component, call `useGetManufacturerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManufacturerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManufacturerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetManufacturerQuery(
	baseOptions: Apollo.QueryHookOptions<GetManufacturerQuery, GetManufacturerQueryVariables> &
		({ variables: GetManufacturerQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetManufacturerQuery, GetManufacturerQueryVariables>(
		GetManufacturerDocument,
		options
	);
}
export function useGetManufacturerLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetManufacturerQuery, GetManufacturerQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetManufacturerQuery, GetManufacturerQueryVariables>(
		GetManufacturerDocument,
		options
	);
}
export function useGetManufacturerSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetManufacturerQuery, GetManufacturerQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetManufacturerQuery, GetManufacturerQueryVariables>(
		GetManufacturerDocument,
		options
	);
}
export type GetManufacturerQueryHookResult = ReturnType<typeof useGetManufacturerQuery>;
export type GetManufacturerLazyQueryHookResult = ReturnType<typeof useGetManufacturerLazyQuery>;
export type GetManufacturerSuspenseQueryHookResult = ReturnType<
	typeof useGetManufacturerSuspenseQuery
>;
export type GetManufacturerQueryResult = Apollo.QueryResult<
	GetManufacturerQuery,
	GetManufacturerQueryVariables
>;
export const GetOfferBatchLocationDocument = gql`
	query GetOfferBatchLocation($id: ID!) {
		getOfferBatchLocation(id: $id) {
			offerBatchId
			orderQuoteId
		}
	}
`;

/**
 * __useGetOfferBatchLocationQuery__
 *
 * To run a query within a React component, call `useGetOfferBatchLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferBatchLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferBatchLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOfferBatchLocationQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOfferBatchLocationQuery,
		GetOfferBatchLocationQueryVariables
	> &
		({ variables: GetOfferBatchLocationQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOfferBatchLocationQuery, GetOfferBatchLocationQueryVariables>(
		GetOfferBatchLocationDocument,
		options
	);
}
export function useGetOfferBatchLocationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOfferBatchLocationQuery,
		GetOfferBatchLocationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOfferBatchLocationQuery, GetOfferBatchLocationQueryVariables>(
		GetOfferBatchLocationDocument,
		options
	);
}
export function useGetOfferBatchLocationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOfferBatchLocationQuery,
				GetOfferBatchLocationQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOfferBatchLocationQuery, GetOfferBatchLocationQueryVariables>(
		GetOfferBatchLocationDocument,
		options
	);
}
export type GetOfferBatchLocationQueryHookResult = ReturnType<typeof useGetOfferBatchLocationQuery>;
export type GetOfferBatchLocationLazyQueryHookResult = ReturnType<
	typeof useGetOfferBatchLocationLazyQuery
>;
export type GetOfferBatchLocationSuspenseQueryHookResult = ReturnType<
	typeof useGetOfferBatchLocationSuspenseQuery
>;
export type GetOfferBatchLocationQueryResult = Apollo.QueryResult<
	GetOfferBatchLocationQuery,
	GetOfferBatchLocationQueryVariables
>;
export const GetSampleLocationDocument = gql`
	query GetSampleLocation($id: ID!) {
		getSampleLocation(id: $id) {
			sampleId
			orderItemId
			orderId
		}
	}
`;

/**
 * __useGetSampleLocationQuery__
 *
 * To run a query within a React component, call `useGetSampleLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSampleLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSampleLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSampleLocationQuery(
	baseOptions: Apollo.QueryHookOptions<GetSampleLocationQuery, GetSampleLocationQueryVariables> &
		({ variables: GetSampleLocationQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetSampleLocationQuery, GetSampleLocationQueryVariables>(
		GetSampleLocationDocument,
		options
	);
}
export function useGetSampleLocationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetSampleLocationQuery,
		GetSampleLocationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetSampleLocationQuery, GetSampleLocationQueryVariables>(
		GetSampleLocationDocument,
		options
	);
}
export function useGetSampleLocationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetSampleLocationQuery, GetSampleLocationQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetSampleLocationQuery, GetSampleLocationQueryVariables>(
		GetSampleLocationDocument,
		options
	);
}
export type GetSampleLocationQueryHookResult = ReturnType<typeof useGetSampleLocationQuery>;
export type GetSampleLocationLazyQueryHookResult = ReturnType<typeof useGetSampleLocationLazyQuery>;
export type GetSampleLocationSuspenseQueryHookResult = ReturnType<
	typeof useGetSampleLocationSuspenseQuery
>;
export type GetSampleLocationQueryResult = Apollo.QueryResult<
	GetSampleLocationQuery,
	GetSampleLocationQueryVariables
>;
export const GetNotificationSettingsDocument = gql`
	query GetNotificationSettings {
		getNotificationSettings {
			type
			label
			description
			category
			audience
			templateKey
			emailEnabled
			bellEnabled
			alwaysOn
		}
	}
`;

/**
 * __useGetNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useGetNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationSettingsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetNotificationSettingsQuery,
		GetNotificationSettingsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>(
		GetNotificationSettingsDocument,
		options
	);
}
export function useGetNotificationSettingsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetNotificationSettingsQuery,
		GetNotificationSettingsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>(
		GetNotificationSettingsDocument,
		options
	);
}
export function useGetNotificationSettingsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetNotificationSettingsQuery,
				GetNotificationSettingsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetNotificationSettingsQuery,
		GetNotificationSettingsQueryVariables
	>(GetNotificationSettingsDocument, options);
}
export type GetNotificationSettingsQueryHookResult = ReturnType<
	typeof useGetNotificationSettingsQuery
>;
export type GetNotificationSettingsLazyQueryHookResult = ReturnType<
	typeof useGetNotificationSettingsLazyQuery
>;
export type GetNotificationSettingsSuspenseQueryHookResult = ReturnType<
	typeof useGetNotificationSettingsSuspenseQuery
>;
export type GetNotificationSettingsQueryResult = Apollo.QueryResult<
	GetNotificationSettingsQuery,
	GetNotificationSettingsQueryVariables
>;
export const GetMyNotificationsDocument = gql`
	query GetMyNotifications($limit: Int, $offset: Int, $unreadOnly: Boolean) {
		getMyNotifications(limit: $limit, offset: $offset, unreadOnly: $unreadOnly) {
			total
			unreadCount
			items {
				id
				type
				title
				body
				entityType
				entityId
				readAt
				emailSent
				createdAt
			}
		}
	}
`;

/**
 * __useGetMyNotificationsQuery__
 *
 * To run a query within a React component, call `useGetMyNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNotificationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      unreadOnly: // value for 'unreadOnly'
 *   },
 * });
 */
export function useGetMyNotificationsQuery(
	baseOptions?: Apollo.QueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(
		GetMyNotificationsDocument,
		options
	);
}
export function useGetMyNotificationsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetMyNotificationsQuery,
		GetMyNotificationsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(
		GetMyNotificationsDocument,
		options
	);
}
export function useGetMyNotificationsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(
		GetMyNotificationsDocument,
		options
	);
}
export type GetMyNotificationsQueryHookResult = ReturnType<typeof useGetMyNotificationsQuery>;
export type GetMyNotificationsLazyQueryHookResult = ReturnType<
	typeof useGetMyNotificationsLazyQuery
>;
export type GetMyNotificationsSuspenseQueryHookResult = ReturnType<
	typeof useGetMyNotificationsSuspenseQuery
>;
export type GetMyNotificationsQueryResult = Apollo.QueryResult<
	GetMyNotificationsQuery,
	GetMyNotificationsQueryVariables
>;
export const GetMyUnreadNotificationCountDocument = gql`
	query GetMyUnreadNotificationCount {
		getMyUnreadNotificationCount
	}
`;

/**
 * __useGetMyUnreadNotificationCountQuery__
 *
 * To run a query within a React component, call `useGetMyUnreadNotificationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyUnreadNotificationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyUnreadNotificationCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyUnreadNotificationCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetMyUnreadNotificationCountQuery,
		GetMyUnreadNotificationCountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetMyUnreadNotificationCountQuery,
		GetMyUnreadNotificationCountQueryVariables
	>(GetMyUnreadNotificationCountDocument, options);
}
export function useGetMyUnreadNotificationCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetMyUnreadNotificationCountQuery,
		GetMyUnreadNotificationCountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetMyUnreadNotificationCountQuery,
		GetMyUnreadNotificationCountQueryVariables
	>(GetMyUnreadNotificationCountDocument, options);
}
export function useGetMyUnreadNotificationCountSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetMyUnreadNotificationCountQuery,
				GetMyUnreadNotificationCountQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetMyUnreadNotificationCountQuery,
		GetMyUnreadNotificationCountQueryVariables
	>(GetMyUnreadNotificationCountDocument, options);
}
export type GetMyUnreadNotificationCountQueryHookResult = ReturnType<
	typeof useGetMyUnreadNotificationCountQuery
>;
export type GetMyUnreadNotificationCountLazyQueryHookResult = ReturnType<
	typeof useGetMyUnreadNotificationCountLazyQuery
>;
export type GetMyUnreadNotificationCountSuspenseQueryHookResult = ReturnType<
	typeof useGetMyUnreadNotificationCountSuspenseQuery
>;
export type GetMyUnreadNotificationCountQueryResult = Apollo.QueryResult<
	GetMyUnreadNotificationCountQuery,
	GetMyUnreadNotificationCountQueryVariables
>;
export const GetOrderDocument = gql`
	query GetOrder($id: ID!, $inCurrency: CurrencyEnum) {
		getOrder(id: $id) {
			id
			name
			orderNumber
			status
			orderQuoteId
			organizationId
			deliveryAddress {
				addressLine1
				addressLine2
				city
				stateCode
				postalCode
				countryCode
			}
			deliveryAddressLockedReason
			deliveryAddressChangedAt
			availableActions(inCurrency: $inCurrency) {
				action
				actor
				kind
				label
				displayType
				blocked
				blockedReason
				warningReason
				itemCount
				paymentTransactionId
				amount
				currency
			}
			availablePaymentMethods {
				method
				available
				reason
			}
			availableSamplePaymentMethods {
				method
				available
				reason
			}
			organization {
				id
				name
				countryCode
				createdAt
				addresses {
					id
					city
					countryCode
					isPrimary
				}
			}
			productPaymentMode
			samplePaymentMode
			stripeCheckoutLimit
			invoiceMinimum
			baseTotalAmount(inCurrency: $inCurrency)
			totalAmount(inCurrency: $inCurrency)
			marginTotal(inCurrency: $inCurrency)
			totalQuantity
			itemsAwaitingConfirmation
			setupStage
			orderQuote {
				id
				name
				description
				purpose
				purposeOther
				deadline
				adminUserIds
				adminUsers {
					id
					firstName
					lastName
				}
				clientContactUserIds
			}
			items {
				orderQuoteOfferId
				id
				productId
				productName
				productImages {
					...OrderItemProductImageFragment
				}
				productDescription
				productSku
				productWeight
				productDimensions {
					length
					width
					height
					unit
				}
				productSpecificationsAt
				productSpecifications {
					...OrderProductSpecificationsFragment
				}
				quantity
				sortOrder
				status
				sampleChoice
				attachments {
					id
					name
					description
					mimeType
					size
					url
				}
				lifecycle {
					step
					label
					completed
					current
					actor
					skipped
					skippedReason
					outstanding
					outstandingReason
				}
				shippedQuantity
				deliveredQuantity
				baseUnitPrice(inCurrency: $inCurrency)
				unitPrice(inCurrency: $inCurrency)
				baseTotalPrice(inCurrency: $inCurrency)
				totalPrice(inCurrency: $inCurrency)
				adjustedTotalPrice(inCurrency: $inCurrency)
				lineTotal(inCurrency: $inCurrency)
				marginAmount(inCurrency: $inCurrency)
				confirmedAt
				vetterEntityId
				confirmedVetterEntityId
				minProductionDays
				maxProductionDays
				paidAt
				productionStartedAt
				productionCompletedAt
				shippedAt
				carrier
				trackingNumber
				estimatedDeliveryDate
				actualDeliveryDate
				shipments {
					quantity
					shipment {
						id
						sequence
						status
						shippingMethod
						carrier
						trackingNumber
						trackingUrl
						shippedAt
						estimatedDeliveryDate
						actualDeliveryDate
						availableActions {
							key
							actor
							kind
							status
							label
							requiredFields
							optionalFields
							blocked
							blockedReason
						}
					}
				}
				waitingOn
				availableActions {
					action
					actor
					kind
					label
					status
					displayType
					blocked
					blockedReason
					warningReason
					requiredFields
					optionalFields
				}
				delivery {
					id
					shippingMethod
					shippingMethodLabel
					quantity
					deliveryDaysMin
					deliveryDaysMax
					totalPrice(inCurrency: $inCurrency)
				}
				samples {
					id
					sampleChoice
					sampleRound
					status
					lifecycle {
						step
						label
						completed
						current
						actor
						outstanding
						outstandingReason
					}
					totalPrice(inCurrency: $inCurrency)
					paymentTreatment
					paidAt
					baseSamplePrice(inCurrency: $inCurrency)
					baseShippingPrice(inCurrency: $inCurrency)
					minProductionDays
					maxProductionDays
					deliveryDaysMin
					deliveryDaysMax
					approvedAt
					approvedBy
					notes
					approvalNotes
					rejectedAt
					rejectedBy
					rejectionReason
					requestNewSample
					productionStartedAt
					productionCompletedAt
					shippedAt
					carrier
					trackingNumber
					trackingUrl
					estimatedDeliveryDate
					actualDeliveryDate
					virtualDeliverySubmittedAt
					virtualDeliveryNotes
					attachments {
						id
						name
						mimeType
						size
						url
						type
					}
					availableActions {
						action
						actor
						kind
						label
						status
						blocked
						blockedReason
						warningReason
						requiredFields
						optionalFields
						requiresAttachments
						supportsAttachments
						hasAttachments
					}
					previousSampleId
					orderItemId
				}
				adjustments {
					id
					name
					description
					type
					calculationType
					value(inCurrency: $inCurrency)
				}
				createdAt
			}
			summary(inCurrency: $inCurrency) {
				productsSubtotal
				samplesTotal
				samplesShippingTotal
				samplesPrepaidTotal
				deliveryTotal
				feesTotal
				fees {
					name
					amount
				}
				discountsTotal
				discounts {
					name
					amount
				}
				sampleCreditAtRisk
				sampleCreditUncredited
				marginTotal
				marginPercentage
				grandTotal
				vatRate
				vatAmount
				grossAmount
			}
			paymentSummary(inCurrency: $inCurrency) {
				productStatus
				productTotalAmount
				productPaidAmount
				productOutstandingAmount
				sampleStatus
				sampleTotalAmount
				samplePaidAmount
				sampleOutstandingAmount
				totalAmount
				totalPaidAmount
				totalOutstandingAmount
				vatRate
			}
			deliveries {
				id
				kind
				isPhysical
				reference
				state
				stateLabel
				carrier
				trackingNumber
				trackingUrl
				shippingMethodLabel
				projected
				expectedEarliest
				expectedLatest
				shippedAt
				actualDeliveryDate
				lines {
					orderItemId
					productName
					quantity
				}
			}
			shipments {
				id
				sequence
				shippingMethod
				status
				lifecycle {
					step
					label
					completed
					current
					actor
					skipped
					outstanding
					outstandingReason
				}
				deliveryDaysMin
				deliveryDaysMax
				carrier
				trackingNumber
				trackingUrl
				shippedAt
				estimatedDeliveryDate
				actualDeliveryDate
				splitOfOrderShipmentId
				availableActions {
					key
					actor
					kind
					status
					label
					requiredFields
					optionalFields
					blocked
					blockedReason
				}
				totalPrice(inCurrency: $inCurrency)
				lines {
					id
					orderItemId
					quantity
				}
			}
			createdAt
			updatedAt
		}
	}
	${OrderItemProductImageFragmentFragmentDoc}
	${OrderProductSpecificationsFragmentFragmentDoc}
`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetOrderQuery(
	baseOptions: Apollo.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables> &
		({ variables: GetOrderQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
}
export function useGetOrderLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
}
export function useGetOrderSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOrderQuery, GetOrderQueryVariables>(
		GetOrderDocument,
		options
	);
}
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderSuspenseQueryHookResult = ReturnType<typeof useGetOrderSuspenseQuery>;
export type GetOrderQueryResult = Apollo.QueryResult<GetOrderQuery, GetOrderQueryVariables>;
export const GetOrderActivitiesDocument = gql`
	query GetOrderActivities($orderId: ID!, $inCurrency: String) {
		getOrderActivities(orderId: $orderId, inCurrency: $inCurrency) {
			id
			action
			message
			actorId
			actorRole
			adminUser {
				firstName
				lastName
			}
			organizationUser {
				firstName
				lastName
			}
			metadata
			orderId
			createdAt
		}
	}
`;

/**
 * __useGetOrderActivitiesQuery__
 *
 * To run a query within a React component, call `useGetOrderActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderActivitiesQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetOrderActivitiesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrderActivitiesQuery,
		GetOrderActivitiesQueryVariables
	> &
		({ variables: GetOrderActivitiesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderActivitiesQuery, GetOrderActivitiesQueryVariables>(
		GetOrderActivitiesDocument,
		options
	);
}
export function useGetOrderActivitiesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderActivitiesQuery,
		GetOrderActivitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrderActivitiesQuery, GetOrderActivitiesQueryVariables>(
		GetOrderActivitiesDocument,
		options
	);
}
export function useGetOrderActivitiesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetOrderActivitiesQuery, GetOrderActivitiesQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOrderActivitiesQuery, GetOrderActivitiesQueryVariables>(
		GetOrderActivitiesDocument,
		options
	);
}
export type GetOrderActivitiesQueryHookResult = ReturnType<typeof useGetOrderActivitiesQuery>;
export type GetOrderActivitiesLazyQueryHookResult = ReturnType<
	typeof useGetOrderActivitiesLazyQuery
>;
export type GetOrderActivitiesSuspenseQueryHookResult = ReturnType<
	typeof useGetOrderActivitiesSuspenseQuery
>;
export type GetOrderActivitiesQueryResult = Apollo.QueryResult<
	GetOrderActivitiesQuery,
	GetOrderActivitiesQueryVariables
>;
export const GetAllOrdersDocument = gql`
	query GetAllOrders($input: GetAllOrdersInput!, $inCurrency: CurrencyEnum) {
		getAllOrders(input: $input) {
			data {
				id
				name
				orderNumber
				status
				organizationId
				organization {
					id
					name
				}
				orderQuoteId
				baseTotalAmount(inCurrency: $inCurrency)
				totalAmount(inCurrency: $inCurrency)
				marginTotal(inCurrency: $inCurrency)
				summary(inCurrency: $inCurrency) {
					grandTotal
					grossAmount
				}
				paymentSummary(inCurrency: $inCurrency) {
					totalAmount
					totalPaidAmount
					totalOutstandingAmount
				}
				items {
					id
					quantity
					productName
					productImages {
						...OrderItemProductImageFragment
					}
					status
				}
				shipping {
					state
					total
					shipped
					overdue
				}
				createdAt
				updatedAt
			}
			pageInfo {
				currentPage
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
	${OrderItemProductImageFragmentFragmentDoc}
`;

/**
 * __useGetAllOrdersQuery__
 *
 * To run a query within a React component, call `useGetAllOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetAllOrdersQuery(
	baseOptions: Apollo.QueryHookOptions<GetAllOrdersQuery, GetAllOrdersQueryVariables> &
		({ variables: GetAllOrdersQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllOrdersQuery, GetAllOrdersQueryVariables>(
		GetAllOrdersDocument,
		options
	);
}
export function useGetAllOrdersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetAllOrdersQuery, GetAllOrdersQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllOrdersQuery, GetAllOrdersQueryVariables>(
		GetAllOrdersDocument,
		options
	);
}
export function useGetAllOrdersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllOrdersQuery, GetAllOrdersQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllOrdersQuery, GetAllOrdersQueryVariables>(
		GetAllOrdersDocument,
		options
	);
}
export type GetAllOrdersQueryHookResult = ReturnType<typeof useGetAllOrdersQuery>;
export type GetAllOrdersLazyQueryHookResult = ReturnType<typeof useGetAllOrdersLazyQuery>;
export type GetAllOrdersSuspenseQueryHookResult = ReturnType<typeof useGetAllOrdersSuspenseQuery>;
export type GetAllOrdersQueryResult = Apollo.QueryResult<
	GetAllOrdersQuery,
	GetAllOrdersQueryVariables
>;
export const GetOrderQuoteDocument = gql`
	query GetOrderQuote($id: ID!) {
		getOrderQuote(id: $id) {
			id
			name
			description
			deadline
			status
			organizationId
			organization {
				id
				name
				logo
			}
			purpose
			purposeOther
			pendingAcceptance
			supersededAcceptances
			adminUserIds
			adminUsers {
				id
				firstName
				lastName
			}
			vetterEntityIds
			vetterEntities {
				id
				name
			}
			deliveryAddress {
				addressLine1
				addressLine2
				city
				stateCode
				postalCode
				countryCode
			}
			offerBatchCount
			lastClientViewedAt
			firstClientViewedAt
			clientViewCount
			productPaymentMode
			samplePaymentMode
			stripeCheckoutLimit
			invoiceMinimum
			paymentSettingsSnapshotAt
			clientContactUserIds
			lifecycle {
				step
				label
				completed
				current
			}
			items {
				id
				productId
				productSpecificationsAt
				productSpecifications {
					...OrderProductSpecificationsFragment
				}
				productName
				productSku
				productDescription
				productWeight
				productDimensions {
					length
					width
					height
					unit
				}
				productImages {
					...OrderQuoteItemProductImageFragment
				}
				deadline
				timelineStatus {
					level
					businessDaysLeft
					isExpired
				}
				sortOrder
				quantities {
					id
					quantity
					sortOrder
				}
				attachments {
					id
					name
					description
					mimeType
					size
					url
				}
			}
			createdAt
			updatedAt
		}
	}
	${OrderProductSpecificationsFragmentFragmentDoc}
	${OrderQuoteItemProductImageFragmentFragmentDoc}
`;

/**
 * __useGetOrderQuoteQuery__
 *
 * To run a query within a React component, call `useGetOrderQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderQuoteQuery(
	baseOptions: Apollo.QueryHookOptions<GetOrderQuoteQuery, GetOrderQuoteQueryVariables> &
		({ variables: GetOrderQuoteQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderQuoteQuery, GetOrderQuoteQueryVariables>(
		GetOrderQuoteDocument,
		options
	);
}
export function useGetOrderQuoteLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetOrderQuoteQuery, GetOrderQuoteQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrderQuoteQuery, GetOrderQuoteQueryVariables>(
		GetOrderQuoteDocument,
		options
	);
}
export function useGetOrderQuoteSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetOrderQuoteQuery, GetOrderQuoteQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOrderQuoteQuery, GetOrderQuoteQueryVariables>(
		GetOrderQuoteDocument,
		options
	);
}
export type GetOrderQuoteQueryHookResult = ReturnType<typeof useGetOrderQuoteQuery>;
export type GetOrderQuoteLazyQueryHookResult = ReturnType<typeof useGetOrderQuoteLazyQuery>;
export type GetOrderQuoteSuspenseQueryHookResult = ReturnType<typeof useGetOrderQuoteSuspenseQuery>;
export type GetOrderQuoteQueryResult = Apollo.QueryResult<
	GetOrderQuoteQuery,
	GetOrderQuoteQueryVariables
>;
export const GetOrderQuoteItemByProductDocument = gql`
	query GetOrderQuoteItemByProduct($orderQuoteId: ID!, $productId: ID!) {
		getOrderQuoteItemByProduct(orderQuoteId: $orderQuoteId, productId: $productId) {
			id
			productId
			deadline
			quantities {
				id
				quantity
				sortOrder
			}
		}
	}
`;

/**
 * __useGetOrderQuoteItemByProductQuery__
 *
 * To run a query within a React component, call `useGetOrderQuoteItemByProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuoteItemByProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuoteItemByProductQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetOrderQuoteItemByProductQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrderQuoteItemByProductQuery,
		GetOrderQuoteItemByProductQueryVariables
	> &
		(
			| { variables: GetOrderQuoteItemByProductQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrderQuoteItemByProductQuery,
		GetOrderQuoteItemByProductQueryVariables
	>(GetOrderQuoteItemByProductDocument, options);
}
export function useGetOrderQuoteItemByProductLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderQuoteItemByProductQuery,
		GetOrderQuoteItemByProductQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrderQuoteItemByProductQuery,
		GetOrderQuoteItemByProductQueryVariables
	>(GetOrderQuoteItemByProductDocument, options);
}
export function useGetOrderQuoteItemByProductSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderQuoteItemByProductQuery,
				GetOrderQuoteItemByProductQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrderQuoteItemByProductQuery,
		GetOrderQuoteItemByProductQueryVariables
	>(GetOrderQuoteItemByProductDocument, options);
}
export type GetOrderQuoteItemByProductQueryHookResult = ReturnType<
	typeof useGetOrderQuoteItemByProductQuery
>;
export type GetOrderQuoteItemByProductLazyQueryHookResult = ReturnType<
	typeof useGetOrderQuoteItemByProductLazyQuery
>;
export type GetOrderQuoteItemByProductSuspenseQueryHookResult = ReturnType<
	typeof useGetOrderQuoteItemByProductSuspenseQuery
>;
export type GetOrderQuoteItemByProductQueryResult = Apollo.QueryResult<
	GetOrderQuoteItemByProductQuery,
	GetOrderQuoteItemByProductQueryVariables
>;
export const GetOrderQuoteActivitiesDocument = gql`
	query GetOrderQuoteActivities($orderQuoteId: ID!, $inCurrency: String) {
		getOrderQuoteActivities(orderQuoteId: $orderQuoteId, inCurrency: $inCurrency) {
			id
			action
			message
			actorId
			actorRole
			adminUser {
				firstName
				lastName
			}
			organizationUser {
				firstName
				lastName
			}
			metadata
			orderQuoteId
			createdAt
		}
	}
`;

/**
 * __useGetOrderQuoteActivitiesQuery__
 *
 * To run a query within a React component, call `useGetOrderQuoteActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuoteActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuoteActivitiesQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetOrderQuoteActivitiesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrderQuoteActivitiesQuery,
		GetOrderQuoteActivitiesQueryVariables
	> &
		({ variables: GetOrderQuoteActivitiesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderQuoteActivitiesQuery, GetOrderQuoteActivitiesQueryVariables>(
		GetOrderQuoteActivitiesDocument,
		options
	);
}
export function useGetOrderQuoteActivitiesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderQuoteActivitiesQuery,
		GetOrderQuoteActivitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrderQuoteActivitiesQuery, GetOrderQuoteActivitiesQueryVariables>(
		GetOrderQuoteActivitiesDocument,
		options
	);
}
export function useGetOrderQuoteActivitiesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderQuoteActivitiesQuery,
				GetOrderQuoteActivitiesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrderQuoteActivitiesQuery,
		GetOrderQuoteActivitiesQueryVariables
	>(GetOrderQuoteActivitiesDocument, options);
}
export type GetOrderQuoteActivitiesQueryHookResult = ReturnType<
	typeof useGetOrderQuoteActivitiesQuery
>;
export type GetOrderQuoteActivitiesLazyQueryHookResult = ReturnType<
	typeof useGetOrderQuoteActivitiesLazyQuery
>;
export type GetOrderQuoteActivitiesSuspenseQueryHookResult = ReturnType<
	typeof useGetOrderQuoteActivitiesSuspenseQuery
>;
export type GetOrderQuoteActivitiesQueryResult = Apollo.QueryResult<
	GetOrderQuoteActivitiesQuery,
	GetOrderQuoteActivitiesQueryVariables
>;
export const GetAllOrderQuoteDocument = gql`
	query GetAllOrderQuote($input: GetAllOrderQuoteInput!) {
		getAllOrderQuote(input: $input) {
			data {
				id
				name
				description
				deadline
				status
				organizationId
				organization {
					id
					name
				}
				purpose
				lastClientViewedAt
				clientViewCount
				createdAt
				updatedAt
			}
			pageInfo {
				currentPage
				totalCount
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllOrderQuoteQuery__
 *
 * To run a query within a React component, call `useGetAllOrderQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrderQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrderQuoteQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllOrderQuoteQuery(
	baseOptions: Apollo.QueryHookOptions<GetAllOrderQuoteQuery, GetAllOrderQuoteQueryVariables> &
		({ variables: GetAllOrderQuoteQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllOrderQuoteQuery, GetAllOrderQuoteQueryVariables>(
		GetAllOrderQuoteDocument,
		options
	);
}
export function useGetAllOrderQuoteLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetAllOrderQuoteQuery, GetAllOrderQuoteQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllOrderQuoteQuery, GetAllOrderQuoteQueryVariables>(
		GetAllOrderQuoteDocument,
		options
	);
}
export function useGetAllOrderQuoteSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllOrderQuoteQuery, GetAllOrderQuoteQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllOrderQuoteQuery, GetAllOrderQuoteQueryVariables>(
		GetAllOrderQuoteDocument,
		options
	);
}
export type GetAllOrderQuoteQueryHookResult = ReturnType<typeof useGetAllOrderQuoteQuery>;
export type GetAllOrderQuoteLazyQueryHookResult = ReturnType<typeof useGetAllOrderQuoteLazyQuery>;
export type GetAllOrderQuoteSuspenseQueryHookResult = ReturnType<
	typeof useGetAllOrderQuoteSuspenseQuery
>;
export type GetAllOrderQuoteQueryResult = Apollo.QueryResult<
	GetAllOrderQuoteQuery,
	GetAllOrderQuoteQueryVariables
>;
export const PreviewOrderQuoteItemQuantityChangeDocument = gql`
	query PreviewOrderQuoteItemQuantityChange(
		$orderQuoteItemId: ID!
		$quantities: [OrderQuoteItemQuantityInput!]!
	) {
		previewOrderQuoteItemQuantityChange(
			orderQuoteItemId: $orderQuoteItemId
			quantities: $quantities
		) {
			accepted
			severity
			errors {
				key
				message
			}
			changes {
				kind
				severity
				key
				message
				orderQuoteItemQuantityId
				currentQuantity
				newQuantity
				impact {
					pricedOfferCount
					deliveryOptionCount
					clientVisibleOfferCount
					clientSelectionCount
					masterSelectionCount
					offers {
						orderQuoteOfferId
						offerName
						orderQuoteOfferBatchId
						batchName
						batchStatus
						isVisibleToClient
					}
				}
			}
		}
	}
`;

/**
 * __usePreviewOrderQuoteItemQuantityChangeQuery__
 *
 * To run a query within a React component, call `usePreviewOrderQuoteItemQuantityChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewOrderQuoteItemQuantityChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewOrderQuoteItemQuantityChangeQuery({
 *   variables: {
 *      orderQuoteItemId: // value for 'orderQuoteItemId'
 *      quantities: // value for 'quantities'
 *   },
 * });
 */
export function usePreviewOrderQuoteItemQuantityChangeQuery(
	baseOptions: Apollo.QueryHookOptions<
		PreviewOrderQuoteItemQuantityChangeQuery,
		PreviewOrderQuoteItemQuantityChangeQueryVariables
	> &
		(
			| { variables: PreviewOrderQuoteItemQuantityChangeQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		PreviewOrderQuoteItemQuantityChangeQuery,
		PreviewOrderQuoteItemQuantityChangeQueryVariables
	>(PreviewOrderQuoteItemQuantityChangeDocument, options);
}
export function usePreviewOrderQuoteItemQuantityChangeLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PreviewOrderQuoteItemQuantityChangeQuery,
		PreviewOrderQuoteItemQuantityChangeQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		PreviewOrderQuoteItemQuantityChangeQuery,
		PreviewOrderQuoteItemQuantityChangeQueryVariables
	>(PreviewOrderQuoteItemQuantityChangeDocument, options);
}
export function usePreviewOrderQuoteItemQuantityChangeSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				PreviewOrderQuoteItemQuantityChangeQuery,
				PreviewOrderQuoteItemQuantityChangeQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		PreviewOrderQuoteItemQuantityChangeQuery,
		PreviewOrderQuoteItemQuantityChangeQueryVariables
	>(PreviewOrderQuoteItemQuantityChangeDocument, options);
}
export type PreviewOrderQuoteItemQuantityChangeQueryHookResult = ReturnType<
	typeof usePreviewOrderQuoteItemQuantityChangeQuery
>;
export type PreviewOrderQuoteItemQuantityChangeLazyQueryHookResult = ReturnType<
	typeof usePreviewOrderQuoteItemQuantityChangeLazyQuery
>;
export type PreviewOrderQuoteItemQuantityChangeSuspenseQueryHookResult = ReturnType<
	typeof usePreviewOrderQuoteItemQuantityChangeSuspenseQuery
>;
export type PreviewOrderQuoteItemQuantityChangeQueryResult = Apollo.QueryResult<
	PreviewOrderQuoteItemQuantityChangeQuery,
	PreviewOrderQuoteItemQuantityChangeQueryVariables
>;
export const GetOrderQuoteValueRangeDocument = gql`
	query GetOrderQuoteValueRange($orderQuoteId: ID!, $inCurrency: CurrencyEnum) {
		getOrderQuoteValueRange(orderQuoteId: $orderQuoteId, inCurrency: $inCurrency) {
			low {
				...OrderQuoteValuePointFragment
			}
			high {
				...OrderQuoteValuePointFragment
			}
		}
	}
	${OrderQuoteValuePointFragmentFragmentDoc}
`;

/**
 * __useGetOrderQuoteValueRangeQuery__
 *
 * To run a query within a React component, call `useGetOrderQuoteValueRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuoteValueRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuoteValueRangeQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetOrderQuoteValueRangeQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrderQuoteValueRangeQuery,
		GetOrderQuoteValueRangeQueryVariables
	> &
		({ variables: GetOrderQuoteValueRangeQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderQuoteValueRangeQuery, GetOrderQuoteValueRangeQueryVariables>(
		GetOrderQuoteValueRangeDocument,
		options
	);
}
export function useGetOrderQuoteValueRangeLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderQuoteValueRangeQuery,
		GetOrderQuoteValueRangeQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrderQuoteValueRangeQuery, GetOrderQuoteValueRangeQueryVariables>(
		GetOrderQuoteValueRangeDocument,
		options
	);
}
export function useGetOrderQuoteValueRangeSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderQuoteValueRangeQuery,
				GetOrderQuoteValueRangeQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrderQuoteValueRangeQuery,
		GetOrderQuoteValueRangeQueryVariables
	>(GetOrderQuoteValueRangeDocument, options);
}
export type GetOrderQuoteValueRangeQueryHookResult = ReturnType<
	typeof useGetOrderQuoteValueRangeQuery
>;
export type GetOrderQuoteValueRangeLazyQueryHookResult = ReturnType<
	typeof useGetOrderQuoteValueRangeLazyQuery
>;
export type GetOrderQuoteValueRangeSuspenseQueryHookResult = ReturnType<
	typeof useGetOrderQuoteValueRangeSuspenseQuery
>;
export type GetOrderQuoteValueRangeQueryResult = Apollo.QueryResult<
	GetOrderQuoteValueRangeQuery,
	GetOrderQuoteValueRangeQueryVariables
>;
export const GetOrderQuoteValueRangesDocument = gql`
	query GetOrderQuoteValueRanges($orderQuoteIds: [ID!]!, $inCurrency: CurrencyEnum) {
		getOrderQuoteValueRanges(orderQuoteIds: $orderQuoteIds, inCurrency: $inCurrency) {
			orderQuoteId
			batchesConsidered
			productsLow {
				...OrderQuoteValueBreakdownFragment
			}
			productsHigh {
				...OrderQuoteValueBreakdownFragment
			}
		}
	}
	${OrderQuoteValueBreakdownFragmentFragmentDoc}
`;

/**
 * __useGetOrderQuoteValueRangesQuery__
 *
 * To run a query within a React component, call `useGetOrderQuoteValueRangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuoteValueRangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuoteValueRangesQuery({
 *   variables: {
 *      orderQuoteIds: // value for 'orderQuoteIds'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetOrderQuoteValueRangesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrderQuoteValueRangesQuery,
		GetOrderQuoteValueRangesQueryVariables
	> &
		({ variables: GetOrderQuoteValueRangesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderQuoteValueRangesQuery, GetOrderQuoteValueRangesQueryVariables>(
		GetOrderQuoteValueRangesDocument,
		options
	);
}
export function useGetOrderQuoteValueRangesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderQuoteValueRangesQuery,
		GetOrderQuoteValueRangesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrderQuoteValueRangesQuery,
		GetOrderQuoteValueRangesQueryVariables
	>(GetOrderQuoteValueRangesDocument, options);
}
export function useGetOrderQuoteValueRangesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderQuoteValueRangesQuery,
				GetOrderQuoteValueRangesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrderQuoteValueRangesQuery,
		GetOrderQuoteValueRangesQueryVariables
	>(GetOrderQuoteValueRangesDocument, options);
}
export type GetOrderQuoteValueRangesQueryHookResult = ReturnType<
	typeof useGetOrderQuoteValueRangesQuery
>;
export type GetOrderQuoteValueRangesLazyQueryHookResult = ReturnType<
	typeof useGetOrderQuoteValueRangesLazyQuery
>;
export type GetOrderQuoteValueRangesSuspenseQueryHookResult = ReturnType<
	typeof useGetOrderQuoteValueRangesSuspenseQuery
>;
export type GetOrderQuoteValueRangesQueryResult = Apollo.QueryResult<
	GetOrderQuoteValueRangesQuery,
	GetOrderQuoteValueRangesQueryVariables
>;
export const PreviewOrderQuoteProductSyncDocument = gql`
	query PreviewOrderQuoteProductSync($orderQuoteId: ID!) {
		previewOrderQuoteProductSync(orderQuoteId: $orderQuoteId) {
			severity
			changedCount
			unavailableCount
			lines {
				orderQuoteItemId
				productId
				productName
				kind
				severity
				message
				snapshotAt
				changes {
					field
					label
					from
					to
				}
				clientVisibleBatches {
					orderQuoteOfferBatchId
					batchName
					batchStatus
				}
			}
		}
	}
`;

/**
 * __usePreviewOrderQuoteProductSyncQuery__
 *
 * To run a query within a React component, call `usePreviewOrderQuoteProductSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewOrderQuoteProductSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewOrderQuoteProductSyncQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *   },
 * });
 */
export function usePreviewOrderQuoteProductSyncQuery(
	baseOptions: Apollo.QueryHookOptions<
		PreviewOrderQuoteProductSyncQuery,
		PreviewOrderQuoteProductSyncQueryVariables
	> &
		(
			| { variables: PreviewOrderQuoteProductSyncQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		PreviewOrderQuoteProductSyncQuery,
		PreviewOrderQuoteProductSyncQueryVariables
	>(PreviewOrderQuoteProductSyncDocument, options);
}
export function usePreviewOrderQuoteProductSyncLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PreviewOrderQuoteProductSyncQuery,
		PreviewOrderQuoteProductSyncQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		PreviewOrderQuoteProductSyncQuery,
		PreviewOrderQuoteProductSyncQueryVariables
	>(PreviewOrderQuoteProductSyncDocument, options);
}
export function usePreviewOrderQuoteProductSyncSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				PreviewOrderQuoteProductSyncQuery,
				PreviewOrderQuoteProductSyncQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		PreviewOrderQuoteProductSyncQuery,
		PreviewOrderQuoteProductSyncQueryVariables
	>(PreviewOrderQuoteProductSyncDocument, options);
}
export type PreviewOrderQuoteProductSyncQueryHookResult = ReturnType<
	typeof usePreviewOrderQuoteProductSyncQuery
>;
export type PreviewOrderQuoteProductSyncLazyQueryHookResult = ReturnType<
	typeof usePreviewOrderQuoteProductSyncLazyQuery
>;
export type PreviewOrderQuoteProductSyncSuspenseQueryHookResult = ReturnType<
	typeof usePreviewOrderQuoteProductSyncSuspenseQuery
>;
export type PreviewOrderQuoteProductSyncQueryResult = Apollo.QueryResult<
	PreviewOrderQuoteProductSyncQuery,
	PreviewOrderQuoteProductSyncQueryVariables
>;
export const PreviewQuoteRecipientsDocument = gql`
	query PreviewQuoteRecipients($orderQuoteId: ID!) {
		previewQuoteRecipients(orderQuoteId: $orderQuoteId) {
			emails
			nominated
		}
	}
`;

/**
 * __usePreviewQuoteRecipientsQuery__
 *
 * To run a query within a React component, call `usePreviewQuoteRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewQuoteRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewQuoteRecipientsQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *   },
 * });
 */
export function usePreviewQuoteRecipientsQuery(
	baseOptions: Apollo.QueryHookOptions<
		PreviewQuoteRecipientsQuery,
		PreviewQuoteRecipientsQueryVariables
	> &
		({ variables: PreviewQuoteRecipientsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PreviewQuoteRecipientsQuery, PreviewQuoteRecipientsQueryVariables>(
		PreviewQuoteRecipientsDocument,
		options
	);
}
export function usePreviewQuoteRecipientsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PreviewQuoteRecipientsQuery,
		PreviewQuoteRecipientsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PreviewQuoteRecipientsQuery, PreviewQuoteRecipientsQueryVariables>(
		PreviewQuoteRecipientsDocument,
		options
	);
}
export function usePreviewQuoteRecipientsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				PreviewQuoteRecipientsQuery,
				PreviewQuoteRecipientsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		PreviewQuoteRecipientsQuery,
		PreviewQuoteRecipientsQueryVariables
	>(PreviewQuoteRecipientsDocument, options);
}
export type PreviewQuoteRecipientsQueryHookResult = ReturnType<
	typeof usePreviewQuoteRecipientsQuery
>;
export type PreviewQuoteRecipientsLazyQueryHookResult = ReturnType<
	typeof usePreviewQuoteRecipientsLazyQuery
>;
export type PreviewQuoteRecipientsSuspenseQueryHookResult = ReturnType<
	typeof usePreviewQuoteRecipientsSuspenseQuery
>;
export type PreviewQuoteRecipientsQueryResult = Apollo.QueryResult<
	PreviewQuoteRecipientsQuery,
	PreviewQuoteRecipientsQueryVariables
>;
export const GetOrderQuoteGuestAccessTokensDocument = gql`
	query GetOrderQuoteGuestAccessTokens($orderQuoteId: ID!) {
		getOrderQuoteGuestAccessTokens(orderQuoteId: $orderQuoteId) {
			id
			email
			link
			status
			acceptedAt
			revokedAt
			createdAt
		}
	}
`;

/**
 * __useGetOrderQuoteGuestAccessTokensQuery__
 *
 * To run a query within a React component, call `useGetOrderQuoteGuestAccessTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuoteGuestAccessTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuoteGuestAccessTokensQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *   },
 * });
 */
export function useGetOrderQuoteGuestAccessTokensQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrderQuoteGuestAccessTokensQuery,
		GetOrderQuoteGuestAccessTokensQueryVariables
	> &
		(
			| { variables: GetOrderQuoteGuestAccessTokensQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrderQuoteGuestAccessTokensQuery,
		GetOrderQuoteGuestAccessTokensQueryVariables
	>(GetOrderQuoteGuestAccessTokensDocument, options);
}
export function useGetOrderQuoteGuestAccessTokensLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderQuoteGuestAccessTokensQuery,
		GetOrderQuoteGuestAccessTokensQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrderQuoteGuestAccessTokensQuery,
		GetOrderQuoteGuestAccessTokensQueryVariables
	>(GetOrderQuoteGuestAccessTokensDocument, options);
}
export function useGetOrderQuoteGuestAccessTokensSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderQuoteGuestAccessTokensQuery,
				GetOrderQuoteGuestAccessTokensQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrderQuoteGuestAccessTokensQuery,
		GetOrderQuoteGuestAccessTokensQueryVariables
	>(GetOrderQuoteGuestAccessTokensDocument, options);
}
export type GetOrderQuoteGuestAccessTokensQueryHookResult = ReturnType<
	typeof useGetOrderQuoteGuestAccessTokensQuery
>;
export type GetOrderQuoteGuestAccessTokensLazyQueryHookResult = ReturnType<
	typeof useGetOrderQuoteGuestAccessTokensLazyQuery
>;
export type GetOrderQuoteGuestAccessTokensSuspenseQueryHookResult = ReturnType<
	typeof useGetOrderQuoteGuestAccessTokensSuspenseQuery
>;
export type GetOrderQuoteGuestAccessTokensQueryResult = Apollo.QueryResult<
	GetOrderQuoteGuestAccessTokensQuery,
	GetOrderQuoteGuestAccessTokensQueryVariables
>;
export const GetOrderQuoteOfferBatchesDocument = gql`
	query GetOrderQuoteOfferBatches(
		$orderQuoteId: ID!
		$statuses: [OrderQuoteOfferStatus!]
		$inCurrency: CurrencyEnum!
	) {
		getOrderQuoteOfferBatches(orderQuoteId: $orderQuoteId, statuses: $statuses) {
			id
			name
			status
			acceptDeadline
			timelineStatus {
				level
				businessDaysLeft
				isExpired
			}
			submittedAt
			sentToClientAt
			respondedAt
			rejectionReason
			orderQuoteId
			availableActions {
				action
				displayType
				label
				blocked
				blockedReason
			}
			summary(inCurrency: $inCurrency) {
				productsSubtotal
				unpricedTierCount
				samplesTotal
				samplesShippingTotal
				samplesPrepaidTotal
				deliveryTotal
				feesTotal
				fees {
					name
					amount
				}
				discountsTotal
				discounts {
					name
					amount
				}
				grandTotal
				vatRate
				vatAmount
				grossAmount
			}
			margin(inCurrency: $inCurrency) {
				amount
				base
				percentage
				markupPercentage
				currency
			}
			offers {
				id
				name
				description
				status
				rejectionReason
				respondedAt
				orderQuoteItemId
				sortOrder
				vetterId
				vetterEntityId
				acceptedPricingId
				acceptedQuantity
				acceptedDeliveryId
				vetterEntity {
					id
					name
				}
				sample {
					id
					status
					baseSamplePrice(inCurrency: $inCurrency)
					baseShippingPrice(inCurrency: $inCurrency)
					totalPrice(inCurrency: $inCurrency)
					pricesByChoice(inCurrency: $inCurrency) {
						sampleChoice
						totalPrice
					}
					minProductionDays
					maxProductionDays
					deliveryDaysMin
					deliveryDaysMax
					notes
					paymentTreatment
					catalogPriceDrift(inCurrency: $inCurrency) {
						label
						direction
						explanation
						action {
							label
							available
							unavailableReason
							warning
						}
					}
				}
				attachments {
					id
					name
					description
					mimeType
					size
					url
				}
				adjustments {
					id
					name
					description
					type
					calculationType
					value(inCurrency: $inCurrency)
					sortOrder
				}
				pricing {
					id
					orderQuoteItemQuantityId
					orderQuoteOfferId
					appliedFrom {
						label
						stillMatches
						appliedAt
						vetterEntity {
							id
							name
						}
					}
					baseUnitPrice(inCurrency: $inCurrency)
					baseTotalPrice(inCurrency: $inCurrency)
					unitPrice(inCurrency: $inCurrency)
					totalPrice(inCurrency: $inCurrency)
					adjustedTotalPrice(inCurrency: $inCurrency)
					markupPercentage
					authoredCurrency
					marginAmount
					marginAmountCurrency
					marginTotal(inCurrency: $inCurrency)
					minProductionDays
					maxProductionDays
					catalogPriceDrift(inCurrency: $inCurrency) {
						label
						direction
						explanation
						caveat
						actions {
							mode
							label
							available
							unavailableReason
							warning
						}
					}
					deliveries {
						id
						shippingMethod
						totalPrice(inCurrency: $inCurrency)
						supplierCost {
							...VetterDeliveryCostFields
							converted(currency: $inCurrency) {
								currency
								price
							}
						}
						appliedFrom {
							label
							stillMatches
							appliedAt
							vetterEntity {
								id
								name
							}
						}
						quantity
						deliveryDaysMin
						deliveryDaysMax
						isSplit
						isValid
						parts {
							id
							sequence
							shippingMethod
							quantity
							totalPrice(inCurrency: $inCurrency)
							supplierCost {
								...VetterDeliveryCostFields
								converted(currency: $inCurrency) {
									currency
									price
								}
							}
							appliedFrom {
								label
								stillMatches
								appliedAt
								vetterEntity {
									id
									name
								}
							}
							deliveryDaysMin
							deliveryDaysMax
							projectedDelivery {
								ifAcceptedNow {
									earliest
									latest
									verdict
								}
								ifAcceptedAtDeadline {
									earliest
									latest
									verdict
								}
							}
						}
						projectedDelivery {
							ifAcceptedNow {
								earliest
								latest
								verdict
							}
							ifAcceptedAtDeadline {
								earliest
								latest
								verdict
							}
						}
					}
				}
			}
			createdAt
			updatedAt
		}
	}
	${VetterDeliveryCostFieldsFragmentDoc}
`;

/**
 * __useGetOrderQuoteOfferBatchesQuery__
 *
 * To run a query within a React component, call `useGetOrderQuoteOfferBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuoteOfferBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuoteOfferBatchesQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *      statuses: // value for 'statuses'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetOrderQuoteOfferBatchesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrderQuoteOfferBatchesQuery,
		GetOrderQuoteOfferBatchesQueryVariables
	> &
		({ variables: GetOrderQuoteOfferBatchesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderQuoteOfferBatchesQuery, GetOrderQuoteOfferBatchesQueryVariables>(
		GetOrderQuoteOfferBatchesDocument,
		options
	);
}
export function useGetOrderQuoteOfferBatchesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderQuoteOfferBatchesQuery,
		GetOrderQuoteOfferBatchesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrderQuoteOfferBatchesQuery,
		GetOrderQuoteOfferBatchesQueryVariables
	>(GetOrderQuoteOfferBatchesDocument, options);
}
export function useGetOrderQuoteOfferBatchesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderQuoteOfferBatchesQuery,
				GetOrderQuoteOfferBatchesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrderQuoteOfferBatchesQuery,
		GetOrderQuoteOfferBatchesQueryVariables
	>(GetOrderQuoteOfferBatchesDocument, options);
}
export type GetOrderQuoteOfferBatchesQueryHookResult = ReturnType<
	typeof useGetOrderQuoteOfferBatchesQuery
>;
export type GetOrderQuoteOfferBatchesLazyQueryHookResult = ReturnType<
	typeof useGetOrderQuoteOfferBatchesLazyQuery
>;
export type GetOrderQuoteOfferBatchesSuspenseQueryHookResult = ReturnType<
	typeof useGetOrderQuoteOfferBatchesSuspenseQuery
>;
export type GetOrderQuoteOfferBatchesQueryResult = Apollo.QueryResult<
	GetOrderQuoteOfferBatchesQuery,
	GetOrderQuoteOfferBatchesQueryVariables
>;
export const GetOrderQuoteOfferBatchDocument = gql`
	query GetOrderQuoteOfferBatch(
		$id: ID!
		$inCurrency: CurrencyEnum
		$selectedPricingIds: [ID!]
		$selectedDeliveryIds: [ID!]
		$selectedSampleChoices: [OfferSampleChoiceInput!]
		$includedOfferIds: [ID!]
	) {
		getOrderQuoteOfferBatch(id: $id) {
			id
			name
			status
			acceptDeadline
			timelineStatus {
				level
				businessDaysLeft
				isExpired
			}
			submittedAt
			sentToClientAt
			respondedAt
			rejectionReason
			orderQuoteId
			availableActions {
				action
				displayType
				label
				blocked
				blockedReason
			}
			summary(
				inCurrency: $inCurrency
				selectedPricingIds: $selectedPricingIds
				selectedDeliveryIds: $selectedDeliveryIds
				selectedSampleChoices: $selectedSampleChoices
				includedOfferIds: $includedOfferIds
			) {
				productsSubtotal
				unpricedTierCount
				samplesTotal
				samplesShippingTotal
				samplesPrepaidTotal
				deliveryTotal
				feesTotal
				fees {
					name
					amount
				}
				discountsTotal
				discounts {
					name
					amount
				}
				grandTotal
				vatRate
				vatAmount
				grossAmount
			}
			margin(
				inCurrency: $inCurrency
				selectedPricingIds: $selectedPricingIds
				includedOfferIds: $includedOfferIds
			) {
				amount
				base
				percentage
				markupPercentage
				currency
			}
			offers {
				id
				name
				description
				status
				rejectionReason
				respondedAt
				orderQuoteItemId
				sortOrder
				vetterId
				vetterEntityId
				acceptedPricingId
				acceptedQuantity
				acceptedDeliveryId
				vetterEntity {
					id
					name
				}
				sample {
					id
					status
					baseSamplePrice(inCurrency: $inCurrency)
					baseShippingPrice(inCurrency: $inCurrency)
					totalPrice(inCurrency: $inCurrency)
					pricesByChoice(inCurrency: $inCurrency) {
						sampleChoice
						totalPrice
					}
					minProductionDays
					maxProductionDays
					deliveryDaysMin
					deliveryDaysMax
					notes
					paymentTreatment
					catalogPriceDrift(inCurrency: $inCurrency) {
						label
						direction
						explanation
						action {
							label
							available
							unavailableReason
							warning
						}
					}
				}
				attachments {
					id
					name
					description
					mimeType
					size
					url
				}
				adjustments {
					id
					name
					description
					type
					calculationType
					value(inCurrency: $inCurrency)
					sortOrder
				}
				pricing {
					id
					orderQuoteItemQuantityId
					orderQuoteOfferId
					appliedFrom {
						label
						stillMatches
						appliedAt
						vetterEntity {
							id
							name
						}
					}
					baseUnitPrice(inCurrency: $inCurrency)
					baseTotalPrice(inCurrency: $inCurrency)
					unitPrice(inCurrency: $inCurrency)
					totalPrice(inCurrency: $inCurrency)
					adjustedTotalPrice(inCurrency: $inCurrency)
					markupPercentage
					authoredCurrency
					marginAmount
					marginAmountCurrency
					marginTotal(inCurrency: $inCurrency)
					minProductionDays
					maxProductionDays
					catalogPriceDrift(inCurrency: $inCurrency) {
						label
						direction
						explanation
						caveat
						actions {
							mode
							label
							available
							unavailableReason
							warning
						}
					}
					deliveries {
						id
						shippingMethod
						totalPrice(inCurrency: $inCurrency)
						quantity
						deliveryDaysMin
						deliveryDaysMax
						isSplit
						isValid
						parts {
							id
							sequence
							shippingMethod
							quantity
							totalPrice(inCurrency: $inCurrency)
							deliveryDaysMin
							deliveryDaysMax
							projectedDelivery {
								ifAcceptedNow {
									earliest
									latest
									verdict
								}
								ifAcceptedAtDeadline {
									earliest
									latest
									verdict
								}
							}
						}
						projectedDelivery {
							ifAcceptedNow {
								earliest
								latest
								verdict
							}
							ifAcceptedAtDeadline {
								earliest
								latest
								verdict
							}
						}
					}
				}
			}
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetOrderQuoteOfferBatchQuery__
 *
 * To run a query within a React component, call `useGetOrderQuoteOfferBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuoteOfferBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuoteOfferBatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *      inCurrency: // value for 'inCurrency'
 *      selectedPricingIds: // value for 'selectedPricingIds'
 *      selectedDeliveryIds: // value for 'selectedDeliveryIds'
 *      selectedSampleChoices: // value for 'selectedSampleChoices'
 *      includedOfferIds: // value for 'includedOfferIds'
 *   },
 * });
 */
export function useGetOrderQuoteOfferBatchQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrderQuoteOfferBatchQuery,
		GetOrderQuoteOfferBatchQueryVariables
	> &
		({ variables: GetOrderQuoteOfferBatchQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderQuoteOfferBatchQuery, GetOrderQuoteOfferBatchQueryVariables>(
		GetOrderQuoteOfferBatchDocument,
		options
	);
}
export function useGetOrderQuoteOfferBatchLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderQuoteOfferBatchQuery,
		GetOrderQuoteOfferBatchQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrderQuoteOfferBatchQuery, GetOrderQuoteOfferBatchQueryVariables>(
		GetOrderQuoteOfferBatchDocument,
		options
	);
}
export function useGetOrderQuoteOfferBatchSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderQuoteOfferBatchQuery,
				GetOrderQuoteOfferBatchQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrderQuoteOfferBatchQuery,
		GetOrderQuoteOfferBatchQueryVariables
	>(GetOrderQuoteOfferBatchDocument, options);
}
export type GetOrderQuoteOfferBatchQueryHookResult = ReturnType<
	typeof useGetOrderQuoteOfferBatchQuery
>;
export type GetOrderQuoteOfferBatchLazyQueryHookResult = ReturnType<
	typeof useGetOrderQuoteOfferBatchLazyQuery
>;
export type GetOrderQuoteOfferBatchSuspenseQueryHookResult = ReturnType<
	typeof useGetOrderQuoteOfferBatchSuspenseQuery
>;
export type GetOrderQuoteOfferBatchQueryResult = Apollo.QueryResult<
	GetOrderQuoteOfferBatchQuery,
	GetOrderQuoteOfferBatchQueryVariables
>;
export const PreviewOrderQuoteOfferFeasibilityDocument = gql`
	query PreviewOrderQuoteOfferFeasibility($input: PreviewOrderQuoteOfferFeasibilityInput!) {
		previewOrderQuoteOfferFeasibility(input: $input) {
			production {
				verdict
				projectedCompletion {
					ifAcceptedNow {
						earliest
						latest
						verdict
					}
					ifAcceptedAtDeadline {
						earliest
						latest
						verdict
					}
				}
				breakdown {
					anchorDate
					minProductionDays
					maxProductionDays
					deliveryDaysMin
					deliveryDaysMax
					leadTimeDaysMin
					leadTimeDaysMax
					projectedArrivalEarliest
					projectedArrivalLatest
					overshootBusinessDays
					overshootBestCaseBusinessDays
					deadlineCapacityBusinessDays
				}
			}
			deliveries {
				shippingMethod
				verdict
				projectedDelivery {
					ifAcceptedNow {
						earliest
						latest
						verdict
					}
					ifAcceptedAtDeadline {
						earliest
						latest
						verdict
					}
				}
				breakdown {
					anchorDate
					minProductionDays
					maxProductionDays
					deliveryDaysMin
					deliveryDaysMax
					leadTimeDaysMin
					leadTimeDaysMax
					projectedArrivalEarliest
					projectedArrivalLatest
					overshootBusinessDays
					overshootBestCaseBusinessDays
					deadlineCapacityBusinessDays
				}
			}
		}
	}
`;

/**
 * __usePreviewOrderQuoteOfferFeasibilityQuery__
 *
 * To run a query within a React component, call `usePreviewOrderQuoteOfferFeasibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewOrderQuoteOfferFeasibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewOrderQuoteOfferFeasibilityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewOrderQuoteOfferFeasibilityQuery(
	baseOptions: Apollo.QueryHookOptions<
		PreviewOrderQuoteOfferFeasibilityQuery,
		PreviewOrderQuoteOfferFeasibilityQueryVariables
	> &
		(
			| { variables: PreviewOrderQuoteOfferFeasibilityQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		PreviewOrderQuoteOfferFeasibilityQuery,
		PreviewOrderQuoteOfferFeasibilityQueryVariables
	>(PreviewOrderQuoteOfferFeasibilityDocument, options);
}
export function usePreviewOrderQuoteOfferFeasibilityLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PreviewOrderQuoteOfferFeasibilityQuery,
		PreviewOrderQuoteOfferFeasibilityQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		PreviewOrderQuoteOfferFeasibilityQuery,
		PreviewOrderQuoteOfferFeasibilityQueryVariables
	>(PreviewOrderQuoteOfferFeasibilityDocument, options);
}
export function usePreviewOrderQuoteOfferFeasibilitySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				PreviewOrderQuoteOfferFeasibilityQuery,
				PreviewOrderQuoteOfferFeasibilityQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		PreviewOrderQuoteOfferFeasibilityQuery,
		PreviewOrderQuoteOfferFeasibilityQueryVariables
	>(PreviewOrderQuoteOfferFeasibilityDocument, options);
}
export type PreviewOrderQuoteOfferFeasibilityQueryHookResult = ReturnType<
	typeof usePreviewOrderQuoteOfferFeasibilityQuery
>;
export type PreviewOrderQuoteOfferFeasibilityLazyQueryHookResult = ReturnType<
	typeof usePreviewOrderQuoteOfferFeasibilityLazyQuery
>;
export type PreviewOrderQuoteOfferFeasibilitySuspenseQueryHookResult = ReturnType<
	typeof usePreviewOrderQuoteOfferFeasibilitySuspenseQuery
>;
export type PreviewOrderQuoteOfferFeasibilityQueryResult = Apollo.QueryResult<
	PreviewOrderQuoteOfferFeasibilityQuery,
	PreviewOrderQuoteOfferFeasibilityQueryVariables
>;
export const ValidateOrderQuoteOfferBatchForClientDocument = gql`
	query ValidateOrderQuoteOfferBatchForClient($id: ID!) {
		validateOrderQuoteOfferBatchForClient(id: $id) {
			canSend
			valid
			errors {
				key
				message
			}
			warnings {
				key
				message
				offerId
				offerName
				orderQuoteItemQuantityId
				quantity
				deliveryId
				shippingMethod
				deadline
			}
		}
	}
`;

/**
 * __useValidateOrderQuoteOfferBatchForClientQuery__
 *
 * To run a query within a React component, call `useValidateOrderQuoteOfferBatchForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateOrderQuoteOfferBatchForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateOrderQuoteOfferBatchForClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useValidateOrderQuoteOfferBatchForClientQuery(
	baseOptions: Apollo.QueryHookOptions<
		ValidateOrderQuoteOfferBatchForClientQuery,
		ValidateOrderQuoteOfferBatchForClientQueryVariables
	> &
		(
			| { variables: ValidateOrderQuoteOfferBatchForClientQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ValidateOrderQuoteOfferBatchForClientQuery,
		ValidateOrderQuoteOfferBatchForClientQueryVariables
	>(ValidateOrderQuoteOfferBatchForClientDocument, options);
}
export function useValidateOrderQuoteOfferBatchForClientLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ValidateOrderQuoteOfferBatchForClientQuery,
		ValidateOrderQuoteOfferBatchForClientQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ValidateOrderQuoteOfferBatchForClientQuery,
		ValidateOrderQuoteOfferBatchForClientQueryVariables
	>(ValidateOrderQuoteOfferBatchForClientDocument, options);
}
export function useValidateOrderQuoteOfferBatchForClientSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				ValidateOrderQuoteOfferBatchForClientQuery,
				ValidateOrderQuoteOfferBatchForClientQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ValidateOrderQuoteOfferBatchForClientQuery,
		ValidateOrderQuoteOfferBatchForClientQueryVariables
	>(ValidateOrderQuoteOfferBatchForClientDocument, options);
}
export type ValidateOrderQuoteOfferBatchForClientQueryHookResult = ReturnType<
	typeof useValidateOrderQuoteOfferBatchForClientQuery
>;
export type ValidateOrderQuoteOfferBatchForClientLazyQueryHookResult = ReturnType<
	typeof useValidateOrderQuoteOfferBatchForClientLazyQuery
>;
export type ValidateOrderQuoteOfferBatchForClientSuspenseQueryHookResult = ReturnType<
	typeof useValidateOrderQuoteOfferBatchForClientSuspenseQuery
>;
export type ValidateOrderQuoteOfferBatchForClientQueryResult = Apollo.QueryResult<
	ValidateOrderQuoteOfferBatchForClientQuery,
	ValidateOrderQuoteOfferBatchForClientQueryVariables
>;
export const GetOrderQuoteVetterJobsDocument = gql`
	query GetOrderQuoteVetterJobs($orderQuoteId: ID!, $currency: CurrencyEnum!) {
		getOrderQuoteVetterJobs(orderQuoteId: $orderQuoteId) {
			id
			status
			stage
			stageLabel
			orderQuoteItemIds
			submittedAt
			withdrawnAt
			createdAt
			note
			currency
			vetterEntityId
			vetterEntity {
				id
				name
			}
			productUsage {
				orderQuoteItemId
				status
				label
				actionLabel
				appliedAt
			}
			prices {
				id
				orderQuoteItemId
				orderQuoteItemQuantityId
				quantity
				baseUnitPrice
				currency
				usage {
					status
					label
					appliedAt
					orderQuoteOfferId
				}
				minProductionDays
				maxProductionDays
				shippingPrices {
					shippingMethod
					price
					deliveryDaysMin
					deliveryDaysMax
				}
				converted(currency: $currency) {
					currency
					baseUnitPrice
					shippingPrices {
						shippingMethod
						price
					}
				}
			}
			links {
				id
				email
				link
				status
				createdAt
				revokedAt
			}
		}
	}
`;

/**
 * __useGetOrderQuoteVetterJobsQuery__
 *
 * To run a query within a React component, call `useGetOrderQuoteVetterJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuoteVetterJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuoteVetterJobsQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetOrderQuoteVetterJobsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrderQuoteVetterJobsQuery,
		GetOrderQuoteVetterJobsQueryVariables
	> &
		({ variables: GetOrderQuoteVetterJobsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderQuoteVetterJobsQuery, GetOrderQuoteVetterJobsQueryVariables>(
		GetOrderQuoteVetterJobsDocument,
		options
	);
}
export function useGetOrderQuoteVetterJobsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderQuoteVetterJobsQuery,
		GetOrderQuoteVetterJobsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrderQuoteVetterJobsQuery, GetOrderQuoteVetterJobsQueryVariables>(
		GetOrderQuoteVetterJobsDocument,
		options
	);
}
export function useGetOrderQuoteVetterJobsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderQuoteVetterJobsQuery,
				GetOrderQuoteVetterJobsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrderQuoteVetterJobsQuery,
		GetOrderQuoteVetterJobsQueryVariables
	>(GetOrderQuoteVetterJobsDocument, options);
}
export type GetOrderQuoteVetterJobsQueryHookResult = ReturnType<
	typeof useGetOrderQuoteVetterJobsQuery
>;
export type GetOrderQuoteVetterJobsLazyQueryHookResult = ReturnType<
	typeof useGetOrderQuoteVetterJobsLazyQuery
>;
export type GetOrderQuoteVetterJobsSuspenseQueryHookResult = ReturnType<
	typeof useGetOrderQuoteVetterJobsSuspenseQuery
>;
export type GetOrderQuoteVetterJobsQueryResult = Apollo.QueryResult<
	GetOrderQuoteVetterJobsQuery,
	GetOrderQuoteVetterJobsQueryVariables
>;
export const PreviewVetterPriceRequestDocument = gql`
	query PreviewVetterPriceRequest($orderQuoteId: ID!, $vetterEntityId: ID!) {
		previewVetterPriceRequest(orderQuoteId: $orderQuoteId, vetterEntityId: $vetterEntityId) {
			notice
			hasAccountHolders
			existingJob {
				id
				orderQuoteItemIds
			}
			recipients {
				vetterUserId
				name
				email
				hasAccount
				deliveryLabel
			}
		}
	}
`;

/**
 * __usePreviewVetterPriceRequestQuery__
 *
 * To run a query within a React component, call `usePreviewVetterPriceRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewVetterPriceRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewVetterPriceRequestQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *      vetterEntityId: // value for 'vetterEntityId'
 *   },
 * });
 */
export function usePreviewVetterPriceRequestQuery(
	baseOptions: Apollo.QueryHookOptions<
		PreviewVetterPriceRequestQuery,
		PreviewVetterPriceRequestQueryVariables
	> &
		({ variables: PreviewVetterPriceRequestQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PreviewVetterPriceRequestQuery, PreviewVetterPriceRequestQueryVariables>(
		PreviewVetterPriceRequestDocument,
		options
	);
}
export function usePreviewVetterPriceRequestLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PreviewVetterPriceRequestQuery,
		PreviewVetterPriceRequestQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		PreviewVetterPriceRequestQuery,
		PreviewVetterPriceRequestQueryVariables
	>(PreviewVetterPriceRequestDocument, options);
}
export function usePreviewVetterPriceRequestSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				PreviewVetterPriceRequestQuery,
				PreviewVetterPriceRequestQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		PreviewVetterPriceRequestQuery,
		PreviewVetterPriceRequestQueryVariables
	>(PreviewVetterPriceRequestDocument, options);
}
export type PreviewVetterPriceRequestQueryHookResult = ReturnType<
	typeof usePreviewVetterPriceRequestQuery
>;
export type PreviewVetterPriceRequestLazyQueryHookResult = ReturnType<
	typeof usePreviewVetterPriceRequestLazyQuery
>;
export type PreviewVetterPriceRequestSuspenseQueryHookResult = ReturnType<
	typeof usePreviewVetterPriceRequestSuspenseQuery
>;
export type PreviewVetterPriceRequestQueryResult = Apollo.QueryResult<
	PreviewVetterPriceRequestQuery,
	PreviewVetterPriceRequestQueryVariables
>;
export const GetOfferBatchesForVetterPricesDocument = gql`
	query GetOfferBatchesForVetterPrices($orderQuoteId: ID!) {
		getOrderQuoteOfferBatches(orderQuoteId: $orderQuoteId) {
			id
			name
			status
			sentToClientAt
			offers {
				id
				orderQuoteItemId
				vetterEntityId
				pricing {
					orderQuoteItemQuantityId
					deliveries {
						id
						parts {
							id
						}
					}
				}
			}
		}
	}
`;

/**
 * __useGetOfferBatchesForVetterPricesQuery__
 *
 * To run a query within a React component, call `useGetOfferBatchesForVetterPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferBatchesForVetterPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferBatchesForVetterPricesQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *   },
 * });
 */
export function useGetOfferBatchesForVetterPricesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOfferBatchesForVetterPricesQuery,
		GetOfferBatchesForVetterPricesQueryVariables
	> &
		(
			| { variables: GetOfferBatchesForVetterPricesQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOfferBatchesForVetterPricesQuery,
		GetOfferBatchesForVetterPricesQueryVariables
	>(GetOfferBatchesForVetterPricesDocument, options);
}
export function useGetOfferBatchesForVetterPricesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOfferBatchesForVetterPricesQuery,
		GetOfferBatchesForVetterPricesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOfferBatchesForVetterPricesQuery,
		GetOfferBatchesForVetterPricesQueryVariables
	>(GetOfferBatchesForVetterPricesDocument, options);
}
export function useGetOfferBatchesForVetterPricesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOfferBatchesForVetterPricesQuery,
				GetOfferBatchesForVetterPricesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOfferBatchesForVetterPricesQuery,
		GetOfferBatchesForVetterPricesQueryVariables
	>(GetOfferBatchesForVetterPricesDocument, options);
}
export type GetOfferBatchesForVetterPricesQueryHookResult = ReturnType<
	typeof useGetOfferBatchesForVetterPricesQuery
>;
export type GetOfferBatchesForVetterPricesLazyQueryHookResult = ReturnType<
	typeof useGetOfferBatchesForVetterPricesLazyQuery
>;
export type GetOfferBatchesForVetterPricesSuspenseQueryHookResult = ReturnType<
	typeof useGetOfferBatchesForVetterPricesSuspenseQuery
>;
export type GetOfferBatchesForVetterPricesQueryResult = Apollo.QueryResult<
	GetOfferBatchesForVetterPricesQuery,
	GetOfferBatchesForVetterPricesQueryVariables
>;
export const PreviewApplyVetterPricesDocument = gql`
	query PreviewApplyVetterPrices($input: ApplyVetterPricesInput!, $inCurrency: CurrencyEnum) {
		previewApplyVetterPrices(input: $input) {
			canApply
			blockedReason
			products {
				orderQuoteItemId
				productName
				supplierChanges
				supplierFrom {
					id
					name
				}
				supplierTo {
					id
					name
				}
				quantities {
					orderQuoteItemQuantityId
					quantity
					changed
					marginRule
					unpricedForClient
					createsPrice
					shipping {
						id
						label
						shippingMethod
						quantity
						source
						createsOption
						changed
						before {
							...ApplyVetterPricesShippingFields
						}
						after {
							...ApplyVetterPricesShippingFields
						}
					}
					before {
						...ApplyVetterPricesTierFields
					}
					after {
						...ApplyVetterPricesTierFields
					}
				}
			}
		}
	}
	${ApplyVetterPricesShippingFieldsFragmentDoc}
	${ApplyVetterPricesTierFieldsFragmentDoc}
`;

/**
 * __usePreviewApplyVetterPricesQuery__
 *
 * To run a query within a React component, call `usePreviewApplyVetterPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewApplyVetterPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewApplyVetterPricesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function usePreviewApplyVetterPricesQuery(
	baseOptions: Apollo.QueryHookOptions<
		PreviewApplyVetterPricesQuery,
		PreviewApplyVetterPricesQueryVariables
	> &
		({ variables: PreviewApplyVetterPricesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PreviewApplyVetterPricesQuery, PreviewApplyVetterPricesQueryVariables>(
		PreviewApplyVetterPricesDocument,
		options
	);
}
export function usePreviewApplyVetterPricesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PreviewApplyVetterPricesQuery,
		PreviewApplyVetterPricesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		PreviewApplyVetterPricesQuery,
		PreviewApplyVetterPricesQueryVariables
	>(PreviewApplyVetterPricesDocument, options);
}
export function usePreviewApplyVetterPricesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				PreviewApplyVetterPricesQuery,
				PreviewApplyVetterPricesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		PreviewApplyVetterPricesQuery,
		PreviewApplyVetterPricesQueryVariables
	>(PreviewApplyVetterPricesDocument, options);
}
export type PreviewApplyVetterPricesQueryHookResult = ReturnType<
	typeof usePreviewApplyVetterPricesQuery
>;
export type PreviewApplyVetterPricesLazyQueryHookResult = ReturnType<
	typeof usePreviewApplyVetterPricesLazyQuery
>;
export type PreviewApplyVetterPricesSuspenseQueryHookResult = ReturnType<
	typeof usePreviewApplyVetterPricesSuspenseQuery
>;
export type PreviewApplyVetterPricesQueryResult = Apollo.QueryResult<
	PreviewApplyVetterPricesQuery,
	PreviewApplyVetterPricesQueryVariables
>;
export const GetOrderQuoteViewSummaryDocument = gql`
	query GetOrderQuoteViewSummary($orderQuoteId: ID!) {
		getOrderQuoteViewSummary(orderQuoteId: $orderQuoteId) {
			orderQuoteId
			totalViews
			distinctViewers
			firstViewedAt
			lastViewedAt
			viewers {
				id
				actorId
				actorRole
				viewCount
				firstViewedAt
				lastViewedAt
				lastChannel
				user {
					id
					email
					role
					organizationUser {
						id
						firstName
						lastName
					}
				}
			}
		}
	}
`;

/**
 * __useGetOrderQuoteViewSummaryQuery__
 *
 * To run a query within a React component, call `useGetOrderQuoteViewSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuoteViewSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuoteViewSummaryQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *   },
 * });
 */
export function useGetOrderQuoteViewSummaryQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrderQuoteViewSummaryQuery,
		GetOrderQuoteViewSummaryQueryVariables
	> &
		({ variables: GetOrderQuoteViewSummaryQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderQuoteViewSummaryQuery, GetOrderQuoteViewSummaryQueryVariables>(
		GetOrderQuoteViewSummaryDocument,
		options
	);
}
export function useGetOrderQuoteViewSummaryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderQuoteViewSummaryQuery,
		GetOrderQuoteViewSummaryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrderQuoteViewSummaryQuery,
		GetOrderQuoteViewSummaryQueryVariables
	>(GetOrderQuoteViewSummaryDocument, options);
}
export function useGetOrderQuoteViewSummarySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderQuoteViewSummaryQuery,
				GetOrderQuoteViewSummaryQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrderQuoteViewSummaryQuery,
		GetOrderQuoteViewSummaryQueryVariables
	>(GetOrderQuoteViewSummaryDocument, options);
}
export type GetOrderQuoteViewSummaryQueryHookResult = ReturnType<
	typeof useGetOrderQuoteViewSummaryQuery
>;
export type GetOrderQuoteViewSummaryLazyQueryHookResult = ReturnType<
	typeof useGetOrderQuoteViewSummaryLazyQuery
>;
export type GetOrderQuoteViewSummarySuspenseQueryHookResult = ReturnType<
	typeof useGetOrderQuoteViewSummarySuspenseQuery
>;
export type GetOrderQuoteViewSummaryQueryResult = Apollo.QueryResult<
	GetOrderQuoteViewSummaryQuery,
	GetOrderQuoteViewSummaryQueryVariables
>;
export const GetOrderQuoteOverviewStatsDocument = gql`
	query GetOrderQuoteOverviewStats {
		getOrderQuoteOverviewStats {
			total
			pending
			accepted
			rejected
		}
	}
`;

/**
 * __useGetOrderQuoteOverviewStatsQuery__
 *
 * To run a query within a React component, call `useGetOrderQuoteOverviewStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuoteOverviewStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuoteOverviewStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrderQuoteOverviewStatsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetOrderQuoteOverviewStatsQuery,
		GetOrderQuoteOverviewStatsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrderQuoteOverviewStatsQuery,
		GetOrderQuoteOverviewStatsQueryVariables
	>(GetOrderQuoteOverviewStatsDocument, options);
}
export function useGetOrderQuoteOverviewStatsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderQuoteOverviewStatsQuery,
		GetOrderQuoteOverviewStatsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrderQuoteOverviewStatsQuery,
		GetOrderQuoteOverviewStatsQueryVariables
	>(GetOrderQuoteOverviewStatsDocument, options);
}
export function useGetOrderQuoteOverviewStatsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderQuoteOverviewStatsQuery,
				GetOrderQuoteOverviewStatsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrderQuoteOverviewStatsQuery,
		GetOrderQuoteOverviewStatsQueryVariables
	>(GetOrderQuoteOverviewStatsDocument, options);
}
export type GetOrderQuoteOverviewStatsQueryHookResult = ReturnType<
	typeof useGetOrderQuoteOverviewStatsQuery
>;
export type GetOrderQuoteOverviewStatsLazyQueryHookResult = ReturnType<
	typeof useGetOrderQuoteOverviewStatsLazyQuery
>;
export type GetOrderQuoteOverviewStatsSuspenseQueryHookResult = ReturnType<
	typeof useGetOrderQuoteOverviewStatsSuspenseQuery
>;
export type GetOrderQuoteOverviewStatsQueryResult = Apollo.QueryResult<
	GetOrderQuoteOverviewStatsQuery,
	GetOrderQuoteOverviewStatsQueryVariables
>;
export const GetOrderOverviewStatsDocument = gql`
	query GetOrderOverviewStats {
		getOrderOverviewStats {
			total
			pending
			inProduction
			completed
			readyToShip
			inTransit
			overdue
		}
	}
`;

/**
 * __useGetOrderOverviewStatsQuery__
 *
 * To run a query within a React component, call `useGetOrderOverviewStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderOverviewStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderOverviewStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrderOverviewStatsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetOrderOverviewStatsQuery,
		GetOrderOverviewStatsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderOverviewStatsQuery, GetOrderOverviewStatsQueryVariables>(
		GetOrderOverviewStatsDocument,
		options
	);
}
export function useGetOrderOverviewStatsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderOverviewStatsQuery,
		GetOrderOverviewStatsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrderOverviewStatsQuery, GetOrderOverviewStatsQueryVariables>(
		GetOrderOverviewStatsDocument,
		options
	);
}
export function useGetOrderOverviewStatsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderOverviewStatsQuery,
				GetOrderOverviewStatsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOrderOverviewStatsQuery, GetOrderOverviewStatsQueryVariables>(
		GetOrderOverviewStatsDocument,
		options
	);
}
export type GetOrderOverviewStatsQueryHookResult = ReturnType<typeof useGetOrderOverviewStatsQuery>;
export type GetOrderOverviewStatsLazyQueryHookResult = ReturnType<
	typeof useGetOrderOverviewStatsLazyQuery
>;
export type GetOrderOverviewStatsSuspenseQueryHookResult = ReturnType<
	typeof useGetOrderOverviewStatsSuspenseQuery
>;
export type GetOrderOverviewStatsQueryResult = Apollo.QueryResult<
	GetOrderOverviewStatsQuery,
	GetOrderOverviewStatsQueryVariables
>;
export const GetOrderStatsDocument = gql`
	query GetOrderStats($currency: CurrencyEnum, $dateRange: DateRangeInput) {
		getOrderStats(currency: $currency, dateRange: $dateRange) {
			totalOrderAmount
			totalOrders
			averageOrderAmount
			medianOrderAmount
			averageDeliveryAmount
			medianDeliveryAmount
			averageMargin
			medianMargin
			currency
		}
	}
`;

/**
 * __useGetOrderStatsQuery__
 *
 * To run a query within a React component, call `useGetOrderStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderStatsQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetOrderStatsQuery(
	baseOptions?: Apollo.QueryHookOptions<GetOrderStatsQuery, GetOrderStatsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderStatsQuery, GetOrderStatsQueryVariables>(
		GetOrderStatsDocument,
		options
	);
}
export function useGetOrderStatsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetOrderStatsQuery, GetOrderStatsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrderStatsQuery, GetOrderStatsQueryVariables>(
		GetOrderStatsDocument,
		options
	);
}
export function useGetOrderStatsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetOrderStatsQuery, GetOrderStatsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOrderStatsQuery, GetOrderStatsQueryVariables>(
		GetOrderStatsDocument,
		options
	);
}
export type GetOrderStatsQueryHookResult = ReturnType<typeof useGetOrderStatsQuery>;
export type GetOrderStatsLazyQueryHookResult = ReturnType<typeof useGetOrderStatsLazyQuery>;
export type GetOrderStatsSuspenseQueryHookResult = ReturnType<typeof useGetOrderStatsSuspenseQuery>;
export type GetOrderStatsQueryResult = Apollo.QueryResult<
	GetOrderStatsQuery,
	GetOrderStatsQueryVariables
>;
export const GetOrderQuoteStatsByStatusDocument = gql`
	query GetOrderQuoteStatsByStatus($dateRange: DateRangeInput, $vetterEntityIds: [ID!]) {
		getOrderQuoteStatsByStatus(dateRange: $dateRange, vetterEntityIds: $vetterEntityIds) {
			total
			totalClients
			statusBreakdown {
				status
				count
				percentage
				clientCount
			}
		}
	}
`;

/**
 * __useGetOrderQuoteStatsByStatusQuery__
 *
 * To run a query within a React component, call `useGetOrderQuoteStatsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuoteStatsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuoteStatsByStatusQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      vetterEntityIds: // value for 'vetterEntityIds'
 *   },
 * });
 */
export function useGetOrderQuoteStatsByStatusQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetOrderQuoteStatsByStatusQuery,
		GetOrderQuoteStatsByStatusQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrderQuoteStatsByStatusQuery,
		GetOrderQuoteStatsByStatusQueryVariables
	>(GetOrderQuoteStatsByStatusDocument, options);
}
export function useGetOrderQuoteStatsByStatusLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderQuoteStatsByStatusQuery,
		GetOrderQuoteStatsByStatusQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrderQuoteStatsByStatusQuery,
		GetOrderQuoteStatsByStatusQueryVariables
	>(GetOrderQuoteStatsByStatusDocument, options);
}
export function useGetOrderQuoteStatsByStatusSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderQuoteStatsByStatusQuery,
				GetOrderQuoteStatsByStatusQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrderQuoteStatsByStatusQuery,
		GetOrderQuoteStatsByStatusQueryVariables
	>(GetOrderQuoteStatsByStatusDocument, options);
}
export type GetOrderQuoteStatsByStatusQueryHookResult = ReturnType<
	typeof useGetOrderQuoteStatsByStatusQuery
>;
export type GetOrderQuoteStatsByStatusLazyQueryHookResult = ReturnType<
	typeof useGetOrderQuoteStatsByStatusLazyQuery
>;
export type GetOrderQuoteStatsByStatusSuspenseQueryHookResult = ReturnType<
	typeof useGetOrderQuoteStatsByStatusSuspenseQuery
>;
export type GetOrderQuoteStatsByStatusQueryResult = Apollo.QueryResult<
	GetOrderQuoteStatsByStatusQuery,
	GetOrderQuoteStatsByStatusQueryVariables
>;
export const GetOrderStatsByStatusDocument = gql`
	query GetOrderStatsByStatus(
		$currency: CurrencyEnum
		$dateRange: DateRangeInput
		$vetterEntityIds: [ID!]
	) {
		getOrderStatsByStatus(
			currency: $currency
			dateRange: $dateRange
			vetterEntityIds: $vetterEntityIds
		) {
			total
			totalAmount
			statusBreakdown {
				status
				count
				totalAmount
				percentage
			}
		}
	}
`;

/**
 * __useGetOrderStatsByStatusQuery__
 *
 * To run a query within a React component, call `useGetOrderStatsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderStatsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderStatsByStatusQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *      dateRange: // value for 'dateRange'
 *      vetterEntityIds: // value for 'vetterEntityIds'
 *   },
 * });
 */
export function useGetOrderStatsByStatusQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetOrderStatsByStatusQuery,
		GetOrderStatsByStatusQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderStatsByStatusQuery, GetOrderStatsByStatusQueryVariables>(
		GetOrderStatsByStatusDocument,
		options
	);
}
export function useGetOrderStatsByStatusLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderStatsByStatusQuery,
		GetOrderStatsByStatusQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrderStatsByStatusQuery, GetOrderStatsByStatusQueryVariables>(
		GetOrderStatsByStatusDocument,
		options
	);
}
export function useGetOrderStatsByStatusSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderStatsByStatusQuery,
				GetOrderStatsByStatusQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOrderStatsByStatusQuery, GetOrderStatsByStatusQueryVariables>(
		GetOrderStatsByStatusDocument,
		options
	);
}
export type GetOrderStatsByStatusQueryHookResult = ReturnType<typeof useGetOrderStatsByStatusQuery>;
export type GetOrderStatsByStatusLazyQueryHookResult = ReturnType<
	typeof useGetOrderStatsByStatusLazyQuery
>;
export type GetOrderStatsByStatusSuspenseQueryHookResult = ReturnType<
	typeof useGetOrderStatsByStatusSuspenseQuery
>;
export type GetOrderStatsByStatusQueryResult = Apollo.QueryResult<
	GetOrderStatsByStatusQuery,
	GetOrderStatsByStatusQueryVariables
>;
export const GetRecentOrderQuotesDocument = gql`
	query GetRecentOrderQuotes($limit: Int, $dateRange: DateRangeInput, $vetterEntityIds: [ID!]) {
		getRecentOrderQuotes(
			limit: $limit
			dateRange: $dateRange
			vetterEntityIds: $vetterEntityIds
		) {
			id
			name
			status
			createdAt
			organization {
				id
				name
			}
		}
	}
`;

/**
 * __useGetRecentOrderQuotesQuery__
 *
 * To run a query within a React component, call `useGetRecentOrderQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentOrderQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentOrderQuotesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      dateRange: // value for 'dateRange'
 *      vetterEntityIds: // value for 'vetterEntityIds'
 *   },
 * });
 */
export function useGetRecentOrderQuotesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetRecentOrderQuotesQuery,
		GetRecentOrderQuotesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetRecentOrderQuotesQuery, GetRecentOrderQuotesQueryVariables>(
		GetRecentOrderQuotesDocument,
		options
	);
}
export function useGetRecentOrderQuotesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetRecentOrderQuotesQuery,
		GetRecentOrderQuotesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetRecentOrderQuotesQuery, GetRecentOrderQuotesQueryVariables>(
		GetRecentOrderQuotesDocument,
		options
	);
}
export function useGetRecentOrderQuotesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetRecentOrderQuotesQuery,
				GetRecentOrderQuotesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetRecentOrderQuotesQuery, GetRecentOrderQuotesQueryVariables>(
		GetRecentOrderQuotesDocument,
		options
	);
}
export type GetRecentOrderQuotesQueryHookResult = ReturnType<typeof useGetRecentOrderQuotesQuery>;
export type GetRecentOrderQuotesLazyQueryHookResult = ReturnType<
	typeof useGetRecentOrderQuotesLazyQuery
>;
export type GetRecentOrderQuotesSuspenseQueryHookResult = ReturnType<
	typeof useGetRecentOrderQuotesSuspenseQuery
>;
export type GetRecentOrderQuotesQueryResult = Apollo.QueryResult<
	GetRecentOrderQuotesQuery,
	GetRecentOrderQuotesQueryVariables
>;
export const GetRecentOrdersDocument = gql`
	query GetRecentOrders(
		$limit: Int
		$dateRange: DateRangeInput
		$vetterEntityIds: [ID!]
		$currency: CurrencyEnum
	) {
		getRecentOrders(limit: $limit, dateRange: $dateRange, vetterEntityIds: $vetterEntityIds) {
			id
			name
			status
			createdAt
			totalAmount(inCurrency: $currency)
			organization {
				id
				name
			}
		}
	}
`;

/**
 * __useGetRecentOrdersQuery__
 *
 * To run a query within a React component, call `useGetRecentOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentOrdersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      dateRange: // value for 'dateRange'
 *      vetterEntityIds: // value for 'vetterEntityIds'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetRecentOrdersQuery(
	baseOptions?: Apollo.QueryHookOptions<GetRecentOrdersQuery, GetRecentOrdersQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetRecentOrdersQuery, GetRecentOrdersQueryVariables>(
		GetRecentOrdersDocument,
		options
	);
}
export function useGetRecentOrdersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetRecentOrdersQuery, GetRecentOrdersQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetRecentOrdersQuery, GetRecentOrdersQueryVariables>(
		GetRecentOrdersDocument,
		options
	);
}
export function useGetRecentOrdersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetRecentOrdersQuery, GetRecentOrdersQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetRecentOrdersQuery, GetRecentOrdersQueryVariables>(
		GetRecentOrdersDocument,
		options
	);
}
export type GetRecentOrdersQueryHookResult = ReturnType<typeof useGetRecentOrdersQuery>;
export type GetRecentOrdersLazyQueryHookResult = ReturnType<typeof useGetRecentOrdersLazyQuery>;
export type GetRecentOrdersSuspenseQueryHookResult = ReturnType<
	typeof useGetRecentOrdersSuspenseQuery
>;
export type GetRecentOrdersQueryResult = Apollo.QueryResult<
	GetRecentOrdersQuery,
	GetRecentOrdersQueryVariables
>;
export const GetInvoicePdfUrlDocument = gql`
	query GetInvoicePdfUrl($invoiceNumber: Int!) {
		getInvoicePdfUrl(invoiceNumber: $invoiceNumber)
	}
`;

/**
 * __useGetInvoicePdfUrlQuery__
 *
 * To run a query within a React component, call `useGetInvoicePdfUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePdfUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePdfUrlQuery({
 *   variables: {
 *      invoiceNumber: // value for 'invoiceNumber'
 *   },
 * });
 */
export function useGetInvoicePdfUrlQuery(
	baseOptions: Apollo.QueryHookOptions<GetInvoicePdfUrlQuery, GetInvoicePdfUrlQueryVariables> &
		({ variables: GetInvoicePdfUrlQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetInvoicePdfUrlQuery, GetInvoicePdfUrlQueryVariables>(
		GetInvoicePdfUrlDocument,
		options
	);
}
export function useGetInvoicePdfUrlLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePdfUrlQuery, GetInvoicePdfUrlQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetInvoicePdfUrlQuery, GetInvoicePdfUrlQueryVariables>(
		GetInvoicePdfUrlDocument,
		options
	);
}
export function useGetInvoicePdfUrlSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetInvoicePdfUrlQuery, GetInvoicePdfUrlQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetInvoicePdfUrlQuery, GetInvoicePdfUrlQueryVariables>(
		GetInvoicePdfUrlDocument,
		options
	);
}
export type GetInvoicePdfUrlQueryHookResult = ReturnType<typeof useGetInvoicePdfUrlQuery>;
export type GetInvoicePdfUrlLazyQueryHookResult = ReturnType<typeof useGetInvoicePdfUrlLazyQuery>;
export type GetInvoicePdfUrlSuspenseQueryHookResult = ReturnType<
	typeof useGetInvoicePdfUrlSuspenseQuery
>;
export type GetInvoicePdfUrlQueryResult = Apollo.QueryResult<
	GetInvoicePdfUrlQuery,
	GetInvoicePdfUrlQueryVariables
>;
export const GetOrderTransactionsDocument = gql`
	query GetOrderTransactions($orderId: ID!) {
		getOrderTransactionsV2(orderId: $orderId) {
			key
			kind
			status
			statusLabel
			tone
			method
			totalPrice
			currency
			date
			paidAt
			invoiceNumber
			isHistory
			paymentTransactionId
			descriptions {
				text
				sampleRound
			}
		}
	}
`;

/**
 * __useGetOrderTransactionsQuery__
 *
 * To run a query within a React component, call `useGetOrderTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderTransactionsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderTransactionsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrderTransactionsQuery,
		GetOrderTransactionsQueryVariables
	> &
		({ variables: GetOrderTransactionsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderTransactionsQuery, GetOrderTransactionsQueryVariables>(
		GetOrderTransactionsDocument,
		options
	);
}
export function useGetOrderTransactionsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderTransactionsQuery,
		GetOrderTransactionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrderTransactionsQuery, GetOrderTransactionsQueryVariables>(
		GetOrderTransactionsDocument,
		options
	);
}
export function useGetOrderTransactionsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderTransactionsQuery,
				GetOrderTransactionsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOrderTransactionsQuery, GetOrderTransactionsQueryVariables>(
		GetOrderTransactionsDocument,
		options
	);
}
export type GetOrderTransactionsQueryHookResult = ReturnType<typeof useGetOrderTransactionsQuery>;
export type GetOrderTransactionsLazyQueryHookResult = ReturnType<
	typeof useGetOrderTransactionsLazyQuery
>;
export type GetOrderTransactionsSuspenseQueryHookResult = ReturnType<
	typeof useGetOrderTransactionsSuspenseQuery
>;
export type GetOrderTransactionsQueryResult = Apollo.QueryResult<
	GetOrderTransactionsQuery,
	GetOrderTransactionsQueryVariables
>;
export const GetOrganizationSettingDocument = gql`
	query GetOrganizationSetting($organizationId: ID!) {
		getOrganizationSetting(organizationId: $organizationId) {
			id
			currency
			productPaymentMode
			samplePaymentMode
			stripeCheckoutLimit
			invoiceMinimumThreshold
			economicPaymentTermsNumber
			economicPaymentTermsName
			invoiceRecipients {
				type
				userId
				email
				name
			}
		}
	}
`;

/**
 * __useGetOrganizationSettingQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSettingQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationSettingQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationSettingQuery,
		GetOrganizationSettingQueryVariables
	> &
		({ variables: GetOrganizationSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationSettingQuery, GetOrganizationSettingQueryVariables>(
		GetOrganizationSettingDocument,
		options
	);
}
export function useGetOrganizationSettingLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationSettingQuery,
		GetOrganizationSettingQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrganizationSettingQuery, GetOrganizationSettingQueryVariables>(
		GetOrganizationSettingDocument,
		options
	);
}
export function useGetOrganizationSettingSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationSettingQuery,
				GetOrganizationSettingQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationSettingQuery,
		GetOrganizationSettingQueryVariables
	>(GetOrganizationSettingDocument, options);
}
export type GetOrganizationSettingQueryHookResult = ReturnType<
	typeof useGetOrganizationSettingQuery
>;
export type GetOrganizationSettingLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationSettingLazyQuery
>;
export type GetOrganizationSettingSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationSettingSuspenseQuery
>;
export type GetOrganizationSettingQueryResult = Apollo.QueryResult<
	GetOrganizationSettingQuery,
	GetOrganizationSettingQueryVariables
>;
export const EconomicPaymentTermsDocument = gql`
	query EconomicPaymentTerms {
		economicPaymentTerms {
			paymentTermsNumber
			name
			daysOfCredit
			paymentTermsType
			isDefault
		}
	}
`;

/**
 * __useEconomicPaymentTermsQuery__
 *
 * To run a query within a React component, call `useEconomicPaymentTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEconomicPaymentTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEconomicPaymentTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEconomicPaymentTermsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EconomicPaymentTermsQuery,
		EconomicPaymentTermsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EconomicPaymentTermsQuery, EconomicPaymentTermsQueryVariables>(
		EconomicPaymentTermsDocument,
		options
	);
}
export function useEconomicPaymentTermsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EconomicPaymentTermsQuery,
		EconomicPaymentTermsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EconomicPaymentTermsQuery, EconomicPaymentTermsQueryVariables>(
		EconomicPaymentTermsDocument,
		options
	);
}
export function useEconomicPaymentTermsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				EconomicPaymentTermsQuery,
				EconomicPaymentTermsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EconomicPaymentTermsQuery, EconomicPaymentTermsQueryVariables>(
		EconomicPaymentTermsDocument,
		options
	);
}
export type EconomicPaymentTermsQueryHookResult = ReturnType<typeof useEconomicPaymentTermsQuery>;
export type EconomicPaymentTermsLazyQueryHookResult = ReturnType<
	typeof useEconomicPaymentTermsLazyQuery
>;
export type EconomicPaymentTermsSuspenseQueryHookResult = ReturnType<
	typeof useEconomicPaymentTermsSuspenseQuery
>;
export type EconomicPaymentTermsQueryResult = Apollo.QueryResult<
	EconomicPaymentTermsQuery,
	EconomicPaymentTermsQueryVariables
>;
export const GetOrganizationApprovalAndMarginDocument = gql`
	query GetOrganizationApprovalAndMargin($organizationId: ID!) {
		getOrganizationApprovalAndMargin(organizationId: $organizationId) {
			organizationId
			defaultApproval
			defaultMargin
		}
	}
`;

/**
 * __useGetOrganizationApprovalAndMarginQuery__
 *
 * To run a query within a React component, call `useGetOrganizationApprovalAndMarginQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationApprovalAndMarginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationApprovalAndMarginQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationApprovalAndMarginQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	> &
		(
			| { variables: GetOrganizationApprovalAndMarginQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	>(GetOrganizationApprovalAndMarginDocument, options);
}
export function useGetOrganizationApprovalAndMarginLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	>(GetOrganizationApprovalAndMarginDocument, options);
}
export function useGetOrganizationApprovalAndMarginSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationApprovalAndMarginQuery,
				GetOrganizationApprovalAndMarginQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	>(GetOrganizationApprovalAndMarginDocument, options);
}
export type GetOrganizationApprovalAndMarginQueryHookResult = ReturnType<
	typeof useGetOrganizationApprovalAndMarginQuery
>;
export type GetOrganizationApprovalAndMarginLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationApprovalAndMarginLazyQuery
>;
export type GetOrganizationApprovalAndMarginSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationApprovalAndMarginSuspenseQuery
>;
export type GetOrganizationApprovalAndMarginQueryResult = Apollo.QueryResult<
	GetOrganizationApprovalAndMarginQuery,
	GetOrganizationApprovalAndMarginQueryVariables
>;
export const GetAllOrganizationUserDocument = gql`
	query GetAllOrganizationUser($input: GetAllOrganizationUserInput!) {
		getAllOrganizationUser(input: $input) {
			data {
				id
				firstName
				lastName
				jobPosition
				avatar
				createdAt
				updatedAt
				authenticationUser {
					id
					email
					role
					lockedAt
					lockReason
					lastActive
				}
			}
			pageInfo {
				...PageInfoFragment
			}
			errors {
				...ResponseErrorFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
	${ResponseErrorFragmentFragmentDoc}
`;

/**
 * __useGetAllOrganizationUserQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllOrganizationUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllOrganizationUserQuery,
		GetAllOrganizationUserQueryVariables
	> &
		({ variables: GetAllOrganizationUserQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllOrganizationUserQuery, GetAllOrganizationUserQueryVariables>(
		GetAllOrganizationUserDocument,
		options
	);
}
export function useGetAllOrganizationUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllOrganizationUserQuery,
		GetAllOrganizationUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllOrganizationUserQuery, GetAllOrganizationUserQueryVariables>(
		GetAllOrganizationUserDocument,
		options
	);
}
export function useGetAllOrganizationUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationUserQuery,
				GetAllOrganizationUserQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllOrganizationUserQuery,
		GetAllOrganizationUserQueryVariables
	>(GetAllOrganizationUserDocument, options);
}
export type GetAllOrganizationUserQueryHookResult = ReturnType<
	typeof useGetAllOrganizationUserQuery
>;
export type GetAllOrganizationUserLazyQueryHookResult = ReturnType<
	typeof useGetAllOrganizationUserLazyQuery
>;
export type GetAllOrganizationUserSuspenseQueryHookResult = ReturnType<
	typeof useGetAllOrganizationUserSuspenseQuery
>;
export type GetAllOrganizationUserQueryResult = Apollo.QueryResult<
	GetAllOrganizationUserQuery,
	GetAllOrganizationUserQueryVariables
>;
export const GetOrganizationUserStatsDocument = gql`
	query GetOrganizationUserStats($input: GetOrganizationUserStatsInput) {
		getOrganizationUserStats(input: $input) {
			active
			pending
			total
		}
	}
`;

/**
 * __useGetOrganizationUserStatsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUserStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUserStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUserStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrganizationUserStatsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetOrganizationUserStatsQuery,
		GetOrganizationUserStatsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationUserStatsQuery, GetOrganizationUserStatsQueryVariables>(
		GetOrganizationUserStatsDocument,
		options
	);
}
export function useGetOrganizationUserStatsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationUserStatsQuery,
		GetOrganizationUserStatsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationUserStatsQuery,
		GetOrganizationUserStatsQueryVariables
	>(GetOrganizationUserStatsDocument, options);
}
export function useGetOrganizationUserStatsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationUserStatsQuery,
				GetOrganizationUserStatsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationUserStatsQuery,
		GetOrganizationUserStatsQueryVariables
	>(GetOrganizationUserStatsDocument, options);
}
export type GetOrganizationUserStatsQueryHookResult = ReturnType<
	typeof useGetOrganizationUserStatsQuery
>;
export type GetOrganizationUserStatsLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationUserStatsLazyQuery
>;
export type GetOrganizationUserStatsSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationUserStatsSuspenseQuery
>;
export type GetOrganizationUserStatsQueryResult = Apollo.QueryResult<
	GetOrganizationUserStatsQuery,
	GetOrganizationUserStatsQueryVariables
>;
export const GetOrganizationDocument = gql`
	query GetOrganization($id: ID!) {
		getOrganization(id: $id) {
			id
			name
			logo
			originalLogo
			websiteUrl
			countryCode
			organizationIndustryId
			organizationIndustry {
				id
				name
				isPublished
			}
			businessRegistrations {
				type
				number
				verified
			}
			organizationSetting {
				id
				currency
				productPaymentMode
				samplePaymentMode
				invoiceMinimumThreshold
				stripeCheckoutLimit
			}
			createdAt
			updatedAt
			addresses {
				id
				addressLine1
				addressLine2
				addressType
				city
				countryCode
				postalCode
				stateCode
				isPrimary
				name
				googlePlaceId
				latitude
				longitude
			}
			organizationUsers {
				id
				firstName
				lastName
				jobPosition
				phone
				birthday
				notes
				avatar
				status
				isGuest
				invitedAt
				createdAt
				authenticationUser {
					id
					email
				}
			}
		}
	}
`;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationQuery(
	baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables> &
		({ variables: GetOrganizationQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(
		GetOrganizationDocument,
		options
	);
}
export function useGetOrganizationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(
		GetOrganizationDocument,
		options
	);
}
export function useGetOrganizationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(
		GetOrganizationDocument,
		options
	);
}
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationSuspenseQuery
>;
export type GetOrganizationQueryResult = Apollo.QueryResult<
	GetOrganizationQuery,
	GetOrganizationQueryVariables
>;
export const GetAllOrganizationDocument = gql`
	query GetAllOrganization($input: GetAllOrganizationInput!) {
		getAllOrganization(input: $input) {
			data {
				id
				name
				logo
				websiteUrl
				organizationIndustryId
				organizationIndustry {
					id
					name
					isPublished
				}
				createdAt
				updatedAt
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllOrganizationQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllOrganizationQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllOrganizationQuery,
		GetAllOrganizationQueryVariables
	> &
		({ variables: GetAllOrganizationQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllOrganizationQuery, GetAllOrganizationQueryVariables>(
		GetAllOrganizationDocument,
		options
	);
}
export function useGetAllOrganizationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllOrganizationQuery,
		GetAllOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllOrganizationQuery, GetAllOrganizationQueryVariables>(
		GetAllOrganizationDocument,
		options
	);
}
export function useGetAllOrganizationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllOrganizationQuery, GetAllOrganizationQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllOrganizationQuery, GetAllOrganizationQueryVariables>(
		GetAllOrganizationDocument,
		options
	);
}
export type GetAllOrganizationQueryHookResult = ReturnType<typeof useGetAllOrganizationQuery>;
export type GetAllOrganizationLazyQueryHookResult = ReturnType<
	typeof useGetAllOrganizationLazyQuery
>;
export type GetAllOrganizationSuspenseQueryHookResult = ReturnType<
	typeof useGetAllOrganizationSuspenseQuery
>;
export type GetAllOrganizationQueryResult = Apollo.QueryResult<
	GetAllOrganizationQuery,
	GetAllOrganizationQueryVariables
>;
export const GetOrganizationStatsDocument = gql`
	query GetOrganizationStats {
		getOrganizationStats {
			totalClients
			active
			industries
			recent
		}
	}
`;

/**
 * __useGetOrganizationStatsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationStatsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetOrganizationStatsQuery,
		GetOrganizationStatsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationStatsQuery, GetOrganizationStatsQueryVariables>(
		GetOrganizationStatsDocument,
		options
	);
}
export function useGetOrganizationStatsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationStatsQuery,
		GetOrganizationStatsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrganizationStatsQuery, GetOrganizationStatsQueryVariables>(
		GetOrganizationStatsDocument,
		options
	);
}
export function useGetOrganizationStatsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationStatsQuery,
				GetOrganizationStatsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOrganizationStatsQuery, GetOrganizationStatsQueryVariables>(
		GetOrganizationStatsDocument,
		options
	);
}
export type GetOrganizationStatsQueryHookResult = ReturnType<typeof useGetOrganizationStatsQuery>;
export type GetOrganizationStatsLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationStatsLazyQuery
>;
export type GetOrganizationStatsSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationStatsSuspenseQuery
>;
export type GetOrganizationStatsQueryResult = Apollo.QueryResult<
	GetOrganizationStatsQuery,
	GetOrganizationStatsQueryVariables
>;
export const GetOrganizationAddressesDocument = gql`
	query GetOrganizationAddresses($organizationId: ID) {
		getOrganizationAddresses(organizationId: $organizationId) {
			id
			addressLine1
			addressLine2
			addressType
			city
			countryCode
			postalCode
			stateCode
			isPrimary
			name
			googlePlaceId
			latitude
			longitude
		}
	}
`;

/**
 * __useGetOrganizationAddressesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAddressesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationAddressesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetOrganizationAddressesQuery,
		GetOrganizationAddressesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationAddressesQuery, GetOrganizationAddressesQueryVariables>(
		GetOrganizationAddressesDocument,
		options
	);
}
export function useGetOrganizationAddressesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationAddressesQuery,
		GetOrganizationAddressesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationAddressesQuery,
		GetOrganizationAddressesQueryVariables
	>(GetOrganizationAddressesDocument, options);
}
export function useGetOrganizationAddressesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationAddressesQuery,
				GetOrganizationAddressesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationAddressesQuery,
		GetOrganizationAddressesQueryVariables
	>(GetOrganizationAddressesDocument, options);
}
export type GetOrganizationAddressesQueryHookResult = ReturnType<
	typeof useGetOrganizationAddressesQuery
>;
export type GetOrganizationAddressesLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationAddressesLazyQuery
>;
export type GetOrganizationAddressesSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationAddressesSuspenseQuery
>;
export type GetOrganizationAddressesQueryResult = Apollo.QueryResult<
	GetOrganizationAddressesQuery,
	GetOrganizationAddressesQueryVariables
>;
export const GetOrganizationGeneralDocument = gql`
	query GetOrganizationGeneral($organizationId: ID!) {
		getOrganization(id: $organizationId) {
			id
			name
			websiteUrl
		}
	}
`;

/**
 * __useGetOrganizationGeneralQuery__
 *
 * To run a query within a React component, call `useGetOrganizationGeneralQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationGeneralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationGeneralQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationGeneralQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationGeneralQuery,
		GetOrganizationGeneralQueryVariables
	> &
		({ variables: GetOrganizationGeneralQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationGeneralQuery, GetOrganizationGeneralQueryVariables>(
		GetOrganizationGeneralDocument,
		options
	);
}
export function useGetOrganizationGeneralLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationGeneralQuery,
		GetOrganizationGeneralQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrganizationGeneralQuery, GetOrganizationGeneralQueryVariables>(
		GetOrganizationGeneralDocument,
		options
	);
}
export function useGetOrganizationGeneralSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationGeneralQuery,
				GetOrganizationGeneralQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationGeneralQuery,
		GetOrganizationGeneralQueryVariables
	>(GetOrganizationGeneralDocument, options);
}
export type GetOrganizationGeneralQueryHookResult = ReturnType<
	typeof useGetOrganizationGeneralQuery
>;
export type GetOrganizationGeneralLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationGeneralLazyQuery
>;
export type GetOrganizationGeneralSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationGeneralSuspenseQuery
>;
export type GetOrganizationGeneralQueryResult = Apollo.QueryResult<
	GetOrganizationGeneralQuery,
	GetOrganizationGeneralQueryVariables
>;
export const GetAllClientContactDocument = gql`
	query GetAllClientContact($input: GetAllClientContactInput!) {
		getAllClientContact(input: $input) {
			data {
				id
				firstName
				lastName
				jobPosition
				phone
				birthday
				notes
				avatar
				isGuest
				status
				invitedAt
				organizationId
				createdAt
				updatedAt
				organization {
					id
					name
					logo
				}
				authenticationUser {
					id
					email
					lastActive
					lockedAt
				}
			}
			pageInfo {
				...PageInfoFragment
			}
			errors {
				...ResponseErrorFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
	${ResponseErrorFragmentFragmentDoc}
`;

/**
 * __useGetAllClientContactQuery__
 *
 * To run a query within a React component, call `useGetAllClientContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClientContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClientContactQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllClientContactQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllClientContactQuery,
		GetAllClientContactQueryVariables
	> &
		({ variables: GetAllClientContactQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllClientContactQuery, GetAllClientContactQueryVariables>(
		GetAllClientContactDocument,
		options
	);
}
export function useGetAllClientContactLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllClientContactQuery,
		GetAllClientContactQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllClientContactQuery, GetAllClientContactQueryVariables>(
		GetAllClientContactDocument,
		options
	);
}
export function useGetAllClientContactSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllClientContactQuery,
				GetAllClientContactQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllClientContactQuery, GetAllClientContactQueryVariables>(
		GetAllClientContactDocument,
		options
	);
}
export type GetAllClientContactQueryHookResult = ReturnType<typeof useGetAllClientContactQuery>;
export type GetAllClientContactLazyQueryHookResult = ReturnType<
	typeof useGetAllClientContactLazyQuery
>;
export type GetAllClientContactSuspenseQueryHookResult = ReturnType<
	typeof useGetAllClientContactSuspenseQuery
>;
export type GetAllClientContactQueryResult = Apollo.QueryResult<
	GetAllClientContactQuery,
	GetAllClientContactQueryVariables
>;
export const GetMyOrganizationMembershipsDocument = gql`
	query GetMyOrganizationMemberships {
		getMyOrganizationMemberships {
			id
			organizationId
			organization {
				id
				name
				logo
			}
		}
	}
`;

/**
 * __useGetMyOrganizationMembershipsQuery__
 *
 * To run a query within a React component, call `useGetMyOrganizationMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrganizationMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrganizationMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyOrganizationMembershipsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetMyOrganizationMembershipsQuery,
		GetMyOrganizationMembershipsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetMyOrganizationMembershipsQuery,
		GetMyOrganizationMembershipsQueryVariables
	>(GetMyOrganizationMembershipsDocument, options);
}
export function useGetMyOrganizationMembershipsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetMyOrganizationMembershipsQuery,
		GetMyOrganizationMembershipsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetMyOrganizationMembershipsQuery,
		GetMyOrganizationMembershipsQueryVariables
	>(GetMyOrganizationMembershipsDocument, options);
}
export function useGetMyOrganizationMembershipsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetMyOrganizationMembershipsQuery,
				GetMyOrganizationMembershipsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetMyOrganizationMembershipsQuery,
		GetMyOrganizationMembershipsQueryVariables
	>(GetMyOrganizationMembershipsDocument, options);
}
export type GetMyOrganizationMembershipsQueryHookResult = ReturnType<
	typeof useGetMyOrganizationMembershipsQuery
>;
export type GetMyOrganizationMembershipsLazyQueryHookResult = ReturnType<
	typeof useGetMyOrganizationMembershipsLazyQuery
>;
export type GetMyOrganizationMembershipsSuspenseQueryHookResult = ReturnType<
	typeof useGetMyOrganizationMembershipsSuspenseQuery
>;
export type GetMyOrganizationMembershipsQueryResult = Apollo.QueryResult<
	GetMyOrganizationMembershipsQuery,
	GetMyOrganizationMembershipsQueryVariables
>;
export const GetAllOrganizationIndustriesDocument = gql`
	query GetAllOrganizationIndustries {
		getAllOrganizationIndustries {
			id
			name
			isPublished
			createdByOrganizationId
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetAllOrganizationIndustriesQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationIndustriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllOrganizationIndustriesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAllOrganizationIndustriesQuery,
		GetAllOrganizationIndustriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllOrganizationIndustriesQuery,
		GetAllOrganizationIndustriesQueryVariables
	>(GetAllOrganizationIndustriesDocument, options);
}
export function useGetAllOrganizationIndustriesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllOrganizationIndustriesQuery,
		GetAllOrganizationIndustriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllOrganizationIndustriesQuery,
		GetAllOrganizationIndustriesQueryVariables
	>(GetAllOrganizationIndustriesDocument, options);
}
export function useGetAllOrganizationIndustriesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationIndustriesQuery,
				GetAllOrganizationIndustriesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllOrganizationIndustriesQuery,
		GetAllOrganizationIndustriesQueryVariables
	>(GetAllOrganizationIndustriesDocument, options);
}
export type GetAllOrganizationIndustriesQueryHookResult = ReturnType<
	typeof useGetAllOrganizationIndustriesQuery
>;
export type GetAllOrganizationIndustriesLazyQueryHookResult = ReturnType<
	typeof useGetAllOrganizationIndustriesLazyQuery
>;
export type GetAllOrganizationIndustriesSuspenseQueryHookResult = ReturnType<
	typeof useGetAllOrganizationIndustriesSuspenseQuery
>;
export type GetAllOrganizationIndustriesQueryResult = Apollo.QueryResult<
	GetAllOrganizationIndustriesQuery,
	GetAllOrganizationIndustriesQueryVariables
>;
export const GetAllOrganizationIndustriesAdminDocument = gql`
	query GetAllOrganizationIndustriesAdmin {
		getAllOrganizationIndustriesAdmin {
			id
			name
			isPublished
			createdByOrganizationId
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetAllOrganizationIndustriesAdminQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationIndustriesAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationIndustriesAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationIndustriesAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllOrganizationIndustriesAdminQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAllOrganizationIndustriesAdminQuery,
		GetAllOrganizationIndustriesAdminQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllOrganizationIndustriesAdminQuery,
		GetAllOrganizationIndustriesAdminQueryVariables
	>(GetAllOrganizationIndustriesAdminDocument, options);
}
export function useGetAllOrganizationIndustriesAdminLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllOrganizationIndustriesAdminQuery,
		GetAllOrganizationIndustriesAdminQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllOrganizationIndustriesAdminQuery,
		GetAllOrganizationIndustriesAdminQueryVariables
	>(GetAllOrganizationIndustriesAdminDocument, options);
}
export function useGetAllOrganizationIndustriesAdminSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationIndustriesAdminQuery,
				GetAllOrganizationIndustriesAdminQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllOrganizationIndustriesAdminQuery,
		GetAllOrganizationIndustriesAdminQueryVariables
	>(GetAllOrganizationIndustriesAdminDocument, options);
}
export type GetAllOrganizationIndustriesAdminQueryHookResult = ReturnType<
	typeof useGetAllOrganizationIndustriesAdminQuery
>;
export type GetAllOrganizationIndustriesAdminLazyQueryHookResult = ReturnType<
	typeof useGetAllOrganizationIndustriesAdminLazyQuery
>;
export type GetAllOrganizationIndustriesAdminSuspenseQueryHookResult = ReturnType<
	typeof useGetAllOrganizationIndustriesAdminSuspenseQuery
>;
export type GetAllOrganizationIndustriesAdminQueryResult = Apollo.QueryResult<
	GetAllOrganizationIndustriesAdminQuery,
	GetAllOrganizationIndustriesAdminQueryVariables
>;
export const GetPantoneBooksDocument = gql`
	query GetPantoneBooks {
		getPantoneBooks {
			id
			title
			finish
			colorCount
		}
	}
`;

/**
 * __useGetPantoneBooksQuery__
 *
 * To run a query within a React component, call `useGetPantoneBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPantoneBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPantoneBooksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPantoneBooksQuery(
	baseOptions?: Apollo.QueryHookOptions<GetPantoneBooksQuery, GetPantoneBooksQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetPantoneBooksQuery, GetPantoneBooksQueryVariables>(
		GetPantoneBooksDocument,
		options
	);
}
export function useGetPantoneBooksLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetPantoneBooksQuery, GetPantoneBooksQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetPantoneBooksQuery, GetPantoneBooksQueryVariables>(
		GetPantoneBooksDocument,
		options
	);
}
export function useGetPantoneBooksSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetPantoneBooksQuery, GetPantoneBooksQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetPantoneBooksQuery, GetPantoneBooksQueryVariables>(
		GetPantoneBooksDocument,
		options
	);
}
export type GetPantoneBooksQueryHookResult = ReturnType<typeof useGetPantoneBooksQuery>;
export type GetPantoneBooksLazyQueryHookResult = ReturnType<typeof useGetPantoneBooksLazyQuery>;
export type GetPantoneBooksSuspenseQueryHookResult = ReturnType<
	typeof useGetPantoneBooksSuspenseQuery
>;
export type GetPantoneBooksQueryResult = Apollo.QueryResult<
	GetPantoneBooksQuery,
	GetPantoneBooksQueryVariables
>;
export const MatchPantoneColorDocument = gql`
	query MatchPantoneColor($input: MatchPantoneColorInput!) {
		matchPantoneColor(input: $input) {
			accuracy
			deltaE
			color {
				id
				book
				bookTitle
				finish
				code
				name
				hex
				pageNumberInBook
			}
		}
	}
`;

/**
 * __useMatchPantoneColorQuery__
 *
 * To run a query within a React component, call `useMatchPantoneColorQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchPantoneColorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchPantoneColorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchPantoneColorQuery(
	baseOptions: Apollo.QueryHookOptions<MatchPantoneColorQuery, MatchPantoneColorQueryVariables> &
		({ variables: MatchPantoneColorQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MatchPantoneColorQuery, MatchPantoneColorQueryVariables>(
		MatchPantoneColorDocument,
		options
	);
}
export function useMatchPantoneColorLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MatchPantoneColorQuery,
		MatchPantoneColorQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MatchPantoneColorQuery, MatchPantoneColorQueryVariables>(
		MatchPantoneColorDocument,
		options
	);
}
export function useMatchPantoneColorSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<MatchPantoneColorQuery, MatchPantoneColorQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MatchPantoneColorQuery, MatchPantoneColorQueryVariables>(
		MatchPantoneColorDocument,
		options
	);
}
export type MatchPantoneColorQueryHookResult = ReturnType<typeof useMatchPantoneColorQuery>;
export type MatchPantoneColorLazyQueryHookResult = ReturnType<typeof useMatchPantoneColorLazyQuery>;
export type MatchPantoneColorSuspenseQueryHookResult = ReturnType<
	typeof useMatchPantoneColorSuspenseQuery
>;
export type MatchPantoneColorQueryResult = Apollo.QueryResult<
	MatchPantoneColorQuery,
	MatchPantoneColorQueryVariables
>;
export const GetAllPantoneColorDocument = gql`
	query GetAllPantoneColor($input: GetAllPantoneColorInput!) {
		getAllPantoneColor(input: $input) {
			data {
				id
				book
				bookTitle
				finish
				code
				name
				hex
				pageNumberInBook
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllPantoneColorQuery__
 *
 * To run a query within a React component, call `useGetAllPantoneColorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPantoneColorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPantoneColorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllPantoneColorQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllPantoneColorQuery,
		GetAllPantoneColorQueryVariables
	> &
		({ variables: GetAllPantoneColorQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllPantoneColorQuery, GetAllPantoneColorQueryVariables>(
		GetAllPantoneColorDocument,
		options
	);
}
export function useGetAllPantoneColorLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllPantoneColorQuery,
		GetAllPantoneColorQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllPantoneColorQuery, GetAllPantoneColorQueryVariables>(
		GetAllPantoneColorDocument,
		options
	);
}
export function useGetAllPantoneColorSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllPantoneColorQuery, GetAllPantoneColorQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllPantoneColorQuery, GetAllPantoneColorQueryVariables>(
		GetAllPantoneColorDocument,
		options
	);
}
export type GetAllPantoneColorQueryHookResult = ReturnType<typeof useGetAllPantoneColorQuery>;
export type GetAllPantoneColorLazyQueryHookResult = ReturnType<
	typeof useGetAllPantoneColorLazyQuery
>;
export type GetAllPantoneColorSuspenseQueryHookResult = ReturnType<
	typeof useGetAllPantoneColorSuspenseQuery
>;
export type GetAllPantoneColorQueryResult = Apollo.QueryResult<
	GetAllPantoneColorQuery,
	GetAllPantoneColorQueryVariables
>;
export const FindPantoneColorAcrossBooksDocument = gql`
	query FindPantoneColorAcrossBooks($code: String!) {
		findPantoneColorAcrossBooks(code: $code) {
			id
			book
			bookTitle
			finish
			code
			name
			hex
		}
	}
`;

/**
 * __useFindPantoneColorAcrossBooksQuery__
 *
 * To run a query within a React component, call `useFindPantoneColorAcrossBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPantoneColorAcrossBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPantoneColorAcrossBooksQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useFindPantoneColorAcrossBooksQuery(
	baseOptions: Apollo.QueryHookOptions<
		FindPantoneColorAcrossBooksQuery,
		FindPantoneColorAcrossBooksQueryVariables
	> &
		(
			| { variables: FindPantoneColorAcrossBooksQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		FindPantoneColorAcrossBooksQuery,
		FindPantoneColorAcrossBooksQueryVariables
	>(FindPantoneColorAcrossBooksDocument, options);
}
export function useFindPantoneColorAcrossBooksLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		FindPantoneColorAcrossBooksQuery,
		FindPantoneColorAcrossBooksQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		FindPantoneColorAcrossBooksQuery,
		FindPantoneColorAcrossBooksQueryVariables
	>(FindPantoneColorAcrossBooksDocument, options);
}
export function useFindPantoneColorAcrossBooksSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				FindPantoneColorAcrossBooksQuery,
				FindPantoneColorAcrossBooksQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		FindPantoneColorAcrossBooksQuery,
		FindPantoneColorAcrossBooksQueryVariables
	>(FindPantoneColorAcrossBooksDocument, options);
}
export type FindPantoneColorAcrossBooksQueryHookResult = ReturnType<
	typeof useFindPantoneColorAcrossBooksQuery
>;
export type FindPantoneColorAcrossBooksLazyQueryHookResult = ReturnType<
	typeof useFindPantoneColorAcrossBooksLazyQuery
>;
export type FindPantoneColorAcrossBooksSuspenseQueryHookResult = ReturnType<
	typeof useFindPantoneColorAcrossBooksSuspenseQuery
>;
export type FindPantoneColorAcrossBooksQueryResult = Apollo.QueryResult<
	FindPantoneColorAcrossBooksQuery,
	FindPantoneColorAcrossBooksQueryVariables
>;
export const GetProductPaymentPreviewDocument = gql`
	query GetProductPaymentPreview($orderId: ID!, $currency: String!, $orderItemIds: [ID!]) {
		getProductPaymentPreview(
			orderId: $orderId
			currency: $currency
			orderItemIds: $orderItemIds
		) {
			currency
			grandTotal
			vatRate
			vatAmount
			grossAmount
			deductionsDeferred
			deliveries {
				method
				amount
			}
			items {
				orderItemId
				description
				productsAmount
				feesAmount
				fees {
					name
					amount
				}
				deliveryAmount
				deliveries {
					method
					amount
				}
				lineSubtotal
				deductibleAmount
				deductibleSamples {
					sampleId
					description
					amount
				}
				lineNetAmount
			}
		}
	}
`;

/**
 * __useGetProductPaymentPreviewQuery__
 *
 * To run a query within a React component, call `useGetProductPaymentPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPaymentPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPaymentPreviewQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      currency: // value for 'currency'
 *      orderItemIds: // value for 'orderItemIds'
 *   },
 * });
 */
export function useGetProductPaymentPreviewQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetProductPaymentPreviewQuery,
		GetProductPaymentPreviewQueryVariables
	> &
		({ variables: GetProductPaymentPreviewQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetProductPaymentPreviewQuery, GetProductPaymentPreviewQueryVariables>(
		GetProductPaymentPreviewDocument,
		options
	);
}
export function useGetProductPaymentPreviewLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetProductPaymentPreviewQuery,
		GetProductPaymentPreviewQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetProductPaymentPreviewQuery,
		GetProductPaymentPreviewQueryVariables
	>(GetProductPaymentPreviewDocument, options);
}
export function useGetProductPaymentPreviewSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetProductPaymentPreviewQuery,
				GetProductPaymentPreviewQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetProductPaymentPreviewQuery,
		GetProductPaymentPreviewQueryVariables
	>(GetProductPaymentPreviewDocument, options);
}
export type GetProductPaymentPreviewQueryHookResult = ReturnType<
	typeof useGetProductPaymentPreviewQuery
>;
export type GetProductPaymentPreviewLazyQueryHookResult = ReturnType<
	typeof useGetProductPaymentPreviewLazyQuery
>;
export type GetProductPaymentPreviewSuspenseQueryHookResult = ReturnType<
	typeof useGetProductPaymentPreviewSuspenseQuery
>;
export type GetProductPaymentPreviewQueryResult = Apollo.QueryResult<
	GetProductPaymentPreviewQuery,
	GetProductPaymentPreviewQueryVariables
>;
export const GetSamplePaymentPreviewDocument = gql`
	query GetSamplePaymentPreview($orderId: ID!, $currency: String!, $sampleIds: [ID!]) {
		getSamplePaymentPreview(orderId: $orderId, currency: $currency, sampleIds: $sampleIds) {
			currency
			grandTotal
			vatRate
			vatAmount
			grossAmount
			items {
				orderItemId
				sampleId
				description
				samplePrice
				shippingPrice
			}
		}
	}
`;

/**
 * __useGetSamplePaymentPreviewQuery__
 *
 * To run a query within a React component, call `useGetSamplePaymentPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSamplePaymentPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSamplePaymentPreviewQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      currency: // value for 'currency'
 *      sampleIds: // value for 'sampleIds'
 *   },
 * });
 */
export function useGetSamplePaymentPreviewQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetSamplePaymentPreviewQuery,
		GetSamplePaymentPreviewQueryVariables
	> &
		({ variables: GetSamplePaymentPreviewQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetSamplePaymentPreviewQuery, GetSamplePaymentPreviewQueryVariables>(
		GetSamplePaymentPreviewDocument,
		options
	);
}
export function useGetSamplePaymentPreviewLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetSamplePaymentPreviewQuery,
		GetSamplePaymentPreviewQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetSamplePaymentPreviewQuery, GetSamplePaymentPreviewQueryVariables>(
		GetSamplePaymentPreviewDocument,
		options
	);
}
export function useGetSamplePaymentPreviewSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetSamplePaymentPreviewQuery,
				GetSamplePaymentPreviewQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetSamplePaymentPreviewQuery,
		GetSamplePaymentPreviewQueryVariables
	>(GetSamplePaymentPreviewDocument, options);
}
export type GetSamplePaymentPreviewQueryHookResult = ReturnType<
	typeof useGetSamplePaymentPreviewQuery
>;
export type GetSamplePaymentPreviewLazyQueryHookResult = ReturnType<
	typeof useGetSamplePaymentPreviewLazyQuery
>;
export type GetSamplePaymentPreviewSuspenseQueryHookResult = ReturnType<
	typeof useGetSamplePaymentPreviewSuspenseQuery
>;
export type GetSamplePaymentPreviewQueryResult = Apollo.QueryResult<
	GetSamplePaymentPreviewQuery,
	GetSamplePaymentPreviewQueryVariables
>;
export const GetFullOrderPaymentPreviewDocument = gql`
	query GetFullOrderPaymentPreview($orderId: ID!, $currency: String!) {
		getFullOrderPaymentPreview(orderId: $orderId, currency: $currency) {
			currency
			items {
				orderItemId
				description
				productsAmount
				deliveryAmount
				feesAmount
				lineSubtotal
				deductibleAmount
				lineNetAmount
			}
			samples {
				sampleId
				orderItemId
				description
				sampleAmount
				shippingAmount
			}
			deliveries {
				method
				amount
			}
			deductionsUncredited
			deductionsDeferred
			grandTotal
			vatRate
			vatAmount
			grossAmount
		}
	}
`;

/**
 * __useGetFullOrderPaymentPreviewQuery__
 *
 * To run a query within a React component, call `useGetFullOrderPaymentPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullOrderPaymentPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullOrderPaymentPreviewQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetFullOrderPaymentPreviewQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetFullOrderPaymentPreviewQuery,
		GetFullOrderPaymentPreviewQueryVariables
	> &
		(
			| { variables: GetFullOrderPaymentPreviewQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetFullOrderPaymentPreviewQuery,
		GetFullOrderPaymentPreviewQueryVariables
	>(GetFullOrderPaymentPreviewDocument, options);
}
export function useGetFullOrderPaymentPreviewLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetFullOrderPaymentPreviewQuery,
		GetFullOrderPaymentPreviewQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetFullOrderPaymentPreviewQuery,
		GetFullOrderPaymentPreviewQueryVariables
	>(GetFullOrderPaymentPreviewDocument, options);
}
export function useGetFullOrderPaymentPreviewSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetFullOrderPaymentPreviewQuery,
				GetFullOrderPaymentPreviewQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetFullOrderPaymentPreviewQuery,
		GetFullOrderPaymentPreviewQueryVariables
	>(GetFullOrderPaymentPreviewDocument, options);
}
export type GetFullOrderPaymentPreviewQueryHookResult = ReturnType<
	typeof useGetFullOrderPaymentPreviewQuery
>;
export type GetFullOrderPaymentPreviewLazyQueryHookResult = ReturnType<
	typeof useGetFullOrderPaymentPreviewLazyQuery
>;
export type GetFullOrderPaymentPreviewSuspenseQueryHookResult = ReturnType<
	typeof useGetFullOrderPaymentPreviewSuspenseQuery
>;
export type GetFullOrderPaymentPreviewQueryResult = Apollo.QueryResult<
	GetFullOrderPaymentPreviewQuery,
	GetFullOrderPaymentPreviewQueryVariables
>;
export const GetAllProductsDocument = gql`
	query GetAllProducts($input: GetAllProductInput!) {
		getAllProduct(input: $input) {
			data {
				id
				name
				description
				sku
				weight
				status
				brandId
				organizationId
				organization {
					id
					name
					logo
				}
				dimensions {
					length
					width
					height
					unit
				}
				images {
					id
					url
					name
					isPrimary
					altText
					sortOrder
					mimeType
					size
					uploadedAt
					crop {
						x
						y
						width
						height
						zoom
						rotation
						aspectRatio
						unit
					}
				}
				tags {
					id
					name
					color
				}
				recommendations {
					id
					productId
					type
					title
					description
					actionLabel
					actionUrl
					status
				}
				isPublishedToCommunity
				communityPublishedAt
				createdAt
				updatedAt
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllProductsQuery__
 *
 * To run a query within a React component, call `useGetAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllProductsQuery(
	baseOptions: Apollo.QueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables> &
		({ variables: GetAllProductsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(
		GetAllProductsDocument,
		options
	);
}
export function useGetAllProductsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(
		GetAllProductsDocument,
		options
	);
}
export function useGetAllProductsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(
		GetAllProductsDocument,
		options
	);
}
export type GetAllProductsQueryHookResult = ReturnType<typeof useGetAllProductsQuery>;
export type GetAllProductsLazyQueryHookResult = ReturnType<typeof useGetAllProductsLazyQuery>;
export type GetAllProductsSuspenseQueryHookResult = ReturnType<
	typeof useGetAllProductsSuspenseQuery
>;
export type GetAllProductsQueryResult = Apollo.QueryResult<
	GetAllProductsQuery,
	GetAllProductsQueryVariables
>;
export const GetCommunityProductsDocument = gql`
	query GetCommunityProducts($input: GetAllProductInput!) {
		getAllProduct(input: $input) {
			data {
				id
				name
				description
				images {
					id
					url
					name
					isPrimary
					sortOrder
					crop {
						x
						y
						width
						height
						zoom
						rotation
						aspectRatio
						unit
					}
				}
				tags {
					id
					name
					color
				}
				communityPublishedAt
				availableActions {
					canDuplicate
					canRemix
				}
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetCommunityProductsQuery__
 *
 * To run a query within a React component, call `useGetCommunityProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCommunityProductsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetCommunityProductsQuery,
		GetCommunityProductsQueryVariables
	> &
		({ variables: GetCommunityProductsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetCommunityProductsQuery, GetCommunityProductsQueryVariables>(
		GetCommunityProductsDocument,
		options
	);
}
export function useGetCommunityProductsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetCommunityProductsQuery,
		GetCommunityProductsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetCommunityProductsQuery, GetCommunityProductsQueryVariables>(
		GetCommunityProductsDocument,
		options
	);
}
export function useGetCommunityProductsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetCommunityProductsQuery,
				GetCommunityProductsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetCommunityProductsQuery, GetCommunityProductsQueryVariables>(
		GetCommunityProductsDocument,
		options
	);
}
export type GetCommunityProductsQueryHookResult = ReturnType<typeof useGetCommunityProductsQuery>;
export type GetCommunityProductsLazyQueryHookResult = ReturnType<
	typeof useGetCommunityProductsLazyQuery
>;
export type GetCommunityProductsSuspenseQueryHookResult = ReturnType<
	typeof useGetCommunityProductsSuspenseQuery
>;
export type GetCommunityProductsQueryResult = Apollo.QueryResult<
	GetCommunityProductsQuery,
	GetCommunityProductsQueryVariables
>;
export const GetProductTagsDocument = gql`
	query GetProductTags($input: GetAllProductTagInput!) {
		getAllProductTag(input: $input) {
			data {
				id
				name
				color
				parentId
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetProductTagsQuery__
 *
 * To run a query within a React component, call `useGetProductTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductTagsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductTagsQuery(
	baseOptions: Apollo.QueryHookOptions<GetProductTagsQuery, GetProductTagsQueryVariables> &
		({ variables: GetProductTagsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetProductTagsQuery, GetProductTagsQueryVariables>(
		GetProductTagsDocument,
		options
	);
}
export function useGetProductTagsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetProductTagsQuery, GetProductTagsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetProductTagsQuery, GetProductTagsQueryVariables>(
		GetProductTagsDocument,
		options
	);
}
export function useGetProductTagsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetProductTagsQuery, GetProductTagsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetProductTagsQuery, GetProductTagsQueryVariables>(
		GetProductTagsDocument,
		options
	);
}
export type GetProductTagsQueryHookResult = ReturnType<typeof useGetProductTagsQuery>;
export type GetProductTagsLazyQueryHookResult = ReturnType<typeof useGetProductTagsLazyQuery>;
export type GetProductTagsSuspenseQueryHookResult = ReturnType<
	typeof useGetProductTagsSuspenseQuery
>;
export type GetProductTagsQueryResult = Apollo.QueryResult<
	GetProductTagsQuery,
	GetProductTagsQueryVariables
>;
export const GetProductStatsDocument = gql`
	query GetProductStats {
		getProductStats {
			total
			admin
			organization
			community
			withImages
			recent
		}
	}
`;

/**
 * __useGetProductStatsQuery__
 *
 * To run a query within a React component, call `useGetProductStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductStatsQuery(
	baseOptions?: Apollo.QueryHookOptions<GetProductStatsQuery, GetProductStatsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetProductStatsQuery, GetProductStatsQueryVariables>(
		GetProductStatsDocument,
		options
	);
}
export function useGetProductStatsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetProductStatsQuery, GetProductStatsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetProductStatsQuery, GetProductStatsQueryVariables>(
		GetProductStatsDocument,
		options
	);
}
export function useGetProductStatsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetProductStatsQuery, GetProductStatsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetProductStatsQuery, GetProductStatsQueryVariables>(
		GetProductStatsDocument,
		options
	);
}
export type GetProductStatsQueryHookResult = ReturnType<typeof useGetProductStatsQuery>;
export type GetProductStatsLazyQueryHookResult = ReturnType<typeof useGetProductStatsLazyQuery>;
export type GetProductStatsSuspenseQueryHookResult = ReturnType<
	typeof useGetProductStatsSuspenseQuery
>;
export type GetProductStatsQueryResult = Apollo.QueryResult<
	GetProductStatsQuery,
	GetProductStatsQueryVariables
>;
export const GetProductDocument = gql`
	query GetProduct($id: ID!) {
		getProduct(id: $id) {
			id
			name
			description
			sku
			brandId
			weight
			metadata {
				isAIGenerated
				createdFromProject
			}
			dimensions {
				length
				width
				height
				unit
			}
			specifications {
				...ProductSpecificationsFragment
			}
			images {
				id
				url
				name
				isPrimary
				altText
				mimeType
				sortOrder
				crop {
					x
					y
					width
					height
					zoom
					rotation
					aspectRatio
					unit
				}
				metadata {
					type
					x
					y
					width
					height
					points {
						x
						y
					}
					comment
					canvasWidth
					canvasHeight
					attachments {
						fileName
						contentType
						size
						url
					}
				}
			}
			brand {
				id
				name
				brandFiles {
					id
					name
					url
					type
					mimeType
					size
					uploadedAt
				}
			}
			recommendations {
				id
				productId
				type
				title
				description
				actionLabel
				actionUrl
				status
			}
			studioFileId
			studioFile {
				id
				name
				currentVersion {
					id
					imageUrls
					versionNumber
				}
			}
			organizationId
			tags {
				id
				name
				color
			}
			isPublishedToCommunity
			communityPublishedAt
			communityPublishability {
				canPublish
				reason
			}
			communityCopyCount
			sourceProductId
			availableActions {
				canDuplicate
				canRemix
				canEdit
				canDelete
			}
			createdAt
			updatedAt
		}
	}
	${ProductSpecificationsFragmentFragmentDoc}
`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(
	baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables> &
		({ variables: GetProductQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
}
export function useGetProductLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(
		GetProductDocument,
		options
	);
}
export function useGetProductSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetProductQuery, GetProductQueryVariables>(
		GetProductDocument,
		options
	);
}
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductSuspenseQueryHookResult = ReturnType<typeof useGetProductSuspenseQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetProductPricesDocument = gql`
	query GetProductPrices($input: GetProductPricesInput!, $currency: CurrencyEnum!) {
		getProductPrices(input: $input) {
			id
			productId
			vetterEntityId
			vetterEntity {
				id
				name
			}
			quantity
			baseUnitPrice
			currency
			markupPercentage
			unitSalePrice
			marginUnit
			marginPercentage
			minProductionDays
			maxProductionDays
			isActive
			validFrom
			validTo
			lastQuotedUnitPrice
			lastQuotedCurrency
			lastQuotedAt
			lastQuotedOfferId
			converted(currency: $currency) {
				currency
				baseUnitPrice
				unitSalePrice
				marginUnit
				lastQuotedUnitPrice
				exchangeRate
			}
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetProductPricesQuery__
 *
 * To run a query within a React component, call `useGetProductPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPricesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetProductPricesQuery(
	baseOptions: Apollo.QueryHookOptions<GetProductPricesQuery, GetProductPricesQueryVariables> &
		({ variables: GetProductPricesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetProductPricesQuery, GetProductPricesQueryVariables>(
		GetProductPricesDocument,
		options
	);
}
export function useGetProductPricesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetProductPricesQuery, GetProductPricesQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetProductPricesQuery, GetProductPricesQueryVariables>(
		GetProductPricesDocument,
		options
	);
}
export function useGetProductPricesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetProductPricesQuery, GetProductPricesQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetProductPricesQuery, GetProductPricesQueryVariables>(
		GetProductPricesDocument,
		options
	);
}
export type GetProductPricesQueryHookResult = ReturnType<typeof useGetProductPricesQuery>;
export type GetProductPricesLazyQueryHookResult = ReturnType<typeof useGetProductPricesLazyQuery>;
export type GetProductPricesSuspenseQueryHookResult = ReturnType<
	typeof useGetProductPricesSuspenseQuery
>;
export type GetProductPricesQueryResult = Apollo.QueryResult<
	GetProductPricesQuery,
	GetProductPricesQueryVariables
>;
export const SuggestOrderQuoteItemPricingDocument = gql`
	query SuggestOrderQuoteItemPricing(
		$orderQuoteItemId: ID!
		$vetterEntityId: ID
		$inCurrency: CurrencyEnum
	) {
		suggestOrderQuoteItemPricing(
			orderQuoteItemId: $orderQuoteItemId
			vetterEntityId: $vetterEntityId
			inCurrency: $inCurrency
		) {
			orderQuoteItemQuantityId
			quantity
			baseUnitPrice
			currency
			markupPercentage
			minProductionDays
			maxProductionDays
			source
			vetterEntity {
				id
				name
			}
			matchedQuantity
			match
			converted {
				currency
				baseUnitPrice
				exchangeRate
				shippingPrices {
					shippingMethod
					price
					deliveryDaysMin
					deliveryDaysMax
				}
			}
			note
			shippingPrices {
				shippingMethod
				price
				deliveryDaysMin
				deliveryDaysMax
			}
			alternatives {
				quantity
				baseUnitPrice
				currency
				markupPercentage
				minProductionDays
				maxProductionDays
				converted {
					currency
					baseUnitPrice
					exchangeRate
				}
			}
		}
	}
`;

/**
 * __useSuggestOrderQuoteItemPricingQuery__
 *
 * To run a query within a React component, call `useSuggestOrderQuoteItemPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestOrderQuoteItemPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestOrderQuoteItemPricingQuery({
 *   variables: {
 *      orderQuoteItemId: // value for 'orderQuoteItemId'
 *      vetterEntityId: // value for 'vetterEntityId'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useSuggestOrderQuoteItemPricingQuery(
	baseOptions: Apollo.QueryHookOptions<
		SuggestOrderQuoteItemPricingQuery,
		SuggestOrderQuoteItemPricingQueryVariables
	> &
		(
			| { variables: SuggestOrderQuoteItemPricingQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SuggestOrderQuoteItemPricingQuery,
		SuggestOrderQuoteItemPricingQueryVariables
	>(SuggestOrderQuoteItemPricingDocument, options);
}
export function useSuggestOrderQuoteItemPricingLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SuggestOrderQuoteItemPricingQuery,
		SuggestOrderQuoteItemPricingQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SuggestOrderQuoteItemPricingQuery,
		SuggestOrderQuoteItemPricingQueryVariables
	>(SuggestOrderQuoteItemPricingDocument, options);
}
export function useSuggestOrderQuoteItemPricingSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				SuggestOrderQuoteItemPricingQuery,
				SuggestOrderQuoteItemPricingQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		SuggestOrderQuoteItemPricingQuery,
		SuggestOrderQuoteItemPricingQueryVariables
	>(SuggestOrderQuoteItemPricingDocument, options);
}
export type SuggestOrderQuoteItemPricingQueryHookResult = ReturnType<
	typeof useSuggestOrderQuoteItemPricingQuery
>;
export type SuggestOrderQuoteItemPricingLazyQueryHookResult = ReturnType<
	typeof useSuggestOrderQuoteItemPricingLazyQuery
>;
export type SuggestOrderQuoteItemPricingSuspenseQueryHookResult = ReturnType<
	typeof useSuggestOrderQuoteItemPricingSuspenseQuery
>;
export type SuggestOrderQuoteItemPricingQueryResult = Apollo.QueryResult<
	SuggestOrderQuoteItemPricingQuery,
	SuggestOrderQuoteItemPricingQueryVariables
>;
export const SuggestOrderQuoteOfferPricingDocument = gql`
	query SuggestOrderQuoteOfferPricing($orderQuoteOfferId: ID!, $inCurrency: CurrencyEnum) {
		suggestOrderQuoteOfferPricing(
			orderQuoteOfferId: $orderQuoteOfferId
			inCurrency: $inCurrency
		) {
			orderQuoteItemQuantityId
			quantity
			baseUnitPrice
			currency
			markupPercentage
			minProductionDays
			maxProductionDays
			source
			vetterEntity {
				id
				name
			}
			matchedQuantity
			match
			converted {
				currency
				baseUnitPrice
				exchangeRate
			}
			alternatives {
				quantity
				baseUnitPrice
				currency
				markupPercentage
				minProductionDays
				maxProductionDays
				converted {
					currency
					baseUnitPrice
					exchangeRate
				}
			}
		}
	}
`;

/**
 * __useSuggestOrderQuoteOfferPricingQuery__
 *
 * To run a query within a React component, call `useSuggestOrderQuoteOfferPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestOrderQuoteOfferPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestOrderQuoteOfferPricingQuery({
 *   variables: {
 *      orderQuoteOfferId: // value for 'orderQuoteOfferId'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useSuggestOrderQuoteOfferPricingQuery(
	baseOptions: Apollo.QueryHookOptions<
		SuggestOrderQuoteOfferPricingQuery,
		SuggestOrderQuoteOfferPricingQueryVariables
	> &
		(
			| { variables: SuggestOrderQuoteOfferPricingQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SuggestOrderQuoteOfferPricingQuery,
		SuggestOrderQuoteOfferPricingQueryVariables
	>(SuggestOrderQuoteOfferPricingDocument, options);
}
export function useSuggestOrderQuoteOfferPricingLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SuggestOrderQuoteOfferPricingQuery,
		SuggestOrderQuoteOfferPricingQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SuggestOrderQuoteOfferPricingQuery,
		SuggestOrderQuoteOfferPricingQueryVariables
	>(SuggestOrderQuoteOfferPricingDocument, options);
}
export function useSuggestOrderQuoteOfferPricingSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				SuggestOrderQuoteOfferPricingQuery,
				SuggestOrderQuoteOfferPricingQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		SuggestOrderQuoteOfferPricingQuery,
		SuggestOrderQuoteOfferPricingQueryVariables
	>(SuggestOrderQuoteOfferPricingDocument, options);
}
export type SuggestOrderQuoteOfferPricingQueryHookResult = ReturnType<
	typeof useSuggestOrderQuoteOfferPricingQuery
>;
export type SuggestOrderQuoteOfferPricingLazyQueryHookResult = ReturnType<
	typeof useSuggestOrderQuoteOfferPricingLazyQuery
>;
export type SuggestOrderQuoteOfferPricingSuspenseQueryHookResult = ReturnType<
	typeof useSuggestOrderQuoteOfferPricingSuspenseQuery
>;
export type SuggestOrderQuoteOfferPricingQueryResult = Apollo.QueryResult<
	SuggestOrderQuoteOfferPricingQuery,
	SuggestOrderQuoteOfferPricingQueryVariables
>;
export const GetProductSamplePricesDocument = gql`
	query GetProductSamplePrices($input: GetProductSamplePricesInput!, $currency: CurrencyEnum!) {
		getProductSamplePrices(input: $input) {
			id
			productId
			vetterEntityId
			vetterEntity {
				id
				name
			}
			samplePrice
			shippingPrice
			currency
			minProductionDays
			maxProductionDays
			deliveryDaysMin
			deliveryDaysMax
			isActive
			validFrom
			validTo
			lastQuotedSamplePrice
			lastQuotedShippingPrice
			lastQuotedCurrency
			lastQuotedAt
			lastQuotedOfferId
			converted(currency: $currency) {
				currency
				exchangeRate
				samplePrice
				shippingPrice
				lastQuotedSamplePrice
				lastQuotedShippingPrice
			}
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetProductSamplePricesQuery__
 *
 * To run a query within a React component, call `useGetProductSamplePricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSamplePricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSamplePricesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetProductSamplePricesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetProductSamplePricesQuery,
		GetProductSamplePricesQueryVariables
	> &
		({ variables: GetProductSamplePricesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetProductSamplePricesQuery, GetProductSamplePricesQueryVariables>(
		GetProductSamplePricesDocument,
		options
	);
}
export function useGetProductSamplePricesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetProductSamplePricesQuery,
		GetProductSamplePricesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetProductSamplePricesQuery, GetProductSamplePricesQueryVariables>(
		GetProductSamplePricesDocument,
		options
	);
}
export function useGetProductSamplePricesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetProductSamplePricesQuery,
				GetProductSamplePricesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetProductSamplePricesQuery,
		GetProductSamplePricesQueryVariables
	>(GetProductSamplePricesDocument, options);
}
export type GetProductSamplePricesQueryHookResult = ReturnType<
	typeof useGetProductSamplePricesQuery
>;
export type GetProductSamplePricesLazyQueryHookResult = ReturnType<
	typeof useGetProductSamplePricesLazyQuery
>;
export type GetProductSamplePricesSuspenseQueryHookResult = ReturnType<
	typeof useGetProductSamplePricesSuspenseQuery
>;
export type GetProductSamplePricesQueryResult = Apollo.QueryResult<
	GetProductSamplePricesQuery,
	GetProductSamplePricesQueryVariables
>;
export const GetQuoteProductCommentsDocument = gql`
	query GetQuoteProductComments($input: QuoteProductThreadInput!) {
		getQuoteProductComments(input: $input) {
			...QuoteProductCommentFields
		}
	}
	${QuoteProductCommentFieldsFragmentDoc}
`;

/**
 * __useGetQuoteProductCommentsQuery__
 *
 * To run a query within a React component, call `useGetQuoteProductCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteProductCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteProductCommentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuoteProductCommentsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetQuoteProductCommentsQuery,
		GetQuoteProductCommentsQueryVariables
	> &
		({ variables: GetQuoteProductCommentsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetQuoteProductCommentsQuery, GetQuoteProductCommentsQueryVariables>(
		GetQuoteProductCommentsDocument,
		options
	);
}
export function useGetQuoteProductCommentsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuoteProductCommentsQuery,
		GetQuoteProductCommentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetQuoteProductCommentsQuery, GetQuoteProductCommentsQueryVariables>(
		GetQuoteProductCommentsDocument,
		options
	);
}
export function useGetQuoteProductCommentsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetQuoteProductCommentsQuery,
				GetQuoteProductCommentsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetQuoteProductCommentsQuery,
		GetQuoteProductCommentsQueryVariables
	>(GetQuoteProductCommentsDocument, options);
}
export type GetQuoteProductCommentsQueryHookResult = ReturnType<
	typeof useGetQuoteProductCommentsQuery
>;
export type GetQuoteProductCommentsLazyQueryHookResult = ReturnType<
	typeof useGetQuoteProductCommentsLazyQuery
>;
export type GetQuoteProductCommentsSuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteProductCommentsSuspenseQuery
>;
export type GetQuoteProductCommentsQueryResult = Apollo.QueryResult<
	GetQuoteProductCommentsQuery,
	GetQuoteProductCommentsQueryVariables
>;
export const GetQuoteProductMentionCandidatesDocument = gql`
	query GetQuoteProductMentionCandidates($input: QuoteProductThreadInput!) {
		getQuoteProductMentionCandidates(input: $input) {
			userId
			name
			side
			subtitle
		}
	}
`;

/**
 * __useGetQuoteProductMentionCandidatesQuery__
 *
 * To run a query within a React component, call `useGetQuoteProductMentionCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteProductMentionCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteProductMentionCandidatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuoteProductMentionCandidatesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetQuoteProductMentionCandidatesQuery,
		GetQuoteProductMentionCandidatesQueryVariables
	> &
		(
			| { variables: GetQuoteProductMentionCandidatesQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetQuoteProductMentionCandidatesQuery,
		GetQuoteProductMentionCandidatesQueryVariables
	>(GetQuoteProductMentionCandidatesDocument, options);
}
export function useGetQuoteProductMentionCandidatesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuoteProductMentionCandidatesQuery,
		GetQuoteProductMentionCandidatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetQuoteProductMentionCandidatesQuery,
		GetQuoteProductMentionCandidatesQueryVariables
	>(GetQuoteProductMentionCandidatesDocument, options);
}
export function useGetQuoteProductMentionCandidatesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetQuoteProductMentionCandidatesQuery,
				GetQuoteProductMentionCandidatesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetQuoteProductMentionCandidatesQuery,
		GetQuoteProductMentionCandidatesQueryVariables
	>(GetQuoteProductMentionCandidatesDocument, options);
}
export type GetQuoteProductMentionCandidatesQueryHookResult = ReturnType<
	typeof useGetQuoteProductMentionCandidatesQuery
>;
export type GetQuoteProductMentionCandidatesLazyQueryHookResult = ReturnType<
	typeof useGetQuoteProductMentionCandidatesLazyQuery
>;
export type GetQuoteProductMentionCandidatesSuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteProductMentionCandidatesSuspenseQuery
>;
export type GetQuoteProductMentionCandidatesQueryResult = Apollo.QueryResult<
	GetQuoteProductMentionCandidatesQuery,
	GetQuoteProductMentionCandidatesQueryVariables
>;
export const GetQuoteProductThreadsDocument = gql`
	query GetQuoteProductThreads($orderQuoteId: ID!) {
		getQuoteProductThreads(orderQuoteId: $orderQuoteId) {
			...QuoteProductThreadFields
		}
	}
	${QuoteProductThreadFieldsFragmentDoc}
`;

/**
 * __useGetQuoteProductThreadsQuery__
 *
 * To run a query within a React component, call `useGetQuoteProductThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteProductThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteProductThreadsQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *   },
 * });
 */
export function useGetQuoteProductThreadsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetQuoteProductThreadsQuery,
		GetQuoteProductThreadsQueryVariables
	> &
		({ variables: GetQuoteProductThreadsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetQuoteProductThreadsQuery, GetQuoteProductThreadsQueryVariables>(
		GetQuoteProductThreadsDocument,
		options
	);
}
export function useGetQuoteProductThreadsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuoteProductThreadsQuery,
		GetQuoteProductThreadsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetQuoteProductThreadsQuery, GetQuoteProductThreadsQueryVariables>(
		GetQuoteProductThreadsDocument,
		options
	);
}
export function useGetQuoteProductThreadsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetQuoteProductThreadsQuery,
				GetQuoteProductThreadsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetQuoteProductThreadsQuery,
		GetQuoteProductThreadsQueryVariables
	>(GetQuoteProductThreadsDocument, options);
}
export type GetQuoteProductThreadsQueryHookResult = ReturnType<
	typeof useGetQuoteProductThreadsQuery
>;
export type GetQuoteProductThreadsLazyQueryHookResult = ReturnType<
	typeof useGetQuoteProductThreadsLazyQuery
>;
export type GetQuoteProductThreadsSuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteProductThreadsSuspenseQuery
>;
export type GetQuoteProductThreadsQueryResult = Apollo.QueryResult<
	GetQuoteProductThreadsQuery,
	GetQuoteProductThreadsQueryVariables
>;
export const GetQuoteProductCommentTargetDocument = gql`
	query GetQuoteProductCommentTarget($id: ID!) {
		getQuoteProductCommentTarget(id: $id) {
			orderQuoteId
			orderQuoteItemId
			vetterEntityId
			vetterJobId
		}
	}
`;

/**
 * __useGetQuoteProductCommentTargetQuery__
 *
 * To run a query within a React component, call `useGetQuoteProductCommentTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteProductCommentTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteProductCommentTargetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuoteProductCommentTargetQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetQuoteProductCommentTargetQuery,
		GetQuoteProductCommentTargetQueryVariables
	> &
		(
			| { variables: GetQuoteProductCommentTargetQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetQuoteProductCommentTargetQuery,
		GetQuoteProductCommentTargetQueryVariables
	>(GetQuoteProductCommentTargetDocument, options);
}
export function useGetQuoteProductCommentTargetLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuoteProductCommentTargetQuery,
		GetQuoteProductCommentTargetQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetQuoteProductCommentTargetQuery,
		GetQuoteProductCommentTargetQueryVariables
	>(GetQuoteProductCommentTargetDocument, options);
}
export function useGetQuoteProductCommentTargetSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetQuoteProductCommentTargetQuery,
				GetQuoteProductCommentTargetQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetQuoteProductCommentTargetQuery,
		GetQuoteProductCommentTargetQueryVariables
	>(GetQuoteProductCommentTargetDocument, options);
}
export type GetQuoteProductCommentTargetQueryHookResult = ReturnType<
	typeof useGetQuoteProductCommentTargetQuery
>;
export type GetQuoteProductCommentTargetLazyQueryHookResult = ReturnType<
	typeof useGetQuoteProductCommentTargetLazyQuery
>;
export type GetQuoteProductCommentTargetSuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteProductCommentTargetSuspenseQuery
>;
export type GetQuoteProductCommentTargetQueryResult = Apollo.QueryResult<
	GetQuoteProductCommentTargetQuery,
	GetQuoteProductCommentTargetQueryVariables
>;
export const GetQuoteOfferLinesDocument = gql`
	query GetQuoteOfferLines($orderQuoteId: ID!) {
		getOrderQuoteOfferBatches(orderQuoteId: $orderQuoteId) {
			id
			offers {
				id
				orderQuoteItemId
			}
		}
	}
`;

/**
 * __useGetQuoteOfferLinesQuery__
 *
 * To run a query within a React component, call `useGetQuoteOfferLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteOfferLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteOfferLinesQuery({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *   },
 * });
 */
export function useGetQuoteOfferLinesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetQuoteOfferLinesQuery,
		GetQuoteOfferLinesQueryVariables
	> &
		({ variables: GetQuoteOfferLinesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetQuoteOfferLinesQuery, GetQuoteOfferLinesQueryVariables>(
		GetQuoteOfferLinesDocument,
		options
	);
}
export function useGetQuoteOfferLinesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuoteOfferLinesQuery,
		GetQuoteOfferLinesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetQuoteOfferLinesQuery, GetQuoteOfferLinesQueryVariables>(
		GetQuoteOfferLinesDocument,
		options
	);
}
export function useGetQuoteOfferLinesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetQuoteOfferLinesQuery, GetQuoteOfferLinesQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetQuoteOfferLinesQuery, GetQuoteOfferLinesQueryVariables>(
		GetQuoteOfferLinesDocument,
		options
	);
}
export type GetQuoteOfferLinesQueryHookResult = ReturnType<typeof useGetQuoteOfferLinesQuery>;
export type GetQuoteOfferLinesLazyQueryHookResult = ReturnType<
	typeof useGetQuoteOfferLinesLazyQuery
>;
export type GetQuoteOfferLinesSuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteOfferLinesSuspenseQuery
>;
export type GetQuoteOfferLinesQueryResult = Apollo.QueryResult<
	GetQuoteOfferLinesQuery,
	GetQuoteOfferLinesQueryVariables
>;
export const GetShippingCarriersDocument = gql`
	query GetShippingCarriers {
		getShippingCarriers {
			code
			name
			supportsTracking
		}
	}
`;

/**
 * __useGetShippingCarriersQuery__
 *
 * To run a query within a React component, call `useGetShippingCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingCarriersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShippingCarriersQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetShippingCarriersQuery,
		GetShippingCarriersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetShippingCarriersQuery, GetShippingCarriersQueryVariables>(
		GetShippingCarriersDocument,
		options
	);
}
export function useGetShippingCarriersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetShippingCarriersQuery,
		GetShippingCarriersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetShippingCarriersQuery, GetShippingCarriersQueryVariables>(
		GetShippingCarriersDocument,
		options
	);
}
export function useGetShippingCarriersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetShippingCarriersQuery,
				GetShippingCarriersQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetShippingCarriersQuery, GetShippingCarriersQueryVariables>(
		GetShippingCarriersDocument,
		options
	);
}
export type GetShippingCarriersQueryHookResult = ReturnType<typeof useGetShippingCarriersQuery>;
export type GetShippingCarriersLazyQueryHookResult = ReturnType<
	typeof useGetShippingCarriersLazyQuery
>;
export type GetShippingCarriersSuspenseQueryHookResult = ReturnType<
	typeof useGetShippingCarriersSuspenseQuery
>;
export type GetShippingCarriersQueryResult = Apollo.QueryResult<
	GetShippingCarriersQuery,
	GetShippingCarriersQueryVariables
>;
export const GetSubscriptionTierConfigsDocument = gql`
	query GetSubscriptionTierConfigs {
		getSubscriptionTierConfigs {
			tier
			monthlyPrice
			currency
			kickbackRate
			aiTokenRatePerMillion
			stripePriceId
			isActive
			updatedAt
		}
	}
`;

/**
 * __useGetSubscriptionTierConfigsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionTierConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionTierConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionTierConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionTierConfigsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetSubscriptionTierConfigsQuery,
		GetSubscriptionTierConfigsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetSubscriptionTierConfigsQuery,
		GetSubscriptionTierConfigsQueryVariables
	>(GetSubscriptionTierConfigsDocument, options);
}
export function useGetSubscriptionTierConfigsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetSubscriptionTierConfigsQuery,
		GetSubscriptionTierConfigsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetSubscriptionTierConfigsQuery,
		GetSubscriptionTierConfigsQueryVariables
	>(GetSubscriptionTierConfigsDocument, options);
}
export function useGetSubscriptionTierConfigsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetSubscriptionTierConfigsQuery,
				GetSubscriptionTierConfigsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetSubscriptionTierConfigsQuery,
		GetSubscriptionTierConfigsQueryVariables
	>(GetSubscriptionTierConfigsDocument, options);
}
export type GetSubscriptionTierConfigsQueryHookResult = ReturnType<
	typeof useGetSubscriptionTierConfigsQuery
>;
export type GetSubscriptionTierConfigsLazyQueryHookResult = ReturnType<
	typeof useGetSubscriptionTierConfigsLazyQuery
>;
export type GetSubscriptionTierConfigsSuspenseQueryHookResult = ReturnType<
	typeof useGetSubscriptionTierConfigsSuspenseQuery
>;
export type GetSubscriptionTierConfigsQueryResult = Apollo.QueryResult<
	GetSubscriptionTierConfigsQuery,
	GetSubscriptionTierConfigsQueryVariables
>;
export const GetMySubscriptionDocument = gql`
	query GetMySubscription {
		getMySubscription {
			id
			organizationId
			tier
			status
			stripeCustomerId
			stripeSubscriptionId
			stripePriceId
			currentPeriodStart
			currentPeriodEnd
			cancelAtPeriodEnd
			canceledAt
			trialEnd
			pendingTier
			pendingTierEffectiveAt
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetMySubscriptionQuery__
 *
 * To run a query within a React component, call `useGetMySubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMySubscriptionQuery(
	baseOptions?: Apollo.QueryHookOptions<GetMySubscriptionQuery, GetMySubscriptionQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetMySubscriptionQuery, GetMySubscriptionQueryVariables>(
		GetMySubscriptionDocument,
		options
	);
}
export function useGetMySubscriptionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetMySubscriptionQuery,
		GetMySubscriptionQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetMySubscriptionQuery, GetMySubscriptionQueryVariables>(
		GetMySubscriptionDocument,
		options
	);
}
export function useGetMySubscriptionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetMySubscriptionQuery, GetMySubscriptionQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetMySubscriptionQuery, GetMySubscriptionQueryVariables>(
		GetMySubscriptionDocument,
		options
	);
}
export type GetMySubscriptionQueryHookResult = ReturnType<typeof useGetMySubscriptionQuery>;
export type GetMySubscriptionLazyQueryHookResult = ReturnType<typeof useGetMySubscriptionLazyQuery>;
export type GetMySubscriptionSuspenseQueryHookResult = ReturnType<
	typeof useGetMySubscriptionSuspenseQuery
>;
export type GetMySubscriptionQueryResult = Apollo.QueryResult<
	GetMySubscriptionQuery,
	GetMySubscriptionQueryVariables
>;
export const GetSystemSettingsDocument = gql`
	query GetSystemSettings {
		getSystemSettings {
			id
			defaultApproval
			defaultMargin
			defaultStripeCheckoutLimit
			defaultInvoiceMinimumThreshold
			defaultProductPaymentMode
			defaultSamplePaymentMode
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetSystemSettingsQuery__
 *
 * To run a query within a React component, call `useGetSystemSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSystemSettingsQuery(
	baseOptions?: Apollo.QueryHookOptions<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>(
		GetSystemSettingsDocument,
		options
	);
}
export function useGetSystemSettingsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetSystemSettingsQuery,
		GetSystemSettingsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>(
		GetSystemSettingsDocument,
		options
	);
}
export function useGetSystemSettingsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>(
		GetSystemSettingsDocument,
		options
	);
}
export type GetSystemSettingsQueryHookResult = ReturnType<typeof useGetSystemSettingsQuery>;
export type GetSystemSettingsLazyQueryHookResult = ReturnType<typeof useGetSystemSettingsLazyQuery>;
export type GetSystemSettingsSuspenseQueryHookResult = ReturnType<
	typeof useGetSystemSettingsSuspenseQuery
>;
export type GetSystemSettingsQueryResult = Apollo.QueryResult<
	GetSystemSettingsQuery,
	GetSystemSettingsQueryVariables
>;
export const GetAllVetterEntitiesDocument = gql`
	query GetAllVetterEntities($input: GetAllVetterEntityInput!) {
		getAllVetterEntity(input: $input) {
			data {
				id
				name
				description
				notes
				isActive
				createdAt
				primaryContactVetterUserId
				primaryContact {
					id
					firstName
					lastName
					phone
					authenticationUser {
						id
						email
					}
				}
				vetterUsers {
					id
					userId
					firstName
					lastName
				}
			}
			pageInfo {
				currentPage
				totalPages
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllVetterEntitiesQuery__
 *
 * To run a query within a React component, call `useGetAllVetterEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVetterEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVetterEntitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllVetterEntitiesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllVetterEntitiesQuery,
		GetAllVetterEntitiesQueryVariables
	> &
		({ variables: GetAllVetterEntitiesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllVetterEntitiesQuery, GetAllVetterEntitiesQueryVariables>(
		GetAllVetterEntitiesDocument,
		options
	);
}
export function useGetAllVetterEntitiesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllVetterEntitiesQuery,
		GetAllVetterEntitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllVetterEntitiesQuery, GetAllVetterEntitiesQueryVariables>(
		GetAllVetterEntitiesDocument,
		options
	);
}
export function useGetAllVetterEntitiesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllVetterEntitiesQuery,
				GetAllVetterEntitiesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllVetterEntitiesQuery, GetAllVetterEntitiesQueryVariables>(
		GetAllVetterEntitiesDocument,
		options
	);
}
export type GetAllVetterEntitiesQueryHookResult = ReturnType<typeof useGetAllVetterEntitiesQuery>;
export type GetAllVetterEntitiesLazyQueryHookResult = ReturnType<
	typeof useGetAllVetterEntitiesLazyQuery
>;
export type GetAllVetterEntitiesSuspenseQueryHookResult = ReturnType<
	typeof useGetAllVetterEntitiesSuspenseQuery
>;
export type GetAllVetterEntitiesQueryResult = Apollo.QueryResult<
	GetAllVetterEntitiesQuery,
	GetAllVetterEntitiesQueryVariables
>;
export const GetVetterStatsDocument = gql`
	query GetVetterStats {
		getVetterStats {
			total
			active
			inactive
			teamMembers
		}
	}
`;

/**
 * __useGetVetterStatsQuery__
 *
 * To run a query within a React component, call `useGetVetterStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVetterStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVetterStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVetterStatsQuery(
	baseOptions?: Apollo.QueryHookOptions<GetVetterStatsQuery, GetVetterStatsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetVetterStatsQuery, GetVetterStatsQueryVariables>(
		GetVetterStatsDocument,
		options
	);
}
export function useGetVetterStatsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetVetterStatsQuery, GetVetterStatsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetVetterStatsQuery, GetVetterStatsQueryVariables>(
		GetVetterStatsDocument,
		options
	);
}
export function useGetVetterStatsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetVetterStatsQuery, GetVetterStatsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetVetterStatsQuery, GetVetterStatsQueryVariables>(
		GetVetterStatsDocument,
		options
	);
}
export type GetVetterStatsQueryHookResult = ReturnType<typeof useGetVetterStatsQuery>;
export type GetVetterStatsLazyQueryHookResult = ReturnType<typeof useGetVetterStatsLazyQuery>;
export type GetVetterStatsSuspenseQueryHookResult = ReturnType<
	typeof useGetVetterStatsSuspenseQuery
>;
export type GetVetterStatsQueryResult = Apollo.QueryResult<
	GetVetterStatsQuery,
	GetVetterStatsQueryVariables
>;
export const GetVetterEntityDocument = gql`
	query GetVetterEntity($id: ID!) {
		getVetterEntity(id: $id) {
			id
			name
			description
			notes
			isActive
			createdAt
			updatedAt
			primaryContactVetterUserId
			primaryContact {
				id
				firstName
				lastName
				phone
				authenticationUser {
					id
					email
				}
			}
			vetterUsers {
				id
				firstName
				lastName
				userId
				phone
				notes
				invitedAt
				createdAt
				authenticationUser {
					id
					email
					lastActive
				}
			}
			manufacturers {
				id
				name
				country
				description
				website
				logoUrl
				isActive
				createdAt
				updatedAt
			}
		}
	}
`;

/**
 * __useGetVetterEntityQuery__
 *
 * To run a query within a React component, call `useGetVetterEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVetterEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVetterEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVetterEntityQuery(
	baseOptions: Apollo.QueryHookOptions<GetVetterEntityQuery, GetVetterEntityQueryVariables> &
		({ variables: GetVetterEntityQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetVetterEntityQuery, GetVetterEntityQueryVariables>(
		GetVetterEntityDocument,
		options
	);
}
export function useGetVetterEntityLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetVetterEntityQuery, GetVetterEntityQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetVetterEntityQuery, GetVetterEntityQueryVariables>(
		GetVetterEntityDocument,
		options
	);
}
export function useGetVetterEntitySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetVetterEntityQuery, GetVetterEntityQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetVetterEntityQuery, GetVetterEntityQueryVariables>(
		GetVetterEntityDocument,
		options
	);
}
export type GetVetterEntityQueryHookResult = ReturnType<typeof useGetVetterEntityQuery>;
export type GetVetterEntityLazyQueryHookResult = ReturnType<typeof useGetVetterEntityLazyQuery>;
export type GetVetterEntitySuspenseQueryHookResult = ReturnType<
	typeof useGetVetterEntitySuspenseQuery
>;
export type GetVetterEntityQueryResult = Apollo.QueryResult<
	GetVetterEntityQuery,
	GetVetterEntityQueryVariables
>;
export const GetVetterJobDocument = gql`
	query GetVetterJob($id: ID) {
		getVetterJob(id: $id) {
			id
			email
			quoteName
			stage
			stageLabel
			createdAt
			quoteDeadline
			currency
			note
			submittedAt
			canSubmitPrices
			submitPricesBlockedReason
			vetterEntity {
				id
				name
			}
			items {
				orderQuoteItemId
				productName
				productSku
				productDescription
				productWeight
				deadline
				productDimensions {
					length
					width
					height
					unit
				}
				productSpecifications {
					...OrderProductSpecificationsFragment
				}
				productImages {
					...OrderQuoteItemProductImageFragment
				}
				attachments {
					id
					name
					description
					mimeType
					size
					url
				}
				commentThread {
					id
					commentCount
					unreadCount
					lastCommentAt
				}
				tiers {
					orderQuoteItemQuantityId
					quantity
					deliveryOptions {
						id
						label
						isSplit
						shippingMethod
						quantity
						cost {
							...VetterDeliveryCostFields
						}
						parts {
							id
							sequence
							shippingMethod
							quantity
							cost {
								...VetterDeliveryCostFields
							}
						}
					}
					price {
						id
						baseUnitPrice
						currency
						minProductionDays
						maxProductionDays
						shippingPrices {
							shippingMethod
							price
							deliveryDaysMin
							deliveryDaysMax
						}
					}
				}
			}
			orderItems {
				id
				orderId
				orderNumber
				productName
				quantity
				status
				productionStartedAt
				productionCompletedAt
				availableActions {
					...VetterJobActionFields
				}
			}
			shipments {
				id
				orderId
				orderNumber
				sequence
				status
				shippingMethod
				carrier
				trackingNumber
				trackingUrl
				shippedAt
				estimatedDeliveryDate
				actualDeliveryDate
				lines {
					orderItemId
					productName
					quantity
				}
				availableActions {
					...VetterJobActionFields
				}
			}
		}
	}
	${OrderProductSpecificationsFragmentFragmentDoc}
	${OrderQuoteItemProductImageFragmentFragmentDoc}
	${VetterDeliveryCostFieldsFragmentDoc}
	${VetterJobActionFieldsFragmentDoc}
`;

/**
 * __useGetVetterJobQuery__
 *
 * To run a query within a React component, call `useGetVetterJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVetterJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVetterJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVetterJobQuery(
	baseOptions?: Apollo.QueryHookOptions<GetVetterJobQuery, GetVetterJobQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetVetterJobQuery, GetVetterJobQueryVariables>(
		GetVetterJobDocument,
		options
	);
}
export function useGetVetterJobLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetVetterJobQuery, GetVetterJobQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetVetterJobQuery, GetVetterJobQueryVariables>(
		GetVetterJobDocument,
		options
	);
}
export function useGetVetterJobSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetVetterJobQuery, GetVetterJobQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetVetterJobQuery, GetVetterJobQueryVariables>(
		GetVetterJobDocument,
		options
	);
}
export type GetVetterJobQueryHookResult = ReturnType<typeof useGetVetterJobQuery>;
export type GetVetterJobLazyQueryHookResult = ReturnType<typeof useGetVetterJobLazyQuery>;
export type GetVetterJobSuspenseQueryHookResult = ReturnType<typeof useGetVetterJobSuspenseQuery>;
export type GetVetterJobQueryResult = Apollo.QueryResult<
	GetVetterJobQuery,
	GetVetterJobQueryVariables
>;
export const GetMyVetterJobsDocument = gql`
	query GetMyVetterJobs($input: GetMyVetterJobsInput!) {
		getMyVetterJobs(input: $input) {
			data {
				id
				quoteName
				quoteDeadline
				stage
				stageLabel
				submittedAt
				createdAt
				unreadCommentCount
				items {
					orderQuoteItemId
					productName
				}
			}
			pageInfo {
				currentPage
				totalPages
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetMyVetterJobsQuery__
 *
 * To run a query within a React component, call `useGetMyVetterJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyVetterJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyVetterJobsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMyVetterJobsQuery(
	baseOptions: Apollo.QueryHookOptions<GetMyVetterJobsQuery, GetMyVetterJobsQueryVariables> &
		({ variables: GetMyVetterJobsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetMyVetterJobsQuery, GetMyVetterJobsQueryVariables>(
		GetMyVetterJobsDocument,
		options
	);
}
export function useGetMyVetterJobsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetMyVetterJobsQuery, GetMyVetterJobsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetMyVetterJobsQuery, GetMyVetterJobsQueryVariables>(
		GetMyVetterJobsDocument,
		options
	);
}
export function useGetMyVetterJobsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetMyVetterJobsQuery, GetMyVetterJobsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetMyVetterJobsQuery, GetMyVetterJobsQueryVariables>(
		GetMyVetterJobsDocument,
		options
	);
}
export type GetMyVetterJobsQueryHookResult = ReturnType<typeof useGetMyVetterJobsQuery>;
export type GetMyVetterJobsLazyQueryHookResult = ReturnType<typeof useGetMyVetterJobsLazyQuery>;
export type GetMyVetterJobsSuspenseQueryHookResult = ReturnType<
	typeof useGetMyVetterJobsSuspenseQuery
>;
export type GetMyVetterJobsQueryResult = Apollo.QueryResult<
	GetMyVetterJobsQuery,
	GetMyVetterJobsQueryVariables
>;
export const GetMyVetterProfileDocument = gql`
	query GetMyVetterProfile {
		getMyVetterProfile {
			id
			firstName
			lastName
			vetterEntityId
			vetterEntity {
				id
				name
				description
				primaryContactVetterUserId
			}
			authenticationUser {
				id
				email
			}
		}
	}
`;

/**
 * __useGetMyVetterProfileQuery__
 *
 * To run a query within a React component, call `useGetMyVetterProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyVetterProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyVetterProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyVetterProfileQuery(
	baseOptions?: Apollo.QueryHookOptions<GetMyVetterProfileQuery, GetMyVetterProfileQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetMyVetterProfileQuery, GetMyVetterProfileQueryVariables>(
		GetMyVetterProfileDocument,
		options
	);
}
export function useGetMyVetterProfileLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetMyVetterProfileQuery,
		GetMyVetterProfileQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetMyVetterProfileQuery, GetMyVetterProfileQueryVariables>(
		GetMyVetterProfileDocument,
		options
	);
}
export function useGetMyVetterProfileSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetMyVetterProfileQuery, GetMyVetterProfileQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetMyVetterProfileQuery, GetMyVetterProfileQueryVariables>(
		GetMyVetterProfileDocument,
		options
	);
}
export type GetMyVetterProfileQueryHookResult = ReturnType<typeof useGetMyVetterProfileQuery>;
export type GetMyVetterProfileLazyQueryHookResult = ReturnType<
	typeof useGetMyVetterProfileLazyQuery
>;
export type GetMyVetterProfileSuspenseQueryHookResult = ReturnType<
	typeof useGetMyVetterProfileSuspenseQuery
>;
export type GetMyVetterProfileQueryResult = Apollo.QueryResult<
	GetMyVetterProfileQuery,
	GetMyVetterProfileQueryVariables
>;
export const GetMyVetterTeamDocument = gql`
	query GetMyVetterTeam($input: GetAllVetterUserInput!) {
		getAllVetterUser(input: $input) {
			data {
				id
				firstName
				lastName
				phone
				invitedAt
				createdAt
				authenticationUser {
					id
					email
					lastActive
				}
			}
			pageInfo {
				currentPage
				totalPages
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetMyVetterTeamQuery__
 *
 * To run a query within a React component, call `useGetMyVetterTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyVetterTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyVetterTeamQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMyVetterTeamQuery(
	baseOptions: Apollo.QueryHookOptions<GetMyVetterTeamQuery, GetMyVetterTeamQueryVariables> &
		({ variables: GetMyVetterTeamQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetMyVetterTeamQuery, GetMyVetterTeamQueryVariables>(
		GetMyVetterTeamDocument,
		options
	);
}
export function useGetMyVetterTeamLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetMyVetterTeamQuery, GetMyVetterTeamQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetMyVetterTeamQuery, GetMyVetterTeamQueryVariables>(
		GetMyVetterTeamDocument,
		options
	);
}
export function useGetMyVetterTeamSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetMyVetterTeamQuery, GetMyVetterTeamQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetMyVetterTeamQuery, GetMyVetterTeamQueryVariables>(
		GetMyVetterTeamDocument,
		options
	);
}
export type GetMyVetterTeamQueryHookResult = ReturnType<typeof useGetMyVetterTeamQuery>;
export type GetMyVetterTeamLazyQueryHookResult = ReturnType<typeof useGetMyVetterTeamLazyQuery>;
export type GetMyVetterTeamSuspenseQueryHookResult = ReturnType<
	typeof useGetMyVetterTeamSuspenseQuery
>;
export type GetMyVetterTeamQueryResult = Apollo.QueryResult<
	GetMyVetterTeamQuery,
	GetMyVetterTeamQueryVariables
>;
export const OnNotificationAddedDocument = gql`
	subscription OnNotificationAdded {
		notificationAdded {
			id
			type
			title
			body
			entityType
			entityId
			readAt
			emailSent
			createdAt
		}
	}
`;

/**
 * __useOnNotificationAddedSubscription__
 *
 * To run a query within a React component, call `useOnNotificationAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNotificationAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNotificationAddedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnNotificationAddedSubscription(
	baseOptions?: Apollo.SubscriptionHookOptions<
		OnNotificationAddedSubscription,
		OnNotificationAddedSubscriptionVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSubscription<
		OnNotificationAddedSubscription,
		OnNotificationAddedSubscriptionVariables
	>(OnNotificationAddedDocument, options);
}
export type OnNotificationAddedSubscriptionHookResult = ReturnType<
	typeof useOnNotificationAddedSubscription
>;
export type OnNotificationAddedSubscriptionResult =
	Apollo.SubscriptionResult<OnNotificationAddedSubscription>;
export const OnOrderQuoteActivityAddedDocument = gql`
	subscription OnOrderQuoteActivityAdded($orderQuoteId: ID!, $inCurrency: String) {
		orderQuoteActivityAdded(orderQuoteId: $orderQuoteId, inCurrency: $inCurrency) {
			id
			action
			message
			actorId
			actorRole
			adminUser {
				firstName
				lastName
			}
			organizationUser {
				firstName
				lastName
			}
			metadata
			orderQuoteId
			createdAt
		}
	}
`;

/**
 * __useOnOrderQuoteActivityAddedSubscription__
 *
 * To run a query within a React component, call `useOnOrderQuoteActivityAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnOrderQuoteActivityAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnOrderQuoteActivityAddedSubscription({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useOnOrderQuoteActivityAddedSubscription(
	baseOptions: Apollo.SubscriptionHookOptions<
		OnOrderQuoteActivityAddedSubscription,
		OnOrderQuoteActivityAddedSubscriptionVariables
	> &
		(
			| { variables: OnOrderQuoteActivityAddedSubscriptionVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSubscription<
		OnOrderQuoteActivityAddedSubscription,
		OnOrderQuoteActivityAddedSubscriptionVariables
	>(OnOrderQuoteActivityAddedDocument, options);
}
export type OnOrderQuoteActivityAddedSubscriptionHookResult = ReturnType<
	typeof useOnOrderQuoteActivityAddedSubscription
>;
export type OnOrderQuoteActivityAddedSubscriptionResult =
	Apollo.SubscriptionResult<OnOrderQuoteActivityAddedSubscription>;
export const OnQuoteProductThreadUpdatedDocument = gql`
	subscription OnQuoteProductThreadUpdated($input: QuoteProductThreadInput!) {
		quoteProductThreadUpdated(input: $input) {
			kind
			comment {
				...QuoteProductCommentFields
			}
		}
	}
	${QuoteProductCommentFieldsFragmentDoc}
`;

/**
 * __useOnQuoteProductThreadUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnQuoteProductThreadUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnQuoteProductThreadUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnQuoteProductThreadUpdatedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnQuoteProductThreadUpdatedSubscription(
	baseOptions: Apollo.SubscriptionHookOptions<
		OnQuoteProductThreadUpdatedSubscription,
		OnQuoteProductThreadUpdatedSubscriptionVariables
	> &
		(
			| { variables: OnQuoteProductThreadUpdatedSubscriptionVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSubscription<
		OnQuoteProductThreadUpdatedSubscription,
		OnQuoteProductThreadUpdatedSubscriptionVariables
	>(OnQuoteProductThreadUpdatedDocument, options);
}
export type OnQuoteProductThreadUpdatedSubscriptionHookResult = ReturnType<
	typeof useOnQuoteProductThreadUpdatedSubscription
>;
export type OnQuoteProductThreadUpdatedSubscriptionResult =
	Apollo.SubscriptionResult<OnQuoteProductThreadUpdatedSubscription>;
export const OnQuoteProductThreadCountsUpdatedDocument = gql`
	subscription OnQuoteProductThreadCountsUpdated($orderQuoteId: ID!) {
		quoteProductThreadCountsUpdated(orderQuoteId: $orderQuoteId) {
			...QuoteProductThreadFields
		}
	}
	${QuoteProductThreadFieldsFragmentDoc}
`;

/**
 * __useOnQuoteProductThreadCountsUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnQuoteProductThreadCountsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnQuoteProductThreadCountsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnQuoteProductThreadCountsUpdatedSubscription({
 *   variables: {
 *      orderQuoteId: // value for 'orderQuoteId'
 *   },
 * });
 */
export function useOnQuoteProductThreadCountsUpdatedSubscription(
	baseOptions: Apollo.SubscriptionHookOptions<
		OnQuoteProductThreadCountsUpdatedSubscription,
		OnQuoteProductThreadCountsUpdatedSubscriptionVariables
	> &
		(
			| { variables: OnQuoteProductThreadCountsUpdatedSubscriptionVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSubscription<
		OnQuoteProductThreadCountsUpdatedSubscription,
		OnQuoteProductThreadCountsUpdatedSubscriptionVariables
	>(OnQuoteProductThreadCountsUpdatedDocument, options);
}
export type OnQuoteProductThreadCountsUpdatedSubscriptionHookResult = ReturnType<
	typeof useOnQuoteProductThreadCountsUpdatedSubscription
>;
export type OnQuoteProductThreadCountsUpdatedSubscriptionResult =
	Apollo.SubscriptionResult<OnQuoteProductThreadCountsUpdatedSubscription>;
export const OnVetterJobUpdatedDocument = gql`
	subscription OnVetterJobUpdated {
		vetterJobUpdated {
			vetterJobId
			stage
			stageLabel
			unreadCommentCount
			removedAt
		}
	}
`;

/**
 * __useOnVetterJobUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnVetterJobUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnVetterJobUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnVetterJobUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnVetterJobUpdatedSubscription(
	baseOptions?: Apollo.SubscriptionHookOptions<
		OnVetterJobUpdatedSubscription,
		OnVetterJobUpdatedSubscriptionVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSubscription<
		OnVetterJobUpdatedSubscription,
		OnVetterJobUpdatedSubscriptionVariables
	>(OnVetterJobUpdatedDocument, options);
}
export type OnVetterJobUpdatedSubscriptionHookResult = ReturnType<
	typeof useOnVetterJobUpdatedSubscription
>;
export type OnVetterJobUpdatedSubscriptionResult =
	Apollo.SubscriptionResult<OnVetterJobUpdatedSubscription>;
